export const currencyList = [
  "btc",
  "eth",
  "ltc",
  "bch",
  "bnb",
  "eos",
  "xrp",
  "xlm",
  "link",
  "dot",
  "yfi",
  "usd",
  "aed",
  "ars",
  "aud",
  "bdt",
  "bhd",
  "bmd",
  "brl",
  "cad",
  "chf",
  "clp",
  "cny",
  "czk",
  "dkk",
  "eur",
  "gbp",
  "hkd",
  "huf",
  "idr",
  "ils",
  "inr",
  "jpy",
  "krw",
  "kwd",
  "lkr",
  "mmk",
  "mxn",
  "myr",
  "ngn",
  "nok",
  "nzd",
  "php",
  "pkr",
  "pln",
  "rub",
  "sar",
  "sek",
  "sgd",
  "thb",
  "try",
  "twd",
  "uah",
  "vef",
  "vnd",
  "zar",
  "xdr",
  "xag",
  "xau",
  "bits",
  "sats",
];

export const coinList = [
  {
    id: "01coin",
    symbol: "zoc",
    name: "01coin",
  },
  {
    id: "0-5x-long-algorand-token",
    symbol: "algohalf",
    name: "0.5X Long Algorand",
  },
  {
    id: "0-5x-long-altcoin-index-token",
    symbol: "althalf",
    name: "0.5X Long Altcoin Index",
  },
  {
    id: "0-5x-long-ascendex-token-token",
    symbol: "asdhalf",
    name: "0.5X Long AscendEx",
  },
  {
    id: "0-5x-long-bitcoin-cash-token",
    symbol: "bchhalf",
    name: "0.5X Long Bitcoin Cash",
  },
  {
    id: "0-5x-long-bitcoin-token",
    symbol: "half",
    name: "0.5X Long Bitcoin",
  },
  {
    id: "0-5x-long-cardano-token",
    symbol: "adahalf",
    name: "0.5X Long Cardano",
  },
  {
    id: "0-5x-long-chainlink-token",
    symbol: "linkhalf",
    name: "0.5X Long Chainlink",
  },
  {
    id: "0-5x-long-cosmos-token",
    symbol: "atomhalf",
    name: "0.5X Long Cosmos",
  },
  {
    id: "0-5x-long-dogecoin-token",
    symbol: "dogehalf",
    name: "0.5X Long Dogecoin",
  },
  {
    id: "0-5x-long-eos-token",
    symbol: "eoshalf",
    name: "0.5X Long EOS",
  },
  {
    id: "0-5x-long-ethereum-classic-token",
    symbol: "etchalf",
    name: "0.5X Long Ethereum Classic",
  },
  {
    id: "0-5x-long-ethereum-token",
    symbol: "ethhalf",
    name: "0.5X Long Ethereum",
  },
  {
    id: "0-5x-long-kyber-network-token",
    symbol: "knchalf",
    name: "0.5X Long Kyber Network",
  },
  {
    id: "0-5x-long-matic-token",
    symbol: "matichalf",
    name: "0.5X Long Matic Token",
  },
  {
    id: "0-5x-long-privacy-index-token",
    symbol: "privhalf",
    name: "0.5X Long Privacy Index",
  },
  {
    id: "0-5x-long-swipe-token",
    symbol: "sxphalf",
    name: "0.5X Long Swipe",
  },
  {
    id: "0-5x-long-theta-network-token",
    symbol: "thetahalf",
    name: "0.5X Long Theta Network",
  },
  {
    id: "0-5x-long-xrp-token",
    symbol: "xrphalf",
    name: "0.5X Long XRP Token",
  },
  {
    id: "0cash",
    symbol: "zch",
    name: "0cash",
  },
  {
    id: "0chain",
    symbol: "zcn",
    name: "0chain",
  },
  {
    id: "0-mee",
    symbol: "ome",
    name: "O-Mee",
  },
  {
    id: "0x",
    symbol: "zrx",
    name: "0x",
  },
  {
    id: "0xcert",
    symbol: "zxc",
    name: "0xcert",
  },
  {
    id: "0xdao",
    symbol: "oxd",
    name: "0xDAO",
  },
  {
    id: "0xdao-v2",
    symbol: "oxd v2",
    name: "0xDAO V2",
  },
  {
    id: "0xmonero",
    symbol: "0xmr",
    name: "0xMonero",
  },
  {
    id: "0xpad",
    symbol: "0xpad",
    name: "0xPAD",
  },
  {
    id: "0x-wormhole",
    symbol: "zrx",
    name: "0x (Wormhole)",
  },
  {
    id: "10024-10028-appoline",
    symbol: "realt-s-10024-10028-appoline-st-detroit-mi",
    name: "RealT -10024-10028 Appoline St, Detroit, MI 48227",
  },
  {
    id: "10084-grayton",
    symbol: "realt-s-10084-grayton-st-detroit-mi",
    name: "RealT - 10084 Grayton St, Detroit, MI 48224",
  },
  {
    id: "100-days-ventures",
    symbol: "astro",
    name: "100 Days Ventures",
  },
  {
    id: "100x-coin",
    symbol: "100x",
    name: "100xCoin",
  },
  {
    id: "10604-somerset",
    symbol: "realt-s-10604-somerset-ave-detroit-mi",
    name: "RealT - 10604 Somerset Ave, Detroit, MI 48224",
  },
  {
    id: "10612-somerset",
    symbol: "realt-s-10612-somerset-ave-detroit-mi",
    name: "RealT - 10612 Somerset Ave, Detroit, MI 48224",
  },
  {
    id: "10616-mckinney",
    symbol: "realt-s-10616-mckinney-st-detroit-mi",
    name: "RealT - 10616 McKinney St, Detroit, MI 48224",
  },
  {
    id: "10617-hathaway",
    symbol: "realt-s-10617-hathaway-ave-cleveland-oh",
    name: "RealT - 10617 Hathaway Ave, Cleveland, OH 44108",
  },
  {
    id: "10629-mckinney",
    symbol: "realt-s-10629-mckinney-st-detroit-mi",
    name: "RealT - 10629 McKinney St, Detroit, MI 48224",
  },
  {
    id: "10639-stratman",
    symbol: "realt-s-10639-stratman-st-detroit-mi",
    name: "RealT - 10639 Stratman St, Detroit, MI 48224",
  },
  {
    id: "10700-whittier",
    symbol: "realt-s-10700-whittier-ave-detroit-mi",
    name: "RealT - 10700 Whittier Ave, Detroit, MI 48224",
  },
  {
    id: "11078-longview",
    symbol: "realt-s-11078-longview-st-detroit-mi",
    name: "RealT - 11078 Longview St, Detroit, MI 48213",
  },
  {
    id: "11078-wayburn",
    symbol: "realt-s-11078-wayburn-st-detroit-mi",
    name: "RealT - 11078 Wayburn St, Detroit, MI 48224",
  },
  {
    id: "11201-college",
    symbol: "realt-s-11201-college-st-detroit-mi",
    name: "RealT - 11201 College St, Detroit, MI 48205",
  },
  {
    id: "11300-roxbury",
    symbol: "realt-s-11300-roxbury-st-detroit-mi",
    name: "RealT - 11300 Roxbury St, Detroit, MI 48224",
  },
  {
    id: "11653-nottingham",
    symbol: "realt-s-11653-nottingham-rd-detroit-mi",
    name: "RealT - 11653 Nottingham Rd, Detroit, MI 48224",
  },
  {
    id: "11957-olga",
    symbol: "realt-s-11957-olga-st-detroit-mi",
    name: "RealT - 11957 Olga St, Detroit, MI 48213",
  },
  {
    id: "11-minutes",
    symbol: "elvn",
    name: "11 Minutes",
  },
  {
    id: "12334-lansdowne",
    symbol: "realt-s-12334-lansdowne-street-detroit-mi",
    name: "RealT - 12334 Lansdowne Street, Detroit, MI 48224",
  },
  {
    id: "12405-santa-rosa",
    symbol: "realt-s-12405-santa-rosa-dr-detroit-mi",
    name: "RealT - 12405 Santa Rosa Dr, Detroit, MI 48204",
  },
  {
    id: "12409-whitehill",
    symbol: "realt-s-12409-whitehill-st-detroit-mi",
    name: "RealT - 12409 Whitehill St, Detroit, MI 48224",
  },
  {
    id: "1244-s-avers",
    symbol: "realt-s-1244-s.avers-st-chicago-il",
    name: "RealT - 1244 S. Avers St, Chicago, IL 60623",
  },
  {
    id: "12866-lauder",
    symbol: "realt-s-12866-lauder-st-detroit-mi",
    name: "RealT - 12866 Lauder St, Detroit, MI 48227",
  },
  {
    id: "12ships",
    symbol: "tshp",
    name: "12Ships",
  },
  {
    id: "13045-wade",
    symbol: "realt-s-13045-wade-st-detroit-mi",
    name: "RealT - 13045 Wade St, Detroit, MI 48213",
  },
  {
    id: "13114-glenfield",
    symbol: "realt-s-13114-glenfield-ave-detroit-mi",
    name: "RealT - 13114 Glenfield Ave, Detroit, MI 48213",
  },
  {
    id: "13116-kilbourne",
    symbol: "realt-s-13116-kilbourne-ave-detroit-mi",
    name: "RealT - 13116 Kilbourne Ave, Detroit, MI 48213",
  },
  {
    id: "1337",
    symbol: "1337",
    name: "Elite",
  },
  {
    id: "13606-winthrop",
    symbol: "realt-s-13606-winthrop-st-detroit-mi",
    name: "RealT - 13606 Winthrop St, Detroit, MI 48227",
  },
  {
    id: "13991-warwick",
    symbol: "realt-s-13991-warwick-st-detroit-mi",
    name: "RealT -13991 Warwick St, Detroit, MI, 48223",
  },
  {
    id: "14066-santa-rosa",
    symbol: "realt-s-14066-santa-rosa-dr-detroit-mi",
    name: "RealT - 14066 Santa Rosa Dr, Detroit, MI 48238",
  },
  {
    id: "14078-carlisle",
    symbol: "realt-s-14078-carlisle-st-detroit-mi",
    name: "RealT - 14078 Carlisle St, Detroit, MI 48205",
  },
  {
    id: "14229-wilshire",
    symbol: "realt-s-14229-wilshire-dr-detroit-mi",
    name: "RealT - 14229 Wilshire Dr, Detroit, MI 48213",
  },
  {
    id: "14231-strathmoor",
    symbol: "realt-s-14231-strathmoor-st-detroit-mi",
    name: "RealT - 14231 Strathmoor St, Detroit, MI 48227",
  },
  {
    id: "14319-rosemary",
    symbol: "realt-s-14319-rosemary-st-detroit-mi",
    name: "RealT - 14319 Rosemary St, Detroit, MI 48213",
  },
  {
    id: "14494-chelsea",
    symbol: "realt-s-14494-chelsea-ave-detroit-mi",
    name: "RealT - 14494 Chelsea Ave, Detroit, MI 48213",
  },
  {
    id: "14825-wilfred",
    symbol: "realt-s-14825-wilfried-st-detroit-mi",
    name: "RealT - 14825 Wilfred St, Detroit, MI 48213",
  },
  {
    id: "14882-troester",
    symbol: "realt-s-14882-troester-st-detroit-mi",
    name: "RealT - 14882 Troester St, Detroit, MI 48205",
  },
  {
    id: "14918-joy",
    symbol: "realt-s-14918-joy-rd-detroit-mi",
    name: "RealT - 14918 Joy Rd, Detroit, MI 48228",
  },
  {
    id: "15039-ward",
    symbol: "realt-s-15039-ward-ave-detroit-mi",
    name: "RealT - 15039 Ward Ave, Detroit, MI 48227",
  },
  {
    id: "15048-freeland",
    symbol: "realt-s-15048-freeland-st-detroit-mi",
    name: "RealT - 15048 Freeland St, Detroit, MI, 48227",
  },
  {
    id: "15095-hartwell",
    symbol: "realt-s-15095-hartwell-st-detroit-mi",
    name: "RealT -15095 Hartwell St, Detroit, MI 48227",
  },
  {
    id: "15350-greydale",
    symbol: "realt-s-15350-greydale-st-detroit-mi",
    name: "RealT - 15350 Greydale St, Detroit, MI 48223",
  },
  {
    id: "15373-parkside",
    symbol: "realt-s-15373-parkside-st-detroit-mi",
    name: "RealT - 15373 Parkside St, Detroit, MI 48238",
  },
  {
    id: "1542-s-ridgeway",
    symbol: "realt-s-1542-s.ridgeway-ave-chicago-il",
    name: "RealT - 1542 S Ridgeway Ave, Chicago, IL 60623",
  },
  {
    id: "15634-liberal",
    symbol: "realt-s-15634-liberal-st-detroit-mi",
    name: "RealT - 15634 Liberal St, Detroit, MI 48205",
  },
  {
    id: "15753-hartwell",
    symbol: "realt-s-15753-hartwell-st-detroit-mi",
    name: "RealT - 15753 Hartwell St, Detroit, MI 48227",
  },
  {
    id: "15770-prest",
    symbol: "realt-s-15770-prest-st-detroit-mi",
    name: "RealT - 15770 Prest St, Detroit, MI 48227",
  },
  {
    id: "15777-ardmore",
    symbol: "realt-s-15777-ardmore-st-detroit-mi",
    name: "RealT - 15777 Ardmore St, Detroit, MI 48227",
  },
  {
    id: "15778-manor",
    symbol: "realt-s-15778-manor-st-detroit-mi",
    name: "RealT - 15778 Manor St, Detroit, MI 48238",
  },
  {
    id: "15784-monte-vista",
    symbol: "realt-s-15784-monte-vista-st-detroit-mi",
    name: "RealT - 15784 Monte Vista St, Detroit, MI 48238",
  },
  {
    id: "15796-hartwell",
    symbol: "realt-s-15796-hartwell-st-detroit-mi",
    name: "RealT - 15796 Hartwell St, Detroit, MI 48227",
  },
  {
    id: "15860-hartwell",
    symbol: "realt-s-15860-hartwell-st-detroit-mi",
    name: "RealT - 15860 Hartwell St, Detroit, MI 48227",
  },
  {
    id: "1617-s-avers",
    symbol: "realt-s-1617-s.avers-ave-chicago-il",
    name: "RealT - 1617 S Avers Ave, Chicago, IL 60623",
  },
  {
    id: "16200-fullerton",
    symbol: "realt-s-16200-fullerton-ave-detroit-mi",
    name: "RealT - 16200 Fullerton Ave, Detroit, MI 48227",
  },
  {
    id: "17500-evergreen",
    symbol: "realt-s-17500-evergreen-rd-detroit-mi",
    name: "RealT - 17500 Evergreen Rd, Detroit, MI 48219",
  },
  {
    id: "17809-charest",
    symbol: "realt-s-17809-charest-st-detroit-mi",
    name: "RealT - 17809 Charest St, Detroit, MI 48212",
  },
  {
    id: "17813-bradford",
    symbol: "realt-s-17813-bradford-st-detroit-mi",
    name: "RealT - 17813 Bradford St, Detroit, MI 48205",
  },
  {
    id: "1815-s-avers",
    symbol: "realt-s-1815-s.avers-ave-chicago-il",
    name: "RealT - 1815 S Avers Ave, Chicago, IL 60623",
  },
  {
    id: "18273-monte-vista",
    symbol: "realt-s-18273-monte-vista-st-detroit-mi",
    name: "RealT - 18273 Monte Vista St, Detroit, MI 48221",
  },
  {
    id: "18276-appoline",
    symbol: "realt-s-18276-appoline-st-detroit-mi",
    name: "RealT - 18276 Appoline St, Detroit, MI 48235",
  },
  {
    id: "18433-faust",
    symbol: "realt-s-18433-faust-ave-detroit-mi",
    name: "RealT - 18433 Faust Ave, Detroit, MI, 48219",
  },
  {
    id: "18466-fielding",
    symbol: "realt-s-18466-fielding-st-detroit-mi",
    name: "RealT -18466 Fielding St, Detroit, MI 48219",
  },
  {
    id: "18481-westphalia",
    symbol: "realt-s-18481-westphalia-st-detroit-mi",
    name: "RealT - 18481 Westphalia St, Detroit, MI 48205",
  },
  {
    id: "18776-sunderland",
    symbol: "realt-s-18776-sunderland-rd-detroit-mi",
    name: "RealT - 18776 Sunderland Rd, Detroit, MI 48219",
  },
  {
    id: "18900-mansfield",
    symbol: "realt-s-18900-mansfield-st-detroit-mi",
    name: "RealT - 18900 Mansfield St, Detroit, MI 48235",
  },
  {
    id: "18983-alcoy",
    symbol: "realt-s-18983-alcoy-ave-detroit-mi",
    name: "RealT - 18983 Alcoy Ave, Detroit, MI 48205",
  },
  {
    id: "19020-rosemont",
    symbol: "realt-s-19020-rosemont-ave-detroit-mi",
    name: "RealT - 19020 Rosemont Ave, Detroit, MI 48219",
  },
  {
    id: "19136-tracey",
    symbol: "realt-s-19136-tracey-st-detroit-mi",
    name: "RealT - 19136 Tracey St, Detroit MI 48235",
  },
  {
    id: "19163-mitchell",
    symbol: "realt-s-19163-mitchell-st-detroit-mi",
    name: "RealT - 19163 Mitchell St, Detroit, MI 48234",
  },
  {
    id: "19200-strasburg",
    symbol: "realt-s-19200-strasburg-st-detroit-mi",
    name: "RealT - 19200 Strasburg St, Detroit, MI 48205",
  },
  {
    id: "19201-westphalia",
    symbol: "realt-s-19201-westphalia-st-detroit-mi",
    name: "RealT - 19201 Westphalia St, Detroit, MI 48205",
  },
  {
    id: "19218-houghton",
    symbol: "realt-s-19218-houghton-st-detroit-mi",
    name: "RealT - 19218 Houghton St, Detroit, MI 48219",
  },
  {
    id: "19311-keystone",
    symbol: "realt-s-19311-keystone-st-detroit-mi",
    name: "RealT - 19311 Keystone St, Detroit, MI 48234",
  },
  {
    id: "19317-gable",
    symbol: "realt-s-19317-gable-st-detroit-mi",
    name: "RealT - 19317 Gable St, Detroit, MI 48234",
  },
  {
    id: "19333-moenart",
    symbol: "realt-s-19333-moenart-st-detroit-mi",
    name: "RealT - 19333 Moenart St, Detroit MI 48234",
  },
  {
    id: "19596-goulburn",
    symbol: "realt-s-19596-goulburn-st-detroit-mi",
    name: "RealT - 19596 Goulburn Ave, Detroit, MI 48205",
  },
  {
    id: "19996-joann",
    symbol: "realt-s-19996-joann-ave-detroit-mi",
    name: "RealT - 19996 Joann Ave, Detroit, MI 48205",
  },
  {
    id: "1art",
    symbol: "1art",
    name: "OneArt",
  },
  {
    id: "1bch",
    symbol: "1bch",
    name: "1BCH",
  },
  {
    id: "1beam",
    symbol: "1beam",
    name: "1Beam",
  },
  {
    id: "1box",
    symbol: "1box",
    name: "1BOX",
  },
  {
    id: "1doge",
    symbol: "1doge",
    name: "1Doge",
  },
  {
    id: "1-dollar",
    symbol: "oneusd",
    name: "1 Dollar",
  },
  {
    id: "1eco",
    symbol: "1eco",
    name: "1eco",
  },
  {
    id: "1inch",
    symbol: "1inch",
    name: "1inch",
  },
  {
    id: "1inch-wormhole",
    symbol: "1inch",
    name: "1INCH (Wormhole)",
  },
  {
    id: "1million-nfts",
    symbol: "1mil",
    name: "1MillionNFTs",
  },
  {
    id: "1million-token",
    symbol: "1mt",
    name: "1Million",
  },
  {
    id: "1nft",
    symbol: "1nft",
    name: "1NFT",
  },
  {
    id: "1peco",
    symbol: "1peco",
    name: "1peco",
  },
  {
    id: "1safu",
    symbol: "safu",
    name: "1SAFU",
  },
  {
    id: "1sol",
    symbol: "1sol",
    name: "1Sol",
  },
  {
    id: "1sol-io-wormhole",
    symbol: "1sol",
    name: "1sol.io (Wormhole)",
  },
  {
    id: "1tronic",
    symbol: "1trc",
    name: "1TRONIC",
  },
  {
    id: "1-up",
    symbol: "1-up",
    name: "1-UP",
  },
  {
    id: "1world",
    symbol: "1wo",
    name: "1World",
  },
  {
    id: "1x-long-btc-implied-volatility-token",
    symbol: "bvol",
    name: "Bitcoin Volatility Token",
  },
  {
    id: "1x-short-algorand-token",
    symbol: "algohedge",
    name: "1X Short Algorand Token",
  },
  {
    id: "1x-short-bitcoin-cash-token",
    symbol: "bchhedge",
    name: "1X Short Bitcoin Cash Token",
  },
  {
    id: "1x-short-bitcoin-token",
    symbol: "hedge",
    name: "1X Short Bitcoin Token",
  },
  {
    id: "1x-short-bnb-token",
    symbol: "bnbhedge",
    name: "1X Short BNB",
  },
  {
    id: "1x-short-btc-implied-volatility",
    symbol: "ibvol",
    name: "Inverse Bitcoin Volatility",
  },
  {
    id: "1x-short-cardano-token",
    symbol: "adahedge",
    name: "1X Short Cardano",
  },
  {
    id: "1x-short-chainlink-token",
    symbol: "linkhedge",
    name: "1X Short Chainlink",
  },
  {
    id: "1x-short-compound-token-token",
    symbol: "comphedge",
    name: "1X Short Compound",
  },
  {
    id: "1x-short-cosmos-token",
    symbol: "atomhedge",
    name: "1X Short Cosmos",
  },
  {
    id: "1x-short-defi-index-token",
    symbol: "defihedge",
    name: "1X Short DeFi Index",
  },
  {
    id: "1x-short-dogecoin-token",
    symbol: "dogehedge",
    name: "1X Short Dogecoin",
  },
  {
    id: "1x-short-eos-token",
    symbol: "eoshedge",
    name: "1X Short EOS Token",
  },
  {
    id: "1x-short-ethereum-token",
    symbol: "ethhedge",
    name: "1X Short Ethereum Token",
  },
  {
    id: "1x-short-exchange-token-index-token",
    symbol: "exchhedge",
    name: "1X Short Exchange Token Index Token",
  },
  {
    id: "1x-short-litecoin-token",
    symbol: "ltchedge",
    name: "1X Short Litecoin Token",
  },
  {
    id: "1x-short-matic-token",
    symbol: "matichedge",
    name: "1X Short Matic",
  },
  {
    id: "1x-short-okb-token",
    symbol: "okbhedge",
    name: "1X Short OKB",
  },
  {
    id: "1x-short-privacy-index-token",
    symbol: "privhedge",
    name: "1X Short Privacy Index",
  },
  {
    id: "1x-short-shitcoin-index-token",
    symbol: "hedgeshit",
    name: "1X Short Shitcoin Index Token",
  },
  {
    id: "1x-short-swipe-token",
    symbol: "sxphedge",
    name: "1X Short Swipe",
  },
  {
    id: "1x-short-tezos-token",
    symbol: "xtzhedge",
    name: "1X Short Tezos",
  },
  {
    id: "1x-short-theta-network-token",
    symbol: "thetahedge",
    name: "1X Short Theta Network",
  },
  {
    id: "1x-short-tomochain-token",
    symbol: "tomohedge",
    name: "1X Short TomoChain",
  },
  {
    id: "1x-short-trx-token",
    symbol: "trxhedge",
    name: "1X Short TRX",
  },
  {
    id: "1x-short-vechain-token",
    symbol: "vethedge",
    name: "1X Short VeChain",
  },
  {
    id: "1x-short-xrp-token",
    symbol: "xrphedge",
    name: "1X Short XRP",
  },
  {
    id: "20200-lesure",
    symbol: "realt-s-20200-lesure-st-detroit-mi",
    name: "RealT - 20200 Lesure St, Detroit, MI 48235",
  },
  {
    id: "2022moon",
    symbol: "2022m",
    name: "2022MOON",
  },
  {
    id: "2030-floki",
    symbol: "2030floki",
    name: "2030 Floki",
  },
  {
    id: "25097-andover",
    symbol: "realt-s-25097-andover-dr-dearborn-heights-mi",
    name: "RealT - 25097 Andover Dr, Dearborn Heights, MI 48125",
  },
  {
    id: "272-n-e-42nd-court",
    symbol: "realt-s-272-n.e.-42nd-court-deerfield-beach-fl",
    name: "RealT - 272 N.E. 42nd Court, Deerfield Beach, FL 33064",
  },
  {
    id: "28vck",
    symbol: "vck",
    name: "28VCK",
  },
  {
    id: "2acoin",
    symbol: "arms",
    name: "2ACoin",
  },
  {
    id: "2crazynft",
    symbol: "2crz",
    name: "2crazyNFT",
  },
  {
    id: "2gather",
    symbol: "two",
    name: "2gather",
  },
  {
    id: "2gether-2",
    symbol: "2gt",
    name: "2gether",
  },
  {
    id: "2key",
    symbol: "2key",
    name: "2key.network",
  },
  {
    id: "2local-2",
    symbol: "2lc",
    name: "2local",
  },
  {
    id: "2omb-finance",
    symbol: "2omb",
    name: "2omb",
  },
  {
    id: "2share",
    symbol: "2shares",
    name: "2SHARE",
  },
  {
    id: "2x2",
    symbol: "2x2",
    name: "2X2",
  },
  {
    id: "300fit",
    symbol: "fit",
    name: "300FIT",
  },
  {
    id: "30mb-token",
    symbol: "3omb",
    name: "3OMB",
  },
  {
    id: "3432-harding",
    symbol: "realt-s-3432-harding-street-detroit-mi",
    name: "RealT - 3432 Harding Street, Detroit, MI, 48214",
  },
  {
    id: "3shares",
    symbol: "3share",
    name: "3Share",
  },
  {
    id: "3x-long-algorand-token",
    symbol: "algobull",
    name: "3X Long Algorand Token",
  },
  {
    id: "3x-long-altcoin-index-token",
    symbol: "altbull",
    name: "3X Long Altcoin Index Token",
  },
  {
    id: "3x-long-balancer-token",
    symbol: "balbull",
    name: "3X Long Balancer",
  },
  {
    id: "3x-long-bilira-token",
    symbol: "trybbull",
    name: "3X Long BiLira Token",
  },
  {
    id: "3x-long-bitcoin-cash-token",
    symbol: "bchbull",
    name: "3X Long Bitcoin Cash Token",
  },
  {
    id: "3x-long-bitcoin-sv-token",
    symbol: "bsvbull",
    name: "3X Long Bitcoin SV Token",
  },
  {
    id: "3x-long-bitcoin-token",
    symbol: "bull",
    name: "3X Long Bitcoin Token",
  },
  {
    id: "3x-long-bnb-token",
    symbol: "bnbbull",
    name: "3X Long BNB Token",
  },
  {
    id: "3x-long-cardano-token",
    symbol: "adabull",
    name: "3X Long Cardano Token",
  },
  {
    id: "3x-long-chainlink-token",
    symbol: "linkbull",
    name: "3X Long Chainlink Token",
  },
  {
    id: "3x-long-compound-token-token",
    symbol: "compbull",
    name: "3X Long Compound",
  },
  {
    id: "3x-long-compound-usdt-token",
    symbol: "cusdtbull",
    name: "3X Long Compound USDT",
  },
  {
    id: "3x-long-cosmos-token",
    symbol: "atombull",
    name: "3X Long Cosmos Token",
  },
  {
    id: "3x-long-defi-index-token",
    symbol: "defibull",
    name: "3X Long DeFi Index",
  },
  {
    id: "3x-long-dogecoin-token",
    symbol: "dogebull",
    name: "3X Long Dogecoin Token",
  },
  {
    id: "3x-long-dragon-index-token",
    symbol: "drgnbull",
    name: "3X Long Dragon Index Token",
  },
  {
    id: "3x-long-eos-token",
    symbol: "eosbull",
    name: "3X Long EOS Token",
  },
  {
    id: "3x-long-ethereum-classic-token",
    symbol: "etcbull",
    name: "3X Long Ethereum Classic Token",
  },
  {
    id: "3x-long-ethereum-token",
    symbol: "ethbull",
    name: "3X Long Ethereum Token",
  },
  {
    id: "3x-long-exchange-token-index-token",
    symbol: "exchbull",
    name: "3X Long Exchange Token Index Token",
  },
  {
    id: "3x-long-huobi-token-token",
    symbol: "htbull",
    name: "3X Long Huobi Token Token",
  },
  {
    id: "3x-long-kyber-network-token",
    symbol: "kncbull",
    name: "3X Long Kyber Network",
  },
  {
    id: "3x-long-leo-token",
    symbol: "leobull",
    name: "3X Long LEO Token",
  },
  {
    id: "3x-long-litecoin-token",
    symbol: "ltcbull",
    name: "3X Long Litecoin Token",
  },
  {
    id: "3x-long-maker-token",
    symbol: "mkrbull",
    name: "3X Long Maker",
  },
  {
    id: "3x-long-matic-token",
    symbol: "maticbull",
    name: "3X Long Matic Token",
  },
  {
    id: "3x-long-midcap-index-token",
    symbol: "midbull",
    name: "3X Long Midcap Index Token",
  },
  {
    id: "3x-long-okb-token",
    symbol: "okbbull",
    name: "3X Long OKB Token",
  },
  {
    id: "3x-long-pax-gold-token",
    symbol: "paxgbull",
    name: "3X Long PAX Gold Token",
  },
  {
    id: "3x-long-privacy-index-token",
    symbol: "privbull",
    name: "3X Long Privacy Index",
  },
  {
    id: "3x-long-shitcoin-index-token",
    symbol: "bullshit",
    name: "3X Long Shitcoin Index Token",
  },
  {
    id: "3x-long-stellar-token",
    symbol: "xlmbull",
    name: "3X Long Stellar",
  },
  {
    id: "3x-long-sushi-token",
    symbol: "sushibull",
    name: "3X Long Sushi",
  },
  {
    id: "3x-long-swipe-token",
    symbol: "sxpbull",
    name: "3X Long Swipe Token",
  },
  {
    id: "3x-long-tether-gold-token",
    symbol: "xautbull",
    name: "3X Long Tether Gold Token",
  },
  {
    id: "3x-long-tether-token",
    symbol: "usdtbull",
    name: "3X Long Tether Token",
  },
  {
    id: "3x-long-tezos-token",
    symbol: "xtzbull",
    name: "3X Long Tezos Token",
  },
  {
    id: "3x-long-theta-network-token",
    symbol: "thetabull",
    name: "3X Long Theta Network",
  },
  {
    id: "3x-long-tomochain-token",
    symbol: "tomobull",
    name: "3X Long TomoChain Token",
  },
  {
    id: "3x-long-trx-token",
    symbol: "trxbull",
    name: "3X Long TRX Token",
  },
  {
    id: "3x-long-vechain-token",
    symbol: "vetbull",
    name: "3X Long VeChain",
  },
  {
    id: "3x-long-xrp-token",
    symbol: "xrpbull",
    name: "3X Long XRP Token",
  },
  {
    id: "3x-long-zcash-token",
    symbol: "zecbull",
    name: "3X Long Zcash",
  },
  {
    id: "3x-short-altcoin-index-token",
    symbol: "altbear",
    name: "3X Short Altcoin Index Token",
  },
  {
    id: "3x-short-balancer-token",
    symbol: "balbear",
    name: "3X Short Balancer",
  },
  {
    id: "3x-short-bilira-token",
    symbol: "trybbear",
    name: "3X Short BiLira Token",
  },
  {
    id: "3x-short-bitcoin-cash-token",
    symbol: "bchbear",
    name: "3X Short Bitcoin Cash Token",
  },
  {
    id: "3x-short-bitcoin-sv-token",
    symbol: "bsvbear",
    name: "3X Short Bitcoin SV Token",
  },
  {
    id: "3x-short-bitcoin-token",
    symbol: "bear",
    name: "3X Short Bitcoin Token",
  },
  {
    id: "3x-short-bnb-token",
    symbol: "bnbbear",
    name: "3X Short BNB Token",
  },
  {
    id: "3x-short-cardano-token",
    symbol: "adabear",
    name: "3X Short Cardano Token",
  },
  {
    id: "3x-short-chainlink-token",
    symbol: "linkbear",
    name: "3X Short Chainlink Token",
  },
  {
    id: "3x-short-compound-token-token",
    symbol: "compbear",
    name: "3X Short Compound",
  },
  {
    id: "3x-short-compound-usdt-token",
    symbol: "cusdtbear",
    name: "3X Short Compound USDT",
  },
  {
    id: "3x-short-defi-index-token",
    symbol: "defibear",
    name: "3X Short DeFi Index",
  },
  {
    id: "3x-short-dragon-index-token",
    symbol: "drgnbear",
    name: "3X Short Dragon Index Token",
  },
  {
    id: "3x-short-eos-token",
    symbol: "eosbear",
    name: "3X Short EOS Token",
  },
  {
    id: "3x-short-ethereum-classic-token",
    symbol: "etcbear",
    name: "3X Short Ethereum Classic Token",
  },
  {
    id: "3x-short-ethereum-token",
    symbol: "ethbear",
    name: "3X Short Ethereum Token",
  },
  {
    id: "3x-short-exchange-token-index-token",
    symbol: "exchbear",
    name: "3X Short Exchange Token Index Token",
  },
  {
    id: "3x-short-huobi-token-token",
    symbol: "htbear",
    name: "3X Short Huobi Token Token",
  },
  {
    id: "3x-short-kyber-network-token",
    symbol: "kncbear",
    name: "3X Short Kyber Network",
  },
  {
    id: "3x-short-leo-token",
    symbol: "leobear",
    name: "3X Short LEO Token",
  },
  {
    id: "3x-short-litecoin-token",
    symbol: "ltcbear",
    name: "3X Short Litecoin Token",
  },
  {
    id: "3x-short-maker-token",
    symbol: "mkrbear",
    name: "3X Short Maker",
  },
  {
    id: "3x-short-midcap-index-token",
    symbol: "midbear",
    name: "3X Short Midcap Index Token",
  },
  {
    id: "3x-short-okb-token",
    symbol: "okbbear",
    name: "3X Short OKB Token",
  },
  {
    id: "3x-short-pax-gold-token",
    symbol: "paxgbear",
    name: "3X Short PAX Gold Token",
  },
  {
    id: "3x-short-privacy-index-token",
    symbol: "privbear",
    name: "3X Short Privacy Index",
  },
  {
    id: "3x-short-shitcoin-index-token",
    symbol: "bearshit",
    name: "3X Short Shitcoin Index Token",
  },
  {
    id: "3x-short-stellar-token",
    symbol: "xlmbear",
    name: "3X Short Stellar",
  },
  {
    id: "3x-short-sushi-token",
    symbol: "sushibear",
    name: "3X Short Sushi",
  },
  {
    id: "3x-short-swipe-token",
    symbol: "sxpbear",
    name: "3X Short Swipe Token",
  },
  {
    id: "3x-short-tether-gold-token",
    symbol: "xautbear",
    name: "3X Short Tether Gold Token",
  },
  {
    id: "3x-short-tether-token",
    symbol: "usdtbear",
    name: "3X Short Tether Token",
  },
  {
    id: "3x-short-tezos-token",
    symbol: "xtzbear",
    name: "3X Short Tezos Token",
  },
  {
    id: "3x-short-trx-token",
    symbol: "trxbear",
    name: "3X Short TRX Token",
  },
  {
    id: "3x-short-vechain-token",
    symbol: "vetbear",
    name: "3X Short VeChain",
  },
  {
    id: "3x-short-xrp-token",
    symbol: "xrpbear",
    name: "3X Short XRP Token",
  },
  {
    id: "402-s-kostner",
    symbol: "realt-s-402-s.kostner-ave-chicago-il",
    name: "RealT - 402 S Kostner Ave, Chicago, IL 60624",
  },
  {
    id: "404",
    symbol: "404",
    name: "404",
  },
  {
    id: "4061-grand",
    symbol: "realt-s-4061-grand-st-detroit-mi",
    name: "RealT - 4061 Grand St, Detroit, MI 48238",
  },
  {
    id: "42-coin",
    symbol: "42",
    name: "42-coin",
  },
  {
    id: "4340-east-71",
    symbol: "realt-s-4340-east-71-cleveland-oh",
    name: "RealT - 4340 East 71, Cleveland, OH 44105",
  },
  {
    id: "4380-beaconsfield",
    symbol: "realt-s-4380-beaconsfield-st-detroit-mi",
    name: "RealT - 4380 Beaconsfield St, Detroit, MI 48224",
  },
  {
    id: "4680-buckingham",
    symbol: "realt-s-4680-buckingham-ave-detroit-mi",
    name: "RealT - 4680 Buckingham Ave, Detroit, MI 48224",
  },
  {
    id: "4852-4854-w-cortez",
    symbol: "realt-s-4852-4854-w.cortez-st-chicago-il",
    name: "RealT - 4852-4854 W Cortez St, Chicago, IL 60651",
  },
  {
    id: "4artechnologies",
    symbol: "4art",
    name: "4ART Coin",
  },
  {
    id: "4bulls",
    symbol: "4b",
    name: "4Bulls",
  },
  {
    id: "4d-twin-maps",
    symbol: "map",
    name: "4D Twin Maps",
  },
  {
    id: "4int",
    symbol: "4int",
    name: "4INT",
  },
  {
    id: "4jnet",
    symbol: "4jnet",
    name: "4JNET",
  },
  {
    id: "4mw",
    symbol: "4mw",
    name: "4 Meta World",
  },
  {
    id: "4new",
    symbol: "kwatt",
    name: "4New",
  },
  {
    id: "4play",
    symbol: "4play",
    name: "4PLAY",
  },
  {
    id: "4-stock",
    symbol: "4stc",
    name: "4-Stock",
  },
  {
    id: "520",
    symbol: "520",
    name: "520",
  },
  {
    id: "5601-s-wood",
    symbol: "realt-s-5601-s.wood-st-chicago-il",
    name: "RealT - 5601 S Wood St, Chicago, IL 60636",
  },
  {
    id: "581-587-jefferson",
    symbol: "realt-s-581-587-jefferson-ave-rochester-ny",
    name: "RealT - 581-587 Jefferson Ave, Rochester, NY 14611",
  },
  {
    id: "5942-audubon",
    symbol: "realt-s-5942-audubon-rd-detroit-mi",
    name: "RealT - 5942 Audubon Rd, Detroit, MI 48224",
  },
  {
    id: "5g-cash",
    symbol: "vgc",
    name: "5G-CASH",
  },
  {
    id: "5ire",
    symbol: "5ire",
    name: "5ire",
  },
  {
    id: "5star",
    symbol: "5star",
    name: "5Star",
  },
  {
    id: "5table-finance",
    symbol: "5table",
    name: "5table Finance",
  },
  {
    id: "6923-greenview",
    symbol: "realt-s-6923-greenview-ave-detroit-mi",
    name: "RealT - 6923 Greenview Ave, Detroit, MI 48228",
  },
  {
    id: "7eleven",
    symbol: "7e",
    name: "7ELEVEN",
  },
  {
    id: "7plus-coin",
    symbol: "sv7",
    name: "7Plus Coin",
  },
  {
    id: "7share",
    symbol: "7share",
    name: "7Share",
  },
  {
    id: "7up",
    symbol: "7up",
    name: "7up",
  },
  {
    id: "808ta-token",
    symbol: "808ta",
    name: "808TA",
  },
  {
    id: "8181-bliss",
    symbol: "realt-s-8181-bliss-st-detroit-mi",
    name: "RealT - 8181 Bliss St, Detroit, MI 48234",
  },
  {
    id: "8342-schaefer",
    symbol: "realt-s-8342-schaefer-highway-detroit-mi",
    name: "RealT - 8342 Schaefer Highway, Detroit, MI 48228",
  },
  {
    id: "867",
    symbol: "867",
    name: "867",
  },
  {
    id: "888tron",
    symbol: "888",
    name: "888tron",
  },
  {
    id: "88mph",
    symbol: "mph",
    name: "88mph",
  },
  {
    id: "8bit-doge",
    symbol: "bitd",
    name: "8Bit Doge",
  },
  {
    id: "8dao",
    symbol: "8dao",
    name: "8DAO",
  },
  {
    id: "8ight-finance",
    symbol: "eight",
    name: "8ight Finance",
  },
  {
    id: "8pay",
    symbol: "8pay",
    name: "8Pay",
  },
  {
    id: "8x8-protocol",
    symbol: "exe",
    name: "8X8 Protocol",
  },
  {
    id: "9133-devonshire",
    symbol: "realt-s-9133-devonshire-rd-detroit-mi",
    name: "RealT - 9133 Devonshire Rd, Detroit, MI 48224",
  },
  {
    id: "9165-kensington",
    symbol: "realt-s-9165-kensington-ave-detroit-mi",
    name: "RealT - 9165 Kensington Ave, Detroit, MI 48224",
  },
  {
    id: "9166-devonshire",
    symbol: "realt-s-9166-devonshire-rd-detroit-mi",
    name: "RealT - 9166 Devonshire Rd, Detroit MI 48224",
  },
  {
    id: "9169-boleyn",
    symbol: "realt-s-9169-boleyn-st-detroit-mi",
    name: "RealT - 9169 Boleyn St, Detroit, MI, 48224",
  },
  {
    id: "9309-courville",
    symbol: "realt-s-9309-courville-st-detroit-mi",
    name: "RealT - 9309 Courville St, Detroit, MI 48224",
  },
  {
    id: "9336-patton",
    symbol: "realt-s-9336-patton-st-detroit-mi",
    name: "RealT - 9336 Patton St, Detroit, MI 48228",
  },
  {
    id: "9465-beaconsfield",
    symbol: "realt-s-9465-beaconsfield-st-detroit-mi",
    name: "RealT - 9465 Beaconsfield St, Detroit, MI 48224",
  },
  {
    id: "9481-wayburn",
    symbol: "realt-s-9481-wayburn-st-detroit-mi",
    name: "RealT - 9481 Wayburn St, Detroit, MI 48224",
  },
  {
    id: "9717-everts",
    symbol: "realt-s-9717-everts-st-detroit-mi",
    name: "RealT - 9717 Everts St, Detroit, MI 48224",
  },
  {
    id: "9920-bishop",
    symbol: "realt-s-9920-bishop-st-detroit-mi",
    name: "RealT - 9920 Bishop St, Detroit, MI 48224",
  },
  {
    id: "99defi",
    symbol: "99defi",
    name: "99Defi",
  },
  {
    id: "99starz",
    symbol: "stz",
    name: "99Starz",
  },
  {
    id: "a4-finance",
    symbol: "a4",
    name: "A4 Finance",
  },
  {
    id: "aag-ventures",
    symbol: "aag",
    name: "AAG Ventures",
  },
  {
    id: "aananaapegarden",
    symbol: "bag",
    name: "BananaApeGarden",
  },
  {
    id: "aaptitude",
    symbol: "aapt",
    name: "AAptitude",
  },
  {
    id: "aarma",
    symbol: "arma",
    name: "Aarma",
  },
  {
    id: "aave",
    symbol: "aave",
    name: "Aave",
  },
  {
    id: "aave-aave",
    symbol: "aaave",
    name: "Aave AAVE",
  },
  {
    id: "aave-amm-bptbalweth",
    symbol: "aammbptbalweth",
    name: "Aave AMM BptBALWETH",
  },
  {
    id: "aave-amm-bptwbtcweth",
    symbol: "aammbptwbtcweth",
    name: "Aave AMM BptWBTCWETH",
  },
  {
    id: "aave-amm-dai",
    symbol: "aammdai",
    name: "Aave AMM DAI",
  },
  {
    id: "aave-amm-uniaaveweth",
    symbol: "aammuniaaveweth",
    name: "Aave AMM UniAAVEWETH",
  },
  {
    id: "aave-amm-unibatweth",
    symbol: "aammunibatweth",
    name: "Aave AMM UniBATWETH",
  },
  {
    id: "aave-amm-unicrvweth",
    symbol: "aammunicrvweth",
    name: "Aave AMM UniCRVWETH",
  },
  {
    id: "aave-amm-unidaiusdc",
    symbol: "aammunidaiusdc",
    name: "Aave AMM UniDAIUSDC",
  },
  {
    id: "aave-amm-unidaiweth",
    symbol: "aammunidaiweth",
    name: "Aave AMM UniDAIWETH",
  },
  {
    id: "aave-amm-unilinkweth",
    symbol: "aammunilinkweth",
    name: "Aave AMM UniLINKWETH",
  },
  {
    id: "aave-amm-unimkrweth",
    symbol: "aammunimkrweth",
    name: "Aave AMM UniMKRWETH",
  },
  {
    id: "aave-amm-unirenweth",
    symbol: "aammunirenweth",
    name: "Aave AMM UniRENWETH",
  },
  {
    id: "aave-amm-unisnxweth",
    symbol: "aammunisnxweth",
    name: "Aave AMM UniSNXWETH",
  },
  {
    id: "aave-amm-uniuniweth",
    symbol: "aammuniuniweth",
    name: "Aave AMM UniUNIWETH",
  },
  {
    id: "aave-amm-uniusdcweth",
    symbol: "aammuniusdcweth",
    name: "Aave AMM UniUSDCWETH",
  },
  {
    id: "aave-amm-uniwbtcusdc",
    symbol: "aammuniwbtcusdc",
    name: "Aave AMM UniWBTCUSDC",
  },
  {
    id: "aave-amm-uniwbtcweth",
    symbol: "aammuniwbtcweth",
    name: "Aave AMM UniWBTCWETH",
  },
  {
    id: "aave-amm-uniyfiweth",
    symbol: "aammuniyfiweth",
    name: "Aave AMM UniYFIWETH",
  },
  {
    id: "aave-amm-usdc",
    symbol: "aammusdc",
    name: "Aave AMM USDC",
  },
  {
    id: "aave-amm-usdt",
    symbol: "aammusdt",
    name: "Aave AMM USDT",
  },
  {
    id: "aave-amm-wbtc",
    symbol: "aammwbtc",
    name: "Aave AMM WBTC",
  },
  {
    id: "aave-amm-weth",
    symbol: "aammweth",
    name: "Aave AMM WETH",
  },
  {
    id: "aave-bal",
    symbol: "abal",
    name: "Aave BAL",
  },
  {
    id: "aave-balancer-pool-token",
    symbol: "abpt",
    name: "Aave Balancer Pool Token",
  },
  {
    id: "aave-bat",
    symbol: "abat",
    name: "Aave BAT",
  },
  {
    id: "aave-bat-v1",
    symbol: "abat",
    name: "Aave BAT v1",
  },
  {
    id: "aave-busd",
    symbol: "abusd",
    name: "Aave BUSD",
  },
  {
    id: "aave-busd-v1",
    symbol: "abusd",
    name: "Aave BUSD v1",
  },
  {
    id: "aave-crv",
    symbol: "acrv",
    name: "Aave CRV",
  },
  {
    id: "aave-dai",
    symbol: "adai",
    name: "Aave DAI",
  },
  {
    id: "aave-dai-v1",
    symbol: "adai",
    name: "Aave DAI v1",
  },
  {
    id: "aave-enj",
    symbol: "aenj",
    name: "Aave ENJ",
  },
  {
    id: "aave-enj-v1",
    symbol: "aenj",
    name: "Aave ENJ v1",
  },
  {
    id: "aave-eth-v1",
    symbol: "aeth",
    name: "Aave ETH v1",
  },
  {
    id: "aavegotchi",
    symbol: "ghst",
    name: "Aavegotchi",
  },
  {
    id: "aavegotchi-alpha",
    symbol: "alpha",
    name: "Aavegotchi ALPHA",
  },
  {
    id: "aavegotchi-fomo",
    symbol: "fomo",
    name: "Aavegotchi FOMO",
  },
  {
    id: "aavegotchi-fud",
    symbol: "fud",
    name: "Aavegotchi FUD",
  },
  {
    id: "aavegotchi-kek",
    symbol: "kek",
    name: "Aavegotchi KEK",
  },
  {
    id: "aave-gusd",
    symbol: "agusd",
    name: "Aave GUSD",
  },
  {
    id: "aave-interest-bearing-steth",
    symbol: "asteth",
    name: "Aave Interest Bearing STETH",
  },
  {
    id: "aave-knc",
    symbol: "aknc",
    name: "Aave KNC",
  },
  {
    id: "aave-knc-v1",
    symbol: "aknc",
    name: "Aave KNC v1",
  },
  {
    id: "aave-link",
    symbol: "alink",
    name: "Aave LINK",
  },
  {
    id: "aave-link-v1",
    symbol: "alink",
    name: "Aave LINK v1",
  },
  {
    id: "aave-mana",
    symbol: "amana",
    name: "Aave MANA",
  },
  {
    id: "aave-mana-v1",
    symbol: "amana",
    name: "Aave MANA v1",
  },
  {
    id: "aave-mkr",
    symbol: "amkr",
    name: "Aave MKR",
  },
  {
    id: "aave-mkr-v1",
    symbol: "amkr",
    name: "Aave MKR v1",
  },
  {
    id: "aave-polygon-aave",
    symbol: "amaave",
    name: "Aave Polygon AAVE",
  },
  {
    id: "aave-polygon-dai",
    symbol: "amdai",
    name: "Aave Polygon DAI",
  },
  {
    id: "aave-polygon-usdc",
    symbol: "amusdc",
    name: "Aave Polygon USDC",
  },
  {
    id: "aave-polygon-usdt",
    symbol: "amusdt",
    name: "Aave Polygon USDT",
  },
  {
    id: "aave-polygon-wbtc",
    symbol: "amwbtc",
    name: "Aave Polygon WBTC",
  },
  {
    id: "aave-polygon-weth",
    symbol: "amweth",
    name: "Aave Polygon WETH",
  },
  {
    id: "aave-polygon-wmatic",
    symbol: "amwmatic",
    name: "Aave Polygon WMATIC",
  },
  {
    id: "aave-rai",
    symbol: "arai",
    name: "Aave RAI",
  },
  {
    id: "aave-ren",
    symbol: "aren",
    name: "Aave REN",
  },
  {
    id: "aave-ren-v1",
    symbol: "aren",
    name: "Aave REN v1",
  },
  {
    id: "aave-snx",
    symbol: "asnx",
    name: "Aave SNX",
  },
  {
    id: "aave-snx-v1",
    symbol: "asnx",
    name: "Aave SNX v1",
  },
  {
    id: "aave-susd",
    symbol: "asusd",
    name: "Aave SUSD",
  },
  {
    id: "aave-susd-v1",
    symbol: "asusd",
    name: "Aave SUSD v1",
  },
  {
    id: "aave-tusd",
    symbol: "atusd",
    name: "Aave TUSD",
  },
  {
    id: "aave-tusd-v1",
    symbol: "atusd",
    name: "Aave TUSD v1",
  },
  {
    id: "aave-uni",
    symbol: "auni",
    name: "Aave UNI",
  },
  {
    id: "aave-usdc",
    symbol: "ausdc",
    name: "Aave USDC",
  },
  {
    id: "aave-usdc-v1",
    symbol: "ausdc",
    name: "Aave USDC v1",
  },
  {
    id: "aave-usdt",
    symbol: "ausdt",
    name: "Aave USDT",
  },
  {
    id: "aave-usdt-v1",
    symbol: "ausdt",
    name: "Aave USDT v1",
  },
  {
    id: "aave-wbtc",
    symbol: "awbtc",
    name: "Aave WBTC",
  },
  {
    id: "aave-wbtc-v1",
    symbol: "awbtc",
    name: "Aave WBTC v1",
  },
  {
    id: "aave-weth",
    symbol: "aweth",
    name: "Aave WETH",
  },
  {
    id: "aave-wormhole",
    symbol: "aave",
    name: "Aave (Wormhole)",
  },
  {
    id: "aave-xsushi",
    symbol: "axsushi",
    name: "Aave XSUSHI",
  },
  {
    id: "aave-yfi",
    symbol: "ayfi",
    name: "Aave YFI",
  },
  {
    id: "aave-zrx",
    symbol: "azrx",
    name: "Aave ZRX",
  },
  {
    id: "aave-zrx-v1",
    symbol: "azrx",
    name: "Aave ZRX v1",
  },
  {
    id: "aax-token",
    symbol: "aab",
    name: "AAX",
  },
  {
    id: "abachi",
    symbol: "abi",
    name: "Abachi",
  },
  {
    id: "abacus",
    symbol: "abc",
    name: "Abacus",
  },
  {
    id: "abby-inu",
    symbol: "abby",
    name: "Abby Inu",
  },
  {
    id: "abc-chain",
    symbol: "abc",
    name: "ABC Chain",
  },
  {
    id: "abcc-token",
    symbol: "at",
    name: "ABCC",
  },
  {
    id: "abell-coin",
    symbol: "abc",
    name: "Abell Coin",
  },
  {
    id: "abey",
    symbol: "abey",
    name: "Abey",
  },
  {
    id: "abitshadow-token",
    symbol: "abst",
    name: "Abitshadow",
  },
  {
    id: "able-finance",
    symbol: "able",
    name: "Able Finance",
  },
  {
    id: "absolute",
    symbol: "abs",
    name: "Absolute",
  },
  {
    id: "absolute-sync-token",
    symbol: "ast",
    name: "Absolute Sync",
  },
  {
    id: "absorber",
    symbol: "abs",
    name: "Absorber",
  },
  {
    id: "abulaba",
    symbol: "aaa",
    name: "Abulaba",
  },
  {
    id: "abura-farm",
    symbol: "abu",
    name: "Abura Farm",
  },
  {
    id: "acala",
    symbol: "aca",
    name: "Acala",
  },
  {
    id: "acala-dollar",
    symbol: "ausd",
    name: "Acala Dollar",
  },
  {
    id: "acash-coin",
    symbol: "aca",
    name: "Acash Coin",
  },
  {
    id: "aca-token",
    symbol: "aca",
    name: "ACA",
  },
  {
    id: "accel-defi",
    symbol: "accel",
    name: "Accel Defi",
  },
  {
    id: "accesslauncher",
    symbol: "acx",
    name: "AccessLauncher",
  },
  {
    id: "aced",
    symbol: "aced",
    name: "Aced [OLD]",
  },
  {
    id: "aced-2",
    symbol: "aced",
    name: "Aced",
  },
  {
    id: "acent",
    symbol: "ace",
    name: "Acent",
  },
  {
    id: "acestarter",
    symbol: "astar",
    name: "AceStarter",
  },
  {
    id: "acetoken",
    symbol: "ace",
    name: "ACEToken",
  },
  {
    id: "acet-token",
    symbol: "act",
    name: "Acet",
  },
  {
    id: "ac-exchange-token",
    symbol: "acxt",
    name: "ACDX Exchange",
  },
  {
    id: "achain",
    symbol: "act",
    name: "Achain",
  },
  {
    id: "acknoledger",
    symbol: "ack",
    name: "AcknoLedger",
  },
  {
    id: "ac-milan-fan-token",
    symbol: "acm",
    name: "AC Milan Fan Token",
  },
  {
    id: "acoconut",
    symbol: "ac",
    name: "ACoconut",
  },
  {
    id: "acoin",
    symbol: "acoin",
    name: "Acoin",
  },
  {
    id: "acreage-coin",
    symbol: "acr",
    name: "Acreage Coin",
  },
  {
    id: "acryptos",
    symbol: "acs",
    name: "ACryptoS",
  },
  {
    id: "acryptosi",
    symbol: "acsi",
    name: "ACryptoSI",
  },
  {
    id: "acta-finance",
    symbol: "acta",
    name: "Acta Finance",
  },
  {
    id: "actifit",
    symbol: "afit",
    name: "Actifit",
  },
  {
    id: "actinium",
    symbol: "acm",
    name: "Actinium",
  },
  {
    id: "action-coin",
    symbol: "actn",
    name: "Action Coin",
  },
  {
    id: "activada",
    symbol: "acada",
    name: "ActivADA",
  },
  {
    id: "active-world-rewards-token",
    symbol: "awrt",
    name: "Active World Rewards",
  },
  {
    id: "acuity-token",
    symbol: "acu",
    name: "Acuity",
  },
  {
    id: "acumen",
    symbol: "acm",
    name: "Acumen",
  },
  {
    id: "acu-platform",
    symbol: "acu",
    name: "ACU Platform",
  },
  {
    id: "acute-angle-cloud",
    symbol: "aac",
    name: "Double-A Chain",
  },
  {
    id: "acy-finance",
    symbol: "acy",
    name: "ACY Finance",
  },
  {
    id: "adaboy",
    symbol: "adaboy",
    name: "ADABoy",
  },
  {
    id: "adacash",
    symbol: "adacash",
    name: "ADAcash",
  },
  {
    id: "adadao",
    symbol: "adao",
    name: "ADADao",
  },
  {
    id: "adadex-tools",
    symbol: "adat",
    name: "Adadex Tools",
  },
  {
    id: "adaflect",
    symbol: "adaflect",
    name: "ADAFlect",
  },
  {
    id: "adakong",
    symbol: "akong",
    name: "AdaKong",
  },
  {
    id: "adalend",
    symbol: "adal",
    name: "Adalend",
  },
  {
    id: "adamant",
    symbol: "addy",
    name: "Adamant",
  },
  {
    id: "adamant-coin",
    symbol: "admc",
    name: "Adamant Coin",
  },
  {
    id: "adamant-messenger",
    symbol: "adm",
    name: "ADAMANT Messenger",
  },
  {
    id: "adam-oracle",
    symbol: "adam",
    name: "ADAM Oracle",
  },
  {
    id: "adana-demirspor",
    symbol: "demir",
    name: "Adana Demirspor",
  },
  {
    id: "adapad",
    symbol: "adapad",
    name: "ADAPad",
  },
  {
    id: "adappter-token",
    symbol: "adp",
    name: "Adappter",
  },
  {
    id: "adaswap",
    symbol: "asw",
    name: "AdaSwap",
  },
  {
    id: "adax",
    symbol: "adax",
    name: "ADAX",
  },
  {
    id: "adbank",
    symbol: "adb",
    name: "adbank",
  },
  {
    id: "add-xyz-new",
    symbol: "add",
    name: "Add.xyz (NEW)",
  },
  {
    id: "adelphoi",
    symbol: "adl",
    name: "Adelphoi",
  },
  {
    id: "adene",
    symbol: "aden",
    name: "Adene",
  },
  {
    id: "adex",
    symbol: "adx",
    name: "Ambire AdEx",
  },
  {
    id: "ad-flex-token",
    symbol: "adf",
    name: "Ad Flex",
  },
  {
    id: "aditus",
    symbol: "adi",
    name: "Aditus",
  },
  {
    id: "admonkey",
    symbol: "admonkey",
    name: "AdMonkey",
  },
  {
    id: "adora-token",
    symbol: "ara",
    name: "Adora",
  },
  {
    id: "adroverse",
    symbol: "adr",
    name: "Adroverse",
  },
  {
    id: "adshares",
    symbol: "ads",
    name: "Adshares",
  },
  {
    id: "adtoken",
    symbol: "adt",
    name: "adChain",
  },
  {
    id: "advanced-internet-block",
    symbol: "aib",
    name: "Advanced Integrated Blocks",
  },
  {
    id: "advanced-united-continent",
    symbol: "auc",
    name: "Advanced United Continent",
  },
  {
    id: "advar-protocol",
    symbol: "advar",
    name: "Advar Protocol",
  },
  {
    id: "adventure-gold",
    symbol: "agld",
    name: "Adventure Gold",
  },
  {
    id: "adventure-inu",
    symbol: "adinu",
    name: "Adventure Inu",
  },
  {
    id: "adventure-token",
    symbol: "twa",
    name: "Adventure",
  },
  {
    id: "advertise-coin",
    symbol: "adco",
    name: "Advertise Coin",
  },
  {
    id: "aegis",
    symbol: "ags",
    name: "Aegis",
  },
  {
    id: "aegis-launchpad",
    symbol: "agspad",
    name: "Aegis Launchpad",
  },
  {
    id: "aelf",
    symbol: "elf",
    name: "aelf",
  },
  {
    id: "aelin",
    symbol: "aelin",
    name: "Aelin",
  },
  {
    id: "aelysir",
    symbol: "ael",
    name: "Aelysir",
  },
  {
    id: "aeneas",
    symbol: "ash",
    name: "Aeneas",
  },
  {
    id: "aen-smart-token",
    symbol: "aens",
    name: "AEN Smart",
  },
  {
    id: "aeon",
    symbol: "aeon",
    name: "Aeon",
  },
  {
    id: "aerarium-fi",
    symbol: "aera",
    name: "Aerarium Fi",
  },
  {
    id: "aerdrop",
    symbol: "aer",
    name: "Aerdrop",
  },
  {
    id: "aergo",
    symbol: "aergo",
    name: "Aergo",
  },
  {
    id: "aerochain",
    symbol: "aero-v2",
    name: "Aerochain Coin V2",
  },
  {
    id: "aeron",
    symbol: "arnx",
    name: "Aeron",
  },
  {
    id: "aerotoken",
    symbol: "aet",
    name: "AEROTOKEN",
  },
  {
    id: "aerotyne",
    symbol: "atyne",
    name: "Aerotyne",
  },
  {
    id: "aerovek-aviation",
    symbol: "aero",
    name: "Aerovek Aviation",
  },
  {
    id: "aeternity",
    symbol: "ae",
    name: "Aeternity",
  },
  {
    id: "aetherius",
    symbol: "aeth",
    name: "Aetherius",
  },
  {
    id: "aetherv2",
    symbol: "ath",
    name: "AetherV2",
  },
  {
    id: "aeur",
    symbol: "aeur",
    name: "AEUR",
  },
  {
    id: "aevo",
    symbol: "aevo",
    name: "Always Evolving",
  },
  {
    id: "aevolve-token",
    symbol: "avex!",
    name: "Aevolve",
  },
  {
    id: "aezora",
    symbol: "azr",
    name: "Azzure",
  },
  {
    id: "afen-blockchain",
    symbol: "afen",
    name: "AFEN Blockchain",
  },
  {
    id: "affyn",
    symbol: "fyn",
    name: "Affyn",
  },
  {
    id: "afin-coin",
    symbol: "afin",
    name: "Asian Fintech",
  },
  {
    id: "afkdao",
    symbol: "afk",
    name: "AFKDAO",
  },
  {
    id: "afreum",
    symbol: "afr",
    name: "Afreum",
  },
  {
    id: "afrix",
    symbol: "afx",
    name: "Afrix",
  },
  {
    id: "afro",
    symbol: "afro",
    name: "Afro",
  },
  {
    id: "afrodex",
    symbol: "afrox",
    name: "AfroDex",
  },
  {
    id: "afrostar",
    symbol: "afro",
    name: "Afrostar",
  },
  {
    id: "aga-carbon-credit",
    symbol: "agac",
    name: "AGA Carbon Credit",
  },
  {
    id: "aga-carbon-rewards",
    symbol: "acar",
    name: "AGA Carbon Rewards",
  },
  {
    id: "again-project",
    symbol: "again",
    name: "Again Project",
  },
  {
    id: "aga-rewards",
    symbol: "edc",
    name: "Edcoin",
  },
  {
    id: "aga-rewards-2",
    symbol: "agar",
    name: "AGA Rewards",
  },
  {
    id: "aga-token",
    symbol: "aga",
    name: "AGA",
  },
  {
    id: "agavecoin",
    symbol: "agvc",
    name: "AgaveCoin",
  },
  {
    id: "agave-token",
    symbol: "agve",
    name: "Agave",
  },
  {
    id: "agenor",
    symbol: "age",
    name: "Agenor",
  },
  {
    id: "agent-shiba-inu",
    symbol: "agentshibainu",
    name: "Agent Shiba I.N.U.",
  },
  {
    id: "ageofgods",
    symbol: "aog",
    name: "AgeOfGods",
  },
  {
    id: "age-of-knights",
    symbol: "gem",
    name: "Age Of Knights",
  },
  {
    id: "age-of-tanks",
    symbol: "a.o.t",
    name: "Age Of Tanks",
  },
  {
    id: "ageur",
    symbol: "ageur",
    name: "agEUR",
  },
  {
    id: "ageur-wormhole",
    symbol: "ageur",
    name: "agEUR (Wormhole)",
  },
  {
    id: "aggle-io",
    symbol: "aggl",
    name: "aggle.io",
  },
  {
    id: "aggregatedfinance",
    symbol: "agfi",
    name: "AggregatedFinance [OLD]",
  },
  {
    id: "aggregatedfinance-2",
    symbol: "agfi",
    name: "AggregatedFinance",
  },
  {
    id: "agile",
    symbol: "agl",
    name: "Agile",
  },
  {
    id: "agora-defi",
    symbol: "agora",
    name: "Agora Defi",
  },
  {
    id: "agoras-currency-of-tau",
    symbol: "agrs",
    name: "Agoras: Currency of Tau",
  },
  {
    id: "agora-token",
    symbol: "ago",
    name: "Agora AGO",
  },
  {
    id: "agoric",
    symbol: "bld",
    name: "Agoric",
  },
  {
    id: "agouti",
    symbol: "agu",
    name: "Agouti",
  },
  {
    id: "agpc",
    symbol: "agpc",
    name: "AGPC",
  },
  {
    id: "agrello",
    symbol: "dlt",
    name: "Agrello",
  },
  {
    id: "agricoin",
    symbol: "agn",
    name: "Agricoin",
  },
  {
    id: "agrinoble",
    symbol: "agn",
    name: "Agrinoble",
  },
  {
    id: "agrinovuscoin",
    symbol: "agri",
    name: "AgriNovusCoin",
  },
  {
    id: "agrocash-x",
    symbol: "xagc",
    name: "AgroCash X",
  },
  {
    id: "agrofarm",
    symbol: "farm",
    name: "Agrofarm",
  },
  {
    id: "agro-global",
    symbol: "agro",
    name: "Agro Global",
  },
  {
    id: "agro-matic",
    symbol: "amt",
    name: "Agro-Matic",
  },
  {
    id: "agronomist",
    symbol: "agte",
    name: "Agronomist",
  },
  {
    id: "ahatoken",
    symbol: "aht",
    name: "Aha",
  },
  {
    id: "a-hunters-dream",
    symbol: "caw",
    name: "A Hunters Dream",
  },
  {
    id: "aichain",
    symbol: "ait",
    name: "AICHAIN",
  },
  {
    id: "aicon",
    symbol: "aico",
    name: "Aicon",
  },
  {
    id: "aidcoin",
    symbol: "aid",
    name: "AidCoin",
  },
  {
    id: "aidi-finance",
    symbol: "aidi",
    name: "Aidi Finance",
  },
  {
    id: "aidi-inu",
    symbol: "aidi",
    name: "Aidi Inu",
  },
  {
    id: "ai-doctor",
    symbol: "aidoc",
    name: "AI Doctor",
  },
  {
    id: "aidos-kuneen",
    symbol: "adk",
    name: "Aidos Kuneen",
  },
  {
    id: "ailink-token",
    symbol: "ali",
    name: "AiLink",
  },
  {
    id: "aimedis-2",
    symbol: "aimx",
    name: "Aimedis",
  },
  {
    id: "ai-network",
    symbol: "ain",
    name: "AI Network",
  },
  {
    id: "ainu-token",
    symbol: "ainu",
    name: "Ainu",
  },
  {
    id: "aion",
    symbol: "aion",
    name: "Aion",
  },
  {
    id: "aioz-network",
    symbol: "aioz",
    name: "AIOZ Network",
  },
  {
    id: "airbloc-protocol",
    symbol: "abl",
    name: "Airbloc",
  },
  {
    id: "airbnb-tokenized-stock-zipmex",
    symbol: "abnb",
    name: "Airbnb Tokenized Stock Zipmex",
  },
  {
    id: "aircoin-2",
    symbol: "air",
    name: "AirCoin",
  },
  {
    id: "aircoins",
    symbol: "airx",
    name: "Aircoins",
  },
  {
    id: "airdropper",
    symbol: "air",
    name: "AirDropper",
  },
  {
    id: "airdrop-world",
    symbol: "awt",
    name: "Airdrop World",
  },
  {
    id: "airight",
    symbol: "airi",
    name: "aiRight",
  },
  {
    id: "airnft-token",
    symbol: "airt",
    name: "AirNFT",
  },
  {
    id: "airpay",
    symbol: "airpay",
    name: "AirPay",
  },
  {
    id: "airraid-lottery-token",
    symbol: "araid",
    name: "AirRaid Lottery",
  },
  {
    id: "air-shiba",
    symbol: "airshib",
    name: "Air Shiba",
  },
  {
    id: "airswap",
    symbol: "ast",
    name: "AirSwap",
  },
  {
    id: "aisf",
    symbol: "agt",
    name: "AISF",
  },
  {
    id: "aitra",
    symbol: "aitra",
    name: "AITRA",
  },
  {
    id: "aiwork",
    symbol: "awo",
    name: "AiWork",
  },
  {
    id: "ajeverse",
    symbol: "aje",
    name: "Ajeverse",
  },
  {
    id: "akamaru-inu",
    symbol: "akamaru",
    name: "Akamaru Inu",
  },
  {
    id: "akash-network",
    symbol: "akt",
    name: "Akash Network",
  },
  {
    id: "akihiko-inu",
    symbol: "akihiko",
    name: "Akihiko Inu",
  },
  {
    id: "akil-coin",
    symbol: "akl",
    name: "Akil Coin",
  },
  {
    id: "akita-inu",
    symbol: "akita",
    name: "Akita Inu",
  },
  {
    id: "akitavax",
    symbol: "akitax",
    name: "Akitavax",
  },
  {
    id: "akoin",
    symbol: "akn",
    name: "Akoin",
  },
  {
    id: "akroma",
    symbol: "aka",
    name: "Akroma",
  },
  {
    id: "akropolis",
    symbol: "akro",
    name: "Akropolis",
  },
  {
    id: "akropolis-delphi",
    symbol: "adel",
    name: "Delphi",
  },
  {
    id: "akro-wormhole",
    symbol: "akro",
    name: "Akropolis (Wormhole)",
  },
  {
    id: "aktio",
    symbol: "aktio",
    name: "Aktio",
  },
  {
    id: "aladdin-cvxcrv",
    symbol: "acrv",
    name: "Aladdin cvxCRV",
  },
  {
    id: "aladdin-dao",
    symbol: "ald",
    name: "Aladdin DAO",
  },
  {
    id: "aladiex",
    symbol: "ala",
    name: "Aladiex",
  },
  {
    id: "alanyaspor-fan-token",
    symbol: "ala",
    name: "Alanyaspor Fan Token",
  },
  {
    id: "alaya",
    symbol: "atp",
    name: "Alaya",
  },
  {
    id: "alchemist",
    symbol: "mist",
    name: "Alchemist",
  },
  {
    id: "alchemix",
    symbol: "alcx",
    name: "Alchemix",
  },
  {
    id: "alchemix-usd",
    symbol: "alusd",
    name: "Alchemix USD",
  },
  {
    id: "alchemy-dao",
    symbol: "alch",
    name: "AlchemyDAO",
  },
  {
    id: "alchemy-pay",
    symbol: "ach",
    name: "Alchemy Pay",
  },
  {
    id: "aldrin",
    symbol: "rin",
    name: "Aldrin",
  },
  {
    id: "aleph",
    symbol: "aleph",
    name: "Aleph.im",
  },
  {
    id: "aleph-finance",
    symbol: "naleph",
    name: "Aleph Finance",
  },
  {
    id: "aleph-im-wormhole",
    symbol: "aleph",
    name: "Aleph.im (Wormhole)",
  },
  {
    id: "alephium",
    symbol: "alph",
    name: "Alephium",
  },
  {
    id: "aleph-zero",
    symbol: "azero",
    name: "Aleph Zero",
  },
  {
    id: "alethea-artificial-liquid-intelligence-token",
    symbol: "ali",
    name: "Alethea Artificial Liquid Intelligence",
  },
  {
    id: "alex",
    symbol: "alex",
    name: "Alex",
  },
  {
    id: "alexgo",
    symbol: "alex",
    name: "Alexgo",
  },
  {
    id: "alfa-romeo-racing-orlen-fan-token",
    symbol: "sauber",
    name: "Alfa Romeo Racing ORLEN Fan Token",
  },
  {
    id: "alfheim-finance",
    symbol: "afm",
    name: "Alfheim Finance",
  },
  {
    id: "algebra",
    symbol: "algb",
    name: "Algebra",
  },
  {
    id: "algoblocks",
    symbol: "algoblk",
    name: "AlgoBlocks",
  },
  {
    id: "algodao",
    symbol: "adao",
    name: "AlgoDAO",
  },
  {
    id: "algodex",
    symbol: "algx",
    name: "Algodex",
  },
  {
    id: "algogems",
    symbol: "gems",
    name: "AlgoGems",
  },
  {
    id: "algomint",
    symbol: "gomint",
    name: "Algomint",
  },
  {
    id: "algopad",
    symbol: "algopad",
    name: "AlgoPad",
  },
  {
    id: "algopainter",
    symbol: "algop",
    name: "AlgoPainter",
  },
  {
    id: "algoracle",
    symbol: "gora",
    name: "Goracle",
  },
  {
    id: "algorand",
    symbol: "algo",
    name: "Algorand",
  },
  {
    id: "algory",
    symbol: "alg",
    name: "Algory",
  },
  {
    id: "algovest",
    symbol: "avs",
    name: "AlgoVest",
  },
  {
    id: "alibabacoin",
    symbol: "abbc",
    name: "ABBC",
  },
  {
    id: "alibaba-tokenized-stock-defichain",
    symbol: "dbaba",
    name: "Alibaba Tokenized Stock Defichain",
  },
  {
    id: "alibaba-tokenized-stock-zipmex",
    symbol: "baba",
    name: "Alibaba Tokenized Stock Zipmex",
  },
  {
    id: "alicoin",
    symbol: "alicn",
    name: "Alicoin",
  },
  {
    id: "alien-chicken-farm",
    symbol: "acf",
    name: "Alien Chicken Farm",
  },
  {
    id: "alien-inu",
    symbol: "alien",
    name: "Alien Inu",
  },
  {
    id: "alien-shiba-inu",
    symbol: "ashib",
    name: "Alien Shiba Inu",
  },
  {
    id: "alien-wars-gold",
    symbol: "awg",
    name: "Alien Wars Gold",
  },
  {
    id: "alien-worlds",
    symbol: "tlm",
    name: "Alien Worlds",
  },
  {
    id: "alightpay",
    symbol: "alpy",
    name: "Alightpay",
  },
  {
    id: "alinx",
    symbol: "alix",
    name: "AlinX",
  },
  {
    id: "alis",
    symbol: "alis",
    name: "ALIS",
  },
  {
    id: "a-list-royale",
    symbol: "alist",
    name: "A-List Royale",
  },
  {
    id: "alita",
    symbol: "ali",
    name: "Alita",
  },
  {
    id: "alita-network",
    symbol: "alita",
    name: "Alita Network",
  },
  {
    id: "alitas",
    symbol: "alt",
    name: "Alitas",
  },
  {
    id: "alium-finance",
    symbol: "alm",
    name: "Alium Finance",
  },
  {
    id: "alkemi-network-dao-token",
    symbol: "alk",
    name: "Alkemi Network DAO",
  },
  {
    id: "alkimi",
    symbol: "$ads",
    name: "Alkimi",
  },
  {
    id: "all-art",
    symbol: "aart",
    name: "ALL.ART",
  },
  {
    id: "all-best-ico",
    symbol: "allbi",
    name: "ALL BEST ICO",
  },
  {
    id: "allbridge",
    symbol: "abr",
    name: "Allbridge",
  },
  {
    id: "all-coins-yield-capital",
    symbol: "acyc",
    name: "All Coins Yield Capital",
  },
  {
    id: "alldex-alliance",
    symbol: "axa",
    name: "Alldex Alliance",
  },
  {
    id: "allianceblock",
    symbol: "albt",
    name: "AllianceBlock",
  },
  {
    id: "alliance-cargo-direct",
    symbol: "acd",
    name: "Alliance Cargo Direct",
  },
  {
    id: "alliance-fan-token",
    symbol: "all",
    name: "Alliance Fan Token",
  },
  {
    id: "alliance-token",
    symbol: "alto",
    name: "Alliance",
  },
  {
    id: "alliance-x-trading",
    symbol: "axt",
    name: "Alliance X Trading",
  },
  {
    id: "allium-finance",
    symbol: "alm",
    name: "Allium Finance",
  },
  {
    id: "allive",
    symbol: "alv",
    name: "Allive",
  },
  {
    id: "all-me",
    symbol: "me",
    name: "All.me",
  },
  {
    id: "alloy-project",
    symbol: "xao",
    name: "Alloy Project",
  },
  {
    id: "allsafe",
    symbol: "asafe",
    name: "AllSafe",
  },
  {
    id: "all-sports",
    symbol: "soc",
    name: "All Sports [OLD]",
  },
  {
    id: "all-sports-2",
    symbol: "soc",
    name: "All Sports",
  },
  {
    id: "allspot",
    symbol: "alt",
    name: "Allspot",
  },
  {
    id: "alluo",
    symbol: "alluo",
    name: "Alluo",
  },
  {
    id: "ally",
    symbol: "aly",
    name: "Ally",
  },
  {
    id: "ally-direct",
    symbol: "drct",
    name: "Ally Direct",
  },
  {
    id: "almond",
    symbol: "alm",
    name: "Almond",
  },
  {
    id: "alnair-finance",
    symbol: "alnr",
    name: "Alnair Finance",
  },
  {
    id: "alnair-finance-nika",
    symbol: "nika",
    name: "Alnair Finance NIKA",
  },
  {
    id: "alnair-finance-xalnr",
    symbol: "xalnr",
    name: "Alnair Finance xALNR",
  },
  {
    id: "alnassr-fc-fan-token",
    symbol: "nassr",
    name: "Alnassr FC Fan Token",
  },
  {
    id: "aloha",
    symbol: "aloha",
    name: "Aloha",
  },
  {
    id: "alpaca",
    symbol: "alpa",
    name: "Alpaca City",
  },
  {
    id: "alpaca-finance",
    symbol: "alpaca",
    name: "Alpaca Finance",
  },
  {
    id: "alpaca-usd",
    symbol: "ausd",
    name: "Alpaca USD",
  },
  {
    id: "alpha5",
    symbol: "a5t",
    name: "Alpha5",
  },
  {
    id: "alpha-brain-capital",
    symbol: "abc",
    name: "Alpha Brain Capital [OLD]",
  },
  {
    id: "alpha-brain-capital-2",
    symbol: "acap",
    name: "Alpha Capital",
  },
  {
    id: "alphacat",
    symbol: "acat",
    name: "Alphacat",
  },
  {
    id: "alphacoin",
    symbol: "alpha",
    name: "AlphaCoin",
  },
  {
    id: "alpha-coin",
    symbol: "apc",
    name: "Alpha Coin",
  },
  {
    id: "alphadex",
    symbol: "dex",
    name: "AlphaDex",
  },
  {
    id: "alpha-dex",
    symbol: "roar",
    name: "Alpha DEX",
  },
  {
    id: "alpha-finance",
    symbol: "alpha",
    name: "Alpha Venture DAO",
  },
  {
    id: "alpha-kombat",
    symbol: "alkom",
    name: "Alpha Kombat",
  },
  {
    id: "alphalink",
    symbol: "ank",
    name: "AlphaLink",
  },
  {
    id: "alpha-nodes",
    symbol: "$alpha",
    name: "Alpha Shares",
  },
  {
    id: "alpha-pad",
    symbol: "apad",
    name: "Alpha Pad",
  },
  {
    id: "alpha-platform",
    symbol: "a",
    name: "Alpha A",
  },
  {
    id: "alpha-quark-token",
    symbol: "aqt",
    name: "Alpha Quark",
  },
  {
    id: "alphatoken",
    symbol: ".alpha",
    name: ".Alpha",
  },
  {
    id: "alphr",
    symbol: "alphr",
    name: "Alphr",
  },
  {
    id: "alpine-f1-team-fan-token",
    symbol: "alpine",
    name: "Alpine F1 Team Fan Token",
  },
  {
    id: "alta-finance",
    symbol: "alta",
    name: "Alta Finance",
  },
  {
    id: "altair",
    symbol: "air",
    name: "Altair",
  },
  {
    id: "altbase",
    symbol: "altb",
    name: "Altbase",
  },
  {
    id: "alt-coin",
    symbol: "alt",
    name: "Alt Coin",
  },
  {
    id: "altcommunity-coin",
    symbol: "altom",
    name: "ALTOM",
  },
  {
    id: "alter",
    symbol: "alter",
    name: "Alter",
  },
  {
    id: "altera",
    symbol: "aen",
    name: "Altera",
  },
  {
    id: "altered-state-token",
    symbol: "asto",
    name: "Altered State Machine",
  },
  {
    id: "alternatemoney",
    symbol: "am",
    name: "AlternateMoney",
  },
  {
    id: "alt-estate",
    symbol: "alt",
    name: "AltEstate",
  },
  {
    id: "altmarkets-coin",
    symbol: "altm",
    name: "Altmarkets Coin",
  },
  {
    id: "altrucoin-2",
    symbol: "altrucoin",
    name: "Altrucoin",
  },
  {
    id: "altswitch",
    symbol: "alts",
    name: "AltSwitch",
  },
  {
    id: "altura",
    symbol: "alu",
    name: "Altura",
  },
  {
    id: "aluna",
    symbol: "aln",
    name: "Aluna",
  },
  {
    id: "alyattes",
    symbol: "alya",
    name: "Alyattes",
  },
  {
    id: "amara-finance",
    symbol: "mara",
    name: "Amara Finance",
  },
  {
    id: "amasa",
    symbol: "amas",
    name: "Amasa",
  },
  {
    id: "amaten",
    symbol: "ama",
    name: "Amaten",
  },
  {
    id: "amateras",
    symbol: "amt",
    name: "Amateras",
  },
  {
    id: "amaterasufi-izanagi",
    symbol: "iza",
    name: "AmaterasuFi Izanagi",
  },
  {
    id: "amazingdoge",
    symbol: "adoge",
    name: "AmazingDoge",
  },
  {
    id: "amazingteamdao",
    symbol: "amazingteam",
    name: "AmazingTeamDAO",
  },
  {
    id: "amazonacoin",
    symbol: "amz",
    name: "AmazonasCoin",
  },
  {
    id: "amazon-tokenized-stock-defichain",
    symbol: "damzn",
    name: "Amazon Tokenized Stock Defichain",
  },
  {
    id: "amazon-tokenized-stock-zipmex",
    symbol: "amzn",
    name: "Amazon Tokenized Stock Zipmex",
  },
  {
    id: "amber",
    symbol: "amb",
    name: "Ambrosus",
  },
  {
    id: "ambire-wallet",
    symbol: "wallet",
    name: "Ambire Wallet",
  },
  {
    id: "amc-fight-night",
    symbol: "amc",
    name: "AMC Fight Night",
  },
  {
    id: "amdg-token",
    symbol: "amdg",
    name: "AMDG",
  },
  {
    id: "amepay",
    symbol: "ame",
    name: "AME Chain",
  },
  {
    id: "american-shiba",
    symbol: "ushiba",
    name: "American Shiba",
  },
  {
    id: "americanstaff-inu",
    symbol: "amstaff",
    name: "AmericanStaff Inu",
  },
  {
    id: "amerikan-pitbull-terrier",
    symbol: "terrier",
    name: "Amerikan Pitbull Terrier",
  },
  {
    id: "ameru-dao",
    symbol: "adao",
    name: "Ameru DAO",
  },
  {
    id: "amethyst",
    symbol: "ames",
    name: "Amethyst",
  },
  {
    id: "amgen",
    symbol: "amg",
    name: "Amgen",
  },
  {
    id: "amis",
    symbol: "amis",
    name: "AMIS",
  },
  {
    id: "ammyi-coin",
    symbol: "ami",
    name: "AMMYI Coin",
  },
  {
    id: "amnext",
    symbol: "amc",
    name: "Amnext",
  },
  {
    id: "amo",
    symbol: "amo",
    name: "AMO Coin",
  },
  {
    id: "amon",
    symbol: "amn",
    name: "Amon",
  },
  {
    id: "amond",
    symbol: "amon",
    name: "AmonD",
  },
  {
    id: "amoveo",
    symbol: "veo",
    name: "Amoveo",
  },
  {
    id: "ampleforth",
    symbol: "ampl",
    name: "Ampleforth",
  },
  {
    id: "ampleforth-governance-token",
    symbol: "forth",
    name: "Ampleforth Governance",
  },
  {
    id: "ampleforth-wormhole",
    symbol: "ampl",
    name: "Ampleforth (Wormhole)",
  },
  {
    id: "ampleswap",
    symbol: "ample",
    name: "AmpleSwap",
  },
  {
    id: "amplify",
    symbol: "ampt",
    name: "Amplify",
  },
  {
    id: "ampnet",
    symbol: "aapx",
    name: "AMPnet",
  },
  {
    id: "amp-token",
    symbol: "amp",
    name: "Amp",
  },
  {
    id: "amp-wormhole",
    symbol: "amp",
    name: "Amp (Wormhole)",
  },
  {
    id: "amun-defi-index",
    symbol: "dfi",
    name: "Amun DeFi Index",
  },
  {
    id: "amy-finance",
    symbol: "amy",
    name: "Amy Finance",
  },
  {
    id: "amz-coin",
    symbol: "amz",
    name: "AMZ Coin",
  },
  {
    id: "a-nation",
    symbol: "anation",
    name: "A-Nation",
  },
  {
    id: "anchor",
    symbol: "anct",
    name: "Anchor",
  },
  {
    id: "anchor-beth-token",
    symbol: "beth",
    name: "Anchor bETH Token",
  },
  {
    id: "anchor-neural-world-token",
    symbol: "anw",
    name: "Anchor Neural World",
  },
  {
    id: "anchor-protocol",
    symbol: "anc",
    name: "Anchor Protocol",
  },
  {
    id: "anchorswap",
    symbol: "anchor",
    name: "AnchorSwap",
  },
  {
    id: "anchorust",
    symbol: "aust",
    name: "AnchorUST",
  },
  {
    id: "ancient-kingdom",
    symbol: "dom",
    name: "Ancient Kingdom",
  },
  {
    id: "ancient-warrior",
    symbol: "ancw",
    name: "Ancient Warrior",
  },
  {
    id: "andromeda",
    symbol: "m31",
    name: "Andromeda",
  },
  {
    id: "andronodes",
    symbol: "andro",
    name: "AndroNodes",
  },
  {
    id: "anduschain",
    symbol: "deb",
    name: "Anduschain",
  },
  {
    id: "angelheart-token",
    symbol: "aht",
    name: "AngelHeart",
  },
  {
    id: "angel-inu",
    symbol: "angel",
    name: "Angel Inu",
  },
  {
    id: "angel-nodes",
    symbol: "angel",
    name: "Angel Nodes",
  },
  {
    id: "angel-protocol",
    symbol: "halo",
    name: "Angel Protocol",
  },
  {
    id: "angelscreed",
    symbol: "angel",
    name: "AngelsCreed",
  },
  {
    id: "angle-protocol",
    symbol: "angle",
    name: "ANGLE",
  },
  {
    id: "angryb",
    symbol: "anb",
    name: "Angryb",
  },
  {
    id: "angryfloki",
    symbol: "$afloki",
    name: "AngryFloki",
  },
  {
    id: "angular-finance",
    symbol: "angl",
    name: "Angular Finance",
  },
  {
    id: "animal-concerts-token",
    symbol: "anml",
    name: "Animal Concerts",
  },
  {
    id: "animalia",
    symbol: "anim",
    name: "Animalia",
  },
  {
    id: "animal-tycoon",
    symbol: "amt",
    name: "Animal Tycoon",
  },
  {
    id: "animecoin",
    symbol: "ani",
    name: "Animecoin",
  },
  {
    id: "anime-token",
    symbol: "ani",
    name: "Anime",
  },
  {
    id: "anime-vault-nftx",
    symbol: "anime",
    name: "ANIME Vault (NFTX)",
  },
  {
    id: "animverse",
    symbol: "anm",
    name: "Animverse",
  },
  {
    id: "anito-legends",
    symbol: "laro",
    name: "Anito Legends",
  },
  {
    id: "aniverse",
    symbol: "anv",
    name: "Aniverse",
  },
  {
    id: "anj",
    symbol: "anj",
    name: "Aragon Court",
  },
  {
    id: "anji",
    symbol: "anji",
    name: "Anji",
  },
  {
    id: "ankaragucu-fan-token",
    symbol: "anka",
    name: "Ankaragücü Fan Tokens",
  },
  {
    id: "ankr",
    symbol: "ankr",
    name: "Ankr",
  },
  {
    id: "ankr-avalanche-reward-earning-bond",
    symbol: "aavaxb",
    name: "Ankr Avalanche Reward Earning Bond",
  },
  {
    id: "ankreth",
    symbol: "aethc",
    name: "Ankr Reward-Bearing Staked ETH",
  },
  {
    id: "ankr-network-wormhole",
    symbol: "ankr",
    name: "Ankr Network (Wormhole)",
  },
  {
    id: "ankr-reward-bearing-stake",
    symbol: "abnbc",
    name: "Ankr Reward Bearing Stake BNB",
  },
  {
    id: "ankr-reward-earning-matic",
    symbol: "amaticc",
    name: "Ankr Reward Earning MATIC",
  },
  {
    id: "annex",
    symbol: "ann",
    name: "Annex Finance",
  },
  {
    id: "anomus-coin",
    symbol: "anom",
    name: "Anomus Coin",
  },
  {
    id: "anon",
    symbol: "anon",
    name: "ANON",
  },
  {
    id: "anonfloki",
    symbol: "anonfloki",
    name: "AnonFloki",
  },
  {
    id: "anon-inu",
    symbol: "ainu",
    name: "Anon Inu",
  },
  {
    id: "anonpay",
    symbol: "apay",
    name: "AnonPay",
  },
  {
    id: "anons-network",
    symbol: "anons",
    name: "Anons Network",
  },
  {
    id: "anonverse",
    symbol: "anon",
    name: "Anonverse",
  },
  {
    id: "anonydoxx",
    symbol: "adxx",
    name: "AnonyDoxx",
  },
  {
    id: "anonymous-bsc",
    symbol: "anon",
    name: "Anonymous BSC",
  },
  {
    id: "anortis",
    symbol: "anortis",
    name: "Anortis",
  },
  {
    id: "anpanswap-token",
    symbol: "anpan",
    name: "AnpanSwap",
  },
  {
    id: "anrkey-x",
    symbol: "$anrx",
    name: "AnRKey X",
  },
  {
    id: "ans-crypto-coin",
    symbol: "ans",
    name: "ANS Crypto Coin",
  },
  {
    id: "answerly",
    symbol: "ansr",
    name: "Answerly",
  },
  {
    id: "antalyaspor",
    symbol: "akrep",
    name: "Antalyaspor",
  },
  {
    id: "antedao",
    symbol: "ante",
    name: "AnteDAO",
  },
  {
    id: "antex",
    symbol: "antex",
    name: "Antex",
  },
  {
    id: "antgold",
    symbol: "antg",
    name: "AntGold",
  },
  {
    id: "antiample",
    symbol: "xamp",
    name: "Antiample",
  },
  {
    id: "antimatter",
    symbol: "matter",
    name: "AntiMatter",
  },
  {
    id: "antimony",
    symbol: "atmn",
    name: "Antimony",
  },
  {
    id: "antis-inu",
    symbol: "antis",
    name: "Antis Inu",
  },
  {
    id: "antra",
    symbol: "antr",
    name: "Antra",
  },
  {
    id: "any-blocknet",
    symbol: "ablock",
    name: "ANY Blocknet",
  },
  {
    id: "anypad",
    symbol: "apad",
    name: "Anypad",
  },
  {
    id: "anyprinter",
    symbol: "anyp",
    name: "AnyPrinter",
  },
  {
    id: "anysniper",
    symbol: "snipe",
    name: "AnySniper",
  },
  {
    id: "anyswap",
    symbol: "any",
    name: "Anyswap",
  },
  {
    id: "aok",
    symbol: "aok",
    name: "AOK",
  },
  {
    id: "aonea-coin",
    symbol: "a1a",
    name: "Aonea Coin",
  },
  {
    id: "aos",
    symbol: "aos",
    name: "AOS",
  },
  {
    id: "ape",
    symbol: "ape",
    name: "APE",
  },
  {
    id: "apeboys",
    symbol: "apeboys",
    name: "ApeBoys",
  },
  {
    id: "apebusd",
    symbol: "apebusd",
    name: "ApeBUSD",
  },
  {
    id: "apecoin",
    symbol: "ape",
    name: "ApeCoin",
  },
  {
    id: "apecoin-token",
    symbol: "ape",
    name: "APEcoin Token",
  },
  {
    id: "ape-finance",
    symbol: "apefi",
    name: "Ape Finance",
  },
  {
    id: "apefund",
    symbol: "apefund",
    name: "ApeFund",
  },
  {
    id: "ape-fun-token",
    symbol: "aft",
    name: "Ape Fun",
  },
  {
    id: "ape-in",
    symbol: "apein",
    name: "Ape In",
  },
  {
    id: "ape_in_records",
    symbol: "air",
    name: "Ape In Records",
  },
  {
    id: "apejet",
    symbol: "jet",
    name: "ApeJet",
  },
  {
    id: "apelab",
    symbol: "ape",
    name: "ApeLab",
  },
  {
    id: "apenft",
    symbol: "nft",
    name: "APENFT",
  },
  {
    id: "ape-punk",
    symbol: "ape$",
    name: "APE Punk",
  },
  {
    id: "apes-token",
    symbol: "apes",
    name: "Apes",
  },
  {
    id: "apeswap-finance",
    symbol: "banana",
    name: "ApeSwap",
  },
  {
    id: "apetoken",
    symbol: "apet",
    name: "APEToken",
  },
  {
    id: "ape-universe",
    symbol: "apeu",
    name: "Ape Universe",
  },
  {
    id: "apeusd",
    symbol: "apeusd",
    name: "ApeUSD",
  },
  {
    id: "ape-x",
    symbol: "ape-x",
    name: "Ape-X",
  },
  {
    id: "apex-army",
    symbol: "apex",
    name: "APEx Army",
  },
  {
    id: "apex-foundation",
    symbol: "apex",
    name: "Apex Foundation",
  },
  {
    id: "apexit-finance",
    symbol: "apex",
    name: "ApeXit Finance",
  },
  {
    id: "apex-predator",
    symbol: "apex",
    name: "Apex Predator",
  },
  {
    id: "apex-protocol",
    symbol: "apxp",
    name: "APEX Protocol",
  },
  {
    id: "apex-token-2",
    symbol: "apex",
    name: "ApeX",
  },
  {
    id: "api3",
    symbol: "api3",
    name: "API3",
  },
  {
    id: "apidai-network",
    symbol: "apidai",
    name: "Apidai Network",
  },
  {
    id: "apish-me",
    symbol: "apish",
    name: "Apish Me",
  },
  {
    id: "apix",
    symbol: "apix",
    name: "APIX",
  },
  {
    id: "apm-coin",
    symbol: "apm",
    name: "apM Coin",
  },
  {
    id: "apocalypse",
    symbol: "apoc",
    name: "Apocalypse",
  },
  {
    id: "apollo",
    symbol: "apl",
    name: "Apollo",
  },
  {
    id: "apollo-coin",
    symbol: "apx",
    name: "Apollo Coin",
  },
  {
    id: "apollo-inu",
    symbol: "apollo",
    name: "Apollo Inu",
  },
  {
    id: "apollon-limassol",
    symbol: "apl",
    name: "Apollon Limassol Fan Token",
  },
  {
    id: "apollo-protocol",
    symbol: "apollo",
    name: "Apollo Protocol",
  },
  {
    id: "apollox-2",
    symbol: "apx",
    name: "ApolloX",
  },
  {
    id: "apoyield",
    symbol: "soul",
    name: "APOyield",
  },
  {
    id: "app-alliance-association",
    symbol: "aaa",
    name: "AAAchain",
  },
  {
    id: "appcoins",
    symbol: "appc",
    name: "AppCoins",
  },
  {
    id: "appics",
    symbol: "apx",
    name: "Appics",
  },
  {
    id: "apple",
    symbol: "apple",
    name: "Apple",
  },
  {
    id: "apple-binemon",
    symbol: "amb",
    name: "Apple (Binemon)",
  },
  {
    id: "apple-finance",
    symbol: "aplp",
    name: "Apple Finance",
  },
  {
    id: "apple-fruit",
    symbol: "apple",
    name: "Apple Fruit",
  },
  {
    id: "apple-protocol-token",
    symbol: "aapl",
    name: "Apple Protocol",
  },
  {
    id: "appleswap",
    symbol: "apple",
    name: "AppleSwap",
  },
  {
    id: "apple-tokenized-stock-defichain",
    symbol: "daapl",
    name: "Apple Tokenized Stock Defichain",
  },
  {
    id: "apr-coin",
    symbol: "apr",
    name: "APR Coin",
  },
  {
    id: "apreum",
    symbol: "apu",
    name: "Apreum",
  },
  {
    id: "apricot",
    symbol: "apt",
    name: "Apricot",
  },
  {
    id: "april",
    symbol: "april",
    name: "April",
  },
  {
    id: "apron",
    symbol: "apn",
    name: "Apron",
  },
  {
    id: "apwine",
    symbol: "apw",
    name: "APWine",
  },
  {
    id: "apy-finance",
    symbol: "apy",
    name: "APY.Finance",
  },
  {
    id: "apyswap",
    symbol: "apys",
    name: "APYSwap",
  },
  {
    id: "apy-vision",
    symbol: "vision",
    name: "APY.vision",
  },
  {
    id: "aqar-chain",
    symbol: "aqr",
    name: "Aqar Chain",
  },
  {
    id: "aquachain",
    symbol: "aqua",
    name: "Aquachain",
  },
  {
    id: "aqua-goat",
    symbol: "aquagoat",
    name: "Aqua Goat",
  },
  {
    id: "aquagoat-old",
    symbol: "aquagoat",
    name: "AquaGoat (Old)",
  },
  {
    id: "aquanee",
    symbol: "aqdc",
    name: "Aquanee",
  },
  {
    id: "aquari",
    symbol: "aquari",
    name: "Aquari",
  },
  {
    id: "aquarius",
    symbol: "aqua",
    name: "Aquarius",
  },
  {
    id: "aquariuscoin",
    symbol: "arco",
    name: "AquariusCoin",
  },
  {
    id: "aquarius-fi",
    symbol: "aqu",
    name: "Aquarius.Fi",
  },
  {
    id: "arabic",
    symbol: "abic",
    name: "Arabic",
  },
  {
    id: "arable-protocol",
    symbol: "acre",
    name: "Arable Protocol",
  },
  {
    id: "aradenean-gold",
    symbol: "ag",
    name: "Aradenean Gold",
  },
  {
    id: "aragon",
    symbol: "ant",
    name: "Aragon",
  },
  {
    id: "arata",
    symbol: "arata",
    name: "Arata",
  },
  {
    id: "ara-token",
    symbol: "ara",
    name: "Ara",
  },
  {
    id: "araw-token",
    symbol: "araw",
    name: "ARAW",
  },
  {
    id: "arbidex",
    symbol: "abx",
    name: "Arbidex",
  },
  {
    id: "arbidoge",
    symbol: "adoge",
    name: "ArbiDoge",
  },
  {
    id: "arbifarm",
    symbol: "afarm",
    name: "ArbiFarm",
  },
  {
    id: "arbimatter",
    symbol: "arbimatter",
    name: "ArbiMATTER",
  },
  {
    id: "arbinyan",
    symbol: "nyan",
    name: "ArbiNYAN",
  },
  {
    id: "arbirise-finance",
    symbol: "arf",
    name: "ArbiRiseFinance",
  },
  {
    id: "arbis-finance",
    symbol: "arbis",
    name: "Arbis Finance",
  },
  {
    id: "arbismart-token",
    symbol: "rbis",
    name: "ArbiSmart",
  },
  {
    id: "arbix-finance",
    symbol: "arbx",
    name: "Arbix Finance",
  },
  {
    id: "arbucks",
    symbol: "buck",
    name: "Arbucks",
  },
  {
    id: "arbys",
    symbol: "arbys",
    name: "Arbys",
  },
  {
    id: "arc",
    symbol: "arc",
    name: "Arc",
  },
  {
    id: "arcade",
    symbol: "arc",
    name: "Arcade",
  },
  {
    id: "arcadenetwork",
    symbol: "arc",
    name: "ArcadeNetwork",
  },
  {
    id: "arcader",
    symbol: "ard",
    name: "Arcader",
  },
  {
    id: "arcadetoken",
    symbol: "arcade",
    name: "ArcadeToken",
  },
  {
    id: "arcana",
    symbol: "arca",
    name: "Arcana",
  },
  {
    id: "arcana-token",
    symbol: "xar",
    name: "Arcana Network",
  },
  {
    id: "arcaneleague",
    symbol: "arcaneleague",
    name: "ArcaneLeague",
  },
  {
    id: "arcane-token",
    symbol: "arcane",
    name: "Arcane Token",
  },
  {
    id: "arcblock",
    symbol: "abt",
    name: "Arcblock",
  },
  {
    id: "arc-governance",
    symbol: "arcx",
    name: "ARC Governance",
  },
  {
    id: "archangel-token",
    symbol: "archa",
    name: "ArchAngel",
  },
  {
    id: "archer-dao-governance-token",
    symbol: "arch",
    name: "Archer DAO Governance",
  },
  {
    id: "archethic",
    symbol: "uco",
    name: "Archethic",
  },
  {
    id: "archetypal-network",
    symbol: "actp",
    name: "Archetypal Network",
  },
  {
    id: "arcona",
    symbol: "arcona",
    name: "Arcona",
  },
  {
    id: "arcs",
    symbol: "arx",
    name: "ARCS",
  },
  {
    id: "arcticcoin",
    symbol: "arc",
    name: "Advanced Technology Coin",
  },
  {
    id: "arctic-finance",
    symbol: "aurora",
    name: "Arctic Finance",
  },
  {
    id: "arc-token",
    symbol: "arc",
    name: "Arc Protocol",
  },
  {
    id: "ardana",
    symbol: "dana",
    name: "Ardana",
  },
  {
    id: "ardcoin",
    symbol: "ardx",
    name: "ArdCoin",
  },
  {
    id: "ardor",
    symbol: "ardr",
    name: "Ardor",
  },
  {
    id: "arena-token",
    symbol: "arena",
    name: "ArenaSwap",
  },
  {
    id: "arenaverse",
    symbol: "averse",
    name: "Arenaverse",
  },
  {
    id: "arenum",
    symbol: "arn",
    name: "Arenum",
  },
  {
    id: "ares-protocol",
    symbol: "ares",
    name: "Ares Protocol",
  },
  {
    id: "argentine-football-association-fan-token",
    symbol: "arg",
    name: "Argentine Football Association Fan Token",
  },
  {
    id: "argo",
    symbol: "argo",
    name: "ArGoApp",
  },
  {
    id: "argo-2",
    symbol: "argo",
    name: "Argo",
  },
  {
    id: "argo-finance",
    symbol: "argo",
    name: "Argo Finance",
  },
  {
    id: "argon",
    symbol: "argon",
    name: "Argon",
  },
  {
    id: "argonon-helium",
    symbol: "arg",
    name: "Argonon Helium",
  },
  {
    id: "ari10",
    symbol: "ari10",
    name: "Ari10",
  },
  {
    id: "aria-currency",
    symbol: "ria",
    name: "aRIA Currency",
  },
  {
    id: "ariadne",
    symbol: "ardn",
    name: "Ariadne",
  },
  {
    id: "arianee",
    symbol: "aria20",
    name: "Arianee",
  },
  {
    id: "aries-financial-token",
    symbol: "afib",
    name: "Aries Financial",
  },
  {
    id: "arion",
    symbol: "arion",
    name: "Arion",
  },
  {
    id: "arionum",
    symbol: "aro",
    name: "Arionum",
  },
  {
    id: "ari-swap",
    symbol: "ari",
    name: "Ari Swap",
  },
  {
    id: "ariva",
    symbol: "arv",
    name: "Ariva",
  },
  {
    id: "arix",
    symbol: "arix",
    name: "Arix",
  },
  {
    id: "arize",
    symbol: "arz",
    name: "ARize",
  },
  {
    id: "ark",
    symbol: "ark",
    name: "Ark",
  },
  {
    id: "arkadiko-protocol",
    symbol: "diko",
    name: "Arkadiko",
  },
  {
    id: "arkania-protocol",
    symbol: "ania",
    name: "Arkania Protocol",
  },
  {
    id: "arkarus",
    symbol: "aks",
    name: "Arkarus",
  },
  {
    id: "arker-2",
    symbol: "arker",
    name: "Arker",
  },
  {
    id: "ark-innovation-etf-defichain",
    symbol: "darkk",
    name: "ARK Innovation ETF Defichain",
  },
  {
    id: "ark-of-the-universe",
    symbol: "arks",
    name: "Ark Of The Universe",
  },
  {
    id: "ark-rivals",
    symbol: "arkn",
    name: "Ark Rivals",
  },
  {
    id: "armacoin",
    symbol: "gzm",
    name: "Armacoin",
  },
  {
    id: "armada",
    symbol: "armd",
    name: "Armada",
  },
  {
    id: "armor",
    symbol: "armor",
    name: "ARMOR",
  },
  {
    id: "armor-nxm",
    symbol: "arnxm",
    name: "Armor NXM",
  },
  {
    id: "armours",
    symbol: "arm",
    name: "Armours",
  },
  {
    id: "army-node-finance",
    symbol: "army",
    name: "Army Node Finance",
  },
  {
    id: "around-network",
    symbol: "art",
    name: "Around Network [OLD]",
  },
  {
    id: "around-network-2",
    symbol: "art",
    name: "Around Network",
  },
  {
    id: "arowana-token",
    symbol: "arw",
    name: "Arowana",
  },
  {
    id: "arpa-chain",
    symbol: "arpa",
    name: "ARPA Chain",
  },
  {
    id: "arqma",
    symbol: "arq",
    name: "ArQmA",
  },
  {
    id: "arrb-token",
    symbol: "arrb",
    name: "Arrb",
  },
  {
    id: "arrow",
    symbol: "arw",
    name: "Arrow",
  },
  {
    id: "arsenal-fan-token",
    symbol: "afc",
    name: "Arsenal Fan Token",
  },
  {
    id: "artax",
    symbol: "xax",
    name: "ARTAX",
  },
  {
    id: "artbyte",
    symbol: "aby",
    name: "ArtByte",
  },
  {
    id: "arte",
    symbol: "arte",
    name: "ARTE",
  },
  {
    id: "artem",
    symbol: "artem",
    name: "Artem",
  },
  {
    id: "artemis",
    symbol: "mis",
    name: "Artemis",
  },
  {
    id: "artemis-vision",
    symbol: "arv",
    name: "Artemis Vision",
  },
  {
    id: "arteq-nft-investment-fund",
    symbol: "arteq",
    name: "artèQ NFT Investment Fund",
  },
  {
    id: "artery",
    symbol: "artr",
    name: "Artery",
  },
  {
    id: "artex",
    symbol: "artex",
    name: "Artex",
  },
  {
    id: "artfinity-token",
    symbol: "at",
    name: "Artfinity",
  },
  {
    id: "arth",
    symbol: "arth",
    name: "ARTH",
  },
  {
    id: "arth-valuecoin",
    symbol: "arth",
    name: "ARTH Valuecoin",
  },
  {
    id: "artic-foundation",
    symbol: "artic",
    name: "ARTIC Foundation",
  },
  {
    id: "articoin",
    symbol: "atc",
    name: "ArtiCoin",
  },
  {
    id: "artificial-intelligence",
    symbol: "ai",
    name: "Artificial Intelligence",
  },
  {
    id: "artii-token",
    symbol: "artii",
    name: "ARTII",
  },
  {
    id: "artik",
    symbol: "artk",
    name: "Artik",
  },
  {
    id: "arti-project",
    symbol: "arti",
    name: "Arti Project",
  },
  {
    id: "artkit",
    symbol: "arti",
    name: "ArtKit",
  },
  {
    id: "artl",
    symbol: "artl",
    name: "ARTL",
  },
  {
    id: "artm",
    symbol: "artm",
    name: "ARTM",
  },
  {
    id: "artmeta",
    symbol: "$mart",
    name: "ArtMeta",
  },
  {
    id: "artonline",
    symbol: "art",
    name: "ArtOnline",
  },
  {
    id: "artrade",
    symbol: "atr",
    name: "Artrade",
  },
  {
    id: "art-rino",
    symbol: "artrino",
    name: "Art Rino",
  },
  {
    id: "artube",
    symbol: "att",
    name: "Artube",
  },
  {
    id: "artverse-token",
    symbol: "avt",
    name: "Artverse",
  },
  {
    id: "artwork-nft",
    symbol: "anft",
    name: "Artwork NFT",
  },
  {
    id: "artx",
    symbol: "artx",
    name: "ARTX",
  },
  {
    id: "arweave",
    symbol: "ar",
    name: "Arweave",
  },
  {
    id: "aryacoin",
    symbol: "aya",
    name: "Aryacoin",
  },
  {
    id: "arya-finance",
    symbol: "arya",
    name: "Arya Finance",
  },
  {
    id: "ascend",
    symbol: "ace",
    name: "Ascend",
  },
  {
    id: "ascend-node-club",
    symbol: "asnd",
    name: "Ascend Node Club",
  },
  {
    id: "ascension",
    symbol: "asn",
    name: "Ascension",
  },
  {
    id: "ascension-protocol",
    symbol: "ascend",
    name: "Ascension Protocol",
  },
  {
    id: "ascentpad",
    symbol: "asp",
    name: "AscentPad",
  },
  {
    id: "asch",
    symbol: "xas",
    name: "Asch",
  },
  {
    id: "asd",
    symbol: "asd",
    name: "AscendEx",
  },
  {
    id: "asec-frontier",
    symbol: "asec",
    name: "ASEC Frontier",
  },
  {
    id: "asgard-dao",
    symbol: "asgard",
    name: "Asgard DAO",
  },
  {
    id: "asgard-dao-v2",
    symbol: "asgardv2",
    name: "Asgard DAO V2",
  },
  {
    id: "asgardian-aereus",
    symbol: "volt",
    name: "Asgardian Aereus",
  },
  {
    id: "ash",
    symbol: "ash",
    name: "ASH",
  },
  {
    id: "ashare",
    symbol: "ashare",
    name: "ASHARE",
  },
  {
    id: "ashera",
    symbol: "ash",
    name: "Ashera",
  },
  {
    id: "ash-token",
    symbol: "ash",
    name: "Ash Token",
  },
  {
    id: "asia-coin",
    symbol: "asia",
    name: "Asia Coin",
  },
  {
    id: "asia-pacific-electronic-coin",
    symbol: "apecoin",
    name: "Asia Pacific Electronic Coin",
  },
  {
    id: "asimi",
    symbol: "asimi",
    name: "ASIMI",
  },
  {
    id: "asix",
    symbol: "asix",
    name: "ASIX",
  },
  {
    id: "asixplus",
    symbol: "asix+",
    name: "AsixPlus",
  },
  {
    id: "ask-me-anything",
    symbol: "ama",
    name: "Ask Me Anything",
  },
  {
    id: "askobar-network",
    symbol: "asko",
    name: "Asko",
  },
  {
    id: "as-monaco-fan-token",
    symbol: "asm",
    name: "AS Monaco Fan Token",
  },
  {
    id: "aspire",
    symbol: "asp",
    name: "Aspire",
  },
  {
    id: "aspo-world",
    symbol: "aspo",
    name: "ASPO World",
  },
  {
    id: "as-roma-fan-token",
    symbol: "asr",
    name: "AS Roma Fan Token",
  },
  {
    id: "assangedao",
    symbol: "justice",
    name: "AssangeDAO",
  },
  {
    id: "assaplay",
    symbol: "assa",
    name: "AssaPlay",
  },
  {
    id: "assara",
    symbol: "assa",
    name: "ASSARA",
  },
  {
    id: "assemble-protocol",
    symbol: "asm",
    name: "Assemble Protocol",
  },
  {
    id: "assent-protocol",
    symbol: "asnt",
    name: "Assent Protocol",
  },
  {
    id: "asset-backed-protocol",
    symbol: "abp",
    name: "Asset Backed Protocol",
  },
  {
    id: "assetmantle",
    symbol: "mntl",
    name: "AssetMantle",
  },
  {
    id: "asta",
    symbol: "asta",
    name: "ASTA",
  },
  {
    id: "astar",
    symbol: "astr",
    name: "Astar",
  },
  {
    id: "aster",
    symbol: "atc",
    name: "Aster",
  },
  {
    id: "ast-finance",
    symbol: "ast",
    name: "AST.finance",
  },
  {
    id: "aston-martin-cognizant-fan-token",
    symbol: "am",
    name: "Aston Martin Cognizant Fan Token",
  },
  {
    id: "aston-villa-fan-token",
    symbol: "avl",
    name: "Aston Villa Fan Token",
  },
  {
    id: "astra-guild-ventures",
    symbol: "agv",
    name: "Astra Guild Ventures",
  },
  {
    id: "astral-farm",
    symbol: "astral",
    name: "Astral Farm",
  },
  {
    id: "astralis",
    symbol: "star",
    name: "Astralis",
  },
  {
    id: "astrals-glxy",
    symbol: "glxy",
    name: "Astrals GLXY",
  },
  {
    id: "astrapad",
    symbol: "astra",
    name: "AstraPad",
  },
  {
    id: "astra-protocol-2",
    symbol: "$astr",
    name: "Astra Protocol",
  },
  {
    id: "astrobirdz",
    symbol: "abz",
    name: "AstroBirdz",
  },
  {
    id: "astrodonkey",
    symbol: "dnky",
    name: "AstroDonkey",
  },
  {
    id: "astroelon",
    symbol: "elonone",
    name: "AstroElon",
  },
  {
    id: "astrokitty",
    symbol: "ak",
    name: "Astrokitties",
  },
  {
    id: "astronaut",
    symbol: "naut",
    name: "Astronaut",
  },
  {
    id: "astronodes",
    symbol: "astro",
    name: "AstroNodes",
  },
  {
    id: "astronos",
    symbol: "astro",
    name: "Astronos",
  },
  {
    id: "astroport",
    symbol: "astroc",
    name: "Astroport Classic",
  },
  {
    id: "astrosanta",
    symbol: "asa",
    name: "AstroSanta",
  },
  {
    id: "astrospaces-io",
    symbol: "spaces",
    name: "AstroSpaces.io",
  },
  {
    id: "astroswap",
    symbol: "astro",
    name: "AstroSwap",
  },
  {
    id: "astrotools",
    symbol: "astro",
    name: "AstroTools",
  },
  {
    id: "astro-verse",
    symbol: "asv",
    name: "Astro Verse",
  },
  {
    id: "astrowar",
    symbol: "awar",
    name: "Astrowar",
  },
  {
    id: "asuna-inu",
    symbol: "asunainu",
    name: "Asuna Inu",
  },
  {
    id: "asva",
    symbol: "asva",
    name: "Asva Labs",
  },
  {
    id: "asward-coin",
    symbol: "asc",
    name: "Ashward Coin",
  },
  {
    id: "asyagro",
    symbol: "asy",
    name: "ASYAGRO",
  },
  {
    id: "atari",
    symbol: "atri",
    name: "Atari",
  },
  {
    id: "atauro",
    symbol: "atr",
    name: "Atauro",
  },
  {
    id: "atbcoin",
    symbol: "atb",
    name: "ATBCoin",
  },
  {
    id: "at-finance",
    symbol: "at",
    name: "AT Finance",
  },
  {
    id: "atheios",
    symbol: "ath",
    name: "Atheios",
  },
  {
    id: "athena-crypto-bank",
    symbol: "ath",
    name: "Athena Crypto Bank",
  },
  {
    id: "athena-money",
    symbol: "ath",
    name: "Athena Money",
  },
  {
    id: "athena-money-owl",
    symbol: "owl",
    name: "Athena Money Owl",
  },
  {
    id: "athenas",
    symbol: "athenasv2",
    name: "Athenas",
  },
  {
    id: "atheneum",
    symbol: "aem",
    name: "Atheneum",
  },
  {
    id: "athens",
    symbol: "ath",
    name: "Athens",
  },
  {
    id: "ath-games",
    symbol: "athd",
    name: "ATH Games",
  },
  {
    id: "athletex",
    symbol: "ax",
    name: "AthleteX",
  },
  {
    id: "atlantis",
    symbol: "atlas",
    name: "Atlantis",
  },
  {
    id: "atlantis-finance",
    symbol: "atls",
    name: "Atlantis Finance",
  },
  {
    id: "atlantis-loans",
    symbol: "atl",
    name: "Atlantis Loans",
  },
  {
    id: "atlantis-loans-polygon",
    symbol: "atlx",
    name: "Atlantis Loans Polygon",
  },
  {
    id: "atlantis-metaverse",
    symbol: "tau",
    name: "Atlantis Metaverse",
  },
  {
    id: "atlantis-token",
    symbol: "atis",
    name: "Atlantis ATIS",
  },
  {
    id: "atlantis-universe-money",
    symbol: "aum",
    name: "Atlantis Universe Money",
  },
  {
    id: "atlas-cloud",
    symbol: "atlas",
    name: "Atlas Cloud",
  },
  {
    id: "atlas-dex",
    symbol: "ats",
    name: "Atlas DEX",
  },
  {
    id: "atlas-protocol",
    symbol: "atp",
    name: "Atlas Protocol",
  },
  {
    id: "atlas-usv",
    symbol: "usv",
    name: "Atlas USV",
  },
  {
    id: "atletico-madrid",
    symbol: "atm",
    name: "Atletico Madrid Fan Token",
  },
  {
    id: "atlo",
    symbol: "atlo",
    name: "Atlo",
  },
  {
    id: "atmos",
    symbol: "atmos",
    name: "Atmos",
  },
  {
    id: "atn",
    symbol: "atn",
    name: "ATN",
  },
  {
    id: "atomic-wallet-coin",
    symbol: "awc",
    name: "Atomic Wallet Coin",
  },
  {
    id: "atompad",
    symbol: "atpad",
    name: "AtomPad",
  },
  {
    id: "atrollcity",
    symbol: "pine",
    name: "Atrollcity",
  },
  {
    id: "atromg8",
    symbol: "ag8",
    name: "ATROMG8",
  },
  {
    id: "attack-wagon",
    symbol: "atk",
    name: "Attack Wagon",
  },
  {
    id: "attila",
    symbol: "att",
    name: "Attila",
  },
  {
    id: "attlas-token",
    symbol: "ats",
    name: "Attlas",
  },
  {
    id: "attn",
    symbol: "attn",
    name: "ATTN",
  },
  {
    id: "attrace",
    symbol: "attr",
    name: "Attrace",
  },
  {
    id: "auction",
    symbol: "auction",
    name: "Bounce",
  },
  {
    id: "auctus",
    symbol: "auc",
    name: "Auctus",
  },
  {
    id: "audax",
    symbol: "audax",
    name: "Audax",
  },
  {
    id: "audiocoin",
    symbol: "adc",
    name: "AudioCoin",
  },
  {
    id: "auditchain",
    symbol: "audt",
    name: "Auditchain",
  },
  {
    id: "audius",
    symbol: "audio",
    name: "Audius",
  },
  {
    id: "audius-wormhole",
    symbol: "audio",
    name: "Audius (Wormhole)",
  },
  {
    id: "augmented-finance",
    symbol: "agf",
    name: "Augmented Finance",
  },
  {
    id: "augur",
    symbol: "rep",
    name: "Augur",
  },
  {
    id: "augury-finance",
    symbol: "omen",
    name: "Augury Finance",
  },
  {
    id: "aunit",
    symbol: "aunit",
    name: "Aunit",
  },
  {
    id: "aura-network",
    symbol: "aura",
    name: "Aura Network",
  },
  {
    id: "aureo",
    symbol: "aur",
    name: "AUREO",
  },
  {
    id: "aureus-nummus-gold",
    symbol: "ang",
    name: "Aureus Nummus Gold",
  },
  {
    id: "aureus-token",
    symbol: "aureusrh",
    name: "Aureus",
  },
  {
    id: "auric-network",
    symbol: "auscm",
    name: "Auric Network",
  },
  {
    id: "aurigami",
    symbol: "ply",
    name: "Aurigami",
  },
  {
    id: "aurix",
    symbol: "aur",
    name: "Aurix",
  },
  {
    id: "aurora",
    symbol: "aoa",
    name: "Aurora Chain",
  },
  {
    id: "auroracoin",
    symbol: "aur",
    name: "Auroracoin",
  },
  {
    id: "aurora-dao",
    symbol: "idex",
    name: "IDEX",
  },
  {
    id: "aurora-finance",
    symbol: "aura",
    name: "Aurora Finance",
  },
  {
    id: "aurora-near",
    symbol: "aurora",
    name: "Aurora",
  },
  {
    id: "aurorashibamoon",
    symbol: "ashibam",
    name: "AuroraShibaMoon",
  },
  {
    id: "auroratoken",
    symbol: "aurora",
    name: "AuroraToken",
  },
  {
    id: "aurora-token",
    symbol: "$adtx",
    name: "Aurora Dimension",
  },
  {
    id: "aurory",
    symbol: "aury",
    name: "Aurory",
  },
  {
    id: "aurory-wormhole",
    symbol: "aury",
    name: "Aurory (Wormhole)",
  },
  {
    id: "auroshiba",
    symbol: "ashiba",
    name: "AuroShiba",
  },
  {
    id: "auruscoin",
    symbol: "awx",
    name: "AurusDeFi",
  },
  {
    id: "aurusgold",
    symbol: "awg",
    name: "AurusGOLD",
  },
  {
    id: "aurus-silver",
    symbol: "aws",
    name: "AurusSILVER",
  },
  {
    id: "ausd",
    symbol: "ausd",
    name: "aUSD",
  },
  {
    id: "australian-crypto-coin-green",
    symbol: "accg",
    name: "Australian Crypto Coin Green",
  },
  {
    id: "australian-safe-shepherd",
    symbol: "ass",
    name: "Australian Safe Shepherd",
  },
  {
    id: "auto",
    symbol: "auto",
    name: "Auto",
  },
  {
    id: "autobahn",
    symbol: "atb",
    name: "Autobahn",
  },
  {
    id: "autobahn-network",
    symbol: "txl",
    name: "Autobahn Network",
  },
  {
    id: "autobitco-token",
    symbol: "abco",
    name: "AutoBitco",
  },
  {
    id: "autobusd",
    symbol: "abs",
    name: "Autobusd",
  },
  {
    id: "autocrypto",
    symbol: "au",
    name: "AutoCrypto",
  },
  {
    id: "automata",
    symbol: "ata",
    name: "Automata",
  },
  {
    id: "automaticup",
    symbol: "atmup",
    name: "AutoMaticUp",
  },
  {
    id: "autonio",
    symbol: "niox",
    name: "Autonio",
  },
  {
    id: "autoshark",
    symbol: "jaws",
    name: "AutoShark",
  },
  {
    id: "autumn",
    symbol: "autumn",
    name: "Autumn",
  },
  {
    id: "auxilium",
    symbol: "aux",
    name: "Auxilium",
  },
  {
    id: "avakus",
    symbol: "avak",
    name: "Avakus",
  },
  {
    id: "avalanche-2",
    symbol: "avax",
    name: "Avalanche",
  },
  {
    id: "avalanche-honeybee",
    symbol: "a.bee",
    name: "Avalanche HoneyBee",
  },
  {
    id: "avalanchevoid",
    symbol: "void",
    name: "AvalancheVoid",
  },
  {
    id: "avalanche-wormhole",
    symbol: "avax",
    name: "Avalanche (Wormhole)",
  },
  {
    id: "avalaunch",
    symbol: "xava",
    name: "Avalaunch",
  },
  {
    id: "avalend-finance",
    symbol: "aval",
    name: "Avalend Finance",
  },
  {
    id: "avaluse",
    symbol: "aval",
    name: "Avaluse",
  },
  {
    id: "ava-mim",
    symbol: "avamim",
    name: "Ava MIM",
  },
  {
    id: "avania",
    symbol: "nova",
    name: "Avania",
  },
  {
    id: "avanyan",
    symbol: "anyan",
    name: "AvaNyan",
  },
  {
    id: "avaocado-dao",
    symbol: "avg",
    name: "Avocado DAO",
  },
  {
    id: "avaone-finance",
    symbol: "avao",
    name: "AvaOne Finance",
  },
  {
    id: "avapay",
    symbol: "avapay",
    name: "AvaPay",
  },
  {
    id: "avara",
    symbol: "avr",
    name: "AVARA",
  },
  {
    id: "avastr-vault-nftx",
    symbol: "avastr",
    name: "AVASTR Vault (NFTX)",
  },
  {
    id: "avata-network",
    symbol: "avat",
    name: "AVATA Network",
  },
  {
    id: "avaterra",
    symbol: "terra",
    name: "Avaterra",
  },
  {
    id: "ava-time",
    symbol: "avtime",
    name: "Ava Time",
  },
  {
    id: "avaware",
    symbol: "ave",
    name: "Avaware",
  },
  {
    id: "avaware-usd",
    symbol: "ausd",
    name: "Avaware USD",
  },
  {
    id: "avax-1x",
    symbol: "avax1x",
    name: "AVAX 1x",
  },
  {
    id: "avax-capital-node",
    symbol: "acn",
    name: "AVAX Capital Node",
  },
  {
    id: "avaxdao",
    symbol: "avaxd",
    name: "AvaxDAO",
  },
  {
    id: "avaxlauncher",
    symbol: "avxl",
    name: "Avaxlauncher",
  },
  {
    id: "avax-nodes",
    symbol: "anode",
    name: "Avax Nodes",
  },
  {
    id: "avaxtars",
    symbol: "avxt",
    name: "Avaxtars",
  },
  {
    id: "avaxup",
    symbol: "avaxup",
    name: "AvaxUp",
  },
  {
    id: "aventus",
    symbol: "avt",
    name: "Aventus",
  },
  {
    id: "avianite",
    symbol: "avian",
    name: "Avianite",
  },
  {
    id: "avian-network",
    symbol: "avn",
    name: "AVIAN",
  },
  {
    id: "avinoc",
    symbol: "avinoc",
    name: "AVINOC",
  },
  {
    id: "avme",
    symbol: "avme",
    name: "AVME",
  },
  {
    id: "avnrich",
    symbol: "avn",
    name: "AVNRich",
  },
  {
    id: "avocadocoin",
    symbol: "avdo",
    name: "AvocadoCoin",
  },
  {
    id: "axe",
    symbol: "axe",
    name: "Axe",
  },
  {
    id: "axel",
    symbol: "axel",
    name: "AXEL",
  },
  {
    id: "axelar-network",
    symbol: "axl",
    name: "Axelar Network",
  },
  {
    id: "axentro",
    symbol: "axnt",
    name: "Axentro",
  },
  {
    id: "axia",
    symbol: "axiav3",
    name: "Axia",
  },
  {
    id: "axial",
    symbol: "axl",
    name: "AXiaL",
  },
  {
    id: "axial-token",
    symbol: "axial",
    name: "Axial Token",
  },
  {
    id: "axie-infinity",
    symbol: "axs",
    name: "Axie Infinity",
  },
  {
    id: "axie-infinity-shard-wormhole",
    symbol: "axset",
    name: "Axie Infinity Shard (Wormhole)",
  },
  {
    id: "axioms",
    symbol: "axi",
    name: "Axioms",
  },
  {
    id: "axion",
    symbol: "axn",
    name: "Axion",
  },
  {
    id: "axis-defi",
    symbol: "axis",
    name: "Axis DeFi",
  },
  {
    id: "axis-token",
    symbol: "axis",
    name: "AXIS",
  },
  {
    id: "axl-inu",
    symbol: "axl",
    name: "AXL INU",
  },
  {
    id: "axpire",
    symbol: "axpr",
    name: "aXpire",
  },
  {
    id: "azbit",
    symbol: "az",
    name: "Azbit",
  },
  {
    id: "azeusx",
    symbol: "azx",
    name: "AzeusX",
  },
  {
    id: "azit",
    symbol: "azit",
    name: "Azit",
  },
  {
    id: "aztec-nodes-sun",
    symbol: "sun",
    name: "Aztec Nodes SUN",
  },
  {
    id: "azuki",
    symbol: "azuki",
    name: "Azuki",
  },
  {
    id: "azuma-coin",
    symbol: "azum",
    name: "Azuma Coin",
  },
  {
    id: "azuras",
    symbol: "uzz",
    name: "UZURAS",
  },
  {
    id: "azuray",
    symbol: "azy",
    name: "Azuray",
  },
  {
    id: "azus",
    symbol: "azu",
    name: "Azus",
  },
  {
    id: "b20",
    symbol: "b20",
    name: "B20",
  },
  {
    id: "b21",
    symbol: "b21",
    name: "B21",
  },
  {
    id: "b2bcoin-2",
    symbol: "b2b",
    name: "B2Bcoin",
  },
  {
    id: "b2u-coin",
    symbol: "b2u",
    name: "B2U Coin",
  },
  {
    id: "baanx",
    symbol: "bxx",
    name: "Baanx",
  },
  {
    id: "baasid",
    symbol: "baas",
    name: "BaaSid",
  },
  {
    id: "babb",
    symbol: "bax",
    name: "BABB",
  },
  {
    id: "babelfish",
    symbol: "babel",
    name: "BabelFish",
  },
  {
    id: "baboon-financial",
    symbol: "boon",
    name: "Baboon Financial",
  },
  {
    id: "baby-ada",
    symbol: "babyada",
    name: "Baby ADA",
  },
  {
    id: "babyaeth",
    symbol: "baeth",
    name: "BabyAETH",
  },
  {
    id: "baby-aetherius",
    symbol: "babyaeth",
    name: "Baby Aetherius",
  },
  {
    id: "babyarmy",
    symbol: "barmy",
    name: "BabyArmy",
  },
  {
    id: "baby-bali",
    symbol: "bb",
    name: "Baby Bali",
  },
  {
    id: "babybanana",
    symbol: "bbnana",
    name: "BabyBanana",
  },
  {
    id: "babybitcoin",
    symbol: "babybitc",
    name: "BabyBitcoin",
  },
  {
    id: "baby-bitcoin",
    symbol: "bbtc",
    name: "Baby Bitcoin",
  },
  {
    id: "babybnb",
    symbol: "babybnb",
    name: "BabyBNB",
  },
  {
    id: "babyboo",
    symbol: "babyboo",
    name: "BabyBoo",
  },
  {
    id: "baby-boxer",
    symbol: "bboxer",
    name: "Baby Boxer",
  },
  {
    id: "babybusd",
    symbol: "babybusd",
    name: "BabyBUSD",
  },
  {
    id: "baby-cake",
    symbol: "babycake",
    name: "Baby Cake",
  },
  {
    id: "babycare",
    symbol: "babycare",
    name: "BabyCare",
  },
  {
    id: "babycasper",
    symbol: "babycasper",
    name: "Baby Casper",
  },
  {
    id: "baby-catcoin",
    symbol: "babycats",
    name: "Baby Catcoin",
  },
  {
    id: "babycatgirl",
    symbol: "babycatgirl",
    name: "BabyCatGirl",
  },
  {
    id: "baby-chedda",
    symbol: "babychedda",
    name: "Baby Chedda",
  },
  {
    id: "baby-cheems-inu",
    symbol: "bci",
    name: "Baby Cheems Inu",
  },
  {
    id: "baby-defido",
    symbol: "babydefido",
    name: "Baby DeFido",
  },
  {
    id: "baby-doge-billionaire",
    symbol: "babydb",
    name: "Baby Doge Billionaire",
  },
  {
    id: "babydogecake",
    symbol: "bdc",
    name: "BabyDogeCake",
  },
  {
    id: "baby-doge-cash",
    symbol: "babydogecash",
    name: "Baby Doge Cash",
  },
  {
    id: "baby-doge-coin",
    symbol: "babydoge",
    name: "Baby Doge Coin",
  },
  {
    id: "babydoge-coin-eth",
    symbol: "babydoge",
    name: "BabyDoge ETH",
  },
  {
    id: "baby-doge-inu",
    symbol: "$babydogeinu",
    name: "Baby Doge Inu",
  },
  {
    id: "babydogeking",
    symbol: "babydogeking",
    name: "BabyDogeKing",
  },
  {
    id: "baby-doge-money-maker",
    symbol: "babydogemm",
    name: "Baby Doge Money Maker",
  },
  {
    id: "babydogezilla",
    symbol: "babydogezilla",
    name: "BabyDogeZilla",
  },
  {
    id: "baby-dogo-coin",
    symbol: "babydogo",
    name: "Baby Dogo Coin",
  },
  {
    id: "babydot",
    symbol: "bdot",
    name: "BabyDot",
  },
  {
    id: "baby-doug",
    symbol: "babydoug",
    name: "Baby Doug",
  },
  {
    id: "babyeth",
    symbol: "babyeth",
    name: "BabyEth",
  },
  {
    id: "babyethereum",
    symbol: "bbeth",
    name: "BabyEthereum",
  },
  {
    id: "babyeth-v2",
    symbol: "babyethv2",
    name: "BabyETH V2",
  },
  {
    id: "baby-everdoge",
    symbol: "baby everdoge",
    name: "Baby EverDoge",
  },
  {
    id: "babyfeg",
    symbol: "bbfeg",
    name: "Babyfeg",
  },
  {
    id: "babyfloki",
    symbol: "babyfloki",
    name: "BabyFloki",
  },
  {
    id: "baby-floki",
    symbol: "babyfloki",
    name: "Baby Floki",
  },
  {
    id: "baby-floki-billionaire",
    symbol: "babyfb",
    name: "Baby Floki Billionaire",
  },
  {
    id: "baby-floki-coin",
    symbol: "babyflokicoin",
    name: "Baby Floki Coin",
  },
  {
    id: "baby-floki-doge",
    symbol: "babyfd",
    name: "Baby Floki Doge",
  },
  {
    id: "baby-floki-inu",
    symbol: "bfloki",
    name: "Baby Floki Inu",
  },
  {
    id: "baby-floki-up",
    symbol: "bfu",
    name: "Baby Floki Up",
  },
  {
    id: "babyfrog",
    symbol: "babyfrog",
    name: "BabyFrog",
  },
  {
    id: "babyharmony",
    symbol: "babyharmony",
    name: "BabyHarmony",
  },
  {
    id: "baby-kishu",
    symbol: "babykishu",
    name: "Baby Kishu",
  },
  {
    id: "babykitty",
    symbol: "babykitty",
    name: "BabyKitty",
  },
  {
    id: "babykraken",
    symbol: "krakbaby",
    name: "BabyKraken",
  },
  {
    id: "baby-kshark",
    symbol: "bks",
    name: "Baby KShark",
  },
  {
    id: "baby-lambo-inu",
    symbol: "blinu",
    name: "Baby Lambo Inu",
  },
  {
    id: "baby-lion",
    symbol: "bln",
    name: "Baby Lion",
  },
  {
    id: "babylondao",
    symbol: "bby",
    name: "BabylonDAO",
  },
  {
    id: "babylon-finance",
    symbol: "babl",
    name: "Babylon Finance",
  },
  {
    id: "babylons",
    symbol: "babi",
    name: "Babylons",
  },
  {
    id: "baby-lovely-inu",
    symbol: "blovely",
    name: "Baby Lovely Inu",
  },
  {
    id: "baby-meta",
    symbol: "babymeta",
    name: "Baby Meta",
  },
  {
    id: "baby-mind",
    symbol: "bmnd",
    name: "Baby Mind",
  },
  {
    id: "baby-moon-floki",
    symbol: "floki",
    name: "Baby Moon Floki",
  },
  {
    id: "baby-moon-wolf",
    symbol: "babywolf",
    name: "Baby Moon Wolf",
  },
  {
    id: "baby-o-baby",
    symbol: "bob",
    name: "Baby o Baby",
  },
  {
    id: "babyokx",
    symbol: "babyokx",
    name: "BABYOKX (BSC)",
  },
  {
    id: "babyokx-2",
    symbol: "babyokx",
    name: "BABYOKX",
  },
  {
    id: "baby-panda",
    symbol: "bpanda",
    name: "Baby Panda",
  },
  {
    id: "baby-pig-token",
    symbol: "babypig",
    name: "Baby Pig",
  },
  {
    id: "baby-pokemoon",
    symbol: "bpm",
    name: "Baby Pokemoon",
  },
  {
    id: "babypumpkin-finance",
    symbol: "bump",
    name: "BabyPumpkin Finance",
  },
  {
    id: "babyquick",
    symbol: "babyquick",
    name: "BabyQuick",
  },
  {
    id: "baby-ripple",
    symbol: "babyxrp",
    name: "Baby Ripple",
  },
  {
    id: "babysafemoon",
    symbol: "bsfm",
    name: "BabySafeMoon",
  },
  {
    id: "baby-saitama",
    symbol: "babysaitama",
    name: "Baby Saitama",
  },
  {
    id: "baby-samo-coin",
    symbol: "baby",
    name: "Baby Samo Coin",
  },
  {
    id: "baby-satoshi",
    symbol: "sats",
    name: "Baby Satoshi",
  },
  {
    id: "baby-shark",
    symbol: "shark",
    name: "Baby Shark",
  },
  {
    id: "baby-shark-finance",
    symbol: "bbs",
    name: "Baby-Shark.Finance",
  },
  {
    id: "baby-shark-tank",
    symbol: "bashtank",
    name: "Baby Shark Tank",
  },
  {
    id: "baby-shiba-coin",
    symbol: "babyshiba",
    name: "Baby Shiba Coin",
  },
  {
    id: "baby-shiba-dot",
    symbol: "bsd",
    name: "Baby Shiba Dot",
  },
  {
    id: "baby-shiba-inu",
    symbol: "babyshibainu",
    name: "Baby Shiba Inu",
  },
  {
    id: "babyshibby-inu",
    symbol: "babyshib",
    name: "BabyShibby Inu",
  },
  {
    id: "baby-soulja-boy",
    symbol: "draco",
    name: "Baby Soulja Boy",
  },
  {
    id: "baby-starlink-doge",
    symbol: "starlinkdoge",
    name: "Baby Starlink Doge",
  },
  {
    id: "babyswap",
    symbol: "baby",
    name: "BabySwap",
  },
  {
    id: "baby-tether",
    symbol: "babytether",
    name: "BABY TETHER",
  },
  {
    id: "babytigergold",
    symbol: "babytiger",
    name: "BabyTigerGold",
  },
  {
    id: "baby-tiger-king",
    symbol: "babytk",
    name: "Baby Tiger King",
  },
  {
    id: "baby-token",
    symbol: "baby",
    name: "Baby",
  },
  {
    id: "baby-trump",
    symbol: "babytrump",
    name: "Baby Trump",
  },
  {
    id: "babyusdt",
    symbol: "babyusdt",
    name: "BabyUSDT",
  },
  {
    id: "babywakandainu",
    symbol: "babywkd",
    name: "Babywakandainu",
  },
  {
    id: "babywhale",
    symbol: "bbw",
    name: "BabyWhale",
  },
  {
    id: "babywhitetiger",
    symbol: "bwt",
    name: "BabyWhiteTiger",
  },
  {
    id: "baby-woj",
    symbol: "bwj",
    name: "Baby WOJ",
  },
  {
    id: "babyxape",
    symbol: "babyx",
    name: "BabyXape",
  },
  {
    id: "babyxrp",
    symbol: "bbyxrp",
    name: "BabyXrp",
  },
  {
    id: "babyzoro-inu",
    symbol: "babyzoroinu",
    name: "Babyzoro Inu",
  },
  {
    id: "backed-protocol",
    symbol: "bakt",
    name: "Backed Protocol",
  },
  {
    id: "backpacker-coin",
    symbol: "bpc",
    name: "BackPacker Coin",
  },
  {
    id: "bacon",
    symbol: "bacon",
    name: "BACON",
  },
  {
    id: "bacon-coin",
    symbol: "bacon",
    name: "Bacon Coin",
  },
  {
    id: "bacondao",
    symbol: "bacon",
    name: "BaconDAO",
  },
  {
    id: "baconswap",
    symbol: "bacon",
    name: "BaconSwap",
  },
  {
    id: "baddest-alpha-ape-bundle",
    symbol: "aped",
    name: "Baddest Alpha Ape Bundle",
  },
  {
    id: "badger-dao",
    symbol: "badger",
    name: "Badger DAO",
  },
  {
    id: "badger-sett-badger",
    symbol: "bbadger",
    name: "Badger Sett Badger",
  },
  {
    id: "badger-sett-digg",
    symbol: "bdigg",
    name: "Badger Sett Digg",
  },
  {
    id: "bae",
    symbol: "bae",
    name: "Bae",
  },
  {
    id: "baepay",
    symbol: "baepay",
    name: "BAEPAY",
  },
  {
    id: "bafe-io",
    symbol: "bafe",
    name: "Bafe.io",
  },
  {
    id: "bafi-finance-token",
    symbol: "bafi",
    name: "Bafi Finance",
  },
  {
    id: "bagel",
    symbol: "bagel",
    name: "Bagels Finance",
  },
  {
    id: "bagswap",
    symbol: "bswap",
    name: "BagSwap",
  },
  {
    id: "baguette",
    symbol: "bag",
    name: "Baguette",
  },
  {
    id: "bagus-wallet",
    symbol: "bg",
    name: "Bagus Wallet",
  },
  {
    id: "bahtcoin",
    symbol: "bht",
    name: "Bahtcoin",
  },
  {
    id: "bai-stablecoin",
    symbol: "bai",
    name: "BAI Stablecoin",
  },
  {
    id: "baitcoin",
    symbol: "bait",
    name: "Baitcoin",
  },
  {
    id: "bakc-vault-nftx",
    symbol: "bakc",
    name: "BAKC Vault (NFTX)",
  },
  {
    id: "bake-coin",
    symbol: "bakecoin",
    name: "Bake Coin",
  },
  {
    id: "bakedcake",
    symbol: "bakedcake",
    name: "BakedCake Finance",
  },
  {
    id: "baked-token",
    symbol: "baked",
    name: "Baked",
  },
  {
    id: "baker-guild",
    symbol: "baker",
    name: "Baker Guild",
  },
  {
    id: "bakerytoken",
    symbol: "bake",
    name: "BakerySwap",
  },
  {
    id: "bakerytools",
    symbol: "tbake",
    name: "BakeryTools",
  },
  {
    id: "baklava",
    symbol: "bava",
    name: "Baklava",
  },
  {
    id: "baksdao",
    symbol: "baks",
    name: "BaksDAO",
  },
  {
    id: "balanced-dollars",
    symbol: "bnusd",
    name: "Balanced Dollars",
  },
  {
    id: "balancer",
    symbol: "bal",
    name: "Balancer",
  },
  {
    id: "balancer-boosted-aave-dai",
    symbol: "bb-a-dai",
    name: "Balancer Boosted Aave DAI",
  },
  {
    id: "balancer-boosted-aave-usdc",
    symbol: "bb-a-usdc",
    name: "Balancer Boosted Aave USDC",
  },
  {
    id: "balancer-boosted-aave-usdt",
    symbol: "bb-a-usdt",
    name: "Balancer Boosted Aave USDT",
  },
  {
    id: "balancer-booster-aave-usd",
    symbol: "bb-a-usd",
    name: "Balancer Boosted Aave USD",
  },
  {
    id: "balance-tokens",
    symbol: "baln",
    name: "Balanced Network",
  },
  {
    id: "balicoin",
    symbol: "bali",
    name: "Bali Coin",
  },
  {
    id: "balikesirspor-token",
    symbol: "blks",
    name: "Balıkesirspor Token",
  },
  {
    id: "balisari",
    symbol: "bst",
    name: "Balisari",
  },
  {
    id: "bali-social-integrated",
    symbol: "bsi",
    name: "Bali Social Integrated",
  },
  {
    id: "bali-token",
    symbol: "bli",
    name: "Bali Token",
  },
  {
    id: "balkari-token",
    symbol: "bkr",
    name: "Balkari",
  },
  {
    id: "ball-coin",
    symbol: "ball",
    name: "BALL Coin",
  },
  {
    id: "balloon-coin",
    symbol: "balo",
    name: "Balloon Coin",
  },
  {
    id: "balloonsville-air",
    symbol: "air",
    name: "Balloonsville AIR",
  },
  {
    id: "ballotbox",
    symbol: "bbx",
    name: "Ballotbox",
  },
  {
    id: "ballswap",
    symbol: "bsp",
    name: "BallSwap",
  },
  {
    id: "ballswapper-accelerator-reflection-token",
    symbol: "bart",
    name: "Ballswapper Accelerator Reflection",
  },
  {
    id: "balpha",
    symbol: "balpha",
    name: "bAlpha",
  },
  {
    id: "bamboo",
    symbol: "bam",
    name: "BAMBOO",
  },
  {
    id: "bamboo-coin",
    symbol: "bmbo",
    name: "Bamboo Coin",
  },
  {
    id: "bamboo-defi",
    symbol: "bamboo",
    name: "BambooDeFi",
  },
  {
    id: "bamboonium",
    symbol: "bamb",
    name: "Bamboonium",
  },
  {
    id: "bami",
    symbol: "bami",
    name: "Bami",
  },
  {
    id: "banana",
    symbol: "banana",
    name: "Banana",
  },
  {
    id: "banana-bucks",
    symbol: "bab",
    name: "Banana Bucks",
  },
  {
    id: "banana-finance",
    symbol: "banana",
    name: "Banana Finance",
  },
  {
    id: "banana-task-force-ape",
    symbol: "btfa",
    name: "Banana Task Force Ape",
  },
  {
    id: "bananatok",
    symbol: "bna",
    name: "BananaTok",
  },
  {
    id: "banana-token",
    symbol: "bnana",
    name: "Chimpion",
  },
  {
    id: "bananaz-club",
    symbol: "bananaz",
    name: "BANANAZ CLUB",
  },
  {
    id: "banano",
    symbol: "ban",
    name: "Banano",
  },
  {
    id: "banca",
    symbol: "banca",
    name: "Banca",
  },
  {
    id: "bancambios-ax",
    symbol: "bxs",
    name: "Bancambios AX",
  },
  {
    id: "bancor",
    symbol: "bnt",
    name: "Bancor Network",
  },
  {
    id: "bancor-governance-token",
    symbol: "vbnt",
    name: "Bancor Governance",
  },
  {
    id: "bancor-wormhole",
    symbol: "bnt",
    name: "Bancor (Wormhole)",
  },
  {
    id: "band-protocol",
    symbol: "band",
    name: "Band Protocol",
  },
  {
    id: "bankcoincash",
    symbol: "bcash",
    name: "BankCoin BCash",
  },
  {
    id: "bankera",
    symbol: "bnk",
    name: "Bankera",
  },
  {
    id: "bankerdoge",
    symbol: "banker",
    name: "BankerDoge",
  },
  {
    id: "bankers-dream",
    symbol: "bank$",
    name: "Bankers Dream",
  },
  {
    id: "banketh",
    symbol: "banketh",
    name: "BankEth",
  },
  {
    id: "bankless-bed-index",
    symbol: "bed",
    name: "Bankless BED Index",
  },
  {
    id: "bankless-dao",
    symbol: "bank",
    name: "Bankless DAO",
  },
  {
    id: "bankless-defi-innovation-index",
    symbol: "gmi",
    name: "Bankless DeFi Innovation Index",
  },
  {
    id: "banklife",
    symbol: "lib",
    name: "Banklife",
  },
  {
    id: "bankroll-extended-token",
    symbol: "bnkrx",
    name: "Bankroll Extended",
  },
  {
    id: "bankroll-network",
    symbol: "bnkr",
    name: "Bankroll Network",
  },
  {
    id: "bankroll-vault",
    symbol: "vlt",
    name: "Bankroll Vault",
  },
  {
    id: "banksea",
    symbol: "kse",
    name: "Banksea",
  },
  {
    id: "banksocial",
    symbol: "bsl",
    name: "BankSocial",
  },
  {
    id: "bankwupt",
    symbol: "bankwupt",
    name: "Bankwupt",
  },
  {
    id: "banque-universal",
    symbol: "cbu",
    name: "Banque Universal",
  },
  {
    id: "bantu",
    symbol: "xbn",
    name: "Bantu",
  },
  {
    id: "bao-finance",
    symbol: "bao",
    name: "Bao Finance",
  },
  {
    id: "barbecueswap",
    symbol: "bbq",
    name: "BarbecueSwap",
  },
  {
    id: "bare",
    symbol: "bare",
    name: "BARE",
  },
  {
    id: "barnbridge",
    symbol: "bond",
    name: "BarnBridge",
  },
  {
    id: "barrel",
    symbol: "barrel",
    name: "Barrel",
  },
  {
    id: "barter",
    symbol: "brtr",
    name: "Barter",
  },
  {
    id: "bartertrade",
    symbol: "bart",
    name: "BarterTrade",
  },
  {
    id: "based-finance",
    symbol: "based",
    name: "Based Finance",
  },
  {
    id: "based-money",
    symbol: "$based",
    name: "Based Money",
  },
  {
    id: "based-shares",
    symbol: "bshare",
    name: "BASED Shares",
  },
  {
    id: "based-token",
    symbol: "bdc",
    name: "Based",
  },
  {
    id: "base-protocol",
    symbol: "base",
    name: "Base Protocol",
  },
  {
    id: "basic",
    symbol: "basic",
    name: "BASIC",
  },
  {
    id: "basic-attention-token",
    symbol: "bat",
    name: "Basic Attention",
  },
  {
    id: "basic-attention-token-wormhole",
    symbol: "bat",
    name: "Basic Attention Token (Wormhole)",
  },
  {
    id: "basid-coin",
    symbol: "basid",
    name: "Basid Coin",
  },
  {
    id: "basis-bond",
    symbol: "bab",
    name: "Basis Bond",
  },
  {
    id: "basis-cash",
    symbol: "bac",
    name: "Basis Cash",
  },
  {
    id: "basis-coin-cash",
    symbol: "bcc",
    name: "Basis Coin Cash",
  },
  {
    id: "basiscoin-share",
    symbol: "bcs",
    name: "Basis Coin Share",
  },
  {
    id: "basis-dollar",
    symbol: "bsd",
    name: "Basis Dollar",
  },
  {
    id: "basis-dollar-share",
    symbol: "bsds",
    name: "Basis Dollar Share",
  },
  {
    id: "basis-gold-share-heco",
    symbol: "bags",
    name: "Basis Gold Share (Heco)",
  },
  {
    id: "basis-markets",
    symbol: "basis",
    name: "basis.markets",
  },
  {
    id: "basis-share",
    symbol: "bas",
    name: "Basis Share",
  },
  {
    id: "basketball-legends",
    symbol: "bbl",
    name: "Basketball Legends",
  },
  {
    id: "basketballverse",
    symbol: "bvr",
    name: "Basketballverse",
  },
  {
    id: "basketcoin",
    symbol: "bskt",
    name: "BasketCoin",
  },
  {
    id: "basketdao",
    symbol: "bask",
    name: "BasketDAO",
  },
  {
    id: "basketdao-defi-index",
    symbol: "bdi",
    name: "BasketDAO DeFi Index",
  },
  {
    id: "bastille-de-la-bouje",
    symbol: "bastille",
    name: "Bastille De La Bouje",
  },
  {
    id: "bastion-protocol",
    symbol: "bstn",
    name: "Bastion Protocol",
  },
  {
    id: "bata",
    symbol: "bta",
    name: "Bata",
  },
  {
    id: "batasm-protocol-bftm",
    symbol: "bftm",
    name: "Batasm Protocol BFTM",
  },
  {
    id: "batasm-protocol-bsm",
    symbol: "bsm",
    name: "Batasm Protocol BSM",
  },
  {
    id: "batman",
    symbol: "batman",
    name: "Batman",
  },
  {
    id: "batorrent",
    symbol: "ba",
    name: "BaTorrent",
  },
  {
    id: "battle-esports-coin",
    symbol: "bes",
    name: "battle esports coin",
  },
  {
    id: "battle-for-life",
    symbol: "bfl",
    name: "Battle for Life",
  },
  {
    id: "battle-hero",
    symbol: "bath",
    name: "Battle Hero",
  },
  {
    id: "battle-inu",
    symbol: "binu",
    name: "Battle Inu",
  },
  {
    id: "battlemechs",
    symbol: "gemz",
    name: "BattleMechs",
  },
  {
    id: "battle-of-guardians-share",
    symbol: "bgs",
    name: "Battle of Guardians Share",
  },
  {
    id: "battle-pets",
    symbol: "pet",
    name: "Battle Pets",
  },
  {
    id: "battleroyaletoken",
    symbol: "brtk",
    name: "BattleRoyale",
  },
  {
    id: "battle-saga",
    symbol: "btl",
    name: "Battle Saga",
  },
  {
    id: "battleverse",
    symbol: "bvc",
    name: "BattleVerse",
  },
  {
    id: "battle-world",
    symbol: "bwo",
    name: "Battle World",
  },
  {
    id: "bayc-history",
    symbol: "sweep",
    name: "BAYC History -The Great Floor Sweep",
  },
  {
    id: "bayc-vault-nftx",
    symbol: "bayc",
    name: "BAYC Vault (NFTX)",
  },
  {
    id: "bb-gaming",
    symbol: "bb",
    name: "BB Gaming",
  },
  {
    id: "bbscoin",
    symbol: "bbs",
    name: "BBSCoin",
  },
  {
    id: "bbs-network",
    symbol: "bbs",
    name: "BBS Network",
  },
  {
    id: "bchpad",
    symbol: "bpad",
    name: "BCHPad",
  },
  {
    id: "bcpay-fintech",
    symbol: "bcpay",
    name: "BCPAY FinTech",
  },
  {
    id: "b-cube-ai",
    symbol: "bcube",
    name: "B-cube.ai",
  },
  {
    id: "bcv",
    symbol: "bcv",
    name: "BitCapitalVendor",
  },
  {
    id: "bdollar",
    symbol: "bdo",
    name: "bDollar",
  },
  {
    id: "bdollar-share",
    symbol: "sbdo",
    name: "bDollar Share",
  },
  {
    id: "beachboyz",
    symbol: "boyz",
    name: "BeachBoyz",
  },
  {
    id: "beach-token",
    symbol: "beach",
    name: "Beach",
  },
  {
    id: "beach-token-bsc",
    symbol: "beach",
    name: "Beach BSC",
  },
  {
    id: "beacon",
    symbol: "becn",
    name: "Beacon",
  },
  {
    id: "beam",
    symbol: "beam",
    name: "BEAM",
  },
  {
    id: "beamswap",
    symbol: "glint",
    name: "BeamSwap",
  },
  {
    id: "bean",
    symbol: "bean",
    name: "Bean",
  },
  {
    id: "bean-cash",
    symbol: "bitb",
    name: "Bean Cash",
  },
  {
    id: "bearn-fi",
    symbol: "bfi",
    name: "Bearn.fi",
  },
  {
    id: "beast-masters",
    symbol: "master",
    name: "Beast Masters",
  },
  {
    id: "beast-nft",
    symbol: "bnft",
    name: "Beast NFT",
  },
  {
    id: "beatbind",
    symbol: "bbnd",
    name: "BeatBind",
  },
  {
    id: "beatzcoin",
    symbol: "btzc",
    name: "BeatzCoin",
  },
  {
    id: "beau-cat",
    symbol: "buc",
    name: "Beau Cat",
  },
  {
    id: "beavis-and-butthead",
    symbol: "bbh",
    name: "Beavis and Butthead",
  },
  {
    id: "bebop-inu",
    symbol: "bebop-inu",
    name: "Bebop Inu",
  },
  {
    id: "becoswap-token",
    symbol: "beco",
    name: "BecoSwap",
  },
  {
    id: "bedpage-coin",
    symbol: "bed",
    name: "Bedpage Coin",
  },
  {
    id: "bedrock",
    symbol: "rock",
    name: "Bedrock",
  },
  {
    id: "bee-capital",
    symbol: "bee",
    name: "Bee Capital",
  },
  {
    id: "beechat",
    symbol: "chat",
    name: "BeeChat",
  },
  {
    id: "beefy-escrowed-fantom",
    symbol: "beftm",
    name: "Beefy Escrowed Fantom",
  },
  {
    id: "beefy-finance",
    symbol: "bifi",
    name: "Beefy.Finance",
  },
  {
    id: "bee-inu",
    symbol: "beeinu",
    name: "Bee Inu",
  },
  {
    id: "beekan",
    symbol: "bkbt",
    name: "BeeKan / Beenews",
  },
  {
    id: "beenode",
    symbol: "bnode",
    name: "Beenode",
  },
  {
    id: "beer-money",
    symbol: "beer",
    name: "Beer Money",
  },
  {
    id: "bee-safe",
    symbol: "bsafe",
    name: "Bee Safe",
  },
  {
    id: "beethoven-x",
    symbol: "beets",
    name: "Beethoven X",
  },
  {
    id: "beetlecoin",
    symbol: "beet",
    name: "Beetlecoin",
  },
  {
    id: "beglobaldao",
    symbol: "glbd",
    name: "BeglobalDAO",
  },
  {
    id: "beholder",
    symbol: "eye",
    name: "Behodler",
  },
  {
    id: "bela",
    symbol: "aqua",
    name: "Bela Aqua",
  },
  {
    id: "beldex",
    symbol: "bdx",
    name: "Beldex",
  },
  {
    id: "belecx-protocol",
    symbol: "bex",
    name: "BelecX Protocol",
  },
  {
    id: "belifex",
    symbol: "befx",
    name: "Belifex",
  },
  {
    id: "belka",
    symbol: "blk",
    name: "Belka",
  },
  {
    id: "bella-protocol",
    symbol: "bel",
    name: "Bella Protocol",
  },
  {
    id: "bellcoin",
    symbol: "bell",
    name: "Bellcoin",
  },
  {
    id: "belon-dao",
    symbol: "be",
    name: "Belon DAO",
  },
  {
    id: "belrium",
    symbol: "bel",
    name: "Belrium",
  },
  {
    id: "belt",
    symbol: "belt",
    name: "Belt",
  },
  {
    id: "beluga-fi",
    symbol: "beluga",
    name: "Beluga.fi",
  },
  {
    id: "bem",
    symbol: "bemt",
    name: "BEM",
  },
  {
    id: "be-meta-famous",
    symbol: "bmf",
    name: "Be Meta Famous",
  },
  {
    id: "bemil-coin",
    symbol: "bem",
    name: "Bemil Coin",
  },
  {
    id: "benative",
    symbol: "bnv",
    name: "BeNative",
  },
  {
    id: "benchmark-protocol",
    symbol: "mark",
    name: "Benchmark Protocol",
  },
  {
    id: "benchmark-protocol-governance-token",
    symbol: "bend",
    name: "Benchmark Protocol Governance",
  },
  {
    id: "benddao",
    symbol: "bend",
    name: "BendDao",
  },
  {
    id: "bengals",
    symbol: "pbengals",
    name: "Bengals - Super Bowl",
  },
  {
    id: "benqi",
    symbol: "qi",
    name: "BENQI",
  },
  {
    id: "benqi-liquid-staked-avax",
    symbol: "savax",
    name: "BENQI Liquid Staked AVAX",
  },
  {
    id: "bent-finance",
    symbol: "bent",
    name: "Bent Finance",
  },
  {
    id: "benzene",
    symbol: "bzn",
    name: "Benzene",
  },
  {
    id: "bep20-leo",
    symbol: "bleo",
    name: "BEP20 LEO",
  },
  {
    id: "bepay",
    symbol: "becoin",
    name: "bePAY Finance",
  },
  {
    id: "bepis",
    symbol: "bepis",
    name: "BEPIS",
  },
  {
    id: "bepro-network",
    symbol: "bepro",
    name: "BEPRO Network",
  },
  {
    id: "berachain-bera",
    symbol: "bera",
    name: "Berachain BERA",
  },
  {
    id: "berachain-bgt",
    symbol: "bgt",
    name: "Berachain BGT",
  },
  {
    id: "berachain-honey",
    symbol: "honey",
    name: "Berachain Honey",
  },
  {
    id: "bernard",
    symbol: "bern",
    name: "Bernard",
  },
  {
    id: "berry",
    symbol: "berry",
    name: "Berry",
  },
  {
    id: "berry-data",
    symbol: "bry",
    name: "Berry Data",
  },
  {
    id: "berryswap",
    symbol: "berry",
    name: "BerrySwap",
  },
  {
    id: "berylbit",
    symbol: "brb",
    name: "BerylBit",
  },
  {
    id: "beshare-token",
    symbol: "bst",
    name: "Beshare",
  },
  {
    id: "beskar",
    symbol: "bsk-baa025",
    name: "Beskar",
  },
  {
    id: "bestay",
    symbol: "bsy",
    name: "Bestay",
  },
  {
    id: "beta-finance",
    symbol: "beta",
    name: "Beta Finance",
  },
  {
    id: "beta-token",
    symbol: "beta",
    name: "Beta",
  },
  {
    id: "betdao",
    symbol: "bdao",
    name: "BetDao",
  },
  {
    id: "betdice",
    symbol: "dice",
    name: "BetDice",
  },
  {
    id: "betero",
    symbol: "bte",
    name: "Betero",
  },
  {
    id: "betherchip",
    symbol: "bec",
    name: "Betherchip",
  },
  {
    id: "bethereum",
    symbol: "bether",
    name: "Bethereum",
  },
  {
    id: "betify",
    symbol: "betify",
    name: "Betify",
  },
  {
    id: "betller-coin",
    symbol: "btllr",
    name: "Betller Coin",
  },
  {
    id: "betswamp",
    symbol: "bets",
    name: "Betswamp",
  },
  {
    id: "betswap-gg",
    symbol: "bsgg",
    name: "Betswap.gg",
  },
  {
    id: "better-money",
    symbol: "better",
    name: "Better Money",
  },
  {
    id: "betu",
    symbol: "betu",
    name: "Betu",
  },
  {
    id: "betxoin",
    symbol: "betxc",
    name: "Betxoin",
  },
  {
    id: "beverage",
    symbol: "beverage",
    name: "BEVERAGE",
  },
  {
    id: "beverage-token",
    symbol: "drink",
    name: "Beverage Finance",
  },
  {
    id: "beyondcoin",
    symbol: "bynd",
    name: "Beyondcoin",
  },
  {
    id: "beyond-finance",
    symbol: "byn",
    name: "BeyondFi",
  },
  {
    id: "beyond-protocol",
    symbol: "bp",
    name: "Beyond Protocol",
  },
  {
    id: "bezant",
    symbol: "bznt",
    name: "Bezant",
  },
  {
    id: "bezoge-earth",
    symbol: "bezoge",
    name: "Bezoge Earth",
  },
  {
    id: "bezosdoge",
    symbol: "$bedoge",
    name: "BezosDoge",
  },
  {
    id: "bfg-token",
    symbol: "bfg",
    name: "BetFury",
  },
  {
    id: "bficoin",
    symbol: "bfic",
    name: "Bficoin",
  },
  {
    id: "bgan-vault-nftx",
    symbol: "bgan",
    name: "BGAN Vault (NFTX)",
  },
  {
    id: "bgl-token",
    symbol: "bgl",
    name: "BGL",
  },
  {
    id: "bgogo",
    symbol: "bgg",
    name: "Bgogo",
  },
  {
    id: "bgov",
    symbol: "bgov",
    name: "BGOV",
  },
  {
    id: "bgt",
    symbol: "bgt",
    name: "BGT",
  },
  {
    id: "bhnetwork",
    symbol: "bhat",
    name: "BHNetwork",
  },
  {
    id: "bho-network",
    symbol: "bho",
    name: "BHO Network",
  },
  {
    id: "biblepay",
    symbol: "bbp",
    name: "BiblePay",
  },
  {
    id: "bibox-token",
    symbol: "bix",
    name: "Bibox",
  },
  {
    id: "biconomy",
    symbol: "bico",
    name: "Biconomy",
  },
  {
    id: "biconomy-exchange-token",
    symbol: "bit",
    name: "Biconomy Exchange",
  },
  {
    id: "bicyclefi",
    symbol: "bcf",
    name: "BicycleFi",
  },
  {
    id: "bidao",
    symbol: "bid",
    name: "Bidao",
  },
  {
    id: "biden",
    symbol: "biden",
    name: "BIDEN",
  },
  {
    id: "bidipass",
    symbol: "bdp",
    name: "BidiPass",
  },
  {
    id: "bifi",
    symbol: "bifi",
    name: "BiFi",
  },
  {
    id: "bifrost",
    symbol: "bfc",
    name: "Bifrost",
  },
  {
    id: "bifrost-native-coin",
    symbol: "bnc",
    name: "Bifrost Native Coin",
  },
  {
    id: "bigbang-core",
    symbol: "bbc",
    name: "BigBang Core",
  },
  {
    id: "bigbang-game",
    symbol: "bbgc",
    name: "BigBang Game",
  },
  {
    id: "bigbom-eco",
    symbol: "bbo",
    name: "Bigbom",
  },
  {
    id: "bigdata-cash",
    symbol: "bdcash",
    name: "BigdataCash",
  },
  {
    id: "big-data-protocol",
    symbol: "bdp",
    name: "Big Data Protocol",
  },
  {
    id: "big-defi-energy",
    symbol: "bde",
    name: "Big Defi Energy",
  },
  {
    id: "big-digital-shares",
    symbol: "bds",
    name: "Big Digital Shares",
  },
  {
    id: "big-dog-coin",
    symbol: "bdog",
    name: "Big Dog Coin",
  },
  {
    id: "big-eth",
    symbol: "bigeth",
    name: "BIG ETH",
  },
  {
    id: "bigfoot",
    symbol: "foot",
    name: "BIGFOOT",
  },
  {
    id: "big-fund-capital-dao",
    symbol: "bfc",
    name: "Big Fund Capital DAO",
  },
  {
    id: "biggerminds",
    symbol: "mind",
    name: "BiggerMINDS",
  },
  {
    id: "bigh-bull",
    symbol: "bigb",
    name: "Bigh Bull",
  },
  {
    id: "big-league",
    symbol: "bglg",
    name: "Big League",
  },
  {
    id: "big-mouth-monster",
    symbol: "bmm",
    name: "Big Mouth Monster",
  },
  {
    id: "bigo-token",
    symbol: "bigo",
    name: "BIGOCOIN",
  },
  {
    id: "bigshortbets",
    symbol: "bigsb",
    name: "BigShortBets",
  },
  {
    id: "bigwinner",
    symbol: "big",
    name: "Bigwinner",
  },
  {
    id: "biitgatti",
    symbol: "bitgatti",
    name: "Bitgatti",
  },
  {
    id: "bikerush",
    symbol: "brt",
    name: "Bikerush",
  },
  {
    id: "bikini-finance",
    symbol: "bikini",
    name: "Bikini Finance",
  },
  {
    id: "bilira",
    symbol: "tryb",
    name: "BiLira",
  },
  {
    id: "billionaire-plus",
    symbol: "bplus",
    name: "Billionaire Plus",
  },
  {
    id: "billionhappiness",
    symbol: "bhc",
    name: "BillionHappiness",
  },
  {
    id: "bill-token",
    symbol: "bill",
    name: "Bill",
  },
  {
    id: "bimp-finance",
    symbol: "bimp",
    name: "Bimp Finance",
  },
  {
    id: "binahero",
    symbol: "hero",
    name: "BinaHero",
  },
  {
    id: "binahunter",
    symbol: "bhunt",
    name: "BinaHunter",
  },
  {
    id: "binamars",
    symbol: "bmars",
    name: "Binamars",
  },
  {
    id: "binamars-game",
    symbol: "bgame",
    name: "Binamars Game",
  },
  {
    id: "binamon",
    symbol: "bmon",
    name: "Binamon",
  },
  {
    id: "binance8",
    symbol: "b8",
    name: "Binance8",
  },
  {
    id: "binance-bitcoin",
    symbol: "btcb",
    name: "Binance Bitcoin",
  },
  {
    id: "binancecoin",
    symbol: "bnb",
    name: "BNB",
  },
  {
    id: "binance-coin-wormhole",
    symbol: "bnb",
    name: "Binance Coin (Wormhole)",
  },
  {
    id: "binance-eth",
    symbol: "beth",
    name: "Binance ETH staking",
  },
  {
    id: "binancehodl",
    symbol: "bihodl",
    name: "BinanceHODL",
  },
  {
    id: "binanceidr",
    symbol: "bidr",
    name: "BIDR",
  },
  {
    id: "binance-multi-chain-capital",
    symbol: "bmcc",
    name: "Binance Multi-Chain Capital",
  },
  {
    id: "binance-peg-avalanche",
    symbol: "avax",
    name: "Binance-Peg Avalanche",
  },
  {
    id: "binance-peg-bitcoin-cash",
    symbol: "bch",
    name: "Binance-Peg Bitcoin Cash",
  },
  {
    id: "binance-peg-cardano",
    symbol: "ada",
    name: "Binance-Peg Cardano",
  },
  {
    id: "binance-peg-dogecoin",
    symbol: "doge",
    name: "Binance-Peg Dogecoin",
  },
  {
    id: "binance-peg-eos",
    symbol: "eos",
    name: "Binance-Peg EOS",
  },
  {
    id: "binance-peg-filecoin",
    symbol: "fil",
    name: "Binance-Peg Filecoin",
  },
  {
    id: "binance-peg-iotex",
    symbol: "iotx",
    name: "Binance-Peg IoTeX",
  },
  {
    id: "binance-peg-litecoin",
    symbol: "ltc",
    name: "Binance-Peg Litecoin",
  },
  {
    id: "binance-peg-ontology",
    symbol: "ont",
    name: "Binance-Peg Ontology",
  },
  {
    id: "binance-peg-polkadot",
    symbol: "dot",
    name: "Binance-Peg Polkadot",
  },
  {
    id: "binance-peg-xrp",
    symbol: "xrp",
    name: "Binance-Peg XRP",
  },
  {
    id: "binance-smart-chain-girl",
    symbol: "bscgirl",
    name: "Binance Smart Chain Girl",
  },
  {
    id: "binance-usd",
    symbol: "busd",
    name: "Binance USD",
  },
  {
    id: "binance-usd-wormhole",
    symbol: "busdet",
    name: "Binance USD (Wormhole)",
  },
  {
    id: "binance-usd-wormhole-from-bsc",
    symbol: "busdbs",
    name: "Binance USD (Wormhole from BSC)",
  },
  {
    id: "binance-wrapped-btc",
    symbol: "bbtc",
    name: "Binance Wrapped BTC",
  },
  {
    id: "binance-wrapped-dot",
    symbol: "bdot",
    name: "Binance Wrapped DOT",
  },
  {
    id: "binapet",
    symbol: "bpet",
    name: "Binapet",
  },
  {
    id: "binarium",
    symbol: "bin",
    name: "Binarium",
  },
  {
    id: "binary-cat",
    symbol: "kitty",
    name: "Binary Cat",
  },
  {
    id: "binarydao",
    symbol: "byte",
    name: "BinaryDAO",
  },
  {
    id: "binaryx",
    symbol: "bnx",
    name: "BinaryX",
  },
  {
    id: "bincentive",
    symbol: "bcnt",
    name: "Bincentive",
  },
  {
    id: "binemon",
    symbol: "bin",
    name: "Binemon",
  },
  {
    id: "bingdwendwen",
    symbol: "bingdwendwen",
    name: "BingDwenDwen",
  },
  {
    id: "bingo-doge",
    symbol: "bdoge",
    name: "Bingo Doge",
  },
  {
    id: "bingo-game",
    symbol: "bingo",
    name: "Bingo Game",
  },
  {
    id: "bingo-share",
    symbol: "sbgo",
    name: "Bingo Share",
  },
  {
    id: "binjit-coin",
    symbol: "bnj",
    name: "Binjit Coin",
  },
  {
    id: "binom-protocol",
    symbol: "binom",
    name: "Binom Protocol",
  },
  {
    id: "binopoly",
    symbol: "bino",
    name: "Binopoly",
  },
  {
    id: "binspirit",
    symbol: "binspirit",
    name: "binSPIRIT",
  },
  {
    id: "binstarter",
    symbol: "bsr",
    name: "BinStarter",
  },
  {
    id: "bintex-futures",
    symbol: "bntx",
    name: "Bintex Futures",
  },
  {
    id: "biokkoin",
    symbol: "bkkg",
    name: "Biokkoin",
  },
  {
    id: "biometric-financial",
    symbol: "biofi",
    name: "Biometric Financial",
  },
  {
    id: "biopassport",
    symbol: "biot",
    name: "Bio Passport",
  },
  {
    id: "bios",
    symbol: "bios",
    name: "0x_nodes",
  },
  {
    id: "biotron",
    symbol: "btrn",
    name: "Biotron",
  },
  {
    id: "birake",
    symbol: "bir",
    name: "Birake",
  },
  {
    id: "birb",
    symbol: "birb",
    name: "Birb",
  },
  {
    id: "birdchain",
    symbol: "bird",
    name: "Birdchain",
  },
  {
    id: "bird-money",
    symbol: "bird",
    name: "Bird.Money",
  },
  {
    id: "birdy-finance",
    symbol: "bird",
    name: "Birdy Finance",
  },
  {
    id: "bishares",
    symbol: "bison",
    name: "BiShares",
  },
  {
    id: "bishu-finance",
    symbol: "bishufi",
    name: "Bishu Finance",
  },
  {
    id: "bismuth",
    symbol: "bis",
    name: "Bismuth",
  },
  {
    id: "bistroo",
    symbol: "bist",
    name: "Bistroo",
  },
  {
    id: "biswap",
    symbol: "bsw",
    name: "Biswap",
  },
  {
    id: "biswap-token",
    symbol: "biswap",
    name: "Biswap Token",
  },
  {
    id: "bit2me",
    symbol: "b2m",
    name: "Bit2Me",
  },
  {
    id: "bitalgo",
    symbol: "alg",
    name: "Bitalgo",
  },
  {
    id: "bitant",
    symbol: "bitant",
    name: "BitANT",
  },
  {
    id: "bitastir",
    symbol: "bita",
    name: "BitAstir",
  },
  {
    id: "bitau",
    symbol: "bau",
    name: "BitAU",
  },
  {
    id: "bitazza",
    symbol: "btz",
    name: "Bitazza",
  },
  {
    id: "bitball",
    symbol: "btb",
    name: "Bitball",
  },
  {
    id: "bitball-treasure",
    symbol: "btrs",
    name: "Bitball Treasure",
  },
  {
    id: "bitbar",
    symbol: "btb",
    name: "Bitbar",
  },
  {
    id: "bitbase-token",
    symbol: "btbs",
    name: "BitBase BTBS",
  },
  {
    id: "bitberry-token",
    symbol: "bbr",
    name: "Bitberry",
  },
  {
    id: "bitblocks-finance",
    symbol: "bbkfi",
    name: "BitBlocks Finance",
  },
  {
    id: "bitblocks-fire",
    symbol: "bfire",
    name: "Bitblocks Fire",
  },
  {
    id: "bitblocks-project",
    symbol: "bbk",
    name: "BitBlocks",
  },
  {
    id: "bitbook-token",
    symbol: "bbt",
    name: "BitBook",
  },
  {
    id: "bitboost",
    symbol: "bbt",
    name: "BitBoost",
  },
  {
    id: "bitbucks",
    symbol: "bitbucks",
    name: "BitBucks",
  },
  {
    id: "bitcanna",
    symbol: "bcna",
    name: "BitCanna",
  },
  {
    id: "bitcarecoin",
    symbol: "bcare",
    name: "BitCareCoin",
  },
  {
    id: "bitcash",
    symbol: "bitc",
    name: "BitCash",
  },
  {
    id: "bitcashpay-old",
    symbol: "bcp",
    name: "BitcashPay (Old)",
  },
  {
    id: "bit-castle-war",
    symbol: "bcw",
    name: "Bit Castle War",
  },
  {
    id: "bitceo",
    symbol: "bceo",
    name: "bitCEO",
  },
  {
    id: "bitcherry",
    symbol: "bchc",
    name: "BitCherry",
  },
  {
    id: "bitcicoin",
    symbol: "bitci",
    name: "Bitcicoin",
  },
  {
    id: "bitclave",
    symbol: "cat",
    name: "BitClave",
  },
  {
    id: "bitcloud",
    symbol: "btdx",
    name: "Bitcloud",
  },
  {
    id: "bitclout",
    symbol: "deso",
    name: "Decentralized Social",
  },
  {
    id: "bitcny",
    symbol: "bitcny",
    name: "bitCNY",
  },
  {
    id: "bitcoffeen",
    symbol: "bff",
    name: "Bitcoffeen",
  },
  {
    id: "bitcoin",
    symbol: "btc",
    name: "Bitcoin",
  },
  {
    id: "bitcoin-2",
    symbol: "btc2",
    name: "Bitcoin 2",
  },
  {
    id: "bitcoin-adult",
    symbol: "btad",
    name: "Bitcoin Adult",
  },
  {
    id: "bitcoin-and-ethereum-standard-token",
    symbol: "best",
    name: "Bitcoin and Ethereum Standard",
  },
  {
    id: "bitcoin-anonymous",
    symbol: "btca",
    name: "Bitcoin Anonymous",
  },
  {
    id: "bitcoin-asia",
    symbol: "btca",
    name: "Bitcoin Asia",
  },
  {
    id: "bitcoin-asset",
    symbol: "bta",
    name: "Bitcoin Asset (Old)",
  },
  {
    id: "bitcoin-asset-2",
    symbol: "bta",
    name: "Bitcoin Asset",
  },
  {
    id: "bitcoin-atom",
    symbol: "bca",
    name: "Bitcoin Atom",
  },
  {
    id: "bitcoinbam",
    symbol: "btcbam",
    name: "BitcoinBam",
  },
  {
    id: "bitcoin-bep2",
    symbol: "btcb",
    name: "Bitcoin BEP2",
  },
  {
    id: "bitcoin-br",
    symbol: "btcbr",
    name: "Bitcoin BR",
  },
  {
    id: "bitcoinbrand",
    symbol: "btcb",
    name: "BitcoinBrand",
  },
  {
    id: "bitcoin-cash",
    symbol: "bch",
    name: "Bitcoin Cash",
  },
  {
    id: "bitcoin-cash-sv",
    symbol: "bsv",
    name: "Bitcoin SV",
  },
  {
    id: "bitcoin-city-coin",
    symbol: "bcity",
    name: "Bitcoin City Coin",
  },
  {
    id: "bitcoin-confidential",
    symbol: "bc",
    name: "Bitcoin Confidential",
  },
  {
    id: "bitcoin-cure",
    symbol: "byron",
    name: "Byron",
  },
  {
    id: "bitcoin-diamond",
    symbol: "bcd",
    name: "Bitcoin Diamond",
  },
  {
    id: "bitcoin-fast",
    symbol: "bcf",
    name: "Bitcoin Fast",
  },
  {
    id: "bitcoin-final",
    symbol: "btcf",
    name: "Bitcoin Final",
  },
  {
    id: "bitcoin-free-cash",
    symbol: "bfc",
    name: "Bitcoin Free Cash",
  },
  {
    id: "bitcoin-god",
    symbol: "god",
    name: "Bitcoin God",
  },
  {
    id: "bitcoin-gold",
    symbol: "btg",
    name: "Bitcoin Gold",
  },
  {
    id: "bitcoin-green",
    symbol: "bitg",
    name: "Bitcoin Green",
  },
  {
    id: "bitcoin-hd",
    symbol: "bhd",
    name: "Bitcoin HD",
  },
  {
    id: "bitcoin-hot",
    symbol: "bth",
    name: "Bitcoin Hot",
  },
  {
    id: "bitcoin-instant",
    symbol: "bti",
    name: "Bitcoin Instant",
  },
  {
    id: "bitcoin-international",
    symbol: "btci",
    name: "Bitcoin International",
  },
  {
    id: "bitcoin-latinum",
    symbol: "ltnm",
    name: "Bitcoin Latinum",
  },
  {
    id: "bitcoinlegend",
    symbol: "bcl",
    name: "BitcoinLegend",
  },
  {
    id: "bitcoin-lightning",
    symbol: "bltg",
    name: "Block-Logic",
  },
  {
    id: "bitcoin-metaverse",
    symbol: "bitmeta",
    name: "Bitcoin Metaverse",
  },
  {
    id: "bitcoinmoney",
    symbol: "bcm",
    name: "BitcoinMoney",
  },
  {
    id: "bitcoinmono",
    symbol: "btcmz",
    name: "BitcoinMono",
  },
  {
    id: "bitcoin-networks",
    symbol: "btcn",
    name: "Bitcoin Networks",
  },
  {
    id: "bitcoin-one",
    symbol: "btcone",
    name: "BitCoin One",
  },
  {
    id: "bitcoin-pay",
    symbol: "btp",
    name: "Bitcoin Pay",
  },
  {
    id: "bitcoin-plus",
    symbol: "xbc",
    name: "Bitcoin Plus",
  },
  {
    id: "bitcoinprint",
    symbol: "btcp",
    name: "BitcoinPrint",
  },
  {
    id: "bitcoin-private",
    symbol: "btcp",
    name: "Bitcoin Private",
  },
  {
    id: "bitcoin-pro",
    symbol: "btcp",
    name: "Bitcoin Pro",
  },
  {
    id: "bitcoin-red",
    symbol: "btcred",
    name: "Bitcoin Red",
  },
  {
    id: "bitcoinregular",
    symbol: "btrl",
    name: "BitcoinRegular",
  },
  {
    id: "bitcoin-rhodium",
    symbol: "xrc",
    name: "xRhodium",
  },
  {
    id: "bitcoin-scrypt",
    symbol: "btcs",
    name: "Bitcoin Scrypt",
  },
  {
    id: "bitcoinsov",
    symbol: "bsov",
    name: "BitcoinSoV",
  },
  {
    id: "bitcoinstaking",
    symbol: "bsk",
    name: "BitcoinStaking",
  },
  {
    id: "bitcoin-stash",
    symbol: "bsh",
    name: "Bitcoin Stash",
  },
  {
    id: "bitcoin-subsidium",
    symbol: "xbtx",
    name: "Bitcoin Subsidium",
  },
  {
    id: "bitcoin-token",
    symbol: "btct",
    name: "BitcoinToken",
  },
  {
    id: "bitcoin-trc20",
    symbol: "btct",
    name: "Bitcoin TRC20",
  },
  {
    id: "bitcoin-trust",
    symbol: "bct",
    name: "Bitcoin Trust",
  },
  {
    id: "bitcoin-ultra",
    symbol: "btcu",
    name: "BitcoinUltra",
  },
  {
    id: "bitcoinv",
    symbol: "btcv",
    name: "BitcoinV",
  },
  {
    id: "bitcoin-vault",
    symbol: "btcv",
    name: "Bitcoin Vault",
  },
  {
    id: "bitcoinvend",
    symbol: "bcvt",
    name: "BitcoinVend",
  },
  {
    id: "bitcoinx",
    symbol: "bcx",
    name: "BitcoinX",
  },
  {
    id: "bitcoinx-2",
    symbol: "btcx",
    name: "BitcoinXGames",
  },
  {
    id: "bitcoinz",
    symbol: "btcz",
    name: "BitcoinZ",
  },
  {
    id: "bitcoiva",
    symbol: "bca",
    name: "Bitcoiva",
  },
  {
    id: "bitcoke",
    symbol: "coke",
    name: "BitCoke",
  },
  {
    id: "bitcolojix",
    symbol: "btcix",
    name: "BITCOLOJIX",
  },
  {
    id: "bitcomine",
    symbol: "bme",
    name: "BitcoMine",
  },
  {
    id: "bitcomo",
    symbol: "bm",
    name: "Bitcomo",
  },
  {
    id: "bitconnect",
    symbol: "bcc",
    name: "Bitconnect",
  },
  {
    id: "bitconnectx-genesis",
    symbol: "bccx",
    name: "BCCXGenesis",
  },
  {
    id: "bitcore",
    symbol: "btx",
    name: "BitCore",
  },
  {
    id: "bitcrex-coin",
    symbol: "bic",
    name: "Bitcrex Coin",
  },
  {
    id: "bitcrush",
    symbol: "crush",
    name: "Bitcrush",
  },
  {
    id: "bitcurate",
    symbol: "btcr",
    name: "Bitcurate",
  },
  {
    id: "bitdao",
    symbol: "bit",
    name: "BitDAO",
  },
  {
    id: "bitdegree",
    symbol: "bdg",
    name: "BitDegree",
  },
  {
    id: "bitecoin",
    symbol: "$bitc",
    name: "Bitecoin",
  },
  {
    id: "bit-ecological-digital",
    symbol: "bed",
    name: "Bit Ecological Digital",
  },
  {
    id: "bitenium-token",
    symbol: "bt",
    name: "Bitenium",
  },
  {
    id: "bitfari",
    symbol: "fari",
    name: "Bitfari",
  },
  {
    id: "bitfex-2",
    symbol: "bce",
    name: "Bitfex",
  },
  {
    id: "bit_financial",
    symbol: "bfc",
    name: "Bit Financial",
  },
  {
    id: "bitflowers",
    symbol: "petal",
    name: "bitFlowers",
  },
  {
    id: "bitforex",
    symbol: "bf",
    name: "Bitforex",
  },
  {
    id: "bitfresh",
    symbol: "bft",
    name: "Bitfresh",
  },
  {
    id: "bitgear",
    symbol: "gear",
    name: "Bitgear",
  },
  {
    id: "bitgem",
    symbol: "xbtg",
    name: "Bitgem",
  },
  {
    id: "bitgesell",
    symbol: "bgl",
    name: "Bitgesell",
  },
  {
    id: "bitget-token",
    symbol: "bgb",
    name: "Bitget",
  },
  {
    id: "bitguild",
    symbol: "plat",
    name: "BitGuild PLAT",
  },
  {
    id: "bithachi",
    symbol: "bith",
    name: "Bithachi",
  },
  {
    id: "bithashex",
    symbol: "bhax",
    name: "Bithashex",
  },
  {
    id: "bithash-token",
    symbol: "bt",
    name: "BitHash",
  },
  {
    id: "bithostcoin",
    symbol: "bih",
    name: "BitHostCoin",
  },
  {
    id: "bit-hotel",
    symbol: "bth",
    name: "Bit Hotel",
  },
  {
    id: "bitica-coin",
    symbol: "bdcc",
    name: "BITICA COIN",
  },
  {
    id: "bitjob",
    symbol: "stu",
    name: "bitJob",
  },
  {
    id: "bitkub-coin",
    symbol: "kub",
    name: "Bitkub Coin",
  },
  {
    id: "bitliberte",
    symbol: "liberte",
    name: "Bitliberte",
  },
  {
    id: "bitlive",
    symbol: "blt",
    name: "BITLIVE",
  },
  {
    id: "bitlocus",
    symbol: "btl",
    name: "Bitlocus",
  },
  {
    id: "bitlorrent",
    symbol: "blt",
    name: "Bitlorrent",
  },
  {
    id: "bitmark",
    symbol: "marks",
    name: "Bitmark",
  },
  {
    id: "bitmart-token",
    symbol: "bmx",
    name: "BitMart",
  },
  {
    id: "bitmax-coin",
    symbol: "bmx",
    name: "Bitmax Coin",
  },
  {
    id: "bitmex-token",
    symbol: "bmex",
    name: "BitMEX",
  },
  {
    id: "bitmic",
    symbol: "bmic",
    name: "Bitmic",
  },
  {
    id: "bit-miner-chain",
    symbol: "btmc",
    name: "Bit Miner Chain",
  },
  {
    id: "bitmon",
    symbol: "bit",
    name: "Bitmon",
  },
  {
    id: "bitmoney",
    symbol: "bit",
    name: "BitMoney",
  },
  {
    id: "bitnautic",
    symbol: "btnt",
    name: "BitNautic",
  },
  {
    id: "bitnorm",
    symbol: "bn",
    name: "Bitnorm",
  },
  {
    id: "bito-coin",
    symbol: "bito",
    name: "BITO Coin",
  },
  {
    id: "bitone",
    symbol: "bio",
    name: "BITONE",
  },
  {
    id: "bitonyx-token",
    symbol: "btnyx",
    name: "BitOnyx",
  },
  {
    id: "bitorbit",
    symbol: "bitorb",
    name: "BitOrbit",
  },
  {
    id: "bitpaid-token",
    symbol: "btp",
    name: "Bitpaid",
  },
  {
    id: "bitpanda-ecosystem-token",
    symbol: "best",
    name: "Bitpanda Ecosystem",
  },
  {
    id: "bit-public-talent-network",
    symbol: "bptn",
    name: "Bit Public Talent Network",
  },
  {
    id: "bitradio",
    symbol: "bro",
    name: "Bitradio",
  },
  {
    id: "bitrent",
    symbol: "rntb",
    name: "BitRent",
  },
  {
    id: "bit-rides",
    symbol: "rides",
    name: "Bit Rides",
  },
  {
    id: "bitrise-token",
    symbol: "brise",
    name: "Bitgert",
  },
  {
    id: "bitriver",
    symbol: "btr",
    name: "Bitriver",
  },
  {
    id: "bitroncoin",
    symbol: "btrn",
    name: "BitronCoin",
  },
  {
    id: "bitrue-token",
    symbol: "btr",
    name: "Bitrue Coin",
  },
  {
    id: "bitscreener",
    symbol: "bitx",
    name: "BitScreener",
  },
  {
    id: "bitshares",
    symbol: "bts",
    name: "BitShares",
  },
  {
    id: "bitshark",
    symbol: "btshk",
    name: "Bitshark",
  },
  {
    id: "bitshiba",
    symbol: "shiba",
    name: "BitShiba",
  },
  {
    id: "bitsol-finance",
    symbol: "btsl",
    name: "Bitsol Finance",
  },
  {
    id: "bitsong",
    symbol: "btsg",
    name: "BitSong",
  },
  {
    id: "bitsonic-token",
    symbol: "bsc",
    name: "Bitsonic",
  },
  {
    id: "bitspawn",
    symbol: "spwn",
    name: "Bitspawn",
  },
  {
    id: "bitstake",
    symbol: "xbs",
    name: "BitStake",
  },
  {
    id: "bitsten-token",
    symbol: "bst",
    name: "Bitsten",
  },
  {
    id: "bit-store-coin",
    symbol: "store",
    name: "Bit Store",
  },
  {
    id: "bitsubishi",
    symbol: "bitsu",
    name: "Bitsubishi",
  },
  {
    id: "bitsum",
    symbol: "mat",
    name: "Matka",
  },
  {
    id: "bitswift",
    symbol: "bits",
    name: "Bitswift",
  },
  {
    id: "bitto-exchange",
    symbol: "bitto",
    name: "BITTO",
  },
  {
    id: "bittoken",
    symbol: "bitt",
    name: "BITT",
  },
  {
    id: "bittokens",
    symbol: "bxt",
    name: "BitTokens",
  },
  {
    id: "bittorrent",
    symbol: "btt",
    name: "BitTorrent",
  },
  {
    id: "bittorrent-old",
    symbol: "bttold",
    name: "BitTorrent [OLD]",
  },
  {
    id: "bittracksystems",
    symbol: "bttr",
    name: "BittrackSystems",
  },
  {
    id: "bittube",
    symbol: "tube",
    name: "BitTube",
  },
  {
    id: "bittwatt",
    symbol: "bwt",
    name: "Bittwatt",
  },
  {
    id: "bitup",
    symbol: "bitup",
    name: "BitUp",
  },
  {
    id: "bitup-token",
    symbol: "but",
    name: "BitUP BUT",
  },
  {
    id: "bitvalley",
    symbol: "bitv",
    name: "BitValley",
  },
  {
    id: "bitvalve-2",
    symbol: "btv",
    name: "BitValve",
  },
  {
    id: "bitvote",
    symbol: "btv",
    name: "Bitvote",
  },
  {
    id: "bitweb",
    symbol: "bte",
    name: "Bitweb",
  },
  {
    id: "bitwell-token",
    symbol: "well",
    name: "Bitwell",
  },
  {
    id: "bitwhite",
    symbol: "btw",
    name: "BitWhite",
  },
  {
    id: "bitwin24",
    symbol: "bwi",
    name: "Bitwin24",
  },
  {
    id: "bitz",
    symbol: "bitz",
    name: "bitz",
  },
  {
    id: "bitzeny",
    symbol: "zny",
    name: "BitZeny",
  },
  {
    id: "bixb-coin",
    symbol: "bixb",
    name: "BixB Coin",
  },
  {
    id: "bixcpro",
    symbol: "bixcpro",
    name: "BIXCPRO",
  },
  {
    id: "bizzcoin",
    symbol: "bizz",
    name: "BIZZCOIN",
  },
  {
    id: "bkex-token",
    symbol: "bkk",
    name: "BKEX Chain",
  },
  {
    id: "bking-finance",
    symbol: "bkf",
    name: "BKING Finance",
  },
  {
    id: "blackcoin",
    symbol: "blk",
    name: "BlackCoin",
  },
  {
    id: "black-diamond",
    symbol: "diamonds",
    name: "Black Diamond",
  },
  {
    id: "blackdragon-token",
    symbol: "bdt",
    name: "BlackDragon",
  },
  {
    id: "black-eye-galaxy",
    symbol: "byg",
    name: "Black Eye Galaxy",
  },
  {
    id: "blackhat-coin",
    symbol: "blkc",
    name: "BlackHat Coin",
  },
  {
    id: "blackholedao",
    symbol: "bho",
    name: "BlackHoleDAO",
  },
  {
    id: "blackhole-protocol",
    symbol: "black",
    name: "BlackHole Protocol",
  },
  {
    id: "blackholeswap-compound-dai-usdc",
    symbol: "bhsc",
    name: "BlackHoleSwap-Compound DAI/USDC",
  },
  {
    id: "black-label",
    symbol: "klb",
    name: "Black Label",
  },
  {
    id: "blackmoon-crypto",
    symbol: "bmc",
    name: "Blackmoon Crypto",
  },
  {
    id: "blacknet",
    symbol: "bln",
    name: "Blacknet",
  },
  {
    id: "blackpearl-chain",
    symbol: "bplc",
    name: "BlackPearl",
  },
  {
    id: "black-phoenix",
    symbol: "bpx",
    name: "Black Phoenix",
  },
  {
    id: "blackpoker",
    symbol: "bpkr",
    name: "BlackPoker",
  },
  {
    id: "blackpool-token",
    symbol: "bpt",
    name: "BlackPool",
  },
  {
    id: "black-shiba",
    symbol: "bshib",
    name: "Black Shiba",
  },
  {
    id: "black-whale",
    symbol: "blk",
    name: "Black Whale",
  },
  {
    id: "blanc",
    symbol: "blanc",
    name: "Blanc",
  },
  {
    id: "blank",
    symbol: "blank",
    name: "BlockWallet",
  },
  {
    id: "blast",
    symbol: "blast",
    name: "BLAST",
  },
  {
    id: "blazar",
    symbol: "blazar",
    name: "BLAZAR",
  },
  {
    id: "blaze-network",
    symbol: "blzn",
    name: "Blaze Network",
  },
  {
    id: "blind-boxes",
    symbol: "bles",
    name: "Blind Boxes",
  },
  {
    id: "blink",
    symbol: "blk",
    name: "BLink",
  },
  {
    id: "blin-metaverse",
    symbol: "blin",
    name: "Blin Metaverse",
  },
  {
    id: "blitz-labs",
    symbol: "blitz",
    name: "Blitz Labs",
  },
  {
    id: "blitzpredict",
    symbol: "xbp",
    name: "BlitzPick",
  },
  {
    id: "blizzard",
    symbol: "xblzd",
    name: "Blizzard",
  },
  {
    id: "blizzard-network",
    symbol: "blizz",
    name: "Blizzard Network",
  },
  {
    id: "blizz-finance",
    symbol: "blzz",
    name: "Blizz Finance",
  },
  {
    id: "blocery",
    symbol: "bly",
    name: "Blocery",
  },
  {
    id: "block-18",
    symbol: "18c",
    name: "Block 18",
  },
  {
    id: "block2play",
    symbol: "b2p",
    name: "Block2Play",
  },
  {
    id: "block-ape-scissors",
    symbol: "bas",
    name: "Block Ape Scissors",
  },
  {
    id: "blockasset",
    symbol: "block",
    name: "Blockasset",
  },
  {
    id: "blockbank",
    symbol: "bbank",
    name: "BlockBank",
  },
  {
    id: "blockbase",
    symbol: "bbt",
    name: "BlockBase",
  },
  {
    id: "blockblend",
    symbol: "bbl",
    name: "BlockBlend",
  },
  {
    id: "blockburn",
    symbol: "burn",
    name: "BlockBurn",
  },
  {
    id: "blockcdn",
    symbol: "bcdn",
    name: "BlockCDN",
  },
  {
    id: "blockchain-adventurers-guild",
    symbol: "bag",
    name: "Blockchain Adventurers Guild",
  },
  {
    id: "blockchain-based-distributed-super-computing-platform",
    symbol: "mbcc",
    name: "Blockchain-Based Distributed Super Computing Platform",
  },
  {
    id: "blockchain-brawlers",
    symbol: "brwl",
    name: "Blockchain Brawlers",
  },
  {
    id: "blockchain-certified-data-token",
    symbol: "bcdt",
    name: "EvidenZ",
  },
  {
    id: "blockchain-cuties-universe",
    symbol: "cute",
    name: "Blockchain Cuties Universe",
  },
  {
    id: "blockchain-cuties-universe-governance",
    symbol: "bcug",
    name: "Blockchain Cuties Universe Governance",
  },
  {
    id: "blockchain-euro-project",
    symbol: "bepr",
    name: "Blockchain Euro Project",
  },
  {
    id: "blockchain-exchange-alliance",
    symbol: "bxa",
    name: "Blockchain Exchange Alliance",
  },
  {
    id: "blockchain-monster-hunt",
    symbol: "bcmc",
    name: "Blockchain Monster Hunt",
  },
  {
    id: "blockchain-of-hash-power",
    symbol: "bhp",
    name: "Blockchain of Hash Power",
  },
  {
    id: "blockchainpoland",
    symbol: "bcp",
    name: "BlockchainPoland",
  },
  {
    id: "blockchain-protocol",
    symbol: "protocol",
    name: "Blockchain Protocol",
  },
  {
    id: "blockchain-quotations-index-token",
    symbol: "bqt",
    name: "Blockchain Quotations Index",
  },
  {
    id: "blockchainspace",
    symbol: "guild",
    name: "BlockchainSpace",
  },
  {
    id: "block-commerce-protocol",
    symbol: "bcp",
    name: "Block Commerce Protocol",
  },
  {
    id: "block-creatures",
    symbol: "moolah",
    name: "Block Creatures",
  },
  {
    id: "blockfilesystem",
    symbol: "bfs",
    name: "BlockFileSystem",
  },
  {
    id: "block-forest",
    symbol: "bft",
    name: "Block Forest",
  },
  {
    id: "blockidcoin",
    symbol: "bid",
    name: "Blockidcoin",
  },
  {
    id: "blockify-games",
    symbol: "blockify",
    name: "Blockify.Games",
  },
  {
    id: "blockmason-credit-protocol",
    symbol: "bcpt",
    name: "Blockmason Credit Protocol",
  },
  {
    id: "blockmason-link",
    symbol: "blink",
    name: "BlockMason Link",
  },
  {
    id: "blockmax",
    symbol: "ocb",
    name: "BLOCKMAX",
  },
  {
    id: "blockmesh-2",
    symbol: "bmh",
    name: "BlockMesh",
  },
  {
    id: "blockmine",
    symbol: "gold nugget",
    name: "Blockmine",
  },
  {
    id: "block-monsters",
    symbol: "mnstrs",
    name: "Block Monsters",
  },
  {
    id: "blocknet",
    symbol: "block",
    name: "Blocknet",
  },
  {
    id: "blocknotex",
    symbol: "bnox",
    name: "BlockNoteX",
  },
  {
    id: "blockpad",
    symbol: "blos",
    name: "Blockius",
  },
  {
    id: "blockpass",
    symbol: "pass",
    name: "Blockpass",
  },
  {
    id: "blockport",
    symbol: "bux",
    name: "BUX",
  },
  {
    id: "blocks",
    symbol: "blocks",
    name: "BLOCKS",
  },
  {
    id: "blocksmith-labs-forge",
    symbol: "$forge",
    name: "Blocksmith Labs Forge",
  },
  {
    id: "blockspace-token",
    symbol: "bls",
    name: "Blocks Space",
  },
  {
    id: "blocksport",
    symbol: "bspt",
    name: "Blocksport",
  },
  {
    id: "blocksquare",
    symbol: "bst",
    name: "Blocksquare",
  },
  {
    id: "blockstack",
    symbol: "stx",
    name: "Stacks",
  },
  {
    id: "blockstamp",
    symbol: "bst",
    name: "BlockStamp",
  },
  {
    id: "blockster",
    symbol: "bxr",
    name: "Blockster",
  },
  {
    id: "blockstream-mining-notes",
    symbol: "bmn",
    name: "BlockStream Mining Notes",
  },
  {
    id: "blockswap-network",
    symbol: "cbsn",
    name: "BlockSwap Network",
  },
  {
    id: "blocktanium",
    symbol: "bkt",
    name: "Blocktanium",
  },
  {
    id: "blocktix",
    symbol: "tix",
    name: "Blocktix",
  },
  {
    id: "blocktyme",
    symbol: "btym",
    name: "Blocktyme",
  },
  {
    id: "blockv",
    symbol: "vee",
    name: "BLOCKv",
  },
  {
    id: "blockwarrior",
    symbol: "blwa",
    name: "BlockWarrior",
  },
  {
    id: "blockwrk",
    symbol: "wrk",
    name: "BlockWRK",
  },
  {
    id: "bloc-money",
    symbol: "bloc",
    name: "Bloc.Money",
  },
  {
    id: "blocsport-one",
    symbol: "bls",
    name: "blocsport.one",
  },
  {
    id: "blocto-token",
    symbol: "blt",
    name: "Blocto",
  },
  {
    id: "bloggercoin",
    symbol: "blogger",
    name: "Bloggercoin",
  },
  {
    id: "blokpad",
    symbol: "bpad",
    name: "BlokPad",
  },
  {
    id: "bloktopia",
    symbol: "blok",
    name: "Bloktopia",
  },
  {
    id: "blood-token",
    symbol: "blood",
    name: "Blood Nodes",
  },
  {
    id: "bloom",
    symbol: "blt",
    name: "Bloom",
  },
  {
    id: "bloom-token",
    symbol: "bloom",
    name: "Tulip Dao Bloom",
  },
  {
    id: "bloomzed-token",
    symbol: "blct",
    name: "Bloomzed Loyalty Club Ticket",
  },
  {
    id: "blossomcoin",
    symbol: "blosm",
    name: "BlossomCoin",
  },
  {
    id: "blowup",
    symbol: "$blow",
    name: "BlowUP",
  },
  {
    id: "blox",
    symbol: "cdt",
    name: "Blox",
  },
  {
    id: "bloxmove-erc20",
    symbol: "blxm",
    name: "bloXmove",
  },
  {
    id: "blox-token",
    symbol: "blox",
    name: "Blox SDK",
  },
  {
    id: "bluca",
    symbol: "bluc",
    name: "Bluca",
  },
  {
    id: "blue",
    symbol: "blue",
    name: "Blue Protocol",
  },
  {
    id: "blueark",
    symbol: "brk",
    name: "BlueArk",
  },
  {
    id: "blue-baikal",
    symbol: "bbc",
    name: "Blue Baikal",
  },
  {
    id: "bluebit",
    symbol: "bbt",
    name: "BlueBit",
  },
  {
    id: "bluechip-capital-token",
    symbol: "bcc",
    name: "BlueChip Capital",
  },
  {
    id: "bluechips-token",
    symbol: "bchip",
    name: "BLUECHIPS",
  },
  {
    id: "bluecoin",
    symbol: "blu",
    name: "Bluecoin",
  },
  {
    id: "blue-earth-protocol",
    symbol: "bep",
    name: "Blue Earth Protocol",
  },
  {
    id: "bluefi",
    symbol: "bleu",
    name: "BleuFi",
  },
  {
    id: "bluefincore",
    symbol: "bfc",
    name: "Bluefincore",
  },
  {
    id: "blue-gold",
    symbol: "blg",
    name: "Blue Gold",
  },
  {
    id: "blue-horizon",
    symbol: "blh",
    name: "Blue Horizon",
  },
  {
    id: "blueshift",
    symbol: "blues",
    name: "Blueshift",
  },
  {
    id: "bluesparrow-token",
    symbol: "bluesparrow",
    name: "BlueSparrow",
  },
  {
    id: "blue-whale",
    symbol: "bwx",
    name: "Blue Whale",
  },
  {
    id: "bluewizard",
    symbol: "wiz",
    name: "BlueWizard",
  },
  {
    id: "blurt",
    symbol: "blurt",
    name: "Blurt",
  },
  {
    id: "bluzelle",
    symbol: "blz",
    name: "Bluzelle",
  },
  {
    id: "bmchain-token",
    symbol: "bmt",
    name: "BMCHAIN",
  },
  {
    id: "bnb48-club-token",
    symbol: "koge",
    name: "BNB48 Club",
  },
  {
    id: "bnb-axis",
    symbol: "baxis",
    name: "BNB Axis",
  },
  {
    id: "bnbback",
    symbol: "bnbback",
    name: "BNBBack",
  },
  {
    id: "bnb-bank",
    symbol: "bbk",
    name: "BNB Bank",
  },
  {
    id: "bnb-chain-all-best-ico",
    symbol: "bnballbi",
    name: "BNB CHAIN ALL BEST ICO",
  },
  {
    id: "bnbdefi",
    symbol: "$defi",
    name: "BNBDeFi",
  },
  {
    id: "bnb-diamond",
    symbol: "bnbd",
    name: "BNB Diamond",
  },
  {
    id: "bnb-dragon",
    symbol: "bnbdragon",
    name: "BnB Dragon",
  },
  {
    id: "bnbglobal-v2",
    symbol: "bnbg",
    name: "BNBGlobal V2",
  },
  {
    id: "bnbheroes-token",
    symbol: "bnbh",
    name: "BnbHeroes",
  },
  {
    id: "bnbhunter",
    symbol: "bht",
    name: "BNBHunter",
  },
  {
    id: "bnbrise",
    symbol: "brise",
    name: "BNBRise",
  },
  {
    id: "bnb-shinobi",
    symbol: "chakra",
    name: "BNB Shinobi",
  },
  {
    id: "bnb-superheroes",
    symbol: "bsh",
    name: "BNB Superheroes",
  },
  {
    id: "bnbtiger",
    symbol: "bnbtiger",
    name: "BNBTiger",
  },
  {
    id: "bnbx-finance",
    symbol: "bnbx",
    name: "BNBX Finance",
  },
  {
    id: "bnext-b3x",
    symbol: "b3x",
    name: "Bnext B3X",
  },
  {
    id: "bnftx-token",
    symbol: "bnftt",
    name: "BNFTX",
  },
  {
    id: "bnktothefuture",
    symbol: "bft",
    name: "BnkToTheFuture",
  },
  {
    id: "b-non-fungible-yearn",
    symbol: "bnfy",
    name: "B Non-Fungible Yearn",
  },
  {
    id: "bnpl-pay",
    symbol: "bnpl",
    name: "BNPL Pay",
  },
  {
    id: "bnsd-finance",
    symbol: "bnsd",
    name: "BNSD Finance",
  },
  {
    id: "bns-token",
    symbol: "bns",
    name: "BNS",
  },
  {
    id: "bns-token-old",
    symbol: "bns",
    name: "BNS Token [OLD]",
  },
  {
    id: "bnx-finex",
    symbol: "bnx",
    name: "Bnx Finex",
  },
  {
    id: "boba-brewery",
    symbol: "bre",
    name: "Boba Brewery",
  },
  {
    id: "bobadoge",
    symbol: "bdoge",
    name: "BobaDoge",
  },
  {
    id: "boba-network",
    symbol: "boba",
    name: "Boba Network",
  },
  {
    id: "bobatama",
    symbol: "boba",
    name: "Bobamask",
  },
  {
    id: "bobcoin",
    symbol: "bobc",
    name: "Bobcoin",
  },
  {
    id: "bobo-cash",
    symbol: "bobo",
    name: "Bobo Cash",
  },
  {
    id: "bobs_repair",
    symbol: "bob",
    name: "Bob's Repair",
  },
  {
    id: "boda-token",
    symbol: "bodav2",
    name: "BODA",
  },
  {
    id: "bodhi-network",
    symbol: "nbot",
    name: "Bodhi Network",
  },
  {
    id: "bofb",
    symbol: "bofb",
    name: "bofb",
  },
  {
    id: "bogged-finance",
    symbol: "bog",
    name: "Bogged Finance",
  },
  {
    id: "bogged-finance-[old]",
    symbol: "bog",
    name: "Bogged Finance [OLD]",
  },
  {
    id: "bohr",
    symbol: "br",
    name: "BoHr [OLD]",
  },
  {
    id: "bohr-2",
    symbol: "br",
    name: "BoHr",
  },
  {
    id: "boid",
    symbol: "boid",
    name: "Boid",
  },
  {
    id: "boji",
    symbol: "boji",
    name: "Boji",
  },
  {
    id: "boku",
    symbol: "boku",
    name: "Boryoku Dragonz",
  },
  {
    id: "bold-point",
    symbol: "bpt",
    name: "Bold Point",
  },
  {
    id: "boletoken",
    symbol: "bole",
    name: "Bole",
  },
  {
    id: "bole-token",
    symbol: "bole",
    name: "Boleld",
  },
  {
    id: "bolide",
    symbol: "blid",
    name: "Bolide",
  },
  {
    id: "boliecoin",
    symbol: "bolc",
    name: "Boliecoin",
  },
  {
    id: "bolivarcoin",
    symbol: "boli",
    name: "Bolivarcoin",
  },
  {
    id: "bollycoin",
    symbol: "bolly",
    name: "BollyCoin",
  },
  {
    id: "bologna-fc-fan-token",
    symbol: "bfc",
    name: "Bologna FC Fan Token",
  },
  {
    id: "bolt",
    symbol: "bolt",
    name: "Bolt",
  },
  {
    id: "boltt-coin",
    symbol: "boltt",
    name: "BolttCoin",
  },
  {
    id: "bolt-true-dollar",
    symbol: "btd",
    name: "Bolt Dollar",
  },
  {
    id: "bolt-true-share",
    symbol: "bts",
    name: "Bolt Share",
  },
  {
    id: "bomb",
    symbol: "bomb",
    name: "BOMB",
  },
  {
    id: "bomber-coin",
    symbol: "bcoin",
    name: "Bomber Coin",
  },
  {
    id: "bomberman",
    symbol: "$bomb",
    name: "Bomberman",
  },
  {
    id: "bomb-money",
    symbol: "bomb",
    name: "Bomb Money",
  },
  {
    id: "bomb-money-bshare",
    symbol: "bshare",
    name: "Bomb Money BShare",
  },
  {
    id: "bondappetite-usd",
    symbol: "usdap",
    name: "BondAppetite USD",
  },
  {
    id: "bondappetit-gov-token",
    symbol: "bag",
    name: "BondAppetit Governance",
  },
  {
    id: "bonded-luna",
    symbol: "bluna",
    name: "Bonded Luna",
  },
  {
    id: "bondly",
    symbol: "bondly",
    name: "Forj",
  },
  {
    id: "bondtoearn",
    symbol: "bte",
    name: "BondToEarn",
  },
  {
    id: "bone",
    symbol: "bone",
    name: "Bone [OLD]",
  },
  {
    id: "bone-2",
    symbol: "bone",
    name: "Bone",
  },
  {
    id: "b-one-payment",
    symbol: "b1p",
    name: "B ONE PAYMENT",
  },
  {
    id: "bone-shibaswap",
    symbol: "bone",
    name: "Bone ShibaSwap",
  },
  {
    id: "bonezyard",
    symbol: "bnz",
    name: "BonezYard",
  },
  {
    id: "bonfi",
    symbol: "bnf",
    name: "BonFi",
  },
  {
    id: "bonfida",
    symbol: "fida",
    name: "Bonfida",
  },
  {
    id: "bonfire",
    symbol: "bonfire",
    name: "Bonfire",
  },
  {
    id: "bongweedcoin",
    symbol: "bwc",
    name: "BongWeedCoin",
  },
  {
    id: "bonorum-coin",
    symbol: "bono",
    name: "Bonorum",
  },
  {
    id: "bontecoin",
    symbol: "bonte",
    name: "Bontecoin",
  },
  {
    id: "bonuz",
    symbol: "bonuz",
    name: "Bonuz",
  },
  {
    id: "boobank",
    symbol: "boob",
    name: "BooBank",
  },
  {
    id: "booby-trap",
    symbol: "bbt",
    name: "Booby Trap",
  },
  {
    id: "boocake",
    symbol: "boocake",
    name: "BooCake",
  },
  {
    id: "boo-finance",
    symbol: "boofi",
    name: "Boo Finance",
  },
  {
    id: "boolberry",
    symbol: "bbr",
    name: "BoolBerry",
  },
  {
    id: "boolean",
    symbol: "bool",
    name: "Boolean",
  },
  {
    id: "boo-mirrorworld",
    symbol: "xboo",
    name: "Boo MirrorWorld",
  },
  {
    id: "boom-shiba",
    symbol: "boomshiba",
    name: "Boom Shiba",
  },
  {
    id: "boomspace",
    symbol: "space",
    name: "BoomSpace",
  },
  {
    id: "boom-token",
    symbol: "boom",
    name: "Boom",
  },
  {
    id: "boorio",
    symbol: "orio",
    name: "Boorio",
  },
  {
    id: "boost",
    symbol: "boost",
    name: "Boost",
  },
  {
    id: "boosted-finance",
    symbol: "boost",
    name: "Boosted Finance",
  },
  {
    id: "booster",
    symbol: "boo",
    name: "Booster",
  },
  {
    id: "boosto",
    symbol: "bst",
    name: "BOOSTO",
  },
  {
    id: "boozedoge",
    symbol: "bodo",
    name: "BoozeDoge",
  },
  {
    id: "bora",
    symbol: "bora",
    name: "BORA",
  },
  {
    id: "borealis",
    symbol: "brl",
    name: "Borealis",
  },
  {
    id: "bored-ape-social-club",
    symbol: "bape",
    name: "Bored Ape Social Club",
  },
  {
    id: "bored-battle-apes",
    symbol: "bape",
    name: "Bored Battle Apes",
  },
  {
    id: "bored-floki-yacht-club",
    symbol: "bfyc",
    name: "Bored Floki Yacht Club",
  },
  {
    id: "boringdao",
    symbol: "boring",
    name: "BoringDAO",
  },
  {
    id: "boringdao-btc",
    symbol: "obtc",
    name: "BoringDAO BTC",
  },
  {
    id: "boringdao-[old]",
    symbol: "bor",
    name: "BoringDAO [OLD]",
  },
  {
    id: "boring-protocol",
    symbol: "bop",
    name: "Boring Protocol",
  },
  {
    id: "bork",
    symbol: "bork",
    name: "Bork",
  },
  {
    id: "bork-inu",
    symbol: "bork",
    name: "Bork Inu",
  },
  {
    id: "boruto-inu",
    symbol: "boruto",
    name: "Boruto Inu",
  },
  {
    id: "boryoku-genesis-dragonz-index",
    symbol: "drgnz",
    name: "Boryoku Genesis Dragonz Index",
  },
  {
    id: "bosagora",
    symbol: "boa",
    name: "BOSAGORA",
  },
  {
    id: "boson-protocol",
    symbol: "boson",
    name: "Boson Protocol",
  },
  {
    id: "boss",
    symbol: "boss",
    name: "Boss",
  },
  {
    id: "bossswap",
    symbol: "boss",
    name: "Boss Swap",
  },
  {
    id: "bostrom",
    symbol: "boot",
    name: "Bostrom",
  },
  {
    id: "botopiafinance",
    symbol: "btop",
    name: "BotopiaFinance",
  },
  {
    id: "bot-planet",
    symbol: "bot",
    name: "Bot Planet",
  },
  {
    id: "botto",
    symbol: "botto",
    name: "Botto",
  },
  {
    id: "bottos",
    symbol: "bto",
    name: "Bottos",
  },
  {
    id: "botxcoin",
    symbol: "botx",
    name: "BOTXCOIN",
  },
  {
    id: "bountie-hunter",
    symbol: "bountie",
    name: "Bountie Hunter",
  },
  {
    id: "bounty",
    symbol: "bnty",
    name: "Bounty",
  },
  {
    id: "bounty0x",
    symbol: "bnty",
    name: "Bounty0x",
  },
  {
    id: "bountymarketcap",
    symbol: "bmc",
    name: "BountyMarketCap",
  },
  {
    id: "boutspro",
    symbol: "bouts",
    name: "BoutsPro",
  },
  {
    id: "bovineverse",
    symbol: "bvg",
    name: "BovineVerse",
  },
  {
    id: "bowscoin",
    symbol: "bsc",
    name: "BowsCoin",
  },
  {
    id: "box",
    symbol: "box",
    name: "BOX",
  },
  {
    id: "boxaxis",
    symbol: "baxs",
    name: "BoxAxis",
  },
  {
    id: "boxerdoge",
    symbol: "boxerdoge",
    name: "BoxerDOGE",
  },
  {
    id: "boxer-inu",
    symbol: "boxer",
    name: "Boxer Inu",
  },
  {
    id: "box-token",
    symbol: "box",
    name: "BOX Token",
  },
  {
    id: "bozkurt-token",
    symbol: "bt",
    name: "Bozkurt",
  },
  {
    id: "b-protocol",
    symbol: "bpro",
    name: "B.Protocol",
  },
  {
    id: "br34p",
    symbol: "br34p",
    name: "BR34P",
  },
  {
    id: "brainiac",
    symbol: "brains",
    name: "Brainiac",
  },
  {
    id: "braintrust",
    symbol: "btrst",
    name: "Braintrust",
  },
  {
    id: "brandpad-finance",
    symbol: "brand",
    name: "BrandPad Finance",
  },
  {
    id: "brank",
    symbol: "brank",
    name: "Brank",
  },
  {
    id: "bravo-coin",
    symbol: "bravo",
    name: "BravoCoin",
  },
  {
    id: "brazil-fan-token",
    symbol: "bft",
    name: "Brazil Fan Token",
  },
  {
    id: "brcp-token",
    symbol: "brcp",
    name: "BRCP",
  },
  {
    id: "bread",
    symbol: "brd",
    name: "Bread",
  },
  {
    id: "breakout-2",
    symbol: "break",
    name: "Breakout",
  },
  {
    id: "breederdao",
    symbol: "breed",
    name: "BreederDAO",
  },
  {
    id: "breezecoin",
    symbol: "brze",
    name: "Breezecoin",
  },
  {
    id: "brewlabs",
    symbol: "brewlabs",
    name: "Brewlabs",
  },
  {
    id: "bribe",
    symbol: "bribe",
    name: "BRIBE",
  },
  {
    id: "bribe-token-2",
    symbol: "bribe",
    name: "BRIBE Token",
  },
  {
    id: "brick",
    symbol: "brick",
    name: "r/FortNiteBR Bricks",
  },
  {
    id: "brickchain-finance",
    symbol: "brick",
    name: "Brickchain Finance",
  },
  {
    id: "brick-token",
    symbol: "brick",
    name: "Brick",
  },
  {
    id: "bridge",
    symbol: "brg.x",
    name: "Bridge$",
  },
  {
    id: "bridge-mutual",
    symbol: "bmi",
    name: "Bridge Mutual",
  },
  {
    id: "bridge-network",
    symbol: "brdg",
    name: "Bridge Network",
  },
  {
    id: "bridge-oracle",
    symbol: "brg",
    name: "Bridge Oracle",
  },
  {
    id: "bridgesplit-brand-index",
    symbol: "bbi",
    name: "Bridgesplit Brand Index",
  },
  {
    id: "brig-finance",
    symbol: "brig",
    name: "Brig Finance",
  },
  {
    id: "bright-risk-index",
    symbol: "bri",
    name: "Bright Risk Index",
  },
  {
    id: "bright-token",
    symbol: "bright",
    name: "BrightID",
  },
  {
    id: "bright-union",
    symbol: "bright",
    name: "Bright Union",
  },
  {
    id: "bring",
    symbol: "nor",
    name: "Noir",
  },
  {
    id: "bring-finance",
    symbol: "brng",
    name: "bRing.Finance",
  },
  {
    id: "brise-paradise",
    symbol: "prds",
    name: "Brise Paradise",
  },
  {
    id: "britto",
    symbol: "brt",
    name: "Britto",
  },
  {
    id: "brmv-token",
    symbol: "brmv",
    name: "BRMV",
  },
  {
    id: "brn-metaverse",
    symbol: "brn",
    name: "BRN Metaverse",
  },
  {
    id: "brokkr",
    symbol: "bro",
    name: "Brokkr",
  },
  {
    id: "brokoli",
    symbol: "brkl",
    name: "Brokoli",
  },
  {
    id: "broovs-projects",
    symbol: "brs",
    name: "Broovs Projects",
  },
  {
    id: "brother-music-platform",
    symbol: "bmp",
    name: "Brother Music Platform",
  },
  {
    id: "bro-token",
    symbol: "bro",
    name: "Bro",
  },
  {
    id: "browniesswap",
    symbol: "brown",
    name: "BrowniesSwap",
  },
  {
    id: "brz",
    symbol: "brz",
    name: "Brazilian Digital",
  },
  {
    id: "bscarmy",
    symbol: "barmy",
    name: "BscArmy",
  },
  {
    id: "bscbay",
    symbol: "bscb",
    name: "BSCBAY",
  },
  {
    id: "bscbond",
    symbol: "bscb",
    name: "BscBond",
  },
  {
    id: "bsccrop",
    symbol: "bsccrop",
    name: "BSCCrop",
  },
  {
    id: "bscex",
    symbol: "bscx",
    name: "BSCEX",
  },
  {
    id: "bscgold",
    symbol: "bscgold",
    name: "BSCGold",
  },
  {
    id: "bsclaunch",
    symbol: "bsl",
    name: "BSClaunch",
  },
  {
    id: "bsc-memepad",
    symbol: "bscm",
    name: "BSC MemePad",
  },
  {
    id: "bscpad",
    symbol: "bscpad",
    name: "BSCPAD",
  },
  {
    id: "bscshiba",
    symbol: "bshiba",
    name: "bscShiba",
  },
  {
    id: "bscstarter",
    symbol: "start",
    name: "Starter.xyz",
  },
  {
    id: "bsc-station",
    symbol: "bscs",
    name: "BSC Station",
  },
  {
    id: "bscview",
    symbol: "bscv",
    name: "Bscview",
  },
  {
    id: "bscwin-bulls",
    symbol: "bscwin",
    name: "BSCWIN Bulls",
  },
  {
    id: "bsdium",
    symbol: "bscd",
    name: "BSDium",
  },
  {
    id: "bsha3",
    symbol: "bsha3",
    name: "BSHA3",
  },
  {
    id: "bsocial",
    symbol: "bins",
    name: "BSocial",
  },
  {
    id: "bsys",
    symbol: "bsys",
    name: "BSYS",
  },
  {
    id: "btc-2x-flexible-leverage-index",
    symbol: "btc2x-fli",
    name: "BTC 2x Flexible Leverage Index",
  },
  {
    id: "btc-2x-flexible-leverage-index-polygon",
    symbol: "btc2x-fli-p",
    name: "BTC 2x Flexible Leverage Index (Polygon)",
  },
  {
    id: "btc-lite",
    symbol: "btcl",
    name: "BTC Lite",
  },
  {
    id: "btcmoon",
    symbol: "btcm",
    name: "BTCMoon",
  },
  {
    id: "btc-network-demand-set-ii",
    symbol: "byte",
    name: "BTC Network Demand Set II",
  },
  {
    id: "btc-proxy",
    symbol: "btcpx",
    name: "BTC Proxy",
  },
  {
    id: "btc-standard-hashrate-token",
    symbol: "btcst",
    name: "BTC Standard Hashrate Token",
  },
  {
    id: "btecoin",
    symbol: "bte",
    name: "BTEcoin",
  },
  {
    id: "btf",
    symbol: "btf",
    name: "Bitcoin Faith",
  },
  {
    id: "bt-finance",
    symbol: "bt",
    name: "BT.Finance",
  },
  {
    id: "btmiracles",
    symbol: "bm",
    name: "BtMiracles",
  },
  {
    id: "btour-chain",
    symbol: "msot",
    name: "BTour Chain",
  },
  {
    id: "btrips",
    symbol: "btr",
    name: "BTRIPS",
  },
  {
    id: "bts-chain",
    symbol: "btsc",
    name: "BTS Chain",
  },
  {
    id: "btse-token",
    symbol: "btse",
    name: "BTSE Token",
  },
  {
    id: "btu-protocol",
    symbol: "btu",
    name: "BTU Protocol",
  },
  {
    id: "bubblefong",
    symbol: "bbf",
    name: "Bubblefong",
  },
  {
    id: "bubble-network",
    symbol: "bbl",
    name: "Bubble Network",
  },
  {
    id: "bubbles",
    symbol: "bubble",
    name: "Bubbles",
  },
  {
    id: "buccaneer-2",
    symbol: "buc",
    name: "Buccaneer",
  },
  {
    id: "buckhath-coin",
    symbol: "bhig",
    name: "BuckHath Coin",
  },
  {
    id: "buckswap",
    symbol: "bucks",
    name: "BuckSwap",
  },
  {
    id: "budacoin",
    symbol: "buda",
    name: "BudaCoin",
  },
  {
    id: "buddy",
    symbol: "bud",
    name: "Buddy",
  },
  {
    id: "buffalo-swap",
    symbol: "buff",
    name: "Buffalo Swap",
  },
  {
    id: "buffaloswap-horn",
    symbol: "horn",
    name: "BuffaloSwap HORN",
  },
  {
    id: "buff-doge-coin",
    symbol: "dogecoin",
    name: "Buff Doge Coin",
  },
  {
    id: "buffed-kishu",
    symbol: "bkishu",
    name: "Buffed Kishu",
  },
  {
    id: "buffedshiba",
    symbol: "bshib",
    name: "BuffedShiba",
  },
  {
    id: "buff-floki",
    symbol: "bufloki",
    name: "Buff Floki",
  },
  {
    id: "buff-samo",
    symbol: "bsamo",
    name: "Buff Samo",
  },
  {
    id: "buff-shiba-inu",
    symbol: "buffshiba",
    name: "Buff Shiba Inu",
  },
  {
    id: "buffswap",
    symbol: "buffs",
    name: "BuffSwap",
  },
  {
    id: "bugg-finance",
    symbol: "bugg",
    name: "BUGG Finance",
  },
  {
    id: "bugg-inu",
    symbol: "bugg",
    name: "Bugg Inu",
  },
  {
    id: "buildercoin",
    symbol: "bldr",
    name: "BuilderCoin",
  },
  {
    id: "builder-coin",
    symbol: "bldr",
    name: "BUilDER Coin",
  },
  {
    id: "build-finance",
    symbol: "build",
    name: "BUILD Finance",
  },
  {
    id: "buildup",
    symbol: "bup",
    name: "BuildUp",
  },
  {
    id: "bukh",
    symbol: "bukh",
    name: "bUKHI",
  },
  {
    id: "bul-finance",
    symbol: "bul",
    name: "Bul.Finance",
  },
  {
    id: "bulk-network",
    symbol: "bulk",
    name: "Bulk Network",
  },
  {
    id: "bullchain",
    symbol: "bull",
    name: "Bullchain",
  },
  {
    id: "bull-coin",
    symbol: "bull",
    name: "Bull Coin",
  },
  {
    id: "bulldog-billionaires",
    symbol: "bone",
    name: "Bulldog Billionaires",
  },
  {
    id: "bulldog-coin",
    symbol: "bulldog",
    name: "BullDog Coin",
  },
  {
    id: "bulldoge-inu",
    symbol: "bulld",
    name: "Bulldoge Inu",
  },
  {
    id: "bulldogswap",
    symbol: "budg",
    name: "BullDogSwap",
  },
  {
    id: "bulldog-token",
    symbol: "bdog",
    name: "Bulldog BDOG",
  },
  {
    id: "bulleon",
    symbol: "bul",
    name: "Bulleon",
  },
  {
    id: "bulleth",
    symbol: "bulleth",
    name: "Bulleth",
  },
  {
    id: "bullex",
    symbol: "blx",
    name: "BulleX",
  },
  {
    id: "bullieverse",
    symbol: "bull",
    name: "Bullieverse",
  },
  {
    id: "bull-inu",
    symbol: "bull",
    name: "BULL Inu",
  },
  {
    id: "bullion",
    symbol: "cbx",
    name: "Bullion",
  },
  {
    id: "bullionfx",
    symbol: "bull",
    name: "BullionFX",
  },
  {
    id: "bullish-af",
    symbol: "bullaf",
    name: "Bullish AF",
  },
  {
    id: "bullishapes",
    symbol: "bullish",
    name: "BullishApes",
  },
  {
    id: "bullit",
    symbol: "bult",
    name: "Bullit",
  },
  {
    id: "bullperks",
    symbol: "blp",
    name: "BullPerks",
  },
  {
    id: "bullrise",
    symbol: "bull",
    name: "BullRise",
  },
  {
    id: "bull-run-token",
    symbol: "br",
    name: "Bull Run Finance",
  },
  {
    id: "bullshit-inu",
    symbol: "bull",
    name: "Bullshit Inu",
  },
  {
    id: "bullswap-protocol",
    symbol: "bvl",
    name: "Bullswap Protocol",
  },
  {
    id: "bully-inu",
    symbol: "binu",
    name: "Bully Inu",
  },
  {
    id: "bumoon",
    symbol: "bumn",
    name: "BUMooN",
  },
  {
    id: "bumper",
    symbol: "bump",
    name: "Bumper",
  },
  {
    id: "bundles",
    symbol: "bund",
    name: "Bundles",
  },
  {
    id: "bunicorn",
    symbol: "buni",
    name: "Bunicorn",
  },
  {
    id: "bunnycoin",
    symbol: "bun",
    name: "Bunnycoin",
  },
  {
    id: "bunnygirl",
    symbol: "bunnygirl",
    name: "BunnyGirl",
  },
  {
    id: "bunnypark",
    symbol: "bp",
    name: "BunnyPark",
  },
  {
    id: "bunnypark-game",
    symbol: "bg",
    name: "BunnyPark Game",
  },
  {
    id: "bunnyrocket",
    symbol: "bunnyrocket",
    name: "BunnyRocket",
  },
  {
    id: "bunnytoken",
    symbol: "bunny",
    name: "Bunny",
  },
  {
    id: "bunny-token-polygon",
    symbol: "polybunny",
    name: "Pancake Bunny Polygon",
  },
  {
    id: "bunnyverse",
    symbol: "bnv",
    name: "BunnyVerse",
  },
  {
    id: "bunny-zilla",
    symbol: "bunnyzilla",
    name: "Bunny Zilla",
  },
  {
    id: "bunscake",
    symbol: "bscake",
    name: "Bunscake",
  },
  {
    id: "bured-fortis-oeconomia-token",
    symbol: "bfot",
    name: "Burned Fortis Oeconomia",
  },
  {
    id: "burency",
    symbol: "buy",
    name: "Burency",
  },
  {
    id: "burger-swap",
    symbol: "burger",
    name: "Burger Swap",
  },
  {
    id: "buried-bones",
    symbol: "bbt",
    name: "Buried Bones",
  },
  {
    id: "burn1coin",
    symbol: "burn1coin",
    name: "Burn1Coin",
  },
  {
    id: "burndoge",
    symbol: "burndoge",
    name: "BurnDoge",
  },
  {
    id: "burnfloki",
    symbol: "bfloki",
    name: "BurnFloki",
  },
  {
    id: "burningmoon",
    symbol: "bm",
    name: "BurningMoon",
  },
  {
    id: "burnrocket",
    symbol: "burnrocket",
    name: "BurnRocket",
  },
  {
    id: "burnt-cake",
    symbol: "bcake",
    name: "Burnt Cake",
  },
  {
    id: "burnx20",
    symbol: "burnx20",
    name: "BurnX 2.0",
  },
  {
    id: "burp",
    symbol: "burp",
    name: "Burp",
  },
  {
    id: "burrow",
    symbol: "brrr",
    name: "Burrow",
  },
  {
    id: "busdx",
    symbol: "busdx",
    name: "BUSDX",
  },
  {
    id: "business-age-of-empires",
    symbol: "baoe",
    name: "Business Age of Empires",
  },
  {
    id: "business-credit-substitute",
    symbol: "bcs",
    name: "Business Credit Substitute",
  },
  {
    id: "busta",
    symbol: "bust",
    name: "BUSTA",
  },
  {
    id: "busy-dao",
    symbol: "busy",
    name: "Busy DAO",
  },
  {
    id: "buttcoin-2",
    symbol: "butt",
    name: "Button",
  },
  {
    id: "butterflydao",
    symbol: "btrfly",
    name: "Redacted Cartel",
  },
  {
    id: "butterfly-protocol-2",
    symbol: "bfly",
    name: "Butterfly Protocol",
  },
  {
    id: "butterswap",
    symbol: "butter",
    name: "ButterSwap",
  },
  {
    id: "buxcoin",
    symbol: "bux",
    name: "BUXCOIN",
  },
  {
    id: "buying",
    symbol: "buy",
    name: "Buying.com",
  },
  {
    id: "buymainstreet",
    symbol: "$mainst",
    name: "BuyMainStreet",
  },
  {
    id: "buysell",
    symbol: "bull",
    name: "BuySell",
  },
  {
    id: "buyucoin-token",
    symbol: "buc",
    name: "BuyUCoin",
  },
  {
    id: "buzzshow",
    symbol: "gldy",
    name: "Buzzshow",
  },
  {
    id: "b-watch-box",
    symbol: "box",
    name: "B.watch Box",
  },
  {
    id: "bxbtc",
    symbol: "bxbtc",
    name: "bxBTC",
  },
  {
    id: "bxh",
    symbol: "bxh",
    name: "BXH",
  },
  {
    id: "bxmi-token",
    symbol: "bxmi",
    name: "Bxmi",
  },
  {
    id: "bxtb-foundation",
    symbol: "bxtb",
    name: "BXTB Foundation",
  },
  {
    id: "byakko",
    symbol: "byk",
    name: "Byakko",
  },
  {
    id: "byteball",
    symbol: "gbyte",
    name: "Obyte",
  },
  {
    id: "bytecoin",
    symbol: "bcn",
    name: "Bytecoin",
  },
  {
    id: "bytedex",
    symbol: "bext",
    name: "ByteDex",
  },
  {
    id: "byteex",
    symbol: "bx",
    name: "ByteEx",
  },
  {
    id: "bytenext",
    symbol: "bnu",
    name: "ByteNext",
  },
  {
    id: "bytom",
    symbol: "btm",
    name: "Bytom",
  },
  {
    id: "bytz",
    symbol: "bytz",
    name: "BYTZ",
  },
  {
    id: "bzedge",
    symbol: "bze",
    name: "BZEdge",
  },
  {
    id: "bzx-protocol",
    symbol: "bzrx",
    name: "bZx Protocol",
  },
  {
    id: "bzzone",
    symbol: "bzzone",
    name: "Bzzone",
  },
  {
    id: "c2x-2",
    symbol: "ctx",
    name: "C2X",
  },
  {
    id: "c3",
    symbol: "c3",
    name: "C3",
  },
  {
    id: "caashcow",
    symbol: "cow",
    name: "CaashCow",
  },
  {
    id: "caave",
    symbol: "caave",
    name: "cAAVE",
  },
  {
    id: "cabana-token",
    symbol: "cba",
    name: "Cabana",
  },
  {
    id: "cabin",
    symbol: "cabin",
    name: "Cabin",
  },
  {
    id: "cache-gold",
    symbol: "cgt",
    name: "CACHE Gold",
  },
  {
    id: "cacti-club",
    symbol: "cacti",
    name: "Cacti Club",
  },
  {
    id: "cad-coin",
    symbol: "cadc",
    name: "CAD Coin",
  },
  {
    id: "caesar-finance",
    symbol: "$caesar",
    name: "Caesar Finance",
  },
  {
    id: "cafeswap-token",
    symbol: "brew",
    name: "CafeSwap",
  },
  {
    id: "cage",
    symbol: "c4g3",
    name: "Cage",
  },
  {
    id: "cage-governance",
    symbol: "cgt",
    name: "Cage Governance",
  },
  {
    id: "caica-coin",
    symbol: "cicc",
    name: "CAICA Coin",
  },
  {
    id: "caietf-finance",
    symbol: "cai",
    name: "CAIETF.Finance",
  },
  {
    id: "cake",
    symbol: "cake",
    name: "CakeDAO",
  },
  {
    id: "cakebaker",
    symbol: "cakebaker",
    name: "CakeBaker",
  },
  {
    id: "cake-bank",
    symbol: "cakebank",
    name: "Cake Bank",
  },
  {
    id: "cake-girl",
    symbol: "cakegirl",
    name: "Cake Girl",
  },
  {
    id: "cake-monster",
    symbol: "monsta",
    name: "Cake Monster",
  },
  {
    id: "cakepad",
    symbol: "ckp",
    name: "CakePad",
  },
  {
    id: "cakepunks",
    symbol: "cakepunks",
    name: "CAKEPUNKS",
  },
  {
    id: "cakeswap",
    symbol: "cakeswap",
    name: "CakeSwap",
  },
  {
    id: "caketools",
    symbol: "ckt",
    name: "Caketools",
  },
  {
    id: "calamari-network",
    symbol: "kma",
    name: "Calamari Network",
  },
  {
    id: "calaswap",
    symbol: "cls",
    name: "Calaswap",
  },
  {
    id: "calaxy",
    symbol: "clxy",
    name: "Calaxy",
  },
  {
    id: "calcifer",
    symbol: "calcifer",
    name: "Calcifer",
  },
  {
    id: "calicoin",
    symbol: "cali",
    name: "CaliCoin",
  },
  {
    id: "californium",
    symbol: "cf",
    name: "Californium",
  },
  {
    id: "callisto",
    symbol: "clo",
    name: "Callisto Network",
  },
  {
    id: "calluna-wallet",
    symbol: "can",
    name: "CAN",
  },
  {
    id: "calo-app",
    symbol: "calo",
    name: "Calo",
  },
  {
    id: "caluracoin",
    symbol: "clc",
    name: "CaluraCoin",
  },
  {
    id: "calvex",
    symbol: "clvx",
    name: "Calvex",
  },
  {
    id: "camelcoin",
    symbol: "cml",
    name: "Camelcoin",
  },
  {
    id: "cameltoken",
    symbol: "cmlt",
    name: "Camel",
  },
  {
    id: "camp",
    symbol: "camp",
    name: "Camp",
  },
  {
    id: "canary",
    symbol: "cnr",
    name: "Canary",
  },
  {
    id: "canary-dollar",
    symbol: "cand",
    name: "Canary Dollar",
  },
  {
    id: "canaryx",
    symbol: "cnyx",
    name: "CanaryX",
  },
  {
    id: "candela-coin",
    symbol: "cla",
    name: "Candela Coin",
  },
  {
    id: "can-devs-do-something-please",
    symbol: "cddsp",
    name: "Can Devs Do Something Please",
  },
  {
    id: "candle",
    symbol: "cndl",
    name: "Candle",
  },
  {
    id: "candylad",
    symbol: "candylad",
    name: "Candylad",
  },
  {
    id: "cannabiscoin",
    symbol: "cann",
    name: "CannabisCoin",
  },
  {
    id: "cannabis-seed-token",
    symbol: "cana",
    name: "Cannabis Seed",
  },
  {
    id: "cannumo",
    symbol: "canu",
    name: "Cannumo",
  },
  {
    id: "canopus",
    symbol: "opus",
    name: "Canopus",
  },
  {
    id: "canyacoin",
    symbol: "can",
    name: "CanYaCoin",
  },
  {
    id: "cap",
    symbol: "cap",
    name: "Cap",
  },
  {
    id: "capital-aggregator-token",
    symbol: "cat+",
    name: "Capital Aggregator",
  },
  {
    id: "capital-dao-starter-token",
    symbol: "cds",
    name: "Capital DAO Starter",
  },
  {
    id: "capital-system",
    symbol: "capsys",
    name: "Capital System",
  },
  {
    id: "capital-x-cell",
    symbol: "cxc",
    name: "CAPITAL X CELL",
  },
  {
    id: "capitol",
    symbol: "cptl",
    name: "Capitol",
  },
  {
    id: "cappasity",
    symbol: "capp",
    name: "Cappasity",
  },
  {
    id: "captain",
    symbol: "capt",
    name: "Captain",
  },
  {
    id: "captain-inu",
    symbol: "cptinu",
    name: "Captain Inu",
  },
  {
    id: "captain-shibarrow",
    symbol: "shibarrow",
    name: "Captain Shibarrow",
  },
  {
    id: "capybara",
    symbol: "capy",
    name: "Capybara",
  },
  {
    id: "caramelswap",
    symbol: "mel",
    name: "CaramelSwap",
  },
  {
    id: "carat",
    symbol: "carat",
    name: "CARAT",
  },
  {
    id: "carbon",
    symbol: "crbn",
    name: "Carbon",
  },
  {
    id: "carboncoin",
    symbol: "carbon",
    name: "Carboncoin",
  },
  {
    id: "carbon-credit",
    symbol: "cct",
    name: "Carbon Credit",
  },
  {
    id: "carbondefi",
    symbol: "carbo",
    name: "CarbonDEFI",
  },
  {
    id: "carboneum",
    symbol: "c8",
    name: "Carboneum",
  },
  {
    id: "carbon-finance",
    symbol: "carbon",
    name: "Carbon Finance",
  },
  {
    id: "carbon-gems",
    symbol: "gems",
    name: "Carbon GEMS",
  },
  {
    id: "carbon-labs",
    symbol: "carb",
    name: "Carbon Labs",
  },
  {
    id: "car-coin",
    symbol: "ccm",
    name: "Car Coin",
  },
  {
    id: "cardano",
    symbol: "ada",
    name: "Cardano",
  },
  {
    id: "cardanoevo",
    symbol: "cevo",
    name: "CardanoEvo",
  },
  {
    id: "cardashift",
    symbol: "clap",
    name: "Cardashift",
  },
  {
    id: "cardence",
    symbol: "$crdn",
    name: "Cardence",
  },
  {
    id: "cardiocoin",
    symbol: "crdc",
    name: "Cardiocoin",
  },
  {
    id: "cardstack",
    symbol: "card",
    name: "Cardstack",
  },
  {
    id: "cardstarter",
    symbol: "cards",
    name: "Cardstarter",
  },
  {
    id: "cardswap",
    symbol: "cswap",
    name: "CardSwap",
  },
  {
    id: "cardwallet",
    symbol: "cw",
    name: "CardWallet",
  },
  {
    id: "care-coin",
    symbol: "crc",
    name: "Care Coin",
  },
  {
    id: "cargolink",
    symbol: "clx",
    name: "CargoLink",
  },
  {
    id: "cargox",
    symbol: "cxo",
    name: "CargoX",
  },
  {
    id: "carma-coin",
    symbol: "carma",
    name: "Carma Coin",
  },
  {
    id: "carnomaly",
    symbol: "carr",
    name: "Carnomaly",
  },
  {
    id: "carr-finance",
    symbol: "crt",
    name: "Carrot Finance",
  },
  {
    id: "carrot-stable-coin",
    symbol: "carrot",
    name: "Carrot Stable Coin",
  },
  {
    id: "carrot-token",
    symbol: "carrot",
    name: "Carrot Token",
  },
  {
    id: "carry",
    symbol: "cre",
    name: "Carry",
  },
  {
    id: "carsautofinance",
    symbol: "caf",
    name: "CarsAutoFinance",
  },
  {
    id: "cartesi",
    symbol: "ctsi",
    name: "Cartesi",
  },
  {
    id: "carvertical",
    symbol: "cv",
    name: "carVertical",
  },
  {
    id: "cash",
    symbol: "cash",
    name: "Cash",
  },
  {
    id: "cash2",
    symbol: "cash2",
    name: "Cash2",
  },
  {
    id: "cashaa",
    symbol: "cas",
    name: "Cashaa",
  },
  {
    id: "cashbackpro",
    symbol: "cbp",
    name: "CashBackPro",
  },
  {
    id: "cashbet-coin",
    symbol: "cbc",
    name: "CBC.network",
  },
  {
    id: "cashcats",
    symbol: "$cats",
    name: "CashCats",
  },
  {
    id: "cashcow",
    symbol: "cow",
    name: "CashCow",
  },
  {
    id: "cashcow-finance",
    symbol: "ccf",
    name: "CashCow.Finance",
  },
  {
    id: "cashdog",
    symbol: "cashdog",
    name: "CashDog",
  },
  {
    id: "cashera",
    symbol: "csr",
    name: "Cashera",
  },
  {
    id: "cashhand",
    symbol: "chnd",
    name: "Cashhand",
  },
  {
    id: "cashio-dollar",
    symbol: "cash",
    name: "Cashio Dollar",
  },
  {
    id: "cashio-token",
    symbol: "cashio",
    name: "Cashio",
  },
  {
    id: "cashpay",
    symbol: "cpz",
    name: "CashPay",
  },
  {
    id: "cash-tech",
    symbol: "cate",
    name: "Cash Tech",
  },
  {
    id: "casinocoin",
    symbol: "csc",
    name: "Casinocoin",
  },
  {
    id: "casinoxmetaverse",
    symbol: "$casio",
    name: "CasinoXMetaverse",
  },
  {
    id: "casper-defi",
    symbol: "casper",
    name: "Casper DeFi",
  },
  {
    id: "casper-network",
    symbol: "cspr",
    name: "Casper Network",
  },
  {
    id: "casperpad",
    symbol: "cspd",
    name: "CasperPad",
  },
  {
    id: "caspian",
    symbol: "csp",
    name: "Caspian",
  },
  {
    id: "castello-coin",
    symbol: "cast",
    name: "Castello Coin",
  },
  {
    id: "castweet",
    symbol: "ctt",
    name: "Castweet",
  },
  {
    id: "cat",
    symbol: "cat",
    name: "CAT",
  },
  {
    id: "catapult",
    symbol: "atd",
    name: "Catapult",
  },
  {
    id: "catbonk",
    symbol: "cabo",
    name: "Catbonk",
  },
  {
    id: "catboy-2",
    symbol: "catboy",
    name: "CatBoy",
  },
  {
    id: "catbread",
    symbol: "catbread",
    name: "CatBread",
  },
  {
    id: "catchy",
    symbol: "catchy",
    name: "Catchy",
  },
  {
    id: "catcoin-2",
    symbol: "cat",
    name: "CATCOIN",
  },
  {
    id: "catcoin-cash",
    symbol: "catcoin",
    name: "CatCoin.com",
  },
  {
    id: "catcoin-token",
    symbol: "cats",
    name: "CatCoin Token",
  },
  {
    id: "catecoin",
    symbol: "cate",
    name: "CateCoin",
  },
  {
    id: "catex-token",
    symbol: "catt",
    name: "Catex",
  },
  {
    id: "catge-coin",
    symbol: "catge",
    name: "Catge Coin",
  },
  {
    id: "catgirl",
    symbol: "catgirl",
    name: "Catgirl",
  },
  {
    id: "catnip",
    symbol: "nip",
    name: "CatNIP",
  },
  {
    id: "cato",
    symbol: "cato",
    name: "CATO",
  },
  {
    id: "catocoin",
    symbol: "cato",
    name: "CatoCoin",
  },
  {
    id: "catpay",
    symbol: "catpay",
    name: "CATpay",
  },
  {
    id: "catscoin",
    symbol: "cats",
    name: "Catscoin",
  },
  {
    id: "cat-token",
    symbol: "cat",
    name: "Mooncat CAT",
  },
  {
    id: "catwoman",
    symbol: "cw",
    name: "CatWoman",
  },
  {
    id: "catzcoin",
    symbol: "catz",
    name: "CatzCoin",
  },
  {
    id: "cavapoo",
    symbol: "cava",
    name: "Cavapoo",
  },
  {
    id: "cave",
    symbol: "cave",
    name: "Crypto Cavemen",
  },
  {
    id: "cbbn-token",
    symbol: "cbbn",
    name: "CBBN",
  },
  {
    id: "cbdao",
    symbol: "bree",
    name: "CBDAO",
  },
  {
    id: "cbd-coin",
    symbol: "cbd",
    name: "CBD Coin",
  },
  {
    id: "cberry",
    symbol: "cby",
    name: "CBerry",
  },
  {
    id: "cbet-token",
    symbol: "cbet",
    name: "CBET",
  },
  {
    id: "cc",
    symbol: "cc",
    name: "CC",
  },
  {
    id: "cca",
    symbol: "cca",
    name: "CCA",
  },
  {
    id: "ccomp",
    symbol: "ccomp",
    name: "cCOMP",
  },
  {
    id: "ccore",
    symbol: "cco",
    name: "Ccore",
  },
  {
    id: "ccswap",
    symbol: "cc",
    name: "CCSwap",
  },
  {
    id: "ccuniverse",
    symbol: "uvu",
    name: "CCUniverse",
  },
  {
    id: "cdai",
    symbol: "cdai",
    name: "cDAI",
  },
  {
    id: "cdzexchange",
    symbol: "cdz",
    name: "CDzExchange",
  },
  {
    id: "cedars",
    symbol: "ceds",
    name: "CEDARS",
  },
  {
    id: "ceek",
    symbol: "ceek",
    name: "CEEK Smart VR",
  },
  {
    id: "ceezee-safu",
    symbol: "safu",
    name: "CEEZEE SAFU",
  },
  {
    id: "celcoin",
    symbol: "celc",
    name: "CelCoin",
  },
  {
    id: "celeb",
    symbol: "celeb",
    name: "Celeb",
  },
  {
    id: "celer-network",
    symbol: "celr",
    name: "Celer Network",
  },
  {
    id: "celery",
    symbol: "cly",
    name: "Celery",
  },
  {
    id: "celestial",
    symbol: "celt",
    name: "Celestial",
  },
  {
    id: "celestial-unity",
    symbol: "cu",
    name: "Celestial Unity",
  },
  {
    id: "celeum",
    symbol: "clx",
    name: "Celeum",
  },
  {
    id: "celletf",
    symbol: "ecell",
    name: "Consensus Cell Network",
  },
  {
    id: "cellframe",
    symbol: "cell",
    name: "Cellframe",
  },
  {
    id: "celo",
    symbol: "celo",
    name: "Celo",
  },
  {
    id: "celo-dollar",
    symbol: "cusd",
    name: "Celo Dollar",
  },
  {
    id: "celo-euro",
    symbol: "ceur",
    name: "Celo Euro",
  },
  {
    id: "celolaunch",
    symbol: "cla",
    name: "CeloLaunch",
  },
  {
    id: "celostarter",
    symbol: "cstar",
    name: "CeloStarter",
  },
  {
    id: "celsius-degree-token",
    symbol: "cel",
    name: "Celsius Network",
  },
  {
    id: "celsius-wormhole",
    symbol: "cel",
    name: "Celsius (Wormhole)",
  },
  {
    id: "celsiusx-wrapped-ada",
    symbol: "cxada",
    name: "CelsiusX Wrapped ADA",
  },
  {
    id: "celsiusx-wrapped-btc",
    symbol: "cxbtc",
    name: "CelsiusX Wrapped BTC",
  },
  {
    id: "celsiusx-wrapped-doge",
    symbol: "cxdoge",
    name: "CelsiusX Wrapped DOGE",
  },
  {
    id: "celsiusx-wrapped-eth",
    symbol: "cxeth",
    name: "CelsiusX Wrapped ETH",
  },
  {
    id: "cens-world",
    symbol: "cens",
    name: "Cens World",
  },
  {
    id: "centaur",
    symbol: "cntr",
    name: "Centaur",
  },
  {
    id: "centaurify",
    symbol: "cent",
    name: "Centaurify",
  },
  {
    id: "centcex",
    symbol: "cenx",
    name: "Centcex",
  },
  {
    id: "centerprime",
    symbol: "cpx",
    name: "CenterPrime",
  },
  {
    id: "centralex",
    symbol: "cenx",
    name: "Centralex",
  },
  {
    id: "centrality",
    symbol: "cennz",
    name: "CENNZnet",
  },
  {
    id: "centric-cash",
    symbol: "cns",
    name: "Centric Swap",
  },
  {
    id: "centrifuge",
    symbol: "cfg",
    name: "Centrifuge",
  },
  {
    id: "centurion",
    symbol: "cnt",
    name: "Centurion",
  },
  {
    id: "centurion-inu",
    symbol: "cent",
    name: "Centurion Inu",
  },
  {
    id: "cerberus",
    symbol: "ccf",
    name: "Cerberus Finance",
  },
  {
    id: "cerberus-2",
    symbol: "crbrus",
    name: "Cerberus",
  },
  {
    id: "cerby-token",
    symbol: "cerby",
    name: "Cerby",
  },
  {
    id: "cerealia",
    symbol: "cer",
    name: "Cerealia",
  },
  {
    id: "cere-network",
    symbol: "cere",
    name: "Cere Network",
  },
  {
    id: "ceres",
    symbol: "ceres",
    name: "Ceres",
  },
  {
    id: "cerium",
    symbol: "xce",
    name: "Cerium",
  },
  {
    id: "certik",
    symbol: "ctk",
    name: "Shentu",
  },
  {
    id: "certrise",
    symbol: "cert",
    name: "CertRise",
  },
  {
    id: "certurium",
    symbol: "crt",
    name: "Certurium",
  },
  {
    id: "cetf",
    symbol: "cetf",
    name: "Cell ETF",
  },
  {
    id: "cexlt",
    symbol: "clt",
    name: "Cexlt",
  },
  {
    id: "cfl365-finance",
    symbol: "cfl365",
    name: "CFL365 Finance",
  },
  {
    id: "cforforum-token",
    symbol: "cfo",
    name: "Cfoforum",
  },
  {
    id: "cfx-quantum",
    symbol: "cfxq",
    name: "CFX Quantum",
  },
  {
    id: "chadfi",
    symbol: "chad",
    name: "ChadFi",
  },
  {
    id: "chads-vc",
    symbol: "chads",
    name: "CHADS VC",
  },
  {
    id: "chain-2",
    symbol: "xcn",
    name: "Chain",
  },
  {
    id: "chainbing",
    symbol: "cbg",
    name: "Chainbing",
  },
  {
    id: "chaincade",
    symbol: "chaincade",
    name: "ChainCade",
  },
  {
    id: "chaincoin",
    symbol: "chc",
    name: "Chaincoin",
  },
  {
    id: "chain-colosseum",
    symbol: "colos",
    name: "Chain Colosseum",
  },
  {
    id: "chaincorn",
    symbol: "cornx",
    name: "Chaincorn",
  },
  {
    id: "chain-estate-dao",
    symbol: "ches",
    name: "Chain Estate DAO",
  },
  {
    id: "chainflip",
    symbol: "flip",
    name: "Chainflip",
  },
  {
    id: "chainflix",
    symbol: "cfxt",
    name: "Chainflix",
  },
  {
    id: "chain-flowers",
    symbol: "cflo",
    name: "Chain Flowers",
  },
  {
    id: "chain-games",
    symbol: "chain",
    name: "Chain Games",
  },
  {
    id: "chainge-finance",
    symbol: "chng",
    name: "Chainge Finance",
  },
  {
    id: "chain-guardians",
    symbol: "cgg",
    name: "Chain Guardians",
  },
  {
    id: "chainium",
    symbol: "chx",
    name: "WeOwn",
  },
  {
    id: "chainlink",
    symbol: "link",
    name: "Chainlink",
  },
  {
    id: "chainlink-wormhole",
    symbol: "link",
    name: "Chainlink (Wormhole)",
  },
  {
    id: "chainlist",
    symbol: "clist",
    name: "Chainlist",
  },
  {
    id: "chainpay",
    symbol: "cpay",
    name: "Chainpay",
  },
  {
    id: "chain-pet",
    symbol: "cpet",
    name: "Chain Pet",
  },
  {
    id: "chainport",
    symbol: "portx",
    name: "ChainPort",
  },
  {
    id: "chainsquare",
    symbol: "chs",
    name: "Chainsquare",
  },
  {
    id: "chainswap",
    symbol: "asap",
    name: "Chainswap",
  },
  {
    id: "chain-wars-essence",
    symbol: "cwe",
    name: "Chain Wars",
  },
  {
    id: "chainx",
    symbol: "pcx",
    name: "ChainX",
  },
  {
    id: "challengedac",
    symbol: "chl",
    name: "ChallengeDAC",
  },
  {
    id: "champinu",
    symbol: "champinu",
    name: "ChampInu",
  },
  {
    id: "change",
    symbol: "cag",
    name: "Change",
  },
  {
    id: "changenow",
    symbol: "now",
    name: "ChangeNOW",
  },
  {
    id: "changer",
    symbol: "cng",
    name: "Changer",
  },
  {
    id: "channels",
    symbol: "can",
    name: "Channels",
  },
  {
    id: "charactbit",
    symbol: "chb",
    name: "Charactbit",
  },
  {
    id: "charg-coin",
    symbol: "chg",
    name: "Charg Coin",
  },
  {
    id: "chargedefi-charge",
    symbol: "charge",
    name: "ChargeDeFi Charge",
  },
  {
    id: "chargedefi-static",
    symbol: "static",
    name: "ChargeDeFi Static",
  },
  {
    id: "charged-particles",
    symbol: "ionx",
    name: "Charged Particles",
  },
  {
    id: "charitas",
    symbol: "char",
    name: "Charitas",
  },
  {
    id: "charity-alfa",
    symbol: "mich",
    name: "Charity Alfa",
  },
  {
    id: "charitydao",
    symbol: "chd",
    name: "CharityDAO",
  },
  {
    id: "charix-token",
    symbol: "charix",
    name: "Charix",
  },
  {
    id: "charizard-inu",
    symbol: "charizard",
    name: "Charizard Inu",
  },
  {
    id: "charli3",
    symbol: "c3",
    name: "Charli3",
  },
  {
    id: "charlie-finance",
    symbol: "cht",
    name: "Charlie Finance",
  },
  {
    id: "charm",
    symbol: "charm",
    name: "Charm",
  },
  {
    id: "chartex",
    symbol: "chart",
    name: "ChartEx",
  },
  {
    id: "checkdot",
    symbol: "cdt",
    name: "CheckDot",
  },
  {
    id: "checkerchain",
    symbol: "checkr",
    name: "CheckerChain",
  },
  {
    id: "checoin",
    symbol: "checoin",
    name: "CheCoin",
  },
  {
    id: "chedda",
    symbol: "chedda",
    name: "Chedda",
  },
  {
    id: "chee",
    symbol: "chee",
    name: "Chee Finance",
  },
  {
    id: "cheebs",
    symbol: "chee",
    name: "CHEEBS",
  },
  {
    id: "cheems",
    symbol: "cheems",
    name: "Cheems",
  },
  {
    id: "cheems-inu",
    symbol: "$cinu",
    name: "CHEEMS INU",
  },
  {
    id: "cheersland",
    symbol: "cheers",
    name: "CheersLand",
  },
  {
    id: "cheesecakeswap",
    symbol: "ccake",
    name: "CheesecakeSwap",
  },
  {
    id: "cheesedao",
    symbol: "cheez",
    name: "CheeseDAO",
  },
  {
    id: "cheesefry",
    symbol: "cheese",
    name: "CheeseFry",
  },
  {
    id: "cheesesoda-token",
    symbol: "soda",
    name: "CheeseSoda",
  },
  {
    id: "cheeseswap",
    symbol: "chs",
    name: "CheeseSwap",
  },
  {
    id: "cheese-swap",
    symbol: "cheese",
    name: "Cheese Swap",
  },
  {
    id: "cheese-token",
    symbol: "cheese",
    name: "Hamster Cheese",
  },
  {
    id: "cheesus",
    symbol: "cheesus",
    name: "Cheesus",
  },
  {
    id: "chefcake",
    symbol: "chefcake",
    name: "ChefCake",
  },
  {
    id: "chellitcoin",
    symbol: "chlt",
    name: "Chellitcoin",
  },
  {
    id: "chemix-ecology-governance-token",
    symbol: "kun",
    name: "Chemix Ecology Governance",
  },
  {
    id: "cheqd-network",
    symbol: "cheq",
    name: "CHEQD Network",
  },
  {
    id: "cherish",
    symbol: "chc",
    name: "Cherish",
  },
  {
    id: "cherry-network",
    symbol: "cher",
    name: "Cherry Network",
  },
  {
    id: "cherrypick",
    symbol: "cherry",
    name: "CherryPick",
  },
  {
    id: "cherryswap",
    symbol: "che",
    name: "CherrySwap",
  },
  {
    id: "cherry-token",
    symbol: "yt",
    name: "Cherry YT",
  },
  {
    id: "chesscoin-0-32",
    symbol: "chess",
    name: "ChessCoin 0.32%",
  },
  {
    id: "chessnft",
    symbol: "cnft",
    name: "ChessNFT",
  },
  {
    id: "chex-token",
    symbol: "chex",
    name: "CHEX Token",
  },
  {
    id: "chhipscoin",
    symbol: "chh",
    name: "CHHIPSCOIN",
  },
  {
    id: "chi",
    symbol: "chi",
    name: "Chi",
  },
  {
    id: "chia",
    symbol: "xch",
    name: "Chia",
  },
  {
    id: "chiba-inu",
    symbol: "chiba",
    name: "Chiba Inu",
  },
  {
    id: "chicken",
    symbol: "kfc",
    name: "Chicken",
  },
  {
    id: "chickenlegs",
    symbol: "corn",
    name: "ChickenLegs",
  },
  {
    id: "chicken-nugget-coin",
    symbol: "nugget",
    name: "Chicken Nugget Coin",
  },
  {
    id: "chi-gastoken",
    symbol: "chi",
    name: "Chi Gas",
  },
  {
    id: "chi-gastoken-bsc",
    symbol: "chi",
    name: "Chi Gas (BSC)",
  },
  {
    id: "chihiro-inu",
    symbol: "chiro",
    name: "Chihiro Inu",
  },
  {
    id: "chihuahua",
    symbol: "hua",
    name: "Chihuahua",
  },
  {
    id: "chihuahuasol",
    symbol: "chih",
    name: "ChihuahuaSol",
  },
  {
    id: "chihuahua-token",
    symbol: "huahua",
    name: "Chihuahua Chain",
  },
  {
    id: "chihuahuax",
    symbol: "chihua",
    name: "Chihuahuax",
  },
  {
    id: "chihua-token",
    symbol: "chihua",
    name: "Chihua",
  },
  {
    id: "chikincoin",
    symbol: "ckc",
    name: "ChikinCoin",
  },
  {
    id: "chikn-egg",
    symbol: "egg",
    name: "Chikn Egg",
  },
  {
    id: "chikn-feed",
    symbol: "feed",
    name: "chikn feed",
  },
  {
    id: "chikn-fert",
    symbol: "fert",
    name: "Chikn Fert",
  },
  {
    id: "childhoods-end",
    symbol: "o",
    name: "Childhoods End",
  },
  {
    id: "chiliz",
    symbol: "chz",
    name: "Chiliz",
  },
  {
    id: "chiliz-wormhole",
    symbol: "chz",
    name: "Chiliz (Wormhole)",
  },
  {
    id: "chimaera",
    symbol: "chi",
    name: "XAYA",
  },
  {
    id: "chimeras",
    symbol: "chim",
    name: "Chimeras",
  },
  {
    id: "chimp-fight",
    symbol: "nana",
    name: "Nana",
  },
  {
    id: "chinaom",
    symbol: "com",
    name: "ChinaOM",
  },
  {
    id: "chinu",
    symbol: "$chinu",
    name: "Chinu",
  },
  {
    id: "chip",
    symbol: "chip",
    name: "Chip",
  },
  {
    id: "chipstars",
    symbol: "chips",
    name: "Chipstars",
  },
  {
    id: "chipz",
    symbol: "chpz",
    name: "Chipz",
  },
  {
    id: "chiva-token",
    symbol: "chiv",
    name: "Chiva",
  },
  {
    id: "chives-coin",
    symbol: "xcc",
    name: "Chives Coin",
  },
  {
    id: "chiwawa",
    symbol: "chiwa",
    name: "Chiwawa",
  },
  {
    id: "choccyswap",
    symbol: "ccy",
    name: "ChoccySwap",
  },
  {
    id: "choice-coin",
    symbol: "choice",
    name: "Choice Coin",
  },
  {
    id: "chonk",
    symbol: "chonk",
    name: "Chonk",
  },
  {
    id: "chopper-inu",
    symbol: "chopper",
    name: "Chopper Inu",
  },
  {
    id: "chorusx",
    symbol: "cx1",
    name: "ChorusX",
  },
  {
    id: "chow-chow-finance",
    symbol: "chow",
    name: "Chow Chow Finance",
  },
  {
    id: "chowdao",
    symbol: "chow",
    name: "ChowDAO",
  },
  {
    id: "chow-inu",
    symbol: "chow",
    name: "Chow Inu",
  },
  {
    id: "christmas-bnb",
    symbol: "xmasbnb",
    name: "Christmas BNB",
  },
  {
    id: "chromaway",
    symbol: "chr",
    name: "Chromia",
  },
  {
    id: "chronicle",
    symbol: "xnl",
    name: "Chronicle",
  },
  {
    id: "chronobank",
    symbol: "time",
    name: "chrono.tech",
  },
  {
    id: "chronobase",
    symbol: "tik",
    name: "ChronoBase",
  },
  {
    id: "chronologic",
    symbol: "day",
    name: "Chronologic",
  },
  {
    id: "chubbies",
    symbol: "chubbies20",
    name: "Chubbies",
  },
  {
    id: "chubbyakita",
    symbol: "cakita",
    name: "ChubbyAkita",
  },
  {
    id: "chug-token",
    symbol: "chug",
    name: "CHUG",
  },
  {
    id: "chumbai-valley",
    symbol: "chmb",
    name: "Chumbi Valley",
  },
  {
    id: "chum-coin",
    symbol: "chum",
    name: "Chum Coin",
  },
  {
    id: "cia",
    symbol: "cia",
    name: "CIA",
  },
  {
    id: "cigarette-token",
    symbol: "cig",
    name: "Cigarette",
  },
  {
    id: "cindicator",
    symbol: "cnd",
    name: "Cindicator",
  },
  {
    id: "cindrum",
    symbol: "cind",
    name: "Cindrum",
  },
  {
    id: "cine-media-celebrity-coin",
    symbol: "cmccoin",
    name: "CINE MEDIA CELEBRITY COIN",
  },
  {
    id: "cino-games",
    symbol: "cino",
    name: "Cino Games",
  },
  {
    id: "cipher-2",
    symbol: "cpr",
    name: "CIPHER",
  },
  {
    id: "circlepod",
    symbol: "cpx",
    name: "Circlepod",
  },
  {
    id: "circleswap",
    symbol: "cir",
    name: "CircleSwap",
  },
  {
    id: "circuits-of-value",
    symbol: "coval",
    name: "Circuits of Value",
  },
  {
    id: "ciredo",
    symbol: "cir",
    name: "Ciredo",
  },
  {
    id: "cirquity",
    symbol: "cirq",
    name: "Cirquity",
  },
  {
    id: "cirrus",
    symbol: "crs",
    name: "Cirrus",
  },
  {
    id: "cirus",
    symbol: "cirus",
    name: "Cirus",
  },
  {
    id: "citadao",
    symbol: "knight",
    name: "CitaDAO",
  },
  {
    id: "citadel",
    symbol: "ctl",
    name: "Citadel",
  },
  {
    id: "citadel-one",
    symbol: "xct",
    name: "Citadel.one",
  },
  {
    id: "cities-vault-nftx",
    symbol: "cities",
    name: "CITIES Vault (NFTX)",
  },
  {
    id: "citizen-finance",
    symbol: "cifi",
    name: "Citizen Finance",
  },
  {
    id: "citizen-finance-old",
    symbol: "cifi",
    name: "Citizen Finance (OLD)",
  },
  {
    id: "citrus",
    symbol: "cts",
    name: "Citrus",
  },
  {
    id: "city-coin",
    symbol: "city",
    name: "City Coin",
  },
  {
    id: "city-of-dream",
    symbol: "cod",
    name: "City of Dream",
  },
  {
    id: "citystates-medieval",
    symbol: "csm",
    name: "CityStates Medieval",
  },
  {
    id: "civfund-stone",
    symbol: "0ne",
    name: "Civfund Stone",
  },
  {
    id: "civic",
    symbol: "cvc",
    name: "Civic",
  },
  {
    id: "civic-power",
    symbol: "power",
    name: "Civic Power",
  },
  {
    id: "civilization",
    symbol: "civ",
    name: "Civilization",
  },
  {
    id: "claimswap",
    symbol: "cla",
    name: "ClaimSwap",
  },
  {
    id: "clams",
    symbol: "clam",
    name: "Clams",
  },
  {
    id: "clash-of-cars",
    symbol: "clash",
    name: "Clash Of Cars",
  },
  {
    id: "class-coin",
    symbol: "class",
    name: "Class Coin",
  },
  {
    id: "classicbitcoin",
    symbol: "cbtc",
    name: "ClassicBitcoin",
  },
  {
    id: "classic-coin",
    symbol: "cls",
    name: "Classic Coin",
  },
  {
    id: "classicdoge",
    symbol: "xdoge",
    name: "ClassicDoge",
  },
  {
    id: "classzz",
    symbol: "czz",
    name: "ClassZZ",
  },
  {
    id: "clavis",
    symbol: "clavis",
    name: "Clavis",
  },
  {
    id: "cleanocean",
    symbol: "clean",
    name: "CleanOcean",
  },
  {
    id: "clear-coin",
    symbol: "clr",
    name: "Clear Coin",
  },
  {
    id: "cleardao",
    symbol: "clh",
    name: "ClearDAO",
  },
  {
    id: "clearpoll",
    symbol: "poll",
    name: "ClearPoll",
  },
  {
    id: "clearpool",
    symbol: "cpool",
    name: "Clearpool",
  },
  {
    id: "clear-water",
    symbol: "$clear",
    name: "Clear Water",
  },
  {
    id: "clexchain",
    symbol: "clex",
    name: "Clexchain",
  },
  {
    id: "clifford-inu",
    symbol: "cliff",
    name: "Clifford Inu",
  },
  {
    id: "climb-token-finance",
    symbol: "climb",
    name: "Climb Token Finance",
  },
  {
    id: "clintex-cti",
    symbol: "cti",
    name: "ClinTex CTi",
  },
  {
    id: "cliq",
    symbol: "ct",
    name: "CLIQ",
  },
  {
    id: "cloakcoin",
    symbol: "cloak",
    name: "Cloakcoin",
  },
  {
    id: "clock-24",
    symbol: "c24",
    name: "Clock 24",
  },
  {
    id: "cloudbric",
    symbol: "clbk",
    name: "Cloudbric",
  },
  {
    id: "cloudname",
    symbol: "cname",
    name: "Cloudname",
  },
  {
    id: "cloud-protocol",
    symbol: "cpro",
    name: "Cloud Protocol",
  },
  {
    id: "cloutcontracts",
    symbol: "ccs",
    name: "CloutContracts",
  },
  {
    id: "clover",
    symbol: "clv",
    name: "Clover",
  },
  {
    id: "clover-finance",
    symbol: "clv",
    name: "Clover Finance",
  },
  {
    id: "clqdr",
    symbol: "clqdr",
    name: "cLQDR",
  },
  {
    id: "club-atletico-independiente",
    symbol: "cai",
    name: "Club Atletico Independiente Fan Token",
  },
  {
    id: "club-donkey",
    symbol: "cdonk",
    name: "Club Donkey",
  },
  {
    id: "clube-atletico-mineiro-fan-token",
    symbol: "galo",
    name: "Clube Atlético Mineiro Fan Token",
  },
  {
    id: "clubrare-empower",
    symbol: "mpwr",
    name: "ClubRare Empower",
  },
  {
    id: "clucoin",
    symbol: "clu",
    name: "CluCoin",
  },
  {
    id: "clytie",
    symbol: "cly",
    name: "Clytie",
  },
  {
    id: "cmc-coin",
    symbol: "cmcc",
    name: "CMC Coin",
  },
  {
    id: "cmeta",
    symbol: "cmeta",
    name: "cMETA",
  },
  {
    id: "cmitcoin",
    symbol: "cmit",
    name: "CMITCOIN",
  },
  {
    id: "cneta",
    symbol: "cneta",
    name: "cNETA",
  },
  {
    id: "cng-casino",
    symbol: "cng",
    name: "CNG Casino",
  },
  {
    id: "cnn",
    symbol: "cnn",
    name: "Content Neutrality Network",
  },
  {
    id: "cnns",
    symbol: "cnns",
    name: "CNNS",
  },
  {
    id: "coalculus",
    symbol: "coal",
    name: "Coalculus",
  },
  {
    id: "cobak-token",
    symbol: "cbk",
    name: "Cobak",
  },
  {
    id: "coban",
    symbol: "coban",
    name: "COBAN",
  },
  {
    id: "cobragoose",
    symbol: "cbg",
    name: "CobraGoose",
  },
  {
    id: "cockapoo",
    symbol: "cpoo",
    name: "Cockapoo",
  },
  {
    id: "cocktailbar",
    symbol: "coc",
    name: "cocktailbar.finance",
  },
  {
    id: "cocos-bcx",
    symbol: "cocos",
    name: "COCOS BCX",
  },
  {
    id: "coco-swap",
    symbol: "coco",
    name: "Coco Swap",
  },
  {
    id: "code4rena",
    symbol: "arena",
    name: "Code4rena",
  },
  {
    id: "code-7",
    symbol: "code7",
    name: "Code 7",
  },
  {
    id: "codex",
    symbol: "cdex",
    name: "Codex",
  },
  {
    id: "codex-finance",
    symbol: "codex",
    name: "CODEX Finance",
  },
  {
    id: "codi-finance",
    symbol: "codi",
    name: "Codi Finance",
  },
  {
    id: "codyfight",
    symbol: "ctok",
    name: "Codyfight",
  },
  {
    id: "coffe-1-st-round",
    symbol: "cff",
    name: "Coffe",
  },
  {
    id: "coffeecoin",
    symbol: "cof",
    name: "CoffeeCoin",
  },
  {
    id: "coffin-dollar",
    symbol: "cousd",
    name: "Coffin Dollar",
  },
  {
    id: "coffin-finance",
    symbol: "coffin",
    name: "Coffin Finance",
  },
  {
    id: "cofinex",
    symbol: "cnx",
    name: "Cofinex",
  },
  {
    id: "cofix",
    symbol: "cofi",
    name: "CoFiX",
  },
  {
    id: "cogecoin",
    symbol: "coge",
    name: "Cogecoin",
  },
  {
    id: "cogiverse",
    symbol: "cogi",
    name: "9D NFT",
  },
  {
    id: "coic",
    symbol: "coic",
    name: "COIC",
  },
  {
    id: "coin",
    symbol: "coin",
    name: "Coin",
  },
  {
    id: "coin4trade",
    symbol: "c4t",
    name: "Coin4Trade",
  },
  {
    id: "coin98",
    symbol: "c98",
    name: "Coin98",
  },
  {
    id: "coinage-finance",
    symbol: "cage",
    name: "Coinage Finance",
  },
  {
    id: "coinalpha",
    symbol: "alp",
    name: "CoinAlpha",
  },
  {
    id: "coin-artist",
    symbol: "coin",
    name: "Coin Artist",
  },
  {
    id: "coinary-token",
    symbol: "cyt",
    name: "Coinary",
  },
  {
    id: "coinbase-stock",
    symbol: "coin",
    name: "Coinbase Tokenized Stock on FTX",
  },
  {
    id: "coinbase-stock-bittrex",
    symbol: "coin",
    name: "Coinbase Tokenized Stock on Bittrex",
  },
  {
    id: "coinbase-tokenized-stock-defichain",
    symbol: "dcoin",
    name: "Coinbase Tokenized Stock Defichain",
  },
  {
    id: "coin-capsule",
    symbol: "caps",
    name: "Ternoa",
  },
  {
    id: "coinclaim",
    symbol: "clm",
    name: "CoinClaim",
  },
  {
    id: "coindeal-token",
    symbol: "cdl",
    name: "CoinDeal Token",
  },
  {
    id: "coin-discovery",
    symbol: "codi",
    name: "Coin Discovery",
  },
  {
    id: "coindom",
    symbol: "scc",
    name: "Stem Cell Coin",
  },
  {
    id: "coinerr",
    symbol: "err",
    name: "Coinerr",
  },
  {
    id: "coinex-token",
    symbol: "cet",
    name: "CoinEx",
  },
  {
    id: "coin-fast-alert",
    symbol: "cfa",
    name: "Coin Fast Alert [OLD]",
  },
  {
    id: "coin-fast-alert-v2",
    symbol: "cfa",
    name: "Coin Fast Alert V2",
  },
  {
    id: "coinfi",
    symbol: "cofi",
    name: "CoinFi",
  },
  {
    id: "coinfield-coin",
    symbol: "cfc",
    name: "CoinField Coin",
  },
  {
    id: "coinfirm-amlt",
    symbol: "amlt",
    name: "AMLT Network",
  },
  {
    id: "coinflect",
    symbol: "wcflt",
    name: "Coinflect",
  },
  {
    id: "coinfresh",
    symbol: "cfresh",
    name: "Coinfresh",
  },
  {
    id: "coingress",
    symbol: "cgress",
    name: "Coingress",
  },
  {
    id: "coinhunters",
    symbol: "chtrv2",
    name: "Coinhunters",
  },
  {
    id: "coinlancer",
    symbol: "cl",
    name: "Coinlancer",
  },
  {
    id: "coinlion",
    symbol: "lion",
    name: "CoinLion",
  },
  {
    id: "coinloan",
    symbol: "clt",
    name: "CoinLoan",
  },
  {
    id: "coinlogin",
    symbol: "clg",
    name: "CoinLogin",
  },
  {
    id: "coinmeet",
    symbol: "meet",
    name: "CoinMeet",
  },
  {
    id: "coinmerge",
    symbol: "cmerge",
    name: "CoinMerge (ERC20)",
  },
  {
    id: "coinmerge-bsc",
    symbol: "cmerge",
    name: "CoinMerge (BEP20)",
  },
  {
    id: "coinmetro",
    symbol: "xcm",
    name: "Coinmetro",
  },
  {
    id: "coinmooner",
    symbol: "mooner",
    name: "CoinMooner",
  },
  {
    id: "coinnec",
    symbol: "coi",
    name: "Coinnec",
  },
  {
    id: "coin-of-nature",
    symbol: "con",
    name: "Coin of Nature",
  },
  {
    id: "coin-of-the-champions",
    symbol: "coc",
    name: "Coin of the champions",
  },
  {
    id: "coin-on-file-token",
    symbol: "coft",
    name: "Coin on File",
  },
  {
    id: "coinpad",
    symbol: "cp",
    name: "Coinpad",
  },
  {
    id: "coinpoker",
    symbol: "chp",
    name: "CoinPoker",
  },
  {
    id: "coinracer",
    symbol: "crace",
    name: "Coinracer",
  },
  {
    id: "coinradr",
    symbol: "radr",
    name: "CoinRadr",
  },
  {
    id: "coinsale",
    symbol: "csf",
    name: "Coinsale",
  },
  {
    id: "coinsbit-token",
    symbol: "cnb",
    name: "Coinsbit Token",
  },
  {
    id: "coinscan",
    symbol: "scan",
    name: "CoinScan",
  },
  {
    id: "coinscope",
    symbol: "coinscope",
    name: "Coinscope",
  },
  {
    id: "coinspaid",
    symbol: "cpd",
    name: "CoinsPaid",
  },
  {
    id: "coinstox",
    symbol: "csx",
    name: "Coinstox",
  },
  {
    id: "coinswap-space",
    symbol: "css",
    name: "CoinSwap Space",
  },
  {
    id: "cointorox",
    symbol: "orox",
    name: "Cointorox",
  },
  {
    id: "coinversation",
    symbol: "cto",
    name: "Coinversation",
  },
  {
    id: "coinviewcap",
    symbol: "cvc",
    name: "CoinViewCap",
  },
  {
    id: "coinwealth",
    symbol: "cnw",
    name: "CoinWealth",
  },
  {
    id: "coinweb",
    symbol: "cweb",
    name: "Coinweb",
  },
  {
    id: "coinwind",
    symbol: "cow",
    name: "CoinWind",
  },
  {
    id: "coinxpad",
    symbol: "cxpad",
    name: "CoinxPad",
  },
  {
    id: "cola-token",
    symbol: "cola",
    name: "Cola",
  },
  {
    id: "coldbank",
    symbol: "cold",
    name: "Coldbank",
  },
  {
    id: "cold-finance",
    symbol: "cold",
    name: "Cold Finance",
  },
  {
    id: "coldstack",
    symbol: "cls",
    name: "Coldstack",
  },
  {
    id: "colizeum",
    symbol: "zeum",
    name: "Colizeum",
  },
  {
    id: "collateral-pay",
    symbol: "coll",
    name: "Collateral Pay",
  },
  {
    id: "collateral-pay-governance",
    symbol: "collg",
    name: "Collateral Pay Governance",
  },
  {
    id: "collectcoin-2",
    symbol: "clct",
    name: "CollectCoin",
  },
  {
    id: "collective",
    symbol: "co2",
    name: "Collective",
  },
  {
    id: "collector-coin",
    symbol: "ags",
    name: "Collector Coin",
  },
  {
    id: "collegecoinnetwork",
    symbol: "ccn",
    name: "CollegeCoinNetwork",
  },
  {
    id: "collegicoin",
    symbol: "clg",
    name: "Collegicoin",
  },
  {
    id: "colligo",
    symbol: "cotk",
    name: "Colligo",
  },
  {
    id: "colony",
    symbol: "cly",
    name: "Colony",
  },
  {
    id: "colony-network-token",
    symbol: "clny",
    name: "Colony Network",
  },
  {
    id: "colossuscoinxt",
    symbol: "colx",
    name: "ColossusXT",
  },
  {
    id: "columbus",
    symbol: "cbs",
    name: "Columbus",
  },
  {
    id: "comb-finance",
    symbol: "comb",
    name: "Comb Finance",
  },
  {
    id: "combo-2",
    symbol: "comb",
    name: "Combo",
  },
  {
    id: "comdex",
    symbol: "cmdx",
    name: "Comdex",
  },
  {
    id: "comet-nodes",
    symbol: "comet",
    name: "Comet Nodes",
  },
  {
    id: "comfy",
    symbol: "comfy",
    name: "Comfy",
  },
  {
    id: "comfy-share",
    symbol: "cshare",
    name: "Comfy Share",
  },
  {
    id: "comfy-v2",
    symbol: "comfy",
    name: "Comfy V2",
  },
  {
    id: "commons-earth",
    symbol: "com",
    name: "Commons Earth",
  },
  {
    id: "communifty",
    symbol: "cnft",
    name: "Communifty",
  },
  {
    id: "community-business-token",
    symbol: "cbt",
    name: "Community Business",
  },
  {
    id: "community-coin-2",
    symbol: "ctc",
    name: "Community Coin Foundation",
  },
  {
    id: "community-doge-coin",
    symbol: "ccdoge",
    name: "Community Doge Coin",
  },
  {
    id: "community-metaverse",
    symbol: "comt",
    name: "Community Metaverse",
  },
  {
    id: "communitytoken",
    symbol: "ct",
    name: "Cojam",
  },
  {
    id: "community-vote-power",
    symbol: "cvp",
    name: "Community Vote Power",
  },
  {
    id: "comodo-coin",
    symbol: "cmd",
    name: "Comodo Coin",
  },
  {
    id: "compendium-fi",
    symbol: "cmfi",
    name: "Compendium.Fi",
  },
  {
    id: "complifi",
    symbol: "comfi",
    name: "CompliFi",
  },
  {
    id: "compound-0x",
    symbol: "czrx",
    name: "c0x",
  },
  {
    id: "compound-basic-attention-token",
    symbol: "cbat",
    name: "cBAT",
  },
  {
    id: "compound-chainlink-token",
    symbol: "clink",
    name: "cLINK",
  },
  {
    id: "compound-coin",
    symbol: "comp",
    name: "Compound Coin",
  },
  {
    id: "compound-ether",
    symbol: "ceth",
    name: "cETH",
  },
  {
    id: "compound-governance-token",
    symbol: "comp",
    name: "Compound",
  },
  {
    id: "compound-maker",
    symbol: "cmkr",
    name: "cMKR",
  },
  {
    id: "compound-sushi",
    symbol: "csushi",
    name: "cSUSHI",
  },
  {
    id: "compound-uniswap",
    symbol: "cuni",
    name: "cUNI",
  },
  {
    id: "compound-usd-coin",
    symbol: "cusdc",
    name: "cUSDC",
  },
  {
    id: "compound-usdt",
    symbol: "cusdt",
    name: "cUSDT",
  },
  {
    id: "compound-wormhole",
    symbol: "comp",
    name: "Compound (Wormhole)",
  },
  {
    id: "compound-wrapped-btc",
    symbol: "cwbtc",
    name: "cWBTC",
  },
  {
    id: "compound-yearn-finance",
    symbol: "cyfi",
    name: "cYFI",
  },
  {
    id: "comsa",
    symbol: "cms",
    name: "COMSA",
  },
  {
    id: "comtech-gold",
    symbol: "cgo",
    name: "Comtech Gold",
  },
  {
    id: "concave",
    symbol: "cnv",
    name: "Concave",
  },
  {
    id: "conceal",
    symbol: "ccx",
    name: "Conceal",
  },
  {
    id: "concentrated-voting-power",
    symbol: "cvp",
    name: "PowerPool Concentrated Voting Power",
  },
  {
    id: "concertvr",
    symbol: "cvt",
    name: "concertVR",
  },
  {
    id: "concierge-io",
    symbol: "ava",
    name: "Travala.com",
  },
  {
    id: "concordium",
    symbol: "ccd",
    name: "Concordium",
  },
  {
    id: "concrete-codes",
    symbol: "conc",
    name: "Concrete Codes",
  },
  {
    id: "conegame",
    symbol: "conegame",
    name: "ConeGame",
  },
  {
    id: "confetti",
    symbol: "cfti",
    name: "Confetti",
  },
  {
    id: "conflux-token",
    symbol: "cfx",
    name: "Conflux",
  },
  {
    id: "congruent-dao-token",
    symbol: "gaas",
    name: "Congruent DAO",
  },
  {
    id: "conic-finance",
    symbol: "cnc",
    name: "Conic",
  },
  {
    id: "conjee",
    symbol: "conj",
    name: "Conjee",
  },
  {
    id: "connect-coin",
    symbol: "xcon",
    name: "Connect Coin",
  },
  {
    id: "connect-financial",
    symbol: "cnfi",
    name: "Connect Financial",
  },
  {
    id: "connectico",
    symbol: "con",
    name: "Connectico",
  },
  {
    id: "connectjob",
    symbol: "cjt",
    name: "ConnectJob",
  },
  {
    id: "connectome",
    symbol: "cntm",
    name: "Connectome",
  },
  {
    id: "connector-coin",
    symbol: "ctco",
    name: "Connector Coin",
  },
  {
    id: "connect-token",
    symbol: "cnt",
    name: "Connect Stela",
  },
  {
    id: "conqueror",
    symbol: "conq",
    name: "Conqueror",
  },
  {
    id: "consentium",
    symbol: "csm",
    name: "Consentium",
  },
  {
    id: "constellation-labs",
    symbol: "dag",
    name: "Constellation",
  },
  {
    id: "constitutiondao",
    symbol: "people",
    name: "ConstitutionDAO",
  },
  {
    id: "constitutiondao-wormhole",
    symbol: "people",
    name: "ConstitutionDAO (Wormhole)",
  },
  {
    id: "contentbox",
    symbol: "box",
    name: "ContentBox",
  },
  {
    id: "contentos",
    symbol: "cos",
    name: "Contentos",
  },
  {
    id: "content-value-network",
    symbol: "cvnt",
    name: "Conscious Value Network",
  },
  {
    id: "continuum-finance",
    symbol: "ctn",
    name: "Continuum Finance",
  },
  {
    id: "continuum-world",
    symbol: "um",
    name: "Continuum World",
  },
  {
    id: "contracoin",
    symbol: "ctcn",
    name: "Contracoin",
  },
  {
    id: "contracto",
    symbol: "lock",
    name: "Contracto",
  },
  {
    id: "contribute",
    symbol: "trib",
    name: "Contribute",
  },
  {
    id: "conun",
    symbol: "con",
    name: "CONUN",
  },
  {
    id: "convergence",
    symbol: "conv",
    name: "Convergence",
  },
  {
    id: "converter-finance",
    symbol: "con",
    name: "Converter Finance",
  },
  {
    id: "convex-crv",
    symbol: "cvxcrv",
    name: "Convex CRV",
  },
  {
    id: "convex-finance",
    symbol: "cvx",
    name: "Convex Finance",
  },
  {
    id: "convex-finance-wormhole",
    symbol: "cvx",
    name: "Convex Finance (Wormhole)",
  },
  {
    id: "cook",
    symbol: "cook",
    name: "Cook",
  },
  {
    id: "cool-cats",
    symbol: "cool20",
    name: "Cool Cats",
  },
  {
    id: "coolmining",
    symbol: "cooha",
    name: "CoolMining",
  },
  {
    id: "cool-monke-banana",
    symbol: "cmb",
    name: "Cool Monke Banana",
  },
  {
    id: "cool-vault-nftx",
    symbol: "cool",
    name: "COOL Vault (NFTX)",
  },
  {
    id: "cope",
    symbol: "cope",
    name: "Cope",
  },
  {
    id: "copiosa",
    symbol: "cop",
    name: "Copiosa",
  },
  {
    id: "copuppy",
    symbol: "cp",
    name: "CoPuppy",
  },
  {
    id: "copycat-finance",
    symbol: "copycat",
    name: "Copycat Finance",
  },
  {
    id: "coral-swap",
    symbol: "coral",
    name: "Coral Swap",
  },
  {
    id: "cord-finance",
    symbol: "cord",
    name: "CORD.Finance",
  },
  {
    id: "core",
    symbol: "cmcx",
    name: "CORE MultiChain",
  },
  {
    id: "coredao",
    symbol: "coredao",
    name: "coreDAO",
  },
  {
    id: "corestarter",
    symbol: "cstr",
    name: "CoreStarter",
  },
  {
    id: "coreto",
    symbol: "cor",
    name: "Coreto",
  },
  {
    id: "coreum",
    symbol: "core",
    name: "Coreum",
  },
  {
    id: "corgicoin",
    symbol: "corgi",
    name: "CorgiCoin",
  },
  {
    id: "corgidoge",
    symbol: "corgi",
    name: "Corgidoge",
  },
  {
    id: "corgi-inu",
    symbol: "corgi",
    name: "Corgi Inu",
  },
  {
    id: "corginftgame",
    symbol: "cor",
    name: "CorgiNFTGame",
  },
  {
    id: "corgiswap",
    symbol: "coris",
    name: "CorgiSwap",
  },
  {
    id: "corionx",
    symbol: "corx",
    name: "CorionX",
  },
  {
    id: "corn",
    symbol: "corn",
    name: "CORN",
  },
  {
    id: "cornatto",
    symbol: "cnc",
    name: "Cornatto",
  },
  {
    id: "cornichon",
    symbol: "corn",
    name: "Cornichon",
  },
  {
    id: "cornucopias",
    symbol: "copi",
    name: "Cornucopias",
  },
  {
    id: "corra-finance",
    symbol: "cora",
    name: "Corra.Finance",
  },
  {
    id: "corsac-v2",
    symbol: "csct",
    name: "Corsac v2",
  },
  {
    id: "cortex",
    symbol: "ctxc",
    name: "Cortex",
  },
  {
    id: "cortexdao",
    symbol: "cxd",
    name: "CortexDAO",
  },
  {
    id: "coshi-inu",
    symbol: "coshi",
    name: "CoShi Inu",
  },
  {
    id: "cosmic-ape-coin",
    symbol: "cac",
    name: "Cosmic Ape Coin",
  },
  {
    id: "cosmic-champs",
    symbol: "cosg",
    name: "Cosmic Champs",
  },
  {
    id: "cosmic-coin",
    symbol: "cosmic",
    name: "Cosmic Coin",
  },
  {
    id: "cosmic-music",
    symbol: "csmc",
    name: "Cosmic Music",
  },
  {
    id: "cosmicswap",
    symbol: "cosmic",
    name: "CosmicSwap",
  },
  {
    id: "cosmic-universe-magic-token",
    symbol: "magic",
    name: "Cosmic Universe Magic",
  },
  {
    id: "cosmo-coin",
    symbol: "cosm",
    name: "Cosmo Coin",
  },
  {
    id: "cosmos",
    symbol: "atom",
    name: "Cosmos Hub",
  },
  {
    id: "cosmostarter",
    symbol: "csms",
    name: "Cosmostarter",
  },
  {
    id: "cosplay-token",
    symbol: "cot",
    name: "Cosplay (OLD)",
  },
  {
    id: "cosplay-token-2",
    symbol: "cot",
    name: "Cosplay",
  },
  {
    id: "cost-coin",
    symbol: "akm",
    name: "COST COIN+",
  },
  {
    id: "coti",
    symbol: "coti",
    name: "COTI",
  },
  {
    id: "cotrader",
    symbol: "cot",
    name: "CoTrader",
  },
  {
    id: "couchain",
    symbol: "cou",
    name: "Couchain",
  },
  {
    id: "council-of-apes",
    symbol: "coape",
    name: "Council of Apes",
  },
  {
    id: "counos-coin",
    symbol: "cca",
    name: "Counos Coin",
  },
  {
    id: "counosx",
    symbol: "ccxx",
    name: "CounosX",
  },
  {
    id: "counterparty",
    symbol: "xcp",
    name: "Counterparty",
  },
  {
    id: "county-metaverse",
    symbol: "county",
    name: "County Metaverse",
  },
  {
    id: "couponbay",
    symbol: "cup",
    name: "CouponBay",
  },
  {
    id: "covalent",
    symbol: "cqt",
    name: "Covalent",
  },
  {
    id: "covalent-cova",
    symbol: "cova",
    name: "Cova Unity",
  },
  {
    id: "covenant-child",
    symbol: "covn",
    name: "Covenant",
  },
  {
    id: "covercompared",
    symbol: "cvr",
    name: "CoverCompared",
  },
  {
    id: "cover-protocol",
    symbol: "cover",
    name: "Cover Protocol",
  },
  {
    id: "covesting",
    symbol: "cov",
    name: "Covesting",
  },
  {
    id: "covicoin",
    symbol: "cvc",
    name: "CoviCoin",
  },
  {
    id: "covid-19-recovery-token",
    symbol: "covdr",
    name: "COVID-19 Recovery",
  },
  {
    id: "covid-doge",
    symbol: "covid doge",
    name: "Covid Doge",
  },
  {
    id: "covid-slice",
    symbol: "covid19",
    name: "Covid Slice",
  },
  {
    id: "cowboy-snake",
    symbol: "cows",
    name: "Cowboy Snake",
  },
  {
    id: "cowcoin",
    symbol: "cc",
    name: "CowCoin",
  },
  {
    id: "cow-inu",
    symbol: "ci",
    name: "Cow Inu",
  },
  {
    id: "cow-protocol",
    symbol: "cow",
    name: "CoW Protocol",
  },
  {
    id: "cowry",
    symbol: "cow",
    name: "COWRY",
  },
  {
    id: "coxswap",
    symbol: "cox",
    name: "Coxswap",
  },
  {
    id: "cpchain",
    symbol: "cpc",
    name: "CPChain",
  },
  {
    id: "cplay-network",
    symbol: "cplay",
    name: "CPLAY Network",
  },
  {
    id: "cpos-cloud-payment",
    symbol: "cpos",
    name: "CPOS Cloud Payment",
  },
  {
    id: "cprop",
    symbol: "cprop",
    name: "CPROP",
  },
  {
    id: "cpuchain",
    symbol: "cpu",
    name: "CPUchain",
  },
  {
    id: "cpucoin",
    symbol: "cpu",
    name: "CPUcoin",
  },
  {
    id: "crabada",
    symbol: "cra",
    name: "Crabada",
  },
  {
    id: "crabada-amulet",
    symbol: "cram",
    name: "Crabada Amulet",
  },
  {
    id: "crafting-finance",
    symbol: "crf",
    name: "Crafting Finance",
  },
  {
    id: "craft-network",
    symbol: "cft",
    name: "Craft network",
  },
  {
    id: "cranx-chain",
    symbol: "granx",
    name: "GranX Chain",
  },
  {
    id: "cratos",
    symbol: "crts",
    name: "Cratos",
  },
  {
    id: "crave",
    symbol: "crave",
    name: "Crave",
  },
  {
    id: "crazy-bunny-equity-token",
    symbol: "cbunny",
    name: "Crazy Bunny Equity",
  },
  {
    id: "crazyminer",
    symbol: "pwr",
    name: "CrazyMiner",
  },
  {
    id: "crazy-rich-coin",
    symbol: "crc",
    name: "Crazy Rich Coin",
  },
  {
    id: "crazytime",
    symbol: "crazytime",
    name: "CrazyTime",
  },
  {
    id: "crb-coin",
    symbol: "crb",
    name: "CRB Coin",
  },
  {
    id: "crd-network",
    symbol: "crd",
    name: "CRD Network",
  },
  {
    id: "crdt",
    symbol: "crdt",
    name: "CRDT",
  },
  {
    id: "cre8r-dao",
    symbol: "cre8r",
    name: "CRE8R DAO",
  },
  {
    id: "cream",
    symbol: "crm",
    name: "Creamcoin",
  },
  {
    id: "cream-2",
    symbol: "cream",
    name: "Cream",
  },
  {
    id: "cream-eth2",
    symbol: "creth2",
    name: "Cream ETH 2",
  },
  {
    id: "creampye",
    symbol: "pye",
    name: "Creampye [OLD]",
  },
  {
    id: "cream-shares",
    symbol: "cshare",
    name: "IceCream Shares",
  },
  {
    id: "cream-wormhole",
    symbol: "cream",
    name: "Cream (Wormhole)",
  },
  {
    id: "creamy",
    symbol: "creamy",
    name: "Creamy",
  },
  {
    id: "creaticles",
    symbol: "cre8",
    name: "Creaticles",
  },
  {
    id: "creativecoin",
    symbol: "crea",
    name: "CREA",
  },
  {
    id: "creator-platform",
    symbol: "ctr",
    name: "Creator Platform",
  },
  {
    id: "creator-protocol",
    symbol: "cre",
    name: "Creator Protocol",
  },
  {
    id: "creature_hunters",
    symbol: "chts",
    name: "Creature Hunters",
  },
  {
    id: "creda",
    symbol: "creda",
    name: "CreDA",
  },
  {
    id: "credefi",
    symbol: "credi",
    name: "Credefi",
  },
  {
    id: "credefi-wormhole",
    symbol: "credi",
    name: "Credefi (Wormhole)",
  },
  {
    id: "credit",
    symbol: "credit",
    name: "TerraCredit",
  },
  {
    id: "credit-2",
    symbol: "credit",
    name: "PROXI DeFi",
  },
  {
    id: "creditcoin-2",
    symbol: "ctc",
    name: "Creditcoin",
  },
  {
    id: "credit-printer",
    symbol: "creditp",
    name: "Credit Printer",
  },
  {
    id: "credits",
    symbol: "cs",
    name: "CREDITS",
  },
  {
    id: "creditum",
    symbol: "credit",
    name: "Creditum",
  },
  {
    id: "credmark",
    symbol: "cmk",
    name: "Credmark",
  },
  {
    id: "creds",
    symbol: "creds",
    name: "Creds",
  },
  {
    id: "creo-engine",
    symbol: "creo",
    name: "Creo Engine",
  },
  {
    id: "crescent-network",
    symbol: "cre",
    name: "Crescent Network",
  },
  {
    id: "cresio",
    symbol: "xcre",
    name: "Cresio",
  },
  {
    id: "crespo",
    symbol: "cso",
    name: "Crespo",
  },
  {
    id: "crevacoin",
    symbol: "creva",
    name: "Crevacoin",
  },
  {
    id: "crex-token",
    symbol: "crex",
    name: "Crex",
  },
  {
    id: "cricket-foundation",
    symbol: "cric",
    name: "Cricket Foundation",
  },
  {
    id: "cricket-star-manager",
    symbol: "csm",
    name: "Cricket Star Manager",
  },
  {
    id: "crimecash",
    symbol: "ccash",
    name: "CrimeCash",
  },
  {
    id: "crimegold",
    symbol: "cgold",
    name: "CrimeGold",
  },
  {
    id: "crime-gold",
    symbol: "crime",
    name: "Crime Gold",
  },
  {
    id: "crinet",
    symbol: "cnt",
    name: "Crinet",
  },
  {
    id: "crir-msh",
    symbol: "msh",
    name: "CRIR MSH",
  },
  {
    id: "croat",
    symbol: "croat",
    name: "CROAT",
  },
  {
    id: "crobank",
    symbol: "bank",
    name: "CroBank",
  },
  {
    id: "croblanc",
    symbol: "croblanc",
    name: "Croblanc",
  },
  {
    id: "crocash",
    symbol: "crocash",
    name: "Crocash",
  },
  {
    id: "crodex",
    symbol: "crx",
    name: "Crodex",
  },
  {
    id: "croeth",
    symbol: "croeth",
    name: "CROETH",
  },
  {
    id: "crogecoin",
    symbol: "croge",
    name: "Crogecoin",
  },
  {
    id: "croissant-games",
    symbol: "croissant",
    name: "Croissant Games",
  },
  {
    id: "croking",
    symbol: "crk",
    name: "Croking",
  },
  {
    id: "crolambos",
    symbol: "crolambos",
    name: "CROLambos",
  },
  {
    id: "cromarket-token",
    symbol: "cm",
    name: "Cromarket",
  },
  {
    id: "cromoon",
    symbol: "moon",
    name: "CroMoon",
  },
  {
    id: "cronaswap",
    symbol: "crona",
    name: "CronaSwap",
  },
  {
    id: "cronodes",
    symbol: "crn",
    name: "CroNodes",
  },
  {
    id: "cronofi-finance",
    symbol: "crono",
    name: "Cronofi Finance",
  },
  {
    id: "cronosphere",
    symbol: "sphere",
    name: "Cronosphere",
  },
  {
    id: "cronos-stable-swap",
    symbol: "cross",
    name: "Cronos Stable Swap",
  },
  {
    id: "cronos-wormhole",
    symbol: "cro",
    name: "Cronos (Wormhole)",
  },
  {
    id: "cronus-finance",
    symbol: "crn",
    name: "Cronus Finance",
  },
  {
    id: "cropbytes",
    symbol: "cbx",
    name: "CropBytes",
  },
  {
    id: "cropperfinance",
    symbol: "crp",
    name: "CropperFinance",
  },
  {
    id: "cro-predict",
    symbol: "crp",
    name: "CRO Predict",
  },
  {
    id: "cross-chain-bch",
    symbol: "ccbch",
    name: "Cross-Chain BCH",
  },
  {
    id: "cross-chain-bridge",
    symbol: "bridge",
    name: "Cross-Chain Bridge",
  },
  {
    id: "cross-chain-capital",
    symbol: "ccc",
    name: "Cross Chain Capital",
  },
  {
    id: "cross-chain-farming",
    symbol: "ccf",
    name: "Cross Chain Farming",
  },
  {
    id: "crosschain-iotx",
    symbol: "ciotx",
    name: "Crosschain IOTX",
  },
  {
    id: "crossfi",
    symbol: "crfi",
    name: "CrossFi",
  },
  {
    id: "crossing-the-yellow-blocks",
    symbol: "cbk",
    name: "Crossing the Yellow Blocks",
  },
  {
    id: "crosspad",
    symbol: "cross",
    name: "CrossPad",
  },
  {
    id: "crossswap",
    symbol: "cswap",
    name: "CrossSwap",
  },
  {
    id: "crosswallet",
    symbol: "cwt",
    name: "CrossWallet",
  },
  {
    id: "crossy-animals",
    symbol: "ca",
    name: "Crossy Animals",
  },
  {
    id: "crotama",
    symbol: "crotama",
    name: "Crotama",
  },
  {
    id: "crowd",
    symbol: "cwd",
    name: "CROWD",
  },
  {
    id: "crowdclassic",
    symbol: "crcl",
    name: "CRowdCLassic",
  },
  {
    id: "crowdhero",
    symbol: "crwd",
    name: "CrowdHero",
  },
  {
    id: "crowdswap",
    symbol: "crowd",
    name: "CrowdSwap",
  },
  {
    id: "crown",
    symbol: "crw",
    name: "Crown",
  },
  {
    id: "crowns",
    symbol: "cws",
    name: "Seascape Crowns",
  },
  {
    id: "crown-sovereign",
    symbol: "csov",
    name: "Crown Sovereign",
  },
  {
    id: "crownsterling",
    symbol: "wcsov",
    name: "CrownSterling",
  },
  {
    id: "crown-token",
    symbol: "cwt",
    name: "Crown CWT",
  },
  {
    id: "crowny-token",
    symbol: "crwny",
    name: "Crowny",
  },
  {
    id: "crow-token",
    symbol: "crow",
    name: "Crow",
  },
  {
    id: "croxswap",
    symbol: "crox",
    name: "CroxSwap",
  },
  {
    id: "crude-token",
    symbol: "crude",
    name: "Crude",
  },
  {
    id: "crusaders-of-crypto",
    symbol: "crusader",
    name: "Crusaders of Crypto",
  },
  {
    id: "crust-network",
    symbol: "cru",
    name: "Crust Network",
  },
  {
    id: "crust-storage-market",
    symbol: "csm",
    name: "Crust Shadow",
  },
  {
    id: "cryb",
    symbol: "cryb",
    name: "Cryb",
  },
  {
    id: "crybet",
    symbol: "cbt",
    name: "CryBet",
  },
  {
    id: "crycash",
    symbol: "crc",
    name: "CRYCASH",
  },
  {
    id: "cry-coin",
    symbol: "cryy",
    name: "Cry Coin",
  },
  {
    id: "cryn",
    symbol: "cryn",
    name: "CRYN",
  },
  {
    id: "cryowar-token",
    symbol: "cwar",
    name: "Cryowar",
  },
  {
    id: "crypcade-shares",
    symbol: "cade",
    name: "CrypCade Shares",
  },
  {
    id: "cryptalk",
    symbol: "cryp",
    name: "Cryptalk",
  },
  {
    id: "cryptaur",
    symbol: "cpt",
    name: "Cryptaur",
  },
  {
    id: "crypterium",
    symbol: "crpt",
    name: "Crypterium",
  },
  {
    id: "cryptertoken",
    symbol: "crypt",
    name: "Crypter",
  },
  {
    id: "cryptex",
    symbol: "crx",
    name: "CryptEx",
  },
  {
    id: "cryptex-finance",
    symbol: "ctx",
    name: "Cryptex Finance",
  },
  {
    id: "cryptia",
    symbol: "crypt",
    name: "Cryptia",
  },
  {
    id: "cryptid",
    symbol: "cid",
    name: "Cryptid",
  },
  {
    id: "cryption-network",
    symbol: "cnt",
    name: "Cryption Network",
  },
  {
    id: "crypto20",
    symbol: "c20",
    name: "CRYPTO20",
  },
  {
    id: "crypto-accept",
    symbol: "acpt",
    name: "Crypto Accept",
  },
  {
    id: "crypto-application-token",
    symbol: "capp",
    name: "Crypto Application",
  },
  {
    id: "crypto-arcade-punk",
    symbol: "c-arcade",
    name: "Crypto Arcade Punk",
  },
  {
    id: "cryptoart-ai",
    symbol: "cart",
    name: "CryptoArt.Ai",
  },
  {
    id: "cryptoball",
    symbol: "cryptoball",
    name: "CryptoBall",
  },
  {
    id: "crypto-bank",
    symbol: "cbank",
    name: "Crypto Bank",
  },
  {
    id: "crypto-bank-token",
    symbol: "cbt",
    name: "Crypto Bank Token",
  },
  {
    id: "cryptobattles",
    symbol: "cbt",
    name: "CryptoBattles",
  },
  {
    id: "cryptobay",
    symbol: "bay",
    name: "CryptoBay",
  },
  {
    id: "crypto-bay",
    symbol: "pearl",
    name: "Crypto Bay",
  },
  {
    id: "cryptobike",
    symbol: "cb",
    name: "CryptoBike",
  },
  {
    id: "crypto-bike-riders",
    symbol: "riders",
    name: "Crypto Bike Riders",
  },
  {
    id: "crypto-birds",
    symbol: "xcb",
    name: "Crypto Birds",
  },
  {
    id: "cryptoblades",
    symbol: "skill",
    name: "CryptoBlades",
  },
  {
    id: "cryptoblades-kingdoms",
    symbol: "king",
    name: "CryptoBlades Kingdoms",
  },
  {
    id: "cryptoblast",
    symbol: "cbt",
    name: "CryptoBlast",
  },
  {
    id: "cryptobonusmiles",
    symbol: "cbm",
    name: "CryptoBonusMiles",
  },
  {
    id: "cryptobosscoin",
    symbol: "cbc",
    name: "CryptoBossCoin",
  },
  {
    id: "cryptobucks",
    symbol: "cbucks",
    name: "CRYPTOBUCKS",
  },
  {
    id: "cryptobuyer-token",
    symbol: "xpt",
    name: "Cryptobuyer",
  },
  {
    id: "crypto-candy",
    symbol: "candy",
    name: "Crypto Candy",
  },
  {
    id: "crypto-carbon-energy",
    symbol: "cyce",
    name: "Crypto Carbon Energy",
  },
  {
    id: "cryptocars",
    symbol: "ccar",
    name: "CryptoCars",
  },
  {
    id: "cryptocart",
    symbol: "ccv2",
    name: "CryptoCart V2",
  },
  {
    id: "cryptocat",
    symbol: "ccat",
    name: "CryptoCat",
  },
  {
    id: "cryptocean",
    symbol: "cron",
    name: "Cryptocean",
  },
  {
    id: "crypto-chip",
    symbol: "bvc",
    name: "Crypto Chip",
  },
  {
    id: "cryptochrome",
    symbol: "chm",
    name: "Cryptochrome",
  },
  {
    id: "cryptocitizen",
    symbol: "ccash",
    name: "CryptoCitizen",
  },
  {
    id: "cryptoclans",
    symbol: "coc",
    name: "CryptoClans",
  },
  {
    id: "crypto-classic",
    symbol: "crc",
    name: "Crypto Classic",
  },
  {
    id: "cryptocoinpay",
    symbol: "ccp",
    name: "CryptoCoinPay",
  },
  {
    id: "crypto-com-chain",
    symbol: "cro",
    name: "Cronos",
  },
  {
    id: "crypto-crash-gaming",
    symbol: "ccg",
    name: "Crypto Crash Gaming",
  },
  {
    id: "cryptocricketclub",
    symbol: "3cs",
    name: "CryptoCricketClub",
  },
  {
    id: "cryptocurrency-market-index",
    symbol: "cmi",
    name: "Cryptocurrency Market Index",
  },
  {
    id: "cryptocurrency-top-10-tokens-index",
    symbol: "cc10",
    name: "Cryptocurrency Top 10 Index",
  },
  {
    id: "crypto-development-services",
    symbol: "cds",
    name: "Crypto Development Services",
  },
  {
    id: "cryptodicehero",
    symbol: "hro",
    name: "CryptoDiceHero",
  },
  {
    id: "cryptodogs",
    symbol: "crd",
    name: "CryptoDogs",
  },
  {
    id: "cryptodrop",
    symbol: "juice",
    name: "CryptoDrop",
  },
  {
    id: "cryptoenergy",
    symbol: "cnrg",
    name: "CryptoEnergy",
  },
  {
    id: "crypto-energy-token",
    symbol: "cet",
    name: "Crypto Energy",
  },
  {
    id: "crypto-excellence",
    symbol: "ce",
    name: "Crypto Excellence",
  },
  {
    id: "cryptoexpress",
    symbol: "xpress",
    name: "CryptoXpress",
  },
  {
    id: "crypto-fantasy-coin",
    symbol: "cfc",
    name: "Crypto Fantasy Coin",
  },
  {
    id: "crypto-fantasy-league",
    symbol: "cfl",
    name: "Crypto Fantasy League",
  },
  {
    id: "cryptofarming",
    symbol: "$cfar",
    name: "CryptoFarming",
  },
  {
    id: "cryptofifa",
    symbol: "ffa",
    name: "FFA.Games",
  },
  {
    id: "crypto-fight-club",
    symbol: "fight",
    name: "Crypto Fight Club",
  },
  {
    id: "cryptoflow",
    symbol: "cfl",
    name: "Cryptoflow",
  },
  {
    id: "cryptofootball",
    symbol: "ballz",
    name: "CryptoFootball",
  },
  {
    id: "cryptofranc",
    symbol: "xchf",
    name: "CryptoFranc",
  },
  {
    id: "cryptogamez",
    symbol: "cgaz",
    name: "CryptoGamez",
  },
  {
    id: "crypto-gaming-united",
    symbol: "cgu",
    name: "Crypto Gaming United",
  },
  {
    id: "cryptogangsters",
    symbol: "cgang",
    name: "CryptoGangsters",
  },
  {
    id: "cryptogcoin",
    symbol: "crg",
    name: "Cryptogcoin",
  },
  {
    id: "crypto-gladiator-shards",
    symbol: "cgs",
    name: "Crypto Gladiator Shards",
  },
  {
    id: "cryptogodz",
    symbol: "godz",
    name: "Cryptogodz",
  },
  {
    id: "cryptogram",
    symbol: "cryptogram",
    name: "Cryptogram",
  },
  {
    id: "cryptoguards",
    symbol: "cgar",
    name: "CryptoGuards",
  },
  {
    id: "cryptoheadz",
    symbol: "headz",
    name: "Cryptoheadz",
  },
  {
    id: "crypto-holding-frank-token",
    symbol: "chft",
    name: "Crypto Holding Frank",
  },
  {
    id: "cryptohorse",
    symbol: "chorse",
    name: "CryptoHorse",
  },
  {
    id: "cryptoids-admin-coin",
    symbol: "cac",
    name: "Cryptoids Admin Coin",
  },
  {
    id: "cryptoids-game-coin",
    symbol: "cgc",
    name: "Cryptoids Game Coin",
  },
  {
    id: "cryptoindex-io",
    symbol: "cix100",
    name: "Cryptoindex.com 100",
  },
  {
    id: "crypto-international",
    symbol: "cri",
    name: "Crypto International",
  },
  {
    id: "crypto-inu",
    symbol: "abcd",
    name: "Crypto Inu",
  },
  {
    id: "crypto-island",
    symbol: "cisla",
    name: "Crypto Island",
  },
  {
    id: "crypto-jackpot",
    symbol: "cjp",
    name: "Crypto Jackpot",
  },
  {
    id: "cryptojetski",
    symbol: "cjet",
    name: "CryptoJetski",
  },
  {
    id: "crypto-kart-racing",
    symbol: "ckracing",
    name: "Crypto Kart Racing",
  },
  {
    id: "cryptokek",
    symbol: "kek",
    name: "Cryptokek",
  },
  {
    id: "cryptokenz",
    symbol: "cyt",
    name: "Cryptokenz",
  },
  {
    id: "crypto-klash",
    symbol: "klh",
    name: "Crypto Klash",
  },
  {
    id: "crypto-kombat",
    symbol: "kombat",
    name: "Crypto Kombat",
  },
  {
    id: "cryptoku",
    symbol: "cku",
    name: "Cryptoku",
  },
  {
    id: "cryptolion",
    symbol: "clion",
    name: "CryptoLion",
  },
  {
    id: "cryptomafia",
    symbol: "$cmf",
    name: "CryptoMafia",
  },
  {
    id: "crypto-makers-foundation",
    symbol: "cmf",
    name: "Crypto Makers Foundation",
  },
  {
    id: "cryptomeda",
    symbol: "tech",
    name: "Cryptomeda",
  },
  {
    id: "crypto-media-network",
    symbol: "cmn",
    name: "Crypto Media Network",
  },
  {
    id: "cryptomines-eternal",
    symbol: "eternal",
    name: "CryptoMines Eternal",
  },
  {
    id: "cryptomines-reborn",
    symbol: "crux",
    name: "CryptoMines Reborn",
  },
  {
    id: "cryptomoonshots",
    symbol: "cms",
    name: "CryptoMoonShots",
  },
  {
    id: "cryptomotorcycle",
    symbol: "cmc",
    name: "CryptoMotorcycle",
  },
  {
    id: "crypto-mushroomz",
    symbol: "shroomz",
    name: "Crypto Mushroomz",
  },
  {
    id: "cryptoneur-network-foundation",
    symbol: "cnf",
    name: "CryptoNeur Network foundation",
  },
  {
    id: "cryptonex",
    symbol: "cnx",
    name: "Cryptonex",
  },
  {
    id: "cryptonia-poker",
    symbol: "cnp",
    name: "Cryptonia Poker",
  },
  {
    id: "cryptonite-token",
    symbol: "ctnt",
    name: "CryptoniteGame",
  },
  {
    id: "cryptonits",
    symbol: "crt",
    name: "Cryptonits",
  },
  {
    id: "crypto-nodes",
    symbol: "crnd",
    name: "Crypto Nodes",
  },
  {
    id: "cryptonovae",
    symbol: "yae",
    name: "Cryptonovae",
  },
  {
    id: "cryptopay",
    symbol: "cpay",
    name: "Cryptopay",
  },
  {
    id: "cryptoperformance-coin",
    symbol: "cpc",
    name: "CryptoPerformance Coin",
  },
  {
    id: "crypto-perx",
    symbol: "cprx",
    name: "Crypto Perx",
  },
  {
    id: "crypto-phoenix",
    symbol: "cphx",
    name: "Crypto Phoenix",
  },
  {
    id: "crypto-piece",
    symbol: "belly",
    name: "Crypto Piece",
  },
  {
    id: "cryptoplanes",
    symbol: "cpan",
    name: "CryptoPlanes",
  },
  {
    id: "cryptoplants",
    symbol: "cpc",
    name: "CryptoPlants Club",
  },
  {
    id: "cryptopolis",
    symbol: "cpo",
    name: "Cryptopolis",
  },
  {
    id: "crypto-pote-token",
    symbol: "pope",
    name: "Crypto Pote",
  },
  {
    id: "crypto-price-index",
    symbol: "cpi",
    name: "Crypto Price Index",
  },
  {
    id: "cryptoprofile",
    symbol: "cp",
    name: "CryptoProfile",
  },
  {
    id: "crypto-puffs",
    symbol: "puffs",
    name: "Crypto Puffs",
  },
  {
    id: "cryptopunk-7171-hoodie",
    symbol: "hoodie",
    name: "CryptoPunk #7171",
  },
  {
    id: "cryptopunt",
    symbol: "pun",
    name: "CryptoPunt",
  },
  {
    id: "crypto-raiders",
    symbol: "raider",
    name: "Crypto Raiders",
  },
  {
    id: "crypto-realms-war",
    symbol: "yny",
    name: "Crypto Realms War",
  },
  {
    id: "cryptorewards",
    symbol: "crs",
    name: "Crypto Rewards Studio",
  },
  {
    id: "cryptorg-token",
    symbol: "ctg",
    name: "Cryptorg",
  },
  {
    id: "crypto-rocket-launch",
    symbol: "crl",
    name: "Crypto Rocket Launch",
  },
  {
    id: "cryptorockets",
    symbol: "crocket",
    name: "CryptoRockets",
  },
  {
    id: "crypto-royale",
    symbol: "roy",
    name: "Crypto Royale",
  },
  {
    id: "cryptorpg",
    symbol: "rpg",
    name: "CryptoRPG",
  },
  {
    id: "cryptorun-network",
    symbol: "crn",
    name: "Cryptorun Network",
  },
  {
    id: "cryptosaga",
    symbol: "saga",
    name: "CryptoSaga",
  },
  {
    id: "cryptoshares",
    symbol: "shares",
    name: "Cryptoshares",
  },
  {
    id: "crypto-shield",
    symbol: "shield",
    name: "Crypto Shield",
  },
  {
    id: "cryptoships",
    symbol: "cship",
    name: "CryptoShips",
  },
  {
    id: "cryptoskates",
    symbol: "cst",
    name: "CryptoSkates",
  },
  {
    id: "crypto-snack",
    symbol: "snack",
    name: "Crypto Snack",
  },
  {
    id: "crypto-soccer",
    symbol: "csc",
    name: "Crypto Soccer",
  },
  {
    id: "cryptosoul",
    symbol: "soul",
    name: "CryptoSoul",
  },
  {
    id: "crypto-sports",
    symbol: "cspn",
    name: "Crypto Sports",
  },
  {
    id: "crypto-stake-token",
    symbol: "cst",
    name: "CryptoStake",
  },
  {
    id: "cryptosword",
    symbol: "swd",
    name: "CryptoSword",
  },
  {
    id: "cryptotanks",
    symbol: "tank",
    name: "CryptoTanks",
  },
  {
    id: "cryptotask-2",
    symbol: "ctask",
    name: "CryptoTask",
  },
  {
    id: "cryptotaxis-token",
    symbol: "ctax",
    name: "Cryptotaxis",
  },
  {
    id: "cryptotem",
    symbol: "totem",
    name: "Cryptotem",
  },
  {
    id: "crypto-tex",
    symbol: "ctex",
    name: "Crypto Tex",
  },
  {
    id: "cryptotrains",
    symbol: "ctrain",
    name: "CryptoTrains",
  },
  {
    id: "cryptotycoon",
    symbol: "ctt",
    name: "CryptoTycoon",
  },
  {
    id: "cryptounit",
    symbol: "cru",
    name: "Cryptounit",
  },
  {
    id: "crypto-vault",
    symbol: "cvt",
    name: "Crypto Vault",
  },
  {
    id: "cryptoverificationcoin",
    symbol: "cvcc",
    name: "CryptoVerificationCoin",
  },
  {
    id: "cryptoverse",
    symbol: "",
    name: "Cryptoverse",
  },
  {
    id: "crypto-village-accelerator",
    symbol: "cva",
    name: "Crypto Village Accelerator",
  },
  {
    id: "crypto-village-accelerator-cvag",
    symbol: "cvag",
    name: "Crypto Village Accelerator CVAG",
  },
  {
    id: "crypto-volatility-token",
    symbol: "cvol",
    name: "Crypto Volatility",
  },
  {
    id: "cryptovszombie",
    symbol: "cvz",
    name: "CryptoVsZombie",
  },
  {
    id: "cryptowar-xblade",
    symbol: "open",
    name: "OpenWorld",
  },
  {
    id: "cryptowolf",
    symbol: "cwolf",
    name: "CryptoWolf",
  },
  {
    id: "cryptoworld-vip",
    symbol: "cwv",
    name: "CryptoWorld.VIP",
  },
  {
    id: "crypto-wrestling-inu",
    symbol: "$cwi",
    name: "Crypto Wrestling Inu",
  },
  {
    id: "cryptozerofi",
    symbol: "zeri",
    name: "CryptoZerofi",
  },
  {
    id: "cryptozoo",
    symbol: "zoo",
    name: "CryptoZoo",
  },
  {
    id: "cryptozoon",
    symbol: "zoon",
    name: "CryptoZoon",
  },
  {
    id: "cryptrust",
    symbol: "ctrt",
    name: "Cryptrust",
  },
  {
    id: "cryptyk",
    symbol: "ctk",
    name: "Cryptyk",
  },
  {
    id: "crystal-clear",
    symbol: "cct",
    name: "Crystal Clear",
  },
  {
    id: "crystal-kingdoms",
    symbol: "ckg",
    name: "Crystal Kingdoms",
  },
  {
    id: "crystal-of-dragon",
    symbol: "cod",
    name: "Crystal Of Dragon",
  },
  {
    id: "crystal-powder",
    symbol: "cp",
    name: "Crystal Powder",
  },
  {
    id: "crystal-token",
    symbol: "cyl",
    name: "Crystal CYL",
  },
  {
    id: "crystl-finance",
    symbol: "crystl",
    name: "Crystl Finance",
  },
  {
    id: "cspc",
    symbol: "cspc",
    name: "CSPC",
  },
  {
    id: "csp-dao-network",
    symbol: "nebo",
    name: "CSP DAO Network",
  },
  {
    id: "csr",
    symbol: "csr",
    name: "CSR",
  },
  {
    id: "ctc",
    symbol: "c2c",
    name: "C2C System",
  },
  {
    id: "ctc-2",
    symbol: "ctc",
    name: "CTC",
  },
  {
    id: "c-token-2",
    symbol: "c",
    name: "Carbon Coin",
  },
  {
    id: "ctomorrow-platform",
    symbol: "ctp",
    name: "Ctomorrow Platform",
  },
  {
    id: "cts-coin",
    symbol: "ctsc",
    name: "Crypto Trading Solutions Coin",
  },
  {
    id: "cube",
    symbol: "itamcube",
    name: "CUBE",
  },
  {
    id: "cube-intelligence",
    symbol: "auto",
    name: "Cube Intelligence",
  },
  {
    id: "cube-token",
    symbol: "cube",
    name: "Tower Finance Cube",
  },
  {
    id: "cub-finance",
    symbol: "cub",
    name: "Cub Finance",
  },
  {
    id: "cubiex",
    symbol: "cbix",
    name: "Cubiex",
  },
  {
    id: "cubiex-power",
    symbol: "cbix-p",
    name: "Cubiex Power",
  },
  {
    id: "cubo",
    symbol: "cubo",
    name: "Cubo",
  },
  {
    id: "cudl-finance",
    symbol: "cudl",
    name: "Cudl Finance",
  },
  {
    id: "cudos",
    symbol: "cudos",
    name: "Cudos",
  },
  {
    id: "cuex",
    symbol: "ccap",
    name: "CUEX Capital",
  },
  {
    id: "cuffies",
    symbol: "$cuffies",
    name: "Cuffies",
  },
  {
    id: "cujo-inu",
    symbol: "cujo",
    name: "Cujo Inu",
  },
  {
    id: "cult-dao",
    symbol: "cult",
    name: "Cult DAO",
  },
  {
    id: "cultiplan",
    symbol: "ctpl",
    name: "Cultiplan",
  },
  {
    id: "culture-ticket-chain",
    symbol: "ctc",
    name: "Culture Ticket Chain",
  },
  {
    id: "cuminu",
    symbol: "cuminu",
    name: "Cuminu",
  },
  {
    id: "cumrocket",
    symbol: "cummies",
    name: "CumRocket",
  },
  {
    id: "cupid-farm",
    symbol: "arrows",
    name: "Cupid Farm",
  },
  {
    id: "curate",
    symbol: "xcur",
    name: "Curate",
  },
  {
    id: "curecoin",
    symbol: "cure",
    name: "Curecoin",
  },
  {
    id: "cure-token-v2",
    symbol: "cure",
    name: "CURE V2",
  },
  {
    id: "curio-governance",
    symbol: "cgt",
    name: "Curio Governance",
  },
  {
    id: "curryswap",
    symbol: "curry",
    name: "CurrySwap",
  },
  {
    id: "curve-dao-token",
    symbol: "crv",
    name: "Curve DAO",
  },
  {
    id: "curve-dao-token-wormhole",
    symbol: "crv",
    name: "Curve DAO Token (Wormhole)",
  },
  {
    id: "curve-fi-gdai-gusdc-gusdt",
    symbol: "g3crv",
    name: "Curve.fi gDAI/gUSDC/gUSDT",
  },
  {
    id: "curve-fi-ydai-yusdc-yusdt-ytusd",
    symbol: "ycurve",
    name: "LP-yCurve",
  },
  {
    id: "curvehash",
    symbol: "curve",
    name: "CURVEHASH",
  },
  {
    id: "custom-contract-network",
    symbol: "ccn",
    name: "Custom contract network",
  },
  {
    id: "cutcoin",
    symbol: "cut",
    name: "CUTcoin",
  },
  {
    id: "cvault-finance",
    symbol: "core",
    name: "cVault.finance",
  },
  {
    id: "cvd19",
    symbol: "cvd19",
    name: "CVD19",
  },
  {
    id: "cvip",
    symbol: "cvip",
    name: "CVIP",
  },
  {
    id: "cvnx",
    symbol: "cvnx",
    name: "CVNX",
  },
  {
    id: "cvshots",
    symbol: "cvshot",
    name: "CVSHOTS",
  },
  {
    id: "cxcoin",
    symbol: "cx",
    name: "CxCoin",
  },
  {
    id: "cxrbn-token",
    symbol: "cxrbn",
    name: "CXRBN",
  },
  {
    id: "cyberclassic",
    symbol: "class",
    name: "Cyberclassic",
  },
  {
    id: "cyber-crystal",
    symbol: "crystal",
    name: "Cyber Crystal",
  },
  {
    id: "cyberdao",
    symbol: "cyber",
    name: "CyberDAO",
  },
  {
    id: "cyberdoge",
    symbol: "cybrrrdoge",
    name: "CyberDoge",
  },
  {
    id: "cyberdragon-gold",
    symbol: "gold",
    name: "CyberDragon Gold",
  },
  {
    id: "cyberfi",
    symbol: "cfi",
    name: "CyberFi",
  },
  {
    id: "cyberfm",
    symbol: "cyfm",
    name: "CyberFM",
  },
  {
    id: "cyberkongz",
    symbol: "kongz20",
    name: "CYBERKONGZ",
  },
  {
    id: "cybermiles",
    symbol: "cmt",
    name: "CyberMiles",
  },
  {
    id: "cyber-movie-chain",
    symbol: "cmct",
    name: "Cyber Movie Chain",
  },
  {
    id: "cybermusic",
    symbol: "cymt",
    name: "CyberMusic",
  },
  {
    id: "cybertime-finance",
    symbol: "ctf",
    name: "CyberTime Finance",
  },
  {
    id: "cybertronchain",
    symbol: "ctc",
    name: "CyberTronchain",
  },
  {
    id: "cybervein",
    symbol: "cvt",
    name: "CyberVein",
  },
  {
    id: "cybex",
    symbol: "cyb",
    name: "Cybex",
  },
  {
    id: "cybloc-battery-token",
    symbol: "cbt",
    name: "CyBall CyBloc Battery",
  },
  {
    id: "cyborg-apes",
    symbol: "borg",
    name: "Cyborg Apes",
  },
  {
    id: "cyborgswap",
    symbol: "cbo",
    name: "CyborgSwap",
  },
  {
    id: "cycan-network",
    symbol: "cyn",
    name: "Cycan Network",
  },
  {
    id: "cycle-token",
    symbol: "cycle",
    name: "Cycle",
  },
  {
    id: "cyclone-protocol",
    symbol: "cyc",
    name: "Cyclone Protocol",
  },
  {
    id: "cyclops-treasure",
    symbol: "cytr",
    name: "Cyclops Treasure",
  },
  {
    id: "cyclos",
    symbol: "cys",
    name: "Cykura",
  },
  {
    id: "cylum-finance",
    symbol: "cym",
    name: "Cylum Finance",
  },
  {
    id: "cyn-c",
    symbol: "cync",
    name: "Cyn-C",
  },
  {
    id: "cyop-protocol",
    symbol: "cyop",
    name: "CyOp Protocol",
  },
  {
    id: "cypherium",
    symbol: "cph",
    name: "Cypherium",
  },
  {
    id: "czfarm",
    symbol: "czf",
    name: "CZFarm",
  },
  {
    id: "czusd",
    symbol: "czusd",
    name: "CZUSD",
  },
  {
    id: "d3",
    symbol: "defi",
    name: "D3",
  },
  {
    id: "dabb-doge",
    symbol: "ddoge",
    name: "Dabb Doge",
  },
  {
    id: "dab-coin",
    symbol: "dab",
    name: "DAB Coin",
  },
  {
    id: "dacc",
    symbol: "dacc",
    name: "DACC",
  },
  {
    id: "dacxi",
    symbol: "dacxi",
    name: "Dacxi",
  },
  {
    id: "daddybezos",
    symbol: "djbz",
    name: "DaddyBezos",
  },
  {
    id: "daddy-doge",
    symbol: "daddydoge",
    name: "Daddy Doge",
  },
  {
    id: "daddy-dogeback",
    symbol: "daddydb",
    name: "Daddy Dogeback",
  },
  {
    id: "daddyeth",
    symbol: "daddyeth",
    name: "DaddyETH",
  },
  {
    id: "daddyusdt",
    symbol: "daddyusdt",
    name: "DaddyUSDT",
  },
  {
    id: "daddyyorkie",
    symbol: "ddy",
    name: "DaddyYorkie",
  },
  {
    id: "daex",
    symbol: "dax",
    name: "DAEX",
  },
  {
    id: "dafin",
    symbol: "daf",
    name: "DaFIN",
  },
  {
    id: "dafi-protocol",
    symbol: "dafi",
    name: "Dafi Protocol",
  },
  {
    id: "dagger",
    symbol: "xdag",
    name: "Dagger",
  },
  {
    id: "dai",
    symbol: "dai",
    name: "Dai",
  },
  {
    id: "daikicoin",
    symbol: "dic",
    name: "Daikicoin",
  },
  {
    id: "daikokuten-sama",
    symbol: "dkks",
    name: "Daikokuten Sama",
  },
  {
    id: "daily-cop",
    symbol: "dlycop",
    name: "Daily COP",
  },
  {
    id: "dain-token",
    symbol: "dain",
    name: "Dain",
  },
  {
    id: "dairy-money-milk",
    symbol: "milk",
    name: "Dairy.Money MILK",
  },
  {
    id: "dai-stablecoin-wormhole",
    symbol: "daipo",
    name: "Dai Stablecoin (Wormhole)",
  },
  {
    id: "daisy",
    symbol: "daisy",
    name: "Daisy Protocol",
  },
  {
    id: "dai-wormhole",
    symbol: "dai",
    name: "DAI (Wormhole)",
  },
  {
    id: "dalecoin",
    symbol: "dalc",
    name: "Dalecoin",
  },
  {
    id: "dali",
    symbol: "dali",
    name: "DALI",
  },
  {
    id: "dama",
    symbol: "dama",
    name: "DAMA",
  },
  {
    id: "damn-token",
    symbol: "damn",
    name: "DAMN",
  },
  {
    id: "danat-coin",
    symbol: "dnc",
    name: "Danat Coin",
  },
  {
    id: "dandy",
    symbol: "dandy",
    name: "Dandy Dego",
  },
  {
    id: "dangermoon",
    symbol: "dangermoon",
    name: "DangerMoon",
  },
  {
    id: "dante-finance",
    symbol: "dante",
    name: "Dante Finance",
  },
  {
    id: "dao1",
    symbol: "dao1",
    name: "DAO1",
  },
  {
    id: "daobao",
    symbol: "bao",
    name: "DAOBAO",
  },
  {
    id: "dao-farmer-daof",
    symbol: "daof",
    name: "DAO Farmer DAOF",
  },
  {
    id: "dao-farmer-dfg",
    symbol: "dfg",
    name: "DAO Farmer DFG",
  },
  {
    id: "dao-farmer-dfm",
    symbol: "dfm",
    name: "DAO Farmer DFM",
  },
  {
    id: "dao-farmer-dfw",
    symbol: "dfw",
    name: "DAO Farmer DFW",
  },
  {
    id: "daohaus",
    symbol: "haus",
    name: "DAOhaus",
  },
  {
    id: "dao-invest",
    symbol: "vest",
    name: "DAO Invest",
  },
  {
    id: "daoland",
    symbol: "dld",
    name: "Daoland",
  },
  {
    id: "daolaunch",
    symbol: "dal",
    name: "DAOLaunch",
  },
  {
    id: "dao-maker",
    symbol: "dao",
    name: "DAO Maker",
  },
  {
    id: "dao-maker-wormhole",
    symbol: "dao",
    name: "DAO Maker (Wormhole)",
  },
  {
    id: "daopolis-token",
    symbol: "daos",
    name: "Daopolis",
  },
  {
    id: "daosol",
    symbol: "daosol",
    name: "daoSOL",
  },
  {
    id: "daosquare",
    symbol: "rice",
    name: "DAOSquare",
  },
  {
    id: "daostack",
    symbol: "gen",
    name: "DAOstack",
  },
  {
    id: "daovc",
    symbol: "daovc",
    name: "DAOvc",
  },
  {
    id: "daoventures",
    symbol: "dvd",
    name: "DAOventures",
  },
  {
    id: "dapp",
    symbol: "dapp",
    name: "LiquidApps",
  },
  {
    id: "dappatoz",
    symbol: "dcash",
    name: "Dappatoz",
  },
  {
    id: "dapp-com",
    symbol: "dappt",
    name: "Dapp.com",
  },
  {
    id: "dappercoin",
    symbol: "dapp",
    name: "DapperCoin",
  },
  {
    id: "dappnode",
    symbol: "node",
    name: "DAppNode",
  },
  {
    id: "dappradar",
    symbol: "radar",
    name: "DappRadar",
  },
  {
    id: "dappstore",
    symbol: "dappx",
    name: "dAppstore",
  },
  {
    id: "dappsy",
    symbol: "app",
    name: "Dappsy",
  },
  {
    id: "daps-token",
    symbol: "daps",
    name: "DAPS Coin",
  },
  {
    id: "darcmatter-coin",
    symbol: "darc",
    name: "Konstellation",
  },
  {
    id: "dar-dex-token",
    symbol: "ddt",
    name: "Dar Dex",
  },
  {
    id: "darenft",
    symbol: "dnft",
    name: "DareNFT",
  },
  {
    id: "dareplay",
    symbol: "dpl",
    name: "DarePlay",
  },
  {
    id: "darkcrypto",
    symbol: "dark",
    name: "DarkCrypto",
  },
  {
    id: "darkcrypto-share",
    symbol: "sky",
    name: "DarkCrypto Share",
  },
  {
    id: "dark-energy-crystals",
    symbol: "dec",
    name: "Dark Energy Crystals",
  },
  {
    id: "dark-frontiers",
    symbol: "dark",
    name: "Dark Frontiers",
  },
  {
    id: "darkgang-finance",
    symbol: "darkg",
    name: "DarkGang Finance",
  },
  {
    id: "darkknight",
    symbol: "dknight",
    name: "Dark Knight",
  },
  {
    id: "dark-land-survival",
    symbol: "big",
    name: "Dark Land Survival",
  },
  {
    id: "dark-magic",
    symbol: "dmagic",
    name: "Dark Magic",
  },
  {
    id: "darkmatter",
    symbol: "dmt",
    name: "DarkMatter",
  },
  {
    id: "dark-matter",
    symbol: "dmt",
    name: "Dark Matter",
  },
  {
    id: "dark-matter-defi",
    symbol: "dmd",
    name: "Dark Matter Defi",
  },
  {
    id: "dark-matter-token",
    symbol: "dkmt",
    name: "Vibranium Dark Matter",
  },
  {
    id: "darkness-dollar",
    symbol: "dusd",
    name: "Darkness Dollar",
  },
  {
    id: "darkness-share",
    symbol: "ness",
    name: "Darkness Share",
  },
  {
    id: "darkopera-finance",
    symbol: "darko",
    name: "DarkOpera Finance",
  },
  {
    id: "darkpaycoin",
    symbol: "d4rk",
    name: "DARK",
  },
  {
    id: "dark-planet",
    symbol: "dp",
    name: "Dark Planet",
  },
  {
    id: "darkshield",
    symbol: "dks",
    name: "DarkShield",
  },
  {
    id: "darleygo-essence",
    symbol: "dge",
    name: "DarleyGo Essence",
  },
  {
    id: "darma-cash",
    symbol: "dmch",
    name: "Darma Cash",
  },
  {
    id: "dart-insurance",
    symbol: "dart",
    name: "dART Insurance",
  },
  {
    id: "dart-inu",
    symbol: "dart",
    name: "Dart Inu",
  },
  {
    id: "darwinia-commitment-token",
    symbol: "kton",
    name: "Darwinia Commitment",
  },
  {
    id: "darwinia-crab-network",
    symbol: "crab",
    name: "Darwinia Crab Network Native",
  },
  {
    id: "darwinia-network-native-token",
    symbol: "ring",
    name: "Darwinia Network",
  },
  {
    id: "dascoin",
    symbol: "grn",
    name: "GreenPower",
  },
  {
    id: "dash",
    symbol: "dash",
    name: "Dash",
  },
  {
    id: "dash-diamond",
    symbol: "dashd",
    name: "Dash Diamond",
  },
  {
    id: "dashsports",
    symbol: "dass",
    name: "DashSports",
  },
  {
    id: "data",
    symbol: "dta",
    name: "DATA",
  },
  {
    id: "databroker-dao",
    symbol: "dtx",
    name: "DaTa eXchange DTX",
  },
  {
    id: "datachain-foundation",
    symbol: "dc",
    name: "DATACHAIN FOUNDATION",
  },
  {
    id: "datacoin",
    symbol: "dtc",
    name: "Datacoin",
  },
  {
    id: "data-economy-index",
    symbol: "data",
    name: "Data Economy Index",
  },
  {
    id: "data-enterprise-chain",
    symbol: "dec",
    name: "Data Enterprise Chain",
  },
  {
    id: "datahighway",
    symbol: "dhx",
    name: "DataHighway",
  },
  {
    id: "datakyc",
    symbol: "dkyc",
    name: "DataKYC",
  },
  {
    id: "datamine",
    symbol: "dam",
    name: "Datamine",
  },
  {
    id: "datx",
    symbol: "datx",
    name: "DATx",
  },
  {
    id: "dav",
    symbol: "dav",
    name: "DAV Network",
  },
  {
    id: "davidcoin",
    symbol: "dc",
    name: "DavidCoin",
  },
  {
    id: "davinci-coin",
    symbol: "dac",
    name: "Davinci Coin",
  },
  {
    id: "davis-cup-fan-token",
    symbol: "davis",
    name: "Davis Cup Fan Token",
  },
  {
    id: "dawg",
    symbol: "dawg",
    name: "DAWG",
  },
  {
    id: "dawn-of-gods",
    symbol: "dago",
    name: "Dawn Of Gods",
  },
  {
    id: "dawn-protocol",
    symbol: "dawn",
    name: "Dawn Protocol",
  },
  {
    id: "day-by-day",
    symbol: "dbd",
    name: "Day By Day",
  },
  {
    id: "day-of-defeat",
    symbol: "dod",
    name: "Day Of Defeat",
  },
  {
    id: "dbquest",
    symbol: "dbq",
    name: "DBQuest",
  },
  {
    id: "dbx-2",
    symbol: "dbx",
    name: "DBX",
  },
  {
    id: "dcap",
    symbol: "$dcap",
    name: "DCAP",
  },
  {
    id: "dcd-ecosystem",
    symbol: "dcd",
    name: "DCD Ecosystem",
  },
  {
    id: "dchess-king",
    symbol: "king",
    name: "DChess King",
  },
  {
    id: "dcoin-token",
    symbol: "dt",
    name: "Dcoin",
  },
  {
    id: "d-community",
    symbol: "dili",
    name: "D Community",
  },
  {
    id: "dddx-protocol",
    symbol: "dddx",
    name: "DDDX Protocol",
  },
  {
    id: "ddmcoin",
    symbol: "ddm",
    name: "DDMCoin",
  },
  {
    id: "dead-knight",
    symbol: "dkm",
    name: "Dead Knight",
  },
  {
    id: "deapcoin",
    symbol: "dep",
    name: "DEAPCOIN",
  },
  {
    id: "deathroad",
    symbol: "drace",
    name: "DeathRoad",
  },
  {
    id: "death-token",
    symbol: "death",
    name: "Death",
  },
  {
    id: "debio-network",
    symbol: "dbio",
    name: "DeBio Network",
  },
  {
    id: "debitum-network",
    symbol: "deb",
    name: "Debitum Network",
  },
  {
    id: "deblox",
    symbol: "dgs",
    name: "Deblox",
  },
  {
    id: "decentbet",
    symbol: "dbet",
    name: "DecentBet",
  },
  {
    id: "decent-database",
    symbol: "decent",
    name: "DECENT Database",
  },
  {
    id: "decentr",
    symbol: "dec",
    name: "Decentr",
  },
  {
    id: "decentrahub-coin",
    symbol: "dcntr",
    name: "Decentrahub Coin",
  },
  {
    id: "decentraland",
    symbol: "mana",
    name: "Decentraland",
  },
  {
    id: "decentraland-wormhole",
    symbol: "mana",
    name: "Decentraland (Wormhole)",
  },
  {
    id: "decentral-games",
    symbol: "dg",
    name: "Decentral Games",
  },
  {
    id: "decentral-games-governance",
    symbol: "xdg",
    name: "Decentral Games Governance",
  },
  {
    id: "decentral-games-ice",
    symbol: "ice",
    name: "Decentral Games ICE",
  },
  {
    id: "decentral-games-old",
    symbol: "dg",
    name: "Decentral Games (Old)",
  },
  {
    id: "decentralized-advertising",
    symbol: "dad",
    name: "DAD",
  },
  {
    id: "decentralized-asset-trading-platform",
    symbol: "datp",
    name: "Decentralized Asset Trading Platform",
  },
  {
    id: "decentralized-autonomous-organization",
    symbol: "dao",
    name: "Decentralized Autonomous Organization",
  },
  {
    id: "decentralized-business-systems",
    symbol: "dbs",
    name: "Decentralized Business Systems",
  },
  {
    id: "decentralized-community-investment-protocol",
    symbol: "dcip",
    name: "Decentralized Community Investment Protocol",
  },
  {
    id: "decentralized-currency-assets",
    symbol: "dca",
    name: "Decentralize Currency",
  },
  {
    id: "decentralized-etf",
    symbol: "detf",
    name: "Decentralized ETF",
  },
  {
    id: "decentralized-machine-learning",
    symbol: "dml",
    name: "Decentralized Machine Learning Protocol",
  },
  {
    id: "decentralized-mining-exchange",
    symbol: "dmc",
    name: "Decentralized Mining Exchange",
  },
  {
    id: "decentralized-nations",
    symbol: "dena",
    name: "Decentralized Nations",
  },
  {
    id: "decentralized-universal-basic-income",
    symbol: "dubi",
    name: "Decentralized Universal Basic Income",
  },
  {
    id: "decentralized-usd",
    symbol: "dusd",
    name: "Decentralized USD",
  },
  {
    id: "decentralized-vulnerability-platform",
    symbol: "dvp",
    name: "Decentralized Vulnerability Platform",
  },
  {
    id: "decentra-lotto",
    symbol: "delo",
    name: "Decentra-Lotto",
  },
  {
    id: "decentralway",
    symbol: "dcw",
    name: "Decentralway",
  },
  {
    id: "decentraweb",
    symbol: "dweb",
    name: "DecentraWeb",
  },
  {
    id: "decentsol",
    symbol: "dsol",
    name: "DecentSol",
  },
  {
    id: "decenturion",
    symbol: "dcnt",
    name: "Decenturion",
  },
  {
    id: "dechart",
    symbol: "dch",
    name: "DeChart",
  },
  {
    id: "decimal",
    symbol: "del",
    name: "Decimal",
  },
  {
    id: "decimated",
    symbol: "dio",
    name: "Decimated",
  },
  {
    id: "decoin",
    symbol: "dtep",
    name: "Decoin",
  },
  {
    id: "decred",
    symbol: "dcr",
    name: "Decred",
  },
  {
    id: "decredit",
    symbol: "cdtc",
    name: "DeCredit",
  },
  {
    id: "decubate",
    symbol: "dcb",
    name: "Decubate",
  },
  {
    id: "decurian",
    symbol: "ecu",
    name: "Decurian",
  },
  {
    id: "deep-blue-sea",
    symbol: "dbea",
    name: "Deep Blue Sea",
  },
  {
    id: "deepbrain-chain",
    symbol: "dbc",
    name: "DeepBrain Chain",
  },
  {
    id: "deepcloud-ai",
    symbol: "deep",
    name: "DeepCloud AI",
  },
  {
    id: "deeper-network",
    symbol: "dpr",
    name: "Deeper Network",
  },
  {
    id: "deeponion",
    symbol: "onion",
    name: "DeepOnion",
  },
  {
    id: "deepspace",
    symbol: "dps",
    name: "DEEPSPACE",
  },
  {
    id: "deepspace-token",
    symbol: "dxo",
    name: "DeepSpace DXO",
  },
  {
    id: "deesse",
    symbol: "love",
    name: "Deesse",
  },
  {
    id: "deez-nuts",
    symbol: "deeznuts",
    name: "Deez Nuts",
  },
  {
    id: "defactor",
    symbol: "factr",
    name: "Defactor",
  },
  {
    id: "defhold",
    symbol: "defo",
    name: "DefHold",
  },
  {
    id: "defi11",
    symbol: "d11",
    name: "DeFi11",
  },
  {
    id: "defiai",
    symbol: "dfai",
    name: "DeFiAI",
  },
  {
    id: "defiant",
    symbol: "defi",
    name: "DeFiant",
  },
  {
    id: "defiat",
    symbol: "dft",
    name: "DeFiat",
  },
  {
    id: "defiato",
    symbol: "dfiat",
    name: "DeFiato",
  },
  {
    id: "defibank-money",
    symbol: "dfm",
    name: "DefiBank.Money",
  },
  {
    id: "defi-bank-tycoon",
    symbol: "dbtycoon",
    name: "DeFi Bank Tycoon",
  },
  {
    id: "defibay",
    symbol: "dbay",
    name: "DefiBay",
  },
  {
    id: "defibet",
    symbol: "$dbet",
    name: "DefiBet",
  },
  {
    id: "defi-bids",
    symbol: "bid",
    name: "DeFi Bids",
  },
  {
    id: "defibox",
    symbol: "box",
    name: "DefiBox",
  },
  {
    id: "defi-ch",
    symbol: "dfch",
    name: "DeFi.ch",
  },
  {
    id: "defichain",
    symbol: "dfi",
    name: "DeFiChain",
  },
  {
    id: "defi-city",
    symbol: "dfc",
    name: "DeFi City",
  },
  {
    id: "deficliq",
    symbol: "cliq",
    name: "DefiCliq",
  },
  {
    id: "defi-coin",
    symbol: "defc",
    name: "DeFi Coin",
  },
  {
    id: "deficonnect",
    symbol: "dfc",
    name: "DefiConnect",
  },
  {
    id: "defi-degen-land",
    symbol: "ddl",
    name: "DeFi Degen Land",
  },
  {
    id: "defido",
    symbol: "defido",
    name: "DeFido",
  },
  {
    id: "defidollar",
    symbol: "dusd",
    name: "DefiDollar",
  },
  {
    id: "defidollar-dao",
    symbol: "dfd",
    name: "DefiDollar DAO",
  },
  {
    id: "defi-empire-gold",
    symbol: "deg",
    name: "Defi Empire Gold",
  },
  {
    id: "defi-for-you",
    symbol: "dfy",
    name: "Defi For You",
  },
  {
    id: "defi-gold",
    symbol: "dfgl",
    name: "DeFi Gold",
  },
  {
    id: "defigram",
    symbol: "dfg",
    name: "Defigram",
  },
  {
    id: "defi-holdings",
    symbol: "dhold",
    name: "DeFi Holdings",
  },
  {
    id: "defihorse",
    symbol: "dfh",
    name: "DeFiHorse",
  },
  {
    id: "defihorse-rocket-race",
    symbol: "rr",
    name: "DeFiHorse Rocket Race",
  },
  {
    id: "defi-hunters-dao",
    symbol: "ddao",
    name: "DeFi Hunters DAO",
  },
  {
    id: "defi-kingdoms",
    symbol: "jewel",
    name: "DeFi Kingdoms",
  },
  {
    id: "defi-kingdoms-crystal",
    symbol: "crystal",
    name: "DeFi Kingdoms Crystal",
  },
  {
    id: "defil",
    symbol: "dfl",
    name: "DeFIL",
  },
  {
    id: "defi-land",
    symbol: "dfl",
    name: "DeFi Land",
  },
  {
    id: "defi-land-gold",
    symbol: "goldy",
    name: "DeFi Land Gold",
  },
  {
    id: "defi-launch",
    symbol: "dlaunch",
    name: "DeFi Launch",
  },
  {
    id: "defily",
    symbol: "dfl",
    name: "Defily",
  },
  {
    id: "defina-finance",
    symbol: "fina",
    name: "Defina Finance",
  },
  {
    id: "define",
    symbol: "dfa",
    name: "DeFine",
  },
  {
    id: "definer",
    symbol: "fin",
    name: "DeFiner",
  },
  {
    id: "definity",
    symbol: "defx",
    name: "DeFinity",
  },
  {
    id: "definix",
    symbol: "finix",
    name: "Definix",
  },
  {
    id: "defi-on-mcw",
    symbol: "dfm",
    name: "DeFi on MCW",
  },
  {
    id: "defipie",
    symbol: "pie",
    name: "DeFiPie",
  },
  {
    id: "defiplaza",
    symbol: "dfp2",
    name: "DefiPlaza",
  },
  {
    id: "defipulse-index",
    symbol: "dpi",
    name: "DeFi Pulse Index",
  },
  {
    id: "defire",
    symbol: "cwap",
    name: "DeFIRE",
  },
  {
    id: "defis",
    symbol: "xgm",
    name: "Defis",
  },
  {
    id: "defiscale",
    symbol: "dfc",
    name: "DeFiScale",
  },
  {
    id: "defi-shopping-stake",
    symbol: "dss",
    name: "Defi Shopping Stake",
  },
  {
    id: "defis-network",
    symbol: "dfs",
    name: "Defis Network",
  },
  {
    id: "defisportscoin",
    symbol: "dsc",
    name: "DefiSportsCoin",
  },
  {
    id: "defistarter",
    symbol: "dfi",
    name: "DfiStarter",
  },
  {
    id: "defi-stoa",
    symbol: "sta",
    name: "STOA Network",
  },
  {
    id: "defit",
    symbol: "defit",
    name: "Digital Fitness",
  },
  {
    id: "defi-top-5-tokens-index",
    symbol: "defi5",
    name: "DEFI Top 5 Index",
  },
  {
    id: "defiville-island",
    symbol: "isla",
    name: "DefiVille Island",
  },
  {
    id: "defi-warrior",
    symbol: "fiwa",
    name: "Defi Warrior",
  },
  {
    id: "defi-yield-protocol",
    symbol: "dyp",
    name: "DeFi Yield Protocol",
  },
  {
    id: "deflyball",
    symbol: "defly",
    name: "Deflyball",
  },
  {
    id: "defrost-finance",
    symbol: "melt",
    name: "Defrost Finance",
  },
  {
    id: "defrost-finance-h2o",
    symbol: "h2o",
    name: "Defrost Finance H2O",
  },
  {
    id: "defycoinv2",
    symbol: "defy",
    name: "DefyCoinV2",
  },
  {
    id: "defydefi",
    symbol: "defy",
    name: "DefyDefi",
  },
  {
    id: "defyswap-finance",
    symbol: "dfy",
    name: "DefySwap Finance",
  },
  {
    id: "degate",
    symbol: "dg",
    name: "DeGate",
  },
  {
    id: "degem",
    symbol: "dgm",
    name: "DegemV2",
  },
  {
    id: "degen",
    symbol: "degn",
    name: "Degen",
  },
  {
    id: "degen-ape-club",
    symbol: "dac",
    name: "Degen Ape Club",
  },
  {
    id: "degenerate-money",
    symbol: "degenr",
    name: "Degenerate Money",
  },
  {
    id: "degenerator",
    symbol: "meme",
    name: "Meme",
  },
  {
    id: "degen-finance",
    symbol: "degen",
    name: "Degen Finance",
  },
  {
    id: "degen-index",
    symbol: "degen",
    name: "DEGEN Index",
  },
  {
    id: "degen-protocol-token",
    symbol: "sh33p",
    name: "Degen Protocol",
  },
  {
    id: "degenvc",
    symbol: "dgvc",
    name: "DegenVC",
  },
  {
    id: "degis",
    symbol: "deg",
    name: "Degis",
  },
  {
    id: "dego-finance",
    symbol: "dego",
    name: "Dego Finance",
  },
  {
    id: "degree-crypto-token",
    symbol: "dct",
    name: "Degree Crypto",
  },
  {
    id: "dehealth",
    symbol: "dhlt",
    name: "DeHealth",
  },
  {
    id: "dehero-community-token",
    symbol: "heroes",
    name: "Dehero Community",
  },
  {
    id: "dehive",
    symbol: "dhv",
    name: "DeHive",
  },
  {
    id: "dehorizon",
    symbol: "devt",
    name: "DeHorizon",
  },
  {
    id: "dehr-network",
    symbol: "dhr",
    name: "DeHR Network",
  },
  {
    id: "dehub",
    symbol: "dehub",
    name: "DeHub",
  },
  {
    id: "deimos-token",
    symbol: "dio",
    name: "Deimos DIO",
  },
  {
    id: "deipool",
    symbol: "dip",
    name: "Deipool",
  },
  {
    id: "deip-protocol",
    symbol: "deip",
    name: "DEIP Protocol",
  },
  {
    id: "dei-token",
    symbol: "dei",
    name: "DEI",
  },
  {
    id: "dekbox",
    symbol: "dek",
    name: "DekBox",
  },
  {
    id: "deku-inu",
    symbol: "deku",
    name: "Deku Inu",
  },
  {
    id: "delfino-finance",
    symbol: "dlf",
    name: "Delfino Finance",
  },
  {
    id: "deligence",
    symbol: "ira",
    name: "Diligence",
  },
  {
    id: "deli-of-thrones",
    symbol: "dotx",
    name: "DeFi of Thrones",
  },
  {
    id: "delion",
    symbol: "dln",
    name: "Delion",
  },
  {
    id: "deliq",
    symbol: "dlq",
    name: "Deliq",
  },
  {
    id: "delos-defi",
    symbol: "delos",
    name: "Delos Defi",
  },
  {
    id: "delot-io",
    symbol: "delot",
    name: "DELOT.IO",
  },
  {
    id: "delphy",
    symbol: "dpy",
    name: "Delphy",
  },
  {
    id: "deltachain",
    symbol: "delta",
    name: "DeltaChain",
  },
  {
    id: "delta-exchange-token",
    symbol: "deto",
    name: "Delta Exchange",
  },
  {
    id: "deltafi",
    symbol: "delfi",
    name: "DeltaFi",
  },
  {
    id: "delta-financial",
    symbol: "delta",
    name: "Delta Financial",
  },
  {
    id: "deltaflip",
    symbol: "deltaf",
    name: "DeltaFlip",
  },
  {
    id: "delta-theta",
    symbol: "dlta",
    name: "delta.theta",
  },
  {
    id: "demeter",
    symbol: "deo",
    name: "Demeter",
  },
  {
    id: "demeter-usd",
    symbol: "dusd",
    name: "Demeter USD",
  },
  {
    id: "demodyfi",
    symbol: "dmod",
    name: "Demodyfi",
  },
  {
    id: "demole",
    symbol: "dmlg",
    name: "Demole",
  },
  {
    id: "demonic-doge",
    symbol: "dmd",
    name: "Demonic Doge",
  },
  {
    id: "denarius",
    symbol: "d",
    name: "Denarius",
  },
  {
    id: "dendomains",
    symbol: "ddn",
    name: "Den Domains",
  },
  {
    id: "dengba-planet",
    symbol: "dbt",
    name: "Dengba Planet",
  },
  {
    id: "denizlispor-fan-token",
    symbol: "dnz",
    name: "Denizlispor Fan Token",
  },
  {
    id: "dent",
    symbol: "dent",
    name: "Dent",
  },
  {
    id: "dentacoin",
    symbol: "dcn",
    name: "Dentacoin",
  },
  {
    id: "dentrocoin",
    symbol: "dentro",
    name: "Dentrocoin",
  },
  {
    id: "deonex-token",
    symbol: "don",
    name: "DEONEX",
  },
  {
    id: "depay",
    symbol: "depay",
    name: "DePay",
  },
  {
    id: "depo",
    symbol: "depo",
    name: "Depo",
  },
  {
    id: "depocket",
    symbol: "depo",
    name: "DePocket",
  },
  {
    id: "deportivo-alaves-fan-token",
    symbol: "daft",
    name: "Deportivo Alavés Fan Token",
  },
  {
    id: "depth-token",
    symbol: "dep",
    name: "Depth",
  },
  {
    id: "dequant",
    symbol: "deq",
    name: "Dequant",
  },
  {
    id: "derace",
    symbol: "derc",
    name: "DeRace",
  },
  {
    id: "deracoin",
    symbol: "drc",
    name: "Deracoin",
  },
  {
    id: "derify-protocol",
    symbol: "drf",
    name: "Derify Protocol",
  },
  {
    id: "deri-protocol",
    symbol: "deri",
    name: "Deri Protocol",
  },
  {
    id: "derivadao",
    symbol: "ddx",
    name: "DerivaDAO",
  },
  {
    id: "derived",
    symbol: "dvdx",
    name: "Derived",
  },
  {
    id: "dero",
    symbol: "dero",
    name: "Dero",
  },
  {
    id: "desirenft",
    symbol: "desire",
    name: "DesireNFT",
  },
  {
    id: "desmos",
    symbol: "dsm",
    name: "Desmos",
  },
  {
    id: "despace",
    symbol: "dse",
    name: "Despace",
  },
  {
    id: "despace-protocol",
    symbol: "des",
    name: "DeSpace Protocol",
  },
  {
    id: "destorage",
    symbol: "ds",
    name: "DeStorage",
  },
  {
    id: "deswap",
    symbol: "daw",
    name: "Deswap",
  },
  {
    id: "dether",
    symbol: "dth",
    name: "Dether",
  },
  {
    id: "detik",
    symbol: "dtk",
    name: "DETIK",
  },
  {
    id: "deus-finance-2",
    symbol: "deus",
    name: "DEUS Finance",
  },
  {
    id: "deutsche-emark",
    symbol: "dem",
    name: "Deutsche eMark",
  },
  {
    id: "deuxpad",
    symbol: "deux",
    name: "DeuxPad",
  },
  {
    id: "deva-token",
    symbol: "deva",
    name: "DEVA",
  },
  {
    id: "devault",
    symbol: "dvt",
    name: "DeVault",
  },
  {
    id: "devery",
    symbol: "eve",
    name: "Devery",
  },
  {
    id: "devia8",
    symbol: "devia8",
    name: "Devia8",
  },
  {
    id: "deviantcoin",
    symbol: "dev",
    name: "Deviant Coin",
  },
  {
    id: "devikins",
    symbol: "dvk",
    name: "Devikins",
  },
  {
    id: "devil-finance",
    symbol: "devil",
    name: "Devil Finance",
  },
  {
    id: "devil-token",
    symbol: "devl",
    name: "Devil",
  },
  {
    id: "devious-licks-gold",
    symbol: "dgold",
    name: "Devious Licks Gold",
  },
  {
    id: "devita-global",
    symbol: "life",
    name: "DEVITA",
  },
  {
    id: "devium",
    symbol: "devi",
    name: "Devium",
  },
  {
    id: "devolution",
    symbol: "devo",
    name: "DeVolution",
  },
  {
    id: "devour",
    symbol: "restaurants",
    name: "Devour",
  },
  {
    id: "dev-protocol",
    symbol: "dev",
    name: "Dev Protocol",
  },
  {
    id: "dexa-coin",
    symbol: "dexa",
    name: "DEXA COIN",
  },
  {
    id: "dexalot",
    symbol: "alot",
    name: "Dexalot",
  },
  {
    id: "dexbrowser",
    symbol: "bro",
    name: "DexBrowser",
  },
  {
    id: "dexe",
    symbol: "dexe",
    name: "DeXe",
  },
  {
    id: "dexfin",
    symbol: "dxf",
    name: "Dexfin",
  },
  {
    id: "dexfolio",
    symbol: "dexf",
    name: "Dexfolio",
  },
  {
    id: "dex-game",
    symbol: "dxgm",
    name: "DexGame",
  },
  {
    id: "dexigas",
    symbol: "dxg",
    name: "Dexigas",
  },
  {
    id: "dexioprotocol",
    symbol: "dexi",
    name: "Dexioprotocol",
  },
  {
    id: "dexira",
    symbol: "dex",
    name: "dexIRA",
  },
  {
    id: "dexit-finance",
    symbol: "dxt",
    name: "Dexit Network",
  },
  {
    id: "dexkit",
    symbol: "kit",
    name: "DexKit",
  },
  {
    id: "dexlab",
    symbol: "dxl",
    name: "Dexlab",
  },
  {
    id: "dexpad",
    symbol: "dxp",
    name: "DexPad",
  },
  {
    id: "dexpools",
    symbol: "dxp",
    name: "Dexpools",
  },
  {
    id: "dexscrow",
    symbol: "dxw",
    name: "Dexscrow",
  },
  {
    id: "dexshare",
    symbol: "dexshare",
    name: "dexSHARE",
  },
  {
    id: "dexsport",
    symbol: "desu",
    name: "Dexsport",
  },
  {
    id: "dextf",
    symbol: "dextf",
    name: "Domani Protocol",
  },
  {
    id: "dextoken-governance",
    symbol: "dexg",
    name: "Dextoken Governance",
  },
  {
    id: "dextools",
    symbol: "dext",
    name: "DexTools",
  },
  {
    id: "dex-trade-coin",
    symbol: "dxc",
    name: "Dex-Trade Coin",
  },
  {
    id: "dextro",
    symbol: "dxo",
    name: "Dextro",
  },
  {
    id: "dfe-finance",
    symbol: "dfe",
    name: "DFE.Finance",
  },
  {
    id: "dfinance",
    symbol: "xfi",
    name: "Dfinance",
  },
  {
    id: "dfohub",
    symbol: "buidl",
    name: "dfohub",
  },
  {
    id: "dforce-token",
    symbol: "df",
    name: "dForce",
  },
  {
    id: "dfs-mafia",
    symbol: "dfsm",
    name: "DFS MAFIA",
  },
  {
    id: "dfsocial",
    symbol: "dfsocial",
    name: "DFSocial (Old)",
  },
  {
    id: "dfsocial-gaming-2",
    symbol: "dfsg",
    name: "DFSocial Gaming",
  },
  {
    id: "dfund",
    symbol: "dfnd",
    name: "dFund",
  },
  {
    id: "dfuture",
    symbol: "dft",
    name: "dfuture",
  },
  {
    id: "dfx-finance",
    symbol: "dfx",
    name: "DFX Finance",
  },
  {
    id: "dfyn-network",
    symbol: "dfyn",
    name: "Dfyn Network",
  },
  {
    id: "dgld",
    symbol: "dgld",
    name: "DGLD",
  },
  {
    id: "dgpayment",
    symbol: "dgp",
    name: "DGPayment",
  },
  {
    id: "dhabicoin",
    symbol: "dbc",
    name: "Dhabicoin",
  },
  {
    id: "dhealth",
    symbol: "dhp",
    name: "dHealth",
  },
  {
    id: "dhedge-dao",
    symbol: "dht",
    name: "dHEDGE DAO",
  },
  {
    id: "dhedge-stablecoin-yield",
    symbol: "dusd",
    name: "dHEDGE Stablecoin Yield",
  },
  {
    id: "dhedge-top-index",
    symbol: "dtop",
    name: "dHEDGE Top Index",
  },
  {
    id: "dia-data",
    symbol: "dia",
    name: "DIA",
  },
  {
    id: "diamond",
    symbol: "dmd",
    name: "Diamond",
  },
  {
    id: "diamond-boyz-coin",
    symbol: "dbz",
    name: "Diamond Boyz Coin",
  },
  {
    id: "diamond-coin",
    symbol: "diamond",
    name: "Diamond Coin",
  },
  {
    id: "diamonddao",
    symbol: "dmnd",
    name: "DiamondDAO",
  },
  {
    id: "diamond-dnd",
    symbol: "dnd",
    name: "Diamond DND",
  },
  {
    id: "diamond-hands-token",
    symbol: "dhc",
    name: "Diamond Hands DHC",
  },
  {
    id: "diamondhold",
    symbol: "dhold",
    name: "DiamondHold",
  },
  {
    id: "diamond-love",
    symbol: "love",
    name: "Diamond Love",
  },
  {
    id: "diamond-platform-token",
    symbol: "dpt",
    name: "Diamond Platform",
  },
  {
    id: "diamondq",
    symbol: "diq",
    name: "DiamondQ",
  },
  {
    id: "diamondshiba",
    symbol: "ds$",
    name: "DiamondShiba",
  },
  {
    id: "diamond-whitex",
    symbol: "dwhx",
    name: "Diamond Whitex",
  },
  {
    id: "diamond-xrpl",
    symbol: "diamond",
    name: "Diamond XRPL",
  },
  {
    id: "diarrheacoin",
    symbol: "diah",
    name: "DiarrheaCoin",
  },
  {
    id: "dibs-money",
    symbol: "dibs",
    name: "Dibs Money",
  },
  {
    id: "dibs-share",
    symbol: "dshare",
    name: "Dibs Share",
  },
  {
    id: "dice-inu",
    symbol: "dice",
    name: "Dice Inu",
  },
  {
    id: "didcoin-2",
    symbol: "did",
    name: "Didcoin",
  },
  {
    id: "diemlibre",
    symbol: "dlb",
    name: "DiemLibre",
  },
  {
    id: "diffusion",
    symbol: "diff",
    name: "Diffusion",
  },
  {
    id: "difo-network",
    symbol: "dfn",
    name: "Difo Network",
  },
  {
    id: "dify-finance",
    symbol: "yfiii",
    name: "Dify.Finance",
  },
  {
    id: "dig-chain",
    symbol: "dig",
    name: "Dig Chain",
  },
  {
    id: "digg",
    symbol: "digg",
    name: "DIGG",
  },
  {
    id: "digible",
    symbol: "digi",
    name: "Digible",
  },
  {
    id: "digibyte",
    symbol: "dgb",
    name: "DigiByte",
  },
  {
    id: "digichain",
    symbol: "digichain",
    name: "Digichain Coin",
  },
  {
    id: "digicol-token",
    symbol: "dgcl",
    name: "DigiCol",
  },
  {
    id: "digi-dinar",
    symbol: "ddr",
    name: "Digi Dinar",
  },
  {
    id: "digidinar-stabletoken",
    symbol: "ddrst",
    name: "DigiDinar Stable",
  },
  {
    id: "digidinar-token",
    symbol: "ddrt",
    name: "DigiDinar Token",
  },
  {
    id: "digifinextoken",
    symbol: "dft",
    name: "DigiFinex",
  },
  {
    id: "digifit",
    symbol: "dgi",
    name: "DIGIFIT",
  },
  {
    id: "digimetaverse",
    symbol: "dgmv",
    name: "DigiMetaverse",
  },
  {
    id: "digimoney",
    symbol: "dgm",
    name: "DigiMoney",
  },
  {
    id: "digital-bank-of-africa",
    symbol: "dba",
    name: "Digital Bank of Africa",
  },
  {
    id: "digitalbits",
    symbol: "xdb",
    name: "DigitalBits",
  },
  {
    id: "digitalcoin",
    symbol: "dgc",
    name: "Digitalcoin",
  },
  {
    id: "digitaldollar",
    symbol: "dusd",
    name: "DigitalDollar",
  },
  {
    id: "digital-financial-exchange",
    symbol: "difx",
    name: "Digital Financial Exchange",
  },
  {
    id: "digital-money-bits",
    symbol: "dmb",
    name: "Digital Money Bits",
  },
  {
    id: "digitalnote",
    symbol: "xdn",
    name: "DigitalNote",
  },
  {
    id: "digitalprice",
    symbol: "dp",
    name: "DigitalPrice",
  },
  {
    id: "digital-rand",
    symbol: "dzar",
    name: "Digital Rand",
  },
  {
    id: "digital-reserve-currency",
    symbol: "drc",
    name: "Digital Reserve Currency",
  },
  {
    id: "digital-swis-franc",
    symbol: "dsfr",
    name: "Digital Swiss Franc",
  },
  {
    id: "digital-ticks",
    symbol: "dtx",
    name: "Digital Ticks",
  },
  {
    id: "digitex-futures-exchange",
    symbol: "dgtx",
    name: "Digitex",
  },
  {
    id: "digits-dao",
    symbol: "digits",
    name: "Digits DAO",
  },
  {
    id: "digixdao",
    symbol: "dgd",
    name: "DigixDAO",
  },
  {
    id: "digix-gold",
    symbol: "dgx",
    name: "Digix Gold",
  },
  {
    id: "dike",
    symbol: "dike",
    name: "Dike",
  },
  {
    id: "dimecoin",
    symbol: "dime",
    name: "Dimecoin",
  },
  {
    id: "diminutive-coin",
    symbol: "dimi",
    name: "Diminutive Coin",
  },
  {
    id: "dimitra",
    symbol: "dmtr",
    name: "Dimitra",
  },
  {
    id: "dimsum",
    symbol: "dms",
    name: "DimSum",
  },
  {
    id: "dina",
    symbol: "dina",
    name: "Dina",
  },
  {
    id: "dinamo-zagreb-fan-token",
    symbol: "dzg",
    name: "Dinamo Zagreb Fan Token",
  },
  {
    id: "dinastycoin",
    symbol: "dcy",
    name: "Dinastycoin",
  },
  {
    id: "dinero",
    symbol: "din",
    name: "Dinero",
  },
  {
    id: "dinger-token",
    symbol: "dinger",
    name: "Dinger",
  },
  {
    id: "dingocoin",
    symbol: "dingo",
    name: "Dingocoin",
  },
  {
    id: "dingo-token",
    symbol: "dingo",
    name: "Dingo",
  },
  {
    id: "dink-donk",
    symbol: "dink",
    name: "Dink Doink",
  },
  {
    id: "dino",
    symbol: "dino",
    name: "Dino",
  },
  {
    id: "dinoegg",
    symbol: "dinoegg",
    name: "DINOEGG",
  },
  {
    id: "dino-exchange",
    symbol: "dino",
    name: "Dino Exchange",
  },
  {
    id: "dinoland",
    symbol: "dnl",
    name: "Dinoland",
  },
  {
    id: "dinopark",
    symbol: "dinop",
    name: "DinoPark",
  },
  {
    id: "dinosaureggs",
    symbol: "dsg",
    name: "Dinosaur Eggs",
  },
  {
    id: "dinostep",
    symbol: "dns",
    name: "DinoStep",
  },
  {
    id: "dinoswap",
    symbol: "dino",
    name: "DinoSwap",
  },
  {
    id: "dinox",
    symbol: "dnxc",
    name: "DinoX",
  },
  {
    id: "dint-token",
    symbol: "dint",
    name: "DINT",
  },
  {
    id: "dionpay",
    symbol: "dion",
    name: "Dionpay",
  },
  {
    id: "dios-finance",
    symbol: "dios",
    name: "Dios Finance",
  },
  {
    id: "dipper",
    symbol: "dip",
    name: "Dipper",
  },
  {
    id: "dipper-network",
    symbol: "dip",
    name: "Dipper Network",
  },
  {
    id: "dirham",
    symbol: "dah",
    name: "Dirham",
  },
  {
    id: "dirham-crypto",
    symbol: "dhs",
    name: "Dirham Crypto",
  },
  {
    id: "dirty-finance",
    symbol: "dirty",
    name: "Dirty Finance",
  },
  {
    id: "disbalancer",
    symbol: "ddos",
    name: "disBalancer",
  },
  {
    id: "disco-burn-token",
    symbol: "dbt",
    name: "Disco Burn",
  },
  {
    id: "district0x",
    symbol: "dnt",
    name: "district0x",
  },
  {
    id: "distx",
    symbol: "distx",
    name: "DistX",
  },
  {
    id: "ditto",
    symbol: "ditto",
    name: "Ditto",
  },
  {
    id: "dittoinu",
    symbol: "dittoinu",
    name: "DittoInu",
  },
  {
    id: "divergence-protocol",
    symbol: "diver",
    name: "Divergence Protocol",
  },
  {
    id: "diversifi",
    symbol: "dfi",
    name: "DiversiFi",
  },
  {
    id: "divi",
    symbol: "divi",
    name: "Divi",
  },
  {
    id: "divi-land",
    symbol: "dvld",
    name: "DIVI LAND",
  },
  {
    id: "divine-dao",
    symbol: "divine",
    name: "Divine DAO",
  },
  {
    id: "diviner",
    symbol: "div",
    name: "Diviner",
  },
  {
    id: "diviner-protocol",
    symbol: "dpt",
    name: "Diviner Protocol",
  },
  {
    id: "divs",
    symbol: "divs",
    name: "Divs",
  },
  {
    id: "dixt-finance",
    symbol: "dixt",
    name: "Dixt Finance",
  },
  {
    id: "diyarbekirspor",
    symbol: "diyar",
    name: "Diyarbekirspor",
  },
  {
    id: "dkargo",
    symbol: "dka",
    name: "dKargo",
  },
  {
    id: "dkey-bank",
    symbol: "dkey",
    name: "DKEY Bank",
  },
  {
    id: "dlp-duck-token",
    symbol: "duck",
    name: "DLP Duck",
  },
  {
    id: "dmarket",
    symbol: "dmt",
    name: "DMarket",
  },
  {
    id: "dmd",
    symbol: "dmd",
    name: "DMD",
  },
  {
    id: "dmme-app",
    symbol: "dmme",
    name: "DMme",
  },
  {
    id: "dmm-governance",
    symbol: "dmg",
    name: "DMM: Governance",
  },
  {
    id: "dmt-token",
    symbol: "dmt",
    name: "DMT",
  },
  {
    id: "dmz-token",
    symbol: "dmz",
    name: "DMZ",
  },
  {
    id: "dna-dollar",
    symbol: "dna",
    name: "DNA Dollar",
  },
  {
    id: "dna-genesys",
    symbol: "dna",
    name: "DNA Genesys",
  },
  {
    id: "dna-share",
    symbol: "dshare",
    name: "DNA Share",
  },
  {
    id: "dnaxcat",
    symbol: "dxct",
    name: "DNAxCAT",
  },
  {
    id: "dnd-metaverse",
    symbol: "dndb",
    name: "DnD Metaverse",
  },
  {
    id: "dnft-protocol",
    symbol: "dnf",
    name: "DNFT Protocol",
  },
  {
    id: "doaibu",
    symbol: "doa",
    name: "Doaibu",
  },
  {
    id: "dobermann",
    symbol: "dobe",
    name: "Dobermann",
  },
  {
    id: "dock",
    symbol: "dock",
    name: "Dock",
  },
  {
    id: "docuchain",
    symbol: "dcct",
    name: "DocuChain",
  },
  {
    id: "documentchain",
    symbol: "dms",
    name: "Documentchain",
  },
  {
    id: "dodo",
    symbol: "dodo",
    name: "DODO",
  },
  {
    id: "dodreamchain",
    symbol: "drm",
    name: "DoDreamChain",
  },
  {
    id: "doex",
    symbol: "doex",
    name: "DOEX",
  },
  {
    id: "dofi",
    symbol: "doo",
    name: "Dofi",
  },
  {
    id: "dog",
    symbol: "dog",
    name: "Dog [OLD]",
  },
  {
    id: "dog-2",
    symbol: "dog",
    name: "Dog",
  },
  {
    id: "dogami",
    symbol: "doga",
    name: "Dogami",
  },
  {
    id: "dog-boss",
    symbol: "dogboss",
    name: "Dog Boss",
  },
  {
    id: "dog-collar",
    symbol: "collar",
    name: "Dog Collar",
  },
  {
    id: "dogdeficoin",
    symbol: "dogdefi",
    name: "DogDeFiCoin",
  },
  {
    id: "doge-1-mission-to-the-moon",
    symbol: "doge-1",
    name: "Doge-1 Mission to the moon",
  },
  {
    id: "doge-alliance",
    symbol: "dogeally",
    name: "Doge Alliance",
  },
  {
    id: "doge-army-token",
    symbol: "dgat",
    name: "Doge Army",
  },
  {
    id: "dogebonk",
    symbol: "dobo",
    name: "DogeBonk",
  },
  {
    id: "dogecash",
    symbol: "dogec",
    name: "DogeCash",
  },
  {
    id: "doge-cat",
    symbol: "dogecat",
    name: "DOGE-CAT",
  },
  {
    id: "dogecoin",
    symbol: "doge",
    name: "Dogecoin",
  },
  {
    id: "dogecoin-2",
    symbol: "doge2",
    name: "Dogecoin 2.0",
  },
  {
    id: "dogecola",
    symbol: "dogecola",
    name: "DogeCola",
  },
  {
    id: "dogecolony",
    symbol: "dogeco",
    name: "Dogecolony",
  },
  {
    id: "dogecube",
    symbol: "dogecube",
    name: "DogeCube",
  },
  {
    id: "dogedao",
    symbol: "dogedao",
    name: "DogeDao",
  },
  {
    id: "doge-dash",
    symbol: "dogedash",
    name: "Doge Dash",
  },
  {
    id: "dogedead",
    symbol: "dogedead",
    name: "DogeDead",
  },
  {
    id: "dogedi",
    symbol: "dogedi",
    name: "DOGEDI",
  },
  {
    id: "dogefather",
    symbol: "dogefather",
    name: "Dogefather",
  },
  {
    id: "dogefather-token",
    symbol: "father",
    name: "DogeFather Token",
  },
  {
    id: "dogefi",
    symbol: "dogefi",
    name: "DogeFi",
  },
  {
    id: "doge-floki-coin",
    symbol: "dofi",
    name: "Doge Floki Coin",
  },
  {
    id: "dogefood",
    symbol: "dogefood",
    name: "DogeFood",
  },
  {
    id: "dogegamer",
    symbol: "dga",
    name: "Doge Gamer",
  },
  {
    id: "dogegayson",
    symbol: "goge",
    name: "DogeGaySon",
  },
  {
    id: "dogegf",
    symbol: "dogegf",
    name: "DogeGF",
  },
  {
    id: "doge-in-shiba",
    symbol: "dgshib",
    name: "Doge in Shiba",
  },
  {
    id: "dogeking",
    symbol: "dogeking",
    name: "DogeKing",
  },
  {
    id: "dogekongzilla",
    symbol: "dogekongzilla",
    name: "DogeKongZilla",
  },
  {
    id: "dogelana",
    symbol: "dgln",
    name: "Dogelana",
  },
  {
    id: "dogelon-mars",
    symbol: "elon",
    name: "Dogelon Mars",
  },
  {
    id: "dogelon-mars-wormhole",
    symbol: "elon",
    name: "Dogelon Mars (Wormhole)",
  },
  {
    id: "doge-lumens",
    symbol: "dxlm",
    name: "Doge Lumens",
  },
  {
    id: "dogeman",
    symbol: "dgman",
    name: "DogeMan",
  },
  {
    id: "dogemania",
    symbol: "dogemania",
    name: "DogeMania",
  },
  {
    id: "dogematic",
    symbol: "dm",
    name: "Dogematic",
  },
  {
    id: "dogemetaverse",
    symbol: "dogemeta",
    name: "Dogemetaverse",
  },
  {
    id: "dogemon-go",
    symbol: "dogo",
    name: "DogemonGo",
  },
  {
    id: "dogemoon",
    symbol: "dogemoon",
    name: "Dogemoon",
  },
  {
    id: "doge-ninja-samurai",
    symbol: "dinja",
    name: "DOGE NINJA SAMURAI",
  },
  {
    id: "dogeon",
    symbol: "don",
    name: "Dogeon",
  },
  {
    id: "dogepepsi",
    symbol: "dogepepsi",
    name: "DogePepsi",
  },
  {
    id: "doge-protocol",
    symbol: "dogep",
    name: "Doge Protocol",
  },
  {
    id: "doge-raca",
    symbol: "doca",
    name: "Doge Raca",
  },
  {
    id: "doge-rise-up",
    symbol: "dogeriseup",
    name: "Doge Rise Up",
  },
  {
    id: "doge-run",
    symbol: "drun",
    name: "Doge Run",
  },
  {
    id: "doge-spacex",
    symbol: "dogesx",
    name: "Doge SpaceX",
  },
  {
    id: "doges-spirited-howling-castle-game",
    symbol: "miyazaki",
    name: "Doges Spirited Howling Castle Game",
  },
  {
    id: "doge-strap",
    symbol: "drap",
    name: "Doge Strap",
  },
  {
    id: "dogestribute",
    symbol: "dgstb",
    name: "Dogestribute",
  },
  {
    id: "dogeswap",
    symbol: "doges",
    name: "Dogeswap",
  },
  {
    id: "dogetama",
    symbol: "dogetama",
    name: "Dogetama",
  },
  {
    id: "doge-token",
    symbol: "doget",
    name: "Doge Token",
  },
  {
    id: "doge-universe",
    symbol: "spacexdoge",
    name: "Doge Universe",
  },
  {
    id: "dogeville",
    symbol: "dville",
    name: "DogeVille",
  },
  {
    id: "dogewarrior",
    symbol: "dwr",
    name: "DogeWarrior",
  },
  {
    id: "dogewhale",
    symbol: "dogewhale",
    name: "Dogewhale",
  },
  {
    id: "dogewhisky",
    symbol: "dogewhisky",
    name: "Dogewhisky",
  },
  {
    id: "doge-x",
    symbol: "dogex",
    name: "Doge X",
  },
  {
    id: "doge-yellow-coin",
    symbol: "dogey",
    name: "Doge Yellow Coin",
  },
  {
    id: "dogeyield",
    symbol: "dogy",
    name: "DogeYield",
  },
  {
    id: "dogey-inu",
    symbol: "dinu",
    name: "Dogey-Inu",
  },
  {
    id: "dogezilla",
    symbol: "dogezilla",
    name: "DogeZilla",
  },
  {
    id: "doge-zilla",
    symbol: "dogez",
    name: "DogeZilla Token",
  },
  {
    id: "dogger",
    symbol: "dogger",
    name: "Dogger",
  },
  {
    id: "doggy",
    symbol: "doggy",
    name: "Doggy",
  },
  {
    id: "doggystyle-coin",
    symbol: "dsc",
    name: "DoggyStyle Coin",
  },
  {
    id: "dogira",
    symbol: "dogira",
    name: "Dogira",
  },
  {
    id: "dogkage",
    symbol: "dake",
    name: "DogKage",
  },
  {
    id: "dogs",
    symbol: "dogs",
    name: "DOGS",
  },
  {
    id: "dogs-kombat",
    symbol: "dk",
    name: "Dogs Kombat",
  },
  {
    id: "dogsofelon",
    symbol: "doe",
    name: "Dogs Of Elon",
  },
  {
    id: "dogswap-token",
    symbol: "dog",
    name: "Dogeswap (HECO)",
  },
  {
    id: "dogus",
    symbol: "dogus",
    name: "Dogus",
  },
  {
    id: "dogyrace",
    symbol: "dor",
    name: "DogyRace",
  },
  {
    id: "dogz",
    symbol: "dogz",
    name: "Dogz",
  },
  {
    id: "dogzverse-token",
    symbol: "dgzv",
    name: "DogZVerse",
  },
  {
    id: "dohrnii",
    symbol: "dhn",
    name: "Dohrnii",
  },
  {
    id: "dojo",
    symbol: "dojo",
    name: "DOJO",
  },
  {
    id: "doken",
    symbol: "doken",
    name: "DoKEN",
  },
  {
    id: "doki-doki-finance",
    symbol: "doki",
    name: "Doki Doki",
  },
  {
    id: "dok-token",
    symbol: "dok",
    name: "DOK",
  },
  {
    id: "dola-usd",
    symbol: "dola",
    name: "Dola",
  },
  {
    id: "dollardoge",
    symbol: "dollardoge",
    name: "DollarDoge",
  },
  {
    id: "dollar-online",
    symbol: "dollar",
    name: "Dollar INTERNATIONAL",
  },
  {
    id: "dollars",
    symbol: "usdx",
    name: "Dollars",
  },
  {
    id: "dollypad-finance",
    symbol: "dolly",
    name: "Dollypad Finance",
  },
  {
    id: "domain-coin",
    symbol: "dmn",
    name: "Domain Coin",
  },
  {
    id: "domi",
    symbol: "domi",
    name: "Domi",
  },
  {
    id: "dominium-2",
    symbol: "dom",
    name: "Dominium",
  },
  {
    id: "domraider",
    symbol: "drt",
    name: "DomRaider",
  },
  {
    id: "dona",
    symbol: "dona",
    name: "DONA",
  },
  {
    id: "donkey",
    symbol: "donk",
    name: "Donkey",
  },
  {
    id: "don-key",
    symbol: "don",
    name: "Don-key",
  },
  {
    id: "donkey-token",
    symbol: "don",
    name: "Donkey DON",
  },
  {
    id: "donnie-finance",
    symbol: "don",
    name: "Donnie Finance",
  },
  {
    id: "dont-kyc",
    symbol: "dkyc",
    name: "Don't KYC",
  },
  {
    id: "dont-play-with-kitty",
    symbol: "dpwk",
    name: "Dont Play With Kitty",
  },
  {
    id: "donut",
    symbol: "donut",
    name: "Donut",
  },
  {
    id: "doogee",
    symbol: "doogee",
    name: "Doogee",
  },
  {
    id: "doom-hero-dao",
    symbol: "dhd",
    name: "Doom Hero Dao",
  },
  {
    id: "doom-hero-game",
    symbol: "dhg",
    name: "Doom Hero Game",
  },
  {
    id: "doont-buy",
    symbol: "dbuy",
    name: "Doont Buy",
  },
  {
    id: "door",
    symbol: "door",
    name: "DOOR",
  },
  {
    id: "dooropen",
    symbol: "doc",
    name: "Dooropen",
  },
  {
    id: "doos-token",
    symbol: "doos",
    name: "DOOS",
  },
  {
    id: "dope-wars-paper",
    symbol: "paper",
    name: "Dope Wars Paper",
  },
  {
    id: "dopewarz",
    symbol: "drug",
    name: "DopeWarz",
  },
  {
    id: "dopex",
    symbol: "dpx",
    name: "Dopex",
  },
  {
    id: "dopex-rebate-token",
    symbol: "rdpx",
    name: "Dopex Rebate",
  },
  {
    id: "dopple-finance",
    symbol: "dop",
    name: "Dopple Finance",
  },
  {
    id: "doraemoninu",
    symbol: "doraemoninu",
    name: "DoraemonInu",
  },
  {
    id: "doraemoon",
    symbol: "dora",
    name: "Doraemoon",
  },
  {
    id: "dora-factory",
    symbol: "dora",
    name: "Dora Factory",
  },
  {
    id: "doragonland",
    symbol: "dor",
    name: "DoragonLand",
  },
  {
    id: "doren",
    symbol: "dre",
    name: "DoRen",
  },
  {
    id: "dose-token",
    symbol: "dose",
    name: "DOSE",
  },
  {
    id: "dos-network",
    symbol: "dos",
    name: "DOS Network",
  },
  {
    id: "dotarcade",
    symbol: "adt",
    name: "DotArcade",
  },
  {
    id: "dotc-pro-token",
    symbol: "dotc",
    name: "dotc.pro",
  },
  {
    id: "dot-dot-finance",
    symbol: "ddd",
    name: "Dot Dot Finance",
  },
  {
    id: "dot-finance",
    symbol: "pink",
    name: "Dot Finance",
  },
  {
    id: "dotmoovs",
    symbol: "moov",
    name: "dotmoovs",
  },
  {
    id: "do-token",
    symbol: "do",
    name: "Do",
  },
  {
    id: "dotoracle",
    symbol: "dto",
    name: "DotOracle",
  },
  {
    id: "dotori",
    symbol: "dtr",
    name: "Dotori",
  },
  {
    id: "doubledice-token",
    symbol: "dodi",
    name: "DoubleDice",
  },
  {
    id: "doubloon",
    symbol: "dbl",
    name: "Doubloon",
  },
  {
    id: "douge",
    symbol: "douge",
    name: "Douge",
  },
  {
    id: "dough",
    symbol: "dough",
    name: "Dough",
  },
  {
    id: "dovu",
    symbol: "dov",
    name: "Dovu",
  },
  {
    id: "dowcoin",
    symbol: "dow",
    name: "Dowcoin",
  },
  {
    id: "down-below",
    symbol: "$abyss",
    name: "Down Below",
  },
  {
    id: "doxed",
    symbol: "dox",
    name: "Doxed",
  },
  {
    id: "doxxed-santa",
    symbol: "dxsanta",
    name: "Doxxed Santa",
  },
  {
    id: "dpad-finance",
    symbol: "dpad",
    name: "Dpad Finance",
  },
  {
    id: "dpk",
    symbol: "dpk token",
    name: "DPK",
  },
  {
    id: "dprating",
    symbol: "rating",
    name: "DPRating",
  },
  {
    id: "dp-token",
    symbol: "dpt",
    name: "DP",
  },
  {
    id: "draco-finance",
    symbol: "draco",
    name: "Draco.Finance",
  },
  {
    id: "dracoomaster",
    symbol: "bas",
    name: "DracooMaster",
  },
  {
    id: "dracoo-point",
    symbol: "dra",
    name: "Dracoo Point",
  },
  {
    id: "dracula",
    symbol: "drc",
    name: "Dracula",
  },
  {
    id: "dragon",
    symbol: "dragon",
    name: "Dragon",
  },
  {
    id: "dragonbit",
    symbol: "drgb",
    name: "Dragonbit",
  },
  {
    id: "dragonbite",
    symbol: "bite",
    name: "DragonBite",
  },
  {
    id: "dragonchain",
    symbol: "drgn",
    name: "Dragonchain",
  },
  {
    id: "dragon-coin",
    symbol: "drg",
    name: "Dragon Coin",
  },
  {
    id: "dragon-crypto-aurum",
    symbol: "dcau",
    name: "Dragon Crypto Aurum",
  },
  {
    id: "dragon-egg",
    symbol: "dregg",
    name: "Dragon Egg",
  },
  {
    id: "dragonereum-gold",
    symbol: "gold",
    name: "Dragonereum GOLD",
  },
  {
    id: "dragon-infinity",
    symbol: "$di",
    name: "Dragon Infinity",
  },
  {
    id: "dragon-kart-token",
    symbol: "kart",
    name: "Dragon Kart",
  },
  {
    id: "dragonknight",
    symbol: "dk",
    name: "Dragon Knight",
  },
  {
    id: "dragon-mainland-shards",
    symbol: "dms",
    name: "Dragon Mainland Shards",
  },
  {
    id: "dragonmaster-token",
    symbol: "dmt",
    name: "DragonMaster",
  },
  {
    id: "dragonmaster-totem",
    symbol: "totem",
    name: "DragonMaster Totem",
  },
  {
    id: "dragonmoon",
    symbol: "dmoon",
    name: "DragonMoon",
  },
  {
    id: "dragonmusk",
    symbol: "dmusk",
    name: "Dragonmusk",
  },
  {
    id: "dragon-pool",
    symbol: "dp",
    name: "Dragon Pool",
  },
  {
    id: "dragonsb",
    symbol: "sb",
    name: "DragonSB",
  },
  {
    id: "dragonsea",
    symbol: "dge",
    name: "DragonSea",
  },
  {
    id: "dragons-gamefi",
    symbol: "$dragons",
    name: "Dragons gameFi",
  },
  {
    id: "dragon-slayer",
    symbol: "drs",
    name: "Dragon Slayer",
  },
  {
    id: "dragons-quick",
    symbol: "dquick",
    name: "Dragon's Quick",
  },
  {
    id: "dragonvein",
    symbol: "dvc",
    name: "DragonVein",
  },
  {
    id: "dragon-verse",
    symbol: "drv",
    name: "Dragon Verse",
  },
  {
    id: "dragon-war",
    symbol: "draw",
    name: "Dragon War",
  },
  {
    id: "dragon-x",
    symbol: "dax",
    name: "Dragon X",
  },
  {
    id: "drakeball-token",
    symbol: "dball",
    name: "DrakeBall [OLD]",
  },
  {
    id: "draken",
    symbol: "drk",
    name: "Draken",
  },
  {
    id: "drakoin",
    symbol: "drk",
    name: "Drakoin",
  },
  {
    id: "drawshop-kingdom-reverse-joystick",
    symbol: "joy",
    name: "Drawshop Kingdom Reverse Joystick",
  },
  {
    id: "drax",
    symbol: "drax",
    name: "Drax",
  },
  {
    id: "drc-mobility",
    symbol: "drc",
    name: "DRC Mobility",
  },
  {
    id: "drdoge",
    symbol: "drdoge",
    name: "DrDoge",
  },
  {
    id: "dreamdao",
    symbol: "dream",
    name: "DreamDAO",
  },
  {
    id: "dreamn",
    symbol: "$dreamn",
    name: "DreamN",
  },
  {
    id: "dreamr-platform-token",
    symbol: "dmr",
    name: "Dreamr Platform",
  },
  {
    id: "dreamscoin",
    symbol: "dream",
    name: "DreamsCoin",
  },
  {
    id: "dreams-quest",
    symbol: "dreams",
    name: "Dreams Quest",
  },
  {
    id: "dream-swap",
    symbol: "dream",
    name: "Dream Swap",
  },
  {
    id: "dream-token",
    symbol: "dream",
    name: "Dream",
  },
  {
    id: "dreamverse",
    symbol: "dv",
    name: "Dreamverse",
  },
  {
    id: "dreamy-undersea-world",
    symbol: "duw",
    name: "Dreamy Undersea World",
  },
  {
    id: "d-reit",
    symbol: "drt",
    name: "D-ReiT",
  },
  {
    id: "drep",
    symbol: "drep",
    name: "Drep",
  },
  {
    id: "drep-new",
    symbol: "drep",
    name: "Drep [new]",
  },
  {
    id: "drife",
    symbol: "drf",
    name: "Drife",
  },
  {
    id: "driftdelivery-cc",
    symbol: "drift",
    name: "DriftDelivery.CC",
  },
  {
    id: "drip-network",
    symbol: "drip",
    name: "Drip Network",
  },
  {
    id: "dripto",
    symbol: "dryp",
    name: "Dripto",
  },
  {
    id: "drivenx",
    symbol: "dvx",
    name: "DRIVENx",
  },
  {
    id: "dronefly",
    symbol: "kdc",
    name: "DroneFly",
  },
  {
    id: "drops-ownership-power",
    symbol: "dop",
    name: "Drops Ownership Power",
  },
  {
    id: "dr-skull",
    symbol: "drsl",
    name: "Dr. Skull",
  },
  {
    id: "drunkdoge",
    symbol: "drunk",
    name: "DrunkDoge",
  },
  {
    id: "drunk-robots",
    symbol: "metal",
    name: "Drunk Robots",
  },
  {
    id: "dry-doge-metaverse",
    symbol: "drydoge",
    name: "Dry Doge Metaverse",
  },
  {
    id: "dshares",
    symbol: "dshare",
    name: "DShares",
  },
  {
    id: "d-skyscraper",
    symbol: "dsg",
    name: "D-Skyscraper",
  },
  {
    id: "dsys",
    symbol: "dsys",
    name: "DSYS",
  },
  {
    id: "dt-dragon-coin",
    symbol: "dt",
    name: "DT Dragon Coin",
  },
  {
    id: "dtng",
    symbol: "dtng",
    name: "DTNG",
  },
  {
    id: "dtravel",
    symbol: "trvl",
    name: "TRVL",
  },
  {
    id: "dtsla",
    symbol: "dtsla",
    name: "Tesla Tokenized Stock Defichain",
  },
  {
    id: "dtube-coin",
    symbol: "dtube",
    name: "Dtube Coin",
  },
  {
    id: "ducato-finance",
    symbol: "ducato",
    name: "Ducato Finance",
  },
  {
    id: "duckdaodime",
    symbol: "ddim",
    name: "DuckDaoDime",
  },
  {
    id: "duckduck-token",
    symbol: "duck",
    name: "DuckDuck",
  },
  {
    id: "duckie-land-multi-metaverse",
    symbol: "mmeta",
    name: "Duckie Land Multi Metaverse",
  },
  {
    id: "duckrocket",
    symbol: "duck",
    name: "DuckRocket",
  },
  {
    id: "duck-vault-nftx",
    symbol: "duck",
    name: "DUCK Vault (NFTX)",
  },
  {
    id: "duckydefi",
    symbol: "degg",
    name: "DuckyDefi",
  },
  {
    id: "duelist-king",
    symbol: "dkt",
    name: "Duelist King",
  },
  {
    id: "duel-network",
    symbol: "duel",
    name: "Duel Network",
  },
  {
    id: "duet-protocol",
    symbol: "duet",
    name: "Duet Protocol",
  },
  {
    id: "dukascoin",
    symbol: "duk+",
    name: "Dukascoin",
  },
  {
    id: "dukecoin",
    symbol: "dkc",
    name: "Dukecoin",
  },
  {
    id: "duke-inu-token",
    symbol: "duke",
    name: "Duke Inu",
  },
  {
    id: "dulcet",
    symbol: "dlc",
    name: "Dulcet",
  },
  {
    id: "dumpbuster",
    symbol: "gtfo",
    name: "DumpBuster",
  },
  {
    id: "dune",
    symbol: "dun",
    name: "Dune",
  },
  {
    id: "dune-token",
    symbol: "dune",
    name: "Frost Finance Dune",
  },
  {
    id: "dungeonswap",
    symbol: "dnd",
    name: "DungeonSwap",
  },
  {
    id: "duo",
    symbol: "duo",
    name: "DUO Network",
  },
  {
    id: "durham-inu",
    symbol: "rbi",
    name: "Durham Inu",
  },
  {
    id: "dusd-network",
    symbol: "dusd",
    name: "DUSD Network",
  },
  {
    id: "dusk-network",
    symbol: "dusk",
    name: "DUSK Network",
  },
  {
    id: "dust",
    symbol: "dust",
    name: "Dust",
  },
  {
    id: "dust-protocol",
    symbol: "dust",
    name: "DUST Protocol",
  },
  {
    id: "dust-token",
    symbol: "dust",
    name: "DUST Token",
  },
  {
    id: "dvf",
    symbol: "dvf",
    name: "DeversiFi",
  },
  {
    id: "dvision-network",
    symbol: "dvi",
    name: "Dvision Network",
  },
  {
    id: "dxbpay",
    symbol: "dxb",
    name: "DXBPay",
  },
  {
    id: "dxchain",
    symbol: "dx",
    name: "DxChain",
  },
  {
    id: "dxdao",
    symbol: "dxd",
    name: "DXdao",
  },
  {
    id: "dxsale-network",
    symbol: "sale",
    name: "DxSale Network",
  },
  {
    id: "dx-spot",
    symbol: "dxs",
    name: "Dx Spot",
  },
  {
    id: "dyakon",
    symbol: "dyn",
    name: "DYAKON",
  },
  {
    id: "dydx",
    symbol: "dydx",
    name: "dYdX",
  },
  {
    id: "dydx-wormhole",
    symbol: "dydx",
    name: "dYdX (Wormhole)",
  },
  {
    id: "dymmax",
    symbol: "dmx",
    name: "Dymmax",
  },
  {
    id: "dynamic",
    symbol: "dyn",
    name: "Dynamic",
  },
  {
    id: "dynamic-set-dollar",
    symbol: "dsd",
    name: "Dynamic Set Dollar",
  },
  {
    id: "dynamite",
    symbol: "dyt",
    name: "DoYourTip",
  },
  {
    id: "dynamite-token",
    symbol: "dynmt",
    name: "Dynamite",
  },
  {
    id: "dynamix",
    symbol: "dyna",
    name: "Dynamix",
  },
  {
    id: "dynamo-coin",
    symbol: "dynamo",
    name: "Dynamo Coin",
  },
  {
    id: "dynasty-global-investments-ag",
    symbol: "dyn",
    name: "Dynasty Global Investments AG",
  },
  {
    id: "dyor",
    symbol: "dyor",
    name: "DYOR",
  },
  {
    id: "dystopia",
    symbol: "dyst",
    name: "Dystopia",
  },
  {
    id: "e1337",
    symbol: "1337",
    name: "1337",
  },
  {
    id: "eaglecoin-2",
    symbol: "elc",
    name: "EagleCoin",
  },
  {
    id: "eagonswap-token",
    symbol: "eagon",
    name: "EagonSwap",
  },
  {
    id: "early-bird",
    symbol: "ebird",
    name: "Early Bird",
  },
  {
    id: "earlybsc",
    symbol: "ebsc",
    name: "EarlyBSC",
  },
  {
    id: "earnablefi",
    symbol: "efi",
    name: "EarnableFi",
  },
  {
    id: "earnable-v2",
    symbol: "earn",
    name: "Earnable v2",
  },
  {
    id: "earnbusd",
    symbol: "ebusd",
    name: "EarnBUSD",
  },
  {
    id: "earncraft",
    symbol: "plot",
    name: "Earncraft",
  },
  {
    id: "earndefi",
    symbol: "edc",
    name: "EarnDeFi",
  },
  {
    id: "earnfinex",
    symbol: "efx",
    name: "Earnfinex",
  },
  {
    id: "earnguild",
    symbol: "earn",
    name: "EarnGuild",
  },
  {
    id: "earnhub",
    symbol: "ehb",
    name: "EarnHub",
  },
  {
    id: "earnpay",
    symbol: "earnpay",
    name: "EarnPay",
  },
  {
    id: "earnx-v2",
    symbol: "earnx",
    name: "EarnX V2",
  },
  {
    id: "earnzcoin",
    symbol: "erz",
    name: "EarnzCoin",
  },
  {
    id: "earthbyt",
    symbol: "ebyt",
    name: "EarthByt",
  },
  {
    id: "earthchain",
    symbol: "earth",
    name: "EarthChain",
  },
  {
    id: "earthcoin",
    symbol: "eac",
    name: "Earthcoin",
  },
  {
    id: "earthfund",
    symbol: "1earth",
    name: "EarthFund",
  },
  {
    id: "easter-floki",
    symbol: "efloki",
    name: "Easter Floki",
  },
  {
    id: "easticoin",
    symbol: "esti",
    name: "Easticoin",
  },
  {
    id: "easyfi",
    symbol: "ez",
    name: "EasyFi V2",
  },
  {
    id: "easy-finance-token",
    symbol: "eft",
    name: "Easy Finance",
  },
  {
    id: "easymine",
    symbol: "emt",
    name: "easyMine",
  },
  {
    id: "eautocoin",
    symbol: "ato",
    name: "EAutocoin",
  },
  {
    id: "eazypayza",
    symbol: "ezpay",
    name: "EazyPayZa",
  },
  {
    id: "eblockstock",
    symbol: "ebso",
    name: "eBlockStock",
  },
  {
    id: "eboost",
    symbol: "ebst",
    name: "eBoost",
  },
  {
    id: "ebox",
    symbol: "ebox",
    name: "Ebox",
  },
  {
    id: "ebsp-token",
    symbol: "ebsp",
    name: "EBSP",
  },
  {
    id: "ecash",
    symbol: "xec",
    name: "eCash",
  },
  {
    id: "ecc",
    symbol: "ecc",
    name: "ECC",
  },
  {
    id: "e-chat",
    symbol: "echt",
    name: "e-Chat",
  },
  {
    id: "echelon",
    symbol: "ech",
    name: "Echelon",
  },
  {
    id: "echidna",
    symbol: "ecd",
    name: "Echidna",
  },
  {
    id: "echoin",
    symbol: "ec",
    name: "Echoin",
  },
  {
    id: "echolink",
    symbol: "eko",
    name: "EchoLink",
  },
  {
    id: "echosoracoin",
    symbol: "esrc",
    name: "EchoSoraCoin",
  },
  {
    id: "echo-tech-coin",
    symbol: "ecot",
    name: "Echo Tech Coin",
  },
  {
    id: "ecio-space",
    symbol: "ecio",
    name: "ECIO Space",
  },
  {
    id: "eclipse-2",
    symbol: "ecp",
    name: "Eclipse",
  },
  {
    id: "ecobit",
    symbol: "ecob",
    name: "Ecobit",
  },
  {
    id: "ecochain",
    symbol: "ecoc",
    name: "Ecochain",
  },
  {
    id: "ecochain-token",
    symbol: "ect",
    name: "Ecochain Finance",
  },
  {
    id: "ecocredit",
    symbol: "eco",
    name: "EcoCREDIT",
  },
  {
    id: "eco-defi",
    symbol: "ecop",
    name: "Eco DeFi",
  },
  {
    id: "ecodollar",
    symbol: "ecos",
    name: "EcoDollar",
  },
  {
    id: "ecofi",
    symbol: "eco",
    name: "EcoFi",
  },
  {
    id: "ecog9coin",
    symbol: "egc",
    name: "EcoG9coin",
  },
  {
    id: "ecoin-2",
    symbol: "ecoin",
    name: "Ecoin",
  },
  {
    id: "ecoin-finance",
    symbol: "ecoin",
    name: "Ecoin Finance",
  },
  {
    id: "ecomi",
    symbol: "omi",
    name: "ECOMI",
  },
  {
    id: "ecoscu",
    symbol: "ecu",
    name: "ECOSC",
  },
  {
    id: "ecosystem-coin-network",
    symbol: "ecn",
    name: "Ecosystem Coin Network",
  },
  {
    id: "eco-value-coin",
    symbol: "evc",
    name: "Eco Value Coin",
  },
  {
    id: "ecowatt",
    symbol: "ewt",
    name: "Ecowatt",
  },
  {
    id: "ecp-technology",
    symbol: "ecp",
    name: "ECP+ Technology",
  },
  {
    id: "edac",
    symbol: "edac",
    name: "EDAC",
  },
  {
    id: "edain",
    symbol: "eai",
    name: "Edain",
  },
  {
    id: "edc-blockchain",
    symbol: "edc",
    name: "EDC Blockchain",
  },
  {
    id: "eddaswap",
    symbol: "edda",
    name: "EDDASwap",
  },
  {
    id: "eden",
    symbol: "eden",
    name: "EDEN",
  },
  {
    id: "edenchain",
    symbol: "edn",
    name: "Edenchain",
  },
  {
    id: "edenloop",
    symbol: "elt",
    name: "EdenLoop",
  },
  {
    id: "edge",
    symbol: "edge",
    name: "Edge",
  },
  {
    id: "edgecoin-2",
    symbol: "edgt",
    name: "Edgecoin",
  },
  {
    id: "edgeless",
    symbol: "edg",
    name: "Edgeless",
  },
  {
    id: "edgeswap",
    symbol: "egs",
    name: "EdgeSwap",
  },
  {
    id: "edgeware",
    symbol: "edg",
    name: "Edgeware",
  },
  {
    id: "educare",
    symbol: "ekt",
    name: "EDUCare",
  },
  {
    id: "education-assessment-cult",
    symbol: "eac",
    name: "Education Assessment Cult",
  },
  {
    id: "education-ecosystem",
    symbol: "ledu",
    name: "Education Ecosystem",
  },
  {
    id: "educoin",
    symbol: "edu",
    name: "Educoin",
  },
  {
    id: "edufex",
    symbol: "edux",
    name: "Edufex",
  },
  {
    id: "eeat",
    symbol: "eeat",
    name: "eEat",
  },
  {
    id: "effect-network",
    symbol: "efx",
    name: "Effect Network",
  },
  {
    id: "efil",
    symbol: "efil",
    name: "eFIL",
  },
  {
    id: "efin",
    symbol: "efin",
    name: "eFIN",
  },
  {
    id: "efin-decentralized",
    symbol: "wefin",
    name: "eFin Decentralized",
  },
  {
    id: "efinity",
    symbol: "efi",
    name: "Efinity",
  },
  {
    id: "eft",
    symbol: "eft",
    name: "EFT",
  },
  {
    id: "efun",
    symbol: "efun",
    name: "EFUN",
  },
  {
    id: "eggplant",
    symbol: "eggplant",
    name: "Eggplant",
  },
  {
    id: "eggplant-finance",
    symbol: "eggp",
    name: "Eggplant Finance",
  },
  {
    id: "egg-protocol",
    symbol: "egg",
    name: "EGG Protocol",
  },
  {
    id: "eggzilla",
    symbol: "egg",
    name: "eggzilla",
  },
  {
    id: "egoh-finance",
    symbol: "egoh",
    name: "EGOH Finance",
  },
  {
    id: "egold",
    symbol: "egold",
    name: "eGold",
  },
  {
    id: "egoras",
    symbol: "egr",
    name: "Egoras Rights",
  },
  {
    id: "egoras-credit",
    symbol: "egc",
    name: "Egoras Credit",
  },
  {
    id: "egretia",
    symbol: "egt",
    name: "Egretia",
  },
  {
    id: "egyptian-mau",
    symbol: "mau",
    name: "Egyptian Mau",
  },
  {
    id: "ehash",
    symbol: "ehash",
    name: "EHash",
  },
  {
    id: "eidos",
    symbol: "eidos",
    name: "EIDOS",
  },
  {
    id: "eifi-finance",
    symbol: "eifi",
    name: "EIFI Finance",
  },
  {
    id: "eight-hours",
    symbol: "ehrt",
    name: "Eight Hours",
  },
  {
    id: "eiichiro-oda-inu",
    symbol: "oda",
    name: "Eiichiro Oda Inu",
  },
  {
    id: "einsteinium",
    symbol: "emc2",
    name: "Einsteinium",
  },
  {
    id: "eject",
    symbol: "eject",
    name: "Eject",
  },
  {
    id: "ekta-2",
    symbol: "ekta",
    name: "Ekta",
  },
  {
    id: "elamachain",
    symbol: "elama",
    name: "Elamachain",
  },
  {
    id: "elasticswap",
    symbol: "tic",
    name: "ElasticSwap",
  },
  {
    id: "elastos",
    symbol: "ela",
    name: "Elastos",
  },
  {
    id: "electra",
    symbol: "eca",
    name: "Electra",
  },
  {
    id: "electra-protocol",
    symbol: "xep",
    name: "Electra Protocol",
  },
  {
    id: "electric-cash",
    symbol: "elcash",
    name: "Electric Cash",
  },
  {
    id: "electric-vehicle-direct-currency",
    symbol: "evdc",
    name: "Electric Vehicle Direct Currency",
  },
  {
    id: "electric-vehicle-zone",
    symbol: "evz",
    name: "Electric Vehicle Zone",
  },
  {
    id: "electrify-asia",
    symbol: "elec",
    name: "Electrify.Asia",
  },
  {
    id: "electronero",
    symbol: "etnx",
    name: "Electronero",
  },
  {
    id: "electronero-pulse",
    symbol: "etnxp",
    name: "Electronero Pulse",
  },
  {
    id: "electroneum",
    symbol: "etn",
    name: "Electroneum",
  },
  {
    id: "electronicgulden",
    symbol: "efl",
    name: "Electronic Gulden",
  },
  {
    id: "electronic-pk-chain",
    symbol: "epc",
    name: "Electronic PK Chain",
  },
  {
    id: "electrum-dark",
    symbol: "eld",
    name: "Electrum Dark",
  },
  {
    id: "elefworld",
    symbol: "elef",
    name: "ELEF World",
  },
  {
    id: "element-black",
    symbol: "elt",
    name: "Element Black",
  },
  {
    id: "element-finance",
    symbol: "elfi",
    name: "Element Finance",
  },
  {
    id: "elementrem",
    symbol: "ele",
    name: "Elementrem",
  },
  {
    id: "elements-2",
    symbol: "elm",
    name: "Elements",
  },
  {
    id: "elemon",
    symbol: "elmon",
    name: "Elemon",
  },
  {
    id: "elena-protocol",
    symbol: "elena",
    name: "Elena Protocol",
  },
  {
    id: "elephant-money",
    symbol: "elephant",
    name: "Elephant Money",
  },
  {
    id: "elevate",
    symbol: "ele",
    name: "Elevate",
  },
  {
    id: "e-leven",
    symbol: "elv",
    name: "E-leven",
  },
  {
    id: "eleven-finance",
    symbol: "ele",
    name: "Eleven Finance",
  },
  {
    id: "eleventoken",
    symbol: "elvn",
    name: "11Minutes",
  },
  {
    id: "elexir",
    symbol: "elxr",
    name: "Elexir",
  },
  {
    id: "elf-token",
    symbol: "elf",
    name: "Elf",
  },
  {
    id: "elfworld",
    symbol: "elft",
    name: "Elfworld",
  },
  {
    id: "eligma",
    symbol: "goc",
    name: "GoCrypto",
  },
  {
    id: "elis",
    symbol: "xls",
    name: "ELIS",
  },
  {
    id: "elite-swap",
    symbol: "elt",
    name: "Elite Swap",
  },
  {
    id: "elitium",
    symbol: "eum",
    name: "Elitium",
  },
  {
    id: "elk-finance",
    symbol: "elk",
    name: "Elk Finance",
  },
  {
    id: "ellipsis",
    symbol: "eps",
    name: "Ellipsis [OLD]",
  },
  {
    id: "ellipsis-x",
    symbol: "epx",
    name: "Ellipsis X",
  },
  {
    id: "eloin",
    symbol: "eloin",
    name: "Eloin",
  },
  {
    id: "elo-inu",
    symbol: "elo inu",
    name: "Elo Inu",
  },
  {
    id: "elonballs",
    symbol: "elonballs",
    name: "ELONBALLS",
  },
  {
    id: "elonbank",
    symbol: "elonbank",
    name: "ElonBank",
  },
  {
    id: "elondoge-dao",
    symbol: "edao",
    name: "ElonDoge DAO",
  },
  {
    id: "elon-doge-token",
    symbol: "edoge",
    name: "ElonDoge.io",
  },
  {
    id: "elongate",
    symbol: "elongate",
    name: "ElonGate",
  },
  {
    id: "elongate-duluxe",
    symbol: "elongd",
    name: "Elongate Deluxe",
  },
  {
    id: "elon-goat",
    symbol: "egt",
    name: "Elon GOAT",
  },
  {
    id: "elongrab",
    symbol: "elongrab",
    name: "Elongrab",
  },
  {
    id: "elonhype",
    symbol: "elonhype",
    name: "ElonHype",
  },
  {
    id: "eloniumcoin",
    symbol: "elnc",
    name: "EloniumCoin",
  },
  {
    id: "elonjet",
    symbol: "elonjet",
    name: "ElonJet",
  },
  {
    id: "elonomics",
    symbol: "$elonom",
    name: "Elonomics",
  },
  {
    id: "elon-peg",
    symbol: "elonpeg",
    name: "Elon Peg",
  },
  {
    id: "elons-marvin",
    symbol: "marvin",
    name: "Elon's Marvin",
  },
  {
    id: "elons-rabbit",
    symbol: "erabbit",
    name: "ELONs RABBIT",
  },
  {
    id: "elontech",
    symbol: "etch",
    name: "ElonTech",
  },
  {
    id: "elpis-battle",
    symbol: "eba",
    name: "Elpis Battle",
  },
  {
    id: "elrond-erd-2",
    symbol: "egld",
    name: "Elrond",
  },
  {
    id: "eltcoin",
    symbol: "eltcoin",
    name: "Eltcoin",
  },
  {
    id: "elumia",
    symbol: "elu",
    name: "Elumia",
  },
  {
    id: "elvantis",
    symbol: "elv",
    name: "Elvantis",
  },
  {
    id: "elves-century",
    symbol: "elves",
    name: "Elves Century",
  },
  {
    id: "elves-continent",
    symbol: "ek",
    name: "Elves Continent",
  },
  {
    id: "elya",
    symbol: "elya",
    name: "Elya",
  },
  {
    id: "elyfi",
    symbol: "elfi",
    name: "ELYFI",
  },
  {
    id: "elynet-token",
    symbol: "elyx",
    name: "Elynet",
  },
  {
    id: "elysia",
    symbol: "el",
    name: "ELYSIA",
  },
  {
    id: "elysian",
    symbol: "ely",
    name: "Elysian",
  },
  {
    id: "elysiant-token",
    symbol: "els",
    name: "Elysian ELS",
  },
  {
    id: "elysium",
    symbol: "lys",
    name: "Elysium",
  },
  {
    id: "emanate",
    symbol: "emt",
    name: "Emanate",
  },
  {
    id: "embr",
    symbol: "embr",
    name: "Embr",
  },
  {
    id: "emerald-crypto",
    symbol: "emd",
    name: "Emerald Crypto",
  },
  {
    id: "emerald-nodes",
    symbol: "$em",
    name: "Emerald Nodes",
  },
  {
    id: "emercoin",
    symbol: "emc",
    name: "EmerCoin",
  },
  {
    id: "eminer",
    symbol: "em",
    name: "Eminer",
  },
  {
    id: "emirex-token",
    symbol: "emrx",
    name: "Emirex",
  },
  {
    id: "emiswap",
    symbol: "esw",
    name: "EmiSwap",
  },
  {
    id: "emocoin",
    symbol: "emo",
    name: "Emocoin",
  },
  {
    id: "emogi-network",
    symbol: "lol",
    name: "EMOGI Network",
  },
  {
    id: "e-money",
    symbol: "ngm",
    name: "e-Money",
  },
  {
    id: "e-money-eur",
    symbol: "eeur",
    name: "e-Money EUR",
  },
  {
    id: "empire-capital-token",
    symbol: "ecc",
    name: "Empire Capital",
  },
  {
    id: "empire-token",
    symbol: "empire",
    name: "Empire",
  },
  {
    id: "emp-money",
    symbol: "emp",
    name: "Emp Money",
  },
  {
    id: "empow",
    symbol: "em",
    name: "Empow",
  },
  {
    id: "empowa",
    symbol: "emp",
    name: "Empowa",
  },
  {
    id: "emp-shares",
    symbol: "eshare",
    name: "EMP Shares",
  },
  {
    id: "empty-set-crypto",
    symbol: "esc",
    name: "Empty Set Crypto",
  },
  {
    id: "empty-set-dollar",
    symbol: "esd",
    name: "Empty Set Dollar",
  },
  {
    id: "empyrean",
    symbol: "empyr",
    name: "Empyrean",
  },
  {
    id: "emrals",
    symbol: "emrals",
    name: "Emrals",
  },
  {
    id: "encocoinplus",
    symbol: "epg",
    name: "Encocoinplus",
  },
  {
    id: "encrypgen",
    symbol: "dna",
    name: "EncrypGen",
  },
  {
    id: "endgame-token",
    symbol: "end",
    name: "Endgame",
  },
  {
    id: "endless-battlefield",
    symbol: "eb",
    name: "Endless Battlefield",
  },
  {
    id: "endless-battlefield-coin",
    symbol: "ebc",
    name: "Endless Battlefield Coin",
  },
  {
    id: "endor",
    symbol: "edr",
    name: "Endor Protocol",
  },
  {
    id: "endpoint-cex-fan-token",
    symbol: "endcex",
    name: "Endpoint Cex Fan Token",
  },
  {
    id: "eneftor",
    symbol: "eftr",
    name: "Eneftor",
  },
  {
    id: "enegra",
    symbol: "egx",
    name: "Enegra",
  },
  {
    id: "energi",
    symbol: "nrg",
    name: "Energi",
  },
  {
    id: "energi-dollar",
    symbol: "usde",
    name: "Energi Dollar",
  },
  {
    id: "energo",
    symbol: "tsl",
    name: "Tesla TSL",
  },
  {
    id: "energoncoin",
    symbol: "tfg1",
    name: "Energoncoin",
  },
  {
    id: "energy",
    symbol: "nrgy",
    name: "ENERGY",
  },
  {
    id: "energy8",
    symbol: "e8",
    name: "Energy8",
  },
  {
    id: "energy-efficient-mortgage-tokenized-stock-defichain",
    symbol: "deem",
    name: "iShares MSCI Emerging Markets ETF Defichain",
  },
  {
    id: "energyfi",
    symbol: "eft",
    name: "Energyfi",
  },
  {
    id: "energy-ledger",
    symbol: "elx",
    name: "Energy Ledger",
  },
  {
    id: "energy-pay",
    symbol: "eny",
    name: "Energy Pay",
  },
  {
    id: "energy-web-token",
    symbol: "ewt",
    name: "Energy Web",
  },
  {
    id: "enex",
    symbol: "enx",
    name: "ENEX",
  },
  {
    id: "engine",
    symbol: "egcc",
    name: "Engine",
  },
  {
    id: "engines-of-fury",
    symbol: "fury",
    name: "Engines of Fury",
  },
  {
    id: "engine-token",
    symbol: "engn",
    name: "Engine Token",
  },
  {
    id: "enhanced-liquidity-konstrukt",
    symbol: "elk",
    name: "Enhanced Liquidity Konstrukt",
  },
  {
    id: "enhance-v2",
    symbol: "enh",
    name: "Enhance V2",
  },
  {
    id: "enigma",
    symbol: "eng",
    name: "Enigma",
  },
  {
    id: "enjincoin",
    symbol: "enj",
    name: "Enjin Coin",
  },
  {
    id: "enjinstarter",
    symbol: "ejs",
    name: "Enjinstarter",
  },
  {
    id: "enjin-wormhole",
    symbol: "enj",
    name: "Enjin (Wormhole)",
  },
  {
    id: "enkix",
    symbol: "ekx",
    name: "EnkiX",
  },
  {
    id: "enno-cash",
    symbol: "enno",
    name: "ENNO Cash",
  },
  {
    id: "enq-enecuum",
    symbol: "enq",
    name: "Enecuum",
  },
  {
    id: "enreachdao",
    symbol: "nrch",
    name: "EnreachDAO",
  },
  {
    id: "enrex",
    symbol: "enrx",
    name: "Enrex",
  },
  {
    id: "en-tan-mo",
    symbol: "etm",
    name: "En-Tan-Mo",
  },
  {
    id: "enterbutton",
    symbol: "entc",
    name: "EnterButton",
  },
  {
    id: "entercoin",
    symbol: "entrc",
    name: "EnterCoin",
  },
  {
    id: "enterdao",
    symbol: "entr",
    name: "EnterDAO",
  },
  {
    id: "entireswap",
    symbol: "entire",
    name: "EntireSwap",
  },
  {
    id: "entropyfi",
    symbol: "erp",
    name: "Entropyfi",
  },
  {
    id: "env-finance",
    symbol: "env",
    name: "ENV Finance",
  },
  {
    id: "envion",
    symbol: "evn",
    name: "Envion",
  },
  {
    id: "enviro",
    symbol: "enviro",
    name: "Enviro",
  },
  {
    id: "envision",
    symbol: "vis",
    name: "Envision",
  },
  {
    id: "envoy-defi",
    symbol: "voy",
    name: "enVoy DeFi",
  },
  {
    id: "envoy-network",
    symbol: "env",
    name: "Envoy",
  },
  {
    id: "eos",
    symbol: "eos",
    name: "EOS",
  },
  {
    id: "eosbet",
    symbol: "bet",
    name: "EarnBet",
  },
  {
    id: "eosblack",
    symbol: "black",
    name: "eosBLACK",
  },
  {
    id: "eosdac",
    symbol: "eosdac",
    name: "eosDAC",
  },
  {
    id: "eosforce",
    symbol: "eosc",
    name: "EOSForce",
  },
  {
    id: "eos-pow-coin",
    symbol: "pow",
    name: "EOS PoW Coin",
  },
  {
    id: "eox",
    symbol: "eox",
    name: "EOX",
  },
  {
    id: "epanus",
    symbol: "eps",
    name: "Epanus",
  },
  {
    id: "epic-cash",
    symbol: "epic",
    name: "Epic Cash",
  },
  {
    id: "epichero",
    symbol: "epichero",
    name: "EpicHero",
  },
  {
    id: "epic-war",
    symbol: "ewar",
    name: "Epic War",
  },
  {
    id: "epik-prime",
    symbol: "epik",
    name: "Epik Prime",
  },
  {
    id: "epik-protocol",
    symbol: "epk",
    name: "EpiK Protocol",
  },
  {
    id: "eqifi",
    symbol: "eqx",
    name: "EQIFi",
  },
  {
    id: "equal",
    symbol: "eql",
    name: "Equal",
  },
  {
    id: "equalizer",
    symbol: "eqz",
    name: "Equalizer",
  },
  {
    id: "equilibrium",
    symbol: "eq",
    name: "Equilibrium Games",
  },
  {
    id: "equilibrium-eosdt",
    symbol: "eosdt",
    name: "Equilibrium EOSDT",
  },
  {
    id: "equinox",
    symbol: "enx",
    name: "Equinox",
  },
  {
    id: "equitrader",
    symbol: "eqt",
    name: "EquiTrader",
  },
  {
    id: "equos-origin",
    symbol: "eqo",
    name: "EQO",
  },
  {
    id: "era7",
    symbol: "era",
    name: "Era7",
  },
  {
    id: "e-radix",
    symbol: "exrd",
    name: "e-Radix",
  },
  {
    id: "era-swap-token",
    symbol: "es",
    name: "Era Swap",
  },
  {
    id: "erc20",
    symbol: "erc20",
    name: "ERC20",
  },
  {
    id: "ergo",
    symbol: "erg",
    name: "Ergo",
  },
  {
    id: "ergopad",
    symbol: "ergopad",
    name: "Ergopad",
  },
  {
    id: "erica-social-token",
    symbol: "est",
    name: "Erica Social Token",
  },
  {
    id: "eristica",
    symbol: "ert",
    name: "Eristica",
  },
  {
    id: "eron",
    symbol: "eron",
    name: "ERON",
  },
  {
    id: "eros",
    symbol: "ers",
    name: "Eros",
  },
  {
    id: "eroverse",
    symbol: "ero",
    name: "Eroverse",
  },
  {
    id: "ertha",
    symbol: "ertha",
    name: "Ertha",
  },
  {
    id: "erugo-world-coin",
    symbol: "ewc",
    name: "Erugo World Coin",
  },
  {
    id: "erzurumspor-token",
    symbol: "erz",
    name: "Erzurumspor Token",
  },
  {
    id: "escoin-token",
    symbol: "elg",
    name: "Escoin",
  },
  {
    id: "escudonavacense",
    symbol: "esn",
    name: "EscudoNavacense",
  },
  {
    id: "esg",
    symbol: "esg",
    name: "ESG",
  },
  {
    id: "esg-chain",
    symbol: "esgc",
    name: "ESG Chain",
  },
  {
    id: "eska",
    symbol: "esk",
    name: "Eska",
  },
  {
    id: "eskisehir-fan-token",
    symbol: "eses",
    name: "Eskişehir Fan Tokens",
  },
  {
    id: "espers",
    symbol: "esp",
    name: "Espers",
  },
  {
    id: "esplash",
    symbol: "espl",
    name: "ESplash",
  },
  {
    id: "esportgame",
    symbol: "esm",
    name: "EsportGame",
  },
  {
    id: "esports",
    symbol: "ert",
    name: "Esports.com",
  },
  {
    id: "esportspro",
    symbol: "espro",
    name: "EsportsPro",
  },
  {
    id: "esportsref",
    symbol: "esr",
    name: "EsportsRef",
  },
  {
    id: "essence-of-creation",
    symbol: "eoc",
    name: "Essence of Creation",
  },
  {
    id: "essentia",
    symbol: "ess",
    name: "Essentia",
  },
  {
    id: "ester-finance",
    symbol: "est",
    name: "Ester Finance",
  },
  {
    id: "eswapping-v2",
    symbol: "eswapv2",
    name: "eSwapping v2",
  },
  {
    id: "eterland",
    symbol: "eter",
    name: "Eterland",
  },
  {
    id: "etermon",
    symbol: "etm",
    name: "Etermon",
  },
  {
    id: "eterna-hybrid-exchange",
    symbol: "ehx",
    name: "Eterna Hybrid Exchange",
  },
  {
    id: "eternal-dragons",
    symbol: "",
    name: "Eternal Dragons",
  },
  {
    id: "eternalflow",
    symbol: "eft",
    name: "EternalFlow",
  },
  {
    id: "eternal-oasis",
    symbol: "etos",
    name: "Eternal Oasis",
  },
  {
    id: "eternal-spire-v2",
    symbol: "ensp",
    name: "Eternal Spire V2",
  },
  {
    id: "etg-finance",
    symbol: "etgf",
    name: "ETG Finance",
  },
  {
    id: "eth_20_day_ma_crossover_set",
    symbol: "eth20smaco",
    name: "ETH 20 Day MA Crossover Set",
  },
  {
    id: "eth2-staking-by-poolx",
    symbol: "eth2",
    name: "Eth 2.0 Staking by Pool-X",
  },
  {
    id: "eth-2x-flexible-leverage-index",
    symbol: "eth2x-fli",
    name: "Index Coop - ETH 2x Flexible Leverage Index",
  },
  {
    id: "eth3s",
    symbol: "eth3s",
    name: "ETH3S",
  },
  {
    id: "etha-lend",
    symbol: "etha",
    name: "ETHA Lend",
  },
  {
    id: "ethax",
    symbol: "ethax",
    name: "ETHAX",
  },
  {
    id: "ethbnt",
    symbol: "ethbnt",
    name: "ETHBNT Relay",
  },
  {
    id: "ethbtc-2x-long-polygon",
    symbol: "mratiomoon",
    name: "ETHBTC 2x Long (Polygon)",
  },
  {
    id: "ethbtc-2x-long-token",
    symbol: "ethbtcmoon",
    name: "ETHBTC 2x Long",
  },
  {
    id: "ethdown",
    symbol: "ethdown",
    name: "ETHDOWN",
  },
  {
    id: "ethdox",
    symbol: "ethdox",
    name: "ETHDOX",
  },
  {
    id: "etheal",
    symbol: "heal",
    name: "Etheal",
  },
  {
    id: "etheking",
    symbol: "ethe",
    name: "ETHEKing",
  },
  {
    id: "ether-1",
    symbol: "etho",
    name: "Etho Protocol",
  },
  {
    id: "ethera-2",
    symbol: "eta",
    name: "Ethera",
  },
  {
    id: "ethera-black",
    symbol: "etb",
    name: "Ethera Black",
  },
  {
    id: "etherback",
    symbol: "ethback",
    name: "EtherBack",
  },
  {
    id: "etherconnect",
    symbol: "ecc",
    name: "Etherconnect",
  },
  {
    id: "ethereans",
    symbol: "os",
    name: "Ethereans",
  },
  {
    id: "ethereum",
    symbol: "eth",
    name: "Ethereum",
  },
  {
    id: "ethereum-apex",
    symbol: "eapex",
    name: "Ethereum Apex",
  },
  {
    id: "ethereum-cash",
    symbol: "ecash",
    name: "Ethereum Cash",
  },
  {
    id: "ethereum-cash-token",
    symbol: "ecash",
    name: "Ethereum Cash ECASH",
  },
  {
    id: "ethereum-classic",
    symbol: "etc",
    name: "Ethereum Classic",
  },
  {
    id: "ethereum-eagle-project",
    symbol: "egl",
    name: "Ethereum Gas Limit",
  },
  {
    id: "ethereum-gold",
    symbol: "etg",
    name: "Ethereum Gold",
  },
  {
    id: "ethereum-gold-project",
    symbol: "etgp",
    name: "Ethereum Gold Project",
  },
  {
    id: "ethereum-lite",
    symbol: "elite",
    name: "Ethereum Lite",
  },
  {
    id: "ethereummax",
    symbol: "emax",
    name: "EthereumMax",
  },
  {
    id: "ethereum-meta",
    symbol: "ethm",
    name: "Ethereum Meta",
  },
  {
    id: "ethereum-money",
    symbol: "ethmny",
    name: "Ethereum Money",
  },
  {
    id: "ethereum-name-service",
    symbol: "ens",
    name: "Ethereum Name Service",
  },
  {
    id: "ethereum-name-service-wormhole",
    symbol: "ens",
    name: "Ethereum Name Service (Wormhole)",
  },
  {
    id: "ethereum-push-notification-service",
    symbol: "push",
    name: "Ethereum Push Notification Service - EPNS",
  },
  {
    id: "ethereum-shillings",
    symbol: "eshill",
    name: "Ethereum Shillings",
  },
  {
    id: "ethereum-stake",
    symbol: "ethys",
    name: "Ethereum Stake",
  },
  {
    id: "ethereum-volatility-index-token",
    symbol: "ethv",
    name: "Ethereum Volatility Index Token",
  },
  {
    id: "ethereum-wormhole",
    symbol: "eth",
    name: "Ethereum (Wormhole)",
  },
  {
    id: "ethereum-wrapped-filecoin",
    symbol: "efil",
    name: "Ethereum Wrapped Filecoin",
  },
  {
    id: "ethereumx",
    symbol: "etx",
    name: "EthereumX",
  },
  {
    id: "ethereum-yield",
    symbol: "ethy",
    name: "Ethereum Yield",
  },
  {
    id: "ethergem",
    symbol: "egem",
    name: "EtherGem",
  },
  {
    id: "etherinc",
    symbol: "eti",
    name: "EtherInc",
  },
  {
    id: "etherisc",
    symbol: "dip",
    name: "Etherisc DIP",
  },
  {
    id: "etherland",
    symbol: "eland",
    name: "Etherland",
  },
  {
    id: "ether-legends",
    symbol: "elet",
    name: "Elementeum",
  },
  {
    id: "etherlite-2",
    symbol: "etl",
    name: "EtherLite",
  },
  {
    id: "ethermon",
    symbol: "emon",
    name: "Ethermon",
  },
  {
    id: "ethernaal",
    symbol: "naal",
    name: "Ethernaal",
  },
  {
    id: "ethernal",
    symbol: "ethernal",
    name: "Ethernal",
  },
  {
    id: "ethernal-finance",
    symbol: "ethfin",
    name: "Ethernal Finance",
  },
  {
    id: "ethernity-chain",
    symbol: "ern",
    name: "Ethernity Chain",
  },
  {
    id: "etheroll",
    symbol: "dice",
    name: "Etheroll",
  },
  {
    id: "etherparty",
    symbol: "fuel",
    name: "Etherparty",
  },
  {
    id: "etherpay",
    symbol: "ethpy",
    name: "Etherpay",
  },
  {
    id: "etherprint",
    symbol: "ethp",
    name: "Etherprint",
  },
  {
    id: "etherrock-72",
    symbol: "pebble",
    name: "Etherrock #72",
  },
  {
    id: "ethersmart",
    symbol: "etm",
    name: "EtherSmart",
  },
  {
    id: "ethersniper",
    symbol: "ets",
    name: "Ethersniper",
  },
  {
    id: "etherstones",
    symbol: "eths",
    name: "Etherstones",
  },
  {
    id: "etherzero",
    symbol: "etz",
    name: "Ether Zero",
  },
  {
    id: "ethfan-burn",
    symbol: "$efb",
    name: "ETHFan Burn",
  },
  {
    id: "eth-fan-token",
    symbol: "eft",
    name: "ETH Fan Token Ecosystem",
  },
  {
    id: "ethichub",
    symbol: "ethix",
    name: "EthicHub",
  },
  {
    id: "ethlend",
    symbol: "lend",
    name: "Aave [OLD]",
  },
  {
    id: "eth-max-yield-index",
    symbol: "ethmaxy",
    name: "ETH Max Yield Index",
  },
  {
    id: "eth-note",
    symbol: "ethnote",
    name: "Eth Note",
  },
  {
    id: "ethorse",
    symbol: "horse",
    name: "Ethorse",
  },
  {
    id: "ethos",
    symbol: "vgx",
    name: "Voyager VGX",
  },
  {
    id: "ethos-project",
    symbol: "ethos",
    name: "Ethos Project",
  },
  {
    id: "ethpad",
    symbol: "ethpad",
    name: "ETHPad",
  },
  {
    id: "ethplode",
    symbol: "ethplo",
    name: "ETHplode",
  },
  {
    id: "ethplus",
    symbol: "ethp",
    name: "ETHPlus",
  },
  {
    id: "eth-shiba",
    symbol: "ethshib",
    name: "Eth Shiba",
  },
  {
    id: "ethst-governance-token",
    symbol: "et",
    name: "ETHST Governance",
  },
  {
    id: "ethup",
    symbol: "ethup",
    name: "ETHUP",
  },
  {
    id: "eth-variable-long",
    symbol: "methmoon",
    name: "ETH Variable Leverage Long",
  },
  {
    id: "ethverse",
    symbol: "ethv",
    name: "Ethverse",
  },
  {
    id: "ethzilla",
    symbol: "ethzilla",
    name: "EthZilla",
  },
  {
    id: "etitanium",
    symbol: "etit",
    name: "eTitanium",
  },
  {
    id: "etna-metabolism",
    symbol: "mtb",
    name: "ETNA Metabolism",
  },
  {
    id: "etna-network",
    symbol: "etna",
    name: "ETNA Network",
  },
  {
    id: "etor",
    symbol: "etor",
    name: "etor",
  },
  {
    id: "etrade",
    symbol: "ett",
    name: "Etrade",
  },
  {
    id: "eub-chain",
    symbol: "eubc",
    name: "EUB Chain",
  },
  {
    id: "euler-tools",
    symbol: "euler",
    name: "Euler Tools",
  },
  {
    id: "euno",
    symbol: "euno",
    name: "EUNO",
  },
  {
    id: "eunomia",
    symbol: "ents",
    name: "EUNOMIA",
  },
  {
    id: "euphoria-2",
    symbol: "wagmi",
    name: "Euphoria",
  },
  {
    id: "eureka-coin",
    symbol: "erk",
    name: "Eureka Coin",
  },
  {
    id: "eurocoinpay",
    symbol: "ecte",
    name: "Eurocoin ECTE",
  },
  {
    id: "euronin",
    symbol: "euronin",
    name: "Euronin",
  },
  {
    id: "europa",
    symbol: "orbit",
    name: "Europa",
  },
  {
    id: "europecoin",
    symbol: "erc",
    name: "EuropeCoin",
  },
  {
    id: "euro-stable-token",
    symbol: "eurst",
    name: "Euro Stable Token",
  },
  {
    id: "eutaria",
    symbol: "eut",
    name: "Eutaria",
  },
  {
    id: "evagrow-coin",
    symbol: "eva",
    name: "Evagrow Coin",
  },
  {
    id: "evai-2",
    symbol: "ev",
    name: "Evai",
  },
  {
    id: "evanesco-network",
    symbol: "eva",
    name: "Evanesco Network",
  },
  {
    id: "evedo",
    symbol: "eved",
    name: "Evedo",
  },
  {
    id: "eve-exchange",
    symbol: "eve",
    name: "EVE",
  },
  {
    id: "evencoin",
    symbol: "evn",
    name: "EvenCoin",
  },
  {
    id: "everbnb",
    symbol: "everbnb",
    name: "EverBNB",
  },
  {
    id: "everdome",
    symbol: "dome",
    name: "Everdome",
  },
  {
    id: "everdot",
    symbol: "everdot",
    name: "EverDot",
  },
  {
    id: "everearn",
    symbol: "earn",
    name: "EverEarn",
  },
  {
    id: "everestcoin",
    symbol: "evcoin",
    name: "EverestCoin",
  },
  {
    id: "everest-token",
    symbol: "evrt",
    name: "Everest DAO",
  },
  {
    id: "evereth",
    symbol: "evereth",
    name: "EverETH",
  },
  {
    id: "everex",
    symbol: "evx",
    name: "Everex",
  },
  {
    id: "evergain",
    symbol: "evergain",
    name: "EverGain",
  },
  {
    id: "evergreen-token",
    symbol: "egt",
    name: "Evergreen",
  },
  {
    id: "evergrowcoin",
    symbol: "egc",
    name: "EverGrowCoin",
  },
  {
    id: "everid",
    symbol: "id",
    name: "Everest",
  },
  {
    id: "everipedia",
    symbol: "iq",
    name: "Everipedia",
  },
  {
    id: "everlens",
    symbol: "elen",
    name: "Everlens",
  },
  {
    id: "evermars",
    symbol: "evm",
    name: "EverMars",
  },
  {
    id: "evermoon",
    symbol: "evm",
    name: "Evermoon",
  },
  {
    id: "everprinter",
    symbol: "eprint",
    name: "EverPrinter",
  },
  {
    id: "everreflect",
    symbol: "evrf",
    name: "EverReflect",
  },
  {
    id: "everrise",
    symbol: "rise",
    name: "EverRise",
  },
  {
    id: "eversafu",
    symbol: "eversafu",
    name: "EverSAFU",
  },
  {
    id: "everscale",
    symbol: "ever",
    name: "Everscale",
  },
  {
    id: "eversol",
    symbol: "esol",
    name: "EVERSOL",
  },
  {
    id: "eversol-staked-sol",
    symbol: "esol",
    name: "EverSOL Staked SOL",
  },
  {
    id: "everswap",
    symbol: "ever",
    name: "EverSwap",
  },
  {
    id: "everton-fan-token",
    symbol: "efc",
    name: "Everton Fan Token",
  },
  {
    id: "everus",
    symbol: "evr",
    name: "Everus",
  },
  {
    id: "everyape-bsc",
    symbol: "evape",
    name: "EveryApe BSC",
  },
  {
    id: "everycoin",
    symbol: "evy",
    name: "EveryCoin",
  },
  {
    id: "every-game",
    symbol: "egame",
    name: "Every Game",
  },
  {
    id: "everyonescrypto",
    symbol: "eoc",
    name: "EveryonesCrypto",
  },
  {
    id: "every-original",
    symbol: "eveo",
    name: "EVERY ORIGINAL",
  },
  {
    id: "evident-proof-transaction-token",
    symbol: "eptt",
    name: "Evident Proof Transaction",
  },
  {
    id: "evil-coin",
    symbol: "evil",
    name: "Evil Coin",
  },
  {
    id: "evil-shiba-inu",
    symbol: "esi",
    name: "Evil Shiba Inu",
  },
  {
    id: "evilsquidgame",
    symbol: "evilsquid",
    name: "EvilSquidGame",
  },
  {
    id: "evmos",
    symbol: "evmos",
    name: "Evmos",
  },
  {
    id: "evmoswap",
    symbol: "emo",
    name: "EvmoSwap",
  },
  {
    id: "evny-token",
    symbol: "evny",
    name: "EVNY",
  },
  {
    id: "evocardano",
    symbol: "evoc",
    name: "EvoCardano",
  },
  {
    id: "evo-finance",
    symbol: "evo",
    name: "Evo Finance",
  },
  {
    id: "evolution",
    symbol: "gen",
    name: "Evolution",
  },
  {
    id: "evolution-finance",
    symbol: "evn",
    name: "Evolution Finance",
  },
  {
    id: "evolution-network",
    symbol: "evox",
    name: "Evolution Network",
  },
  {
    id: "evolution-token",
    symbol: "evo",
    name: "Evolution EVO",
  },
  {
    id: "evoverse-power",
    symbol: "epw",
    name: "Evoverse Power",
  },
  {
    id: "evoverses",
    symbol: "evo",
    name: "EvoVerses",
  },
  {
    id: "evoverse-shard",
    symbol: "evs",
    name: "Evoverse Shard",
  },
  {
    id: "evrice",
    symbol: "evc",
    name: "Evrice",
  },
  {
    id: "evrynet",
    symbol: "evry",
    name: "Evrynet",
  },
  {
    id: "evulus",
    symbol: "evu",
    name: "Evulus",
  },
  {
    id: "exalt",
    symbol: "exalt",
    name: "Exalt",
  },
  {
    id: "excalibur",
    symbol: "exc",
    name: "Excalibur",
  },
  {
    id: "excavo-finance",
    symbol: "cavo",
    name: "Excavo Finance",
  },
  {
    id: "excelon",
    symbol: "xlon",
    name: "Excelon",
  },
  {
    id: "exchangecoin",
    symbol: "excc",
    name: "ExchangeCoin",
  },
  {
    id: "exchange-genesis-ethlas-medium",
    symbol: "xgem",
    name: "Exchange Genesis Ethlas Medium",
  },
  {
    id: "exchange-union",
    symbol: "xuc",
    name: "Exchange Union",
  },
  {
    id: "exciting-japan-coin",
    symbol: "xjp",
    name: "eXciting Japan Coin",
  },
  {
    id: "exclusivecoin",
    symbol: "excl",
    name: "ExclusiveCoin",
  },
  {
    id: "exeedme",
    symbol: "xed",
    name: "Exeedme",
  },
  {
    id: "exeno",
    symbol: "exn",
    name: "exeno coin",
  },
  {
    id: "exenpay-token",
    symbol: "exenp",
    name: "ExenPay",
  },
  {
    id: "exentoken",
    symbol: "exen",
    name: "Exen",
  },
  {
    id: "exgold",
    symbol: "exg",
    name: "Exgold",
  },
  {
    id: "exip",
    symbol: "exip",
    name: "EXIP",
  },
  {
    id: "exist",
    symbol: "exist",
    name: "Exist",
  },
  {
    id: "exmoc",
    symbol: "exmoc",
    name: "EXMOC",
  },
  {
    id: "exmo-coin",
    symbol: "exm",
    name: "EXMO Coin",
  },
  {
    id: "exmr-monero",
    symbol: "exmr",
    name: "EXMR FDN",
  },
  {
    id: "exnetwork-token",
    symbol: "exnt",
    name: "ExNetwork",
  },
  {
    id: "exobots",
    symbol: "exos",
    name: "Exobots",
  },
  {
    id: "exodia",
    symbol: "exod",
    name: "Exodia",
  },
  {
    id: "exohood",
    symbol: "exo",
    name: "Exohood",
  },
  {
    id: "exor",
    symbol: "exor",
    name: "EXOR",
  },
  {
    id: "exordium-limited",
    symbol: "exo",
    name: "Exordium Limited",
  },
  {
    id: "exp",
    symbol: "exp",
    name: "Exp",
  },
  {
    id: "expanse",
    symbol: "exp",
    name: "Expanse",
  },
  {
    id: "expanz",
    symbol: "xpanz",
    name: "Expanz",
  },
  {
    id: "experience-chain",
    symbol: "xpc",
    name: "eXPerience Chain",
  },
  {
    id: "experiencecoin",
    symbol: "epc",
    name: "ExperienceCoin",
  },
  {
    id: "experty-wisdom-token",
    symbol: "wis",
    name: "Experty Wisdom",
  },
  {
    id: "exponential-capital",
    symbol: "expo",
    name: "Exponential Capital",
  },
  {
    id: "export-mortos-platform",
    symbol: "emp",
    name: "Export Motors Platform",
  },
  {
    id: "exrnchain",
    symbol: "exrn",
    name: "EXRNchain",
  },
  {
    id: "exrt-network",
    symbol: "exrt",
    name: "EXRT Network",
  },
  {
    id: "ex-sports",
    symbol: "exs",
    name: "EX Sports",
  },
  {
    id: "extradna",
    symbol: "xdna",
    name: "extraDNA",
  },
  {
    id: "exzocoin",
    symbol: "exzo",
    name: "ExzoCoin 2.0",
  },
  {
    id: "eyes-protocol",
    symbol: "eyes",
    name: "EYES Protocol",
  },
  {
    id: "ezchain",
    symbol: "ezc",
    name: "EZChain",
  },
  {
    id: "ezdex",
    symbol: "ezx",
    name: "EZDex",
  },
  {
    id: "ezillion",
    symbol: "ezi",
    name: "Ezillion",
  },
  {
    id: "ezystayz",
    symbol: "ezy",
    name: "Ezystayz",
  },
  {
    id: "fabric",
    symbol: "fab",
    name: "Fabric",
  },
  {
    id: "fabwelt",
    symbol: "welt",
    name: "Fabwelt",
  },
  {
    id: "face",
    symbol: "face",
    name: "Faceter",
  },
  {
    id: "facebook-tokenized-stock-defichain",
    symbol: "dfb",
    name: "Facebook Tokenized Stock Defichain",
  },
  {
    id: "facebook-tokenized-stock-zipmex",
    symbol: "fb",
    name: "Facebook Tokenized Stock Zipmex",
  },
  {
    id: "facedao",
    symbol: "face",
    name: "FaceDAO",
  },
  {
    id: "face-vault-nftx",
    symbol: "face",
    name: "FACE Vault (NFTX)",
  },
  {
    id: "factom",
    symbol: "fct",
    name: "Factom",
  },
  {
    id: "facts",
    symbol: "bkc",
    name: "FACTS",
  },
  {
    id: "fado-go",
    symbol: "fado",
    name: "FADO Go",
  },
  {
    id: "faircoin",
    symbol: "fair",
    name: "Faircoin",
  },
  {
    id: "fairface",
    symbol: "faf",
    name: "Fairface",
  },
  {
    id: "fairgame",
    symbol: "fair",
    name: "FairGame",
  },
  {
    id: "fairlife",
    symbol: "fairlife",
    name: "FairLife",
  },
  {
    id: "fairum",
    symbol: "fai",
    name: "Fairum",
  },
  {
    id: "fairy",
    symbol: "fairy",
    name: "Fairy",
  },
  {
    id: "fairy-forest",
    symbol: "ffn",
    name: "Fairy Forest",
  },
  {
    id: "faithcoin",
    symbol: "faith",
    name: "FaithCoin",
  },
  {
    id: "faith-tribe",
    symbol: "ftrb",
    name: "Faith Tribe",
  },
  {
    id: "falafel",
    symbol: "falafel",
    name: "Falafel",
  },
  {
    id: "falcon-nine",
    symbol: "f9",
    name: "Falcon Nine",
  },
  {
    id: "falcon-swaps",
    symbol: "falcons",
    name: "Falcon Swaps",
  },
  {
    id: "falcon-token",
    symbol: "fnt",
    name: "Falcon Project",
  },
  {
    id: "falconx",
    symbol: "falcx",
    name: "FalconX",
  },
  {
    id: "fame-mma",
    symbol: "fame",
    name: "Fame MMA",
  },
  {
    id: "family",
    symbol: "fam",
    name: "Family",
  },
  {
    id: "familyparty",
    symbol: "fpc",
    name: "FamilyParty",
  },
  {
    id: "famous-coin",
    symbol: "famous",
    name: "Famous Coin",
  },
  {
    id: "famous-five",
    symbol: "fafi",
    name: "Famous Five",
  },
  {
    id: "fam-token",
    symbol: "fam",
    name: "FAM",
  },
  {
    id: "fan8",
    symbol: "fan8",
    name: "Fan8",
  },
  {
    id: "fanadise",
    symbol: "fan",
    name: "Fanadise",
  },
  {
    id: "fananywhere",
    symbol: "faw",
    name: "FanAnywhere",
  },
  {
    id: "fanaticos-cash",
    symbol: "fch",
    name: "Fanáticos Cash",
  },
  {
    id: "fanbi-token",
    symbol: "fbt",
    name: "FANBI TOKEN",
  },
  {
    id: "fancy-games",
    symbol: "fnc",
    name: "Fancy Games",
  },
  {
    id: "fandom-chain",
    symbol: "kdc",
    name: "Fandom Chain",
  },
  {
    id: "fango",
    symbol: "xfg",
    name: "Fango",
  },
  {
    id: "fangs",
    symbol: "dragonland",
    name: "Dragon Land Metaverse",
  },
  {
    id: "fang-token",
    symbol: "fang",
    name: "FANG",
  },
  {
    id: "fanitrade",
    symbol: "fani",
    name: "FaniTrade",
  },
  {
    id: "fanscoin",
    symbol: "fc",
    name: "FansCoin",
  },
  {
    id: "fanspel",
    symbol: "fan",
    name: "Fanspel",
  },
  {
    id: "fans-squid",
    symbol: "fst",
    name: "Fans Squid",
  },
  {
    id: "fanstime",
    symbol: "fti",
    name: "FansTime",
  },
  {
    id: "fantasm-fsm",
    symbol: "fsm",
    name: "Fantasm FSM",
  },
  {
    id: "fantasm-xftm",
    symbol: "xftm",
    name: "Fantasm XFTM",
  },
  {
    id: "fantastic-protocol-fxm-token",
    symbol: "fxm",
    name: "Fantastic Protocol FXM",
  },
  {
    id: "fantastic-protocol-gaea",
    symbol: "gaea",
    name: "Fantastic Protocol GAEA",
  },
  {
    id: "fantastic-protocol-peg-avax-favax-token",
    symbol: "favax",
    name: "Fantastic Protocol Peg-AVAX (FAVAX)",
  },
  {
    id: "fantastic-protocol-peg-cro",
    symbol: "xcro",
    name: "Fantastic Protocol Peg-CRO",
  },
  {
    id: "fantastic-protocol-peg-ftm",
    symbol: "ftmx",
    name: "Fantastic Protocol Peg-FTM",
  },
  {
    id: "fantastic-protocol-snowy-token",
    symbol: "snowy",
    name: "Fantastic Protocol SNOWY",
  },
  {
    id: "fantasy",
    symbol: "ftsy",
    name: "Fantasy",
  },
  {
    id: "fantasy-doge",
    symbol: "ftd",
    name: "Fantasy Doge",
  },
  {
    id: "fantasy-gold",
    symbol: "fgc",
    name: "Fantasy Gold",
  },
  {
    id: "fantasy-monster",
    symbol: "fts",
    name: "Fantasy Monster",
  },
  {
    id: "fantasy-world-gold",
    symbol: "fwg",
    name: "Fantasy World Gold",
  },
  {
    id: "fantohm",
    symbol: "fhm",
    name: "Fantohm",
  },
  {
    id: "fantom",
    symbol: "ftm",
    name: "Fantom",
  },
  {
    id: "fantom-cake",
    symbol: "fatcake",
    name: "Fantom Cake",
  },
  {
    id: "fantom-doge",
    symbol: "rip",
    name: "Fantom Doge",
  },
  {
    id: "fantom-ethprinter",
    symbol: "fethp",
    name: "FANTOM ETHPrinter",
  },
  {
    id: "fantom-frens",
    symbol: "ffs",
    name: "Fantom Frens",
  },
  {
    id: "fantomgo",
    symbol: "ftg",
    name: "fantomGO",
  },
  {
    id: "fantom-libero-financial",
    symbol: "flibero",
    name: "Fantom Libero Financial",
  },
  {
    id: "fantom-maker",
    symbol: "fame",
    name: "Fantom Maker",
  },
  {
    id: "fantom-oasis",
    symbol: "ftmo",
    name: "Fantom Oasis",
  },
  {
    id: "fantom-of-the-opera-apes",
    symbol: "fantomapes",
    name: "Fantom of the Opera Apes",
  },
  {
    id: "fantomstarter",
    symbol: "fs",
    name: "FantomStarter",
  },
  {
    id: "fantom-token-wormhole",
    symbol: "ftmet",
    name: "Fantom Token (Wormhole)",
  },
  {
    id: "fantom-usd",
    symbol: "fusd",
    name: "Fantom USD",
  },
  {
    id: "fantums-of-opera-token",
    symbol: "foo",
    name: "Fantums of Opera",
  },
  {
    id: "fanverse",
    symbol: "fanv",
    name: "FanVerse",
  },
  {
    id: "fanzy",
    symbol: "fx1",
    name: "FANZY",
  },
  {
    id: "faraland",
    symbol: "fara",
    name: "FaraLand",
  },
  {
    id: "farmageddon",
    symbol: "fg",
    name: "Farmageddon",
  },
  {
    id: "farmbit",
    symbol: "fmb",
    name: "Farmbit",
  },
  {
    id: "farmerdoge",
    symbol: "crop",
    name: "FarmerDoge V3",
  },
  {
    id: "farmersonly-onion",
    symbol: "onion",
    name: "FarmersOnly Onion",
  },
  {
    id: "farmers-world-wood",
    symbol: "fww",
    name: "Farmers World Wood",
  },
  {
    id: "farm-finance",
    symbol: "fft",
    name: "Farm Finance",
  },
  {
    id: "farmland-protocol",
    symbol: "far",
    name: "Farmland Protocol",
  },
  {
    id: "farm-me",
    symbol: "fame",
    name: "Farm Me",
  },
  {
    id: "farm-planet",
    symbol: "fpl",
    name: "Farm Planet",
  },
  {
    id: "farmpoly",
    symbol: "poly",
    name: "FarmPoly",
  },
  {
    id: "farm-skylines",
    symbol: "fsk",
    name: "Farm Skylines",
  },
  {
    id: "farmyield",
    symbol: "famy",
    name: "FarmYield",
  },
  {
    id: "fashion-coin",
    symbol: "fshn",
    name: "Fashion Coin",
  },
  {
    id: "fast-finance",
    symbol: "fast",
    name: "Fast Finance",
  },
  {
    id: "fast-food-wolf-game",
    symbol: "ffwool",
    name: "Fast Food Wolf Game",
  },
  {
    id: "fastmoon",
    symbol: "fastmoon",
    name: "FastMoon",
  },
  {
    id: "fastswap",
    symbol: "fast",
    name: "FastSwap",
  },
  {
    id: "fastswap-bsc",
    symbol: "fast",
    name: "Fastswap (BSC)",
  },
  {
    id: "fatcake",
    symbol: "fatcake",
    name: "FatCake",
  },
  {
    id: "fatcoin",
    symbol: "fat",
    name: "Fatcoin",
  },
  {
    id: "fat-doge",
    symbol: "foge",
    name: "Fat Doge",
  },
  {
    id: "fate-token",
    symbol: "fate",
    name: "Fate",
  },
  {
    id: "fat-satoshi",
    symbol: "fatoshi",
    name: "Fat Satoshi",
  },
  {
    id: "favecoin",
    symbol: "fave",
    name: "Favecoin",
  },
  {
    id: "favor",
    symbol: "favor",
    name: "Favor",
  },
  {
    id: "fayre",
    symbol: "fayre",
    name: "Fayre",
  },
  {
    id: "fband",
    symbol: "fband",
    name: "fBAND",
  },
  {
    id: "fbnb",
    symbol: "fbnb",
    name: "fBNB",
  },
  {
    id: "fbomb",
    symbol: "bomb",
    name: "fBOMB",
  },
  {
    id: "fbtc",
    symbol: "fbtc",
    name: "fBTC",
  },
  {
    id: "fc-barcelona-fan-token",
    symbol: "bar",
    name: "FC Barcelona Fan Token",
  },
  {
    id: "fc-porto",
    symbol: "porto",
    name: "FC Porto",
  },
  {
    id: "fdoge-finance",
    symbol: "fdoge",
    name: "FDoge Finance",
  },
  {
    id: "fds",
    symbol: "fds",
    name: "Fair Dollars",
  },
  {
    id: "fear",
    symbol: "fear",
    name: "Fear",
  },
  {
    id: "fear-token",
    symbol: "fear",
    name: "Spookyverse Fear",
  },
  {
    id: "feathercoin",
    symbol: "ftc",
    name: "Feathercoin",
  },
  {
    id: "fedoracoin",
    symbol: "tips",
    name: "Fedoracoin",
  },
  {
    id: "fedora-gold",
    symbol: "fed",
    name: "Fedora Gold",
  },
  {
    id: "feeder-finance",
    symbol: "feed",
    name: "Feeder Finance",
  },
  {
    id: "feed-pups",
    symbol: "fups",
    name: "Feed Pups",
  },
  {
    id: "feelcoin",
    symbol: "feel",
    name: "FeelCoin",
  },
  {
    id: "feg-token",
    symbol: "feg",
    name: "FEG",
  },
  {
    id: "feg-token-bsc",
    symbol: "feg",
    name: "FEG BSC",
  },
  {
    id: "feichang-niu",
    symbol: "fcn",
    name: "Feichang Niu",
  },
  {
    id: "feisty-doge-nft",
    symbol: "nfd",
    name: "Feisty Doge NFT",
  },
  {
    id: "fei-usd",
    symbol: "fei",
    name: "Fei USD",
  },
  {
    id: "felix",
    symbol: "flx",
    name: "Felix",
  },
  {
    id: "fenerbahce-token",
    symbol: "fb",
    name: "Fenerbahçe",
  },
  {
    id: "fenix-danjon",
    symbol: "djn",
    name: "Fenix Danjon",
  },
  {
    id: "fenomy",
    symbol: "fenomy",
    name: "Fenomy",
  },
  {
    id: "fera",
    symbol: "fera",
    name: "Fera",
  },
  {
    id: "ferret",
    symbol: "frt",
    name: "Ferret",
  },
  {
    id: "ferrum-network",
    symbol: "frm",
    name: "Ferrum Network",
  },
  {
    id: "fertilizer",
    symbol: "frt",
    name: "Fertilizer",
  },
  {
    id: "fess-chain",
    symbol: "fess",
    name: "Fesschain",
  },
  {
    id: "fetch-ai",
    symbol: "fet",
    name: "Fetch.ai",
  },
  {
    id: "fetch-inu",
    symbol: "finu",
    name: "Fetch Inu",
  },
  {
    id: "feth",
    symbol: "feth",
    name: "fETH",
  },
  {
    id: "fetish-coin",
    symbol: "fetish",
    name: "Fetish Coin",
  },
  {
    id: "feudalz-goldz",
    symbol: "goldz",
    name: "Feudalz Goldz",
  },
  {
    id: "feyorra",
    symbol: "fey",
    name: "Feyorra",
  },
  {
    id: "fia-protocol",
    symbol: "fia",
    name: "FIA Protocol",
  },
  {
    id: "fiat24-usd",
    symbol: "usd24",
    name: "Fiat24 USD",
  },
  {
    id: "fiat-dao-token",
    symbol: "fdt",
    name: "Fiat DAO",
  },
  {
    id: "fibitpro-exchange",
    symbol: "fbt",
    name: "Fibitpro Exchange",
  },
  {
    id: "fibodex",
    symbol: "fibo",
    name: "FiboDex",
  },
  {
    id: "fibos",
    symbol: "fo",
    name: "FIBOS",
  },
  {
    id: "fibo-token",
    symbol: "fibo",
    name: "FibSwap DEX",
  },
  {
    id: "fidelis",
    symbol: "fdls",
    name: "FIDELIS",
  },
  {
    id: "fidex-exchange",
    symbol: "fex",
    name: "FIDEX Exchange",
  },
  {
    id: "fidira",
    symbol: "fid",
    name: "Fidira",
  },
  {
    id: "fidometa",
    symbol: "fmc",
    name: "FidoMeta",
  },
  {
    id: "fief",
    symbol: "fief",
    name: "Fief",
  },
  {
    id: "fiestacoin",
    symbol: "fiesta",
    name: "FiestaCoin",
  },
  {
    id: "fiftyonefifty",
    symbol: "fifty",
    name: "FIFTYONEFIFTY",
  },
  {
    id: "filda",
    symbol: "filda",
    name: "Filda",
  },
  {
    id: "filecash",
    symbol: "fic",
    name: "Filecash",
  },
  {
    id: "filecoin",
    symbol: "fil",
    name: "Filecoin",
  },
  {
    id: "filecoin-standard-full-hashrate",
    symbol: "sfil",
    name: "Filecoin Standard Full Hashrate",
  },
  {
    id: "filecoin-standard-hashrate-token",
    symbol: "filst",
    name: "Filecoin Standard Hashrate",
  },
  {
    id: "filenet",
    symbol: "fn",
    name: "Filenet",
  },
  {
    id: "filestar",
    symbol: "star",
    name: "FileStar",
  },
  {
    id: "filipcoin",
    symbol: "fcp",
    name: "Filipcoin",
  },
  {
    id: "film-coin",
    symbol: "fliks",
    name: "Film Coin",
  },
  {
    id: "fimi-market-inc",
    symbol: "fimi",
    name: "Fimi Market Inc.",
  },
  {
    id: "final-frontier",
    symbol: "frnt",
    name: "Final Frontier",
  },
  {
    id: "finance-blocks",
    symbol: "fbx",
    name: "Finance Blocks",
  },
  {
    id: "finance-vote",
    symbol: "fvt",
    name: "Finance Vote",
  },
  {
    id: "financial-intelligence-games",
    symbol: "fig",
    name: "Financial Intelligence Games",
  },
  {
    id: "financial-intelligence-group-token",
    symbol: "atbfig",
    name: "Financial Intelligence Group",
  },
  {
    id: "financial-investment-token",
    symbol: "fit",
    name: "FINANCIAL INVESTMENT",
  },
  {
    id: "financio",
    symbol: "fin",
    name: "Financio",
  },
  {
    id: "findora",
    symbol: "fra",
    name: "Findora",
  },
  {
    id: "findshibby",
    symbol: "fshibby",
    name: "Findshibby",
  },
  {
    id: "finexbox-token",
    symbol: "fnb",
    name: "Finexbox",
  },
  {
    id: "fingerprints",
    symbol: "prints",
    name: "FingerprintsDAO",
  },
  {
    id: "finminity",
    symbol: "fmt",
    name: "Finminity",
  },
  {
    id: "fino-dao",
    symbol: "fino",
    name: "FINO DAO",
  },
  {
    id: "fins-token",
    symbol: "fins",
    name: "Fins",
  },
  {
    id: "fintab",
    symbol: "fntb",
    name: "FinTab",
  },
  {
    id: "fintropy",
    symbol: "fint",
    name: "Fintropy",
  },
  {
    id: "fintrux",
    symbol: "ftx",
    name: "FintruX",
  },
  {
    id: "finxflo",
    symbol: "fxf",
    name: "FINXFLO",
  },
  {
    id: "fio-protocol",
    symbol: "fio",
    name: "FIO Protocol",
  },
  {
    id: "fira",
    symbol: "fira",
    name: "FIRA",
  },
  {
    id: "firdaos",
    symbol: "fdo",
    name: "Firdaos",
  },
  {
    id: "fireants",
    symbol: "ants",
    name: "FireAnts",
  },
  {
    id: "fireball-2",
    symbol: "fire",
    name: "FireBall",
  },
  {
    id: "firebird-finance",
    symbol: "hope",
    name: "Firebird.Finance",
  },
  {
    id: "firebot",
    symbol: "fbx",
    name: "FireBot",
  },
  {
    id: "fireflame-inu",
    symbol: "fire",
    name: "FireFlame Inu",
  },
  {
    id: "fire-lotto",
    symbol: "flot",
    name: "Fire Lotto",
  },
  {
    id: "fire-protocol",
    symbol: "fire",
    name: "Fire Protocol",
  },
  {
    id: "firerocket",
    symbol: "firerocket",
    name: "FireRocket",
  },
  {
    id: "firestarter",
    symbol: "flame",
    name: "FireStarter",
  },
  {
    id: "firetoken",
    symbol: "fire",
    name: "Firework Games",
  },
  {
    id: "fire-token-2",
    symbol: "fire",
    name: "Fire",
  },
  {
    id: "firewood",
    symbol: "wood",
    name: "Firewood",
  },
  {
    id: "firezard",
    symbol: "zard",
    name: "FireZard",
  },
  {
    id: "firmachain",
    symbol: "fct",
    name: "Firmachain",
  },
  {
    id: "first-bitcoin",
    symbol: "bit",
    name: "First Bitcoin",
  },
  {
    id: "firstdoge",
    symbol: "firstdoge",
    name: "FirstDoge",
  },
  {
    id: "first-eleven",
    symbol: "f11",
    name: "First Eleven",
  },
  {
    id: "first-ever-nft",
    symbol: "fen",
    name: "First Ever NFT",
  },
  {
    id: "firsthare",
    symbol: "firsthare",
    name: "FirstHare",
  },
  {
    id: "first-inu",
    symbol: "finu",
    name: "First Inu",
  },
  {
    id: "firulais",
    symbol: "firu",
    name: "Firulais",
  },
  {
    id: "firulais-wallet-token",
    symbol: "fiwt",
    name: "Firulais Wallet",
  },
  {
    id: "fisco",
    symbol: "fscc",
    name: "FISCO Coin",
  },
  {
    id: "fish-crypto",
    symbol: "fico",
    name: "Fish Crypto",
  },
  {
    id: "fishervspirate",
    symbol: "fvp",
    name: "FisherVsPirate",
  },
  {
    id: "fishing-town",
    symbol: "fhtn",
    name: "Fishing Town",
  },
  {
    id: "fishingtowngiltoken",
    symbol: "gil",
    name: "FishingTownGil",
  },
  {
    id: "fishy-tank-token",
    symbol: "fte",
    name: "Fishy Tank",
  },
  {
    id: "fistbump",
    symbol: "fist",
    name: "Fistbump",
  },
  {
    id: "fit-beat",
    symbol: "ftb",
    name: "Fit&Beat",
  },
  {
    id: "fitmin",
    symbol: "ftm",
    name: "Fitmin",
  },
  {
    id: "fitscrypt",
    symbol: "$fit",
    name: "FitScrypt",
  },
  {
    id: "fit-token",
    symbol: "fit",
    name: "FIT",
  },
  {
    id: "five-balance",
    symbol: "fbn",
    name: "Fivebalance Coin",
  },
  {
    id: "fivekm-kmt",
    symbol: "kmt",
    name: "FiveKM KMT",
  },
  {
    id: "fixed-income-asset-token",
    symbol: "fiat",
    name: "Fixed Income Asset",
  },
  {
    id: "fixed-trade-coin",
    symbol: "fxtc",
    name: "Fixed Trade Coin",
  },
  {
    id: "fk-coin",
    symbol: "fk",
    name: "FK Coin",
  },
  {
    id: "flag-network",
    symbol: "flag",
    name: "Flag Network",
  },
  {
    id: "flamengo-fan-token",
    symbol: "mengo",
    name: "Flamengo Fan Token",
  },
  {
    id: "flamingo-finance",
    symbol: "flm",
    name: "Flamingo Finance",
  },
  {
    id: "flappydoge",
    symbol: "flpd",
    name: "FlappyDoge",
  },
  {
    id: "flappy-floki",
    symbol: "flaflo",
    name: "Flappy Floki",
  },
  {
    id: "flappy-shiba-inu",
    symbol: "fsinu",
    name: "Flappy Shiba Inu",
  },
  {
    id: "flare-finance",
    symbol: "exfi",
    name: "Flare Finance",
  },
  {
    id: "flare-token",
    symbol: "1flr",
    name: "Flare",
  },
  {
    id: "flash-inu",
    symbol: "flash",
    name: "Flash Inu",
  },
  {
    id: "flash-token",
    symbol: "flash",
    name: "Flash Loans",
  },
  {
    id: "flash-token-2",
    symbol: "flash",
    name: "Flash",
  },
  {
    id: "flashx-ultra",
    symbol: "fsxu",
    name: "FlashX Ultra",
  },
  {
    id: "flatqube",
    symbol: "qube",
    name: "FlatQube",
  },
  {
    id: "flavors-bsc",
    symbol: "flvr",
    name: "Flavors BSC",
  },
  {
    id: "flesh-token",
    symbol: "flesh",
    name: "Flesh",
  },
  {
    id: "fleta",
    symbol: "fleta",
    name: "FLETA",
  },
  {
    id: "flex-coin",
    symbol: "flex",
    name: "FLEX Coin",
  },
  {
    id: "flexq",
    symbol: "flq",
    name: "FlexQ",
  },
  {
    id: "flex-usd",
    symbol: "flexusd",
    name: "flexUSD",
  },
  {
    id: "flinch",
    symbol: "fln",
    name: "Flinch",
  },
  {
    id: "flink",
    symbol: "flink",
    name: "fLINK",
  },
  {
    id: "flipstar",
    symbol: "flip",
    name: "FlipStar",
  },
  {
    id: "flits",
    symbol: "fls",
    name: "Flits",
  },
  {
    id: "flix",
    symbol: "flix",
    name: "Flix",
  },
  {
    id: "flixxo",
    symbol: "flixx",
    name: "Flixxo",
  },
  {
    id: "float-protocol",
    symbol: "bank",
    name: "Float Protocol",
  },
  {
    id: "float-protocol-float",
    symbol: "float",
    name: "Float Protocol: Float",
  },
  {
    id: "flock",
    symbol: "flock",
    name: "Flock",
  },
  {
    id: "flokibonk",
    symbol: "flobo",
    name: "FlokiBonk",
  },
  {
    id: "flokibro",
    symbol: "fbro",
    name: "FlokiBro",
  },
  {
    id: "flokicoke",
    symbol: "flokicoke",
    name: "FlokiCoke",
  },
  {
    id: "flokidoge",
    symbol: "$floge",
    name: "Flokidoge",
  },
  {
    id: "flokifrunkpuppy",
    symbol: "flokifrunkpuppy",
    name: "FlokiFrunkPuppy",
  },
  {
    id: "flokigainz",
    symbol: "gainz",
    name: "FlokiGainz",
  },
  {
    id: "floki-inu",
    symbol: "floki",
    name: "Floki Inu",
  },
  {
    id: "floki-millions",
    symbol: "millions",
    name: "Floki Millions",
  },
  {
    id: "floki-monk",
    symbol: "flokimonk",
    name: "Floki Monk",
  },
  {
    id: "flokimooni",
    symbol: "flokim",
    name: "Flokimooni",
  },
  {
    id: "floki-musk",
    symbol: "floki",
    name: "Floki Musk",
  },
  {
    id: "flokipad",
    symbol: "flokipad",
    name: "FlokiPad",
  },
  {
    id: "floki-pup",
    symbol: "flokipup",
    name: "Floki Pup",
  },
  {
    id: "flokirai",
    symbol: "flokirai",
    name: "Flokirai",
  },
  {
    id: "flokirocket",
    symbol: "rkf",
    name: "FlokiRocket",
  },
  {
    id: "floki-rocket",
    symbol: "rloki",
    name: "Floki Rocket",
  },
  {
    id: "floki-shiba",
    symbol: "fshib",
    name: "Floki Shiba",
  },
  {
    id: "flokishu",
    symbol: "flishu",
    name: "FloKishu",
  },
  {
    id: "flokiswap",
    symbol: "flokis",
    name: "FlokiSwap",
  },
  {
    id: "flokiverse",
    symbol: "flokiv",
    name: "Flokiverse",
  },
  {
    id: "flokizap",
    symbol: "flokiz",
    name: "FlokiZap",
  },
  {
    id: "floof",
    symbol: "floof",
    name: "FLOOF",
  },
  {
    id: "floordao",
    symbol: "floor",
    name: "FloorDAO",
  },
  {
    id: "florida-man",
    symbol: "fman",
    name: "Florida Man",
  },
  {
    id: "florin",
    symbol: "xfl",
    name: "Florin",
  },
  {
    id: "floshin",
    symbol: "floshin",
    name: "Floshin",
  },
  {
    id: "flourish-coin",
    symbol: "flrs",
    name: "Flourish Coin",
  },
  {
    id: "flourishing-ai-token",
    symbol: "ai",
    name: "Flourishing AI",
  },
  {
    id: "flow",
    symbol: "flow",
    name: "Flow",
  },
  {
    id: "flowchaincoin",
    symbol: "flc",
    name: "Flowchain",
  },
  {
    id: "flowcom",
    symbol: "fig",
    name: "FlowCom",
  },
  {
    id: "flower",
    symbol: "flow",
    name: "Flower",
  },
  {
    id: "flower-solana",
    symbol: "flow",
    name: "Flower Solana",
  },
  {
    id: "floyx",
    symbol: "floyx",
    name: "Floyx",
  },
  {
    id: "fluffy-coin",
    symbol: "fluf",
    name: "Fluffy Coin",
  },
  {
    id: "fluffy-inu",
    symbol: "fluffy",
    name: "Fluffy Inu",
  },
  {
    id: "fluid",
    symbol: "fld",
    name: "FLUID",
  },
  {
    id: "fluidfi",
    symbol: "fluid",
    name: "FluidFi",
  },
  {
    id: "flurry",
    symbol: "flurry",
    name: "Flurry Finance",
  },
  {
    id: "flux",
    symbol: "flux",
    name: "Datamine FLUX",
  },
  {
    id: "fluxchain",
    symbol: "flx",
    name: "FLUXchain",
  },
  {
    id: "flux-protocol",
    symbol: "flux",
    name: "Flux Protocol",
  },
  {
    id: "flux-token",
    symbol: "flx",
    name: "FluxProtocol",
  },
  {
    id: "flyapy",
    symbol: "fly",
    name: "FlyApy",
  },
  {
    id: "flying-colours",
    symbol: "ours",
    name: "Flying Colours",
  },
  {
    id: "flypaper",
    symbol: "sticky",
    name: "FlyPaper",
  },
  {
    id: "flypme",
    symbol: "fyp",
    name: "FlypMe",
  },
  {
    id: "fme",
    symbol: "fme",
    name: "FME",
  },
  {
    id: "fm-gallery",
    symbol: "fmg",
    name: "FM Gallery",
  },
  {
    id: "fnb-protocol",
    symbol: "fnb",
    name: "FNB Protocol",
  },
  {
    id: "fndz-token",
    symbol: "fndz",
    name: "FNDZ",
  },
  {
    id: "fnkcom",
    symbol: "fnk",
    name: "Fnk.com",
  },
  {
    id: "foam-protocol",
    symbol: "foam",
    name: "FOAM",
  },
  {
    id: "fodl-finance",
    symbol: "fodl",
    name: "Fodl Finance",
  },
  {
    id: "foho-coin",
    symbol: "foho",
    name: "Foho Coin",
  },
  {
    id: "foincoin",
    symbol: "foin",
    name: "Foin",
  },
  {
    id: "folder-protocol",
    symbol: "fol",
    name: "Folder Protocol",
  },
  {
    id: "folk",
    symbol: "folk",
    name: "$FOLK",
  },
  {
    id: "follow-token",
    symbol: "folo",
    name: "Alpha Impact",
  },
  {
    id: "fomo-baby",
    symbol: "fomobaby",
    name: "FOMO BABY",
  },
  {
    id: "fomo-chronicles-manga",
    symbol: "otaku",
    name: "FOMO Chronicles Manga",
  },
  {
    id: "fomoeth",
    symbol: "fomoeth",
    name: "FomoETH",
  },
  {
    id: "fomo-pot",
    symbol: "fomo",
    name: "FOMO Pot",
  },
  {
    id: "fompound",
    symbol: "fomp",
    name: "Fompound",
  },
  {
    id: "fone",
    symbol: "fone",
    name: "Fone",
  },
  {
    id: "font",
    symbol: "font",
    name: "Font",
  },
  {
    id: "food-bank",
    symbol: "food",
    name: "Food Bank",
  },
  {
    id: "foodchain-global",
    symbol: "food",
    name: "FoodChain Global",
  },
  {
    id: "food-farmer-finance",
    symbol: "fff",
    name: "Food Farmer Finance",
  },
  {
    id: "football-coin",
    symbol: "xfc",
    name: "Football Coin",
  },
  {
    id: "football-fantasy-pro",
    symbol: "fanta",
    name: "Football Fantasy Pro",
  },
  {
    id: "footballgo",
    symbol: "fgsport",
    name: "FootBallGo",
  },
  {
    id: "footballstars",
    symbol: "fts",
    name: "FootballStars",
  },
  {
    id: "footie-plus",
    symbol: "footie",
    name: "Footie Plus",
  },
  {
    id: "forbitspace",
    symbol: "fbs",
    name: "Forbitspace",
  },
  {
    id: "forcecowboy",
    symbol: "fcb",
    name: "ForceCowBoy",
  },
  {
    id: "force-for-fast",
    symbol: "fff",
    name: "Force For Fast",
  },
  {
    id: "force-of-nature",
    symbol: "fon",
    name: "Force of Nature",
  },
  {
    id: "force-protocol",
    symbol: "for",
    name: "ForTube",
  },
  {
    id: "forefront",
    symbol: "ff",
    name: "Forefront",
  },
  {
    id: "foresight",
    symbol: "fors",
    name: "Foresight",
  },
  {
    id: "forest-knight",
    symbol: "knight",
    name: "Forest Knight",
  },
  {
    id: "foreverblast",
    symbol: "feb",
    name: "ForeverBlast",
  },
  {
    id: "foreverbnb",
    symbol: "fbnb",
    name: "ForeverBNB",
  },
  {
    id: "foreverfomo",
    symbol: "foreverfomo",
    name: "ForeverFOMO",
  },
  {
    id: "forever-pump",
    symbol: "foreverpump",
    name: "Forever Pump",
  },
  {
    id: "forexcoin",
    symbol: "forex",
    name: "FOREXCOIN",
  },
  {
    id: "forge-finance",
    symbol: "forge",
    name: "Forge Finance",
  },
  {
    id: "forint",
    symbol: "forint",
    name: "Forint",
  },
  {
    id: "for-loot-and-glory",
    symbol: "flag",
    name: "For Loot And Glory",
  },
  {
    id: "formation-fi",
    symbol: "form",
    name: "Formation FI",
  },
  {
    id: "formula",
    symbol: "fml",
    name: "FormulA",
  },
  {
    id: "forrest-pump",
    symbol: "fpump",
    name: "Forrest Pump",
  },
  {
    id: "forta",
    symbol: "fort",
    name: "Forta",
  },
  {
    id: "forthbox",
    symbol: "fbx",
    name: "ForthBox",
  },
  {
    id: "fortknox",
    symbol: "knox",
    name: "FortKnox",
  },
  {
    id: "fortknoxter",
    symbol: "fkx",
    name: "FortKnoxster",
  },
  {
    id: "fortress",
    symbol: "fts",
    name: "Fortress Loans",
  },
  {
    id: "fortressdao",
    symbol: "fort",
    name: "Fortress",
  },
  {
    id: "fortuna",
    symbol: "fota",
    name: "Fortuna",
  },
  {
    id: "fortuna-sittard-fan-token",
    symbol: "for",
    name: "Fortuna Sittard Fan Token",
  },
  {
    id: "fortune",
    symbol: "fortune",
    name: "Fortune",
  },
  {
    id: "fortune-finance",
    symbol: "frtn",
    name: "Fortune Finance",
  },
  {
    id: "forus",
    symbol: "fors",
    name: "Forus",
  },
  {
    id: "fossil",
    symbol: "fossil",
    name: "Fossil",
  },
  {
    id: "foundation-eth",
    symbol: "feth",
    name: "Foundation ETH",
  },
  {
    id: "foundrydao-logistics",
    symbol: "fry",
    name: "FoundryDAO Logistics",
  },
  {
    id: "fountain-protocol",
    symbol: "ftp",
    name: "Fountain Protocol",
  },
  {
    id: "fox",
    symbol: "fox",
    name: "Fox",
  },
  {
    id: "foxboy",
    symbol: "fbb",
    name: "Foxboy",
  },
  {
    id: "foxdcoin",
    symbol: "foxd",
    name: "Foxdcoin",
  },
  {
    id: "fox-finance",
    symbol: "fox",
    name: "Fox Finance",
  },
  {
    id: "fox-financev2",
    symbol: "fox",
    name: "Fox Finance V2",
  },
  {
    id: "foxgirl",
    symbol: "foxgirl",
    name: "FoxGirl",
  },
  {
    id: "fox-trading-token",
    symbol: "foxt",
    name: "Fox Trading",
  },
  {
    id: "foxy-equilibrium",
    symbol: "foxy",
    name: "Foxy Equilibrium",
  },
  {
    id: "fqswap",
    symbol: "fqs",
    name: "FqSwap",
  },
  {
    id: "fractal",
    symbol: "fcl",
    name: "Fractal",
  },
  {
    id: "fraction",
    symbol: "fraction",
    name: "Fraction",
  },
  {
    id: "fractionalized-smb-2367",
    symbol: "daojones",
    name: "Fractionalized SMB-2367",
  },
  {
    id: "fractionalized-wave-999",
    symbol: "wav",
    name: "Fractionalized WAVE-999",
  },
  {
    id: "fractionmeta",
    symbol: "ftm",
    name: "FractionMeta",
  },
  {
    id: "fragments-of-arker",
    symbol: "foa",
    name: "Fragments of Arker",
  },
  {
    id: "fraktal",
    symbol: "frak",
    name: "Fraktal",
  },
  {
    id: "fraktionalized-thug-2856",
    symbol: "thug",
    name: "Fraktionalized THUG 2856",
  },
  {
    id: "frakt-token",
    symbol: "frkt",
    name: "FRAKT",
  },
  {
    id: "france-rev-finance",
    symbol: "frf",
    name: "France REV Finance",
  },
  {
    id: "frankenstein-finance",
    symbol: "frank",
    name: "Frankenstein Finance",
  },
  {
    id: "frank-inu",
    symbol: "frank",
    name: "Frank Inu",
  },
  {
    id: "franklin",
    symbol: "fly",
    name: "Franklin",
  },
  {
    id: "frat",
    symbol: "frat",
    name: "Frat",
  },
  {
    id: "frax",
    symbol: "frax",
    name: "Frax",
  },
  {
    id: "frax-price-index",
    symbol: "fpi",
    name: "Frax Price Index",
  },
  {
    id: "frax-price-index-share",
    symbol: "fpis",
    name: "Frax Price Index Share",
  },
  {
    id: "frax-share",
    symbol: "fxs",
    name: "Frax Share",
  },
  {
    id: "frax-share-wormhole",
    symbol: "fxs",
    name: "Frax Share (Wormhole)",
  },
  {
    id: "frax-wormhole",
    symbol: "frax",
    name: "Frax (Wormhole)",
  },
  {
    id: "fredenergy",
    symbol: "fred",
    name: "FRED Energy",
  },
  {
    id: "freecash",
    symbol: "fch",
    name: "Freecash",
  },
  {
    id: "freedom",
    symbol: "fdm",
    name: "Freedom",
  },
  {
    id: "freedom-22-dao",
    symbol: "free",
    name: "Freedom 22 DAO",
  },
  {
    id: "freedomcoin",
    symbol: "freed",
    name: "Freedomcoin",
  },
  {
    id: "freedom-coin",
    symbol: "free",
    name: "FREEdom coin",
  },
  {
    id: "freedom-god-dao",
    symbol: "fgd",
    name: "Freedom God DAO",
  },
  {
    id: "freedom-jobs-business",
    symbol: "$fjb",
    name: "Freedom. Jobs. Business",
  },
  {
    id: "freedom-reserve",
    symbol: "fr",
    name: "Freedom Reserve",
  },
  {
    id: "freela",
    symbol: "frel",
    name: "Freela",
  },
  {
    id: "freeliquid",
    symbol: "fl",
    name: "Freeliquid",
  },
  {
    id: "freemoon",
    symbol: "freemoon",
    name: "Freemoon",
  },
  {
    id: "freemoon-token",
    symbol: "freemoon",
    name: "Freemoon Token",
  },
  {
    id: "free-novak",
    symbol: "freedom",
    name: "Free Novak",
  },
  {
    id: "freerossdao",
    symbol: "free",
    name: "FreeRossDAO",
  },
  {
    id: "freeway",
    symbol: "fwt",
    name: "Freeway",
  },
  {
    id: "freicoin",
    symbol: "frc",
    name: "Freicoin",
  },
  {
    id: "freight-trust-network",
    symbol: "edi",
    name: "Freight Trust Network",
  },
  {
    id: "fren",
    symbol: "fren",
    name: "FREN",
  },
  {
    id: "french-connection-finance",
    symbol: "fcf",
    name: "French Connection Finance",
  },
  {
    id: "french-digital-reserve",
    symbol: "fdr",
    name: "French Digital Reserve",
  },
  {
    id: "frenchie",
    symbol: "fren",
    name: "Frenchie",
  },
  {
    id: "frencoin",
    symbol: "fren",
    name: "FrenCoin",
  },
  {
    id: "frenzy",
    symbol: "fzy",
    name: "Frenzy",
  },
  {
    id: "freshcut-diamond",
    symbol: "fcd",
    name: "FreshCut Diamond",
  },
  {
    id: "frey",
    symbol: "frey",
    name: "Frey",
  },
  {
    id: "freyala",
    symbol: "xya",
    name: "GameFi Crossing",
  },
  {
    id: "friends-with-benefits-pro",
    symbol: "fwb",
    name: "Friends With Benefits Pro",
  },
  {
    id: "friendz",
    symbol: "fdz",
    name: "Friendz",
  },
  {
    id: "friesdao",
    symbol: "fries",
    name: "friesDAO",
  },
  {
    id: "fringe-finance",
    symbol: "frin",
    name: "Fringe Finance",
  },
  {
    id: "frmx-token",
    symbol: "frmx",
    name: "FRMx",
  },
  {
    id: "frog",
    symbol: "frog",
    name: "Frog",
  },
  {
    id: "froge-finance",
    symbol: "frogex",
    name: "FrogeX",
  },
  {
    id: "froggies-token",
    symbol: "froggies",
    name: "Froggies",
  },
  {
    id: "frog-nation-farm",
    symbol: "frog",
    name: "Frog Nation Farm",
  },
  {
    id: "frogswap",
    symbol: "frog",
    name: "FrogSwap",
  },
  {
    id: "frontier-token",
    symbol: "front",
    name: "Frontier",
  },
  {
    id: "frontier-token-wormhole",
    symbol: "front",
    name: "Frontier Token (Wormhole)",
  },
  {
    id: "front-row",
    symbol: "frr",
    name: "Frontrow",
  },
  {
    id: "frost",
    symbol: "frost",
    name: "Frost",
  },
  {
    id: "frosted-cake",
    symbol: "frostedcake",
    name: "Frosted Cake",
  },
  {
    id: "frosty-floki-v2",
    symbol: "frostyfloki",
    name: "Frosty Floki V2",
  },
  {
    id: "froyo-games",
    symbol: "froyo",
    name: "Froyo Games",
  },
  {
    id: "frozentomb",
    symbol: "ftomb",
    name: "Frozentomb",
  },
  {
    id: "frozentomb-lot",
    symbol: "flot",
    name: "Frozentomb LOT",
  },
  {
    id: "frozen-walrus-share",
    symbol: "wshare",
    name: "Frozen Walrus Share",
  },
  {
    id: "fruit",
    symbol: "fruit",
    name: "Fruit",
  },
  {
    id: "fruit-fighters",
    symbol: "foofight",
    name: "Fruit Fighters",
  },
  {
    id: "fruits",
    symbol: "frts",
    name: "Fruits",
  },
  {
    id: "frz-solar-system",
    symbol: "frzss",
    name: "Frz Solar System",
  },
  {
    id: "fsd-coin",
    symbol: "fsdcoin",
    name: "FSD Coin",
  },
  {
    id: "fsn",
    symbol: "fsn",
    name: "FUSION",
  },
  {
    id: "fsw-token",
    symbol: "fsw",
    name: "Falconswap",
  },
  {
    id: "ftm-guru",
    symbol: "elite",
    name: "ftm.guru",
  },
  {
    id: "ftmlaunch",
    symbol: "ftml",
    name: "FTMlaunch",
  },
  {
    id: "ftmpay",
    symbol: "ftmp",
    name: "FTMPay",
  },
  {
    id: "ftribe-fighters",
    symbol: "f2c",
    name: "Ftribe Fighters",
  },
  {
    id: "ftx-token",
    symbol: "ftt",
    name: "FTX",
  },
  {
    id: "ftx-wormhole",
    symbol: "ftt",
    name: "FTX (Wormhole)",
  },
  {
    id: "fubuki",
    symbol: "fubuki",
    name: "Fubuki",
  },
  {
    id: "fudcoin-official",
    symbol: "fud",
    name: "FUDcoin Official",
  },
  {
    id: "fuel-token",
    symbol: "fuel",
    name: "Jetfuel Finance",
  },
  {
    id: "fufu",
    symbol: "fufu",
    name: "Fufu",
  },
  {
    id: "fuji",
    symbol: "fuji",
    name: "Fuji",
  },
  {
    id: "fujidao",
    symbol: "fuji",
    name: "FujiDAO",
  },
  {
    id: "fujitoken",
    symbol: "fjt",
    name: "Fuji FJT",
  },
  {
    id: "fuma-finance",
    symbol: "fuma",
    name: "Fuma Finance",
  },
  {
    id: "fumoney",
    symbol: "fum",
    name: "FUMoney",
  },
  {
    id: "functionland",
    symbol: "fula",
    name: "Functionland",
  },
  {
    id: "fundamenta",
    symbol: "fmta",
    name: "Fundamenta",
  },
  {
    id: "funder-one",
    symbol: "fundx",
    name: "Funder One",
  },
  {
    id: "fund-of-yours",
    symbol: "foy",
    name: "Fund Of Yours",
  },
  {
    id: "fundum",
    symbol: "fnd",
    name: "Fundum",
  },
  {
    id: "funfair",
    symbol: "fun",
    name: "FUN",
  },
  {
    id: "funfi",
    symbol: "fnf",
    name: "FunFi",
  },
  {
    id: "fungie-dao",
    symbol: "fng",
    name: "Fungie DAO",
  },
  {
    id: "furucombo",
    symbol: "combo",
    name: "Furucombo",
  },
  {
    id: "furukuru",
    symbol: "fuku",
    name: "Furukuru",
  },
  {
    id: "fuse-doge",
    symbol: "fdoge",
    name: "Fuse Doge",
  },
  {
    id: "fuse-dollar",
    symbol: "fusd",
    name: "Fuse Dollar",
  },
  {
    id: "fusefi",
    symbol: "volt",
    name: "Voltage Finance",
  },
  {
    id: "fuse-network-token",
    symbol: "fuse",
    name: "Fuse",
  },
  {
    id: "fusible",
    symbol: "fusii",
    name: "Fusible",
  },
  {
    id: "futurax",
    symbol: "ftxt",
    name: "FUTURAX",
  },
  {
    id: "future",
    symbol: "ftr",
    name: "Future",
  },
  {
    id: "future1coin",
    symbol: "f1c",
    name: "Future1Coin",
  },
  {
    id: "futurecoin",
    symbol: "future",
    name: "FutureCoin",
  },
  {
    id: "futurefi",
    symbol: "fufi",
    name: "FutureFi",
  },
  {
    id: "future-real-estate-token",
    symbol: "fret",
    name: "Future Real Estate",
  },
  {
    id: "futurescash",
    symbol: "fct",
    name: "FuturesCash",
  },
  {
    id: "futurescoin",
    symbol: "fc",
    name: "FuturesCoin",
  },
  {
    id: "future-star",
    symbol: "fstar",
    name: "Future Star",
  },
  {
    id: "futureswap",
    symbol: "fst",
    name: "Futureswap",
  },
  {
    id: "futurocoin",
    symbol: "fto",
    name: "FuturoCoin",
  },
  {
    id: "fuze-token",
    symbol: "fuze",
    name: "FUZE",
  },
  {
    id: "fuzex",
    symbol: "fxt",
    name: "FuzeX",
  },
  {
    id: "fuzzballs",
    symbol: "fuzz",
    name: "FuzzBalls",
  },
  {
    id: "fuzz-finance",
    symbol: "fuzz",
    name: "Fuzz Finance",
  },
  {
    id: "fwar-finance",
    symbol: "fwt",
    name: "Fwar Finance",
  },
  {
    id: "fx-coin",
    symbol: "fx",
    name: "Function X",
  },
  {
    id: "fxpay",
    symbol: "fxp",
    name: "FXPay",
  },
  {
    id: "fxt-token",
    symbol: "fxt",
    name: "FXT",
  },
  {
    id: "fxwallet",
    symbol: "fxl",
    name: "FXWallet",
  },
  {
    id: "fydcoin",
    symbol: "fyd",
    name: "FYDcoin",
  },
  {
    id: "fyooz",
    symbol: "fyz",
    name: "Fyooz",
  },
  {
    id: "g999",
    symbol: "g999",
    name: "G999",
  },
  {
    id: "gabecoin",
    symbol: "gabecoin",
    name: "Gabecoin",
  },
  {
    id: "gacube",
    symbol: "gac",
    name: "GACUBE",
  },
  {
    id: "gadget-war",
    symbol: "gwar",
    name: "Gadget War",
  },
  {
    id: "gafa",
    symbol: "gafa",
    name: "Gafa",
  },
  {
    id: "gaia-dao",
    symbol: "gaia",
    name: "Gaia DAO",
  },
  {
    id: "gaia-everworld",
    symbol: "gaia",
    name: "Gaia Everworld",
  },
  {
    id: "gain",
    symbol: "gain",
    name: "GainPool",
  },
  {
    id: "gain-protocol",
    symbol: "gain",
    name: "Gain Protocol",
  },
  {
    id: "gains",
    symbol: "gains",
    name: "Gains",
  },
  {
    id: "gains-farm",
    symbol: "gfarm2",
    name: "Gains Farm",
  },
  {
    id: "gains-network",
    symbol: "gns",
    name: "Gains Network",
  },
  {
    id: "gaj",
    symbol: "gaj",
    name: "Gaj Finance",
  },
  {
    id: "gala",
    symbol: "gala",
    name: "Gala",
  },
  {
    id: "galactic-arena-the-nftverse",
    symbol: "gan",
    name: "Galactic Arena: The NFTverse",
  },
  {
    id: "galactrum",
    symbol: "ore",
    name: "Galactrum",
  },
  {
    id: "galatasaray-fan-token",
    symbol: "gal",
    name: "Galatasaray Fan Token",
  },
  {
    id: "galatic-kitty-fighters",
    symbol: "gkf",
    name: "Galatic Kitty Fighters",
  },
  {
    id: "gala-wormhole",
    symbol: "gala",
    name: "Gala (Wormhole)",
  },
  {
    id: "galaxium",
    symbol: "glxm",
    name: "Galaxium",
  },
  {
    id: "galaxy-adventure",
    symbol: "gla",
    name: "Galaxy Adventure",
  },
  {
    id: "galaxy-blitz",
    symbol: "mit",
    name: "Galaxy Blitz",
  },
  {
    id: "galaxybusd",
    symbol: "galaxy",
    name: "GalaxyBUSD",
  },
  {
    id: "galaxycoin",
    symbol: "galaxy",
    name: "GalaxyCoin",
  },
  {
    id: "galaxy-coin",
    symbol: "glxc",
    name: "Galaxy Coin",
  },
  {
    id: "galaxy-doge",
    symbol: "galaxydoge",
    name: "Galaxy Doge",
  },
  {
    id: "galaxy-essential",
    symbol: "gxe",
    name: "Galaxy Essential",
  },
  {
    id: "galaxy-fight-club",
    symbol: "gcoin",
    name: "Galaxy Fight Club",
  },
  {
    id: "galaxy-finance",
    symbol: "gft",
    name: "Galaxy Finance",
  },
  {
    id: "galaxy-force-x",
    symbol: "gfx",
    name: "Galaxy Force X",
  },
  {
    id: "galaxygoggle",
    symbol: "gg",
    name: "GalaxyGoggle",
  },
  {
    id: "galaxy-heroes-coin",
    symbol: "ghc",
    name: "Galaxy Heroes Coin [OLD]",
  },
  {
    id: "galaxy-heroes-coin-2",
    symbol: "ghc",
    name: "Galaxy Heroes Coin",
  },
  {
    id: "galaxy-network",
    symbol: "gnc",
    name: "Galaxy Network",
  },
  {
    id: "galaxy-surge",
    symbol: "gals",
    name: "Galaxy Surge",
  },
  {
    id: "galaxy-war",
    symbol: "gwt",
    name: "Galaxy War",
  },
  {
    id: "gale-network",
    symbol: "gale",
    name: "Gale Network",
  },
  {
    id: "galeon",
    symbol: "galeon",
    name: "Galeon",
  },
  {
    id: "gallant",
    symbol: "gal",
    name: "Gallant",
  },
  {
    id: "gamb",
    symbol: "gmb",
    name: "GAMB",
  },
  {
    id: "gambit",
    symbol: "gmt",
    name: "Gambit",
  },
  {
    id: "gambler-shiba",
    symbol: "gshiba",
    name: "Gambler Shiba",
  },
  {
    id: "game",
    symbol: "gtc",
    name: "Game",
  },
  {
    id: "game-ace-token",
    symbol: "gat",
    name: "Game Ace",
  },
  {
    id: "gamebox",
    symbol: "gamebox",
    name: "Gamebox",
  },
  {
    id: "game-city",
    symbol: "gmci",
    name: "Game City",
  },
  {
    id: "game-coin",
    symbol: "gmex",
    name: "Game Coin",
  },
  {
    id: "gamecredits",
    symbol: "game",
    name: "GameCredits",
  },
  {
    id: "gamecrypt",
    symbol: "gamecrypt",
    name: "GameCrypt",
  },
  {
    id: "gamedao",
    symbol: "dao",
    name: "GameDAO",
  },
  {
    id: "gamee",
    symbol: "gmee",
    name: "GAMEE",
  },
  {
    id: "gamefantasystar",
    symbol: "gfs",
    name: "GameFantasyStar",
  },
  {
    id: "game-fantasy-token",
    symbol: "gft",
    name: "Game Fantasy",
  },
  {
    id: "gamefi",
    symbol: "gafi",
    name: "GameFi",
  },
  {
    id: "gamefi-collection",
    symbol: "gfc",
    name: "GameFi Collection",
  },
  {
    id: "gamefi-token",
    symbol: "gfi",
    name: "GameFi Protocol",
  },
  {
    id: "gameflip",
    symbol: "flp",
    name: "Gameflip",
  },
  {
    id: "game-frag",
    symbol: "frag",
    name: "Game-Frag",
  },
  {
    id: "gamenft",
    symbol: "gnft",
    name: "GameNFT",
  },
  {
    id: "gameology",
    symbol: "gmy",
    name: "Gameology",
  },
  {
    id: "game-on-players",
    symbol: "gopx",
    name: "Game On Players",
  },
  {
    id: "gamepad",
    symbol: "gpad",
    name: "Gamepad",
  },
  {
    id: "gamer",
    symbol: "gmr",
    name: "GAMER",
  },
  {
    id: "gamercoin",
    symbol: "ghx",
    name: "GamerCoin",
  },
  {
    id: "gamerse",
    symbol: "lfg",
    name: "Gamerse",
  },
  {
    id: "gamers-yield",
    symbol: "gy",
    name: "Gamers Yield",
  },
  {
    id: "gamesafe",
    symbol: "gamesafe",
    name: "Gamesafe",
  },
  {
    id: "gamespad",
    symbol: "gmpd",
    name: "GamesPad",
  },
  {
    id: "gamesta",
    symbol: "gsg",
    name: "Gamesta",
  },
  {
    id: "gamestar-exchange",
    symbol: "gms",
    name: "GameStar",
  },
  {
    id: "game-stars",
    symbol: "gst",
    name: "Game Stars",
  },
  {
    id: "gamestarter",
    symbol: "game",
    name: "Gamestarter",
  },
  {
    id: "gamestation",
    symbol: "gamer",
    name: "GameStation",
  },
  {
    id: "gamestop-finance",
    symbol: "gme",
    name: "GameStop Finance",
  },
  {
    id: "gamestop-tokenized-stock-defichain",
    symbol: "dgme",
    name: "GameStop Tokenized Stock Defichain",
  },
  {
    id: "gameswap-org",
    symbol: "gswap",
    name: "Gameswap",
  },
  {
    id: "game-tree",
    symbol: "gtcoin",
    name: "Game Tree",
  },
  {
    id: "gameverse",
    symbol: "gmv",
    name: "GameVerse",
  },
  {
    id: "gamex",
    symbol: "gmx",
    name: "GameX",
  },
  {
    id: "game-x-change-potion",
    symbol: "gxp",
    name: "Game X Change Potion",
  },
  {
    id: "gameyoo",
    symbol: "gyc",
    name: "GameYoo",
  },
  {
    id: "gamezone",
    symbol: "gzone",
    name: "GameZone",
  },
  {
    id: "gami",
    symbol: "gami",
    name: "Gami",
  },
  {
    id: "gamifi",
    symbol: "gmi",
    name: "GamiFi",
  },
  {
    id: "gaming-doge",
    symbol: "gamingdoge",
    name: "Gaming Doge",
  },
  {
    id: "gamingshiba",
    symbol: "gamingshiba",
    name: "GamingShiba",
  },
  {
    id: "gaming-stars",
    symbol: "games",
    name: "Gaming Stars",
  },
  {
    id: "gamium",
    symbol: "gmm",
    name: "Gamium",
  },
  {
    id: "gami-world",
    symbol: "gami",
    name: "GAMI World",
  },
  {
    id: "gamma",
    symbol: "gamma",
    name: "Gamma",
  },
  {
    id: "gamma-strategies",
    symbol: "gamma",
    name: "Gamma Strategies",
  },
  {
    id: "gamma-token",
    symbol: "gam",
    name: "Gamma GAM",
  },
  {
    id: "gamyfi-token",
    symbol: "gfx",
    name: "GamyFi",
  },
  {
    id: "gangstabet",
    symbol: "gbet",
    name: "GangstaBet",
  },
  {
    id: "gan-punks",
    symbol: "gpunks20",
    name: "Gan Punks",
  },
  {
    id: "gapcoin",
    symbol: "gap",
    name: "Gapcoin",
  },
  {
    id: "gard-governance-token",
    symbol: "ggt",
    name: "GARD Governance",
  },
  {
    id: "gari-network",
    symbol: "gari",
    name: "Gari Network",
  },
  {
    id: "garlic",
    symbol: "grlc",
    name: "Garlic",
  },
  {
    id: "garlicoin",
    symbol: "grlc",
    name: "Garlicoin",
  },
  {
    id: "gas",
    symbol: "gas",
    name: "Gas",
  },
  {
    id: "gas-dao",
    symbol: "gas",
    name: "Gas DAO",
  },
  {
    id: "gasp",
    symbol: "gasp",
    name: "gAsp",
  },
  {
    id: "gastoken",
    symbol: "gst2",
    name: "GasToken",
  },
  {
    id: "gastream",
    symbol: "gstrm",
    name: "GaStream",
  },
  {
    id: "gastrocoin",
    symbol: "gtc",
    name: "GastroCoin",
  },
  {
    id: "gatechain-token",
    symbol: "gt",
    name: "Gate",
  },
  {
    id: "gatechain-wormhole",
    symbol: "gt",
    name: "GateChain (Wormhole)",
  },
  {
    id: "gatenet",
    symbol: "gate",
    name: "GATENet",
  },
  {
    id: "gates-of-ethernity",
    symbol: "goe",
    name: "Gates of Ethernity",
  },
  {
    id: "gateway-protocol",
    symbol: "gwp",
    name: "Gateway Protocol",
  },
  {
    id: "gather",
    symbol: "gth",
    name: "Gather",
  },
  {
    id: "gatorswap",
    symbol: "gator",
    name: "GatorSwap",
  },
  {
    id: "gaur-money",
    symbol: "gaur",
    name: "Gaur Money",
  },
  {
    id: "gaur-shares",
    symbol: "gshare",
    name: "Gaur Shares",
  },
  {
    id: "gax-liquidity-token-reward",
    symbol: "gltr",
    name: "GAX Liquidity Token Reward",
  },
  {
    id: "gazetv",
    symbol: "gaze",
    name: "GazeTV",
  },
  {
    id: "gbox",
    symbol: "gbox",
    name: "GBOX",
  },
  {
    id: "gbrick",
    symbol: "gbx",
    name: "Gbrick",
  },
  {
    id: "gcn-coin",
    symbol: "gcn",
    name: "GCN Coin",
  },
  {
    id: "gdao-governance-vault",
    symbol: "xgdao",
    name: "GDAO Governance Vault",
  },
  {
    id: "gdoge-finance",
    symbol: "gdoge",
    name: "GDOGE Finance",
  },
  {
    id: "gear",
    symbol: "gear",
    name: "Gear",
  },
  {
    id: "gearbox",
    symbol: "gear",
    name: "Gearbox",
  },
  {
    id: "gecoin",
    symbol: "gec",
    name: "Gecoin",
  },
  {
    id: "geeq",
    symbol: "geeq",
    name: "GEEQ",
  },
  {
    id: "gegem",
    symbol: "geg",
    name: "GeGem",
  },
  {
    id: "geist-dai",
    symbol: "gdai",
    name: "Geist Dai",
  },
  {
    id: "geist-eth",
    symbol: "geth",
    name: "Geist ETH",
  },
  {
    id: "geist-finance",
    symbol: "geist",
    name: "Geist Finance",
  },
  {
    id: "geist-ftm",
    symbol: "gftm",
    name: "Geist FTM",
  },
  {
    id: "geist-fusdt",
    symbol: "gfusdt",
    name: "Geist fUSDT",
  },
  {
    id: "geist-usdc",
    symbol: "gusdc",
    name: "Geist USDC",
  },
  {
    id: "geist-wbtc",
    symbol: "gwbtc",
    name: "Geist WBTC",
  },
  {
    id: "gelato",
    symbol: "gel",
    name: "Gelato",
  },
  {
    id: "geld-finance",
    symbol: "geldf",
    name: "GELD Finance",
  },
  {
    id: "gembites",
    symbol: "gbts",
    name: "GemBites",
  },
  {
    id: "gemguardian",
    symbol: "gemg",
    name: "GemGuardian",
  },
  {
    id: "gemhub",
    symbol: "ghub",
    name: "GemHUB",
  },
  {
    id: "gemini-dollar",
    symbol: "gusd",
    name: "Gemini Dollar",
  },
  {
    id: "gemit-app",
    symbol: "gemit",
    name: "GEMIT.app",
  },
  {
    id: "gemlink",
    symbol: "glink",
    name: "GemLink",
  },
  {
    id: "gemma-extending-tech",
    symbol: "gxt",
    name: "Gem Exchange and Trading",
  },
  {
    id: "gemmine",
    symbol: "gemmine",
    name: "GemMine",
  },
  {
    id: "gempad",
    symbol: "gems",
    name: "GemPad",
  },
  {
    id: "gempay",
    symbol: "gpay",
    name: "GemPay",
  },
  {
    id: "gems-2",
    symbol: "gem",
    name: "Gems",
  },
  {
    id: "gem-token",
    symbol: "gem",
    name: "Gem",
  },
  {
    id: "gemuni",
    symbol: "geni",
    name: "GemUni",
  },
  {
    id: "genaro-network",
    symbol: "gnx",
    name: "Genaro Network",
  },
  {
    id: "genart",
    symbol: "genart",
    name: "GENART",
  },
  {
    id: "gencoin-capital",
    symbol: "gencap",
    name: "GenCoin Capital",
  },
  {
    id: "gene",
    symbol: "gene",
    name: "Gene",
  },
  {
    id: "genebank-token",
    symbol: "gnbt",
    name: "Genebank",
  },
  {
    id: "general-attention-currency",
    symbol: "xac",
    name: "General Attention Currency",
  },
  {
    id: "generational-wealth-society",
    symbol: "gws",
    name: "Generational Wealth Society",
  },
  {
    id: "genes-chain",
    symbol: "genes",
    name: "GENES Chain",
  },
  {
    id: "genesis-mana",
    symbol: "mana",
    name: "Genesis Mana",
  },
  {
    id: "genesis-nft",
    symbol: "gnss",
    name: "Genesis NFT",
  },
  {
    id: "genesis-particle",
    symbol: "gp",
    name: "Genesis Particle",
  },
  {
    id: "genesis-pool",
    symbol: "gpool",
    name: "Genesis Pool",
  },
  {
    id: "genesis-shards",
    symbol: "gs",
    name: "Genesis Shards",
  },
  {
    id: "genesis-token",
    symbol: "gent",
    name: "Genesis GENT",
  },
  {
    id: "genesis-vision",
    symbol: "gvt",
    name: "Genesis Vision",
  },
  {
    id: "genesis-worlds",
    symbol: "genesis",
    name: "Genesis Worlds",
  },
  {
    id: "genesisx",
    symbol: "xgs",
    name: "GenesisX",
  },
  {
    id: "genesysgo-shadow",
    symbol: "shdw",
    name: "GenesysGo Shadow",
  },
  {
    id: "genexi",
    symbol: "gxi",
    name: "Genexi",
  },
  {
    id: "genie-protocol",
    symbol: "gnp",
    name: "Genie Protocol",
  },
  {
    id: "genius-coin",
    symbol: "genius",
    name: "Genius Coin",
  },
  {
    id: "genix",
    symbol: "genix",
    name: "Genix",
  },
  {
    id: "gennix",
    symbol: "gnnx",
    name: "Gennix",
  },
  {
    id: "genomesdao",
    symbol: "$gene",
    name: "GenomesDAO",
  },
  {
    id: "genopets",
    symbol: "gene",
    name: "Genopets",
  },
  {
    id: "genre",
    symbol: "genre",
    name: "GENRE",
  },
  {
    id: "genshinflokiinu",
    symbol: "gfloki",
    name: "GenshinFlokiInu",
  },
  {
    id: "genshin-nft",
    symbol: "genshin",
    name: "Genshin NFT",
  },
  {
    id: "genshiro",
    symbol: "gens",
    name: "Genshiro",
  },
  {
    id: "gensokishis-metaverse",
    symbol: "mv",
    name: "GensoKishi Metaverse",
  },
  {
    id: "gentarium",
    symbol: "gtm",
    name: "Gentarium",
  },
  {
    id: "genx",
    symbol: "genx",
    name: "GENX",
  },
  {
    id: "geocoin",
    symbol: "geo",
    name: "Geocoin",
  },
  {
    id: "geodb",
    symbol: "geo",
    name: "GeoDB",
  },
  {
    id: "geojam",
    symbol: "jam",
    name: "Geojam",
  },
  {
    id: "geopoly",
    symbol: "geo$",
    name: "Geopoly",
  },
  {
    id: "gera-coin",
    symbol: "gera",
    name: "Gera Coin",
  },
  {
    id: "gerowallet",
    symbol: "gero",
    name: "GeroWallet",
  },
  {
    id: "get-token",
    symbol: "get",
    name: "GET Protocol",
  },
  {
    id: "geyser",
    symbol: "gysr",
    name: "Geyser",
  },
  {
    id: "geysercoin",
    symbol: "gsr",
    name: "GeyserCoin",
  },
  {
    id: "gforce",
    symbol: "gfce",
    name: "GFORCE",
  },
  {
    id: "gg-coin",
    symbol: "ggc",
    name: "Global Game Coin",
  },
  {
    id: "gg-token",
    symbol: "ggtk",
    name: "GG",
  },
  {
    id: "ghospers-game",
    symbol: "ghsp",
    name: "Ghospers Game",
  },
  {
    id: "ghostblade-inu",
    symbol: "ghostblade",
    name: "GhostBlade Inu",
  },
  {
    id: "ghost-block",
    symbol: "ecto",
    name: "Ghost Block",
  },
  {
    id: "ghost-by-mcafee",
    symbol: "ghost",
    name: "Ghost",
  },
  {
    id: "ghostface",
    symbol: "ghostface",
    name: "Ghostface",
  },
  {
    id: "ghost-farmer-capital",
    symbol: "gfc",
    name: "Ghost Farmer Capital",
  },
  {
    id: "ghost-inu",
    symbol: "ghost",
    name: "Ghost Inu",
  },
  {
    id: "ghostmarket",
    symbol: "gm",
    name: "GhostMarket",
  },
  {
    id: "ghost-trader",
    symbol: "gtr",
    name: "Ghost Trader",
  },
  {
    id: "ghoul-token",
    symbol: "ghoul",
    name: "Ghoul",
  },
  {
    id: "gibx-swap",
    symbol: "x",
    name: "GIBX Swap",
  },
  {
    id: "gictrade",
    symbol: "gict",
    name: "GICTrade",
  },
  {
    id: "giddy",
    symbol: "gddy",
    name: "Giddy",
  },
  {
    id: "giftbag",
    symbol: "gbag",
    name: "Giftbag",
  },
  {
    id: "gift-coin",
    symbol: "gift",
    name: "Gift Coin",
  },
  {
    id: "giftedhands",
    symbol: "ghd",
    name: "Giftedhands",
  },
  {
    id: "gifto",
    symbol: "gto",
    name: "Gifto",
  },
  {
    id: "gigachad",
    symbol: "chad",
    name: "GigaChad",
  },
  {
    id: "giga-watt-token",
    symbol: "wtt",
    name: "Giga Watt",
  },
  {
    id: "gigco",
    symbol: "gig",
    name: "GIGCO",
  },
  {
    id: "gigecoin",
    symbol: "gig",
    name: "GigEcoin",
  },
  {
    id: "giletjaunecoin",
    symbol: "gjco",
    name: "GiletJauneCoin",
  },
  {
    id: "gilgamesh-eth",
    symbol: "gil",
    name: "Gilgamesh ETH",
  },
  {
    id: "gimmer",
    symbol: "gmr",
    name: "Gimmer",
  },
  {
    id: "gin-finance",
    symbol: "gin",
    name: "Gin Finance",
  },
  {
    id: "ginga-finance",
    symbol: "gin",
    name: "Ginga Finance",
  },
  {
    id: "ginoa",
    symbol: "ginoa",
    name: "Ginoa",
  },
  {
    id: "ginspirit",
    symbol: "ginspirit",
    name: "GinSpirit",
  },
  {
    id: "gin-token",
    symbol: "gin",
    name: "Gin",
  },
  {
    id: "ginza-eternity-reward",
    symbol: "ger",
    name: "Ginza Eternity Reward",
  },
  {
    id: "ginza-network",
    symbol: "ginza",
    name: "Ginza Network",
  },
  {
    id: "giresunspor-token",
    symbol: "grs",
    name: "Giresunspor Token",
  },
  {
    id: "girl-story",
    symbol: "metagirl",
    name: "Girl Story",
  },
  {
    id: "gitcoin",
    symbol: "gtc",
    name: "Gitcoin",
  },
  {
    id: "giveth",
    symbol: "giv",
    name: "Giveth",
  },
  {
    id: "givetime-io",
    symbol: "gtm",
    name: "Givetime.io",
  },
  {
    id: "givingtoservices-svs",
    symbol: "svs",
    name: "GivingToServices SVS",
  },
  {
    id: "givly-coin",
    symbol: "giv",
    name: "GIV",
  },
  {
    id: "gizadao",
    symbol: "giza",
    name: "GizaDao",
  },
  {
    id: "glacierlaunch",
    symbol: "glac",
    name: "GlacierLaunch",
  },
  {
    id: "glass-chain",
    symbol: "gls",
    name: "Glass Chain",
  },
  {
    id: "gld-tokenized-stock-defichain",
    symbol: "dgld",
    name: "SPDR Gold Shares Defichain",
  },
  {
    id: "gleec-coin",
    symbol: "gleec",
    name: "Gleec Coin",
  },
  {
    id: "glex",
    symbol: "glex",
    name: "GLEX",
  },
  {
    id: "glide-finance",
    symbol: "glide",
    name: "Glide Finance",
  },
  {
    id: "glimpse",
    symbol: "glms",
    name: "Glimpse",
  },
  {
    id: "glink-arts-shares",
    symbol: "garts",
    name: "Glink Arts Share",
  },
  {
    id: "glitch-protocol",
    symbol: "glch",
    name: "Glitch Protocol",
  },
  {
    id: "glitchy",
    symbol: "gly",
    name: "Glitchy",
  },
  {
    id: "glitter-finance",
    symbol: "xgli",
    name: "Glitter Finance",
  },
  {
    id: "glitzkoin",
    symbol: "gtn",
    name: "GlitzKoin",
  },
  {
    id: "global-aex-token",
    symbol: "gat",
    name: "Global AEX",
  },
  {
    id: "globalboost",
    symbol: "bsty",
    name: "GlobalBoost-Y",
  },
  {
    id: "globalchainz",
    symbol: "gcz",
    name: "GlobalChainZ",
  },
  {
    id: "global-china-cash",
    symbol: "cnc",
    name: "Global China Cash",
  },
  {
    id: "globalcoin",
    symbol: "glc",
    name: "GlobalCoin",
  },
  {
    id: "global-coin-research",
    symbol: "gcr",
    name: "Global Coin Research",
  },
  {
    id: "global-crypto-alliance",
    symbol: "call",
    name: "Global Crypto Alliance",
  },
  {
    id: "global-digital-content",
    symbol: "gdc",
    name: "Global Digital Content",
  },
  {
    id: "global-gaming",
    symbol: "gmng",
    name: "Global Gaming",
  },
  {
    id: "globalgive",
    symbol: "ggive",
    name: "GlobalGive",
  },
  {
    id: "global-gold-token",
    symbol: "ggt",
    name: "Global Gold",
  },
  {
    id: "global-human-trust",
    symbol: "ght",
    name: "Global Human Trust",
  },
  {
    id: "global-reserve-system",
    symbol: "glob",
    name: "Global Reserve System",
  },
  {
    id: "global-smart-asset",
    symbol: "gsa",
    name: "Global Smart Asset",
  },
  {
    id: "global-social-chain",
    symbol: "gsc",
    name: "Global Social Chain",
  },
  {
    id: "global-trust-coin",
    symbol: "gtc",
    name: "Global Trust Coin",
  },
  {
    id: "globaltrustfund",
    symbol: "gtf",
    name: "GLOBALTRUSTFUND",
  },
  {
    id: "globalvillage-ecosystem",
    symbol: "gve",
    name: "Globalvillage Ecosystem",
  },
  {
    id: "globe-derivative-exchange",
    symbol: "gdt",
    name: "Globe Derivative Exchange",
  },
  {
    id: "globiance-exchange",
    symbol: "gbex",
    name: "Globiance Exchange",
  },
  {
    id: "glorydoge",
    symbol: "gloryd",
    name: "GloryDoge",
  },
  {
    id: "glosfer-token",
    symbol: "glo",
    name: "Glosfer",
  },
  {
    id: "glouki",
    symbol: "glk",
    name: "Glouki",
  },
  {
    id: "glow",
    symbol: "glow",
    name: "Glow",
  },
  {
    id: "glow-token",
    symbol: "glow",
    name: "Glow Yield",
  },
  {
    id: "glowv2",
    symbol: "glowv2",
    name: "GlowV2",
  },
  {
    id: "glox-finance",
    symbol: "glox",
    name: "Glox Finance",
  },
  {
    id: "glyph-vault-nftx",
    symbol: "glyph",
    name: "GLYPH Vault (NFTX)",
  },
  {
    id: "gm",
    symbol: "gm",
    name: "GM",
  },
  {
    id: "gma",
    symbol: "gma",
    name: "GMA",
  },
  {
    id: "gmcoin",
    symbol: "gm",
    name: "GM Holding",
  },
  {
    id: "gm-coin",
    symbol: "gm",
    name: "Gm Coin",
  },
  {
    id: "gmcoin-2",
    symbol: "gmcoin",
    name: "GMCoin",
  },
  {
    id: "gm-floki",
    symbol: "gmfloki",
    name: "GM Floki",
  },
  {
    id: "gmsol",
    symbol: "gmsol",
    name: "GMSOL",
  },
  {
    id: "gmt-token",
    symbol: "gmt",
    name: "GMT",
  },
  {
    id: "gmx",
    symbol: "gmx",
    name: "GMX",
  },
  {
    id: "gn",
    symbol: "gn",
    name: "GN",
  },
  {
    id: "gnar-token",
    symbol: "gnar",
    name: "GNAR",
  },
  {
    id: "gnft",
    symbol: "gnft",
    name: "GNFT",
  },
  {
    id: "gnome",
    symbol: "$gnome",
    name: "GNOME",
  },
  {
    id: "gnome-mines",
    symbol: "gmines",
    name: "Gnome Mines",
  },
  {
    id: "gnometoken",
    symbol: "gnome",
    name: "GnomeArmy",
  },
  {
    id: "gnosis",
    symbol: "gno",
    name: "Gnosis",
  },
  {
    id: "gny",
    symbol: "gny",
    name: "GNY",
  },
  {
    id: "goal",
    symbol: "goal",
    name: "CronosFC",
  },
  {
    id: "goaltime-n",
    symbol: "gtx",
    name: "GoalTime N",
  },
  {
    id: "goal-token",
    symbol: "goal",
    name: "Goal",
  },
  {
    id: "goatcoin",
    symbol: "goat",
    name: "Goatcoin",
  },
  {
    id: "goat-coin",
    symbol: "goat",
    name: "Goat Coin",
  },
  {
    id: "goat-gang",
    symbol: "ggt",
    name: "Goat Gang",
  },
  {
    id: "goats",
    symbol: "goats",
    name: "GOATS",
  },
  {
    id: "g-o-a-t-token",
    symbol: "g.o.a.t",
    name: "G.O.A.T",
  },
  {
    id: "goblin",
    symbol: "goblin",
    name: "Goblin",
  },
  {
    id: "gobyte",
    symbol: "gbx",
    name: "GoByte",
  },
  {
    id: "gochain",
    symbol: "go",
    name: "GoChain",
  },
  {
    id: "gocryptome",
    symbol: "gcme",
    name: "GoCryptoMe",
  },
  {
    id: "god-candle",
    symbol: "god",
    name: "God Candle",
  },
  {
    id: "god-dao",
    symbol: "god",
    name: "God DAO",
  },
  {
    id: "gode-chain",
    symbol: "gode",
    name: "Gode Chain",
  },
  {
    id: "gods-and-legends",
    symbol: "gnlr",
    name: "Gods and Legends",
  },
  {
    id: "god-shiba-token",
    symbol: "gshib",
    name: "God Shiba",
  },
  {
    id: "gods-unchained",
    symbol: "gods",
    name: "Gods Unchained",
  },
  {
    id: "godzilla",
    symbol: "godz",
    name: "Godzilla",
  },
  {
    id: "goforit",
    symbol: "goi",
    name: "GoForIt Walk&Win",
  },
  {
    id: "gogocoin",
    symbol: "gogo",
    name: "GOGOcoin",
  },
  {
    id: "gogo-finance",
    symbol: "gogo",
    name: "GOGO Finance",
  },
  {
    id: "gogolcoin",
    symbol: "gol",
    name: "GogolCoin",
  },
  {
    id: "goin",
    symbol: "goin",
    name: "GOIN",
  },
  {
    id: "goku",
    symbol: "goku",
    name: "Goku",
  },
  {
    id: "gokumarket-credit",
    symbol: "gmc",
    name: "GokuMarket Credit",
  },
  {
    id: "gold",
    symbol: "gold",
    name: "GOLD",
  },
  {
    id: "goldario",
    symbol: "gld",
    name: "Goldario",
  },
  {
    id: "goldblocks",
    symbol: "gb",
    name: "GoldBlocks",
  },
  {
    id: "gold-cash",
    symbol: "gold",
    name: "Gold Cash",
  },
  {
    id: "goldcoin",
    symbol: "glc",
    name: "Goldcoin",
  },
  {
    id: "gold-coin-reserve",
    symbol: "gcr",
    name: "Gold Coin Reserve",
  },
  {
    id: "goldefy",
    symbol: "god",
    name: "GoldeFy",
  },
  {
    id: "golden-age",
    symbol: "ga",
    name: "Golden Age",
  },
  {
    id: "golden-ball",
    symbol: "glb",
    name: "Golden Ball",
  },
  {
    id: "golden-banana",
    symbol: "gba",
    name: "Golden Banana",
  },
  {
    id: "goldendiamond9",
    symbol: "g9",
    name: "GoldenDiamond9",
  },
  {
    id: "golden-doge",
    symbol: "gdoge",
    name: "Golden Doge",
  },
  {
    id: "golden-goose",
    symbol: "gold",
    name: "Golden Goose",
  },
  {
    id: "golden-kitty-cake",
    symbol: "gkcake",
    name: "Golden Kitty Cake",
  },
  {
    id: "golden-ratio-coin",
    symbol: "goldr",
    name: "Golden Ratio Coin",
  },
  {
    id: "golden-ratio-token",
    symbol: "grt",
    name: "Golden Ratio Token",
  },
  {
    id: "golden-roots",
    symbol: "gdr",
    name: "Golden Roots",
  },
  {
    id: "golden-token",
    symbol: "gold",
    name: "Golden",
  },
  {
    id: "goldenugget",
    symbol: "gnto",
    name: "GoldeNugget",
  },
  {
    id: "goldex-token",
    symbol: "gldx",
    name: "Goldex",
  },
  {
    id: "goldfarm",
    symbol: "gold",
    name: "GoldFarm",
  },
  {
    id: "gold-fever-native-gold",
    symbol: "ngl",
    name: "Gold Fever Native Gold",
  },
  {
    id: "goldfinch",
    symbol: "gfi",
    name: "Goldfinch",
  },
  {
    id: "goldfinx",
    symbol: "gix",
    name: "GoldFinX",
  },
  {
    id: "goldfund-ico",
    symbol: "gfun",
    name: "GoldFund",
  },
  {
    id: "goldkash",
    symbol: "xgk",
    name: "GoldKash",
  },
  {
    id: "goldminer",
    symbol: "gm",
    name: "GoldMiner",
  },
  {
    id: "gold-mining-members",
    symbol: "gmm",
    name: "Gold Mining Members",
  },
  {
    id: "goldmint",
    symbol: "mntp",
    name: "Goldmint",
  },
  {
    id: "goldmoney",
    symbol: "gdm",
    name: "Goldmoney",
  },
  {
    id: "goldnugget",
    symbol: "ngt",
    name: "Gold Nugget",
  },
  {
    id: "goldpesa-option",
    symbol: "gpo",
    name: "GoldPesa Option",
  },
  {
    id: "gold-poker",
    symbol: "gpkr",
    name: "Gold Poker",
  },
  {
    id: "gold-rush",
    symbol: "grush",
    name: "Gold Rush",
  },
  {
    id: "gold-secured-currency",
    symbol: "gsx",
    name: "Gold Secured Currency",
  },
  {
    id: "golem",
    symbol: "glm",
    name: "Golem",
  },
  {
    id: "golff",
    symbol: "gof",
    name: "Golff",
  },
  {
    id: "golfinance",
    symbol: "gol",
    name: "GolFinance",
  },
  {
    id: "golfrochain",
    symbol: "golf",
    name: "Golfrochain",
  },
  {
    id: "goma-finance",
    symbol: "goma",
    name: "GOMA Finance [OLD]",
  },
  {
    id: "goma-finance-2",
    symbol: "goma",
    name: "Goma Finance",
  },
  {
    id: "gomax",
    symbol: "gomax",
    name: "GOMAx",
  },
  {
    id: "gomb",
    symbol: "gomb",
    name: "GOMB",
  },
  {
    id: "gombshare",
    symbol: "gshare",
    name: "GOMBSHARE",
  },
  {
    id: "gomeat",
    symbol: "gomt",
    name: "GoMeat",
  },
  {
    id: "gomics",
    symbol: "gom",
    name: "Gomics",
  },
  {
    id: "gomoney2",
    symbol: "gom2",
    name: "GoMoney2",
  },
  {
    id: "gondola-finance",
    symbol: "gdl",
    name: "Gondola Finance",
  },
  {
    id: "gonetwork",
    symbol: "got",
    name: "GoNetwork",
  },
  {
    id: "good-bridging",
    symbol: "gb",
    name: "Good Bridging",
  },
  {
    id: "good-fire",
    symbol: "gf",
    name: "Good Fire",
  },
  {
    id: "good-games-guild",
    symbol: "ggg",
    name: "Good Games Guild",
  },
  {
    id: "good-person-coin",
    symbol: "gpcx",
    name: "Good Person Coin",
  },
  {
    id: "gooeys",
    symbol: "goo",
    name: "Gooeys",
  },
  {
    id: "goofydoge",
    symbol: "goofydoge",
    name: "GoofyDoge",
  },
  {
    id: "google-tokenized-stock-defichain",
    symbol: "dgoogl",
    name: "Google Tokenized Stock Defichain",
  },
  {
    id: "google-tokenized-stock-zipmex",
    symbol: "googl",
    name: "Google Tokenized Stock Zipmex",
  },
  {
    id: "goose-finance",
    symbol: "egg",
    name: "Goose Finance",
  },
  {
    id: "goosefx",
    symbol: "gofx",
    name: "GooseFX",
  },
  {
    id: "gorgeous",
    symbol: "gorgeous",
    name: "Gorgeous",
  },
  {
    id: "gorilla-diamond",
    symbol: "gdt",
    name: "Gorilla Diamond",
  },
  {
    id: "gorilla-inu",
    symbol: "gorilla inu",
    name: "Gorilla Inu",
  },
  {
    id: "gorilla-nodes",
    symbol: "banana",
    name: "Gorilla Nodes",
  },
  {
    id: "gosh-realm",
    symbol: "gosh",
    name: "GOSH Realm",
  },
  {
    id: "gotem",
    symbol: "gotem",
    name: "gotEM",
  },
  {
    id: "gotham",
    symbol: "gotham",
    name: "Gotham",
  },
  {
    id: "gourmetgalaxy",
    symbol: "gum",
    name: "Gourmet Galaxy",
  },
  {
    id: "governance-ohm",
    symbol: "gohm",
    name: "Governance OHM",
  },
  {
    id: "governance-ohm-wormhole",
    symbol: "gohm",
    name: "Governance OHM (Wormhole)",
  },
  {
    id: "governance-zil",
    symbol: "gzil",
    name: "governance ZIL",
  },
  {
    id: "governor-dao",
    symbol: "gdao",
    name: "Governor DAO",
  },
  {
    id: "govi",
    symbol: "govi",
    name: "CVI",
  },
  {
    id: "govworld",
    symbol: "gov",
    name: "GovWorld",
  },
  {
    id: "gowithmi",
    symbol: "gmat",
    name: "GoWithMi",
  },
  {
    id: "goya-giant-token",
    symbol: "artg",
    name: "Goya Giant",
  },
  {
    id: "goztepe-s-k-fan-token",
    symbol: "goz",
    name: "Göztepe S.K. Fan Token",
  },
  {
    id: "gpex",
    symbol: "gpx",
    name: "GPEX",
  },
  {
    id: "gps-ecosystem",
    symbol: "gps",
    name: "GPS Ecosystem",
  },
  {
    id: "grafenocoin-2",
    symbol: "gfnc",
    name: "GrafenoCoin",
  },
  {
    id: "graft-blockchain",
    symbol: "grft",
    name: "Graft Blockchain",
  },
  {
    id: "grail",
    symbol: "grail",
    name: "Grail",
  },
  {
    id: "gram",
    symbol: "gram",
    name: "OpenGram",
  },
  {
    id: "grape-2",
    symbol: "grape",
    name: "Grape Protocol",
  },
  {
    id: "grape-finance",
    symbol: "grape",
    name: "Grape Finance",
  },
  {
    id: "grapefruit-coin",
    symbol: "grpft",
    name: "Grapefruit Coin",
  },
  {
    id: "grape-token",
    symbol: "grape",
    name: "Grape",
  },
  {
    id: "grap-finance",
    symbol: "grap",
    name: "Grap Finance",
  },
  {
    id: "graphen",
    symbol: "eltg",
    name: "Graphen",
  },
  {
    id: "graphene",
    symbol: "gfn",
    name: "Graphene",
  },
  {
    id: "graphlinq-protocol",
    symbol: "glq",
    name: "GraphLinq Protocol",
  },
  {
    id: "grave",
    symbol: "grve",
    name: "Grave",
  },
  {
    id: "graviocoin",
    symbol: "gio",
    name: "Graviocoin",
  },
  {
    id: "gravis-finance",
    symbol: "grvs",
    name: "Gravis Finance",
  },
  {
    id: "gravitoken",
    symbol: "grv",
    name: "Gravitoken",
  },
  {
    id: "graviton",
    symbol: "grav",
    name: "Graviton",
  },
  {
    id: "graviton-zero",
    symbol: "grav",
    name: "Graviton Zero",
  },
  {
    id: "gravitx",
    symbol: "grx",
    name: "GravitX",
  },
  {
    id: "grearn",
    symbol: "gst",
    name: "GrEarn",
  },
  {
    id: "great-ape",
    symbol: "greatape",
    name: "Great Ape",
  },
  {
    id: "great-bounty-dealer",
    symbol: "gbd",
    name: "Great Bounty Dealer",
  },
  {
    id: "greed",
    symbol: "$greed",
    name: "Greed",
  },
  {
    id: "greekmythology",
    symbol: "gmt",
    name: "GreekMythology",
  },
  {
    id: "greenair",
    symbol: "green",
    name: "GreenAir",
  },
  {
    id: "green-beli",
    symbol: "grbe",
    name: "Green Beli",
  },
  {
    id: "green-ben",
    symbol: "eben",
    name: "Green Ben",
  },
  {
    id: "green-chart",
    symbol: "green",
    name: "Green Chart",
  },
  {
    id: "green-climate-world",
    symbol: "wgc",
    name: "Green Climate World",
  },
  {
    id: "greencoin",
    symbol: "gre",
    name: "Greencoin",
  },
  {
    id: "green-dildo-finance",
    symbol: "gdildo",
    name: "Green Dildo Finance",
  },
  {
    id: "green-energy-coin",
    symbol: "gec",
    name: "Green Energy Coin",
  },
  {
    id: "greeneum-network",
    symbol: "green",
    name: "Greeneum Network",
  },
  {
    id: "green-eyed-monsters",
    symbol: "gem",
    name: "Green Eyed Monsters",
  },
  {
    id: "green-floki",
    symbol: "greenfloki",
    name: "Green Floki",
  },
  {
    id: "green-flow",
    symbol: "grc",
    name: "GreenCoin.AI",
  },
  {
    id: "greenfuel",
    symbol: "greenfuel",
    name: "Greenfuel",
  },
  {
    id: "greenheart-cbd",
    symbol: "cbd",
    name: "Greenheart CBD",
  },
  {
    id: "greenhouse",
    symbol: "green",
    name: "Greenhouse",
  },
  {
    id: "green-life-energy",
    symbol: "gnl",
    name: "Green Life Energy",
  },
  {
    id: "green-light",
    symbol: "gl",
    name: "Green Light",
  },
  {
    id: "green-meta",
    symbol: "gmeta",
    name: "Green Meta",
  },
  {
    id: "greenmoonzilla",
    symbol: "grmzilla",
    name: "GreenMoonZilla",
  },
  {
    id: "greenpay-coin",
    symbol: "gpc",
    name: "GreenPay Coin",
  },
  {
    id: "green-planet",
    symbol: "gamma",
    name: "Green Planet",
  },
  {
    id: "green-satoshi-token",
    symbol: "gst-sol",
    name: "STEPN Green Satoshi Token on Solana",
  },
  {
    id: "green-satoshi-token-bsc",
    symbol: "gst-bsc",
    name: "Green Satoshi Token on BSC",
  },
  {
    id: "green-shiba-inu",
    symbol: "ginux",
    name: "Green Shiba Inu",
  },
  {
    id: "green-star",
    symbol: "grcc",
    name: "Green Star",
  },
  {
    id: "greentek",
    symbol: "gte",
    name: "GreenTek",
  },
  {
    id: "greentrust",
    symbol: "gnt",
    name: "GreenTrust",
  },
  {
    id: "green-world",
    symbol: "grew",
    name: "Green World",
  },
  {
    id: "greenzonex",
    symbol: "gzx",
    name: "GreenZoneX",
  },
  {
    id: "greyhound",
    symbol: "greyhound",
    name: "Greyhound",
  },
  {
    id: "gric",
    symbol: "gc",
    name: "Gric Coin",
  },
  {
    id: "grid",
    symbol: "grid",
    name: "GridPlus [OLD]",
  },
  {
    id: "gridcoin-research",
    symbol: "grc",
    name: "Gridcoin",
  },
  {
    id: "gridzone",
    symbol: "zone",
    name: "GridZone.io",
  },
  {
    id: "griffin-art",
    symbol: "gart",
    name: "Griffin Art",
  },
  {
    id: "grimace-coin",
    symbol: "grimace",
    name: "Grimace Coin",
  },
  {
    id: "grim-evo",
    symbol: "grim evo",
    name: "Grim EVO",
  },
  {
    id: "grimm",
    symbol: "grimm",
    name: "Grimm",
  },
  {
    id: "grimtoken",
    symbol: "grim",
    name: "Grim",
  },
  {
    id: "grin",
    symbol: "grin",
    name: "Grin",
  },
  {
    id: "grinbit",
    symbol: "grbt",
    name: "Grinbit",
  },
  {
    id: "gro-dao-token",
    symbol: "gro",
    name: "Gro DAO",
  },
  {
    id: "groestlcoin",
    symbol: "grs",
    name: "Groestlcoin",
  },
  {
    id: "grok",
    symbol: "grok",
    name: "Grok",
  },
  {
    id: "grom",
    symbol: "gr",
    name: "GROM",
  },
  {
    id: "groupdao",
    symbol: "gdo",
    name: "GroupDao",
  },
  {
    id: "gro-vault-token",
    symbol: "gvt",
    name: "Gro Vault",
  },
  {
    id: "grove",
    symbol: "gvr",
    name: "Grove",
  },
  {
    id: "growing-fi",
    symbol: "grow",
    name: "Growing.fi",
  },
  {
    id: "growthcoin",
    symbol: "grw",
    name: "GrowthCoin",
  },
  {
    id: "growth-defi",
    symbol: "gro",
    name: "GROWTH DeFi",
  },
  {
    id: "grow-token-2",
    symbol: "grow",
    name: "Grow",
  },
  {
    id: "gscarab",
    symbol: "gscarab",
    name: "GScarab",
  },
  {
    id: "gsenetwork",
    symbol: "gse",
    name: "GSENetwork",
  },
  {
    id: "gsmcoin",
    symbol: "gsm",
    name: "GSMcoin",
  },
  {
    id: "gspi",
    symbol: "gspi",
    name: "Shopping.io Governance",
  },
  {
    id: "gstcoin",
    symbol: "gst",
    name: "GSTCOIN",
  },
  {
    id: "gton-capital",
    symbol: "gton",
    name: "GTON CAPITAL",
  },
  {
    id: "gt-protocol",
    symbol: "gtp",
    name: "GT-Protocol",
  },
  {
    id: "gu",
    symbol: "gu",
    name: "Kugle GU",
  },
  {
    id: "guapcoin",
    symbol: "guap",
    name: "Guapcoin",
  },
  {
    id: "guarded-ether",
    symbol: "geth",
    name: "Guarded Ether",
  },
  {
    id: "guardian-token",
    symbol: "guard",
    name: "Guardian GUARD",
  },
  {
    id: "guider",
    symbol: "gdr",
    name: "Guider",
  },
  {
    id: "guildfi",
    symbol: "gf",
    name: "GuildFi",
  },
  {
    id: "guild-of-guardians",
    symbol: "gog",
    name: "Guild of Guardians",
  },
  {
    id: "guitarswap",
    symbol: "gut",
    name: "GuitarSwap",
  },
  {
    id: "gulden",
    symbol: "nlg",
    name: "Gulden",
  },
  {
    id: "gummy-beans",
    symbol: "gummie",
    name: "Gummy Beans",
  },
  {
    id: "gummy-bull-token",
    symbol: "gummy",
    name: "Gummy Bull",
  },
  {
    id: "guncoin",
    symbol: "gun",
    name: "Guncoin",
  },
  {
    id: "gunstar-metaverse",
    symbol: "gst",
    name: "Gunstar Metaverse",
  },
  {
    id: "gunstar-metaverse-currency",
    symbol: "gsc",
    name: "Gunstar Metaverse Currency",
  },
  {
    id: "gunthy",
    symbol: "gunthy",
    name: "GUNTHY",
  },
  {
    id: "gusd-token",
    symbol: "gusdt",
    name: "Global Utility Smart Digital",
  },
  {
    id: "guss-one",
    symbol: "guss",
    name: "GUSS.ONE",
  },
  {
    id: "gutter-cat-gang",
    symbol: "gcg",
    name: "Gutter Cat Gang",
  },
  {
    id: "guzzler",
    symbol: "gzlr",
    name: "Guzzler",
  },
  {
    id: "gw",
    symbol: "gw",
    name: "GW",
  },
  {
    id: "gxchain",
    symbol: "gxc",
    name: "GXChain",
  },
  {
    id: "gyen",
    symbol: "gyen",
    name: "GYEN",
  },
  {
    id: "gym-network",
    symbol: "gymnet",
    name: "Gym Network",
  },
  {
    id: "gym-token",
    symbol: "gym",
    name: "GYM",
  },
  {
    id: "gyro",
    symbol: "gyro",
    name: "Gyro",
  },
  {
    id: "gyroscope",
    symbol: "gyfi",
    name: "Gyroscope",
  },
  {
    id: "h2finance",
    symbol: "yfih2",
    name: "H2Finance",
  },
  {
    id: "h2o",
    symbol: "h2o",
    name: "H2O",
  },
  {
    id: "h2o-dao",
    symbol: "h2o",
    name: "H2O Dao",
  },
  {
    id: "h3ro3s",
    symbol: "h3ro3s",
    name: "H3RO3S",
  },
  {
    id: "habitat",
    symbol: "hbt",
    name: "Habitat",
  },
  {
    id: "habits",
    symbol: "hbx",
    name: "Habits",
  },
  {
    id: "hacash",
    symbol: "hac",
    name: "Hacash",
  },
  {
    id: "hachiko",
    symbol: "hachiko",
    name: "Hachiko",
  },
  {
    id: "hachiko-charity",
    symbol: "hkc",
    name: "Hachiko Charity",
  },
  {
    id: "hachikoinu",
    symbol: "inu",
    name: "HachikoInu",
  },
  {
    id: "hackenai",
    symbol: "hai",
    name: "Hacken HAI",
  },
  {
    id: "hackerlabs-dao",
    symbol: "hld",
    name: "Hackerlabs DAO",
  },
  {
    id: "hackspace-capital",
    symbol: "hac",
    name: "Hackspace Capital",
  },
  {
    id: "hades-money",
    symbol: "hades",
    name: "Hades Money",
  },
  {
    id: "hado",
    symbol: "hdo",
    name: "HADO",
  },
  {
    id: "hai-governence-token",
    symbol: "damo",
    name: "Hai DAMO",
  },
  {
    id: "haino",
    symbol: "he",
    name: "Haino [OLD]",
  },
  {
    id: "haino-2",
    symbol: "he",
    name: "Haino",
  },
  {
    id: "hakka-finance",
    symbol: "hakka",
    name: "Hakka Finance",
  },
  {
    id: "hakuna-matata",
    symbol: "matata",
    name: "Hakuna Matata",
  },
  {
    id: "hakuna-matata-finance",
    symbol: "hkn",
    name: "Hakuna Matata Finance",
  },
  {
    id: "hakunamatata-new",
    symbol: "hkun",
    name: "HakunaMatata (new)",
  },
  {
    id: "hakuna-metata",
    symbol: "tata",
    name: "HakunaMatata (old)",
  },
  {
    id: "hakuna-shares",
    symbol: "mtt",
    name: "Hakuna Shares",
  },
  {
    id: "hakurai",
    symbol: "$rai",
    name: "Hakurai",
  },
  {
    id: "hakuryu",
    symbol: "$ryu",
    name: "Hakuryu",
  },
  {
    id: "hakuswap",
    symbol: "haku",
    name: "HakuSwap",
  },
  {
    id: "halcyon",
    symbol: "hal",
    name: "Halcyon",
  },
  {
    id: "halfpizza",
    symbol: "piza",
    name: "Half Pizza",
  },
  {
    id: "halo-network",
    symbol: "ho",
    name: "HALO Network",
  },
  {
    id: "halo-platform",
    symbol: "halo",
    name: "Halo Platform",
  },
  {
    id: "halving-coin",
    symbol: "halv",
    name: "Halving",
  },
  {
    id: "hamaru",
    symbol: "maru",
    name: "Hamaru",
  },
  {
    id: "hamdan-coin",
    symbol: "hmc",
    name: "Hamdan Coin",
  },
  {
    id: "hampton-metaverse",
    symbol: "hmeta",
    name: "Hampton Metaverse",
  },
  {
    id: "hamster",
    symbol: "ham",
    name: "Hamster",
  },
  {
    id: "hamster-money",
    symbol: "ham",
    name: "Hamster Money",
  },
  {
    id: "hamster-share",
    symbol: "hshare",
    name: "Hamster Share",
  },
  {
    id: "hanacoin",
    symbol: "hana",
    name: "Hanacoin",
  },
  {
    id: "hanagold-token",
    symbol: "hng",
    name: "HanaGold",
  },
  {
    id: "handle-fi",
    symbol: "forex",
    name: "handle.fi",
  },
  {
    id: "handshake",
    symbol: "hns",
    name: "Handshake",
  },
  {
    id: "handy",
    symbol: "handy",
    name: "Handy",
  },
  {
    id: "hangrybirds",
    symbol: "hangry",
    name: "HangryBirds",
  },
  {
    id: "hanu-yokia",
    symbol: "hanu",
    name: "Hanu Yokia",
  },
  {
    id: "hanzo-inu",
    symbol: "hanzo",
    name: "Hanzo",
  },
  {
    id: "hapi",
    symbol: "hapi",
    name: "HAPI",
  },
  {
    id: "happiness-token",
    symbol: "hps",
    name: "Happiness HPS",
  },
  {
    id: "happy-birthday-coin",
    symbol: "hbdc",
    name: "Happy Birthday Coin",
  },
  {
    id: "happycoin",
    symbol: "happy",
    name: "HappyCoin",
  },
  {
    id: "happyfans",
    symbol: "happy",
    name: "HappyFans",
  },
  {
    id: "happyland",
    symbol: "hpl",
    name: "HappyLand",
  },
  {
    id: "happyland-reward-token",
    symbol: "hpw",
    name: "HappyLand Reward",
  },
  {
    id: "harambe",
    symbol: "harambe",
    name: "Harambe",
  },
  {
    id: "harambe-protocol",
    symbol: "riph",
    name: "Harambe Protocol",
  },
  {
    id: "hara-token",
    symbol: "hart",
    name: "Hara",
  },
  {
    id: "hare",
    symbol: "hare",
    name: "Hare",
  },
  {
    id: "hare-plus",
    symbol: "hare plus",
    name: "Hare Plus",
  },
  {
    id: "hare-token",
    symbol: "hare",
    name: "Hare [OLD]",
  },
  {
    id: "harmes-shares",
    symbol: "hshares",
    name: "Hermes Shares",
  },
  {
    id: "harmomized-app",
    symbol: "hmz",
    name: "Harmonized App",
  },
  {
    id: "harmon-ape",
    symbol: "ape",
    name: "Harmon Ape",
  },
  {
    id: "harmony",
    symbol: "one",
    name: "Harmony",
  },
  {
    id: "harmonycoin",
    symbol: "hmc",
    name: "HarmonyCoin",
  },
  {
    id: "harmonylauncher",
    symbol: "harl",
    name: "HarmonyLauncher",
  },
  {
    id: "harmony-play",
    symbol: "hplay",
    name: "Harmony Play",
  },
  {
    id: "harmonyville",
    symbol: "hville",
    name: "Harmonyville",
  },
  {
    id: "haroldcoin",
    symbol: "hrld",
    name: "Haroldcoin",
  },
  {
    id: "harpy-finance",
    symbol: "harpy",
    name: "Harpy Finance",
  },
  {
    id: "harrison-first",
    symbol: "first",
    name: "Harrison First",
  },
  {
    id: "harrypotterobamasonic10inu",
    symbol: "bitcoin",
    name: "HarryPotterObamaSonic10Inu",
  },
  {
    id: "harvest-finance",
    symbol: "farm",
    name: "Harvest Finance",
  },
  {
    id: "hashbit",
    symbol: "hbit",
    name: "HashBit",
  },
  {
    id: "hash-bridge-oracle",
    symbol: "hbo",
    name: "Hash Bridge Oracle",
  },
  {
    id: "hashbx",
    symbol: "hbx",
    name: "HashBX",
  },
  {
    id: "hashcoin",
    symbol: "hsc",
    name: "HashCoin",
  },
  {
    id: "hashgard",
    symbol: "gard",
    name: "Hashgard",
  },
  {
    id: "hashkings-buds",
    symbol: "buds",
    name: "Hashkings Buds",
  },
  {
    id: "hashland-coin",
    symbol: "hc",
    name: "HashLand Coin",
  },
  {
    id: "hashmasks",
    symbol: "mask20",
    name: "Hashmasks",
  },
  {
    id: "hashnet-biteco",
    symbol: "hnb",
    name: "HashNet BitEco",
  },
  {
    id: "hashpanda",
    symbol: "panda",
    name: "HashPanda",
  },
  {
    id: "hashshare",
    symbol: "hss",
    name: "Hashshare",
  },
  {
    id: "hashtagger",
    symbol: "mooo",
    name: "Hashtagger",
  },
  {
    id: "hash-token",
    symbol: "hash",
    name: "Hashbon",
  },
  {
    id: "hatayspor-token",
    symbol: "hatay",
    name: "Hatayspor Token",
  },
  {
    id: "hatch-dao",
    symbol: "hatch",
    name: "Hatch DAO",
  },
  {
    id: "hathor",
    symbol: "htr",
    name: "Hathor",
  },
  {
    id: "hatoken",
    symbol: "hatok",
    name: "Hatoken [OLD]",
  },
  {
    id: "hatoken-2",
    symbol: "hatok",
    name: "Hatoken",
  },
  {
    id: "hat-swap-city",
    symbol: "htc",
    name: "Hat Swap City",
  },
  {
    id: "hatter",
    symbol: "hatter",
    name: "Hatter",
  },
  {
    id: "have-fun-staying-poor",
    symbol: "hfsp",
    name: "Have Fun Staying Poor",
  },
  {
    id: "haven",
    symbol: "xhv",
    name: "Haven",
  },
  {
    id: "havens-nook",
    symbol: "hxn",
    name: "Havens Nook",
  },
  {
    id: "haven-token",
    symbol: "haven",
    name: "Safehaven DeFi",
  },
  {
    id: "havven",
    symbol: "snx",
    name: "Synthetix Network",
  },
  {
    id: "havy-2",
    symbol: "havy",
    name: "Havy",
  },
  {
    id: "hawaii-coin",
    symbol: "hwi",
    name: "Hawaii Coin",
  },
  {
    id: "hawksight",
    symbol: "hawk",
    name: "Hawksight",
  },
  {
    id: "hayate-inu",
    symbol: "hinu",
    name: "Hayate Inu",
  },
  {
    id: "hayfever",
    symbol: "hay",
    name: "Hayfever",
  },
  {
    id: "hazza",
    symbol: "haz",
    name: "Hazza",
  },
  {
    id: "hbarpad",
    symbol: "hbarp",
    name: "HbarPad",
  },
  {
    id: "hbtc-token",
    symbol: "hbc",
    name: "HBTC Captain",
  },
  {
    id: "hddcoin",
    symbol: "hdd",
    name: "HDDcoin",
  },
  {
    id: "hdpunk-vault-nftx",
    symbol: "hdpunk",
    name: "HDPUNK Vault (NFTX)",
  },
  {
    id: "headbangers-club",
    symbol: "headbangers",
    name: "Headbangers Club",
  },
  {
    id: "head-football",
    symbol: "head",
    name: "Head Football",
  },
  {
    id: "headline",
    symbol: "hdl",
    name: "Headline",
  },
  {
    id: "healing-potion",
    symbol: "hppot",
    name: "Healing Potion",
  },
  {
    id: "healthchainus",
    symbol: "hcut",
    name: "HealthChainUS",
  },
  {
    id: "heal-the-world",
    symbol: "heal",
    name: "Heal The World",
  },
  {
    id: "healthify",
    symbol: "htf",
    name: "Healthify",
  },
  {
    id: "hearn-fi",
    symbol: "hearn",
    name: "Hearn.fi",
  },
  {
    id: "heartbout",
    symbol: "hb",
    name: "HeartBout",
  },
  {
    id: "heartbout-pay",
    symbol: "hp",
    name: "HeartBout Pay",
  },
  {
    id: "heartnumber",
    symbol: "htn",
    name: "Heart Number",
  },
  {
    id: "hearts",
    symbol: "heart",
    name: "Hearts",
  },
  {
    id: "heavenland-hto",
    symbol: "hto",
    name: "Heavenland HTO",
  },
  {
    id: "hebeblock",
    symbol: "hebe",
    name: "Hebeblock",
  },
  {
    id: "hecate-capital",
    symbol: "hecate",
    name: "Hecate Capital",
  },
  {
    id: "hecofi",
    symbol: "hfi",
    name: "HecoFi",
  },
  {
    id: "heco-origin-token",
    symbol: "hogt",
    name: "Heco Origin",
  },
  {
    id: "heco-peg-bnb",
    symbol: "bnb",
    name: "Heco-Peg Binance Coin",
  },
  {
    id: "heco-peg-xrp",
    symbol: "xrp",
    name: "Heco-Peg XRP",
  },
  {
    id: "hector-dao",
    symbol: "hec",
    name: "Hector Finance",
  },
  {
    id: "hedera-hashgraph",
    symbol: "hbar",
    name: "Hedera",
  },
  {
    id: "hedge-finance",
    symbol: "hedge",
    name: "Hedge Finance",
  },
  {
    id: "hedge-protocol",
    symbol: "hdg",
    name: "Hedge Protocol",
  },
  {
    id: "hedget",
    symbol: "hget",
    name: "Hedget",
  },
  {
    id: "hedgetrade",
    symbol: "hedg",
    name: "HedgeTrade",
  },
  {
    id: "hedget-wormhole",
    symbol: "hget",
    name: "Hedget (Wormhole)",
  },
  {
    id: "hedge-usd",
    symbol: "ush",
    name: "Hedge USD",
  },
  {
    id: "hedpay",
    symbol: "hdp.ф",
    name: "HEdpAY",
  },
  {
    id: "hedron",
    symbol: "hdrn",
    name: "Hedron",
  },
  {
    id: "hegic",
    symbol: "hegic",
    name: "Hegic",
  },
  {
    id: "helicopter-finance",
    symbol: "copter",
    name: "Helicopter Finance",
  },
  {
    id: "helio",
    symbol: "hlo",
    name: "Helio",
  },
  {
    id: "helium",
    symbol: "hnt",
    name: "Helium",
  },
  {
    id: "helix",
    symbol: "hlix",
    name: "Helix",
  },
  {
    id: "helkin",
    symbol: "hk",
    name: "Helkin",
  },
  {
    id: "helleniccoin",
    symbol: "hnc",
    name: "HNC Coin",
  },
  {
    id: "hell-hounds",
    symbol: "soul",
    name: "HELL HOUNDS",
  },
  {
    id: "hellmoon",
    symbol: "hmoon",
    name: "HELLMOON",
  },
  {
    id: "hellogold",
    symbol: "hgt",
    name: "HelloGold",
  },
  {
    id: "hellshare",
    symbol: "hellshare",
    name: "HELLSHARE",
  },
  {
    id: "hellsing-inu",
    symbol: "hellsing",
    name: "Hellsing Inu",
  },
  {
    id: "helmet-insure",
    symbol: "helmet",
    name: "Helmet Insure",
  },
  {
    id: "help-coin",
    symbol: "hlp",
    name: "HLP",
  },
  {
    id: "help-coins",
    symbol: "hcs",
    name: "Help Coins",
  },
  {
    id: "helper-search-token",
    symbol: "hsn",
    name: "Helper Search",
  },
  {
    id: "helpico",
    symbol: "help",
    name: "Helpico",
  },
  {
    id: "helpkidz-coin",
    symbol: "hkc",
    name: "HelpKidz Coin",
  },
  {
    id: "helpseed",
    symbol: "helps",
    name: "HelpSeed",
  },
  {
    id: "help-the-homeless-coin",
    symbol: "hth",
    name: "Help The Homeless Coin",
  },
  {
    id: "help-token",
    symbol: "help",
    name: "GoHelpFund",
  },
  {
    id: "hempcoin-thc",
    symbol: "thc",
    name: "Hempcoin",
  },
  {
    id: "hepa-finance",
    symbol: "hepa",
    name: "Hepa Finance",
  },
  {
    id: "heptafranc",
    symbol: "hptf",
    name: "HEPTAFRANC",
  },
  {
    id: "hera-finance",
    symbol: "hera",
    name: "Hera Finance",
  },
  {
    id: "herbalist-token",
    symbol: "herb",
    name: "Herbalist",
  },
  {
    id: "heres",
    symbol: "hrs",
    name: "Heres",
  },
  {
    id: "herity-network",
    symbol: "her",
    name: "Herity Network",
  },
  {
    id: "hermes",
    symbol: "hermes",
    name: "HERMES",
  },
  {
    id: "hermes-protocol",
    symbol: "hermes",
    name: "Hermes Protocol",
  },
  {
    id: "hermez-network-token",
    symbol: "hez",
    name: "Hermez Network",
  },
  {
    id: "hero",
    symbol: "hero",
    name: "HERO",
  },
  {
    id: "hero-arena",
    symbol: "hera",
    name: "Hero Arena",
  },
  {
    id: "herobattle",
    symbol: "hrb",
    name: "Herobattle",
  },
  {
    id: "herobook",
    symbol: "hbg",
    name: "HeroBook",
  },
  {
    id: "hero-cat-key",
    symbol: "hck",
    name: "Hero Cat Key",
  },
  {
    id: "hero-cat-token",
    symbol: "hct",
    name: "Hero Cat",
  },
  {
    id: "herocoin",
    symbol: "play",
    name: "HEROcoin",
  },
  {
    id: "heroeschained",
    symbol: "hec",
    name: "HeroesChained",
  },
  {
    id: "heroes-empires",
    symbol: "he",
    name: "Heroes & Empires",
  },
  {
    id: "heroes-of-nft",
    symbol: "hon",
    name: "Heroes of NFT",
  },
  {
    id: "hero-essence",
    symbol: "hes",
    name: "Hero Essence",
  },
  {
    id: "heroes-td",
    symbol: "htd",
    name: "Heroes TD",
  },
  {
    id: "heroestd-cgc",
    symbol: "cgc",
    name: "HeroesTD CGC",
  },
  {
    id: "herofi",
    symbol: "heroegg",
    name: "HeroFi",
  },
  {
    id: "herofi-token-2",
    symbol: "rofi",
    name: "HeroFi ROFI",
  },
  {
    id: "hero-inu",
    symbol: "heros",
    name: "Heros",
  },
  {
    id: "heropark",
    symbol: "hp",
    name: "HeroPark",
  },
  {
    id: "herosofcrypton",
    symbol: "heroes",
    name: "Heroes of Crypton",
  },
  {
    id: "hero-token",
    symbol: "raise",
    name: "Raise",
  },
  {
    id: "heroverse",
    symbol: "her",
    name: "HeroVerse",
  },
  {
    id: "hertz-network",
    symbol: "htz",
    name: "Hertz Network",
  },
  {
    id: "herum",
    symbol: "ram",
    name: "Herum",
  },
  {
    id: "hesh-fi",
    symbol: "hesh",
    name: "Hesh.Fi",
  },
  {
    id: "hesman-shard",
    symbol: "hes",
    name: "Hesman Shard",
  },
  {
    id: "hex",
    symbol: "hex",
    name: "HEX",
  },
  {
    id: "hex-money",
    symbol: "hxy",
    name: "HXY Money",
  },
  {
    id: "hey-shiba",
    symbol: "$heyshib",
    name: "Hey Shiba",
  },
  {
    id: "hfuel",
    symbol: "hfuel",
    name: "HFuel",
  },
  {
    id: "hibiki-finance",
    symbol: "hibiki",
    name: "Hibiki Finance",
  },
  {
    id: "hiblocks",
    symbol: "hibs",
    name: "Hiblocks",
  },
  {
    id: "hicoin",
    symbol: "xhi",
    name: "HiCoin",
  },
  {
    id: "hidden-coin",
    symbol: "hdn",
    name: "Hidden Coin",
  },
  {
    id: "hideous-coin",
    symbol: "hideous",
    name: "Hideous Finance",
  },
  {
    id: "hi-dollar",
    symbol: "hi",
    name: "hi Dollar",
  },
  {
    id: "hierocoin",
    symbol: "bar",
    name: "Hierocoin",
  },
  {
    id: "hifi-gaming-society",
    symbol: "hifi",
    name: "HiFi Gaming Society",
  },
  {
    id: "higgs",
    symbol: "higgs",
    name: "Higgs",
  },
  {
    id: "highest-yield-savings-service",
    symbol: "hyss",
    name: "Highest Yield Savings Service",
  },
  {
    id: "high-performance-blockchain",
    symbol: "hpb",
    name: "High Performance Blockchain",
  },
  {
    id: "high-roller-hippo-clique",
    symbol: "roll",
    name: "High Roller Hippo Clique",
  },
  {
    id: "highstreet",
    symbol: "high",
    name: "Highstreet",
  },
  {
    id: "hillstone",
    symbol: "hsf",
    name: "Hillstone Finance",
  },
  {
    id: "himalayan-cat-coin",
    symbol: "hima",
    name: "Himalayan Cat Coin",
  },
  {
    id: "himo-world",
    symbol: "himo",
    name: "Himo World",
  },
  {
    id: "hina-inu",
    symbol: "hina",
    name: "Hina Inu",
  },
  {
    id: "hintchain",
    symbol: "hint",
    name: "Hintchain",
  },
  {
    id: "hippo-coin",
    symbol: "$hippo",
    name: "Hippo Coin",
  },
  {
    id: "hippo-token",
    symbol: "hip",
    name: "Hippo",
  },
  {
    id: "hiram",
    symbol: "hiram",
    name: "Hiram",
  },
  {
    id: "hirevibes",
    symbol: "hvt",
    name: "HireVibes",
  },
  {
    id: "historia",
    symbol: "hta",
    name: "Historia",
  },
  {
    id: "hitbtc-token",
    symbol: "hit",
    name: "HitBTC",
  },
  {
    id: "hitchain",
    symbol: "hit",
    name: "HitChain",
  },
  {
    id: "hitcoin",
    symbol: "htc",
    name: "Hitcoin",
  },
  {
    id: "hithotx",
    symbol: "hitx",
    name: "Hithotx",
  },
  {
    id: "hive",
    symbol: "hive",
    name: "Hive",
  },
  {
    id: "hive_dollar",
    symbol: "hbd",
    name: "Hive Dollar",
  },
  {
    id: "hive-investments-honey",
    symbol: "hny",
    name: "Hive.Investments HONEY",
  },
  {
    id: "hiveterminal",
    symbol: "hvn",
    name: "Hiveterminal",
  },
  {
    id: "hiz-finance",
    symbol: "hiz",
    name: "Hiz Finance",
  },
  {
    id: "hk-coin",
    symbol: "hkc",
    name: "HK Coin",
  },
  {
    id: "hkd-com-dao",
    symbol: "hdao",
    name: "Hkd.com Dao",
  },
  {
    id: "hland-token",
    symbol: "hland",
    name: "HLand",
  },
  {
    id: "hlth-token",
    symbol: "hlth",
    name: "HLTH",
  },
  {
    id: "hnk-orijent-1919-token",
    symbol: "ori",
    name: "HNK Orijent 1919",
  },
  {
    id: "hobbs-networking",
    symbol: "hnw",
    name: "Hobbs Networking",
  },
  {
    id: "hobonickels",
    symbol: "hbn",
    name: "Hobonickels",
  },
  {
    id: "hodlassets",
    symbol: "hodl",
    name: "HodlAssets",
  },
  {
    id: "hodlcoin",
    symbol: "hodl",
    name: "HOdlcoin",
  },
  {
    id: "hodler-heroes-nft",
    symbol: "hhnft",
    name: "Hodler Heroes NFT",
  },
  {
    id: "hodl-eth",
    symbol: "heth",
    name: "Hodl ETH",
  },
  {
    id: "hodl-finance",
    symbol: "hft",
    name: "Hodl Finance",
  },
  {
    id: "hodl-token",
    symbol: "hodl",
    name: "HODL",
  },
  {
    id: "hodl-vault",
    symbol: "hvlt",
    name: "HODL Vault",
  },
  {
    id: "hodooi-com",
    symbol: "hod",
    name: "HoDooi.com",
  },
  {
    id: "hoff-coin",
    symbol: "hoff",
    name: "Hoff Coin",
  },
  {
    id: "hoge-finance",
    symbol: "hoge",
    name: "Hoge Finance",
  },
  {
    id: "hokkaidu-inu",
    symbol: "hokk",
    name: "Hokkaido Inu",
  },
  {
    id: "hold2earn",
    symbol: "h2e",
    name: "Hold2Earn",
  },
  {
    id: "hold-diamond",
    symbol: "hdt",
    name: "Hold Diamond",
  },
  {
    id: "holdenomics",
    symbol: "holdenomics",
    name: "Holdenomics",
  },
  {
    id: "holdermoon",
    symbol: "hlm",
    name: "HolderMoon",
  },
  {
    id: "holderswap",
    symbol: "hfs",
    name: "HolderSwap",
  },
  {
    id: "holdex-finance",
    symbol: "holdex",
    name: "Holdex Finance",
  },
  {
    id: "holiday-token",
    symbol: "hol",
    name: "Holiday",
  },
  {
    id: "hollaex-token",
    symbol: "xht",
    name: "HollaEx",
  },
  {
    id: "hollygold",
    symbol: "hgold",
    name: "HollyGold",
  },
  {
    id: "hololoot",
    symbol: "hol",
    name: "Hololoot",
  },
  {
    id: "holoride",
    symbol: "ride",
    name: "holoride",
  },
  {
    id: "holotoken",
    symbol: "hot",
    name: "Holo",
  },
  {
    id: "holydoge",
    symbol: "hdoge",
    name: "HolyDoge",
  },
  {
    id: "holygrail",
    symbol: "hly",
    name: "HolyGrail",
  },
  {
    id: "holyheld-2",
    symbol: "move",
    name: "Mover",
  },
  {
    id: "holy-knight",
    symbol: "holy",
    name: "Holy Knight",
  },
  {
    id: "holy-trinity",
    symbol: "holy",
    name: "Holy Trinity",
  },
  {
    id: "home-coin",
    symbol: "home",
    name: "Home Coin",
  },
  {
    id: "homeros",
    symbol: "hmr",
    name: "Homeros",
  },
  {
    id: "homerun",
    symbol: "hmrn",
    name: "Homerun",
  },
  {
    id: "hom-token",
    symbol: "homt",
    name: "HOMT",
  },
  {
    id: "hondaiscoin",
    symbol: "hndc",
    name: "HondaisCoin",
  },
  {
    id: "honest-mining",
    symbol: "hnst",
    name: "Honest",
  },
  {
    id: "honey",
    symbol: "hny",
    name: "Honey",
  },
  {
    id: "honey-badger",
    symbol: "honeybadger",
    name: "Honey Badger",
  },
  {
    id: "honeybear",
    symbol: "bear",
    name: "HoneyBear",
  },
  {
    id: "honeybee",
    symbol: "bee",
    name: "HoneyBee",
  },
  {
    id: "honeycomb-2",
    symbol: "honey",
    name: "Honeycomb",
  },
  {
    id: "honey-deluxe",
    symbol: "honeyd",
    name: "Honey Deluxe",
  },
  {
    id: "honey-fancybearsmetaverse",
    symbol: "$honey",
    name: "Honey (Fancy Bears Metaverse)",
  },
  {
    id: "honeyfarm-finance",
    symbol: "honey",
    name: "HoneyFarm Finance",
  },
  {
    id: "honey-finance",
    symbol: "honey",
    name: "Honey Finance",
  },
  {
    id: "honeymoon-token",
    symbol: "moon",
    name: "HoneyMOON",
  },
  {
    id: "honeypad",
    symbol: "honey",
    name: "HONEYPAD",
  },
  {
    id: "honey-pot-beekeepers",
    symbol: "honey",
    name: "Honey Pot BeeKeepers",
  },
  {
    id: "honey-token",
    symbol: "sweet",
    name: "Honey SWEET",
  },
  {
    id: "honk-honk",
    symbol: "honk",
    name: "Honk Honk",
  },
  {
    id: "hono",
    symbol: "hono",
    name: "Hono",
  },
  {
    id: "honorland",
    symbol: "honor",
    name: "HonorLand",
  },
  {
    id: "hoopoe",
    symbol: "hoop",
    name: "Hoopoe",
  },
  {
    id: "hoo-token",
    symbol: "hoo",
    name: "Hoo",
  },
  {
    id: "hope-galaxy",
    symbol: "hope",
    name: "HOPE Galaxy",
  },
  {
    id: "hope-token",
    symbol: "hope",
    name: "Hope",
  },
  {
    id: "hoppers-game",
    symbol: "fly",
    name: "Hoppers Game",
  },
  {
    id: "hop-protocol",
    symbol: "hop",
    name: "Hop Protocol",
  },
  {
    id: "hoppy",
    symbol: "hop",
    name: "HOPPY",
  },
  {
    id: "hopr",
    symbol: "hopr",
    name: "HOPR",
  },
  {
    id: "hoqu",
    symbol: "hqx",
    name: "HOQU",
  },
  {
    id: "hord",
    symbol: "hord",
    name: "Hord",
  },
  {
    id: "horde",
    symbol: "hor",
    name: "Last Horde",
  },
  {
    id: "horde-token",
    symbol: "$horde",
    name: "Horde",
  },
  {
    id: "horgi",
    symbol: "horgi",
    name: "Horgi",
  },
  {
    id: "horizondollar",
    symbol: "hzd",
    name: "Horizon Dollar",
  },
  {
    id: "horizonland",
    symbol: "hrz",
    name: "Horizonland",
  },
  {
    id: "horizon-protocol",
    symbol: "hzn",
    name: "Horizon Protocol",
  },
  {
    id: "horuspay",
    symbol: "horus",
    name: "HorusPay",
  },
  {
    id: "hosky",
    symbol: "hosky",
    name: "Hosky",
  },
  {
    id: "hospital-coin",
    symbol: "hosp",
    name: "Hospital Coin",
  },
  {
    id: "hotbit-token",
    symbol: "htb",
    name: "Hotbit",
  },
  {
    id: "hot-cross",
    symbol: "hotcross",
    name: "Hot Cross",
  },
  {
    id: "hotdoge",
    symbol: "hotdoge",
    name: "HotDoge",
  },
  {
    id: "hot-doge",
    symbol: "hotdoge",
    name: "HotDoge [OLD]",
  },
  {
    id: "hotdollars-token",
    symbol: "hds",
    name: "HotDollars",
  },
  {
    id: "hotelium",
    symbol: "htl",
    name: "Hotelium",
  },
  {
    id: "hotmoon",
    symbol: "hotmoon",
    name: "HotMoon",
  },
  {
    id: "hotnow",
    symbol: "hot",
    name: "HotNow",
  },
  {
    id: "hotzilla",
    symbol: "hotzilla",
    name: "HotZilla",
  },
  {
    id: "housedao",
    symbol: "house",
    name: "HouseDAO",
  },
  {
    id: "howdoo",
    symbol: "udoo",
    name: "Hyprr",
  },
  {
    id: "howl-city",
    symbol: "hwl",
    name: "Howl City",
  },
  {
    id: "howlx",
    symbol: "hwxt",
    name: "Howlx",
  },
  {
    id: "hrdcoin",
    symbol: "hrd",
    name: "HRDcoin",
  },
  {
    id: "hrdgcoin",
    symbol: "hrdg",
    name: "HRDGCOIN",
  },
  {
    id: "hshare",
    symbol: "hc",
    name: "HyperCash",
  },
  {
    id: "h-space-metaverse",
    symbol: "hksm",
    name: "H-Space Metaverse",
  },
  {
    id: "htm",
    symbol: "htm",
    name: "HTM",
  },
  {
    id: "htmlcoin",
    symbol: "html",
    name: "HTMLCOIN",
  },
  {
    id: "htmoon",
    symbol: "htmoon",
    name: "HTMoon",
  },
  {
    id: "hubble",
    symbol: "hbb",
    name: "Hubble",
  },
  {
    id: "hubcoin-2",
    symbol: "hub",
    name: "HubCoin",
  },
  {
    id: "hub-token",
    symbol: "hub",
    name: "Hub",
  },
  {
    id: "huckleberry",
    symbol: "finn",
    name: "Huckleberry",
  },
  {
    id: "hudi",
    symbol: "hudi",
    name: "Hudi",
  },
  {
    id: "hughug-coin",
    symbol: "hghg",
    name: "HUGHUG",
  },
  {
    id: "hugo-finance",
    symbol: "hugo",
    name: "Hugo Game",
  },
  {
    id: "huh",
    symbol: "huh",
    name: "HUH",
  },
  {
    id: "humancoin-2",
    symbol: "hmnc",
    name: "HumanCoin",
  },
  {
    id: "humandao",
    symbol: "hdao",
    name: "humanDAO",
  },
  {
    id: "humaniq",
    symbol: "hmq",
    name: "Humaniq",
  },
  {
    id: "human-protocol",
    symbol: "hmt",
    name: "HUMAN Protocol",
  },
  {
    id: "humans-ai",
    symbol: "heart",
    name: "Humans.ai",
  },
  {
    id: "humanscape",
    symbol: "hum",
    name: "Humanscape",
  },
  {
    id: "human-world",
    symbol: "ssap",
    name: "Human World",
  },
  {
    id: "hummingbird-egg-token",
    symbol: "hegg",
    name: "Hummingbird Egg",
  },
  {
    id: "hummingbird-finance",
    symbol: "hmng",
    name: "Hummingbird Finance",
  },
  {
    id: "hummingbot",
    symbol: "hbot",
    name: "Hummingbot",
  },
  {
    id: "hummus",
    symbol: "hum",
    name: "Hummus",
  },
  {
    id: "humpback",
    symbol: "hump",
    name: "Whale Loans",
  },
  {
    id: "hundred-finance",
    symbol: "hnd",
    name: "Hundred Finance",
  },
  {
    id: "hungarian-vizsla-inu",
    symbol: "hvi",
    name: "Hungarian Vizsla Inu",
  },
  {
    id: "hunger-token",
    symbol: "hunger",
    name: "Hunger",
  },
  {
    id: "hungrybear",
    symbol: "hungry",
    name: "HungryBear",
  },
  {
    id: "hungry-bees",
    symbol: "hbee",
    name: "Hungry Bees",
  },
  {
    id: "hunny-love-token",
    symbol: "love",
    name: "HunnyDAO",
  },
  {
    id: "hunter-crypto-coin",
    symbol: "hcc",
    name: "Hunter Crypto Coin",
  },
  {
    id: "hunterdoge",
    symbol: "$hd",
    name: "HunterDoge",
  },
  {
    id: "hunt-token",
    symbol: "hunt",
    name: "Hunt",
  },
  {
    id: "huny",
    symbol: "huny",
    name: "Huny",
  },
  {
    id: "huobi-bitcoin-cash",
    symbol: "hbch",
    name: "Huobi Bitcoin Cash",
  },
  {
    id: "huobi-btc",
    symbol: "hbtc",
    name: "Huobi BTC",
  },
  {
    id: "huobi-btc-wormhole",
    symbol: "hbtc",
    name: "Huobi BTC (Wormhole)",
  },
  {
    id: "huobi-ethereum",
    symbol: "heth",
    name: "Huobi Ethereum",
  },
  {
    id: "huobi-fil",
    symbol: "hfil",
    name: "Huobi Fil",
  },
  {
    id: "huobi-litecoin",
    symbol: "hltc",
    name: "Huobi Litecoin",
  },
  {
    id: "huobi-polkadot",
    symbol: "hdot",
    name: "Huobi Polkadot",
  },
  {
    id: "huobi-pool-token",
    symbol: "hpt",
    name: "Huobi Pool",
  },
  {
    id: "huobi-token",
    symbol: "ht",
    name: "Huobi",
  },
  {
    id: "hupayx",
    symbol: "hpx",
    name: "HUPAYX",
  },
  {
    id: "hurify",
    symbol: "hur",
    name: "Hurify",
  },
  {
    id: "hurrian-network",
    symbol: "mld",
    name: "Hurrian Network",
  },
  {
    id: "hurricane-nft",
    symbol: "nhct",
    name: "Hurricane NFT",
  },
  {
    id: "hurricaneswap-token",
    symbol: "hct",
    name: "HurricaneSwap",
  },
  {
    id: "husd",
    symbol: "husd",
    name: "HUSD",
  },
  {
    id: "husd-stablecoin-wormhole",
    symbol: "husd",
    name: "HUSD Stablecoin (Wormhole)",
  },
  {
    id: "hush",
    symbol: "hush",
    name: "Hush",
  },
  {
    id: "husky",
    symbol: "husky",
    name: "Husky",
  },
  {
    id: "husky-avax",
    symbol: "husky",
    name: "Husky AVAX",
  },
  {
    id: "huskyshiba",
    symbol: "hshiba",
    name: "HuskyShiba",
  },
  {
    id: "hut34-entropy",
    symbol: "entrp",
    name: "Hut34 Entropy",
  },
  {
    id: "hxro",
    symbol: "hxro",
    name: "Hxro",
  },
  {
    id: "hxro-wormhole",
    symbol: "hxro",
    name: "Hxro (Wormhole)",
  },
  {
    id: "hybrid",
    symbol: "hybrid",
    name: "Hybrid",
  },
  {
    id: "hybrid-bank-cash",
    symbol: "hbc",
    name: "Hybrid Bank Cash",
  },
  {
    id: "hybrix",
    symbol: "hy",
    name: "Hybrix",
  },
  {
    id: "hycon",
    symbol: "hyc",
    name: "Hycon",
  },
  {
    id: "hydra",
    symbol: "hydra",
    name: "Hydra",
  },
  {
    id: "hydra-token",
    symbol: "hyd",
    name: "Hydraledger",
  },
  {
    id: "hydraverse",
    symbol: "hdv",
    name: "Hydraverse",
  },
  {
    id: "hydro",
    symbol: "hydro",
    name: "Hydro",
  },
  {
    id: "hydro-h2o",
    symbol: "h2o",
    name: "Hydro H2O",
  },
  {
    id: "hydrolink",
    symbol: "hlink",
    name: "HydroLink",
  },
  {
    id: "hydro-protocol",
    symbol: "hot",
    name: "Hydro Protocol",
  },
  {
    id: "hydro-protocol-token",
    symbol: "hydro",
    name: "Hydro Protocol Finance",
  },
  {
    id: "hygenercoin",
    symbol: "hg",
    name: "Hygenercoin",
  },
  {
    id: "hymnode",
    symbol: "hnt",
    name: "Hymnode",
  },
  {
    id: "hyperalloy",
    symbol: "alloy",
    name: "HyperAlloy",
  },
  {
    id: "hyperboost",
    symbol: "hyperboost",
    name: "HyperBoost",
  },
  {
    id: "hyperchain-x",
    symbol: "hyper",
    name: "HyperChain X",
  },
  {
    id: "hyper-credit-network",
    symbol: "hpay",
    name: "Hyper Credit Network",
  },
  {
    id: "hyperdao",
    symbol: "hdao",
    name: "HyperDAO",
  },
  {
    id: "hyper-deflate",
    symbol: "hdfl",
    name: "Hyper Deflate",
  },
  {
    id: "hyperexchange",
    symbol: "hx",
    name: "HyperExchange",
  },
  {
    id: "hyper-finance",
    symbol: "hyfi",
    name: "Hyper Finance",
  },
  {
    id: "hyperion",
    symbol: "hyn",
    name: "Hyperion",
  },
  {
    id: "hyperone",
    symbol: "hot",
    name: "HyperOne",
  },
  {
    id: "hyper-pay",
    symbol: "hpy",
    name: "Hyper Pay",
  },
  {
    id: "hyperquant",
    symbol: "hqt",
    name: "HyperQuant",
  },
  {
    id: "hyperrun",
    symbol: "hyperr",
    name: "HyperRun",
  },
  {
    id: "hypersign-identity-token",
    symbol: "hid",
    name: "Hypersign Identity",
  },
  {
    id: "hypersonic-finance",
    symbol: "hypersonic",
    name: "Hypersonic Finance",
  },
  {
    id: "hyperstake",
    symbol: "hyp",
    name: "Element",
  },
  {
    id: "hyper-trust",
    symbol: "hptt",
    name: "Hyper Trust",
  },
  {
    id: "hyperverse",
    symbol: "hvt",
    name: "HyperVerse",
  },
  {
    id: "hyruleswap",
    symbol: "rupee",
    name: "HyruleSwap",
  },
  {
    id: "hyve",
    symbol: "hyve",
    name: "Hyve",
  },
  {
    id: "hzm-coin",
    symbol: "hzm",
    name: "HZM Coin",
  },
  {
    id: "i0coin",
    symbol: "i0c",
    name: "I0Coin",
  },
  {
    id: "i4i-finance",
    symbol: "eye",
    name: "i4i Finance",
  },
  {
    id: "i9-coin",
    symbol: "i9c",
    name: "i9 Coin",
  },
  {
    id: "i9x-coin",
    symbol: "i9x",
    name: "i9X Coin",
  },
  {
    id: "iab",
    symbol: "iab",
    name: "IAB",
  },
  {
    id: "iagon",
    symbol: "iag",
    name: "Iagon",
  },
  {
    id: "i-am-vaccinated",
    symbol: "iamvax",
    name: "I Am Vaccinated",
  },
  {
    id: "iassets",
    symbol: "asset",
    name: "iAssets",
  },
  {
    id: "ibank",
    symbol: "ibank",
    name: "iBank",
  },
  {
    id: "ibax-network",
    symbol: "ibxc",
    name: "IBAX Network",
  },
  {
    id: "ibetyou",
    symbol: "iby",
    name: "iBetYou",
  },
  {
    id: "ibg-eth",
    symbol: "ibg",
    name: "iBG Finance (ETH)",
  },
  {
    id: "ibg-token",
    symbol: "ibg",
    name: "iBG Finance (BSC)",
  },
  {
    id: "ibithub",
    symbol: "ibh",
    name: "iBitHub",
  },
  {
    id: "ibnb-2",
    symbol: "ibnb",
    name: "iBNB",
  },
  {
    id: "ibuffer-token",
    symbol: "ibfr",
    name: "iBuffer",
  },
  {
    id: "icarus-finance",
    symbol: "ica",
    name: "Icarus Finance",
  },
  {
    id: "icarus-network",
    symbol: "ica",
    name: "Icarus Network",
  },
  {
    id: "iceberg",
    symbol: "iceberg",
    name: "ICEBERG",
  },
  {
    id: "icebreak-r",
    symbol: "icebrk",
    name: "IceBreak-R",
  },
  {
    id: "icecream-finance",
    symbol: "cream",
    name: "IceCream Finance",
  },
  {
    id: "icecubes-finance",
    symbol: "icube",
    name: "IceCubes Finance",
  },
  {
    id: "ice-dao",
    symbol: "icy",
    name: "Ice Dao",
  },
  {
    id: "iceflake-finance",
    symbol: "flake",
    name: "IceFlake Finance",
  },
  {
    id: "ice-token",
    symbol: "ice",
    name: "Popsicle Finance",
  },
  {
    id: "ice-wormhole",
    symbol: "ice",
    name: "Ice (Wormhole)",
  },
  {
    id: "ichello",
    symbol: "ello",
    name: "Ichello",
  },
  {
    id: "ichi-farm",
    symbol: "ichi",
    name: "ICHI",
  },
  {
    id: "ichigo-inu",
    symbol: "ichigo",
    name: "Ichigo Inu",
  },
  {
    id: "i-coin",
    symbol: "icn",
    name: "I-Coin V2",
  },
  {
    id: "icolcoin",
    symbol: "icol",
    name: "Icolcoin",
  },
  {
    id: "icomex",
    symbol: "icmx",
    name: "iCOMEX",
  },
  {
    id: "icommunity",
    symbol: "icom",
    name: "iCommunity",
  },
  {
    id: "icon",
    symbol: "icx",
    name: "ICON",
  },
  {
    id: "iconiq-lab-token",
    symbol: "icnq",
    name: "Iconic ICNQ",
  },
  {
    id: "icon-usdc",
    symbol: "iusdc",
    name: "Icon USDC",
  },
  {
    id: "icrypto-world",
    symbol: "icw",
    name: "iCrypto World",
  },
  {
    id: "icy-money",
    symbol: "icy",
    name: "ICY.MONEY",
  },
  {
    id: "idavoll-network",
    symbol: "idv",
    name: "Idavoll DAO",
  },
  {
    id: "ideachain",
    symbol: "ich",
    name: "IdeaChain",
  },
  {
    id: "ideamarket",
    symbol: "imo",
    name: "Ideamarket",
  },
  {
    id: "ideanet-token",
    symbol: "inet",
    name: "Ideanet",
  },
  {
    id: "ideaology",
    symbol: "idea",
    name: "Ideaology",
  },
  {
    id: "ideas",
    symbol: "ids",
    name: "IDEAS",
  },
  {
    id: "idefiyieldprotocol",
    symbol: "idyp",
    name: "iDeFiYieldProtocol",
  },
  {
    id: "idena",
    symbol: "idna",
    name: "Idena",
  },
  {
    id: "identity",
    symbol: "idtt",
    name: "Identity",
  },
  {
    id: "idexo-token",
    symbol: "ido",
    name: "Idexo",
  },
  {
    id: "idia",
    symbol: "idia",
    name: "Impossible Finance Launchpad",
  },
  {
    id: "idk",
    symbol: "idk",
    name: "IDK",
  },
  {
    id: "idle",
    symbol: "idle",
    name: "IDLE",
  },
  {
    id: "idle-cyber",
    symbol: "afk",
    name: "Idle Cyber",
  },
  {
    id: "idle-dai-risk-adjusted",
    symbol: "idledaisafe",
    name: "IdleDAI (Risk Adjusted)",
  },
  {
    id: "idle-dai-yield",
    symbol: "idledaiyield",
    name: "IdleDAI (Best Yield)",
  },
  {
    id: "idle-mystic",
    symbol: "mst",
    name: "Idle Mystic",
  },
  {
    id: "idle-mystic-token",
    symbol: "imt",
    name: "Infinite Metaverse",
  },
  {
    id: "idle-susd-yield",
    symbol: "idlesusdyield",
    name: "IdleSUSD (Yield)",
  },
  {
    id: "idle-token",
    symbol: "idle",
    name: "Idle Cyber Game",
  },
  {
    id: "idle-tusd-yield",
    symbol: "idletusdyield",
    name: "IdleTUSD (Best Yield)",
  },
  {
    id: "idle-usdc-risk-adjusted",
    symbol: "idleusdcsafe",
    name: "IdleUSDC (Risk Adjusted)",
  },
  {
    id: "idle-usdc-yield",
    symbol: "idleusdcyield",
    name: "IdleUSDC (Yield)",
  },
  {
    id: "idle-usdt-risk-adjusted",
    symbol: "idleusdtsafe",
    name: "IdleUSDT (Risk Adjusted)",
  },
  {
    id: "idle-usdt-yield",
    symbol: "idleusdtyield",
    name: "IdleUSDT (Yield)",
  },
  {
    id: "idle-wbtc-yield",
    symbol: "idlewbtcyield",
    name: "IdleWBTC (Best Yield)",
  },
  {
    id: "idm-token",
    symbol: "idm",
    name: "IDM Coop",
  },
  {
    id: "idol",
    symbol: "$idol",
    name: "IDOL",
  },
  {
    id: "idoscan",
    symbol: "idoscan",
    name: "Idoscan",
  },
  {
    id: "iethereum",
    symbol: "ieth",
    name: "iEthereum",
  },
  {
    id: "iexec-rlc",
    symbol: "rlc",
    name: "iExec RLC",
  },
  {
    id: "ifarm",
    symbol: "ifarm",
    name: "iFARM",
  },
  {
    id: "ifoswap-token",
    symbol: "h2o",
    name: "IFOSwap",
  },
  {
    id: "iftoken",
    symbol: "ift",
    name: "IFT",
  },
  {
    id: "ifx24",
    symbol: "ifx24",
    name: "IFX24",
  },
  {
    id: "ig-gold",
    symbol: "igg",
    name: "IG Gold",
  },
  {
    id: "ignis",
    symbol: "ignis",
    name: "Ignis",
  },
  {
    id: "ignition",
    symbol: "ic",
    name: "Ignition",
  },
  {
    id: "igtoken",
    symbol: "ig",
    name: "IGT",
  },
  {
    id: "iht-real-estate-protocol",
    symbol: "iht",
    name: "IHT Real Estate Protocol",
  },
  {
    id: "iinjaz",
    symbol: "ijz",
    name: "iinjaz",
  },
  {
    id: "ijascoin",
    symbol: "ijc",
    name: "IjasCoin",
  },
  {
    id: "ik-coin",
    symbol: "ikc",
    name: "iK Coin [OLD]",
  },
  {
    id: "ik-coin-2",
    symbol: "ikc",
    name: "iK Coin",
  },
  {
    id: "ikonic",
    symbol: "ikonic",
    name: "IKONIC",
  },
  {
    id: "ikura-token",
    symbol: "ikura",
    name: "Ikura",
  },
  {
    id: "ilcoin",
    symbol: "ilc",
    name: "ILCOIN",
  },
  {
    id: "illiquiddao",
    symbol: "jpegs",
    name: "IlliquidDAO",
  },
  {
    id: "illuvium",
    symbol: "ilv",
    name: "Illuvium",
  },
  {
    id: "illuvium-wormhole",
    symbol: "ilv",
    name: "Illuvium (Wormhole)",
  },
  {
    id: "ilus-coin",
    symbol: "ilus",
    name: "ILUS Coin",
  },
  {
    id: "imagecash",
    symbol: "imgc",
    name: "ImageCash",
  },
  {
    id: "imagecoin",
    symbol: "img",
    name: "ImageCoin",
  },
  {
    id: "imagictoken",
    symbol: "imagic",
    name: "iMagic",
  },
  {
    id: "ime-lab",
    symbol: "lime",
    name: "iMe Lab",
  },
  {
    id: "imminentverse",
    symbol: "imv",
    name: "ImminentVerse",
  },
  {
    id: "immortaldao",
    symbol: "immo",
    name: "ImmortalDAO",
  },
  {
    id: "immortl",
    symbol: "imrtl",
    name: "Immortl",
  },
  {
    id: "immutable",
    symbol: "dara",
    name: "Immutable",
  },
  {
    id: "immutable-x",
    symbol: "imx",
    name: "Immutable X",
  },
  {
    id: "imo",
    symbol: "imo",
    name: "IMO",
  },
  {
    id: "i-money-crypto",
    symbol: "imc",
    name: "i Money Crypto",
  },
  {
    id: "impactmarket",
    symbol: "pact",
    name: "impactMarket",
  },
  {
    id: "impactx",
    symbol: "impactx",
    name: "ImpactX",
  },
  {
    id: "impactxp",
    symbol: "impactxp",
    name: "ImpactXP",
  },
  {
    id: "imperial-obelisk",
    symbol: "imp",
    name: "Imperial Obelisk",
  },
  {
    id: "imperium-empires",
    symbol: "ime",
    name: "Imperium Empires",
  },
  {
    id: "impermax",
    symbol: "imx",
    name: "Impermax",
  },
  {
    id: "impleum",
    symbol: "impl",
    name: "Impleum",
  },
  {
    id: "impossible-finance",
    symbol: "if",
    name: "Impossible Finance",
  },
  {
    id: "impostors-blood",
    symbol: "blood",
    name: "Impostors Blood",
  },
  {
    id: "improved-bitcoin",
    symbol: "ibtc",
    name: "Improved Bitcoin",
  },
  {
    id: "impulse-by-fdr",
    symbol: "impulse",
    name: "Impulse By FDR",
  },
  {
    id: "impulseven",
    symbol: "i7",
    name: "ImpulseVen",
  },
  {
    id: "inari",
    symbol: "inari",
    name: "Inari",
  },
  {
    id: "incakoin",
    symbol: "nka",
    name: "IncaKoin",
  },
  {
    id: "incinerate",
    symbol: "fire",
    name: "Incinerate",
  },
  {
    id: "inci-token",
    symbol: "inci",
    name: "Inci",
  },
  {
    id: "incognito-2",
    symbol: "prv",
    name: "Incognito",
  },
  {
    id: "incoin",
    symbol: "in",
    name: "InCoin",
  },
  {
    id: "income",
    symbol: "income",
    name: "Income",
  },
  {
    id: "income-island",
    symbol: "income",
    name: "Income Island",
  },
  {
    id: "incooom-genesis",
    symbol: "cooom",
    name: "Incooom Genesis",
  },
  {
    id: "incooom-genesis-gold",
    symbol: "gcooom",
    name: "Incooom Genesis Gold",
  },
  {
    id: "incooom-genesis-psychedelic",
    symbol: "pcooom",
    name: "Incooom Genesis Psychedelic",
  },
  {
    id: "indahash",
    symbol: "idh",
    name: "indaHash",
  },
  {
    id: "index-chain",
    symbol: "idx",
    name: "Index Chain",
  },
  {
    id: "index-cooperative",
    symbol: "index",
    name: "Index Cooperative",
  },
  {
    id: "index-coop-eth-2x-flexible-leverage-index",
    symbol: "eth2x-fli-p",
    name: "Index Coop - ETH 2x Flexible Leverage Index (Polygon)",
  },
  {
    id: "index-coop-inverse-eth-flexible-leverage-index",
    symbol: "ieth-fli-p",
    name: "Index Coop - Inverse ETH Flexible Leverage Index",
  },
  {
    id: "index-coop-inverse-matic-flexible-leverage-index",
    symbol: "imatic-fli-p",
    name: "Index Coop - Inverse MATIC Flexible Leverage Index",
  },
  {
    id: "index-coop-matic-2x-flexible-leverage-index",
    symbol: "matic2x-fli-p",
    name: "Index Coop - MATIC 2x Flexible Leverage Index",
  },
  {
    id: "indexed-finance",
    symbol: "ndx",
    name: "Indexed Finance",
  },
  {
    id: "indian-shiba-inu",
    symbol: "indshib",
    name: "Indian Shiba Inu",
  },
  {
    id: "indigg",
    symbol: "indi",
    name: "IndiGG",
  },
  {
    id: "indorse",
    symbol: "ind",
    name: "Indorse",
  },
  {
    id: "infam",
    symbol: "inf",
    name: "Infam",
  },
  {
    id: "infbundle",
    symbol: "inf",
    name: "INFBUNDLE",
  },
  {
    id: "infchain",
    symbol: "inf",
    name: "InfChain",
  },
  {
    id: "infinitecoin",
    symbol: "ifc",
    name: "Infinitecoin",
  },
  {
    id: "infinitee",
    symbol: "inftee",
    name: "Infinitee",
  },
  {
    id: "infinite-ecosystem",
    symbol: "infinity",
    name: "Infinite Ecosystem",
  },
  {
    id: "infinite-fleet",
    symbol: "inf",
    name: "Infinite Fleet",
  },
  {
    id: "infinite-launch",
    symbol: "ila",
    name: "Infinite Launch",
  },
  {
    id: "infinite-ricks",
    symbol: "rick",
    name: "Infinite Ricks",
  },
  {
    id: "infinito",
    symbol: "inft",
    name: "Infinito",
  },
  {
    id: "infinitx",
    symbol: "inx",
    name: "InfinitX",
  },
  {
    id: "infinity-arena",
    symbol: "inaz",
    name: "Infinity Arena",
  },
  {
    id: "infinitycake",
    symbol: "incake",
    name: "InfinityCake",
  },
  {
    id: "infinitycash",
    symbol: "ifc",
    name: "InfinityCash",
  },
  {
    id: "infinity-dao",
    symbol: "ind",
    name: "Infinity DAO",
  },
  {
    id: "infinity-esaham",
    symbol: "infs",
    name: "Infinity Esaham",
  },
  {
    id: "infinity-eth",
    symbol: "ieth",
    name: "Infinity ETH",
  },
  {
    id: "infinity-finance",
    symbol: "8fi",
    name: "Infinity Finance",
  },
  {
    id: "infinity-game-nft",
    symbol: "ign",
    name: "Infinity Game NFT",
  },
  {
    id: "infinitygaming",
    symbol: "play",
    name: "InfinityGaming",
  },
  {
    id: "infinitypad",
    symbol: "infp",
    name: "InfinityPad",
  },
  {
    id: "infinity-pad",
    symbol: "ipad",
    name: "Infinity Pad",
  },
  {
    id: "infinity-protocol-bsc",
    symbol: "infinity",
    name: "Infinity Protocol BSC",
  },
  {
    id: "infinity-rocket-token",
    symbol: "irt",
    name: "Infinity Rocket",
  },
  {
    id: "infinity-skies",
    symbol: "isky",
    name: "Infinity Skies",
  },
  {
    id: "infinium",
    symbol: "inf",
    name: "Infinium",
  },
  {
    id: "inflation-adjusted-usds",
    symbol: "iusds",
    name: "Inflation Adjusted USDS",
  },
  {
    id: "inflationcoin",
    symbol: "iflt",
    name: "InflationCoin",
  },
  {
    id: "inflation-hedging-coin",
    symbol: "ihc",
    name: "Inflation Hedging Coin",
  },
  {
    id: "inflex-finance",
    symbol: "inflex",
    name: "Inflex Finance",
  },
  {
    id: "infliv",
    symbol: "ifv",
    name: "INFLIV",
  },
  {
    id: "influencer",
    symbol: "imi",
    name: "Influencer",
  },
  {
    id: "influencer-doge",
    symbol: "idoge",
    name: "Influencer Doge",
  },
  {
    id: "influencer-finance",
    symbol: "influence",
    name: "Influencer Finance",
  },
  {
    id: "influencers-of-the-metaverse",
    symbol: "iom",
    name: "Influencers of the Metaverse",
  },
  {
    id: "influencer-token",
    symbol: "inf",
    name: "INFLUENCER TOKEN",
  },
  {
    id: "influxcoin",
    symbol: "infx",
    name: "Influxcoin",
  },
  {
    id: "infomatix",
    symbol: "info",
    name: "Infomatix",
  },
  {
    id: "info-token",
    symbol: "info",
    name: "Kardia Info",
  },
  {
    id: "inft-platform",
    symbol: "inft",
    name: "iNFT",
  },
  {
    id: "inftspace",
    symbol: "ins",
    name: "iNFTspace",
  },
  {
    id: "inheritance-art",
    symbol: "iai",
    name: "inheritance Art",
  },
  {
    id: "injective-protocol",
    symbol: "inj",
    name: "Injective",
  },
  {
    id: "injeolmi",
    symbol: "wijm",
    name: "Wrapped Injeolmi",
  },
  {
    id: "ink",
    symbol: "ink",
    name: "Ink",
  },
  {
    id: "ink-fantom",
    symbol: "ink",
    name: "Ink Fantom",
  },
  {
    id: "ink-protocol",
    symbol: "xnk",
    name: "Ink Protocol",
  },
  {
    id: "inkz",
    symbol: "inkz",
    name: "INKz",
  },
  {
    id: "inlock-token",
    symbol: "ilk",
    name: "INLOCK",
  },
  {
    id: "inmediate",
    symbol: "dit",
    name: "Direct Insurance",
  },
  {
    id: "innova",
    symbol: "inn",
    name: "Innova",
  },
  {
    id: "innovaminex",
    symbol: "minx",
    name: "InnovaMinex",
  },
  {
    id: "innovation-blockchain-payment",
    symbol: "ibp",
    name: "Innovation Blockchain Payment",
  },
  {
    id: "innovative-bioresearch",
    symbol: "innbc",
    name: "Innovative Bioresearch Coin",
  },
  {
    id: "innovativebioresearchclassic",
    symbol: "innbcl",
    name: "InnovativeBioresearchClassic",
  },
  {
    id: "ino-coin",
    symbol: "ino",
    name: "Ino Coin",
  },
  {
    id: "inoovi",
    symbol: "ivi",
    name: "Inoovi",
  },
  {
    id: "inpoker",
    symbol: "inp",
    name: "InPoker",
  },
  {
    id: "inpulse-x",
    symbol: "ipx",
    name: "InpulseX",
  },
  {
    id: "ins3",
    symbol: "ins3",
    name: "INS3",
  },
  {
    id: "insanecoin",
    symbol: "insn",
    name: "INSaNe",
  },
  {
    id: "insight-protocol",
    symbol: "inx",
    name: "Insight Protocol",
  },
  {
    id: "insights-network",
    symbol: "instar",
    name: "INSTAR",
  },
  {
    id: "instadapp",
    symbol: "inst",
    name: "Instadapp",
  },
  {
    id: "instadapp-dai",
    symbol: "idai",
    name: "Instadapp DAI",
  },
  {
    id: "instadapp-eth",
    symbol: "ieth",
    name: "Instadapp ETH",
  },
  {
    id: "instadapp-usdc",
    symbol: "iusdc",
    name: "Instadapp USDC",
  },
  {
    id: "instadapp-wbtc",
    symbol: "iwbtc",
    name: "Instadapp WBTC",
  },
  {
    id: "instantxrp",
    symbol: "instantxrp",
    name: "InstantXRP",
  },
  {
    id: "instaraise",
    symbol: "insta",
    name: "Instaraise",
  },
  {
    id: "instinct",
    symbol: "instinct",
    name: "Instinct",
  },
  {
    id: "instrumental-finance",
    symbol: "strm",
    name: "Instrumental Finance",
  },
  {
    id: "insula",
    symbol: "isla",
    name: "Insula",
  },
  {
    id: "insurace",
    symbol: "insur",
    name: "InsurAce",
  },
  {
    id: "insure",
    symbol: "sure",
    name: "inSure DeFi",
  },
  {
    id: "insuredao",
    symbol: "insure",
    name: "InsureDAO",
  },
  {
    id: "insured-finance",
    symbol: "infi",
    name: "Insured Finance",
  },
  {
    id: "insurepal",
    symbol: "ipl",
    name: "InsurePal",
  },
  {
    id: "insureum",
    symbol: "isr",
    name: "Insureum",
  },
  {
    id: "insurex",
    symbol: "ixt",
    name: "iXledger",
  },
  {
    id: "integral",
    symbol: "itgr",
    name: "Integral",
  },
  {
    id: "integritee",
    symbol: "teer",
    name: "Integritee",
  },
  {
    id: "intelligent-investment-chain",
    symbol: "iic",
    name: "Intelligent Investment Chain",
  },
  {
    id: "intelligent-mining",
    symbol: "im",
    name: "Intelligent Mining",
  },
  {
    id: "intercoin",
    symbol: "itr",
    name: "Intercoin",
  },
  {
    id: "intercrone",
    symbol: "icr",
    name: "InterCrone",
  },
  {
    id: "interest-bearing-bitcoin",
    symbol: "ibbtc",
    name: "Interest Bearing Bitcoin",
  },
  {
    id: "interest-bearing-bitcoin-wormhole",
    symbol: "ibbtc",
    name: "Interest Bearing Bitcoin (Wormhole)",
  },
  {
    id: "interest-bearing-eth",
    symbol: "ibeth",
    name: "Interest Bearing ETH",
  },
  {
    id: "interest-compounding-eth-index",
    symbol: "iceth",
    name: "Interest Compounding ETH Index",
  },
  {
    id: "interfinex-bills",
    symbol: "ifex",
    name: "Interfinex Bills",
  },
  {
    id: "intergalactic-cockroach",
    symbol: "icc",
    name: "Intergalactic Cockroach",
  },
  {
    id: "interlude",
    symbol: "ish",
    name: "Interlude",
  },
  {
    id: "inter-milan-fan-token",
    symbol: "inter",
    name: "Inter Milan Fan Token",
  },
  {
    id: "international-blockchain-technology",
    symbol: "ibt",
    name: "International Blockchain Technology",
  },
  {
    id: "international-cryptox",
    symbol: "incx",
    name: "International CryptoX",
  },
  {
    id: "internet-computer",
    symbol: "icp",
    name: "Internet Computer",
  },
  {
    id: "internet-node-token",
    symbol: "int",
    name: "INTchain",
  },
  {
    id: "internet-of-energy-network",
    symbol: "ioen",
    name: "Internet of Energy Network",
  },
  {
    id: "internxt",
    symbol: "inxt",
    name: "Internxt",
  },
  {
    id: "intersola",
    symbol: "isola",
    name: "Intersola",
  },
  {
    id: "interstellar-domain-order",
    symbol: "ido",
    name: "Interstellar Domain Order",
  },
  {
    id: "intervalue",
    symbol: "inve",
    name: "InterValue",
  },
  {
    id: "intexcoin",
    symbol: "intx",
    name: "INTEXCOIN",
  },
  {
    id: "intucoin",
    symbol: "intu",
    name: "INTUCoin",
  },
  {
    id: "inubis",
    symbol: "inubis",
    name: "Inubis",
  },
  {
    id: "inugami",
    symbol: "inugami",
    name: "Inugami",
  },
  {
    id: "inu-jump-and-the-temple-of-shiba",
    symbol: "inujump",
    name: "Inu Jump and the Temple of Shiba",
  },
  {
    id: "inu-token",
    symbol: "inu",
    name: "INU",
  },
  {
    id: "inu-wars",
    symbol: "iwr",
    name: "Inu Wars",
  },
  {
    id: "inventoryclub",
    symbol: "vnt",
    name: "InventoryClub",
  },
  {
    id: "inverse-btc-flexible-leverage-index",
    symbol: "ibtc-fli-p",
    name: "Inverse BTC Flexible Leverage Index",
  },
  {
    id: "inverse-ethereum-volatility-index-token",
    symbol: "iethv",
    name: "Inverse Ethereum Volatility Index Token",
  },
  {
    id: "inverse-finance",
    symbol: "inv",
    name: "Inverse Finance",
  },
  {
    id: "investdex",
    symbol: "invest",
    name: "InvestDex",
  },
  {
    id: "investdigital",
    symbol: "idt",
    name: "InvestDigital",
  },
  {
    id: "investel",
    symbol: "investel",
    name: "Investel",
  },
  {
    id: "investin",
    symbol: "ivn",
    name: "Investin",
  },
  {
    id: "invest-like-stakeborg-index",
    symbol: "ilsi",
    name: "Invest Like Stakeborg Index",
  },
  {
    id: "invictus",
    symbol: "in",
    name: "Invictus",
  },
  {
    id: "invictus-capital-token",
    symbol: "icap",
    name: "Invictus Capital",
  },
  {
    id: "invictus-hyprion-fund",
    symbol: "ihf",
    name: "Invictus Hyperion Fund",
  },
  {
    id: "invi-token",
    symbol: "invi",
    name: "INVI",
  },
  {
    id: "invoice-coin",
    symbol: "ivc",
    name: "Invoice Coin",
  },
  {
    id: "invoke",
    symbol: "iv",
    name: "Invoker",
  },
  {
    id: "iobusd",
    symbol: "iobusd",
    name: "ioBUSD",
  },
  {
    id: "iocoin",
    symbol: "ioc",
    name: "I/O Coin",
  },
  {
    id: "ioeth",
    symbol: "ioeth",
    name: "ioETH",
  },
  {
    id: "ioex",
    symbol: "ioex",
    name: "ioeX",
  },
  {
    id: "ioi-token",
    symbol: "ioi",
    name: "IOI",
  },
  {
    id: "ion",
    symbol: "ion",
    name: "Ion",
  },
  {
    id: "ionchain-token",
    symbol: "ionc",
    name: "IONChain",
  },
  {
    id: "ionomy",
    symbol: "ion",
    name: "Ionomy",
  },
  {
    id: "iostoken",
    symbol: "iost",
    name: "IOST",
  },
  {
    id: "iota",
    symbol: "miota",
    name: "IOTA",
  },
  {
    id: "iot-chain",
    symbol: "itc",
    name: "IoT Chain",
  },
  {
    id: "ioten",
    symbol: "iotn",
    name: "IOTEN",
  },
  {
    id: "iotex",
    symbol: "iotx",
    name: "IoTeX",
  },
  {
    id: "iotexchart",
    symbol: "iotexchart",
    name: "Iotexchart",
  },
  {
    id: "iotexdoge",
    symbol: "iodoge",
    name: "IotexDoge",
  },
  {
    id: "iotex-monster-go",
    symbol: "mtgo",
    name: "Iotex Monster Go",
  },
  {
    id: "iotexpad",
    symbol: "tex",
    name: "IoTeXPad",
  },
  {
    id: "iotexshiba",
    symbol: "ioshib",
    name: "IoTexShiba",
  },
  {
    id: "iouni",
    symbol: "iouni",
    name: "ioUNI",
  },
  {
    id: "iousdc",
    symbol: "iousdc",
    name: "ioUSDC",
  },
  {
    id: "iousdt",
    symbol: "iousdt",
    name: "ioUSDT",
  },
  {
    id: "iowbtc",
    symbol: "iowbtc",
    name: "ioWBTC",
  },
  {
    id: "iown",
    symbol: "iown",
    name: "iOWN",
  },
  {
    id: "ipay",
    symbol: "ipay",
    name: "iPay",
  },
  {
    id: "ipse",
    symbol: "post",
    name: "IPSE",
  },
  {
    id: "ipulse",
    symbol: "pls",
    name: "iPulse",
  },
  {
    id: "ipverse",
    symbol: "ipv",
    name: "IPVERSE",
  },
  {
    id: "ipx-token",
    symbol: "ipx",
    name: "Tachyon Protocol",
  },
  {
    id: "iq-cash",
    symbol: "iq",
    name: "IQ.cash",
  },
  {
    id: "iqcoin",
    symbol: "iqcoin",
    name: "IQCoin",
  },
  {
    id: "iq-coin",
    symbol: "iqg",
    name: "IQ Coin",
  },
  {
    id: "iqeon",
    symbol: "iqn",
    name: "IQeon",
  },
  {
    id: "iqoniq",
    symbol: "iqq",
    name: "Iqoniq",
  },
  {
    id: "iq-protocol",
    symbol: "iqt",
    name: "IQ Protocol",
  },
  {
    id: "irena-green-energy",
    symbol: "irena",
    name: "IRENA Green Energy",
  },
  {
    id: "iridium",
    symbol: "ird",
    name: "Iridium",
  },
  {
    id: "iris-network",
    symbol: "iris",
    name: "IRISnet",
  },
  {
    id: "iris-token-2",
    symbol: "iris",
    name: "Iris",
  },
  {
    id: "iron-bank",
    symbol: "ib",
    name: "Iron Bank",
  },
  {
    id: "iron-bank-euro",
    symbol: "ibeur",
    name: "Iron Bank EURO",
  },
  {
    id: "iron-bsc",
    symbol: "iron",
    name: "Iron BSC",
  },
  {
    id: "iron-finance",
    symbol: "ice",
    name: "Iron Finance",
  },
  {
    id: "iron-stablecoin",
    symbol: "iron",
    name: "Iron",
  },
  {
    id: "iron-titanium-token",
    symbol: "titan",
    name: "IRON Titanium",
  },
  {
    id: "isalcoin",
    symbol: "isal",
    name: "Isalcoin",
  },
  {
    id: "isengard-nft-marketplace",
    symbol: "iset-84e55e",
    name: "Isengard NFT Marketplace",
  },
  {
    id: "ishares-msci-world-etf-tokenized-stock-defichain",
    symbol: "durth",
    name: "iShares MSCI World ETF Tokenized Stock Defichain",
  },
  {
    id: "isiklar-coin",
    symbol: "isikc",
    name: "Isiklar Coin",
  },
  {
    id: "islamicoin",
    symbol: "islami",
    name: "ISLAMICOIN",
  },
  {
    id: "island-boyz",
    symbol: "$islbyz",
    name: "Island Boyz",
  },
  {
    id: "islander",
    symbol: "isa",
    name: "Islander",
  },
  {
    id: "islandswap",
    symbol: "isl",
    name: "Islandswap",
  },
  {
    id: "isotopec",
    symbol: "iso",
    name: "IsotopeC",
  },
  {
    id: "ispolink",
    symbol: "isp",
    name: "Ispolink",
  },
  {
    id: "istanbul-basaksehir-fan-token",
    symbol: "ibfk",
    name: "İstanbul Başakşehir Fan Token",
  },
  {
    id: "istardust",
    symbol: "isdt",
    name: "Istardust",
  },
  {
    id: "istep",
    symbol: "istep",
    name: "iSTEP",
  },
  {
    id: "italian-lira",
    symbol: "itl",
    name: "Italian Lira",
  },
  {
    id: "italo",
    symbol: "xta",
    name: "Italo",
  },
  {
    id: "itam-games",
    symbol: "itam",
    name: "ITAM Games",
  },
  {
    id: "itc",
    symbol: "itc",
    name: "ITC",
  },
  {
    id: "iten",
    symbol: "iten",
    name: "ITEN",
  },
  {
    id: "iteration-syndicate",
    symbol: "its",
    name: "Iteration Syndicate",
  },
  {
    id: "itheum",
    symbol: "itheum",
    name: "Itheum",
  },
  {
    id: "iticoin",
    symbol: "iti",
    name: "iTicoin",
  },
  {
    id: "itrust-governance-token",
    symbol: "itg",
    name: "iTrust Governance",
  },
  {
    id: "itsmyne",
    symbol: "myne",
    name: "ITSMYNE",
  },
  {
    id: "its-not-art",
    symbol: "notart",
    name: "Its Not Art",
  },
  {
    id: "iungo",
    symbol: "ing",
    name: "Iungo",
  },
  {
    id: "iupixel",
    symbol: "pixel",
    name: "iUPixel",
  },
  {
    id: "ivogel",
    symbol: "ivg",
    name: "IVOGEL",
  },
  {
    id: "ivory",
    symbol: "ivory",
    name: "Ivory",
  },
  {
    id: "ixcoin",
    symbol: "ixc",
    name: "Ixcoin",
  },
  {
    id: "ixicash",
    symbol: "ixi",
    name: "IxiCash",
  },
  {
    id: "ixinium",
    symbol: "xxa",
    name: "Ixinium",
  },
  {
    id: "ixirswap",
    symbol: "ixir",
    name: "Ixirswap",
  },
  {
    id: "ixo",
    symbol: "ixo",
    name: "IXO",
  },
  {
    id: "ix-swap",
    symbol: "ixs",
    name: "IX Swap",
  },
  {
    id: "ix-token",
    symbol: "ixt",
    name: "IX",
  },
  {
    id: "izanagi",
    symbol: "nagi",
    name: "Izanagi",
  },
  {
    id: "ize",
    symbol: "ize",
    name: "IZE",
  },
  {
    id: "izumi-bond-usd",
    symbol: "iusd",
    name: "iZUMi Bond USD",
  },
  {
    id: "izumi-finance",
    symbol: "izi",
    name: "Izumi Finance",
  },
  {
    id: "j9casino",
    symbol: "j9bc",
    name: "J9CASINO",
  },
  {
    id: "jackpool-finance",
    symbol: "jfi",
    name: "JackPool.finance",
  },
  {
    id: "jackpot",
    symbol: "777",
    name: "Jackpot",
  },
  {
    id: "jackpot-token",
    symbol: "jpt",
    name: "Jackpot Token",
  },
  {
    id: "jack-token",
    symbol: "jack",
    name: "Jack Token",
  },
  {
    id: "jacy",
    symbol: "jacy",
    name: "JACY",
  },
  {
    id: "jade-currency",
    symbol: "jade",
    name: "Jade Currency",
  },
  {
    id: "jade-protocol",
    symbol: "jade",
    name: "Jade Protocol",
  },
  {
    id: "jaguarswap",
    symbol: "jaguar",
    name: "JaguarSwap",
  },
  {
    id: "jaiho-crypto",
    symbol: "jaiho",
    name: "Jaiho Crypto",
  },
  {
    id: "jamonswap",
    symbol: "jamon",
    name: "JamonSwap",
  },
  {
    id: "jarvis",
    symbol: "jar",
    name: "Jarvis+",
  },
  {
    id: "jarvis-reward-token",
    symbol: "jrt",
    name: "Jarvis Reward",
  },
  {
    id: "jarvis-synthetic-australian-dollar",
    symbol: "jaud",
    name: "Jarvis Synthetic Australian Dollar",
  },
  {
    id: "jarvis-synthetic-british-pound",
    symbol: "jgbp",
    name: "Jarvis Synthetic British Pound",
  },
  {
    id: "jarvis-synthetic-canadian-dollar",
    symbol: "jcad",
    name: "Jarvis Synthetic Canadian Dollar",
  },
  {
    id: "jarvis-synthetic-chinese-yuan",
    symbol: "jcny",
    name: "Jarvis Synthetic Chinese Yuan",
  },
  {
    id: "jarvis-synthetic-euro",
    symbol: "jeur",
    name: "Jarvis Synthetic Euro",
  },
  {
    id: "jarvis-synthetic-japanese-yen",
    symbol: "jjpy",
    name: "Jarvis Synthetic Japanese Yen",
  },
  {
    id: "jarvis-synthetic-singapore-dollar",
    symbol: "jsgd",
    name: "Jarvis Synthetic Singapore Dollar",
  },
  {
    id: "jarvis-synthetic-swedish-krona",
    symbol: "jsek",
    name: "Jarvis Synthetic Swedish Krona",
  },
  {
    id: "jarvis-synthetic-swiss-franc",
    symbol: "jchf",
    name: "Jarvis Synthetic Swiss Franc",
  },
  {
    id: "jasmycoin",
    symbol: "jasmy",
    name: "JasmyCoin",
  },
  {
    id: "javascript-token",
    symbol: "js",
    name: "JavaScript",
  },
  {
    id: "jax-network",
    symbol: "wjxn",
    name: "Jax.Network",
  },
  {
    id: "jd-coin",
    symbol: "jdc",
    name: "JD Coin",
  },
  {
    id: "jdi-token",
    symbol: "jdi",
    name: "JDI",
  },
  {
    id: "jedstar",
    symbol: "jed",
    name: "JEDSTAR",
  },
  {
    id: "jeet",
    symbol: "jeet",
    name: "JEET",
  },
  {
    id: "jefe",
    symbol: "jefe",
    name: "Jefe",
  },
  {
    id: "jejudoge",
    symbol: "jejudoge",
    name: "Jejudoge",
  },
  {
    id: "jejudoge-bsc",
    symbol: "jejudoge",
    name: "Jejudoge BSC",
  },
  {
    id: "jelly",
    symbol: "jelly",
    name: "Jelly",
  },
  {
    id: "jem",
    symbol: "jem",
    name: "Jem",
  },
  {
    id: "jenny-metaverse-dao-token",
    symbol: "ujenny",
    name: "Jenny Metaverse DAO",
  },
  {
    id: "jeritex",
    symbol: "jrit",
    name: "JERITEX",
  },
  {
    id: "jet",
    symbol: "jet",
    name: "JET",
  },
  {
    id: "jetcoin",
    symbol: "jet",
    name: "Jetcoin",
  },
  {
    id: "jetoken",
    symbol: "jets",
    name: "JeToken",
  },
  {
    id: "jetset",
    symbol: "jts",
    name: "Jetset",
  },
  {
    id: "jetswap-token",
    symbol: "wings",
    name: "JetSwap",
  },
  {
    id: "jewel",
    symbol: "jwl",
    name: "Jewel",
  },
  {
    id: "jfin-coin",
    symbol: "jfin",
    name: "JFIN Coin",
  },
  {
    id: "jigen",
    symbol: "jig",
    name: "Jigen",
  },
  {
    id: "jigsaw",
    symbol: "jigsaw",
    name: "Jigsaw",
  },
  {
    id: "jigstack",
    symbol: "stak",
    name: "Jigstack",
  },
  {
    id: "jindoge",
    symbol: "jindoge",
    name: "Jindoge",
  },
  {
    id: "jindo-inu",
    symbol: "jind",
    name: "Jindo Inu",
  },
  {
    id: "jk-coin",
    symbol: "jk",
    name: "JK Coin",
  },
  {
    id: "jmtime",
    symbol: "jmt",
    name: "JMTIME",
  },
  {
    id: "jobchain",
    symbol: "job",
    name: "Jobchain",
  },
  {
    id: "joe",
    symbol: "joe",
    name: "JOE",
  },
  {
    id: "joe-hat-token",
    symbol: "hat",
    name: "Joe Hat",
  },
  {
    id: "joe-wormhole",
    symbol: "joe",
    name: "JOE (Wormhole)",
  },
  {
    id: "joe-yo-coin",
    symbol: "jyc",
    name: "Joe-Yo Coin",
  },
  {
    id: "joincoin",
    symbol: "join",
    name: "JoinCoin",
  },
  {
    id: "joint",
    symbol: "joint",
    name: "Joint Ventures",
  },
  {
    id: "jointer",
    symbol: "jntr",
    name: "Jointer",
  },
  {
    id: "jojo",
    symbol: "jojo",
    name: "JOJO",
  },
  {
    id: "jojo-inu",
    symbol: "jojo",
    name: "JoJo Inu",
  },
  {
    id: "joke-community",
    symbol: "$joke",
    name: "Joke Community",
  },
  {
    id: "jokermanor-metaverse",
    symbol: "jkt",
    name: "JokerManor Metaverse",
  },
  {
    id: "jokes-meme",
    symbol: "joke",
    name: "Jokes Meme",
  },
  {
    id: "joltify",
    symbol: "jolt",
    name: "Joltify",
  },
  {
    id: "jomon-shiba",
    symbol: "jshiba",
    name: "Jomon Shiba",
  },
  {
    id: "jones-dao",
    symbol: "jones",
    name: "Jones DAO",
  },
  {
    id: "joorschain",
    symbol: "jic",
    name: "JoorsChain",
  },
  {
    id: "joos-protocol",
    symbol: "joos",
    name: "JOOS Protocol",
  },
  {
    id: "joulecoin",
    symbol: "xjo",
    name: "Joulecoin",
  },
  {
    id: "joys",
    symbol: "joys",
    name: "JOYS",
  },
  {
    id: "joystick-2",
    symbol: "joy",
    name: "Joystick",
  },
  {
    id: "joystream",
    symbol: "joy",
    name: "Joystream",
  },
  {
    id: "jpeg-d",
    symbol: "jpeg",
    name: "JPEG'd",
  },
  {
    id: "jpegvaultdao-2",
    symbol: "jpeg",
    name: "JPEGvaultDAO",
  },
  {
    id: "jpg-nft-index",
    symbol: "jpg",
    name: "JPG NFT Index",
  },
  {
    id: "jpool",
    symbol: "jsol",
    name: "JPool",
  },
  {
    id: "jpyc",
    symbol: "jpyc",
    name: "JPY Coin",
  },
  {
    id: "jsb-foundation",
    symbol: "jsb",
    name: "JSB Foundation",
  },
  {
    id: "jswap-finance",
    symbol: "jf",
    name: "Jswap.Finance",
  },
  {
    id: "jubi-token",
    symbol: "jt",
    name: "Jubi Token",
  },
  {
    id: "juggernaut",
    symbol: "jgn",
    name: "Juggernaut",
  },
  {
    id: "juicebox",
    symbol: "jbx",
    name: "Juicebox",
  },
  {
    id: "juice-coin",
    symbol: "juice",
    name: "Juice Coin",
  },
  {
    id: "julien",
    symbol: "julien",
    name: "JULIEN",
  },
  {
    id: "julswap",
    symbol: "juld",
    name: "JulSwap",
  },
  {
    id: "jumbo",
    symbol: "jub",
    name: "Jumbo",
  },
  {
    id: "jumbo-exchange",
    symbol: "jumbo",
    name: "Jumbo Exchange",
  },
  {
    id: "jumptoken",
    symbol: "jmpt",
    name: "JumpToken",
  },
  {
    id: "junca-cash",
    symbol: "jcc",
    name: "Junca cash",
  },
  {
    id: "jungle",
    symbol: "jungle",
    name: "Jungle",
  },
  {
    id: "jungle-defi",
    symbol: "jfi",
    name: "Jungle DeFi",
  },
  {
    id: "jungle-road",
    symbol: "jgrd",
    name: "Jungle Road",
  },
  {
    id: "jungle-token",
    symbol: "jungle",
    name: "Jungle Token",
  },
  {
    id: "junko-inu",
    symbol: "junkoinu",
    name: "Junko Inu",
  },
  {
    id: "juno-network",
    symbol: "juno",
    name: "JUNO",
  },
  {
    id: "junoswap-raw-dao",
    symbol: "raw",
    name: "JunoSwap Raw Dao",
  },
  {
    id: "junsonmingchancoin",
    symbol: "jmc",
    name: "Junsonmingchancoin",
  },
  {
    id: "jupiter",
    symbol: "jup",
    name: "Jupiter",
  },
  {
    id: "jur",
    symbol: "jur",
    name: "Jur",
  },
  {
    id: "jurasaur",
    symbol: "jrex",
    name: "Jurasaur",
  },
  {
    id: "jurassic_nodes",
    symbol: "dino",
    name: "Jurassic Nodes",
  },
  {
    id: "jurassic-token",
    symbol: "jrsc",
    name: "Jurassic",
  },
  {
    id: "just",
    symbol: "jst",
    name: "JUST",
  },
  {
    id: "justcarbon-governance",
    symbol: "jcg",
    name: "JustCarbon Governance",
  },
  {
    id: "justcarbon-removal",
    symbol: "jcr",
    name: "JustCarbon Removal",
  },
  {
    id: "justfarm",
    symbol: "jfm",
    name: "JustFarm",
  },
  {
    id: "justmoney-2",
    symbol: "jm",
    name: "JustMoney",
  },
  {
    id: "just-stablecoin",
    symbol: "usdj",
    name: "JUST Stablecoin",
  },
  {
    id: "justyours",
    symbol: "just",
    name: "JustYours",
  },
  {
    id: "juventus-fan-token",
    symbol: "juv",
    name: "Juventus Fan Token",
  },
  {
    id: "k21",
    symbol: "k21",
    name: "K21",
  },
  {
    id: "kaafila",
    symbol: "kfl",
    name: "Kaafila",
  },
  {
    id: "kabosu",
    symbol: "kabosu",
    name: "Kabosu",
  },
  {
    id: "kaby-arena",
    symbol: "kaby",
    name: "Kaby Arena",
  },
  {
    id: "kaby-gaming-token",
    symbol: "kgt",
    name: "Kaby Gaming",
  },
  {
    id: "kadena",
    symbol: "kda",
    name: "Kadena",
  },
  {
    id: "kagla-finance",
    symbol: "kgl",
    name: "Kagla Finance",
  },
  {
    id: "kaiba-defi",
    symbol: "kaiba",
    name: "Kaiba Defi",
  },
  {
    id: "kaidht",
    symbol: "kaidht",
    name: "Dog House",
  },
  {
    id: "kai-inu",
    symbol: "kaiinu",
    name: "Kai Inu",
  },
  {
    id: "kaiju-worlds",
    symbol: "kaiju",
    name: "Kaiju Worlds",
  },
  {
    id: "kaikeninu",
    symbol: "kaieco",
    name: "KaikenInu",
  },
  {
    id: "kaiken-shiba",
    symbol: "kshib",
    name: "Kaiken Shiba",
  },
  {
    id: "kainet",
    symbol: "kainet",
    name: "KAINET",
  },
  {
    id: "kaizen",
    symbol: "kzen",
    name: "Kaizen",
  },
  {
    id: "kaizilla",
    symbol: "kaizilla",
    name: "Kaizilla",
  },
  {
    id: "kaka-nft-world",
    symbol: "kaka",
    name: "KAKA NFT World",
  },
  {
    id: "kala",
    symbol: "kala",
    name: "Kala",
  },
  {
    id: "kala-finance",
    symbol: "kala",
    name: "Kala Finance",
  },
  {
    id: "kalamint",
    symbol: "kalam",
    name: "Kalamint",
  },
  {
    id: "kala-network",
    symbol: "klnw",
    name: "KALA Network",
  },
  {
    id: "kalao",
    symbol: "klo",
    name: "Kalao",
  },
  {
    id: "kalata",
    symbol: "kala",
    name: "Kalata Protocol",
  },
  {
    id: "kalera-nft",
    symbol: "kln",
    name: "Kalera NFT",
  },
  {
    id: "kalissa",
    symbol: "kali",
    name: "Kalissa",
  },
  {
    id: "kalisten",
    symbol: "ks",
    name: "Kalisten",
  },
  {
    id: "kalkicoin",
    symbol: "klc",
    name: "Kalkicoin",
  },
  {
    id: "kalmar",
    symbol: "kalm",
    name: "Kalmar",
  },
  {
    id: "kalori",
    symbol: "klr",
    name: "Kalori",
  },
  {
    id: "kambria",
    symbol: "kat",
    name: "Kambria",
  },
  {
    id: "kampay",
    symbol: "kampay",
    name: "Kampay",
  },
  {
    id: "kan",
    symbol: "kan",
    name: "BitKan",
  },
  {
    id: "kanaloa-network",
    symbol: "kana",
    name: "Kanaloa Network",
  },
  {
    id: "kandy",
    symbol: "kandy",
    name: "KANDY",
  },
  {
    id: "kang3n",
    symbol: "kang3n",
    name: "kang3n",
  },
  {
    id: "kanga-exchange",
    symbol: "kng",
    name: "Kanga Exchange",
  },
  {
    id: "kangal",
    symbol: "kangal",
    name: "Kangal",
  },
  {
    id: "kangaroo",
    symbol: "gar",
    name: "Kangaroo",
  },
  {
    id: "kangaroocake",
    symbol: "kcake",
    name: "KangarooCake",
  },
  {
    id: "kanpeki",
    symbol: "kae",
    name: "Kanpeki",
  },
  {
    id: "kappa",
    symbol: "kappa",
    name: "Kappa",
  },
  {
    id: "karaganda-token",
    symbol: "krg",
    name: "Karaganda Token",
  },
  {
    id: "karastar-kara",
    symbol: "kara",
    name: "KaraStar",
  },
  {
    id: "karastar-umy",
    symbol: "umy",
    name: "KaraStar UMY",
  },
  {
    id: "karbo",
    symbol: "krb",
    name: "Karbo",
  },
  {
    id: "kardiachain",
    symbol: "kai",
    name: "KardiaChain",
  },
  {
    id: "karencoin",
    symbol: "karen",
    name: "KarenCoin",
  },
  {
    id: "karmadao",
    symbol: "kdao",
    name: "KarmaDao",
  },
  {
    id: "karma-dao",
    symbol: "karma",
    name: "Karma DAO",
  },
  {
    id: "karmaverse",
    symbol: "knot",
    name: "Karmaverse",
  },
  {
    id: "karsiyaka-taraftar-token",
    symbol: "ksk",
    name: "Karsiyaka Taraftar Token",
  },
  {
    id: "kart-racing-league",
    symbol: "krl",
    name: "Kart Racing League",
  },
  {
    id: "karura",
    symbol: "kar",
    name: "Karura",
  },
  {
    id: "kashhcoin",
    symbol: "kashh",
    name: "Kashhcoin",
  },
  {
    id: "kaspa",
    symbol: "kas",
    name: "Kaspa",
  },
  {
    id: "kassandra",
    symbol: "kacy",
    name: "Kassandra",
  },
  {
    id: "kasta",
    symbol: "kasta",
    name: "Kasta",
  },
  {
    id: "katalyo",
    symbol: "ktlyo",
    name: "Katalyo",
  },
  {
    id: "katana-finance",
    symbol: "katana",
    name: "Katana Finance",
  },
  {
    id: "katana-inu",
    symbol: "kata",
    name: "Katana Inu",
  },
  {
    id: "katsumi",
    symbol: "katsumi",
    name: "Katsumi",
  },
  {
    id: "kattana",
    symbol: "ktn",
    name: "Kattana",
  },
  {
    id: "kauri",
    symbol: "kau",
    name: "Kauri",
  },
  {
    id: "kava",
    symbol: "kava",
    name: "Kava",
  },
  {
    id: "kava-lend",
    symbol: "hard",
    name: "Kava Lend",
  },
  {
    id: "kava-swap",
    symbol: "swp",
    name: "Kava Swap",
  },
  {
    id: "kawaii-islands",
    symbol: "kwt",
    name: "Kawaii Islands",
  },
  {
    id: "kawaiinu",
    symbol: "kawaii",
    name: "kawaiINU",
  },
  {
    id: "kawai-shiba",
    symbol: "kshiba",
    name: "Kawai Shiba",
  },
  {
    id: "kawakami",
    symbol: "kawa",
    name: "Kawakami",
  },
  {
    id: "kayserispor",
    symbol: "kysr",
    name: "Kayserispor",
  },
  {
    id: "kazama-senshi",
    symbol: "kazama",
    name: "Kazama Senshi",
  },
  {
    id: "kbn",
    symbol: "kbn",
    name: "Koban",
  },
  {
    id: "kcash",
    symbol: "kcash",
    name: "Kcash",
  },
  {
    id: "kcc-memepad",
    symbol: "kccm",
    name: "KCC MemePad",
  },
  {
    id: "kccpad",
    symbol: "kccpad",
    name: "KCCPad",
  },
  {
    id: "kdag",
    symbol: "kdag",
    name: "King DAG",
  },
  {
    id: "kebab-token",
    symbol: "kebab",
    name: "Kebab",
  },
  {
    id: "keep3rv1",
    symbol: "kp3r",
    name: "Keep3rV1",
  },
  {
    id: "keep3rv1-wormhole",
    symbol: "kp3r",
    name: "Keep3rV1 (Wormhole)",
  },
  {
    id: "keep4r",
    symbol: "kp4r",
    name: "Keep4r",
  },
  {
    id: "keep-network",
    symbol: "keep",
    name: "Keep Network",
  },
  {
    id: "keep-network-wormhole",
    symbol: "keep",
    name: "Keep Network (Wormhole)",
  },
  {
    id: "keeps-coin",
    symbol: "kpc",
    name: "KEEPs Coin",
  },
  {
    id: "keeshond",
    symbol: "$ksh",
    name: "Keeshond",
  },
  {
    id: "keiko",
    symbol: "keiko",
    name: "Keiko",
  },
  {
    id: "keisuke-inu",
    symbol: "$kei",
    name: "Keisuke Inu",
  },
  {
    id: "kekwcoin",
    symbol: "kekw",
    name: "Kekwcoin",
  },
  {
    id: "kelvpn",
    symbol: "kel",
    name: "KelVPN",
  },
  {
    id: "kemacoin",
    symbol: "kema",
    name: "KemaCoin",
  },
  {
    id: "kenshi",
    symbol: "kenshi",
    name: "Kenshi",
  },
  {
    id: "kephi-gallery",
    symbol: "kphi",
    name: "Kephi Gallery",
  },
  {
    id: "kepler452b",
    symbol: "452b",
    name: "Kepler452b",
  },
  {
    id: "kepler-network",
    symbol: "kmw",
    name: "Kepler Network",
  },
  {
    id: "kerman",
    symbol: "kerman",
    name: "KERMAN",
  },
  {
    id: "kermit",
    symbol: "kermit",
    name: "Kermit Finance",
  },
  {
    id: "kevacoin",
    symbol: "kva",
    name: "Kevacoin",
  },
  {
    id: "key",
    symbol: "key",
    name: "Key",
  },
  {
    id: "keyco",
    symbol: "kec",
    name: "Keyco",
  },
  {
    id: "keyfi",
    symbol: "keyfi",
    name: "KeyFi",
  },
  {
    id: "keysians-network",
    symbol: "ken",
    name: "Keysians Network",
  },
  {
    id: "keys-token",
    symbol: "keys",
    name: "Keys",
  },
  {
    id: "keyswap",
    symbol: "key",
    name: "KeySwap",
  },
  {
    id: "keytango",
    symbol: "tango",
    name: "keyTango",
  },
  {
    id: "kfan-token",
    symbol: "kfan",
    name: "KFan",
  },
  {
    id: "khalifa-finance",
    symbol: "khalifa",
    name: "Khalifa Finance",
  },
  {
    id: "khaos-finance",
    symbol: "khaos",
    name: "Khaos Finance",
  },
  {
    id: "ki",
    symbol: "xki",
    name: "KI",
  },
  {
    id: "kiba-inu",
    symbol: "kiba",
    name: "Kiba Inu",
  },
  {
    id: "kibastablecapital",
    symbol: "ksc",
    name: "KibaStableCapital",
  },
  {
    id: "kichicoin",
    symbol: "kich",
    name: "KichiCoin",
  },
  {
    id: "kick",
    symbol: "kick",
    name: "Kick",
  },
  {
    id: "kick-io",
    symbol: "kick",
    name: "KICK.IO",
  },
  {
    id: "kickpad",
    symbol: "kpad",
    name: "KickPad",
  },
  {
    id: "kiki",
    symbol: "kiki",
    name: "Kiki",
  },
  {
    id: "kiki-finance",
    symbol: "kiki",
    name: "Kiki Finance",
  },
  {
    id: "kikswap",
    symbol: "kik",
    name: "Kikswap",
  },
  {
    id: "kiku-inu",
    symbol: "kinu",
    name: "Kiku Inu",
  },
  {
    id: "killswitch",
    symbol: "ksw",
    name: "KillSwitch",
  },
  {
    id: "killthezero",
    symbol: "ktz",
    name: "KILLTHEZERO",
  },
  {
    id: "kiloample",
    symbol: "kmpl",
    name: "KiloAmple",
  },
  {
    id: "kilo-shiba-inu",
    symbol: "kshib",
    name: "Kilo Shiba Inu",
  },
  {
    id: "kilt-protocol",
    symbol: "kilt",
    name: "KILT Protocol",
  },
  {
    id: "kimchi-finance",
    symbol: "kimchi",
    name: "KIMCHI.finance",
  },
  {
    id: "kimex",
    symbol: "kmx",
    name: "KIMEX",
  },
  {
    id: "kimjongmoon",
    symbol: "kimj",
    name: "KimJongMoon",
  },
  {
    id: "kin",
    symbol: "kin",
    name: "Kin",
  },
  {
    id: "kind-ads-token",
    symbol: "kind",
    name: "Kind Ads",
  },
  {
    id: "kindcow-finance",
    symbol: "kind",
    name: "Kindcow Finance",
  },
  {
    id: "kindness-for-soul",
    symbol: "kfs g",
    name: "Kindness For Soul",
  },
  {
    id: "kineko",
    symbol: "kko",
    name: "Kineko",
  },
  {
    id: "kine-protocol",
    symbol: "kine",
    name: "Kine Protocol",
  },
  {
    id: "kinetic-money",
    symbol: "kntc",
    name: "Kinetic Money",
  },
  {
    id: "kinetic-synthetic-ust",
    symbol: "kust",
    name: "Kinetic Synthetic UST",
  },
  {
    id: "king-arthur",
    symbol: "bking",
    name: "King Arthur",
  },
  {
    id: "kingdoge",
    symbol: "kdoge",
    name: "KingDoge",
  },
  {
    id: "kingdoge-token",
    symbol: "kingdoge",
    name: "KingDoge Token",
  },
  {
    id: "king-dog-inu",
    symbol: "kingdog",
    name: "King Dog Inu",
  },
  {
    id: "kingdom-clash",
    symbol: "kct",
    name: "Kingdom Clash",
  },
  {
    id: "kingdom-game-4-0",
    symbol: "kdg",
    name: "Kingdom Game 4.0",
  },
  {
    id: "kingdom-karnage",
    symbol: "kkt",
    name: "Kingdom Karnage",
  },
  {
    id: "kingdom-quest",
    symbol: "kgc",
    name: "Kingdom Quest",
  },
  {
    id: "kingdomswap",
    symbol: "ks",
    name: "Kingdomswap [OLD]",
  },
  {
    id: "kingdomswap-2",
    symbol: "ks2",
    name: "Kingdom Swap 2.0",
  },
  {
    id: "kingdomx",
    symbol: "kt",
    name: "KingdomX",
  },
  {
    id: "king-finance",
    symbol: "king",
    name: "King Finance",
  },
  {
    id: "king-forever",
    symbol: "kfr",
    name: "KING FOREVER",
  },
  {
    id: "king-money",
    symbol: "kim",
    name: "King Money",
  },
  {
    id: "king-of-planets",
    symbol: "kop",
    name: "King of Planets",
  },
  {
    id: "king-of-shiba",
    symbol: "kingshiba",
    name: "King of Shiba",
  },
  {
    id: "kingpad",
    symbol: "crown",
    name: "KingPad",
  },
  {
    id: "king-rooster",
    symbol: "krc",
    name: "King Rooster",
  },
  {
    id: "king-samo",
    symbol: "ksamo",
    name: "King Samo",
  },
  {
    id: "king-share",
    symbol: "kshare",
    name: "KING Share",
  },
  {
    id: "king-shiba",
    symbol: "kingshib",
    name: "King Shiba",
  },
  {
    id: "kingspeed",
    symbol: "ksc",
    name: "KingSpeed",
  },
  {
    id: "king-swap",
    symbol: "$king",
    name: "King Swap",
  },
  {
    id: "kingtama",
    symbol: "kingtama",
    name: "Kingtama",
  },
  {
    id: "kingxchain",
    symbol: "kxc",
    name: "KingXChain",
  },
  {
    id: "kino",
    symbol: "kino",
    name: "Kino",
  },
  {
    id: "kintaman",
    symbol: "kinta",
    name: "Kintaman",
  },
  {
    id: "kintsugi",
    symbol: "kint",
    name: "Kintsugi",
  },
  {
    id: "kintsugi-btc",
    symbol: "kbtc",
    name: "Kintsugi BTC",
  },
  {
    id: "kiradoge-coin",
    symbol: "kiradoge",
    name: "Kiradoge",
  },
  {
    id: "kira-network",
    symbol: "kex",
    name: "KIRA Network",
  },
  {
    id: "kirobo",
    symbol: "kiro",
    name: "Kirobo",
  },
  {
    id: "kishimoto-inu",
    symbol: "kishimoto",
    name: "Kishimoto Inu",
  },
  {
    id: "kishu-baby",
    symbol: "kishubaby",
    name: "Kishu Baby",
  },
  {
    id: "kishu-inu",
    symbol: "kishu",
    name: "Kishu Inu",
  },
  {
    id: "kishutama",
    symbol: "kishutama",
    name: "Kishutama",
  },
  {
    id: "kissmymoon",
    symbol: "kissmymoon",
    name: "KissMyMoon",
  },
  {
    id: "kitcoin",
    symbol: "ktc",
    name: "Kitcoin",
  },
  {
    id: "kite-sync",
    symbol: "kite",
    name: "Kite Sync",
  },
  {
    id: "kitsumon",
    symbol: "$kmc",
    name: "Kitsumon",
  },
  {
    id: "kitten-coin",
    symbol: "kittens",
    name: "Kitten Coin",
  },
  {
    id: "kittenfinance",
    symbol: "kif",
    name: "KittenFinance",
  },
  {
    id: "kittens-puppies",
    symbol: "kap",
    name: "Kittens & Puppies",
  },
  {
    id: "kitty",
    symbol: "kit",
    name: "Kitty",
  },
  {
    id: "kittycake",
    symbol: "kcake",
    name: "KittyCake",
  },
  {
    id: "kittycoin",
    symbol: "kitty",
    name: "Kitty Coin",
  },
  {
    id: "kitty-coin-solana",
    symbol: "kitty",
    name: "Kitty Coin Solana",
  },
  {
    id: "kitty-finance",
    symbol: "kitty",
    name: "Kitty Finance",
  },
  {
    id: "kitty-inu",
    symbol: "kitty",
    name: "Kitty Inu",
  },
  {
    id: "kitty-ninja",
    symbol: "kinja",
    name: "Kitty Ninja",
  },
  {
    id: "kitty-solana",
    symbol: "kitty",
    name: "Kitty Solana",
  },
  {
    id: "kiwigo",
    symbol: "kgo",
    name: "Kiwigo",
  },
  {
    id: "kiwi-token",
    symbol: "kiwi",
    name: "KIWI Token",
  },
  {
    id: "klaycity-lay007",
    symbol: "lay",
    name: "KlayCity Lay007",
  },
  {
    id: "klaycity-orb",
    symbol: "orb",
    name: "KlayCity ORB",
  },
  {
    id: "klayfi-finance",
    symbol: "kfi",
    name: "KlayFi Finance",
  },
  {
    id: "klaymeta",
    symbol: "meta",
    name: "Klaymeta",
  },
  {
    id: "klaymore-stakehouse",
    symbol: "house",
    name: "Klaymore Stakehouse",
  },
  {
    id: "klayswap-protocol",
    symbol: "ksp",
    name: "KlaySwap Protocol",
  },
  {
    id: "klay-token",
    symbol: "klay",
    name: "Klaytn",
  },
  {
    id: "klear-finance",
    symbol: "klear",
    name: "Klear Finance",
  },
  {
    id: "kleekai",
    symbol: "klee",
    name: "KleeKai",
  },
  {
    id: "klend",
    symbol: "klt",
    name: "KLend",
  },
  {
    id: "kleros",
    symbol: "pnk",
    name: "Kleros",
  },
  {
    id: "klever",
    symbol: "klv",
    name: "Klever",
  },
  {
    id: "klever-finance",
    symbol: "kfi",
    name: "Klever Finance",
  },
  {
    id: "klima-dao",
    symbol: "klima",
    name: "Klima DAO",
  },
  {
    id: "klimatas",
    symbol: "kts",
    name: "Klimatas",
  },
  {
    id: "kling",
    symbol: "kling",
    name: "Kling",
  },
  {
    id: "klist-protocol",
    symbol: "list",
    name: "KList Protocol",
  },
  {
    id: "kmushicoin",
    symbol: "ktv",
    name: "Kmushicoin",
  },
  {
    id: "knekted",
    symbol: "knt",
    name: "Knekted",
  },
  {
    id: "knights-of-fantom",
    symbol: "knights",
    name: "Knights of Fantom",
  },
  {
    id: "knights-peasants",
    symbol: "knight",
    name: "Knights & Peasants",
  },
  {
    id: "knightswap",
    symbol: "knight",
    name: "KnightSwap",
  },
  {
    id: "knight-war-spirits",
    symbol: "kws",
    name: "Knight War Spirits",
  },
  {
    id: "knit-finance",
    symbol: "kft",
    name: "Knit Finance",
  },
  {
    id: "know-your-developer",
    symbol: "kydc",
    name: "Know Your Developer",
  },
  {
    id: "knoxedge",
    symbol: "knx",
    name: "KnoxEdge",
  },
  {
    id: "knoxfs",
    symbol: "kfx",
    name: "KnoxFS",
  },
  {
    id: "koakombat",
    symbol: "koacombat",
    name: "KoaKombat",
  },
  {
    id: "koala-token",
    symbol: "mkoala",
    name: "Koala",
  },
  {
    id: "kobocoin",
    symbol: "kobo",
    name: "Kobocoin",
  },
  {
    id: "koda-finance",
    symbol: "koda",
    name: "Koda Cryptocurrency",
  },
  {
    id: "kodi",
    symbol: "kodi",
    name: "KODI",
  },
  {
    id: "koel-coin",
    symbol: "koel",
    name: "Koel Coin",
  },
  {
    id: "kogecoin",
    symbol: "kogecoin",
    name: "KogeCoin",
  },
  {
    id: "koinon",
    symbol: "koin",
    name: "Koinon",
  },
  {
    id: "koinos",
    symbol: "koin",
    name: "Koinos",
  },
  {
    id: "koisan",
    symbol: "kic",
    name: "Koisan",
  },
  {
    id: "koji",
    symbol: "koji",
    name: "Koji",
  },
  {
    id: "kok",
    symbol: "kok",
    name: "KOK",
  },
  {
    id: "koka-inu",
    symbol: "inu",
    name: "KOKA INU",
  },
  {
    id: "kokoa-finance",
    symbol: "kokoa",
    name: "Kokoa Finance",
  },
  {
    id: "kokoa-stable-dollar",
    symbol: "ksd",
    name: "Kokoa Stable Dollar",
  },
  {
    id: "kokoswap",
    symbol: "koko",
    name: "KokoSwap",
  },
  {
    id: "kolibri-dao",
    symbol: "kdao",
    name: "Kolibri DAO",
  },
  {
    id: "kollect",
    symbol: "kol",
    name: "Kollect",
  },
  {
    id: "kollector",
    symbol: "kltr",
    name: "Kollector",
  },
  {
    id: "kolo-market",
    symbol: "kolo",
    name: "Kolo.Market",
  },
  {
    id: "kols-offering-token",
    symbol: "kot",
    name: "Kols Offering",
  },
  {
    id: "kombai-inu",
    symbol: "kombai",
    name: "Kombai Inu",
  },
  {
    id: "komet",
    symbol: "komet",
    name: "Komet",
  },
  {
    id: "kommunitas",
    symbol: "kom",
    name: "Kommunitas",
  },
  {
    id: "komodo",
    symbol: "kmd",
    name: "Komodo",
  },
  {
    id: "kompete",
    symbol: "kompete",
    name: "Kompete",
  },
  {
    id: "kondux",
    symbol: "kndx",
    name: "Kondux",
  },
  {
    id: "kongtama",
    symbol: "kongtama",
    name: "Kongtama",
  },
  {
    id: "konjungate",
    symbol: "konj",
    name: "KONJUNGATE",
  },
  {
    id: "konnect",
    symbol: "kct",
    name: "Konnect",
  },
  {
    id: "konomi-network",
    symbol: "kono",
    name: "Konomi Network",
  },
  {
    id: "konstrukt",
    symbol: "kst",
    name: "Konstrukt",
  },
  {
    id: "koraplay",
    symbol: "kplay",
    name: "Koraplay",
  },
  {
    id: "koreadoge",
    symbol: "kdoge",
    name: "Koreadoge",
  },
  {
    id: "kori-inu",
    symbol: "kori",
    name: "Kori Inu",
  },
  {
    id: "koromaru",
    symbol: "koromaru",
    name: "KOROMARU",
  },
  {
    id: "korss-chain-launchpad",
    symbol: "kclp",
    name: "Kross Chain Launchpad",
  },
  {
    id: "koto",
    symbol: "koto",
    name: "Koto",
  },
  {
    id: "kounotori",
    symbol: "kto",
    name: "Kounotori",
  },
  {
    id: "koyo",
    symbol: "kyo",
    name: "Kōyō",
  },
  {
    id: "kpop-coin",
    symbol: "kpop",
    name: "KPOP Coin",
  },
  {
    id: "kragger-inu",
    symbol: "kinu",
    name: "Kragger Inu",
  },
  {
    id: "kranz-token",
    symbol: "krz",
    name: "Kranz",
  },
  {
    id: "krause",
    symbol: "$krause",
    name: "KRAUSE",
  },
  {
    id: "kred",
    symbol: "kred",
    name: "KRED",
  },
  {
    id: "krida-fans",
    symbol: "krida",
    name: "Krida Fans",
  },
  {
    id: "krigger",
    symbol: "krigger",
    name: "Krigger",
  },
  {
    id: "krill",
    symbol: "krill",
    name: "Krill",
  },
  {
    id: "krios",
    symbol: "gig",
    name: "Krios",
  },
  {
    id: "kripto",
    symbol: "kripto",
    name: "Kripto",
  },
  {
    id: "kripto-galaxy-battle",
    symbol: "kaba",
    name: "Kripto Galaxy Battle",
  },
  {
    id: "kromatika",
    symbol: "krom",
    name: "Kromatika",
  },
  {
    id: "kronn",
    symbol: "krex",
    name: "Kronn",
  },
  {
    id: "kronobit",
    symbol: "knb",
    name: "Kronobit",
  },
  {
    id: "kronosdao",
    symbol: "kronos",
    name: "KronosDao",
  },
  {
    id: "kronos-dao",
    symbol: "krno",
    name: "Kronos Dao",
  },
  {
    id: "krook-coin",
    symbol: "krook",
    name: "Krook Coin",
  },
  {
    id: "k-root-wallet",
    symbol: "kroot",
    name: "K-Root Wallet",
  },
  {
    id: "krown",
    symbol: "krw",
    name: "KROWN",
  },
  {
    id: "kryll",
    symbol: "krl",
    name: "KRYLL",
  },
  {
    id: "kryptobellion",
    symbol: "krypto",
    name: "Kryptobellion",
  },
  {
    id: "krypto-kitty",
    symbol: "kty",
    name: "Krypto Kitty",
  },
  {
    id: "kryptomon",
    symbol: "kmon",
    name: "Kryptomon",
  },
  {
    id: "krypton-dao",
    symbol: "krd",
    name: "Krypton DAO",
  },
  {
    id: "krypton-token",
    symbol: "kgc",
    name: "Krypton Galaxy Coin",
  },
  {
    id: "kryptopets",
    symbol: "kpets",
    name: "KryptoPets",
  },
  {
    id: "kryxivia-game",
    symbol: "kxa",
    name: "Kryxivia Game",
  },
  {
    id: "kryza-exchange",
    symbol: "krx",
    name: "KRYZA Exchange",
  },
  {
    id: "kryza-network",
    symbol: "krn",
    name: "KRYZA Network",
  },
  {
    id: "ksm-starter",
    symbol: "kst",
    name: "Karus Starter",
  },
  {
    id: "kstarcoin",
    symbol: "ksc",
    name: "KStarCoin",
  },
  {
    id: "k-tune",
    symbol: "ktt",
    name: "K-Tune",
  },
  {
    id: "kuaitoken",
    symbol: "kt",
    name: "Kuai",
  },
  {
    id: "kuber-finance",
    symbol: "kft",
    name: "Kuber Finance",
  },
  {
    id: "kubic",
    symbol: "kubic",
    name: "Kubic",
  },
  {
    id: "kucoin-shares",
    symbol: "kcs",
    name: "KuCoin",
  },
  {
    id: "kudoge",
    symbol: "kudo",
    name: "KuDoge",
  },
  {
    id: "kuende",
    symbol: "kue",
    name: "Kuende",
  },
  {
    id: "kujira",
    symbol: "kuji",
    name: "Kujira",
  },
  {
    id: "kuky-star",
    symbol: "kuky",
    name: "Kuky Star",
  },
  {
    id: "kulupu",
    symbol: "klp",
    name: "Kulupu",
  },
  {
    id: "kuma-inu",
    symbol: "kuma",
    name: "Kuma Inu",
  },
  {
    id: "kunaiinu",
    symbol: "kunai",
    name: "KunaiInu",
  },
  {
    id: "kunci-coin",
    symbol: "kunci",
    name: "Kunci Coin",
  },
  {
    id: "kunoichix",
    symbol: "kuno",
    name: "KunoichiX",
  },
  {
    id: "kurai-inu",
    symbol: "kurai",
    name: "Kurai Inu",
  },
  {
    id: "kuramainu",
    symbol: "kunu",
    name: "KuramaInu",
  },
  {
    id: "kurobi",
    symbol: "kuro",
    name: "Kurobi",
  },
  {
    id: "kuro-shiba",
    symbol: "kuro",
    name: "Kuro Shiba",
  },
  {
    id: "kurrent",
    symbol: "kurt",
    name: "Kurrent",
  },
  {
    id: "kusama",
    symbol: "ksm",
    name: "Kusama",
  },
  {
    id: "kusd-t",
    symbol: "kusd-t",
    name: "KUSD-T",
  },
  {
    id: "kush-finance",
    symbol: "kseed",
    name: "Kush Finance",
  },
  {
    id: "kusunoki-samurai",
    symbol: "kusunoki",
    name: "Kusunoki Samurai",
  },
  {
    id: "kuswap",
    symbol: "kus",
    name: "KuSwap",
  },
  {
    id: "kuverit",
    symbol: "kuv",
    name: "Kuverit",
  },
  {
    id: "kwiktrust",
    symbol: "ktx",
    name: "KwikTrust",
  },
  {
    id: "kyanite",
    symbol: "kyan",
    name: "Kyanite",
  },
  {
    id: "kyberdyne",
    symbol: "kbd",
    name: "Kyberdyne",
  },
  {
    id: "kyber-network",
    symbol: "kncl",
    name: "Kyber Network Crystal Legacy",
  },
  {
    id: "kyber-network-crystal",
    symbol: "knc",
    name: "Kyber Network Crystal",
  },
  {
    id: "kyccoin",
    symbol: "kycc",
    name: "KYCCOIN",
  },
  {
    id: "kylin-network",
    symbol: "kyl",
    name: "Kylin Network",
  },
  {
    id: "kyoko",
    symbol: "kyoko",
    name: "Kyoko",
  },
  {
    id: "kyrrex",
    symbol: "krrx",
    name: "Kyrrex",
  },
  {
    id: "kyte-one",
    symbol: "kte",
    name: "Kyte.One",
  },
  {
    id: "kzcash",
    symbol: "kzc",
    name: "Kzcash",
  },
  {
    id: "l2pad",
    symbol: "l2pad",
    name: "L2PAD",
  },
  {
    id: "label-foundation",
    symbol: "lbl",
    name: "LABEL Foundation",
  },
  {
    id: "labracoin",
    symbol: "labra",
    name: "LabraCoin",
  },
  {
    id: "labs-group",
    symbol: "labs",
    name: "LABS Group",
  },
  {
    id: "la-casa-de-papel",
    symbol: "lcdp",
    name: "La Casa De Papel",
  },
  {
    id: "laconic-network-token",
    symbol: "lnt",
    name: "Laconic Network",
  },
  {
    id: "lacucina",
    symbol: "lac",
    name: "LaCucina",
  },
  {
    id: "laddercaster",
    symbol: "lada",
    name: "LadderCaster",
  },
  {
    id: "la-doge-de-papel",
    symbol: "lddp",
    name: "La Doge de Papel",
  },
  {
    id: "ladyminers",
    symbol: "yttrium",
    name: "Ladyminers",
  },
  {
    id: "lady-uni",
    symbol: "luni",
    name: "Lady Uni",
  },
  {
    id: "ladz",
    symbol: "ladz",
    name: "LADZ",
  },
  {
    id: "laikacoin",
    symbol: "laika",
    name: "LaikaCoin",
  },
  {
    id: "laika-protocol",
    symbol: "laika",
    name: "Laika Protocol",
  },
  {
    id: "lambda",
    symbol: "lamb",
    name: "Lambda",
  },
  {
    id: "lambo",
    symbol: "lambo",
    name: "Lambo",
  },
  {
    id: "lamden",
    symbol: "tau",
    name: "Lamden",
  },
  {
    id: "lanacoin",
    symbol: "lana",
    name: "LanaCoin",
  },
  {
    id: "lanceria",
    symbol: "lanc",
    name: "Lanceria",
  },
  {
    id: "land-of-realm",
    symbol: "lor",
    name: "Land of Realm",
  },
  {
    id: "landorc",
    symbol: "lorc",
    name: "LandOrc",
  },
  {
    id: "landshare",
    symbol: "land",
    name: "Landshare",
  },
  {
    id: "landverse",
    symbol: "lvmh",
    name: "Landverse",
  },
  {
    id: "landworld",
    symbol: "lwd",
    name: "Landworld",
  },
  {
    id: "la-peseta",
    symbol: "pta",
    name: "La Peseta",
  },
  {
    id: "laqira-protocol",
    symbol: "lqr",
    name: "Laqira Protocol",
  },
  {
    id: "largo-coin",
    symbol: "lrg",
    name: "Largo Coin",
  },
  {
    id: "larix",
    symbol: "larix",
    name: "Larix",
  },
  {
    id: "lasereyes",
    symbol: "lsr",
    name: "LaserEyes",
  },
  {
    id: "laser-eyes",
    symbol: "lasereyes",
    name: "Laser Eyes",
  },
  {
    id: "lassocoin",
    symbol: "lasso",
    name: "LassoCoin",
  },
  {
    id: "last-survivor",
    symbol: "lsc",
    name: "Last Survivor",
  },
  {
    id: "latamcash",
    symbol: "lmch",
    name: "Latamcash",
  },
  {
    id: "latiumx",
    symbol: "latx",
    name: "LatiumX",
  },
  {
    id: "latoken",
    symbol: "la",
    name: "LA",
  },
  {
    id: "latteswap",
    symbol: "latte",
    name: "LatteSwap",
  },
  {
    id: "lattice-token",
    symbol: "ltx",
    name: "Lattice",
  },
  {
    id: "launchblock",
    symbol: "lbp",
    name: "LaunchBlock",
  },
  {
    id: "launchmynft",
    symbol: "mynft",
    name: "LaunchMyNFT",
  },
  {
    id: "launchpool",
    symbol: "lpool",
    name: "Launchpool",
  },
  {
    id: "launchwall",
    symbol: "wall",
    name: "LaunchWall",
  },
  {
    id: "launchzone",
    symbol: "lz",
    name: "LaunchZone",
  },
  {
    id: "laurus-coin",
    symbol: "lscn",
    name: "Laurus Coin",
  },
  {
    id: "lavacake-finance",
    symbol: "lava",
    name: "LavaCake Finance",
  },
  {
    id: "lavaswap",
    symbol: "lava",
    name: "Lavaswap",
  },
  {
    id: "lavax-labs",
    symbol: "lavax",
    name: "LavaX Labs",
  },
  {
    id: "law",
    symbol: "law",
    name: "LAW",
  },
  {
    id: "law-token",
    symbol: "law",
    name: "Law Token",
  },
  {
    id: "layer2dao",
    symbol: "l2dao",
    name: "Layer2DAO",
  },
  {
    id: "lazio-fan-token",
    symbol: "lazio",
    name: "Lazio Fan Token",
  },
  {
    id: "lazydoge",
    symbol: "lazydoge",
    name: "LazyDoge",
  },
  {
    id: "lazy-horse-race-club",
    symbol: "lhrc",
    name: "Lazy Horse Race Club",
  },
  {
    id: "lazymint",
    symbol: "lazy",
    name: "LazyMint",
  },
  {
    id: "lazy-shiba",
    symbol: "lazyshiba",
    name: "Lazy Shiba",
  },
  {
    id: "lbk",
    symbol: "lbk",
    name: "LBK",
  },
  {
    id: "lbry-credits",
    symbol: "lbc",
    name: "LBRY Credits",
  },
  {
    id: "lcg",
    symbol: "lcg",
    name: "LCG",
  },
  {
    id: "lcms",
    symbol: "lcms",
    name: "LCMS",
  },
  {
    id: "lcx",
    symbol: "lcx",
    name: "LCX",
  },
  {
    id: "lead-token",
    symbol: "lead",
    name: "Lead",
  },
  {
    id: "leafcoin",
    symbol: "leaf",
    name: "Leafcoin",
  },
  {
    id: "leaguedao-governance-token",
    symbol: "leag",
    name: "LeagueDAO Governance",
  },
  {
    id: "league-of-ancients",
    symbol: "loa",
    name: "League of Ancients",
  },
  {
    id: "league-of-empires",
    symbol: "loe",
    name: "League of Empires",
  },
  {
    id: "league-of-kingdoms",
    symbol: "loka",
    name: "League of Kingdoms",
  },
  {
    id: "league-of-zodiacs",
    symbol: "loz",
    name: "League of Zodiacs",
  },
  {
    id: "lean",
    symbol: "lean",
    name: "Lean",
  },
  {
    id: "lean-management-token",
    symbol: "lean",
    name: "Lean Management",
  },
  {
    id: "leapableio",
    symbol: "lea",
    name: "LeapableIO",
  },
  {
    id: "learning-cash",
    symbol: "ead",
    name: "Learning Cash",
  },
  {
    id: "leasehold",
    symbol: "lsh",
    name: "Leasehold",
  },
  {
    id: "leash",
    symbol: "leash",
    name: "Doge Killer",
  },
  {
    id: "le-caliente",
    symbol: "lecliente",
    name: "LE CALIENTE",
  },
  {
    id: "ledgerscore",
    symbol: "led",
    name: "LedgerScore",
  },
  {
    id: "ledgis",
    symbol: "led",
    name: "Ledgis",
  },
  {
    id: "ledgity",
    symbol: "lty",
    name: "Ledgity",
  },
  {
    id: "leeds-united-fan-token",
    symbol: "lufc",
    name: "Leeds United Fan Token",
  },
  {
    id: "leek-token",
    symbol: "leek",
    name: "Leek",
  },
  {
    id: "legal-block",
    symbol: "lbk",
    name: "Legal Block",
  },
  {
    id: "legendaryum",
    symbol: "lgnd",
    name: "Legendaryum",
  },
  {
    id: "legend-of-fantasy-war",
    symbol: "lfw",
    name: "Legend of Fantasy War",
  },
  {
    id: "legends-of-mitra",
    symbol: "mita",
    name: "Legends of Mitra",
  },
  {
    id: "legends-room",
    symbol: "more",
    name: "More Coin",
  },
  {
    id: "legia-warsaw-fan-token",
    symbol: "leg",
    name: "Legia Warsaw Fan Token",
  },
  {
    id: "legiodao",
    symbol: "lgo",
    name: "LegioDAO",
  },
  {
    id: "legion-network",
    symbol: "lgx",
    name: "Legion Network",
  },
  {
    id: "lego-coin",
    symbol: "lego",
    name: "Lego Coin",
  },
  {
    id: "legolas-exchange",
    symbol: "lgo",
    name: "LGO",
  },
  {
    id: "leisuremeta",
    symbol: "lm",
    name: "LeisureMeta",
  },
  {
    id: "leisurepay",
    symbol: "lpy",
    name: "LeisurePay",
  },
  {
    id: "lemochain",
    symbol: "lemo",
    name: "LemoChain",
  },
  {
    id: "lemon",
    symbol: "lmn",
    name: "Lemon",
  },
  {
    id: "lemon-bet",
    symbol: "lbet",
    name: "Lemon Bet",
  },
  {
    id: "lemonchain",
    symbol: "lemc",
    name: "LemonChain",
  },
  {
    id: "lemond",
    symbol: "lemd",
    name: "Lemond",
  },
  {
    id: "lemonn-token",
    symbol: "lmn",
    name: "Lemonn",
  },
  {
    id: "lemon-token",
    symbol: "lemn",
    name: "Crypto Lemon",
  },
  {
    id: "lenda",
    symbol: "lenda",
    name: "Lenda",
  },
  {
    id: "lendefi",
    symbol: "ldfi",
    name: "Lendefi",
  },
  {
    id: "lend-flare-dao-token",
    symbol: "lft",
    name: "Lend Flare Dao",
  },
  {
    id: "lendhub",
    symbol: "lhb",
    name: "Lendhub",
  },
  {
    id: "lendingblock",
    symbol: "lnd",
    name: "Lendingblock",
  },
  {
    id: "lendroid-support-token",
    symbol: "lst",
    name: "Lendroid Support",
  },
  {
    id: "leo",
    symbol: "leo",
    name: "Leo",
  },
  {
    id: "leonicorn-swap",
    symbol: "leos",
    name: "Leonicorn Swap",
  },
  {
    id: "leonidas",
    symbol: "leo",
    name: "Leonidas",
  },
  {
    id: "leonidas-token",
    symbol: "leonidas",
    name: "Leonidas Token",
  },
  {
    id: "leon-token",
    symbol: "leon",
    name: "Leonicorn LEON",
  },
  {
    id: "leopard",
    symbol: "leopard",
    name: "Leopard",
  },
  {
    id: "leo-token",
    symbol: "leo",
    name: "LEO Token",
  },
  {
    id: "lepasa",
    symbol: "lepa",
    name: "Lepasa",
  },
  {
    id: "leprechaun-finance",
    symbol: "lep",
    name: "Leprechaun Finance",
  },
  {
    id: "lepricon",
    symbol: "l3p",
    name: "Lepricon",
  },
  {
    id: "leslar-metaverse",
    symbol: "llverse",
    name: "LESLAR Metaverse",
  },
  {
    id: "less-network",
    symbol: "less",
    name: "Less Network",
  },
  {
    id: "letcoinshop",
    symbol: "lcs",
    name: "LetCoinShop",
  },
  {
    id: "lethean",
    symbol: "lthn",
    name: "Lethean",
  },
  {
    id: "letitride",
    symbol: "lir",
    name: "LetItRide",
  },
  {
    id: "lets-go-brandon",
    symbol: "letsgo",
    name: "Lets Go Brandon",
  },
  {
    id: "lets-go-farming",
    symbol: "lgf",
    name: "Let's Go Farming",
  },
  {
    id: "levante-ud-fan-token",
    symbol: "lev",
    name: "Levante U.D. Fan Token",
  },
  {
    id: "levelapp",
    symbol: "lvl",
    name: "LevelApp",
  },
  {
    id: "levelg",
    symbol: "levelg",
    name: "LEVELG",
  },
  {
    id: "levelup-gaming",
    symbol: "lvlup",
    name: "LevelUp Gaming",
  },
  {
    id: "leven",
    symbol: "leven",
    name: "Leven",
  },
  {
    id: "leverj-gluon",
    symbol: "l2",
    name: "Leverj Gluon",
  },
  {
    id: "lever-network",
    symbol: "lev",
    name: "Lever Network",
  },
  {
    id: "levin",
    symbol: "levin",
    name: "Levin",
  },
  {
    id: "levolution",
    symbol: "levl",
    name: "Levolution",
  },
  {
    id: "lexit-2",
    symbol: "lexi",
    name: "LEXIT",
  },
  {
    id: "lgcy-network",
    symbol: "lgcy",
    name: "LGCY Network",
  },
  {
    id: "lhcoin",
    symbol: "lhcoin",
    name: "LHCoin",
  },
  {
    id: "libartysharetoken",
    symbol: "lst",
    name: "Libartyshare",
  },
  {
    id: "libcoin",
    symbol: "lib",
    name: "Libcoin",
  },
  {
    id: "liber-coin",
    symbol: "lbr",
    name: "LIBER COIN",
  },
  {
    id: "libero-financial",
    symbol: "libero",
    name: "Libero Financial",
  },
  {
    id: "libertas-token",
    symbol: "libertas",
    name: "LIBERTAS",
  },
  {
    id: "libfx",
    symbol: "libfx",
    name: "Libfx",
  },
  {
    id: "libonomy",
    symbol: "lby",
    name: "Libonomy",
  },
  {
    id: "libra-2",
    symbol: "lc",
    name: "Libra",
  },
  {
    id: "libra-credit",
    symbol: "lba",
    name: "Libra Credit",
  },
  {
    id: "libre-defi",
    symbol: "libre",
    name: "Libre DeFi",
  },
  {
    id: "librefreelencer",
    symbol: "libref",
    name: "LibreFreelencer",
  },
  {
    id: "librium-tech",
    symbol: "lib",
    name: "Librium Tech",
  },
  {
    id: "lichang",
    symbol: "lc",
    name: "Lichang",
  },
  {
    id: "lido-dao",
    symbol: "ldo",
    name: "Lido DAO",
  },
  {
    id: "lido-dao-wormhole",
    symbol: "ldo",
    name: "Lido DAO (Wormhole)",
  },
  {
    id: "lido-staked-ether-wormhole",
    symbol: "steth",
    name: "Lido Staked Ether (Wormhole)",
  },
  {
    id: "lido-staked-matic",
    symbol: "stmatic",
    name: "Lido Staked Matic",
  },
  {
    id: "lido-staked-sol",
    symbol: "stsol",
    name: "Lido Staked SOL",
  },
  {
    id: "lien",
    symbol: "lien",
    name: "Lien",
  },
  {
    id: "lifebird",
    symbol: "lifebird",
    name: "LIFEBIRD",
  },
  {
    id: "life-coin",
    symbol: "lfc",
    name: "Life Coin",
  },
  {
    id: "life-crypto",
    symbol: "life",
    name: "Life Crypto",
  },
  {
    id: "life-dao",
    symbol: "lf",
    name: "Life DAO",
  },
  {
    id: "lifetime",
    symbol: "lft",
    name: "Lifetime",
  },
  {
    id: "lifetise",
    symbol: "life",
    name: "Lifetise",
  },
  {
    id: "life-token-v2",
    symbol: "ltnv2",
    name: "Life v2",
  },
  {
    id: "lifinity",
    symbol: "lfnty",
    name: "Lifinity",
  },
  {
    id: "lightbeam-courier-coin",
    symbol: "lbcc",
    name: "Lightbeam Courier Coin",
  },
  {
    id: "lightcoin",
    symbol: "lhc",
    name: "Lightcoin",
  },
  {
    id: "light-defi",
    symbol: "light",
    name: "Light Defi",
  },
  {
    id: "lightening-cash",
    symbol: "lic",
    name: "Lightening Cash",
  },
  {
    id: "lightforge",
    symbol: "ltfg",
    name: "Lightforge",
  },
  {
    id: "lightning-bitcoin",
    symbol: "lbtc",
    name: "Lightning Bitcoin",
  },
  {
    id: "lightningcoin",
    symbol: "lc",
    name: "LightningCoin",
  },
  {
    id: "lightning-protocol",
    symbol: "light",
    name: "Lightning Protocol",
  },
  {
    id: "lightstreams",
    symbol: "pht",
    name: "Lightstreams Photon",
  },
  {
    id: "light-year",
    symbol: "lc",
    name: "Light Year",
  },
  {
    id: "lightyears",
    symbol: "year",
    name: "Lightyears",
  },
  {
    id: "likecoin",
    symbol: "like",
    name: "LikeCoin",
  },
  {
    id: "lil-doge-floki-token",
    symbol: "ldf",
    name: "Lil Doge Floki LDF",
  },
  {
    id: "lil-floki",
    symbol: "lilfloki",
    name: "Lil Floki",
  },
  {
    id: "lilflokiceo",
    symbol: "lilflokiceo",
    name: "LilFlokiCeo",
  },
  {
    id: "lilith-swap",
    symbol: "llth",
    name: "Lilith Swap",
  },
  {
    id: "lillion",
    symbol: "lil",
    name: "Lillion",
  },
  {
    id: "lilly-finance",
    symbol: "ly",
    name: "Lilly Finance",
  },
  {
    id: "limbo-token",
    symbol: "lnfs",
    name: "Limbo",
  },
  {
    id: "limcore",
    symbol: "limc",
    name: "LimCore",
  },
  {
    id: "limestone-network",
    symbol: "limex",
    name: "Limestone Network",
  },
  {
    id: "limited-euro",
    symbol: "leur",
    name: "Limited Euro",
  },
  {
    id: "limited-usd",
    symbol: "lusd",
    name: "Limited USD",
  },
  {
    id: "limitswap",
    symbol: "limit",
    name: "LimitSwap",
  },
  {
    id: "limocoin-swap",
    symbol: "lmcswap",
    name: "Limocoin Swap",
  },
  {
    id: "lina",
    symbol: "lina",
    name: "LINA",
  },
  {
    id: "linda",
    symbol: "mrx",
    name: "Metrix Coin",
  },
  {
    id: "linear",
    symbol: "lina",
    name: "Linear",
  },
  {
    id: "linear-protocol",
    symbol: "linear",
    name: "LiNEAR Protocol",
  },
  {
    id: "linfinity",
    symbol: "lfc",
    name: "Linfinity",
  },
  {
    id: "linix",
    symbol: "lnx",
    name: "LNX Protocol",
  },
  {
    id: "link",
    symbol: "ln",
    name: "LINK",
  },
  {
    id: "linka",
    symbol: "linka",
    name: "LINKA",
  },
  {
    id: "linkart",
    symbol: "lar",
    name: "LinkArt",
  },
  {
    id: "linkcoin-token",
    symbol: "lkn",
    name: "LinkCoin",
  },
  {
    id: "linker-coin",
    symbol: "lnc",
    name: "Linker Coin",
  },
  {
    id: "linkeye",
    symbol: "let",
    name: "Linkeye",
  },
  {
    id: "linkka",
    symbol: "ika",
    name: "Linkka",
  },
  {
    id: "link-machine-learning",
    symbol: "lml",
    name: "Link Machine Learning",
  },
  {
    id: "linkpool",
    symbol: "lpl",
    name: "LinkPool",
  },
  {
    id: "links",
    symbol: "links",
    name: "Links",
  },
  {
    id: "linksync",
    symbol: "sync",
    name: "LinkSync",
  },
  {
    id: "linktoken",
    symbol: "ltk",
    name: "Link LTK",
  },
  {
    id: "linspirit",
    symbol: "linspirit",
    name: "linSpirit",
  },
  {
    id: "lion-scrub-finance",
    symbol: "lion",
    name: "Lion Scrub Finance",
  },
  {
    id: "lion-token",
    symbol: "lion",
    name: "Lion",
  },
  {
    id: "liq-protocol",
    symbol: "liq",
    name: "LIQ Protocol",
  },
  {
    id: "liquidator-dao",
    symbol: "liquidator",
    name: "Liquidator DAO",
  },
  {
    id: "liquid-collectibles",
    symbol: "lico",
    name: "Liquid Collectibles",
  },
  {
    id: "liquid-crowdloan-dot",
    symbol: "lcdot",
    name: "Liquid Crowdloan DOT",
  },
  {
    id: "liquiddriver",
    symbol: "lqdr",
    name: "LiquidDriver",
  },
  {
    id: "liquid-icp",
    symbol: "licp",
    name: "Liquid ICP",
  },
  {
    id: "liquidifty",
    symbol: "lqt",
    name: "Liquidifty",
  },
  {
    id: "liquidify",
    symbol: "lat",
    name: "Liquidify",
  },
  {
    id: "liquidity-dividends-protocol",
    symbol: "lid",
    name: "Liquidity Dividends Protocol",
  },
  {
    id: "liquidity-network",
    symbol: "lqd",
    name: "Liquidity Network",
  },
  {
    id: "liquid-ksm",
    symbol: "lksm",
    name: "Liquid KSM",
  },
  {
    id: "liquid-staking-dot",
    symbol: "ldot",
    name: "Liquid Staking Dot",
  },
  {
    id: "liquidswap",
    symbol: "lqd",
    name: "LiquidSwap",
  },
  {
    id: "liquidus",
    symbol: "liq",
    name: "Liquidus",
  },
  {
    id: "liquity",
    symbol: "lqty",
    name: "Liquity",
  },
  {
    id: "liquity-usd",
    symbol: "lusd",
    name: "Liquity USD",
  },
  {
    id: "liqwid-finance",
    symbol: "lq",
    name: "Liqwid Finance",
  },
  {
    id: "lisk",
    symbol: "lsk",
    name: "Lisk",
  },
  {
    id: "lit",
    symbol: "lit",
    name: "LIT",
  },
  {
    id: "litebar",
    symbol: "ltb",
    name: "LiteBar",
  },
  {
    id: "litebitcoin",
    symbol: "lbtc",
    name: "LiteBitcoin",
  },
  {
    id: "litecash",
    symbol: "cash",
    name: "Litecash",
  },
  {
    id: "litecoin",
    symbol: "ltc",
    name: "Litecoin",
  },
  {
    id: "litecoin-bep2",
    symbol: "ltcb",
    name: "Litecoin BEP2",
  },
  {
    id: "litecoin-cash",
    symbol: "lcc",
    name: "Litecoin Cash",
  },
  {
    id: "litecoin-finance",
    symbol: "ltfn",
    name: "Litecoin Finance",
  },
  {
    id: "litecoin-plus",
    symbol: "lcp",
    name: "Litecoin Plus",
  },
  {
    id: "litecoin-sv",
    symbol: "lsv",
    name: "Litecoin SV",
  },
  {
    id: "litecoin-token",
    symbol: "ltk",
    name: "Litecoin LTK",
  },
  {
    id: "litecoin-ultra",
    symbol: "ltcu",
    name: "LiteCoin Ultra",
  },
  {
    id: "litecoinz",
    symbol: "ltz",
    name: "LitecoinZ",
  },
  {
    id: "litedex",
    symbol: "ldx",
    name: "Litedex",
  },
  {
    id: "litedoge",
    symbol: "ldoge",
    name: "LiteDoge",
  },
  {
    id: "litegold",
    symbol: "ltg",
    name: "LiteGold",
  },
  {
    id: "litentry",
    symbol: "lit",
    name: "Litentry",
  },
  {
    id: "litex",
    symbol: "lxt",
    name: "LITEX",
  },
  {
    id: "litherium",
    symbol: "lith",
    name: "Litherium",
  },
  {
    id: "lithium-2",
    symbol: "lithium",
    name: "Lithium",
  },
  {
    id: "lithium-finance",
    symbol: "lith",
    name: "Lithium Finance",
  },
  {
    id: "lithosphere",
    symbol: "litho",
    name: "Lithosphere",
  },
  {
    id: "lith-token",
    symbol: "lith",
    name: "Lith",
  },
  {
    id: "lition",
    symbol: "lit",
    name: "Lition",
  },
  {
    id: "little-angry-bunny-v2",
    symbol: "lab-v2",
    name: "Little Angry Bunny v2",
  },
  {
    id: "little-bunny-rocket",
    symbol: "lbr",
    name: "Little Bunny Rocket",
  },
  {
    id: "littleghosts-ectoplasm",
    symbol: "ecto",
    name: "LittleGhosts Ectoplasm",
  },
  {
    id: "littleinu",
    symbol: "linu",
    name: "LittleInu",
  },
  {
    id: "little-rabbit",
    symbol: "ltrbt",
    name: "Little Rabbit",
  },
  {
    id: "littlesesame",
    symbol: "lsc",
    name: "Littlesesame",
  },
  {
    id: "little-tsuki-inu",
    symbol: "liltk",
    name: "Little Tsuki Inu",
  },
  {
    id: "little-ugly-duck",
    symbol: "lud",
    name: "Little Ugly Duck",
  },
  {
    id: "lituni",
    symbol: "lito",
    name: "Lituni",
  },
  {
    id: "live-nft",
    symbol: "livenft",
    name: "Live NFT",
  },
  {
    id: "livenodes",
    symbol: "lno",
    name: "Livenodes",
  },
  {
    id: "livenpay",
    symbol: "lvn",
    name: "LivenPay",
  },
  {
    id: "livepeer",
    symbol: "lpt",
    name: "Livepeer",
  },
  {
    id: "live-swap-coin",
    symbol: "lsc",
    name: "Live Swap Coin",
  },
  {
    id: "livetrade-token",
    symbol: "ltd",
    name: "LiveTrade",
  },
  {
    id: "lixir-protocol",
    symbol: "lix",
    name: "Lixir Finance",
  },
  {
    id: "lizard-token",
    symbol: "lizard",
    name: "Lizard",
  },
  {
    id: "lizardtoken-finance",
    symbol: "liz",
    name: "LizardToken.Finance",
  },
  {
    id: "llamaswap",
    symbol: "lama",
    name: "LlamaSwap",
  },
  {
    id: "llamaverse",
    symbol: "spit",
    name: "Llamaverse",
  },
  {
    id: "lnko-token",
    symbol: "lnko",
    name: "LNKO",
  },
  {
    id: "loa-protocol",
    symbol: "loa",
    name: "LOA Protocol",
  },
  {
    id: "lobby",
    symbol: "lby",
    name: "Lobby",
  },
  {
    id: "lobis",
    symbol: "lobi",
    name: "Lobis",
  },
  {
    id: "lobstex-coin",
    symbol: "lobs",
    name: "Lobstex",
  },
  {
    id: "localcoinswap",
    symbol: "lcs",
    name: "LocalCoinSwap",
  },
  {
    id: "local-terra",
    symbol: "local",
    name: "Local Terra",
  },
  {
    id: "localtrade",
    symbol: "ltt",
    name: "LocalTrade",
  },
  {
    id: "locgame",
    symbol: "locg",
    name: "LOCGame",
  },
  {
    id: "lockchain",
    symbol: "loc",
    name: "LockTrip",
  },
  {
    id: "lockness",
    symbol: "lkn",
    name: "Lockness",
  },
  {
    id: "locometa",
    symbol: "loco",
    name: "LocoMeta",
  },
  {
    id: "locus-chain",
    symbol: "locus",
    name: "Locus Chain",
  },
  {
    id: "lofi-defi",
    symbol: "lofi",
    name: "Lofi Defi",
  },
  {
    id: "logitron",
    symbol: "ltr",
    name: "LogiTron",
  },
  {
    id: "logosunaux",
    symbol: "logos",
    name: "Logosunaux",
  },
  {
    id: "logs",
    symbol: "logs",
    name: "LOGS",
  },
  {
    id: "loki-network",
    symbol: "oxen",
    name: "Oxen",
  },
  {
    id: "lokr",
    symbol: "lkr",
    name: "Lokr",
  },
  {
    id: "lol",
    symbol: "lol",
    name: "LOL",
  },
  {
    id: "loltoken",
    symbol: "lol",
    name: "LOLTOKEN",
  },
  {
    id: "londex-2",
    symbol: "ldx",
    name: "Londex",
  },
  {
    id: "londoncoingold",
    symbol: "ldxg",
    name: "LondonCoinGold",
  },
  {
    id: "london-vault-nftx",
    symbol: "london",
    name: "LONDON Vault (NFTX)",
  },
  {
    id: "lonelyfans",
    symbol: "lof",
    name: "LonelyFans",
  },
  {
    id: "longdrink-finance",
    symbol: "long",
    name: "Longdrink Finance",
  },
  {
    id: "lookscoin",
    symbol: "look",
    name: "LooksCoin",
  },
  {
    id: "looksrare",
    symbol: "looks",
    name: "LooksRare",
  },
  {
    id: "looks-rare",
    symbol: "lr",
    name: "Looks Rare",
  },
  {
    id: "loomi",
    symbol: "loomi",
    name: "Loomi",
  },
  {
    id: "loom-network",
    symbol: "loomold",
    name: "Loom Network (OLD)",
  },
  {
    id: "loom-network-new",
    symbol: "loom",
    name: "Loom Network (NEW)",
  },
  {
    id: "loon-network",
    symbol: "loon",
    name: "Loon Network",
  },
  {
    id: "loopnetwork",
    symbol: "loop",
    name: "LoopNetwork",
  },
  {
    id: "loopring",
    symbol: "lrc",
    name: "Loopring",
  },
  {
    id: "loopringcoin-v2-wormhole",
    symbol: "lrc",
    name: "LoopringCoin V2 (Wormhole)",
  },
  {
    id: "loopstarter",
    symbol: "loops",
    name: "LOOPStarter",
  },
  {
    id: "loopswap",
    symbol: "lswap",
    name: "LoopSwap",
  },
  {
    id: "loop-token",
    symbol: "loop",
    name: "LOOP Finance",
  },
  {
    id: "loot",
    symbol: "loot",
    name: "Lootex",
  },
  {
    id: "loot-dollar",
    symbol: "lootdollar",
    name: "Loot Dollar",
  },
  {
    id: "loot-network",
    symbol: "loot",
    name: "Loot Network",
  },
  {
    id: "loot-token",
    symbol: "loot",
    name: "Loot",
  },
  {
    id: "lord-arena",
    symbol: "lorda",
    name: "Lord Arena",
  },
  {
    id: "lorde-edge",
    symbol: "edgelon",
    name: "Lorde Edge",
  },
  {
    id: "lords",
    symbol: "lords",
    name: "LORDS",
  },
  {
    id: "lordtoken",
    symbol: "ltt",
    name: "LordToken",
  },
  {
    id: "loserchick-egg",
    symbol: "egg",
    name: "LoserChick EGG",
  },
  {
    id: "loser-coin",
    symbol: "lowb",
    name: "Loser Coin",
  },
  {
    id: "lossless",
    symbol: "lss",
    name: "Lossless",
  },
  {
    id: "lost-world",
    symbol: "lost",
    name: "Lost World",
  },
  {
    id: "lotoblock",
    symbol: "loto",
    name: "Lotoblock",
  },
  {
    id: "lotto",
    symbol: "lotto",
    name: "Lotto",
  },
  {
    id: "lot-trade",
    symbol: "lott",
    name: "LOT.TRADE",
  },
  {
    id: "lotus-capital",
    symbol: "lc",
    name: "Lotus Capital",
  },
  {
    id: "loud-market",
    symbol: "loud",
    name: "Loud Market",
  },
  {
    id: "louverture",
    symbol: "lvt",
    name: "Louverture V2",
  },
  {
    id: "louvre-finance",
    symbol: "louvre",
    name: "Louvre Finance",
  },
  {
    id: "lovechain",
    symbol: "lov",
    name: "LoveChain",
  },
  {
    id: "love-earth-coin",
    symbol: "lec",
    name: "Love Earth Coin",
  },
  {
    id: "lovelace-world",
    symbol: "lace",
    name: "Lovelace World",
  },
  {
    id: "lovely-inu-finance",
    symbol: "lovely",
    name: "Lovely Inu finance",
  },
  {
    id: "lovepot-token",
    symbol: "love",
    name: "LovePot",
  },
  {
    id: "love-protocol",
    symbol: "love",
    name: "Love Protocol",
  },
  {
    id: "lox-network",
    symbol: "lox",
    name: "Lox Network",
  },
  {
    id: "lp-3pool-curve",
    symbol: "3crv",
    name: "LP 3pool Curve",
  },
  {
    id: "l-pesa",
    symbol: "lpk",
    name: "Kripton",
  },
  {
    id: "lpi-dao",
    symbol: "lpi",
    name: "LPI DAO",
  },
  {
    id: "lp-renbtc-curve",
    symbol: "renbtccurve",
    name: "LP renBTC Curve",
  },
  {
    id: "lp-scurve",
    symbol: "scurve",
    name: "LP-sCurve",
  },
  {
    id: "lto-network",
    symbol: "lto",
    name: "LTO Network",
  },
  {
    id: "ltradex",
    symbol: "ltex",
    name: "Ltradex",
  },
  {
    id: "luart",
    symbol: "luart",
    name: "Luart",
  },
  {
    id: "lua-token",
    symbol: "lua",
    name: "LuaSwap",
  },
  {
    id: "luatoken-wormhole",
    symbol: "lua",
    name: "LuaToken (Wormhole)",
  },
  {
    id: "luca",
    symbol: "luca",
    name: "LUCA",
  },
  {
    id: "lucent",
    symbol: "lcnt",
    name: "Lucent",
  },
  {
    id: "lucha",
    symbol: "lucha",
    name: "Lucha",
  },
  {
    id: "lucidao",
    symbol: "lcd",
    name: "Lucidao",
  },
  {
    id: "lucid-lands",
    symbol: "llg",
    name: "Lucid Lands",
  },
  {
    id: "lucis",
    symbol: "lucis",
    name: "Lucis",
  },
  {
    id: "luckchain",
    symbol: "bash",
    name: "LuckChain",
  },
  {
    id: "luckstar",
    symbol: "lst",
    name: "Luckstar",
  },
  {
    id: "lucky-2",
    symbol: "lucky",
    name: "LUCKY",
  },
  {
    id: "lucky-block",
    symbol: "lblock",
    name: "Lucky Block",
  },
  {
    id: "luckychip",
    symbol: "lc",
    name: "LuckyChip",
  },
  {
    id: "luckydoge",
    symbol: "luckydoge",
    name: "LuckyDoge",
  },
  {
    id: "lucky-lion",
    symbol: "lucky",
    name: "Lucky Lion",
  },
  {
    id: "luckypig",
    symbol: "luckypig",
    name: "LuckyPig",
  },
  {
    id: "lucky-property-development-invest",
    symbol: "lpdi",
    name: "Lucky Property Development Invest",
  },
  {
    id: "luckyseventoken",
    symbol: "lst",
    name: "LuckySevenToken",
  },
  {
    id: "lucky-shinu",
    symbol: "lushi",
    name: "Lucky Shinu",
  },
  {
    id: "luckytoken",
    symbol: "lkt",
    name: "LuckyToken",
  },
  {
    id: "lucky-unicorn-token",
    symbol: "l99",
    name: "Lucky Unicorn",
  },
  {
    id: "lucretius",
    symbol: "luc",
    name: "Lucretius",
  },
  {
    id: "lucrosus-capital",
    symbol: "$luca",
    name: "Lucrosus Capital",
  },
  {
    id: "lucy",
    symbol: "lucy",
    name: "LUCY",
  },
  {
    id: "ludena-protocol",
    symbol: "ldn",
    name: "Ludena Protocol",
  },
  {
    id: "ludos",
    symbol: "lud",
    name: "Ludos Protocol",
  },
  {
    id: "luffy-inu",
    symbol: "luffy",
    name: "Luffy",
  },
  {
    id: "lukso-token",
    symbol: "lyxe",
    name: "LUKSO",
  },
  {
    id: "lulz",
    symbol: "lulz",
    name: "LULZ",
  },
  {
    id: "lumenswap",
    symbol: "lsp",
    name: "Lumenswap",
  },
  {
    id: "lumerin",
    symbol: "lmr",
    name: "Lumerin",
  },
  {
    id: "lumi-credits",
    symbol: "lumi",
    name: "LUMI Credits",
  },
  {
    id: "luminos-mining-protocol",
    symbol: "lumi",
    name: "Luminos Mining Protocol",
  },
  {
    id: "lum-network",
    symbol: "lum",
    name: "Lum Network",
  },
  {
    id: "lumos-metaverse",
    symbol: "lumosx",
    name: "Lumos Metaverse",
  },
  {
    id: "lum-rune",
    symbol: "lum",
    name: "Lum Rune",
  },
  {
    id: "luna-1x",
    symbol: "luna1x",
    name: "LUNA 1x",
  },
  {
    id: "lunachow",
    symbol: "luchow",
    name: "LunaChow",
  },
  {
    id: "lunadoge",
    symbol: "loge",
    name: "LunaDoge",
  },
  {
    id: "lunafi",
    symbol: "lfi",
    name: "Lunafi",
  },
  {
    id: "lunafox",
    symbol: "lufx",
    name: "LunaFox",
  },
  {
    id: "luna-inu",
    symbol: "linu",
    name: "Luna Inu",
  },
  {
    id: "lunaland",
    symbol: "lln",
    name: "LunaLand",
  },
  {
    id: "luna-pad",
    symbol: "lunapad",
    name: "Luna-Pad",
  },
  {
    id: "lunar",
    symbol: "lnr",
    name: "Lunar",
  },
  {
    id: "lunarbrain",
    symbol: "lun",
    name: "LunarBrain",
  },
  {
    id: "lunarium",
    symbol: "xln",
    name: "Lunarium",
  },
  {
    id: "lunarswap",
    symbol: "lunar",
    name: "LunarSwap",
  },
  {
    id: "lunart",
    symbol: "arts",
    name: "LunArt",
  },
  {
    id: "lunar-token",
    symbol: "lunar",
    name: "PolarisFinance Lunar",
  },
  {
    id: "luna-rush",
    symbol: "lus",
    name: "Luna Rush",
  },
  {
    id: "lunaverse",
    symbol: "luv",
    name: "Lunaverse",
  },
  {
    id: "luna-wormhole",
    symbol: "lunc",
    name: "Terra Classic (Wormhole)",
  },
  {
    id: "lunchdao",
    symbol: "lunch",
    name: "LunchDAO",
  },
  {
    id: "lunch-money",
    symbol: "lmy",
    name: "Lunch Money",
  },
  {
    id: "lunes",
    symbol: "lunes",
    name: "Lunes",
  },
  {
    id: "lung-protocol",
    symbol: "l2p",
    name: "Lung Protocol",
  },
  {
    id: "luni",
    symbol: "luni",
    name: "LUNI",
  },
  {
    id: "lunr-token",
    symbol: "lunr",
    name: "Lunr",
  },
  {
    id: "lunyr",
    symbol: "lun",
    name: "Lunyr",
  },
  {
    id: "lusd",
    symbol: "lusd",
    name: "LUSD",
  },
  {
    id: "luto-cash",
    symbol: "luto",
    name: "Luto Cash",
  },
  {
    id: "lux-bio-exchange-coin",
    symbol: "lbxc",
    name: "LUX BIO EXCHANGE COIN",
  },
  {
    id: "luxcoin",
    symbol: "lux",
    name: "LUXCoin",
  },
  {
    id: "luxeracing",
    symbol: "luxe",
    name: "LuxeRacing",
  },
  {
    id: "luxfi",
    symbol: "lxf",
    name: "LuxFi",
  },
  {
    id: "luxo",
    symbol: "luxo",
    name: "Luxo",
  },
  {
    id: "luxor",
    symbol: "lux",
    name: "Luxor",
  },
  {
    id: "luxurious-pro-network-token",
    symbol: "lpnt",
    name: "Luxurious Pro Network",
  },
  {
    id: "luxury-club",
    symbol: "lux",
    name: "Luxury Club",
  },
  {
    id: "luxy",
    symbol: "luxy",
    name: "Luxy",
  },
  {
    id: "luyuka",
    symbol: "lyk",
    name: "Luyuka",
  },
  {
    id: "luzion-protocol",
    symbol: "lzn",
    name: "Luzion Protocol",
  },
  {
    id: "lyca-island",
    symbol: "lyca",
    name: "Lyca Nation",
  },
  {
    id: "lydia-finance",
    symbol: "lyd",
    name: "Lydia Finance",
  },
  {
    id: "lyfe",
    symbol: "lyfe",
    name: "Lyfe",
  },
  {
    id: "lyfe-gold",
    symbol: "lgold",
    name: "Lyfe Gold",
  },
  {
    id: "lyfe-land",
    symbol: "lland",
    name: "Lyfe Land",
  },
  {
    id: "lyfe-silver",
    symbol: "lsilver",
    name: "Lyfe Silver",
  },
  {
    id: "lympo",
    symbol: "lym",
    name: "Lympo",
  },
  {
    id: "lympo-market-token",
    symbol: "lmt",
    name: "Lympo Market",
  },
  {
    id: "lynkey",
    symbol: "lynk",
    name: "LynKey",
  },
  {
    id: "lynx",
    symbol: "lynx",
    name: "Lynx",
  },
  {
    id: "lyocredit",
    symbol: "lyo",
    name: "LYO Credit",
  },
  {
    id: "lyptus-token",
    symbol: "lyptus",
    name: "Lyptus",
  },
  {
    id: "lyra",
    symbol: "lyr",
    name: "Lyra",
  },
  {
    id: "lyra-finance",
    symbol: "lyra",
    name: "Lyra Finance",
  },
  {
    id: "lys-capital",
    symbol: "lys",
    name: "LYS Capital",
  },
  {
    id: "lzp",
    symbol: "lzp",
    name: "LZP",
  },
  {
    id: "m2",
    symbol: "m2",
    name: "M2",
  },
  {
    id: "macaronswap",
    symbol: "mcrn",
    name: "MacaronSwap",
  },
  {
    id: "machinecoin",
    symbol: "mac",
    name: "Machinecoin",
  },
  {
    id: "machix",
    symbol: "mcx",
    name: "Machi X",
  },
  {
    id: "madagascar-token",
    symbol: "$time",
    name: "Madagascar",
  },
  {
    id: "mad-bucks",
    symbol: "mad",
    name: "MAD Bucks",
  },
  {
    id: "madcredits",
    symbol: "mwd",
    name: "MadCredits",
  },
  {
    id: "mad-meerkat-etf",
    symbol: "metf",
    name: "Mad Meerkat ETF",
  },
  {
    id: "mad-meerkat-optimizer",
    symbol: "mmo",
    name: "Mad Meerkat Optimizer",
  },
  {
    id: "mad-network",
    symbol: "mad",
    name: "MADNetwork",
  },
  {
    id: "mad-usd",
    symbol: "musd",
    name: "Mad USD",
  },
  {
    id: "mad-viking-games",
    symbol: "mvg",
    name: "Mad Viking Games",
  },
  {
    id: "madworld",
    symbol: "umad",
    name: "MADworld",
  },
  {
    id: "maecenas",
    symbol: "art",
    name: "Maecenas",
  },
  {
    id: "mafacoin",
    symbol: "mafa",
    name: "MafaCoin",
  },
  {
    id: "magic",
    symbol: "magic",
    name: "Magic",
  },
  {
    id: "magic-beasties",
    symbol: "bsts",
    name: "Magic Beasties",
  },
  {
    id: "magic-birds-token",
    symbol: "mbt",
    name: "Magic Birds",
  },
  {
    id: "magic-bnb",
    symbol: "mbnb",
    name: "MAGIC BNB",
  },
  {
    id: "magicbox",
    symbol: "mbt",
    name: "MagicBox",
  },
  {
    id: "magiccraft",
    symbol: "mcrt",
    name: "MagicCraft",
  },
  {
    id: "magic-cube",
    symbol: "mcc",
    name: "Magic Cube Coin",
  },
  {
    id: "magic-cube-finance",
    symbol: "mast",
    name: "Magic Cube Finance",
  },
  {
    id: "magicdoge",
    symbol: "magicdoge",
    name: "MagicDOGE",
  },
  {
    id: "magic-eggs",
    symbol: "maga",
    name: "Magic Eggs",
  },
  {
    id: "magic-elpis-gem",
    symbol: "meg",
    name: "Magic Elpis Gem",
  },
  {
    id: "magic-ethereum-money",
    symbol: "mem",
    name: "Magic Ethereum Money",
  },
  {
    id: "magic-forest",
    symbol: "magf",
    name: "Magic Forest",
  },
  {
    id: "magic-internet-money",
    symbol: "mim",
    name: "Magic Internet Money",
  },
  {
    id: "magic-internet-money-wormhole",
    symbol: "mimet",
    name: "Magic Internet Money (Wormhole)",
  },
  {
    id: "magic-inu",
    symbol: "magic",
    name: "Magic Inu",
  },
  {
    id: "magick-dao",
    symbol: "magick",
    name: "Magick DAO",
  },
  {
    id: "magic-metaverse",
    symbol: "mac",
    name: "Magic Metaverse",
  },
  {
    id: "magicofgold",
    symbol: "magic",
    name: "MagicofGold",
  },
  {
    id: "magic-of-universe",
    symbol: "mgc",
    name: "Magic of Universe",
  },
  {
    id: "magic-power",
    symbol: "mgp",
    name: "Magic Power",
  },
  {
    id: "magic-token",
    symbol: "magic",
    name: "MagicLand",
  },
  {
    id: "magic-trading-token",
    symbol: "mtk",
    name: "Magic Trading",
  },
  {
    id: "magik",
    symbol: "magik",
    name: "Magik",
  },
  {
    id: "magnachain",
    symbol: "mgc",
    name: "Magnachain",
  },
  {
    id: "magnet-dao",
    symbol: "mag",
    name: "Magnet DAO",
  },
  {
    id: "magnetgold",
    symbol: "mtg",
    name: "MagnetGold",
  },
  {
    id: "magpiecoin",
    symbol: "mgpc",
    name: "MagpieCoin",
  },
  {
    id: "magus-nodes",
    symbol: "magus",
    name: "Magus Nodes",
  },
  {
    id: "mahadao",
    symbol: "maha",
    name: "MahaDAO",
  },
  {
    id: "maia",
    symbol: "maia",
    name: "Maia",
  },
  {
    id: "maiar-dex",
    symbol: "mex",
    name: "Maiar DEX",
  },
  {
    id: "maidcoin",
    symbol: "$maid",
    name: "MaidCoin",
  },
  {
    id: "main",
    symbol: "main",
    name: "Main",
  },
  {
    id: "maincoin",
    symbol: "mnc",
    name: "MainCoin",
  },
  {
    id: "mainframe",
    symbol: "mft",
    name: "Hifi Finance",
  },
  {
    id: "mainstream-for-the-underground",
    symbol: "mftu",
    name: "Mainstream For The Underground",
  },
  {
    id: "maison-capital",
    symbol: "msn",
    name: "Maison Capital",
  },
  {
    id: "major-protocol",
    symbol: "mjr",
    name: "Major Protocol",
  },
  {
    id: "make-more-money",
    symbol: "m3c",
    name: "Make More Money",
  },
  {
    id: "maker",
    symbol: "mkr",
    name: "Maker",
  },
  {
    id: "makes",
    symbol: "mks",
    name: "Makes",
  },
  {
    id: "makiswap",
    symbol: "maki",
    name: "MakiSwap",
  },
  {
    id: "makk",
    symbol: "makk",
    name: "Makk",
  },
  {
    id: "malinka",
    symbol: "mlnk",
    name: "Malinka",
  },
  {
    id: "malt-stablecoin-v2",
    symbol: "malt",
    name: "Malt Stablecoin V2",
  },
  {
    id: "mama-dao",
    symbol: "mama",
    name: "Mama DAO",
  },
  {
    id: "mamadoge",
    symbol: "mamadoge",
    name: "MamaDoge",
  },
  {
    id: "mamaverse",
    symbol: "coinmama",
    name: "MamaVerse",
  },
  {
    id: "manager-pro",
    symbol: "mpro",
    name: "Manager PRO",
  },
  {
    id: "manarium",
    symbol: "ari",
    name: "Manarium",
  },
  {
    id: "manateecoin",
    symbol: "mtc",
    name: "ManateeCoin",
  },
  {
    id: "manchester-city-fan-token",
    symbol: "city",
    name: "Manchester City Fan Token",
  },
  {
    id: "mancium",
    symbol: "manc",
    name: "Mancium",
  },
  {
    id: "mandala-2",
    symbol: "mndl",
    name: "Mandala",
  },
  {
    id: "mandala-exchange-token",
    symbol: "mdx",
    name: "Mandala Exchange",
  },
  {
    id: "mandi-token",
    symbol: "mandi",
    name: "Mandi",
  },
  {
    id: "mandox-2",
    symbol: "mandox",
    name: "MandoX",
  },
  {
    id: "maneki-neko",
    symbol: "neki",
    name: "Maneki-neko",
  },
  {
    id: "manga-token",
    symbol: "$manga",
    name: "Manga",
  },
  {
    id: "mangochain",
    symbol: "mgp",
    name: "MangoChain",
  },
  {
    id: "mango-markets",
    symbol: "mngo",
    name: "Mango",
  },
  {
    id: "manifold-finance",
    symbol: "fold",
    name: "Manifold Finance",
  },
  {
    id: "manna",
    symbol: "manna",
    name: "Manna",
  },
  {
    id: "mantis-network",
    symbol: "mntis",
    name: "Mantis Network",
  },
  {
    id: "mantra-dao",
    symbol: "om",
    name: "MANTRA DAO",
  },
  {
    id: "manufactory-2",
    symbol: "mnft",
    name: "ManuFactory",
  },
  {
    id: "manyswap",
    symbol: "many",
    name: "Manyswap",
  },
  {
    id: "many-worlds",
    symbol: "many",
    name: "Many Worlds",
  },
  {
    id: "mao-zedong",
    symbol: "mao",
    name: "Mao Zedong",
  },
  {
    id: "mapcoin",
    symbol: "mapc",
    name: "MapCoin",
  },
  {
    id: "maple",
    symbol: "mpl",
    name: "Maple",
  },
  {
    id: "mapmetrics",
    symbol: "mmaps",
    name: "MapMetrics",
  },
  {
    id: "maps",
    symbol: "maps",
    name: "MAPS",
  },
  {
    id: "mapt-coin",
    symbol: "xmp",
    name: "Mapt.Coin",
  },
  {
    id: "marble",
    symbol: "$marble",
    name: "Marble Dao",
  },
  {
    id: "marblecoin",
    symbol: "mbc",
    name: "Marblecoin",
  },
  {
    id: "marbledao-block",
    symbol: "block",
    name: "MarbleDao Block",
  },
  {
    id: "marble-heroes",
    symbol: "mbh",
    name: "Marble Heroes",
  },
  {
    id: "marblex",
    symbol: "mbx",
    name: "Marblex",
  },
  {
    id: "marcopolo",
    symbol: "map",
    name: "MAP Protocol",
  },
  {
    id: "margarita",
    symbol: "margarita",
    name: "Margarita",
  },
  {
    id: "marginswap",
    symbol: "mfi",
    name: "Marginswap",
  },
  {
    id: "marhabadefi",
    symbol: "mrhb",
    name: "MarhabaDeFi",
  },
  {
    id: "marinade",
    symbol: "mnde",
    name: "Marinade",
  },
  {
    id: "marinade-staked-sol-wormhole",
    symbol: "msol",
    name: "Marinade staked SOL (Wormhole)",
  },
  {
    id: "mariofloki",
    symbol: "mrfloki",
    name: "MarioFloki",
  },
  {
    id: "markaccy",
    symbol: "mkcy",
    name: "Markaccy",
  },
  {
    id: "market-arbitrage-coin",
    symbol: "wmarc",
    name: "Wrapped Market Arbitrage Coin",
  },
  {
    id: "market-ledger",
    symbol: "ml",
    name: "Market Ledger",
  },
  {
    id: "market-making-pro",
    symbol: "mmpro",
    name: "Market Making Pro",
  },
  {
    id: "marketmove",
    symbol: "move",
    name: "MarketMove",
  },
  {
    id: "market-neutral-yield-eth",
    symbol: "mnye",
    name: "Market Neutral Yield ETH",
  },
  {
    id: "marketpeak",
    symbol: "peak",
    name: "PEAKDEFI",
  },
  {
    id: "markhor-meta",
    symbol: "mm",
    name: "Markhor Meta",
  },
  {
    id: "markmeta",
    symbol: "mmt",
    name: "MarkMeta",
  },
  {
    id: "marlin",
    symbol: "pond",
    name: "Marlin",
  },
  {
    id: "marmaj",
    symbol: "marmaj",
    name: "Marmaj",
  },
  {
    id: "mar-network",
    symbol: "mars",
    name: "Mars Network",
  },
  {
    id: "marnotaur",
    symbol: "taur",
    name: "Marnotaur",
  },
  {
    id: "mars",
    symbol: "mars",
    name: "Mars",
  },
  {
    id: "mars4",
    symbol: "mars4",
    name: "MARS4",
  },
  {
    id: "marscoin",
    symbol: "mars",
    name: "Marscoin",
  },
  {
    id: "marscolony",
    symbol: "clny",
    name: "MarsColony",
  },
  {
    id: "marsdao",
    symbol: "mdao",
    name: "MarsDAO",
  },
  {
    id: "mars-doge",
    symbol: "marsdoge",
    name: "Mars Doge",
  },
  {
    id: "mars-dogecoin",
    symbol: "mdc",
    name: "Mars DogeCoin",
  },
  {
    id: "mars-ecosystem-token",
    symbol: "xms",
    name: "Mars Ecosystem",
  },
  {
    id: "mars-floki-inu",
    symbol: "floki",
    name: "Mars Floki Inu",
  },
  {
    id: "marshal-lion-group-coin",
    symbol: "mlgc",
    name: "Marshal Lion Group Coin",
  },
  {
    id: "marshall-rogan-inu",
    symbol: "mri",
    name: "Marshall Inu",
  },
  {
    id: "marshmellowdefi",
    symbol: "mash",
    name: "MarshmallowDeFi",
  },
  {
    id: "mars-inu",
    symbol: "marsinu",
    name: "Mars Inu",
  },
  {
    id: "mars-panda-world",
    symbol: "mpt",
    name: "Mars Panda World",
  },
  {
    id: "mars-protocol",
    symbol: "mars",
    name: "Mars Protocol",
  },
  {
    id: "marsrise",
    symbol: "marsrise",
    name: "MarsRise",
  },
  {
    id: "mars-space-x",
    symbol: "mpx",
    name: "Mars Space X",
  },
  {
    id: "mars-token",
    symbol: "omt",
    name: "Mars OMT",
  },
  {
    id: "marsupilamii",
    symbol: "mars",
    name: "Marsupilamii",
  },
  {
    id: "marsx",
    symbol: "mx",
    name: "MarsX",
  },
  {
    id: "martexcoin",
    symbol: "mxt",
    name: "MarteXcoin",
  },
  {
    id: "martiandoge",
    symbol: "martiandoge",
    name: "MartianDoge",
  },
  {
    id: "martkist",
    symbol: "martk",
    name: "Martkist",
  },
  {
    id: "marvelous-nfts",
    symbol: "mnft",
    name: "Marvelous NFTs",
  },
  {
    id: "marvininu",
    symbol: "marvin",
    name: "MarvinInu",
  },
  {
    id: "marvin-inu",
    symbol: "marvin",
    name: "Marvin Inu",
  },
  {
    id: "marx",
    symbol: "marx",
    name: "MarX",
  },
  {
    id: "marxcoin",
    symbol: "marx",
    name: "MarxCoin",
  },
  {
    id: "masari",
    symbol: "msr",
    name: "Masari",
  },
  {
    id: "maskdoge",
    symbol: "md3",
    name: "MaskDogeV3",
  },
  {
    id: "mask-network",
    symbol: "mask",
    name: "Mask Network",
  },
  {
    id: "mask-vault-nftx",
    symbol: "mask",
    name: "MASK Vault (NFTX)",
  },
  {
    id: "masq",
    symbol: "masq",
    name: "MASQ",
  },
  {
    id: "mass",
    symbol: "mass",
    name: "MASS",
  },
  {
    id: "massive-protocol",
    symbol: "mav",
    name: "Massive Protocol",
  },
  {
    id: "mass-vehicle-ledger",
    symbol: "mvl",
    name: "MVL",
  },
  {
    id: "master-contract-token",
    symbol: "mct",
    name: "Master Contract",
  },
  {
    id: "master-floki",
    symbol: "master",
    name: "Master Floki",
  },
  {
    id: "masternodesme",
    symbol: "mnme",
    name: "MasterNodesME",
  },
  {
    id: "masterwin",
    symbol: "mw",
    name: "MasterWin",
  },
  {
    id: "mata",
    symbol: "mata",
    name: "Mata",
  },
  {
    id: "matador-token",
    symbol: "mtdr",
    name: "Matador",
  },
  {
    id: "matchpool",
    symbol: "gup",
    name: "Guppy",
  },
  {
    id: "mate",
    symbol: "mate",
    name: "Mate",
  },
  {
    id: "material",
    symbol: "mtrl",
    name: "Material",
  },
  {
    id: "materium",
    symbol: "mtrm",
    name: "Materium",
  },
  {
    id: "math",
    symbol: "math",
    name: "MATH",
  },
  {
    id: "math-token-wormhole",
    symbol: "math",
    name: "MATH Token (Wormhole)",
  },
  {
    id: "matic-aave-aave",
    symbol: "maaave",
    name: "Matic Aave Interest Bearing AAVE",
  },
  {
    id: "matic-aave-usdc",
    symbol: "mausdc",
    name: "Matic Aave Interest Bearing USDC",
  },
  {
    id: "matic-aave-weth",
    symbol: "maweth",
    name: "Matic Aave Interest Bearing WETH",
  },
  {
    id: "matic-dai-stablecoin",
    symbol: "dai-matic",
    name: "Matic DAI Stablecoin",
  },
  {
    id: "maticlaunch",
    symbol: "mtcl",
    name: "MaticLaunch",
  },
  {
    id: "matic-launchpad",
    symbol: "maticpad",
    name: "Matic Launchpad",
  },
  {
    id: "matic-network",
    symbol: "matic",
    name: "Polygon",
  },
  {
    id: "maticpad",
    symbol: "matpad",
    name: "MaticPad",
  },
  {
    id: "maticverse",
    symbol: "mverse",
    name: "MaticVerse",
  },
  {
    id: "matic-wormhole",
    symbol: "maticpo",
    name: "MATIC (Wormhole)",
  },
  {
    id: "matic-wormhole-from-ethereum",
    symbol: "maticet",
    name: "Matic (Wormhole from Ethereum)",
  },
  {
    id: "matrexcoin",
    symbol: "mac",
    name: "Matrexcoin",
  },
  {
    id: "matrix-2",
    symbol: "mtix",
    name: "Matrix",
  },
  {
    id: "matrix-ai-network",
    symbol: "man",
    name: "Matrix AI Network",
  },
  {
    id: "matrixcoin",
    symbol: "mc",
    name: "MatrixCoin",
  },
  {
    id: "matrixetf",
    symbol: "mdf",
    name: "MatrixETF",
  },
  {
    id: "matrix-protocol",
    symbol: "mtx",
    name: "Matrix Protocol",
  },
  {
    id: "matrix-samurai",
    symbol: "mxs",
    name: "Marketing Samurai",
  },
  {
    id: "matrix-solana-index",
    symbol: "msi",
    name: "Matrix Solana Index",
  },
  {
    id: "matrixswap",
    symbol: "matrix",
    name: "Matrix Labs",
  },
  {
    id: "matryx",
    symbol: "mtx",
    name: "MATRYX",
  },
  {
    id: "mavaverse-token",
    symbol: "mvx",
    name: "Mavaverse",
  },
  {
    id: "maxcoin",
    symbol: "max",
    name: "Maxcoin",
  },
  {
    id: "maxgoat",
    symbol: "maxgoat",
    name: "MaxGoat",
  },
  {
    id: "maximizer",
    symbol: "maxi",
    name: "Maximizer",
  },
  {
    id: "maximus",
    symbol: "maxi",
    name: "Maximus",
  },
  {
    id: "maximus-dao",
    symbol: "maxi",
    name: "Maximus DAO",
  },
  {
    id: "maxonrow",
    symbol: "mxw",
    name: "Maxonrow",
  },
  {
    id: "max-property-group",
    symbol: "mcf",
    name: "Max Crowdfund",
  },
  {
    id: "max-revive",
    symbol: "maxr",
    name: "Max Revive",
  },
  {
    id: "max-token",
    symbol: "max",
    name: "MAX",
  },
  {
    id: "maya-preferred-223",
    symbol: "mayp",
    name: "Maya Preferred",
  },
  {
    id: "maza",
    symbol: "mzc",
    name: "Maza",
  },
  {
    id: "mbd-financials",
    symbol: "mbd",
    name: "MBD Financials",
  },
  {
    id: "mbitbooks",
    symbol: "mbit",
    name: "MBitBooks",
  },
  {
    id: "mcat",
    symbol: "mcat",
    name: "mCat",
  },
  {
    id: "mcdex",
    symbol: "mcb",
    name: "MCDEX",
  },
  {
    id: "mcdoge",
    symbol: "mcdoge",
    name: "McDoge",
  },
  {
    id: "mcelo",
    symbol: "mcelo",
    name: "mCELO",
  },
  {
    id: "mceur",
    symbol: "mceur",
    name: "mcEUR",
  },
  {
    id: "mcfinance",
    symbol: "mcf",
    name: "MCFinance",
  },
  {
    id: "mchain",
    symbol: "mar",
    name: "Mchain",
  },
  {
    id: "mch-coin",
    symbol: "mchc",
    name: "MCH Coin",
  },
  {
    id: "mci-coin",
    symbol: "cyclub",
    name: "Cyclub",
  },
  {
    id: "mcn-ventures",
    symbol: "mcn",
    name: "MCN Ventures",
  },
  {
    id: "mcobit",
    symbol: "mct",
    name: "Mcobit",
  },
  {
    id: "mcoin1",
    symbol: "mcoin",
    name: "mCoin",
  },
  {
    id: "mcontent",
    symbol: "mcontent",
    name: "MContent",
  },
  {
    id: "mcpepe",
    symbol: "mcpepe",
    name: "MCPEPE",
  },
  {
    id: "mcs-token",
    symbol: "mcs",
    name: "MCS",
  },
  {
    id: "mdex",
    symbol: "mdx",
    name: "Mdex",
  },
  {
    id: "mdsquare",
    symbol: "tmed",
    name: "MDsquare",
  },
  {
    id: "mdtoken",
    symbol: "mdtk",
    name: "MDT",
  },
  {
    id: "mdu",
    symbol: "mdu",
    name: "MDUKEY",
  },
  {
    id: "mead",
    symbol: "mead",
    name: "Mead",
  },
  {
    id: "meals",
    symbol: "meals",
    name: "MEALS",
  },
  {
    id: "meanfi",
    symbol: "mean",
    name: "Meanfi",
  },
  {
    id: "mean-tamato",
    symbol: "meantamato",
    name: "Mean Tamato",
  },
  {
    id: "measurable-data-token",
    symbol: "mdt",
    name: "Measurable Data",
  },
  {
    id: "meblox-protocol",
    symbol: "meb",
    name: "Meblox Protocol",
  },
  {
    id: "mechachain",
    symbol: "$mecha",
    name: "MechaChain",
  },
  {
    id: "mecha-morphing",
    symbol: "mape",
    name: "Mecha Morphing",
  },
  {
    id: "mechashiba",
    symbol: "mec",
    name: "MechaShiba",
  },
  {
    id: "mecha-tracker",
    symbol: "mecha",
    name: "Mecha Tracker",
  },
  {
    id: "mech-master",
    symbol: "mech",
    name: "Mech Master",
  },
  {
    id: "meconcash",
    symbol: "mch",
    name: "Meconcash",
  },
  {
    id: "mecro-coin",
    symbol: "mec",
    name: "Mecro Coin",
  },
  {
    id: "medacoin",
    symbol: "meda",
    name: "Medacoin",
  },
  {
    id: "medamon",
    symbol: "mon",
    name: "Medamon",
  },
  {
    id: "medano",
    symbol: "mdo",
    name: "Medano",
  },
  {
    id: "medcarecoin",
    symbol: "mcc",
    name: "MedCareCoin",
  },
  {
    id: "media-eye",
    symbol: "eye",
    name: "MeDIA eYe",
  },
  {
    id: "media-licensing-token",
    symbol: "mlt",
    name: "Media Licensing",
  },
  {
    id: "media-network",
    symbol: "media",
    name: "Media Network",
  },
  {
    id: "medibit",
    symbol: "medibit",
    name: "MEDIBIT",
  },
  {
    id: "medibloc",
    symbol: "med",
    name: "Medibloc",
  },
  {
    id: "medicalchain",
    symbol: "mtn",
    name: "Medicalchain",
  },
  {
    id: "medical-token-currency",
    symbol: "mtc",
    name: "Doc.com",
  },
  {
    id: "medicalveda",
    symbol: "mveda",
    name: "MedicalVeda",
  },
  {
    id: "medican-coin",
    symbol: "mcan",
    name: "Medican Coin",
  },
  {
    id: "medic-coin",
    symbol: "medic",
    name: "Medic Coin",
  },
  {
    id: "mediconnect",
    symbol: "medi",
    name: "MediConnect",
  },
  {
    id: "medifakt",
    symbol: "fakt",
    name: "Medifakt",
  },
  {
    id: "medikhanax",
    symbol: "mkx",
    name: "MedikhanaX",
  },
  {
    id: "medishares",
    symbol: "mds",
    name: "MediShares",
  },
  {
    id: "medi-token",
    symbol: "medi",
    name: "Medi",
  },
  {
    id: "medium",
    symbol: "mdm",
    name: "MEDIUM",
  },
  {
    id: "medooza-ecosystem",
    symbol: "mdza",
    name: "Medooza Ecosystem",
  },
  {
    id: "medping",
    symbol: "mpg",
    name: "Medping",
  },
  {
    id: "medusa",
    symbol: "dusa",
    name: "Medusa",
  },
  {
    id: "meebitsdao-pool",
    symbol: "mbbt",
    name: "MeebitsDAO Pool",
  },
  {
    id: "meeb-master",
    symbol: "meeb",
    name: "Meeb Master",
  },
  {
    id: "meeb-vault-nftx",
    symbol: "meeb",
    name: "MEEB Vault (NFTX)",
  },
  {
    id: "meeds-dao",
    symbol: "meed",
    name: "Meeds DAO",
  },
  {
    id: "meerkat-shares",
    symbol: "mshare",
    name: "Meerkat Shares",
  },
  {
    id: "meetone",
    symbol: "meetone",
    name: "MEET.ONE",
  },
  {
    id: "meetple",
    symbol: "mpt",
    name: "Meetple",
  },
  {
    id: "megabonk",
    symbol: "mbonk",
    name: "megaBonk",
  },
  {
    id: "megacoin",
    symbol: "mec",
    name: "Megacoin",
  },
  {
    id: "megacryptopolis",
    symbol: "mega",
    name: "MegaCryptoPolis",
  },
  {
    id: "megadao",
    symbol: "megadao",
    name: "MegaDAO",
  },
  {
    id: "mega-lottery-services-global",
    symbol: "mlr",
    name: "Mega Lottery Services Global",
  },
  {
    id: "megamoon",
    symbol: "mgmoon",
    name: "MegaMoon",
  },
  {
    id: "megashibazilla",
    symbol: "msz",
    name: "MegaShibaZilla",
  },
  {
    id: "megatech",
    symbol: "mgt",
    name: "Megatech",
  },
  {
    id: "megatoken",
    symbol: "mega",
    name: "MegaToken",
  },
  {
    id: "megaweapon",
    symbol: "$weapon",
    name: "Megaweapon",
  },
  {
    id: "megla-doge",
    symbol: "mgd",
    name: "Megla Doge",
  },
  {
    id: "meishu",
    symbol: "meishu",
    name: "Meishu",
  },
  {
    id: "meka",
    symbol: "meka",
    name: "MekaMiners",
  },
  {
    id: "mekkafroggo",
    symbol: "mekka",
    name: "MekkaFroggo",
  },
  {
    id: "mekka-froggo",
    symbol: "lfgo",
    name: "Mekka Froggo",
  },
  {
    id: "melalie",
    symbol: "mel",
    name: "MELX",
  },
  {
    id: "meland-ai",
    symbol: "meld",
    name: "Meland.ai",
  },
  {
    id: "meld",
    symbol: "meld",
    name: "MELD",
  },
  {
    id: "meld-gold",
    symbol: "mcau",
    name: "Meld Gold",
  },
  {
    id: "meli-games",
    symbol: "meli",
    name: "Meli Games",
  },
  {
    id: "meliodas",
    symbol: "meliodas",
    name: "Meliodas",
  },
  {
    id: "meliora",
    symbol: "mora",
    name: "Meliora",
  },
  {
    id: "melody",
    symbol: "melody",
    name: "Melody",
  },
  {
    id: "melon",
    symbol: "mln",
    name: "Enzyme",
  },
  {
    id: "melonheadsprotocol",
    symbol: "mhsp",
    name: "MelonHeadSProtocol",
  },
  {
    id: "melonx",
    symbol: "$mlnx",
    name: "MELONx",
  },
  {
    id: "melos-studio",
    symbol: "melos",
    name: "Melos Studio",
  },
  {
    id: "melo-token",
    symbol: "melo",
    name: "Melo",
  },
  {
    id: "membrana-platform",
    symbol: "mbn",
    name: "Membrana",
  },
  {
    id: "meme-chain-capital",
    symbol: "memes",
    name: "Meme Chain Capital",
  },
  {
    id: "memecoin",
    symbol: "mem",
    name: "Memecoin",
  },
  {
    id: "memecoin-factory",
    symbol: "factory",
    name: "Memecoin Factory",
  },
  {
    id: "memecoinuniverse",
    symbol: "mcu",
    name: "MemeCoinUniverse",
  },
  {
    id: "meme-doge-coin",
    symbol: "memedoge",
    name: "Meme Doge Coin",
  },
  {
    id: "meme-elon-doge-floki",
    symbol: "memelon",
    name: "Meme Elon Doge Floki",
  },
  {
    id: "memeflate",
    symbol: "mflate",
    name: "Memeflate",
  },
  {
    id: "meme-inu",
    symbol: "meme",
    name: "Meme Inu",
  },
  {
    id: "meme-kong",
    symbol: "mkong",
    name: "Meme Kong",
  },
  {
    id: "meme-lordz",
    symbol: "$lordz",
    name: "Meme Lordz",
  },
  {
    id: "meme-ltd",
    symbol: "meme20",
    name: "MEME LTD",
  },
  {
    id: "meme-machine",
    symbol: "mema",
    name: "Meme Machine",
  },
  {
    id: "memenft",
    symbol: "mnft",
    name: "MemeNFT",
  },
  {
    id: "memenopoly-money",
    symbol: "mnop",
    name: "Memenopoly Money",
  },
  {
    id: "memepad",
    symbol: "mepad",
    name: "MemePad",
  },
  {
    id: "memes-token",
    symbol: "memes",
    name: "Memes",
  },
  {
    id: "memetic",
    symbol: "meme",
    name: "Memetic",
  },
  {
    id: "memeverse",
    symbol: "meme",
    name: "Memeverse",
  },
  {
    id: "memewars",
    symbol: "mwar",
    name: "MemeWars",
  },
  {
    id: "memex",
    symbol: "memex",
    name: "MEMEX",
  },
  {
    id: "menapay",
    symbol: "mpay",
    name: "Menapay",
  },
  {
    id: "menlo-one",
    symbol: "one",
    name: "Menlo One",
  },
  {
    id: "mensa",
    symbol: "msa",
    name: "Mensa",
  },
  {
    id: "mensa-protocol",
    symbol: "mensa",
    name: "Mensa Protocol",
  },
  {
    id: "meong-token",
    symbol: "meong",
    name: "Meong",
  },
  {
    id: "meo-tools",
    symbol: "meo",
    name: "Meo.tools",
  },
  {
    id: "meownaut",
    symbol: "mnt",
    name: "Meownaut",
  },
  {
    id: "meowswap-token",
    symbol: "meow",
    name: "MeowSwap",
  },
  {
    id: "mercenary",
    symbol: "mgold",
    name: "Mercenary",
  },
  {
    id: "merchant-token",
    symbol: "mto",
    name: "Merchant",
  },
  {
    id: "merchdao",
    symbol: "mrch",
    name: "MerchDAO",
  },
  {
    id: "mercor-finance",
    symbol: "mrcr",
    name: "Mercor Finance",
  },
  {
    id: "merculet",
    symbol: "mvp",
    name: "Merculet",
  },
  {
    id: "mercurial",
    symbol: "mer",
    name: "Mercurial",
  },
  {
    id: "mercury",
    symbol: "mer",
    name: "Mercury",
  },
  {
    id: "mercury-tools",
    symbol: "mercury",
    name: "Mercury Tools",
  },
  {
    id: "merebel",
    symbol: "meri",
    name: "Merebel",
  },
  {
    id: "merge",
    symbol: "merge",
    name: "Merge",
  },
  {
    id: "meridian-network",
    symbol: "lock",
    name: "Meridian Network",
  },
  {
    id: "merit-circle",
    symbol: "mc",
    name: "Merit Circle",
  },
  {
    id: "merkle-network",
    symbol: "merkle",
    name: "Merkle Network",
  },
  {
    id: "mermaid",
    symbol: "merd",
    name: "Mermaid",
  },
  {
    id: "meschain",
    symbol: "mes",
    name: "MesChain",
  },
  {
    id: "mesefa",
    symbol: "sefa",
    name: "Mesefa",
  },
  {
    id: "meshbox",
    symbol: "mesh",
    name: "MeshBox",
  },
  {
    id: "meshswap-protocol",
    symbol: "mesh",
    name: "Meshswap Protocol",
  },
  {
    id: "meta",
    symbol: "mta",
    name: "mStable Governance: Meta",
  },
  {
    id: "meta3",
    symbol: "mt3",
    name: "Meta3",
  },
  {
    id: "meta-age-of-empires",
    symbol: "maoe",
    name: "Meta Age of Empires",
  },
  {
    id: "metaair",
    symbol: "mair",
    name: "MetaAir",
  },
  {
    id: "metaaltpad",
    symbol: "map",
    name: "MetaAltPad",
  },
  {
    id: "meta-apes",
    symbol: "mapes",
    name: "Meta Apes",
  },
  {
    id: "metaaudio",
    symbol: "audiom",
    name: "MetaAudio",
  },
  {
    id: "metaaxis",
    symbol: "mta",
    name: "MetaAxis",
  },
  {
    id: "metabean",
    symbol: "metabean",
    name: "MetaBean",
  },
  {
    id: "metabet",
    symbol: "mbet",
    name: "MetaBET",
  },
  {
    id: "metabike",
    symbol: "mbike",
    name: "Metabike",
  },
  {
    id: "meta-billionaires-club",
    symbol: "metabc",
    name: "Meta Billionaires Club",
  },
  {
    id: "metablackout",
    symbol: "mbt",
    name: "MetaBlackout",
  },
  {
    id: "metabolic",
    symbol: "mtbc",
    name: "Metabolic",
  },
  {
    id: "metabomb",
    symbol: "mtb",
    name: "MetaBomb",
  },
  {
    id: "metabots",
    symbol: "mtb",
    name: "MetaBots",
  },
  {
    id: "metabrands",
    symbol: "mage",
    name: "MetaBrands",
  },
  {
    id: "meta-brawl",
    symbol: "brawl",
    name: "Meta Brawl",
  },
  {
    id: "meta-bsc",
    symbol: "meta",
    name: "Meta BSC",
  },
  {
    id: "metabullrage",
    symbol: "berage",
    name: "Metabullrage",
  },
  {
    id: "metabullrun",
    symbol: "mbr",
    name: "MetaBullRun",
  },
  {
    id: "metabusdcoin",
    symbol: "mbc",
    name: "MetaBUSDCoin",
  },
  {
    id: "metabusiness",
    symbol: "mefi",
    name: "Metabusiness",
  },
  {
    id: "meta-capital",
    symbol: "mcap",
    name: "Meta Capital",
  },
  {
    id: "meta-car",
    symbol: "meta car",
    name: "Meta Car",
  },
  {
    id: "metacash",
    symbol: "meta",
    name: "MetaCash",
  },
  {
    id: "meta-cat",
    symbol: "mcat",
    name: "Meta Cat",
  },
  {
    id: "metacelo",
    symbol: "cmeta",
    name: "MetaCelo",
  },
  {
    id: "metachess",
    symbol: "shah",
    name: "MetaChess",
  },
  {
    id: "metaclash",
    symbol: "pcore",
    name: "MetaClash",
  },
  {
    id: "meta-cloth",
    symbol: "meta cloth",
    name: "Meta Cloth",
  },
  {
    id: "meta-club",
    symbol: "club",
    name: "Meta Club",
  },
  {
    id: "metacoin",
    symbol: "mtc",
    name: "Metacoin",
  },
  {
    id: "metacontinental",
    symbol: "con",
    name: "MetaContinental",
  },
  {
    id: "meta-course",
    symbol: "course",
    name: "Meta Course",
  },
  {
    id: "metacraft",
    symbol: "mct",
    name: "Metacraft",
  },
  {
    id: "meta-decentraland",
    symbol: "mdl",
    name: "Meta Decentraland",
  },
  {
    id: "metaderby",
    symbol: "dby",
    name: "Metaderby",
  },
  {
    id: "metaderby-hoof",
    symbol: "hoof",
    name: "Metaderby Hoof",
  },
  {
    id: "metadium",
    symbol: "meta",
    name: "Metadium",
  },
  {
    id: "metadoctor",
    symbol: "medoc",
    name: "MetaDoctor",
  },
  {
    id: "meta-doge",
    symbol: "metadoge",
    name: "Meta Doge",
  },
  {
    id: "metadogeswap",
    symbol: "mds",
    name: "MetaDogeSwap",
  },
  {
    id: "metadoge-v2",
    symbol: "metadogev2",
    name: "MetaDoge V2",
  },
  {
    id: "metadog-racing",
    symbol: "dog$",
    name: "MetaDog Racing",
  },
  {
    id: "metadrace",
    symbol: "drace",
    name: "MetaDrace",
  },
  {
    id: "meta-dragon-city",
    symbol: "dragon",
    name: "Meta Dragon City",
  },
  {
    id: "metadress",
    symbol: "mtd",
    name: "MetaDress",
  },
  {
    id: "metadubai",
    symbol: "mdb",
    name: "MetaDubai",
  },
  {
    id: "metafabric",
    symbol: "fabric",
    name: "MetaFabric",
  },
  {
    id: "metaface",
    symbol: "mft",
    name: "MetaFace",
  },
  {
    id: "metafarm-dao",
    symbol: "metafarm",
    name: "MetaFarm DAO",
  },
  {
    id: "meta-farmer-finance",
    symbol: "mff",
    name: "Meta Farmer Finance",
  },
  {
    id: "metafashioners",
    symbol: "mfs",
    name: "MetaFashioners",
  },
  {
    id: "metaficial-world",
    symbol: "mw",
    name: "Metaficial World",
  },
  {
    id: "metafighter",
    symbol: "mf",
    name: "MetaFighter",
  },
  {
    id: "metafinance",
    symbol: "mfi",
    name: "MetaFinance",
  },
  {
    id: "meta_finance",
    symbol: "mf1",
    name: "Meta Finance",
  },
  {
    id: "metafish",
    symbol: "fish",
    name: "Metafish",
  },
  {
    id: "metaflip",
    symbol: "metaflip",
    name: "MetaFlip",
  },
  {
    id: "meta-floki",
    symbol: "mfloki",
    name: "Meta Floki",
  },
  {
    id: "meta-flokimon-go",
    symbol: "metaflokimg",
    name: "Meta FlokiMon Go",
  },
  {
    id: "metafluence",
    symbol: "meto",
    name: "Metafluence",
  },
  {
    id: "metafocus",
    symbol: "metafocus",
    name: "MetaFocus",
  },
  {
    id: "metafootball",
    symbol: "mtf",
    name: "MetaFootball",
  },
  {
    id: "metagalaxy",
    symbol: "mgxy",
    name: "Metagalaxy",
  },
  {
    id: "metagalaxy-land",
    symbol: "megaland",
    name: "Metagalaxy Land",
  },
  {
    id: "metagame",
    symbol: "seed",
    name: "MetaGame",
  },
  {
    id: "metagame-arena",
    symbol: "mga",
    name: "Metagame Arena",
  },
  {
    id: "metagamehub-dao",
    symbol: "mgh",
    name: "MetaGameHub DAO",
  },
  {
    id: "metagamespace",
    symbol: "metags",
    name: "MetaGameSpace",
  },
  {
    id: "metagaming-guild",
    symbol: "mgg",
    name: "MetaGaming Guild",
  },
  {
    id: "metagamz",
    symbol: "metag",
    name: "MetagamZ",
  },
  {
    id: "metagear",
    symbol: "gear",
    name: "MetaGear",
  },
  {
    id: "metagin",
    symbol: "metagin",
    name: "MetaGin",
  },
  {
    id: "metagochi",
    symbol: "mgchi",
    name: "Metagochi",
  },
  {
    id: "metagods",
    symbol: "mgod",
    name: "MetaGods",
  },
  {
    id: "metagon",
    symbol: "metagon",
    name: "Metagon",
  },
  {
    id: "metagox",
    symbol: "mtx",
    name: "Metagox",
  },
  {
    id: "meta-grow",
    symbol: "meta",
    name: "META GROW",
  },
  {
    id: "meta-hangry-games",
    symbol: "mhg",
    name: "Meta Hangry Games",
  },
  {
    id: "metahash",
    symbol: "mhc",
    name: "#MetaHash",
  },
  {
    id: "metahero",
    symbol: "hero",
    name: "Metahero",
  },
  {
    id: "meta-house",
    symbol: "meta house",
    name: "Meta House",
  },
  {
    id: "meta-inu-token",
    symbol: "meta",
    name: "Meta Inu Token",
  },
  {
    id: "meta-islands",
    symbol: "igo",
    name: "Meta Islands",
  },
  {
    id: "metakeeper",
    symbol: "mkp",
    name: "MetaKeeper",
  },
  {
    id: "metakings",
    symbol: "mtk",
    name: "Metakings",
  },
  {
    id: "meta-knight",
    symbol: "metaknight",
    name: "Meta Knight",
  },
  {
    id: "metakombat",
    symbol: "kombat",
    name: "MetaKombat",
  },
  {
    id: "meta-kongz",
    symbol: "mkc",
    name: "Meta Kongz",
  },
  {
    id: "metal",
    symbol: "mtl",
    name: "Metal",
  },
  {
    id: "metalama",
    symbol: "lama",
    name: "MetaLama",
  },
  {
    id: "metaland-dao",
    symbol: "meta",
    name: "Metaland DAO",
  },
  {
    id: "metaland-gameverse",
    symbol: "mst",
    name: "Monster",
  },
  {
    id: "meta-land-yield",
    symbol: "mly",
    name: "Meta Land Yield",
  },
  {
    id: "metalandz",
    symbol: "$metaz",
    name: "MetaLandz",
  },
  {
    id: "metal-backed-money",
    symbol: "mbmx",
    name: "Metal Backed Money",
  },
  {
    id: "meta-legends",
    symbol: "metal",
    name: "Meta Legends",
  },
  {
    id: "metalk",
    symbol: "meta",
    name: "Metalk",
  },
  {
    id: "metal-music-coin",
    symbol: "mtlmc3",
    name: "Metal Music Coin",
  },
  {
    id: "metaloop-tech",
    symbol: "mlt",
    name: "Metaloop Tech",
  },
  {
    id: "metal-packaging-token",
    symbol: "mpt",
    name: "Metal Packaging",
  },
  {
    id: "metalswap",
    symbol: "xmt",
    name: "MetalSwap",
  },
  {
    id: "metaluna",
    symbol: "metaluna",
    name: "MetaLuna",
  },
  {
    id: "metamall",
    symbol: "mall",
    name: "MetaMall",
  },
  {
    id: "metamaps",
    symbol: "mema",
    name: "MetaMaps",
  },
  {
    id: "metamars",
    symbol: "metam",
    name: "MetaMars",
  },
  {
    id: "metamate",
    symbol: "mtm",
    name: "MetaMate",
  },
  {
    id: "metamatrix",
    symbol: "mtx",
    name: "MetaMatrix",
  },
  {
    id: "metamerce",
    symbol: "merce",
    name: "MetaMerce",
  },
  {
    id: "meta-monstas",
    symbol: "monsta",
    name: "Meta Monstas",
  },
  {
    id: "metamoon",
    symbol: "metamoon",
    name: "MetaMoon",
  },
  {
    id: "metamorph",
    symbol: "metm",
    name: "MetaMorph",
  },
  {
    id: "metamounts",
    symbol: "mount",
    name: "MetaMounts",
  },
  {
    id: "metamui",
    symbol: "mmui",
    name: "MetaMUI",
  },
  {
    id: "meta-musk",
    symbol: "meta",
    name: "Meta Musk",
  },
  {
    id: "meta-mvrs",
    symbol: "mvrs",
    name: "Meta MVRS",
  },
  {
    id: "metanations",
    symbol: "mena",
    name: "MetaNations",
  },
  {
    id: "metan-evolutions",
    symbol: "metan",
    name: "Metan Evolutions",
  },
  {
    id: "metanft",
    symbol: "mnft",
    name: "MetaNFT",
  },
  {
    id: "metanftgaming",
    symbol: "mng",
    name: "MetaNFTGaming",
  },
  {
    id: "metaniagames",
    symbol: "metania",
    name: "MetaniaGames",
  },
  {
    id: "metanyx",
    symbol: "metx",
    name: "Metanyx",
  },
  {
    id: "metapad",
    symbol: "mpd",
    name: "Metapad",
  },
  {
    id: "metapay",
    symbol: "mpay",
    name: "Metapay",
  },
  {
    id: "metapets",
    symbol: "metapets",
    name: "MetaPets",
  },
  {
    id: "metapixel",
    symbol: "mepix",
    name: "MetaPixel",
  },
  {
    id: "metaplace",
    symbol: "mpc",
    name: "Metaplace",
  },
  {
    id: "metaplanet",
    symbol: "mpl",
    name: "MetaPlanet",
  },
  {
    id: "metaplay",
    symbol: "mplay",
    name: "MetaPlay [OLD]",
  },
  {
    id: "metaplayers-gg",
    symbol: "fps",
    name: "MetaPlayers.gg",
  },
  {
    id: "meta-pool",
    symbol: "meta",
    name: "Meta Pool",
  },
  {
    id: "metaportal-gaming-index",
    symbol: "game",
    name: "MetaPortal Gaming Index",
  },
  {
    id: "metapplay",
    symbol: "metap",
    name: "MetapPlay",
  },
  {
    id: "metaprints",
    symbol: "",
    name: "Metaprints",
  },
  {
    id: "metaq",
    symbol: "metaq",
    name: "MetaQ",
  },
  {
    id: "metaraca",
    symbol: "metar",
    name: "MetaRaca",
  },
  {
    id: "metaracers",
    symbol: "mrs",
    name: "MetaRacers",
  },
  {
    id: "metarare",
    symbol: "mtra",
    name: "MetaRare",
  },
  {
    id: "metarealm",
    symbol: "mrlm",
    name: "MetaRealm",
  },
  {
    id: "metareserve",
    symbol: "power",
    name: "MetaReserve",
  },
  {
    id: "metarim",
    symbol: "rim",
    name: "MetaRim",
  },
  {
    id: "metarobox",
    symbol: "rbx",
    name: "Metarobox",
  },
  {
    id: "metaroid-nft",
    symbol: "metaroid",
    name: "Metaroid NFT",
  },
  {
    id: "metaroyale",
    symbol: "mrvr",
    name: "MetaRoyale",
  },
  {
    id: "metars",
    symbol: "mtsc",
    name: "Metars",
  },
  {
    id: "meta-ruffy",
    symbol: "mr",
    name: "Meta Ruffy",
  },
  {
    id: "metarun",
    symbol: "mrun",
    name: "Metarun",
  },
  {
    id: "metasafemoon",
    symbol: "metasfm",
    name: "MetaSafeMoon",
  },
  {
    id: "metaseer",
    symbol: "metas",
    name: "Metaseer",
  },
  {
    id: "metasens",
    symbol: "msu",
    name: "Metasens",
  },
  {
    id: "meta-shark",
    symbol: "mts",
    name: "Meta Shark",
  },
  {
    id: "metashells",
    symbol: "shell",
    name: "MetaShells",
  },
  {
    id: "metashiba",
    symbol: "metashib",
    name: "MetaShiba",
  },
  {
    id: "meta-shiba",
    symbol: "mshiba",
    name: "Meta Shiba",
  },
  {
    id: "metashib-token",
    symbol: "metashib",
    name: "MetaShib",
  },
  {
    id: "meta-shield",
    symbol: "shield",
    name: "Meta Shield",
  },
  {
    id: "metashooter",
    symbol: "mhunt",
    name: "MetaShooter",
  },
  {
    id: "meta-skinny-hope",
    symbol: "metash",
    name: "Meta Skinny&Hope",
  },
  {
    id: "metasnooker",
    symbol: "msr",
    name: "MetaSnooker",
  },
  {
    id: "metasoccer",
    symbol: "msu",
    name: "MetaSoccer",
  },
  {
    id: "metaspace",
    symbol: "mspace",
    name: "Metaspace",
  },
  {
    id: "metaspace-reit",
    symbol: "mreit",
    name: "MetaSpace REIT",
  },
  {
    id: "meta-spatial",
    symbol: "spat",
    name: "Meta Spatial",
  },
  {
    id: "metaspets",
    symbol: "msp",
    name: "MetaSpets",
  },
  {
    id: "metasphere",
    symbol: "mtsp",
    name: "Metasphere",
  },
  {
    id: "metastrike",
    symbol: "mts",
    name: "Metastrike",
  },
  {
    id: "metasurvivor",
    symbol: "msg",
    name: "MetaSurvivor",
  },
  {
    id: "metaswap",
    symbol: "msc",
    name: "MetaSwap",
  },
  {
    id: "metatariff",
    symbol: "riff",
    name: "MetaTariff",
  },
  {
    id: "metatoll",
    symbol: "tax",
    name: "MetaToll",
  },
  {
    id: "metatown",
    symbol: "mtown",
    name: "MetaTown",
  },
  {
    id: "metatrone",
    symbol: "met",
    name: "Metatrone",
  },
  {
    id: "metaufo",
    symbol: "metaufo",
    name: "MetaUFO",
  },
  {
    id: "metauniverse",
    symbol: "metauniverse",
    name: "MetaUniverse",
  },
  {
    id: "meta-uranus",
    symbol: "meur",
    name: "Meta Uranus",
  },
  {
    id: "meta-utopia",
    symbol: "land",
    name: "Meta Utopia",
  },
  {
    id: "metavault",
    symbol: "mvd",
    name: "Metavault",
  },
  {
    id: "metavault-trade",
    symbol: "mvx",
    name: "Metavault Trade",
  },
  {
    id: "metavegas",
    symbol: "metavegas",
    name: "MetaVegas",
  },
  {
    id: "metaverseair",
    symbol: "mvrs",
    name: "MetaverseAir",
  },
  {
    id: "metaverse-all-best-ico",
    symbol: "metaallbi",
    name: "Metaverse ALL BEST ICO",
  },
  {
    id: "metaverse-capital",
    symbol: "mvc",
    name: "Metaverse Capital",
  },
  {
    id: "metaverse-dao",
    symbol: "mdao",
    name: "Metaverse DAO",
  },
  {
    id: "metaverse-dog",
    symbol: "mvdg",
    name: "MetaVerse Dog",
  },
  {
    id: "metaverse-dualchain-network-architecture",
    symbol: "dna",
    name: "Metaverse DNA",
  },
  {
    id: "metaverse-etp",
    symbol: "etp",
    name: "Metaverse ETP",
  },
  {
    id: "metaverse-exchange",
    symbol: "metacex",
    name: "Metaverse Exchange",
  },
  {
    id: "metaverse-face",
    symbol: "mefa",
    name: "Metaverse Face",
  },
  {
    id: "metaverse-index",
    symbol: "mvi",
    name: "Metaverse Index",
  },
  {
    id: "metaverse-index-token",
    symbol: "metai",
    name: "Metaverse Index Token",
  },
  {
    id: "metaverse-lab",
    symbol: "mvp",
    name: "Metaverse Lab",
  },
  {
    id: "metaversemgl",
    symbol: "mglc",
    name: "MetaverseMGL",
  },
  {
    id: "metaverse-miner",
    symbol: "meta",
    name: "Metaverse Miner",
  },
  {
    id: "metaverse-network",
    symbol: "metanet",
    name: "Metaverse Network",
  },
  {
    id: "metaverse-nft-index",
    symbol: "play",
    name: "Metaverse NFT Index",
  },
  {
    id: "metaversepro",
    symbol: "meta",
    name: "MetaversePRO",
  },
  {
    id: "metaverse-vr",
    symbol: "mevr",
    name: "Metaverse VR",
  },
  {
    id: "metaversex",
    symbol: "metax",
    name: "MetaverseX",
  },
  {
    id: "metaversus",
    symbol: "metavs",
    name: "MetaVersus",
  },
  {
    id: "metavisa",
    symbol: "mesa",
    name: "metavisa",
  },
  {
    id: "metavpad",
    symbol: "metav",
    name: "MetaVPad",
  },
  {
    id: "metawar",
    symbol: "metawar",
    name: "Metawar",
  },
  {
    id: "metawars",
    symbol: "wars",
    name: "MetaWars",
  },
  {
    id: "metawear",
    symbol: "wear",
    name: "MetaWear",
  },
  {
    id: "metaworld",
    symbol: "mw",
    name: "MetaWorld",
  },
  {
    id: "meta-world",
    symbol: "metaworld",
    name: "Meta World",
  },
  {
    id: "meta-world-game",
    symbol: "mtw",
    name: "Meta World Game",
  },
  {
    id: "metaxhunter",
    symbol: "xhunter",
    name: "MetaXHunter",
  },
  {
    id: "metaxiz",
    symbol: "mexi",
    name: "Metaxiz",
  },
  {
    id: "metaxy",
    symbol: "mxy",
    name: "Metaxy",
  },
  {
    id: "metayoka-spice",
    symbol: "spice",
    name: "Metayoka Spice",
  },
  {
    id: "meta-z",
    symbol: "mzt",
    name: "Meta Z",
  },
  {
    id: "metazilla",
    symbol: "mz",
    name: "MetaZilla",
  },
  {
    id: "metazoon-token",
    symbol: "mez",
    name: "MetaZoon",
  },
  {
    id: "metazuckzilla",
    symbol: "meta",
    name: "MetaZuckZilla",
  },
  {
    id: "meteorite-network",
    symbol: "meteor",
    name: "Meteorite Network",
  },
  {
    id: "meteor-remnants-essence",
    symbol: "mre",
    name: "Meteor Remnants Essence",
  },
  {
    id: "meter",
    symbol: "mtrg",
    name: "Meter Governance",
  },
  {
    id: "meter-governance-mapped-by-meter-io",
    symbol: "emtrg",
    name: "Meter Governance mapped by Meter.io",
  },
  {
    id: "meter-stable",
    symbol: "mtr",
    name: "Meter Stable",
  },
  {
    id: "metfi",
    symbol: "mfi",
    name: "MetFi",
  },
  {
    id: "method-fi",
    symbol: "mthd",
    name: "Method Finance",
  },
  {
    id: "metis",
    symbol: "mts",
    name: "Metis MTS",
  },
  {
    id: "metisrise",
    symbol: "mrise",
    name: "MetisRise",
  },
  {
    id: "metis-token",
    symbol: "metis",
    name: "Metis",
  },
  {
    id: "metoshi",
    symbol: "meto",
    name: "Metoshi",
  },
  {
    id: "metra",
    symbol: "metra",
    name: "Metra",
  },
  {
    id: "metria",
    symbol: "metr",
    name: "Metria Network",
  },
  {
    id: "metric-exchange",
    symbol: "metric",
    name: "MetricExchange",
  },
  {
    id: "metronome",
    symbol: "met",
    name: "Metronome",
  },
  {
    id: "metroverse",
    symbol: "met",
    name: "Metroverse",
  },
  {
    id: "mettalex",
    symbol: "mtlx",
    name: "Mettalex",
  },
  {
    id: "meverse",
    symbol: "mev",
    name: "MEVerse",
  },
  {
    id: "mew-inu",
    symbol: "mew",
    name: "Mew Inu",
  },
  {
    id: "mewn-inu",
    symbol: "mewn",
    name: "Mewn Inu",
  },
  {
    id: "mewtwo-inu",
    symbol: "mewtwo",
    name: "Mewtwo Inu",
  },
  {
    id: "mex",
    symbol: "mex",
    name: "MEX",
  },
  {
    id: "mexc-token",
    symbol: "mexc",
    name: "MEXC",
  },
  {
    id: "mfet",
    symbol: "mfet",
    name: "MFET",
  },
  {
    id: "mgc-token",
    symbol: "mgc",
    name: "MGC",
  },
  {
    id: "mg-social",
    symbol: "mgs",
    name: "MG.Social",
  },
  {
    id: "miami",
    symbol: "miami",
    name: "MIAMI",
  },
  {
    id: "miamicoin",
    symbol: "mia",
    name: "MiamiCoin",
  },
  {
    id: "miami-land",
    symbol: "miami",
    name: "Miami Land",
  },
  {
    id: "mib-coin",
    symbol: "mib",
    name: "MIB Coin",
  },
  {
    id: "microbitcoin",
    symbol: "mbc",
    name: "MicroBitcoin",
  },
  {
    id: "micro-bitcoin-finance",
    symbol: "mbtc",
    name: "Micro Bitcoin Finance",
  },
  {
    id: "microcoin",
    symbol: "mcc",
    name: "MicroCoin",
  },
  {
    id: "microcosm",
    symbol: "mic",
    name: "Microcosm",
  },
  {
    id: "microcredittoken",
    symbol: "1mct",
    name: "MicroCredit",
  },
  {
    id: "microdexwallet",
    symbol: "micro",
    name: "MicroDexWallet",
  },
  {
    id: "micromines",
    symbol: "micro",
    name: "Micromines",
  },
  {
    id: "micromoney",
    symbol: "amm",
    name: "MicroMoney",
  },
  {
    id: "micropets",
    symbol: "pets",
    name: "MicroPets",
  },
  {
    id: "micro-santa-coin",
    symbol: "microsanta",
    name: "Micro Santa Coin",
  },
  {
    id: "microshiba",
    symbol: "microshib",
    name: "MicroSHIBA",
  },
  {
    id: "microsoft-tokenized-stock-defichain",
    symbol: "dmsft",
    name: "Microsoft Tokenized Stock Defichain",
  },
  {
    id: "microtick",
    symbol: "tick",
    name: "Microtick",
  },
  {
    id: "microtuber",
    symbol: "mct",
    name: "MicroTuber",
  },
  {
    id: "microzillas",
    symbol: "mizl",
    name: "MicroZillas",
  },
  {
    id: "midas",
    symbol: "midas",
    name: "Midas",
  },
  {
    id: "midasdao",
    symbol: "crown",
    name: "MidasDAO",
  },
  {
    id: "midas-gold",
    symbol: "mdg",
    name: "Midas Gold",
  },
  {
    id: "midas-protocol",
    symbol: "mas",
    name: "Midas Protocol",
  },
  {
    id: "mie-network",
    symbol: "mie",
    name: "MIE Network",
  },
  {
    id: "migranet",
    symbol: "mig",
    name: "Migranet",
  },
  {
    id: "milestonebased",
    symbol: "mile",
    name: "milestoneBased",
  },
  {
    id: "mileverse",
    symbol: "mvc",
    name: "MileVerse",
  },
  {
    id: "milf-finance",
    symbol: "milf",
    name: "MILF Finance",
  },
  {
    id: "military-finance",
    symbol: "mil",
    name: "Military Finance",
  },
  {
    id: "militia-games",
    symbol: "milit",
    name: "Militia Games",
  },
  {
    id: "milk",
    symbol: "milk",
    name: "Cool Cats Milk",
  },
  {
    id: "milk2",
    symbol: "milk",
    name: "CashCow Protocol Milk",
  },
  {
    id: "milk-alliance",
    symbol: "mlk",
    name: "MiL.k Alliance",
  },
  {
    id: "milk-and-butter",
    symbol: "mb",
    name: "Milk and Butter",
  },
  {
    id: "milkshake",
    symbol: "mshake",
    name: "Milkshake",
  },
  {
    id: "milkshakeswap",
    symbol: "milk",
    name: "Milkshake Swap",
  },
  {
    id: "milkshiba",
    symbol: "mshib",
    name: "MilkShiba",
  },
  {
    id: "milkyswap",
    symbol: "milky",
    name: "MilkySwap",
  },
  {
    id: "milky-token",
    symbol: "milky",
    name: "Milky",
  },
  {
    id: "milkywayex",
    symbol: "milky",
    name: "MilkyWayEx",
  },
  {
    id: "millenniumclub",
    symbol: "mclb",
    name: "MillenniumClub Coin",
  },
  {
    id: "millennium-sapphire",
    symbol: "msto",
    name: "Millennium Sapphire",
  },
  {
    id: "millimeter",
    symbol: "mm",
    name: "Millimeter",
  },
  {
    id: "million",
    symbol: "mm",
    name: "Million",
  },
  {
    id: "millionaire-maker",
    symbol: "million",
    name: "Millionaire Maker",
  },
  {
    id: "million-monke",
    symbol: "mimo",
    name: "Million Monke",
  },
  {
    id: "millionsy",
    symbol: "milli",
    name: "MILLIONSY",
  },
  {
    id: "millonarios-fc-fan-token",
    symbol: "mfc",
    name: "Millonarios FC Fan Token",
  },
  {
    id: "milo-inu",
    symbol: "milo",
    name: "Milo Inu",
  },
  {
    id: "mim",
    symbol: "swarm",
    name: "MIM",
  },
  {
    id: "mimas-finance",
    symbol: "mimas",
    name: "Mimas Finance",
  },
  {
    id: "mimatic",
    symbol: "mimatic",
    name: "MAI",
  },
  {
    id: "mimblewimblecoin",
    symbol: "mwc",
    name: "MimbleWimbleCoin",
  },
  {
    id: "mimir-token",
    symbol: "mimir",
    name: "Mimir",
  },
  {
    id: "mimo-parallel-governance-token",
    symbol: "mimo",
    name: "Mimo Governance",
  },
  {
    id: "mimosa",
    symbol: "mimo",
    name: "Mimosa",
  },
  {
    id: "mina-protocol",
    symbol: "mina",
    name: "Mina Protocol",
  },
  {
    id: "minato",
    symbol: "mnto",
    name: "Minato",
  },
  {
    id: "mincoin",
    symbol: "mnc",
    name: "Mincoin",
  },
  {
    id: "mindcell",
    symbol: "mdc",
    name: "MindCell",
  },
  {
    id: "mindcoin",
    symbol: "mnd",
    name: "MindCoin",
  },
  {
    id: "mindfolk-wood",
    symbol: "$wood",
    name: "Mindfolk Wood",
  },
  {
    id: "mind-music",
    symbol: "mnd",
    name: "Mind Music",
  },
  {
    id: "mindol",
    symbol: "min",
    name: "MINDOL",
  },
  {
    id: "minds",
    symbol: "minds",
    name: "Minds",
  },
  {
    id: "mindsync",
    symbol: "mai",
    name: "Mindsync",
  },
  {
    id: "minebee",
    symbol: "mb",
    name: "MineBee",
  },
  {
    id: "minecrypto",
    symbol: "mcr",
    name: "MineCrypto",
  },
  {
    id: "mine-network",
    symbol: "mnet",
    name: "MINE Network",
  },
  {
    id: "mineral",
    symbol: "mnr",
    name: "Mineral",
  },
  {
    id: "minerblox",
    symbol: "mblox",
    name: "MinerBlox",
  },
  {
    id: "minereum",
    symbol: "mne",
    name: "Minereum",
  },
  {
    id: "minergate-token",
    symbol: "mg",
    name: "MinerGate",
  },
  {
    id: "minerjoe",
    symbol: "gold",
    name: "MinerJoe",
  },
  {
    id: "minersdefi",
    symbol: "miners",
    name: "MinersDefi",
  },
  {
    id: "minerva-wallet",
    symbol: "miva",
    name: "Minerva Wallet",
  },
  {
    id: "mines-of-dalarnia",
    symbol: "dar",
    name: "Mines of Dalarnia",
  },
  {
    id: "mineum",
    symbol: "mnm",
    name: "Mineum",
  },
  {
    id: "mini",
    symbol: "mini",
    name: "Mini",
  },
  {
    id: "mini-baby-doge",
    symbol: "minibabydoge",
    name: "Mini Baby Doge",
  },
  {
    id: "minibitcoin",
    symbol: "mbtc",
    name: "MiniBitcoin",
  },
  {
    id: "minibtc",
    symbol: "minibtc",
    name: "MiniBTC",
  },
  {
    id: "minidoge",
    symbol: "minidoge",
    name: "MiniDOGE",
  },
  {
    id: "mini-doge-pro",
    symbol: "minidogepro",
    name: "Mini Doge Pro",
  },
  {
    id: "mini-floki",
    symbol: "minifloki",
    name: "Mini Floki",
  },
  {
    id: "miniflokiada",
    symbol: "mflokiada",
    name: "MiniFlokiADA",
  },
  {
    id: "minifootball",
    symbol: "minifootball",
    name: "Minifootball",
  },
  {
    id: "minikishimoto-inu",
    symbol: "minikishimoto",
    name: "miniKishimoto Inu",
  },
  {
    id: "minikishu",
    symbol: "minikishu",
    name: "MINIKISHU",
  },
  {
    id: "minima",
    symbol: "minima",
    name: "Minima",
  },
  {
    id: "minimals",
    symbol: "mms",
    name: "Minimals",
  },
  {
    id: "mini-metis",
    symbol: "minime",
    name: "Mini Metis",
  },
  {
    id: "mini-mongoose",
    symbol: "minimongoose",
    name: "mini Mongoose",
  },
  {
    id: "minipanther",
    symbol: "mp",
    name: "MiniPanther",
  },
  {
    id: "minishib-token",
    symbol: "minishib",
    name: "miniSHIB Token",
  },
  {
    id: "minisportzilla",
    symbol: "minisportz",
    name: "MiniSportZilla",
  },
  {
    id: "mini-tiger",
    symbol: "minitiger",
    name: "Mini Tiger",
  },
  {
    id: "miniverse-dollar",
    symbol: "mvdollar",
    name: "MiniVerse Dollar",
  },
  {
    id: "miniverse-share",
    symbol: "mshare",
    name: "Miniverse Share",
  },
  {
    id: "minix",
    symbol: "mnx",
    name: "MiniX",
  },
  {
    id: "miniyak",
    symbol: "myak",
    name: "MiniYAK",
  },
  {
    id: "minmax",
    symbol: "max",
    name: "MinMax",
  },
  {
    id: "minotaur",
    symbol: "mino",
    name: "Minotaur",
  },
  {
    id: "mint-club",
    symbol: "mint",
    name: "Mint Club",
  },
  {
    id: "mintcoin",
    symbol: "mint",
    name: "Mintcoin",
  },
  {
    id: "mintdao",
    symbol: "mint",
    name: "MintDAO",
  },
  {
    id: "minter-hub",
    symbol: "hub",
    name: "Minter Hub",
  },
  {
    id: "minter-network",
    symbol: "bip",
    name: "Minter Network",
  },
  {
    id: "minto",
    symbol: "btcmt",
    name: "Minto",
  },
  {
    id: "mintstarter",
    symbol: "mint",
    name: "MintStarter",
  },
  {
    id: "mintswap",
    symbol: "mint",
    name: "MintSwap",
  },
  {
    id: "mintyswap",
    symbol: "mintys",
    name: "MintySwap",
  },
  {
    id: "miracle-universe",
    symbol: "mu",
    name: "Miracle Universe",
  },
  {
    id: "mirai-token",
    symbol: "mirai",
    name: "Mirai Labs",
  },
  {
    id: "miraqle",
    symbol: "mql",
    name: "MiraQle",
  },
  {
    id: "mirl",
    symbol: "mirl",
    name: "MIRL",
  },
  {
    id: "mirocana",
    symbol: "miro",
    name: "Mirocana",
  },
  {
    id: "mirrored-bitcoin",
    symbol: "mbtc",
    name: "Mirrored Bitcoin",
  },
  {
    id: "mirrored-coca-cola",
    symbol: "mko",
    name: "Mirrored Coca-Cola",
  },
  {
    id: "mirrored-ether",
    symbol: "meth",
    name: "Mirrored Ether",
  },
  {
    id: "mirrored-johnson-johnson",
    symbol: "mjnj",
    name: "Mirrored Johnson & Johnson",
  },
  {
    id: "mirrored-nio",
    symbol: "mnio",
    name: "Mirrored Nio",
  },
  {
    id: "mirrored-nvidia",
    symbol: "mnvda",
    name: "Mirrored Nvidia",
  },
  {
    id: "mirrored-paypal",
    symbol: "mpypl",
    name: "Mirrored Paypal",
  },
  {
    id: "mirrored-starbucks",
    symbol: "msbux",
    name: "Mirrored Starbucks",
  },
  {
    id: "mirror-protocol",
    symbol: "mir",
    name: "Mirror Protocol",
  },
  {
    id: "mirror-world-token",
    symbol: "mw",
    name: "Mirror World",
  },
  {
    id: "misbloc",
    symbol: "msb",
    name: "Misbloc",
  },
  {
    id: "mishka",
    symbol: "msk",
    name: "Mishka",
  },
  {
    id: "mission-helios",
    symbol: "helios",
    name: "Mission Helios",
  },
  {
    id: "mist",
    symbol: "mist",
    name: "Mist",
  },
  {
    id: "mistel-finance",
    symbol: "mistel",
    name: "Mistel Finance",
  },
  {
    id: "mistswap",
    symbol: "mist",
    name: "MistSwap",
  },
  {
    id: "mithril",
    symbol: "mith",
    name: "Mithril",
  },
  {
    id: "mithril-share",
    symbol: "mis",
    name: "Mithril Share",
  },
  {
    id: "mithrilverse",
    symbol: "mithril",
    name: "Mithrilverse",
  },
  {
    id: "mixin",
    symbol: "xin",
    name: "Mixin",
  },
  {
    id: "mixmarvel",
    symbol: "mix",
    name: "MixMarvel",
  },
  {
    id: "mixsome",
    symbol: "some",
    name: "Mixsome",
  },
  {
    id: "mixtrust",
    symbol: "mxt",
    name: "MixTrust",
  },
  {
    id: "mixty-finance",
    symbol: "mxf",
    name: "Mixty Finance",
  },
  {
    id: "miyazaki-inu",
    symbol: "miyazaki",
    name: "Miyazaki Inu",
  },
  {
    id: "mizar",
    symbol: "mzr",
    name: "Mizar",
  },
  {
    id: "mjackswap",
    symbol: "mjack",
    name: "MjackSwap",
  },
  {
    id: "mjewel",
    symbol: "mjewel",
    name: "MJewel",
  },
  {
    id: "mkitty",
    symbol: "mkitty",
    name: "mKitty",
  },
  {
    id: "mktcash",
    symbol: "mch",
    name: "Mktcash",
  },
  {
    id: "mktcoin",
    symbol: "mkt",
    name: "MktCoin",
  },
  {
    id: "mland",
    symbol: "mland",
    name: "Mland",
  },
  {
    id: "mloky",
    symbol: "mloky",
    name: "MLOKY",
  },
  {
    id: "mm72",
    symbol: "mm72",
    name: "MM72",
  },
  {
    id: "mmacoin",
    symbol: "mma",
    name: "MMACoin",
  },
  {
    id: "mma-gaming",
    symbol: "mma",
    name: "MMA Gaming",
  },
  {
    id: "mmaon",
    symbol: "mmaon",
    name: "MMAON",
  },
  {
    id: "mmfinance",
    symbol: "mmf",
    name: "MMFinance",
  },
  {
    id: "mmf-money",
    symbol: "burrow",
    name: "MMF Money",
  },
  {
    id: "mmmluckup7",
    symbol: "mmm7",
    name: "MMMLUCKUP7",
  },
  {
    id: "mmocoin",
    symbol: "mmo",
    name: "MMOCoin",
  },
  {
    id: "mms-cash",
    symbol: "mcash",
    name: "MMS Cash",
  },
  {
    id: "mms-coin",
    symbol: "mmsc",
    name: "MMS Coin",
  },
  {
    id: "mm-token",
    symbol: "mm",
    name: "MM",
  },
  {
    id: "mnmcoin",
    symbol: "mnmc",
    name: "MNMCoin",
  },
  {
    id: "mnpostree",
    symbol: "mptc",
    name: "MNPoSTree",
  },
  {
    id: "mo",
    symbol: "mo",
    name: "MO",
  },
  {
    id: "moar",
    symbol: "moar",
    name: "Moar Finance",
  },
  {
    id: "mobiecoin",
    symbol: "mbx",
    name: "MobieCoin",
  },
  {
    id: "mobifi",
    symbol: "mofi",
    name: "MobiFi",
  },
  {
    id: "mobilecoin",
    symbol: "mob",
    name: "MobileCoin",
  },
  {
    id: "mobile-crypto-pay-coin",
    symbol: "mcpc",
    name: "Mobile Crypto Pay Coin",
  },
  {
    id: "mobilego",
    symbol: "mgo",
    name: "MobileGo",
  },
  {
    id: "mobilian-coin",
    symbol: "mbn",
    name: "Mobilian Coin",
  },
  {
    id: "mobilink-coin",
    symbol: "molk",
    name: "Mobilink",
  },
  {
    id: "mobility-coin",
    symbol: "mobic",
    name: "Mobility Coin",
  },
  {
    id: "mobist",
    symbol: "mitx",
    name: "Mobist",
  },
  {
    id: "mobit-global",
    symbol: "mbgl",
    name: "Mobit Global",
  },
  {
    id: "mobius",
    symbol: "mobi",
    name: "Mobius",
  },
  {
    id: "mobius-finance",
    symbol: "mot",
    name: "Mobius Finance",
  },
  {
    id: "mobius-money",
    symbol: "mobi",
    name: "Mobius Money",
  },
  {
    id: "mobox",
    symbol: "mbox",
    name: "Mobox",
  },
  {
    id: "mobula",
    symbol: "mobl",
    name: "Mobula",
  },
  {
    id: "moby-dick-2",
    symbol: "moby",
    name: "Moby Dick",
  },
  {
    id: "mochi-inu",
    symbol: "mochi",
    name: "Mochi Inu",
  },
  {
    id: "mochi-market",
    symbol: "moma",
    name: "Mochi Market",
  },
  {
    id: "mochimo",
    symbol: "mcm",
    name: "Mochimo",
  },
  {
    id: "moda-dao",
    symbol: "moda",
    name: "MODA DAO",
  },
  {
    id: "modefi",
    symbol: "mod",
    name: "Modefi",
  },
  {
    id: "model-x-coin",
    symbol: "modx",
    name: "MODEL-X-coin",
  },
  {
    id: "modex",
    symbol: "modex",
    name: "Modex",
  },
  {
    id: "modihost",
    symbol: "aim",
    name: "ModiHost",
  },
  {
    id: "moebius",
    symbol: "mobi",
    name: "Moebius",
  },
  {
    id: "moeda-loyalty-points",
    symbol: "mda",
    name: "Moeda Loyalty Points",
  },
  {
    id: "mogu",
    symbol: "mogx",
    name: "Mogu",
  },
  {
    id: "mogul-productions",
    symbol: "stars",
    name: "Mogul Productions",
  },
  {
    id: "mojitoswap",
    symbol: "mjt",
    name: "MojitoSwap",
  },
  {
    id: "mojocoin",
    symbol: "mojo",
    name: "Mojocoin",
  },
  {
    id: "mojo-v2",
    symbol: "mojov2",
    name: "Mojo V2",
  },
  {
    id: "molecular-future",
    symbol: "mof",
    name: "Molecular Future",
  },
  {
    id: "mollector",
    symbol: "mol",
    name: "Mollector",
  },
  {
    id: "moma-protocol",
    symbol: "momat",
    name: "Moma Protocol",
  },
  {
    id: "momento",
    symbol: "momento",
    name: "Momento",
  },
  {
    id: "moments",
    symbol: "mmt",
    name: "Moments Market",
  },
  {
    id: "momentum-token",
    symbol: "mtm",
    name: "Momentum MTM",
  },
  {
    id: "mommon",
    symbol: "mmon",
    name: "Mammon",
  },
  {
    id: "mommy-doge",
    symbol: "mommydoge",
    name: "Mommy Doge",
  },
  {
    id: "mommyusdt",
    symbol: "mommyusdt",
    name: "MommyUSDT",
  },
  {
    id: "momo-key",
    symbol: "key",
    name: "MoMo Key",
  },
  {
    id: "momo-protocol",
    symbol: "momo",
    name: "Momo Protocol",
  },
  {
    id: "mona",
    symbol: "mona",
    name: "Monaco Planet",
  },
  {
    id: "monaco",
    symbol: "mco",
    name: "MCO",
  },
  {
    id: "monacoin",
    symbol: "mona",
    name: "MonaCoin",
  },
  {
    id: "monastery-finance",
    symbol: "monk",
    name: "Monastery Finance",
  },
  {
    id: "monavale",
    symbol: "mona",
    name: "Monavale",
  },
  {
    id: "mondayclub",
    symbol: "monday",
    name: "MondayClub",
  },
  {
    id: "mondo-community-coin",
    symbol: "mndcc",
    name: "Mondo Community Coin",
  },
  {
    id: "monerium-eur-money",
    symbol: "eure",
    name: "Monerium EUR emoney",
  },
  {
    id: "monero",
    symbol: "xmr",
    name: "Monero",
  },
  {
    id: "monero-classic-xmc",
    symbol: "xmc",
    name: "Monero-Classic",
  },
  {
    id: "monerov",
    symbol: "xmv",
    name: "MoneroV",
  },
  {
    id: "moneta",
    symbol: "moneta",
    name: "Moneta",
  },
  {
    id: "moneta-digital",
    symbol: "mmxn",
    name: "Moneta Digital",
  },
  {
    id: "monetaryunit",
    symbol: "mue",
    name: "MonetaryUnit",
  },
  {
    id: "monetas",
    symbol: "mntg",
    name: "Monetas",
  },
  {
    id: "monetha",
    symbol: "mth",
    name: "Monetha",
  },
  {
    id: "moneybrain-bips",
    symbol: "bips",
    name: "Moneybrain BiPS",
  },
  {
    id: "moneybyte",
    symbol: "mon",
    name: "MoneyByte",
  },
  {
    id: "moneydefiswap",
    symbol: "msd",
    name: "MoneydefiSwap",
  },
  {
    id: "moneyrain-finance",
    symbol: "moneyrain",
    name: "Moneyrain Finance",
  },
  {
    id: "moneyswap",
    symbol: "mswap",
    name: "MoneySwap",
  },
  {
    id: "moneytoken",
    symbol: "imt",
    name: "Money IMT",
  },
  {
    id: "moneytree",
    symbol: "money",
    name: "MoneyTree",
  },
  {
    id: "money-versum",
    symbol: "myv",
    name: "Money Versum",
  },
  {
    id: "monfter",
    symbol: "mon",
    name: "Monfter",
  },
  {
    id: "mongo-coin",
    symbol: "mongocm",
    name: "MONGO Coin",
  },
  {
    id: "mongol-nft",
    symbol: "mnft",
    name: "Mongol NFT",
  },
  {
    id: "mongoose",
    symbol: "mongoose",
    name: "Mongoose",
  },
  {
    id: "mongoosecoin",
    symbol: "mongoose",
    name: "MongooseCoin",
  },
  {
    id: "moniwar",
    symbol: "mowa",
    name: "Moniwar",
  },
  {
    id: "monk",
    symbol: "monk",
    name: "Monk",
  },
  {
    id: "monkeyball",
    symbol: "mbs",
    name: "MonkeyLeague",
  },
  {
    id: "monkey-claus-game",
    symbol: "mcg",
    name: "Monkey Claus Game",
  },
  {
    id: "monnfts",
    symbol: "mon",
    name: "MONNFTS",
  },
  {
    id: "monnos",
    symbol: "mns",
    name: "Monnos",
  },
  {
    id: "monomoney",
    symbol: "mono",
    name: "MonoMoney",
  },
  {
    id: "mononoke-inu",
    symbol: "mononoke-inu",
    name: "Mononoke Inu",
  },
  {
    id: "monopolon",
    symbol: "mgm",
    name: "MetaGemMolon",
  },
  {
    id: "monopoly-millionaire-game",
    symbol: "mmg",
    name: "Monopoly Millionaire Game",
  },
  {
    id: "monox",
    symbol: "mono",
    name: "MonoX",
  },
  {
    id: "monsoon-finance",
    symbol: "mcash",
    name: "Monsoon Finance",
  },
  {
    id: "monspac",
    symbol: "mspc",
    name: "Monspac",
  },
  {
    id: "monsta-infinite",
    symbol: "moni",
    name: "Monsta Infinite",
  },
  {
    id: "monstaverse",
    symbol: "monstr",
    name: "MonstaVerse",
  },
  {
    id: "monster-adventure-token",
    symbol: "mat",
    name: "Monster Adventure",
  },
  {
    id: "monster-battle",
    symbol: "mbs",
    name: "Monster Battle",
  },
  {
    id: "monster-cash-share",
    symbol: "mss",
    name: "Monster Slayer Share",
  },
  {
    id: "monster-galaxy",
    symbol: "ggm",
    name: "Monster Galaxy",
  },
  {
    id: "monster-grand-prix-token",
    symbol: "mgpx",
    name: "Monster Grand Prix",
  },
  {
    id: "monster-of-god",
    symbol: "monx",
    name: "Monster of God",
  },
  {
    id: "monsterquest",
    symbol: "mqst",
    name: "MonsterQuest",
  },
  {
    id: "monsterra",
    symbol: "mstr",
    name: "Monsterra",
  },
  {
    id: "monster-saga",
    symbol: "mts",
    name: "Monster Saga",
  },
  {
    id: "monsters-clan",
    symbol: "mons",
    name: "Monsters Clan",
  },
  {
    id: "monster-valley",
    symbol: "monster",
    name: "Monster Valley",
  },
  {
    id: "monstock",
    symbol: "mon",
    name: "Monstock",
  },
  {
    id: "moochii",
    symbol: "moochii",
    name: "Moochii",
  },
  {
    id: "moola-celo-atoken",
    symbol: "mcelo",
    name: "Moola CELO AToken",
  },
  {
    id: "moola-celo-dollars",
    symbol: "mcusd",
    name: "Moola Celo Dollars",
  },
  {
    id: "moola-market",
    symbol: "moo",
    name: "Moola Market",
  },
  {
    id: "moomonster",
    symbol: "moo",
    name: "MooMonster",
  },
  {
    id: "moon",
    symbol: "moon",
    name: "r/CryptoCurrency Moons",
  },
  {
    id: "moonai",
    symbol: "mooi",
    name: "Moonaï",
  },
  {
    id: "moonarch",
    symbol: "moonarch",
    name: "Moonarch",
  },
  {
    id: "moonbeam",
    symbol: "glmr",
    name: "Moonbeam",
  },
  {
    id: "moonbeans",
    symbol: "beans",
    name: "MoonBeans",
  },
  {
    id: "moonbear-finance",
    symbol: "mbf",
    name: "MoonBear.Finance",
  },
  {
    id: "moonbet",
    symbol: "mbet",
    name: "MoonBet",
  },
  {
    id: "moonbird",
    symbol: "mbird",
    name: "Moonbird",
  },
  {
    id: "moonbirds-nft-index-by-mexc",
    symbol: "nmoon",
    name: "Moonbirds NFT Index by MEXC",
  },
  {
    id: "moonboobs",
    symbol: "boobs",
    name: "MoonBoobs",
  },
  {
    id: "mooncake",
    symbol: "moon",
    name: "MoonCake",
  },
  {
    id: "mooncat-vault-nftx",
    symbol: "mooncat",
    name: "MOONCAT Vault (NFTX)",
  },
  {
    id: "mooncoin",
    symbol: "moon",
    name: "Mooncoin",
  },
  {
    id: "moonedge",
    symbol: "mooned",
    name: "MoonEdge",
  },
  {
    id: "mooner",
    symbol: "mnr",
    name: "Mooner",
  },
  {
    id: "moonery",
    symbol: "mnry",
    name: "Moonery",
  },
  {
    id: "mooney",
    symbol: "mooney",
    name: "Moon DAO",
  },
  {
    id: "moon-eye",
    symbol: "me",
    name: "Moon Eye",
  },
  {
    id: "moonfarmer",
    symbol: "mfm",
    name: "MoonFarmer",
  },
  {
    id: "moonfarm-finance",
    symbol: "mfo",
    name: "MoonFarm Finance",
  },
  {
    id: "moonflower-farm",
    symbol: "mff",
    name: "Moonflower Farm",
  },
  {
    id: "moonforce",
    symbol: "force",
    name: "MoonForce",
  },
  {
    id: "moongame",
    symbol: "mgt",
    name: "Moongame",
  },
  {
    id: "mooni",
    symbol: "mooni",
    name: "Mooni",
  },
  {
    id: "moonienft",
    symbol: "mny",
    name: "MoonieNFT",
  },
  {
    id: "moonka",
    symbol: "mka",
    name: "Moonka",
  },
  {
    id: "moonkat-finance",
    symbol: "mkat",
    name: "MoonKat Finance",
  },
  {
    id: "moonlana",
    symbol: "mola",
    name: "MoonLana",
  },
  {
    id: "moonlift",
    symbol: "mltpx",
    name: "Moonlift Capital",
  },
  {
    id: "moon-light-night",
    symbol: "mlnt",
    name: "Moon Light Night",
  },
  {
    id: "moonlight-token",
    symbol: "moonlight",
    name: "Moonlight",
  },
  {
    id: "moon-maker-protocol",
    symbol: "mmp",
    name: "Moon Maker Protocol",
  },
  {
    id: "moonminer",
    symbol: "moonminer",
    name: "MoonMiner",
  },
  {
    id: "moon-nation-game",
    symbol: "mng",
    name: "Moon Nation Game",
  },
  {
    id: "moonpaw",
    symbol: "moonpaw",
    name: "MoonPaw",
  },
  {
    id: "moonpoly",
    symbol: "cmp",
    name: "Moonpoly",
  },
  {
    id: "moonpot",
    symbol: "pots",
    name: "Moonpot",
  },
  {
    id: "moon-rabbit",
    symbol: "aaa",
    name: "Moon Rabbit",
  },
  {
    id: "moonraise",
    symbol: "mrt",
    name: "MoonRaise",
  },
  {
    id: "moonretriever",
    symbol: "fetch",
    name: "MoonRetriever",
  },
  {
    id: "moonrise",
    symbol: "moonrise",
    name: "MoonRise",
  },
  {
    id: "moonriver",
    symbol: "movr",
    name: "Moonriver",
  },
  {
    id: "moonrock",
    symbol: "rock",
    name: "MoonRock [OLD]",
  },
  {
    id: "moon-rocket-coin",
    symbol: "mrc",
    name: "Moon Rocket Coin",
  },
  {
    id: "moonrock-v2",
    symbol: "rock",
    name: "MoonRock V2",
  },
  {
    id: "moon-sack",
    symbol: "sack",
    name: "Moon Sack",
  },
  {
    id: "moonscape",
    symbol: "mscp",
    name: "Moonscape",
  },
  {
    id: "moonsdust",
    symbol: "moond",
    name: "MoonsDust",
  },
  {
    id: "moonseeds",
    symbol: "seeds",
    name: "MoonSeeds",
  },
  {
    id: "moonseer",
    symbol: "moon",
    name: "Moonseer",
  },
  {
    id: "moonshot",
    symbol: "moonshot",
    name: "Moonshot [OLD]",
  },
  {
    id: "moonshot-max",
    symbol: "msm",
    name: "MoonShot Max",
  },
  {
    id: "moonshots-farm",
    symbol: "bones",
    name: "Moonshots Farm",
  },
  {
    id: "moonshot-token",
    symbol: "mshot",
    name: "Moonshot",
  },
  {
    id: "moonstarevenge-token",
    symbol: "mtr",
    name: "MoonstaRevenge",
  },
  {
    id: "moonstarter",
    symbol: "mnst",
    name: "MoonStarter",
  },
  {
    id: "moon-stop",
    symbol: "mnstp",
    name: "Moon Stop",
  },
  {
    id: "moonswap",
    symbol: "moon",
    name: "MoonSwap",
  },
  {
    id: "moontimer",
    symbol: "mtg",
    name: "MoonTimer",
  },
  {
    id: "moontoken",
    symbol: "moontoken",
    name: "MoonToken",
  },
  {
    id: "moon-token",
    symbol: "moon",
    name: "Moon",
  },
  {
    id: "moontools",
    symbol: "moons",
    name: "MoonTools",
  },
  {
    id: "moontrust",
    symbol: "mntt",
    name: "MoonTrust",
  },
  {
    id: "moontrustbsc",
    symbol: "mnttbsc",
    name: "MoonTrustBSC",
  },
  {
    id: "moon-warriors",
    symbol: "mwar",
    name: "Moon Warriors",
  },
  {
    id: "moonway",
    symbol: "moonway",
    name: "MoonWay",
  },
  {
    id: "moonwell",
    symbol: "mfam",
    name: "Moonwell Apollo",
  },
  {
    id: "moonwilly",
    symbol: "moonwilly",
    name: "MoonWilly",
  },
  {
    id: "moonwolf-io",
    symbol: "wolf",
    name: "moonwolf.io",
  },
  {
    id: "morcilla-war",
    symbol: "mor",
    name: "Morcilla War",
  },
  {
    id: "moremoney-usd",
    symbol: "money",
    name: "Moremoney USD",
  },
  {
    id: "more-token",
    symbol: "more",
    name: "More",
  },
  {
    id: "mork",
    symbol: "mork",
    name: "MORK",
  },
  {
    id: "morpher",
    symbol: "mph",
    name: "Morpher",
  },
  {
    id: "morpheus-labs",
    symbol: "mitx",
    name: "Morpheus Labs",
  },
  {
    id: "morpheus-network",
    symbol: "mnw",
    name: "Morpheus Network",
  },
  {
    id: "morpheus-token",
    symbol: "pills",
    name: "Morpheus Swap",
  },
  {
    id: "morphie",
    symbol: "mrfi",
    name: "Morphie",
  },
  {
    id: "mor-stablecoin",
    symbol: "mor",
    name: "Mor Stablecoin",
  },
  {
    id: "mortal-wars",
    symbol: "mwt",
    name: "Mortal Wars",
  },
  {
    id: "moshiheads",
    symbol: "moshi",
    name: "Moshiheads",
  },
  {
    id: "moss-carbon-credit",
    symbol: "mco2",
    name: "Moss Carbon Credit",
  },
  {
    id: "moss-governance",
    symbol: "moss",
    name: "Moss Governance",
  },
  {
    id: "mossland",
    symbol: "moc",
    name: "Mossland",
  },
  {
    id: "mosterisland",
    symbol: "mi",
    name: "MosterIsland",
  },
  {
    id: "mota",
    symbol: "mgot",
    name: "MoTA",
  },
  {
    id: "motacoin",
    symbol: "mota",
    name: "MotaCoin",
  },
  {
    id: "mother-earth",
    symbol: "mot",
    name: "Mother Earth",
  },
  {
    id: "mother-of-memes",
    symbol: "mom",
    name: "Mother of Memes",
  },
  {
    id: "motionwreck-games",
    symbol: "mwg",
    name: "MotionWreck Games",
  },
  {
    id: "motiv-protocol",
    symbol: "mov",
    name: "MOTIV Protocol",
  },
  {
    id: "motocoin",
    symbol: "moto",
    name: "Motocoin",
  },
  {
    id: "mound-token",
    symbol: "mnd",
    name: "Mound",
  },
  {
    id: "mouse",
    symbol: "mouse",
    name: "MouseMN",
  },
  {
    id: "mouse-haunt",
    symbol: "mht",
    name: "Mouse Haunt",
  },
  {
    id: "mousepad",
    symbol: "mpad",
    name: "MousePad",
  },
  {
    id: "movecash",
    symbol: "mca",
    name: "MoveCash",
  },
  {
    id: "movei",
    symbol: "move",
    name: "Movei",
  },
  {
    id: "move-network",
    symbol: "movd",
    name: "MOVE Network",
  },
  {
    id: "movey",
    symbol: "movey",
    name: "Movey",
  },
  {
    id: "movez",
    symbol: "movez",
    name: "MoveZ",
  },
  {
    id: "moviebloc",
    symbol: "mbl",
    name: "MovieBloc",
  },
  {
    id: "movie-magic",
    symbol: "mvm",
    name: "Movie Magic",
  },
  {
    id: "movingon-finance",
    symbol: "movon",
    name: "MovingOn Finance",
  },
  {
    id: "mozik",
    symbol: "moz",
    name: "Mozik",
  },
  {
    id: "mozox",
    symbol: "mozox",
    name: "MozoX",
  },
  {
    id: "mozza",
    symbol: "mozza",
    name: "Mozza",
  },
  {
    id: "mp3",
    symbol: "mp3",
    name: "MP3",
  },
  {
    id: "mr-fox-token",
    symbol: "mrfox",
    name: "Mr.FOX",
  },
  {
    id: "mrv",
    symbol: "mrv",
    name: "MRV",
  },
  {
    id: "mrweb-finance",
    symbol: "ama",
    name: "MrWeb Finance",
  },
  {
    id: "msgsender",
    symbol: "msg",
    name: "MsgSender",
  },
  {
    id: "mshare",
    symbol: "mshare",
    name: "MShare",
  },
  {
    id: "msn",
    symbol: "msn",
    name: "MSN",
  },
  {
    id: "msol",
    symbol: "msol",
    name: "Marinade staked SOL",
  },
  {
    id: "msquare-global",
    symbol: "msq",
    name: "MSquare Global",
  },
  {
    id: "mstation",
    symbol: "mst",
    name: "MStation",
  },
  {
    id: "mt-pelerin-shares",
    symbol: "mps",
    name: "Mt Pelerin Shares",
  },
  {
    id: "mttcoin",
    symbol: "mttcoin",
    name: "MTTCoin",
  },
  {
    id: "mtvx",
    symbol: "mtvx",
    name: "MTVX",
  },
  {
    id: "mu-coin",
    symbol: "mu",
    name: "Mu Coin",
  },
  {
    id: "mu-continent",
    symbol: "mu",
    name: "Mu Continent",
  },
  {
    id: "mu-dank",
    symbol: "dank",
    name: "MU DANK",
  },
  {
    id: "mud-guild-game",
    symbol: "mgg",
    name: "MUD Guild Game",
  },
  {
    id: "mudra",
    symbol: "mudra",
    name: "Mudra",
  },
  {
    id: "muesliswap-milk",
    symbol: "milk",
    name: "MuesliSwap MILK",
  },
  {
    id: "muesliswap-yield-token",
    symbol: "myield",
    name: "MuesliSwap Yield",
  },
  {
    id: "mu-gold",
    symbol: "mug",
    name: "Mu Gold",
  },
  {
    id: "multichain",
    symbol: "multi",
    name: "Multichain",
  },
  {
    id: "multi-chain-capital",
    symbol: "mcc",
    name: "Multi-Chain Capital [OLD]",
  },
  {
    id: "multi-chain-capital-2",
    symbol: "mcc",
    name: "Multi-Chain Capital",
  },
  {
    id: "multi-farm-capital",
    symbol: "mfc",
    name: "Multi-Farm Capital",
  },
  {
    id: "multigame",
    symbol: "multi",
    name: "Multigame",
  },
  {
    id: "multipad",
    symbol: "mpad",
    name: "MultiPad",
  },
  {
    id: "multiplanetary-inus",
    symbol: "inus",
    name: "MultiPlanetary Inus",
  },
  {
    id: "multiplier",
    symbol: "mxx",
    name: "Multiplier",
  },
  {
    id: "multiplier-bsc",
    symbol: "bmxx",
    name: "Multiplier (BSC)",
  },
  {
    id: "multistarter",
    symbol: "mstart",
    name: "MultiStarter",
  },
  {
    id: "multi-strategies-capital",
    symbol: "msc",
    name: "Multi Strategies Capital",
  },
  {
    id: "multivac",
    symbol: "mtv",
    name: "MultiVAC",
  },
  {
    id: "multiverse",
    symbol: "ai",
    name: "Multiverse",
  },
  {
    id: "multiverse-capital",
    symbol: "mvc",
    name: "Multiverse Capital",
  },
  {
    id: "multiversepad",
    symbol: "mtvp",
    name: "MultiversePad",
  },
  {
    id: "muna",
    symbol: "muna",
    name: "Muna",
  },
  {
    id: "munch-token",
    symbol: "munch",
    name: "Munch",
  },
  {
    id: "mundo-token",
    symbol: "$mundo",
    name: "MUNDO",
  },
  {
    id: "muon-network",
    symbol: "",
    name: "Muon Network",
  },
  {
    id: "murphycat",
    symbol: "murphy",
    name: "MURPHYCAT",
  },
  {
    id: "mus",
    symbol: "mus",
    name: "Musashi Finance",
  },
  {
    id: "musd",
    symbol: "musd",
    name: "mStable USD",
  },
  {
    id: "muse-2",
    symbol: "muse",
    name: "Muse DAO",
  },
  {
    id: "museo",
    symbol: "mse",
    name: "Museo",
  },
  {
    id: "museum-of-crypto-art",
    symbol: "moca",
    name: "Museum of Crypto Art",
  },
  {
    id: "mushroom-coin",
    symbol: "coin",
    name: "Mushroom Coin",
  },
  {
    id: "mushu-finance",
    symbol: "mushu",
    name: "Mushu Finance",
  },
  {
    id: "musk",
    symbol: "musk",
    name: "Musk",
  },
  {
    id: "musk-doge",
    symbol: "mkd",
    name: "Musk Doge",
  },
  {
    id: "musk-gold",
    symbol: "musk",
    name: "MUSK Gold",
  },
  {
    id: "musk-ito",
    symbol: "mito",
    name: "Musk Ito",
  },
  {
    id: "musk-melon",
    symbol: "melon",
    name: "Musk Melon",
  },
  {
    id: "musk-metaverse",
    symbol: "metamusk",
    name: "Musk Metaverse",
  },
  {
    id: "muskswap",
    symbol: "musk",
    name: "MuskSwap",
  },
  {
    id: "muso-finance-2",
    symbol: "muso",
    name: "MUSO Finance",
  },
  {
    id: "must",
    symbol: "must",
    name: "Must",
  },
  {
    id: "mute",
    symbol: "mute",
    name: "Mute",
  },
  {
    id: "muu-inu",
    symbol: "minu",
    name: "Muu Inu",
  },
  {
    id: "muzika-network",
    symbol: "mzk",
    name: "Muzika Network",
  },
  {
    id: "mvpad",
    symbol: "mvd",
    name: "MvPad",
  },
  {
    id: "mvp-coin",
    symbol: "mvp",
    name: "MVP Coin",
  },
  {
    id: "mvs-multiverse",
    symbol: "mvs",
    name: "MVS Multiverse",
  },
  {
    id: "mxc",
    symbol: "mxc",
    name: "MXC",
  },
  {
    id: "mx-token",
    symbol: "mx",
    name: "MX",
  },
  {
    id: "mybit-token",
    symbol: "myb",
    name: "MyBit",
  },
  {
    id: "mybricks",
    symbol: "bricks",
    name: "MyBricks",
  },
  {
    id: "myce",
    symbol: "yce",
    name: "MYCE",
  },
  {
    id: "my-ceremonial-event",
    symbol: "myce",
    name: "MY Ceremonial Event",
  },
  {
    id: "mycro-ico",
    symbol: "myo",
    name: "Mycro",
  },
  {
    id: "my-defi-legends",
    symbol: "dlegends",
    name: "My DeFi Legends",
  },
  {
    id: "my-defi-pet",
    symbol: "dpet",
    name: "My DeFi Pet",
  },
  {
    id: "my-farm-pet",
    symbol: "myfarmpet",
    name: "My Farm Pet",
  },
  {
    id: "my-identity-coin",
    symbol: "myid",
    name: "My Identity Coin",
  },
  {
    id: "mykey",
    symbol: "key",
    name: "MYKEY",
  },
  {
    id: "mykingdom",
    symbol: "myk",
    name: "MyKingdom",
  },
  {
    id: "my-lotto-coin",
    symbol: "myl",
    name: "My Lotto Coin",
  },
  {
    id: "my-master-war",
    symbol: "mat",
    name: "My Master War",
  },
  {
    id: "mymessage",
    symbol: "mesa",
    name: "myMessage",
  },
  {
    id: "mymine",
    symbol: "mymine",
    name: "MyMine",
  },
  {
    id: "mymn",
    symbol: "mymn",
    name: "MyMN",
  },
  {
    id: "my-neighbor-alice",
    symbol: "alice",
    name: "My Neighbor Alice",
  },
  {
    id: "my-neighbor-alice-wormhole",
    symbol: "alice",
    name: "My Neighbor Alice (Wormhole)",
  },
  {
    id: "myobu",
    symbol: "myobu",
    name: "Myōbu",
  },
  {
    id: "my-pandaverse",
    symbol: "pandavs",
    name: "My Pandaverse",
  },
  {
    id: "myra-ai",
    symbol: "myra",
    name: "Myra AI",
  },
  {
    id: "myriadcoin",
    symbol: "xmy",
    name: "Myriad",
  },
  {
    id: "myriad-social",
    symbol: "myria",
    name: "Myriad Social",
  },
  {
    id: "my-shiba-academia",
    symbol: "msa",
    name: "My Shiba Academia",
  },
  {
    id: "mysterium",
    symbol: "myst",
    name: "Mysterium",
  },
  {
    id: "mystery",
    symbol: "myst",
    name: "MYSTERY",
  },
  {
    id: "mystic-bets",
    symbol: "mbt",
    name: "MysticBets",
  },
  {
    id: "mystic-warrior",
    symbol: "mystic",
    name: "Mystic Warrior",
  },
  {
    id: "myteamcoin",
    symbol: "myc",
    name: "Myteamcoin",
  },
  {
    id: "mytheria",
    symbol: "myra",
    name: "Mytheria",
  },
  {
    id: "myth-token",
    symbol: "myth",
    name: "Myth",
  },
  {
    id: "mytoken",
    symbol: "mt",
    name: "MyToken",
  },
  {
    id: "mytrade",
    symbol: "myt",
    name: "Mytrade",
  },
  {
    id: "mytvchain",
    symbol: "mytv",
    name: "MyTVchain",
  },
  {
    id: "mywish",
    symbol: "wish",
    name: "MyWish",
  },
  {
    id: "nabox",
    symbol: "nabox",
    name: "Nabox",
  },
  {
    id: "nacho-finance",
    symbol: "nacho",
    name: "Nacho Finance",
  },
  {
    id: "nadeshiko",
    symbol: "ndsk",
    name: "Nadeshiko",
  },
  {
    id: "naffiti",
    symbol: "naff",
    name: "Naffiti",
  },
  {
    id: "nafter",
    symbol: "naft",
    name: "Nafter",
  },
  {
    id: "nafty",
    symbol: "nafty",
    name: "Nafty",
  },
  {
    id: "naga",
    symbol: "ngc",
    name: "NAGA",
  },
  {
    id: "naga-kingdom",
    symbol: "naga",
    name: "Naga Kingdom",
  },
  {
    id: "nagaswap",
    symbol: "bnw",
    name: "NagaSwap",
  },
  {
    id: "nahmii",
    symbol: "nii",
    name: "Nahmii",
  },
  {
    id: "naiad-water-investment-coin",
    symbol: "naiad",
    name: "Naiad Water Investment Coin",
  },
  {
    id: "naka-bodhi-token",
    symbol: "nbot",
    name: "Naka Bodhi",
  },
  {
    id: "nakamoto-games",
    symbol: "naka",
    name: "Nakamoto Games",
  },
  {
    id: "name-changing-token",
    symbol: "nct",
    name: "Name Change",
  },
  {
    id: "namecoin",
    symbol: "nmc",
    name: "Namecoin",
  },
  {
    id: "nami-corporation-token",
    symbol: "nami",
    name: "Nami Corporation",
  },
  {
    id: "nami-inu",
    symbol: "nami",
    name: "Nami Inu",
  },
  {
    id: "nanjcoin",
    symbol: "nanj",
    name: "NANJCOIN",
  },
  {
    id: "nano",
    symbol: "xno",
    name: "Nano",
  },
  {
    id: "nano-bitcoin-token",
    symbol: "nbtc",
    name: "Nano Bitcoin",
  },
  {
    id: "nanobyte",
    symbol: "nbt",
    name: "NanoByte",
  },
  {
    id: "nano-doge",
    symbol: "nanodoge",
    name: "Nano Doge",
  },
  {
    id: "nano-dogecoin",
    symbol: "indc",
    name: "Nano Dogecoin",
  },
  {
    id: "nanometer-bitcoin",
    symbol: "nmbtc",
    name: "NanoMeter Bitcoin",
  },
  {
    id: "nantrade",
    symbol: "nan",
    name: "NanTrade",
  },
  {
    id: "naos-busd",
    symbol: "nbusd",
    name: "NAOS BUSD",
  },
  {
    id: "naos-finance",
    symbol: "naos",
    name: "NAOS Finance",
  },
  {
    id: "naos-usd",
    symbol: "nusd",
    name: "NAOS USD",
  },
  {
    id: "napoleon-x",
    symbol: "npx",
    name: "Napoleon X",
  },
  {
    id: "napoli-fan-token",
    symbol: "nap",
    name: "Napoli Fan Token",
  },
  {
    id: "naruto-inu",
    symbol: "naruto",
    name: "Naruto Inu",
  },
  {
    id: "nasa-doge",
    symbol: "nasadoge",
    name: "Nasa Doge",
  },
  {
    id: "nasdacoin",
    symbol: "nsd",
    name: "Nasdacoin",
  },
  {
    id: "nasdex-token",
    symbol: "nsdx",
    name: "NASDEX",
  },
  {
    id: "nation3",
    symbol: "nation",
    name: "Nation3",
  },
  {
    id: "native-utility-token",
    symbol: "nut",
    name: "Native Utility",
  },
  {
    id: "natural-farm-union-protocol",
    symbol: "nfup",
    name: "Natural Farm Union Protocol",
  },
  {
    id: "natus-vincere-fan-token",
    symbol: "navi",
    name: "Natus Vincere Fan Token",
  },
  {
    id: "nausicaal-inu",
    symbol: "nausicaa",
    name: "Nausicaa-Inu",
  },
  {
    id: "nav-coin",
    symbol: "nav",
    name: "Navcoin",
  },
  {
    id: "navibration",
    symbol: "navi",
    name: "Navibration",
  },
  {
    id: "naxar",
    symbol: "naxar",
    name: "Naxar",
  },
  {
    id: "nayuta-coin",
    symbol: "nc",
    name: "Nayuta Coin",
  },
  {
    id: "ndau",
    symbol: "ndau",
    name: "Ndau",
  },
  {
    id: "ndex",
    symbol: "ndx",
    name: "nDEX",
  },
  {
    id: "ndn-link",
    symbol: "ndn",
    name: "NDN Link",
  },
  {
    id: "near",
    symbol: "near",
    name: "NEAR Protocol",
  },
  {
    id: "nearpad",
    symbol: "pad",
    name: "NearPad",
  },
  {
    id: "neblio",
    symbol: "nebl",
    name: "Neblio",
  },
  {
    id: "nebulas",
    symbol: "nas",
    name: "Nebulas",
  },
  {
    id: "nebulatoken",
    symbol: "nebula",
    name: "NebulaToken",
  },
  {
    id: "nectar-token",
    symbol: "nec",
    name: "Nectar",
  },
  {
    id: "neetcoin",
    symbol: "neet",
    name: "Neetcoin",
  },
  {
    id: "neeva-defi",
    symbol: "nva",
    name: "Neeva Defi",
  },
  {
    id: "neftipedia",
    symbol: "nft",
    name: "NEFTiPEDiA",
  },
  {
    id: "neighbourhoods",
    symbol: "nht",
    name: "Neighbourhoods",
  },
  {
    id: "nekocoin",
    symbol: "nekos",
    name: "Nekocoin",
  },
  {
    id: "neko-network",
    symbol: "neko",
    name: "Neko Network",
  },
  {
    id: "nekonium",
    symbol: "nuko",
    name: "Nekonium",
  },
  {
    id: "nelo-metaverse",
    symbol: "nelo",
    name: "NELO Metaverse",
  },
  {
    id: "nem",
    symbol: "xem",
    name: "NEM",
  },
  {
    id: "nemesis",
    symbol: "nms",
    name: "Nemesis",
  },
  {
    id: "nemesis-dao",
    symbol: "nms",
    name: "Nemesis DAO",
  },
  {
    id: "nemesis-wealth-projects-bsc",
    symbol: "nms",
    name: "Nemesis Wealth Projects BSC",
  },
  {
    id: "neo",
    symbol: "neo",
    name: "NEO",
  },
  {
    id: "neofi",
    symbol: "neofi",
    name: "NeoFi",
  },
  {
    id: "neo-holistic-coin",
    symbol: "nhc",
    name: "Neo Holistic Coin",
  },
  {
    id: "neon-exchange",
    symbol: "nex",
    name: "Nash",
  },
  {
    id: "neonomad-finance",
    symbol: "nni",
    name: "Neonomad Finance",
  },
  {
    id: "neopin",
    symbol: "npt",
    name: "Neopin",
  },
  {
    id: "neos-credits",
    symbol: "ncr",
    name: "Neos Credits",
  },
  {
    id: "neoworld-cash",
    symbol: "nash",
    name: "NeoWorld Cash",
  },
  {
    id: "neptune",
    symbol: "nptun",
    name: "Neptune",
  },
  {
    id: "nerdy-inu",
    symbol: "nerdy",
    name: "Nerdy Inu",
  },
  {
    id: "nerian-network",
    symbol: "nerian",
    name: "Nerian Network",
  },
  {
    id: "nerva",
    symbol: "xnv",
    name: "Nerva",
  },
  {
    id: "nerve-finance",
    symbol: "nrv",
    name: "Nerve Finance",
  },
  {
    id: "nerveflux",
    symbol: "nerve",
    name: "NerveFlux",
  },
  {
    id: "nervenetwork",
    symbol: "nvt",
    name: "NerveNetwork",
  },
  {
    id: "nervos-network",
    symbol: "ckb",
    name: "Nervos Network",
  },
  {
    id: "nerv-protocol",
    symbol: "nrv",
    name: "Nerv Protocol",
  },
  {
    id: "nest",
    symbol: "nest",
    name: "Nest Protocol",
  },
  {
    id: "nest-arcade",
    symbol: "nesta",
    name: "Nest Arcade",
  },
  {
    id: "nest-egg",
    symbol: "negg",
    name: "Nest Egg",
  },
  {
    id: "nestegg-coin",
    symbol: "egg",
    name: "NestEgg Coin",
  },
  {
    id: "nesten",
    symbol: "nit",
    name: "Nesten",
  },
  {
    id: "nestree",
    symbol: "egg",
    name: "Nestree",
  },
  {
    id: "neta",
    symbol: "neta",
    name: "NETA",
  },
  {
    id: "netbox-coin",
    symbol: "nbx",
    name: "Netbox Coin",
  },
  {
    id: "netcoin",
    symbol: "net",
    name: "Netcoin",
  },
  {
    id: "netcoincapital",
    symbol: "ncc",
    name: "Netcoincapital",
  },
  {
    id: "netflix-tokenized-stock-defichain",
    symbol: "dnflx",
    name: "Netflix Tokenized Stock Defichain",
  },
  {
    id: "netflix-tokenized-stock-zipmex",
    symbol: "nflx",
    name: "Netflix Tokenized Stock Zipmex",
  },
  {
    id: "nether",
    symbol: "ntr",
    name: "Nether",
  },
  {
    id: "netkoin",
    symbol: "ntk",
    name: "Netkoin",
  },
  {
    id: "netm",
    symbol: "ntm",
    name: "Netm",
  },
  {
    id: "neton",
    symbol: "nto",
    name: "Neton",
  },
  {
    id: "netswap",
    symbol: "nett",
    name: "Netswap",
  },
  {
    id: "netvrk",
    symbol: "ntvrk",
    name: "Netvrk",
  },
  {
    id: "neumark",
    symbol: "neu",
    name: "Neumark",
  },
  {
    id: "neuralink",
    symbol: "neuralink",
    name: "Neuralink",
  },
  {
    id: "neural-protocol",
    symbol: "nrp",
    name: "Neural Protocol",
  },
  {
    id: "neurochain",
    symbol: "ncc",
    name: "NeuroChain",
  },
  {
    id: "neuromorphic-io",
    symbol: "nmp",
    name: "Neuromorphic.io",
  },
  {
    id: "neurotoken",
    symbol: "ntk",
    name: "Neuro NTK",
  },
  {
    id: "neutrino",
    symbol: "usdn",
    name: "Neutrino USD",
  },
  {
    id: "neutrino-system-base-token",
    symbol: "nsbt",
    name: "Neutrino System Base",
  },
  {
    id: "neuy",
    symbol: "neuy",
    name: "NEUY",
  },
  {
    id: "nevada",
    symbol: "nevada",
    name: "Nevada",
  },
  {
    id: "newb-farm",
    symbol: "newb",
    name: "NewB.Farm",
  },
  {
    id: "new-bitshares",
    symbol: "nbs",
    name: "New BitShares",
  },
  {
    id: "newdex-token",
    symbol: "dex",
    name: "Newdex",
  },
  {
    id: "new-earth-order-money",
    symbol: "neom",
    name: "New Earth Order Money",
  },
  {
    id: "new-era",
    symbol: "nec",
    name: "New Era",
  },
  {
    id: "new-frontier-presents",
    symbol: "nfp",
    name: "New Frontier Presents",
  },
  {
    id: "newinu",
    symbol: "newinu",
    name: "Newinu",
  },
  {
    id: "new-landbox",
    symbol: "land",
    name: "LandBox",
  },
  {
    id: "newo-coin",
    symbol: "newo",
    name: "NEWO Coin",
  },
  {
    id: "new-order",
    symbol: "newo",
    name: "New Order",
  },
  {
    id: "new-origin",
    symbol: "noc",
    name: "New Origin",
  },
  {
    id: "new-paradigm-assets-solution",
    symbol: "npas",
    name: "New Paradigm Assets Solution",
  },
  {
    id: "new-power-coin",
    symbol: "npw",
    name: "New Power Coin",
  },
  {
    id: "newscrypto-coin",
    symbol: "nwc",
    name: "Newscrypto Coin",
  },
  {
    id: "newsolution",
    symbol: "nst",
    name: "Newsolution",
  },
  {
    id: "newsolution-2-0",
    symbol: "nste",
    name: "NewSolution 2.0",
  },
  {
    id: "newton-coin-project",
    symbol: "ncp",
    name: "Newton Coin Project",
  },
  {
    id: "newton-project",
    symbol: "new",
    name: "Newton Project",
  },
  {
    id: "new-year-resolution",
    symbol: "nyr",
    name: "New Year Resolution",
  },
  {
    id: "new-year-token",
    symbol: "nyt",
    name: "New Year",
  },
  {
    id: "newyorkcoin",
    symbol: "nyc",
    name: "NewYorkCoin",
  },
  {
    id: "newyork-exchange",
    symbol: "nye",
    name: "NewYork Exchange",
  },
  {
    id: "nexalt",
    symbol: "xlt",
    name: "Nexalt",
  },
  {
    id: "nexdax",
    symbol: "nt",
    name: "NexDAX",
  },
  {
    id: "nexo",
    symbol: "nexo",
    name: "NEXO",
  },
  {
    id: "nextdao",
    symbol: "nax",
    name: "NextDAO",
  },
  {
    id: "next-defi-protocol",
    symbol: "nxdf",
    name: "NeXt-DeFi Protocol",
  },
  {
    id: "next-earth",
    symbol: "nxtt",
    name: "Next Earth",
  },
  {
    id: "nextech-network",
    symbol: "nx",
    name: "Nxtech Network",
  },
  {
    id: "nextexchange",
    symbol: "next",
    name: "NEXT",
  },
  {
    id: "next-level",
    symbol: "nxl",
    name: "Next Level",
  },
  {
    id: "next-token",
    symbol: "nxt",
    name: "Next NXT",
  },
  {
    id: "nextype-finance",
    symbol: "nt",
    name: "NEXTYPE Finance",
  },
  {
    id: "nexum",
    symbol: "nexm",
    name: "Nexum",
  },
  {
    id: "nexus",
    symbol: "nxs",
    name: "Nexus",
  },
  {
    id: "nexus-beth-token-share-representation",
    symbol: "neth",
    name: "Nexus bETH token share representation",
  },
  {
    id: "nexus-bluna-token-share-representation",
    symbol: "nluna",
    name: "Nexus bLuna token share representation",
  },
  {
    id: "nexus-dubai",
    symbol: "nxd",
    name: "Nexus Dubai",
  },
  {
    id: "nexus-governance-token",
    symbol: "psi",
    name: "Nexus Protocol",
  },
  {
    id: "nexus-mutual-wormhole",
    symbol: "nxm",
    name: "Nexus Mutual (Wormhole)",
  },
  {
    id: "nexus-token",
    symbol: "nexus",
    name: "Nexus Crypto Services",
  },
  {
    id: "nezuko-inu",
    symbol: "nezuko",
    name: "Nezuko Inu",
  },
  {
    id: "nfans",
    symbol: "nfs",
    name: "Nfans",
  },
  {
    id: "nfcore",
    symbol: "nfcr",
    name: "NFCore",
  },
  {
    id: "nfmonsters",
    symbol: "nfmon",
    name: "NFMonsters",
  },
  {
    id: "nfraction",
    symbol: "nfta",
    name: "NFracTion",
  },
  {
    id: "nft11",
    symbol: "nft11",
    name: "NFT11",
  },
  {
    id: "nft-all-best-ico",
    symbol: "nftallbi",
    name: "NFT All Best ICO",
  },
  {
    id: "nft-alley",
    symbol: "alley",
    name: "NFT Alley",
  },
  {
    id: "nft-art-finance",
    symbol: "nftart",
    name: "NFT Art Finance",
  },
  {
    id: "nftascii",
    symbol: "nftascii",
    name: "NFTASCII",
  },
  {
    id: "nftb",
    symbol: "nftb",
    name: "NFTb",
  },
  {
    id: "nftblackmarket",
    symbol: "nbm",
    name: "NFTBlackmarket",
  },
  {
    id: "nftbomb",
    symbol: "nbp",
    name: "NFTBomb",
  },
  {
    id: "nftbooks",
    symbol: "nftbs",
    name: "NFTBooks",
  },
  {
    id: "nft-champions",
    symbol: "champ",
    name: "NFT Champions",
  },
  {
    id: "nftcircle",
    symbol: "nftc",
    name: "NFTCircle",
  },
  {
    id: "nftdao",
    symbol: "nao",
    name: "NFTDAO",
  },
  {
    id: "nfteez",
    symbol: "nfteez",
    name: "NFTeez",
  },
  {
    id: "nfteyez",
    symbol: "eye",
    name: "NftEyez",
  },
  {
    id: "nftfundart",
    symbol: "nfa",
    name: "NFTFundArt",
  },
  {
    id: "nftfy",
    symbol: "nftfy",
    name: "Nftfy",
  },
  {
    id: "nftgamingstars",
    symbol: "gs1",
    name: "NFTGamingStars",
  },
  {
    id: "nft-global-platform",
    symbol: "nftg",
    name: "NFT Global Platform",
  },
  {
    id: "nftify",
    symbol: "n1",
    name: "NFTify",
  },
  {
    id: "nftime",
    symbol: "nftm",
    name: "Nftime",
  },
  {
    id: "nftinder",
    symbol: "nftndr",
    name: "NFTinder",
  },
  {
    id: "nft-index",
    symbol: "nfti",
    name: "NFT Index",
  },
  {
    id: "nftlaunch",
    symbol: "nftl",
    name: "NFTLaunch",
  },
  {
    id: "nftlootbox",
    symbol: "loot",
    name: "LootBox.io",
  },
  {
    id: "nftl-token",
    symbol: "nftl",
    name: "NFTL",
  },
  {
    id: "nftmake",
    symbol: "make",
    name: "NFTMAKE",
  },
  {
    id: "nft-maker",
    symbol: "nmkr",
    name: "NFT-MAKER",
  },
  {
    id: "nftmall",
    symbol: "gem",
    name: "NFTmall",
  },
  {
    id: "nftmania",
    symbol: "mania",
    name: "NFTMania",
  },
  {
    id: "nftmart-token",
    symbol: "nmt",
    name: "NFTMart",
  },
  {
    id: "nft-maze",
    symbol: "maze",
    name: "NFT MAZE",
  },
  {
    id: "nftmusic",
    symbol: "music",
    name: "NFTMusic.ai",
  },
  {
    id: "nftmusic-stream",
    symbol: "streamer",
    name: "NFTMUSIC.STREAM",
  },
  {
    id: "nftopia",
    symbol: "nftopia",
    name: "NFTOPIA",
  },
  {
    id: "nftpad",
    symbol: "nftpad",
    name: "NFTPad",
  },
  {
    id: "nft-platform-index",
    symbol: "nftp",
    name: "NFT Platform Index",
  },
  {
    id: "nft-protocol",
    symbol: "nft",
    name: "NFT Protocol",
  },
  {
    id: "nftpunk-finance",
    symbol: "nftpunk",
    name: "NFTPunk.Finance",
  },
  {
    id: "nftrade",
    symbol: "nftd",
    name: "NFTrade",
  },
  {
    id: "nft-royal-token",
    symbol: "nrt",
    name: "NFT Royal",
  },
  {
    id: "nft-soccer-games",
    symbol: "nfsg",
    name: "NFT Soccer Games",
  },
  {
    id: "nftsocial",
    symbol: "nsc",
    name: "NFTSocial",
  },
  {
    id: "nft-solpad",
    symbol: "nftsol",
    name: "NFT SolPad",
  },
  {
    id: "nft-stars",
    symbol: "nfts",
    name: "NFT Stars",
  },
  {
    id: "nft-starter",
    symbol: "nst",
    name: "NFT Starter",
  },
  {
    id: "nftstyle",
    symbol: "nftstyle",
    name: "NFTStyle",
  },
  {
    id: "nftswaps",
    symbol: "swaps",
    name: "NFTSwaps",
  },
  {
    id: "nft-tech",
    symbol: "nftt",
    name: "NFT Tech",
  },
  {
    id: "nft-tone",
    symbol: "tone",
    name: "NFT Tone",
  },
  {
    id: "nftwiki",
    symbol: "nftk",
    name: "NFTWiki",
  },
  {
    id: "nft-worlds",
    symbol: "wrld",
    name: "NFT Worlds",
  },
  {
    id: "nftx",
    symbol: "nftx",
    name: "NFTX",
  },
  {
    id: "nfty-token",
    symbol: "nfty",
    name: "NFTY Labs",
  },
  {
    id: "nfx-coin",
    symbol: "nfxc",
    name: "NFX Coin",
  },
  {
    id: "ngin",
    symbol: "ng",
    name: "Ngin",
  },
  {
    id: "nhbtc",
    symbol: "nhbtc",
    name: "nHBTC",
  },
  {
    id: "nicheman",
    symbol: "nicheman",
    name: "Nicheman",
  },
  {
    id: "nichonft",
    symbol: "nicho",
    name: "Nichonft",
  },
  {
    id: "nickel-token",
    symbol: "nickel",
    name: "Nickel Token",
  },
  {
    id: "nido-invest-dao",
    symbol: "nido",
    name: "NIDO Invest Dao",
  },
  {
    id: "niftify",
    symbol: "nift",
    name: "Niftify",
  },
  {
    id: "niftsy",
    symbol: "niftsy",
    name: "Envelop (Niftsy)",
  },
  {
    id: "nifty-league",
    symbol: "nftl",
    name: "Nifty League",
  },
  {
    id: "niftypays",
    symbol: "nifty",
    name: "NiftyPays",
  },
  {
    id: "nifty-token",
    symbol: "nfty",
    name: "NFTY DeFi Protocol",
  },
  {
    id: "night-life-crypto",
    symbol: "nlife",
    name: "Night Life Crypto",
  },
  {
    id: "niifi",
    symbol: "niifi",
    name: "NiiFi",
  },
  {
    id: "nil-coin",
    symbol: "nil",
    name: "NIL",
  },
  {
    id: "nil-dao",
    symbol: "nil",
    name: "Nil DAO",
  },
  {
    id: "nilu",
    symbol: "nilu",
    name: "Nilu",
  },
  {
    id: "nimbus",
    symbol: "nbu",
    name: "Nimbus",
  },
  {
    id: "nimbus-governance-token",
    symbol: "gnbu",
    name: "Nimbus Governance",
  },
  {
    id: "nimiq-2",
    symbol: "nim",
    name: "Nimiq",
  },
  {
    id: "ninja-doge",
    symbol: "$ninjadoge",
    name: "Ninja Doge",
  },
  {
    id: "ninja-fantasy-token",
    symbol: "nfs",
    name: "Ninja Fantasy",
  },
  {
    id: "ninja-panda-inu",
    symbol: "npi",
    name: "Ninja Panda Inu",
  },
  {
    id: "ninja-protocol",
    symbol: "ninja",
    name: "Ninja Protocol",
  },
  {
    id: "ninja-squad",
    symbol: "nst",
    name: "Ninja Squad",
  },
  {
    id: "ninky",
    symbol: "ninky",
    name: "Idle Ninja Online",
  },
  {
    id: "ninneko",
    symbol: "nino",
    name: "Ninneko",
  },
  {
    id: "nintia-estate",
    symbol: "ninti",
    name: "Nintia Estate",
  },
  {
    id: "niob",
    symbol: "niob",
    name: "NIOB",
  },
  {
    id: "niobio-cash",
    symbol: "nbr",
    name: "Niobio",
  },
  {
    id: "niobium-coin",
    symbol: "nbc",
    name: "Niobium Coin",
  },
  {
    id: "niros",
    symbol: "niros",
    name: "Niros",
  },
  {
    id: "nirvana-ana",
    symbol: "ana",
    name: "Nirvana ANA",
  },
  {
    id: "nirvanameta",
    symbol: "mnu",
    name: "NirvanaMeta",
  },
  {
    id: "nirvana-nirv",
    symbol: "nirv",
    name: "Nirvana NIRV",
  },
  {
    id: "nitroex",
    symbol: "ntx",
    name: "NitroEX",
  },
  {
    id: "nitro-league",
    symbol: "nitro",
    name: "Nitro League",
  },
  {
    id: "nix-bridge-token",
    symbol: "voice",
    name: "Voice",
  },
  {
    id: "nkcl-classic",
    symbol: "nkclc",
    name: "NKCL Classic",
  },
  {
    id: "nkn",
    symbol: "nkn",
    name: "NKN",
  },
  {
    id: "nnb-token",
    symbol: "nnb",
    name: "CoinBull",
  },
  {
    id: "noah",
    symbol: "noah",
    name: "Noah",
  },
  {
    id: "noahark",
    symbol: "nrk",
    name: "NoahArk",
  },
  {
    id: "noah-coin",
    symbol: "noahp",
    name: "Noah Decentralized State Coin",
  },
  {
    id: "noa-play",
    symbol: "noa",
    name: "NOA PLAY",
  },
  {
    id: "nobelium",
    symbol: "nobel",
    name: "Nobelium",
  },
  {
    id: "nobility",
    symbol: "nbl",
    name: "Nobility",
  },
  {
    id: "noblecoin",
    symbol: "nobl",
    name: "NobleCoin",
  },
  {
    id: "nobo-finance",
    symbol: "nobf",
    name: "Nobo Finance",
  },
  {
    id: "no-bull",
    symbol: "nb",
    name: "No Bull",
  },
  {
    id: "nobunaga",
    symbol: "nbng",
    name: "Nobunaga",
  },
  {
    id: "nocapcoin",
    symbol: "ncc",
    name: "NoCapCoin",
  },
  {
    id: "node-aggregator-capital",
    symbol: "$nodac",
    name: "Node Aggregator Capital",
  },
  {
    id: "nodebunch",
    symbol: "noch",
    name: "NodeBunch",
  },
  {
    id: "node-compiler-avax",
    symbol: "nodec",
    name: "Piler",
  },
  {
    id: "node-cubed",
    symbol: "n3",
    name: "Node Cubed",
  },
  {
    id: "nodeify",
    symbol: "ndfi",
    name: "Nodeify",
  },
  {
    id: "noderunners",
    symbol: "ndr",
    name: "Node Runners",
  },
  {
    id: "nodeseeds",
    symbol: "nds",
    name: "Nodeseeds",
  },
  {
    id: "node-squared",
    symbol: "n2",
    name: "Node Squared",
  },
  {
    id: "nodestats",
    symbol: "ns",
    name: "Nodestats",
  },
  {
    id: "nodetrade",
    symbol: "mnx",
    name: "Nodetrade",
  },
  {
    id: "noften",
    symbol: "nof",
    name: "nOFTEN",
  },
  {
    id: "nogoaltoken",
    symbol: "ino",
    name: "NoGoal",
  },
  {
    id: "noia-network",
    symbol: "noia",
    name: "Syntropy",
  },
  {
    id: "noir-phygital",
    symbol: "noir",
    name: "Noir Phygital",
  },
  {
    id: "nokencoin",
    symbol: "nokn",
    name: "Nokencoin",
  },
  {
    id: "noku",
    symbol: "noku",
    name: "Noku",
  },
  {
    id: "nole-npc",
    symbol: "npc",
    name: "NPC DAO",
  },
  {
    id: "nolewater",
    symbol: "amsk",
    name: "NoleWater",
  },
  {
    id: "nolian-credits",
    symbol: "nlcr",
    name: "Nolian Credits",
  },
  {
    id: "no-limit-ape",
    symbol: "nla",
    name: "No Limit Ape",
  },
  {
    id: "nolimitcoin",
    symbol: "nlc",
    name: "NoLimitCoin",
  },
  {
    id: "nomad-exiles",
    symbol: "pride",
    name: "Nomad Exiles",
  },
  {
    id: "nomadland",
    symbol: "nomad",
    name: "NOMADLAND",
  },
  {
    id: "nominex",
    symbol: "nmx",
    name: "Nominex",
  },
  {
    id: "nomy",
    symbol: "nomy",
    name: "NOMY",
  },
  {
    id: "non-fungible-toke",
    symbol: "toke",
    name: "Non-Fungible TOKE",
  },
  {
    id: "non-fungible-yearn",
    symbol: "nfy",
    name: "Non-Fungible Yearn",
  },
  {
    id: "nooft",
    symbol: "nooft",
    name: "Nooft",
  },
  {
    id: "no-one",
    symbol: "noone",
    name: "No One",
  },
  {
    id: "nora-token",
    symbol: "nra",
    name: "Nora",
  },
  {
    id: "nord-finance",
    symbol: "nord",
    name: "Nord Finance",
  },
  {
    id: "north",
    symbol: "north",
    name: "North (North Pole)",
  },
  {
    id: "nosana",
    symbol: "nos",
    name: "Nosana",
  },
  {
    id: "noshit",
    symbol: "nsh",
    name: "NoShit",
  },
  {
    id: "nosnitches",
    symbol: "nosnitch",
    name: "Nosnitches",
  },
  {
    id: "nosta",
    symbol: "nosta",
    name: "Nosta",
  },
  {
    id: "nosturis",
    symbol: "ntrs",
    name: "Nosturis",
  },
  {
    id: "nota",
    symbol: "usnota",
    name: "NOTA",
  },
  {
    id: "notable",
    symbol: "nbl",
    name: "Notable",
  },
  {
    id: "not-another-shit-altcoin",
    symbol: "nasa",
    name: "Not Another Shit Altcoin",
  },
  {
    id: "note-blockchain",
    symbol: "ntbc",
    name: "Note Blockchain",
  },
  {
    id: "nothing",
    symbol: "nada",
    name: "Nothing",
  },
  {
    id: "notional-finance",
    symbol: "note",
    name: "Notional Finance",
  },
  {
    id: "not-much",
    symbol: "nm",
    name: "Not Much",
  },
  {
    id: "notsafemoon",
    symbol: "notsafemoon",
    name: "NotSafeMoon",
  },
  {
    id: "nova",
    symbol: "nova",
    name: "NOVA",
  },
  {
    id: "novacoin",
    symbol: "nvc",
    name: "Novacoin",
  },
  {
    id: "nova-finance",
    symbol: "nova",
    name: "Nova Finance",
  },
  {
    id: "nova-miningverse",
    symbol: "nmv",
    name: "Nova Miningverse",
  },
  {
    id: "nova-network",
    symbol: "nbk",
    name: "Nova Token",
  },
  {
    id: "novara-calcio-fan-token",
    symbol: "nov",
    name: "Novara Calcio Fan Token",
  },
  {
    id: "novaxcrystal",
    symbol: "xcrs",
    name: "NovaXCrystal",
  },
  {
    id: "novaxmetal",
    symbol: "xmtl",
    name: "NovaXMetal",
  },
  {
    id: "novaxsolar",
    symbol: "xslr",
    name: "NovaXSolar",
  },
  {
    id: "novem-gold",
    symbol: "nnn",
    name: "Novem Gold",
  },
  {
    id: "novem-pro",
    symbol: "nvm",
    name: "Novem Pro",
  },
  {
    id: "novo-token",
    symbol: "novo",
    name: "Novo",
  },
  {
    id: "nowlage-coin",
    symbol: "nac",
    name: "Nowlage Coin",
  },
  {
    id: "npccoin",
    symbol: "npc",
    name: "NPCcoin",
  },
  {
    id: "npick-block",
    symbol: "npick",
    name: "NPick Block",
  },
  {
    id: "npo-coin",
    symbol: "npo",
    name: "NPO Coin",
  },
  {
    id: "nrgy-defi",
    symbol: "nrgy",
    name: "NRGY Defi",
  },
  {
    id: "nshare",
    symbol: "nshare",
    name: "NSHARE",
  },
  {
    id: "nsights",
    symbol: "nsi",
    name: "nSights",
  },
  {
    id: "nss-coin",
    symbol: "nss",
    name: "NSS Coin",
  },
  {
    id: "nsur-coin",
    symbol: "nsur",
    name: "NSUR Coin",
  },
  {
    id: "nsure-network",
    symbol: "nsure",
    name: "Nsure Network",
  },
  {
    id: "nubits",
    symbol: "usnbt",
    name: "NuBits",
  },
  {
    id: "nucleus-vision",
    symbol: "ncash",
    name: "Nucleus Vision",
  },
  {
    id: "nuco-cloud",
    symbol: "ncdt",
    name: "Nuco.Cloud",
  },
  {
    id: "nucoin",
    symbol: "nuc",
    name: "NuCoin",
  },
  {
    id: "nucypher",
    symbol: "nu",
    name: "NuCypher",
  },
  {
    id: "nudes",
    symbol: "nudes",
    name: "NUDES",
  },
  {
    id: "nuke-token",
    symbol: "nuke",
    name: "Nuke",
  },
  {
    id: "nuls",
    symbol: "nuls",
    name: "Nuls",
  },
  {
    id: "num-ars",
    symbol: "nuars",
    name: "Num ARS",
  },
  {
    id: "number-1-token",
    symbol: "nr1",
    name: "Number 1",
  },
  {
    id: "numbers-protocol",
    symbol: "num",
    name: "Numbers Protocol",
  },
  {
    id: "numeraire",
    symbol: "nmr",
    name: "Numeraire",
  },
  {
    id: "numisme",
    symbol: "nume",
    name: "NumisMe",
  },
  {
    id: "numitor",
    symbol: "numi",
    name: "Numitor",
  },
  {
    id: "nuna",
    symbol: "nuna",
    name: "Nuna",
  },
  {
    id: "nunet",
    symbol: "ntx",
    name: "NuNet",
  },
  {
    id: "nunu-spirits",
    symbol: "nnt",
    name: "Nunu Spirits",
  },
  {
    id: "nurifootball",
    symbol: "nrfb",
    name: "NuriFootBall",
  },
  {
    id: "nusd",
    symbol: "susd",
    name: "sUSD",
  },
  {
    id: "nusd-hotbit",
    symbol: "nusd",
    name: "nUSD (HotBit)",
  },
  {
    id: "nushares",
    symbol: "nsr",
    name: "NuShares",
  },
  {
    id: "nutgain",
    symbol: "nutgv2",
    name: "NUTGAIN",
  },
  {
    id: "nuts-gaming",
    symbol: "nutsg",
    name: "NUTS Gaming",
  },
  {
    id: "nuvo-cash",
    symbol: "nuvo",
    name: "Nuvo Cash",
  },
  {
    id: "nvidia-tokenized-stock-defichain",
    symbol: "dnvda",
    name: "Nvidia Tokenized Stock Defichain",
  },
  {
    id: "nvirworld",
    symbol: "nvir",
    name: "NvirWorld",
  },
  {
    id: "nvl-project",
    symbol: "nvl",
    name: "NVL Project",
  },
  {
    id: "nxm",
    symbol: "nxm",
    name: "Nexus Mutual",
  },
  {
    id: "nxt",
    symbol: "nxt",
    name: "NXT",
  },
  {
    id: "nxusd",
    symbol: "nxusd",
    name: "NXUSD",
  },
  {
    id: "nyan-cat",
    symbol: "ncat",
    name: "NCAT",
  },
  {
    id: "nyan-v2",
    symbol: "nyan-2",
    name: "Nyan V2",
  },
  {
    id: "nycccoin",
    symbol: "nyc",
    name: "NewYorkCityCoin",
  },
  {
    id: "nyerium",
    symbol: "nyex",
    name: "Nyerium",
  },
  {
    id: "nym",
    symbol: "nym",
    name: "Nym",
  },
  {
    id: "nynja",
    symbol: "nyn",
    name: "NYNJACoin",
  },
  {
    id: "nyx-token",
    symbol: "nyxt",
    name: "Nyx",
  },
  {
    id: "nyzo",
    symbol: "nyzo",
    name: "Nyzo",
  },
  {
    id: "nzd-stablecoin",
    symbol: "nzds",
    name: "NZD Stablecoin",
  },
  {
    id: "o3-swap",
    symbol: "o3",
    name: "O3 Swap",
  },
  {
    id: "oasis-2",
    symbol: "xos",
    name: "OASIS",
  },
  {
    id: "oasis-city",
    symbol: "osc",
    name: "Oasis City",
  },
  {
    id: "oasisdao",
    symbol: "oas",
    name: "OasisDAO",
  },
  {
    id: "oasis-gold",
    symbol: "og",
    name: "Oasis Gold",
  },
  {
    id: "oasis-network",
    symbol: "rose",
    name: "Oasis Network",
  },
  {
    id: "oasis-token",
    symbol: "oasis",
    name: "Oasis Token",
  },
  {
    id: "oath",
    symbol: "oath",
    name: "Oath",
  },
  {
    id: "obic",
    symbol: "obic",
    name: "OBIC",
  },
  {
    id: "obortech",
    symbol: "obot",
    name: "Obortech",
  },
  {
    id: "obrok",
    symbol: "obrok",
    name: "OBRok",
  },
  {
    id: "observer-coin",
    symbol: "obsr",
    name: "OBSERVER Coin",
  },
  {
    id: "obsidium",
    symbol: "obs",
    name: "Obsidium",
  },
  {
    id: "obtoken",
    symbol: "obt",
    name: "OB",
  },
  {
    id: "ocavu-network",
    symbol: "ocavu",
    name: "Ocavu Network",
  },
  {
    id: "occamfi",
    symbol: "occ",
    name: "OccamFi",
  },
  {
    id: "oceanex",
    symbol: "oce",
    name: "OceanEX",
  },
  {
    id: "oceanland",
    symbol: "oland",
    name: "OceanLand",
  },
  {
    id: "ocean-protocol",
    symbol: "ocean",
    name: "Ocean Protocol",
  },
  {
    id: "oceans-finance",
    symbol: "oceans",
    name: "Oceans Finance",
  },
  {
    id: "oceidon-blox",
    symbol: "oblox",
    name: "Oceidon Blox",
  },
  {
    id: "oc-protocol",
    symbol: "ocp",
    name: "OC Protocol",
  },
  {
    id: "ocra",
    symbol: "ocra",
    name: "OCRA",
  },
  {
    id: "octafarm",
    symbol: "octf",
    name: "Octafarm",
  },
  {
    id: "octane-protocol-token",
    symbol: "octane",
    name: "Octane Protocol",
  },
  {
    id: "octapay",
    symbol: "octa",
    name: "OctaPay",
  },
  {
    id: "octaplex-network",
    symbol: "plx",
    name: "Octaplex Network",
  },
  {
    id: "octaverse-games",
    symbol: "ovg",
    name: "Octaverse Games",
  },
  {
    id: "octax",
    symbol: "octax",
    name: "OctaX",
  },
  {
    id: "oction",
    symbol: "octi",
    name: "Oction",
  },
  {
    id: "octocoin",
    symbol: "888",
    name: "Octocoin",
  },
  {
    id: "octofi",
    symbol: "octo",
    name: "OctoFi",
  },
  {
    id: "octopus-network",
    symbol: "oct",
    name: "Octopus Network",
  },
  {
    id: "octopus-protocol",
    symbol: "ops",
    name: "Octopus Protocol",
  },
  {
    id: "octree-finance",
    symbol: "oak",
    name: "Octree Finance",
  },
  {
    id: "octus-bridge",
    symbol: "bridge",
    name: "Octus Bridge",
  },
  {
    id: "oculus-vision",
    symbol: "ocv",
    name: "Oculus Vision",
  },
  {
    id: "oddz",
    symbol: "oddz",
    name: "Oddz",
  },
  {
    id: "odem",
    symbol: "ode",
    name: "ODEM",
  },
  {
    id: "odin-platform",
    symbol: "odn",
    name: "Odin Platform",
  },
  {
    id: "odop",
    symbol: "odop",
    name: "oDOP",
  },
  {
    id: "oduwa-coin",
    symbol: "owc",
    name: "Oduwa Coin",
  },
  {
    id: "odyssey",
    symbol: "ocn",
    name: "Odyssey",
  },
  {
    id: "oec-bch",
    symbol: "bchk",
    name: "OEC BCH",
  },
  {
    id: "oec-btc",
    symbol: "btck",
    name: "OEC BTC",
  },
  {
    id: "oec-dai",
    symbol: "daik",
    name: "OEC DAI",
  },
  {
    id: "oec-eth",
    symbol: "ethk",
    name: "OEC ETH",
  },
  {
    id: "oec-fil",
    symbol: "filk",
    name: "OEC FIL",
  },
  {
    id: "oec-ltc",
    symbol: "ltck",
    name: "OEC LTC",
  },
  {
    id: "oec-token",
    symbol: "okt",
    name: "OKC",
  },
  {
    id: "oec-tron",
    symbol: "trxk",
    name: "OEC Tron",
  },
  {
    id: "oec-uni",
    symbol: "unik",
    name: "OEC UNI",
  },
  {
    id: "oec-xrp",
    symbol: "xrpk",
    name: "OEC XRP",
  },
  {
    id: "official-crypto-cowboy-token",
    symbol: "occt",
    name: "Official Crypto Cowboy",
  },
  {
    id: "offline",
    symbol: "off",
    name: "Offline",
  },
  {
    id: "offshift",
    symbol: "xft",
    name: "Offshift",
  },
  {
    id: "og-fan-token",
    symbol: "og",
    name: "OG Fan Token",
  },
  {
    id: "oh-finance",
    symbol: "oh",
    name: "Oh! Finance",
  },
  {
    id: "ohm-coin",
    symbol: "ohmc",
    name: "Ohmcoin",
  },
  {
    id: "oikos",
    symbol: "oks",
    name: "Oikos",
  },
  {
    id: "oilage",
    symbol: "oil",
    name: "OILage",
  },
  {
    id: "oiler",
    symbol: "oil",
    name: "Oiler",
  },
  {
    id: "oin-finance",
    symbol: "oin",
    name: "OIN Finance",
  },
  {
    id: "oink-token",
    symbol: "oink",
    name: "Oink",
  },
  {
    id: "oiocoin",
    symbol: "oioc",
    name: "OIOCoin",
  },
  {
    id: "ojamu",
    symbol: "oja",
    name: "Ojamu",
  },
  {
    id: "oje-token",
    symbol: "oje",
    name: "Oje",
  },
  {
    id: "okb",
    symbol: "okb",
    name: "OKB",
  },
  {
    id: "okcash",
    symbol: "ok",
    name: "OKCash",
  },
  {
    id: "ok-lets-go",
    symbol: "oklg",
    name: "ok.lets.go.",
  },
  {
    id: "okletsplay",
    symbol: "oklp",
    name: "OkLetsPlay",
  },
  {
    id: "okratech-token",
    symbol: "ort",
    name: "Okratech",
  },
  {
    id: "okuru",
    symbol: "xot",
    name: "Okuru",
  },
  {
    id: "ola-city",
    symbol: "ola",
    name: "Ola City",
  },
  {
    id: "olea",
    symbol: "ole",
    name: "Olea",
  },
  {
    id: "olecoin",
    symbol: "ole",
    name: "OleCoin",
  },
  {
    id: "olive",
    symbol: "olv",
    name: "OLIVE",
  },
  {
    id: "olivecash",
    symbol: "olive",
    name: "Olive Cash",
  },
  {
    id: "olympic-doge",
    symbol: "olympic doge",
    name: "Olympic Doge",
  },
  {
    id: "olympus",
    symbol: "ohm",
    name: "Olympus",
  },
  {
    id: "olympus-token",
    symbol: "olympus",
    name: "OLYMPUS Token",
  },
  {
    id: "olympus-v1",
    symbol: "ohm",
    name: "Olympus v1",
  },
  {
    id: "olympus-wormhole",
    symbol: "ohm",
    name: "Olympus (Wormhole)",
  },
  {
    id: "olyseum",
    symbol: "oly",
    name: "Olyseum",
  },
  {
    id: "oly-sport",
    symbol: "oly",
    name: "Oly Sport",
  },
  {
    id: "omax-token",
    symbol: "omax",
    name: "Omax",
  },
  {
    id: "ombre",
    symbol: "omb",
    name: "Ombre",
  },
  {
    id: "omega",
    symbol: "omega",
    name: "OMEGA",
  },
  {
    id: "omega-protocol-money",
    symbol: "opm",
    name: "Omega Protocol Money",
  },
  {
    id: "omicron",
    symbol: "omic",
    name: "Omicron",
  },
  {
    id: "omisego",
    symbol: "omg",
    name: "OMG Network",
  },
  {
    id: "omlira",
    symbol: "oml",
    name: "Omlira",
  },
  {
    id: "omm-tokens",
    symbol: "omm",
    name: "Omm",
  },
  {
    id: "omni",
    symbol: "omni",
    name: "Omni",
  },
  {
    id: "omnia",
    symbol: "omnia",
    name: "Omnia",
  },
  {
    id: "omniaverse",
    symbol: "omnia",
    name: "OmniaVerse",
  },
  {
    id: "omni-cash",
    symbol: "oca$h",
    name: "Omni Cash",
  },
  {
    id: "omni-consumer-protocol",
    symbol: "ocp",
    name: "Omni Consumer Protocol",
  },
  {
    id: "omnidex",
    symbol: "charm",
    name: "OmniDex",
  },
  {
    id: "omniflix-network",
    symbol: "flix",
    name: "OmniFlix Network",
  },
  {
    id: "omni-real-estate-token",
    symbol: "ort",
    name: "Omni Real Estate",
  },
  {
    id: "omnis",
    symbol: "omnis",
    name: "OMNIS",
  },
  {
    id: "omnitude",
    symbol: "ecom",
    name: "Omnitude",
  },
  {
    id: "omniwhirl",
    symbol: "whirl",
    name: "OmniWhirl",
  },
  {
    id: "omotenashicoin",
    symbol: "mtns",
    name: "OmotenashiCoin",
  },
  {
    id: "onbuff",
    symbol: "onit",
    name: "ONBUFF",
  },
  {
    id: "on-chain-capital",
    symbol: "occ",
    name: "On Chain Capital",
  },
  {
    id: "one",
    symbol: "one",
    name: "One",
  },
  {
    id: "one-basis-cash",
    symbol: "obs",
    name: "One Basis Cash",
  },
  {
    id: "onebit",
    symbol: "1bit",
    name: "OneBit",
  },
  {
    id: "onebtc",
    symbol: "onebtc",
    name: "Legacy oneBTC",
  },
  {
    id: "one-cash",
    symbol: "onc",
    name: "One Cash",
  },
  {
    id: "onedao-finance",
    symbol: "odao",
    name: "OneDao Finance",
  },
  {
    id: "one-dex",
    symbol: "odex",
    name: "One DEX",
  },
  {
    id: "onefortune",
    symbol: "bold",
    name: "OneFortune",
  },
  {
    id: "onefuse",
    symbol: "onefuse",
    name: "oneFUSE",
  },
  {
    id: "onegetcoin",
    symbol: "ogc",
    name: "Onegetcoin",
  },
  {
    id: "one-hundred-coin-2",
    symbol: "one",
    name: "One Hundred Coin",
  },
  {
    id: "one-ledger",
    symbol: "olt",
    name: "OneLedger",
  },
  {
    id: "oneperl",
    symbol: "oneperl",
    name: "onePERL",
  },
  {
    id: "one-piece",
    symbol: "onepiece",
    name: "ONE PIECE",
  },
  {
    id: "onerare",
    symbol: "orare",
    name: "OneRare",
  },
  {
    id: "onering",
    symbol: "ring",
    name: "OneRing",
  },
  {
    id: "oneroot-network",
    symbol: "rnt",
    name: "OneRoot Network",
  },
  {
    id: "one-share",
    symbol: "ons",
    name: "One Share",
  },
  {
    id: "oneswap-dao-token",
    symbol: "ones",
    name: "OneSwap DAO",
  },
  {
    id: "oneto11",
    symbol: "1to11",
    name: "OneTo11",
  },
  {
    id: "one-world-coin",
    symbol: "owo",
    name: "One World Coin",
  },
  {
    id: "ong",
    symbol: "ong",
    name: "Ontology Gas",
  },
  {
    id: "oni-exchange",
    symbol: "oni",
    name: "ONI Exchange",
  },
  {
    id: "onigiri",
    symbol: "onigiri",
    name: "Onigiri",
  },
  {
    id: "onion-mixer",
    symbol: "omt",
    name: "Onion Mixer",
  },
  {
    id: "oni-token",
    symbol: "oni",
    name: "ONINO",
  },
  {
    id: "onlexpa-token",
    symbol: "onlexpa",
    name: "onLEXpa",
  },
  {
    id: "online-cold-wallet",
    symbol: "ocw",
    name: "Online Cold Wallet",
  },
  {
    id: "online-expo",
    symbol: "expo",
    name: "Expo",
  },
  {
    id: "only1",
    symbol: "like",
    name: "Only1",
  },
  {
    id: "only-1-token",
    symbol: "o1t",
    name: "Only 1",
  },
  {
    id: "onomy-protocol",
    symbol: "nom",
    name: "Onomy Protocol",
  },
  {
    id: "onooks",
    symbol: "ooks",
    name: "Onooks",
  },
  {
    id: "onston",
    symbol: "onston",
    name: "Onston",
  },
  {
    id: "ontology",
    symbol: "ont",
    name: "Ontology",
  },
  {
    id: "onus",
    symbol: "onus",
    name: "ONUS",
  },
  {
    id: "onx-finance",
    symbol: "onx",
    name: "OnX Finance",
  },
  {
    id: "onxrp",
    symbol: "oxp",
    name: "onXRP",
  },
  {
    id: "onyx",
    symbol: "onyx",
    name: "Onyx",
  },
  {
    id: "oobit",
    symbol: "obt",
    name: "Oobit",
  },
  {
    id: "oogear",
    symbol: "og",
    name: "Oogear",
  },
  {
    id: "oogi",
    symbol: "oogi",
    name: "OOGI",
  },
  {
    id: "ooki",
    symbol: "ooki",
    name: "Ooki",
  },
  {
    id: "oolongswap",
    symbol: "olo",
    name: "OolongSwap",
  },
  {
    id: "opacity",
    symbol: "opct",
    name: "Opacity",
  },
  {
    id: "opalcoin",
    symbol: "auop",
    name: "Opalcoin",
  },
  {
    id: "op-coin",
    symbol: "opc",
    name: "OP Coin",
  },
  {
    id: "openalexa-protocol",
    symbol: "oap",
    name: "OpenAlexa Protocol",
  },
  {
    id: "openanx",
    symbol: "oax",
    name: "OAX",
  },
  {
    id: "opendao",
    symbol: "sos",
    name: "OpenDAO",
  },
  {
    id: "opendao-wormhole",
    symbol: "sos",
    name: "OpenDAO (Wormhole)",
  },
  {
    id: "open-data-protocol",
    symbol: "open",
    name: "Open Data Protocol",
  },
  {
    id: "open-governance-token",
    symbol: "open",
    name: "OPEN Governance",
  },
  {
    id: "openlive-nft",
    symbol: "opv",
    name: "OpenLive NFT",
  },
  {
    id: "opennity",
    symbol: "opnn",
    name: "Opennity",
  },
  {
    id: "openocean",
    symbol: "ooe",
    name: "OpenOcean",
  },
  {
    id: "open-platform",
    symbol: "open",
    name: "Open Platform",
  },
  {
    id: "openstream-world",
    symbol: "osw",
    name: "OpenStream World",
  },
  {
    id: "openswap",
    symbol: "oswap",
    name: "OpenSwap",
  },
  {
    id: "openswap-token",
    symbol: "openx",
    name: "OpenSwap.One",
  },
  {
    id: "operon-origins",
    symbol: "oro",
    name: "Operon Origins",
  },
  {
    id: "opes-wrapped-pe",
    symbol: "wpe",
    name: "OPES (Wrapped PE)",
  },
  {
    id: "opium",
    symbol: "opium",
    name: "Opium",
  },
  {
    id: "oppa",
    symbol: "oppa",
    name: "OPPA",
  },
  {
    id: "oppa-token",
    symbol: "oppa",
    name: "OPPA Token",
  },
  {
    id: "opsmen",
    symbol: "opsmen",
    name: "OPSMEN",
  },
  {
    id: "opsya-insurance",
    symbol: "opsy",
    name: "Opsya Insurance",
  },
  {
    id: "optimism",
    symbol: "op",
    name: "Optimism",
  },
  {
    id: "optimus",
    symbol: "optcm",
    name: "Optimus",
  },
  {
    id: "option-panda-platform",
    symbol: "opa",
    name: "Option Panda Platform",
  },
  {
    id: "option-room",
    symbol: "room",
    name: "OptionRoom",
  },
  {
    id: "optionroom-governance-token",
    symbol: "court",
    name: "OptionRoom Governance",
  },
  {
    id: "options-market",
    symbol: "osm",
    name: "Options Market",
  },
  {
    id: "optitoken",
    symbol: "opti",
    name: "Opti",
  },
  {
    id: "opulous",
    symbol: "opul",
    name: "Opulous",
  },
  {
    id: "opus",
    symbol: "opt",
    name: "Opus",
  },
  {
    id: "opyn-squeeth",
    symbol: "osqth",
    name: "Opyn Squeeth",
  },
  {
    id: "oraclechain",
    symbol: "oct",
    name: "OracleChain",
  },
  {
    id: "oracle-system",
    symbol: "orc",
    name: "Oracle System",
  },
  {
    id: "oracolxor",
    symbol: "xor",
    name: "Oracolxor",
  },
  {
    id: "oracula",
    symbol: "oracula",
    name: "Oracula",
  },
  {
    id: "oragonx",
    symbol: "orgn",
    name: "OragonX",
  },
  {
    id: "oraichain-token",
    symbol: "orai",
    name: "Oraichain",
  },
  {
    id: "orakler",
    symbol: "orkl",
    name: "Orakler",
  },
  {
    id: "orakuru",
    symbol: "ork",
    name: "Orakuru",
  },
  {
    id: "orao-network",
    symbol: "orao",
    name: "ORAO Network",
  },
  {
    id: "orbis",
    symbol: "orbc",
    name: "Orbis",
  },
  {
    id: "orbit-2",
    symbol: "orbit",
    name: "Orbit",
  },
  {
    id: "orbitau-taureum",
    symbol: "taum",
    name: "Orbitau Taureum",
  },
  {
    id: "orbit-chain",
    symbol: "orc",
    name: "Orbit Chain",
  },
  {
    id: "orbitcoin",
    symbol: "orb",
    name: "Orbitcoin",
  },
  {
    id: "orbit-token",
    symbol: "orbit",
    name: "First On The Moon ORBIT",
  },
  {
    id: "orbler",
    symbol: "orbr",
    name: "Orbler",
  },
  {
    id: "orbs",
    symbol: "orbs",
    name: "Orbs",
  },
  {
    id: "orbyt-token",
    symbol: "orbyt",
    name: "ORBYT Token",
  },
  {
    id: "orca",
    symbol: "orca",
    name: "Orca",
  },
  {
    id: "orca-avai",
    symbol: "avai",
    name: "Orca AVAI",
  },
  {
    id: "orcadao",
    symbol: "orca",
    name: "Orca DAO",
  },
  {
    id: "orchid-protocol",
    symbol: "oxt",
    name: "Orchid Protocol",
  },
  {
    id: "orclands-metaverse",
    symbol: "orc",
    name: "Orclands Metaverse",
  },
  {
    id: "orcus-oru",
    symbol: "oru",
    name: "Orcus ORU",
  },
  {
    id: "orcus-ousd",
    symbol: "oru",
    name: "Orcus OUSD",
  },
  {
    id: "order-of-the-apeverse",
    symbol: "oav",
    name: "Order of the Apeverse",
  },
  {
    id: "oren-game",
    symbol: "oren",
    name: "OREN Game",
  },
  {
    id: "ore-token",
    symbol: "ore",
    name: "ORE",
  },
  {
    id: "organix",
    symbol: "ogx",
    name: "Organix",
  },
  {
    id: "orica",
    symbol: "ori",
    name: "Orica",
  },
  {
    id: "orient-walt",
    symbol: "htdf",
    name: "Orient Walt",
  },
  {
    id: "original-crypto-coin",
    symbol: "tusc",
    name: "The Universal Settlement Coin",
  },
  {
    id: "original-gangsta-shiba",
    symbol: "ogshib",
    name: "Original Gangsta Shiba",
  },
  {
    id: "origin-dollar",
    symbol: "ousd",
    name: "Origin Dollar",
  },
  {
    id: "origin-protocol",
    symbol: "ogn",
    name: "Origin Protocol",
  },
  {
    id: "origin-sport",
    symbol: "ors",
    name: "Origin Sport",
  },
  {
    id: "origintrail",
    symbol: "trac",
    name: "OriginTrail",
  },
  {
    id: "origo",
    symbol: "ogo",
    name: "Origo",
  },
  {
    id: "orion-money",
    symbol: "orion",
    name: "Orion Money",
  },
  {
    id: "orion-protocol",
    symbol: "orn",
    name: "Orion Protocol",
  },
  {
    id: "orkan",
    symbol: "ork",
    name: "Orkan",
  },
  {
    id: "orlycoin",
    symbol: "orly",
    name: "Orlycoin",
  },
  {
    id: "ormeus-cash",
    symbol: "omc",
    name: "Ormeus Cash",
  },
  {
    id: "ormeuscoin",
    symbol: "orme",
    name: "Ormeus Coin",
  },
  {
    id: "ormeus-ecosystem",
    symbol: "eco",
    name: "Ormeus Ecosystem",
  },
  {
    id: "oro",
    symbol: "oro",
    name: "ORO",
  },
  {
    id: "oshare",
    symbol: "oshare",
    name: "OShare",
  },
  {
    id: "osk",
    symbol: "osk",
    name: "OSK",
  },
  {
    id: "osmiumcoin",
    symbol: "os76",
    name: "OsmiumCoin",
  },
  {
    id: "osmosis",
    symbol: "osmo",
    name: "Osmosis",
  },
  {
    id: "otcbtc-token",
    symbol: "otb",
    name: "OTCBTC",
  },
  {
    id: "ot-compound-dai",
    symbol: "ot-cdai-29dec2022",
    name: "OT Compound Dai",
  },
  {
    id: "otfinancial",
    symbol: "ot",
    name: "OTFINANCIAL",
  },
  {
    id: "otherdao",
    symbol: "othr",
    name: "OtherDAO",
  },
  {
    id: "otherlife",
    symbol: "otl",
    name: "OtherLife",
  },
  {
    id: "otium-technologies",
    symbol: "otium",
    name: "Otium Technologies",
  },
  {
    id: "otocash",
    symbol: "oto",
    name: "OTOCASH",
  },
  {
    id: "oto-protocol",
    symbol: "oto",
    name: "OTO Protocol",
  },
  {
    id: "ot-pendle-eth",
    symbol: "ot-pe-29dec2022",
    name: "OT-PENDLE/ETH",
  },
  {
    id: "otterclam",
    symbol: "clam",
    name: "OtterClam",
  },
  {
    id: "otter-finance",
    symbol: "otr",
    name: "Otter Finance",
  },
  {
    id: "oud",
    symbol: "oud",
    name: "OUD",
  },
  {
    id: "ouranos",
    symbol: "our",
    name: "Ouranos",
  },
  {
    id: "ourglass",
    symbol: "glass",
    name: "OurGlass",
  },
  {
    id: "ouroboros",
    symbol: "ouro",
    name: "Ouroboros",
  },
  {
    id: "ouro-governance-share",
    symbol: "ogs",
    name: "Ouro Governance Share",
  },
  {
    id: "ouro-stablecoin",
    symbol: "ouro",
    name: "Ouro Stablecoin",
  },
  {
    id: "our-pay",
    symbol: "our",
    name: "Our Pay",
  },
  {
    id: "ouse",
    symbol: "ouse",
    name: "Ouse",
  },
  {
    id: "outer-ring",
    symbol: "gq",
    name: "Galactic Quadrant",
  },
  {
    id: "outrace",
    symbol: "ore",
    name: "Outrace",
  },
  {
    id: "ovato",
    symbol: "ovo",
    name: "Ovato",
  },
  {
    id: "overline-emblem",
    symbol: "emb",
    name: "Overline Emblem",
  },
  {
    id: "overload-game",
    symbol: "ovl",
    name: "Overlord Game",
  },
  {
    id: "overlord",
    symbol: "lord",
    name: "Overlord",
  },
  {
    id: "ovr",
    symbol: "ovr",
    name: "Ovr",
  },
  {
    id: "owgaming",
    symbol: "ow",
    name: "OWGaming",
  },
  {
    id: "owldao",
    symbol: "owl",
    name: "OwlDAO",
  },
  {
    id: "owl-share",
    symbol: "oshare",
    name: "Owl Share",
  },
  {
    id: "owndata",
    symbol: "own",
    name: "OWNDATA",
  },
  {
    id: "ownix",
    symbol: "onx",
    name: "Ownix",
  },
  {
    id: "ownly",
    symbol: "own",
    name: "Ownly",
  },
  {
    id: "own-token",
    symbol: "own",
    name: "OWN Token",
  },
  {
    id: "oxbitcoin",
    symbol: "0xbtc",
    name: "0xBitcoin",
  },
  {
    id: "oxbull-solana",
    symbol: "oxs",
    name: "Oxbull Solana",
  },
  {
    id: "oxbull-tech",
    symbol: "oxb",
    name: "Oxbull Tech",
  },
  {
    id: "oxfinance",
    symbol: "oxfi",
    name: "Oxfinance",
  },
  {
    id: "oxo-farm",
    symbol: "oxo",
    name: "OXO.Farm",
  },
  {
    id: "oxsolid",
    symbol: "oxsolid",
    name: "oxSOLID",
  },
  {
    id: "oxy-dev",
    symbol: "oyt",
    name: "OxyDev",
  },
  {
    id: "oxygen",
    symbol: "oxy",
    name: "Oxygen",
  },
  {
    id: "ozagold",
    symbol: "ozg",
    name: "Ozagold",
  },
  {
    id: "p2p",
    symbol: "p2p",
    name: "P2P",
  },
  {
    id: "p2p-solutions-foundation",
    symbol: "p2ps",
    name: "P2P solutions foundation",
  },
  {
    id: "paccoin",
    symbol: "pac",
    name: "PAC Protocol",
  },
  {
    id: "pacific",
    symbol: "paf",
    name: "Pacific",
  },
  {
    id: "pacific-defi",
    symbol: "pacific",
    name: "Pacific DeFi",
  },
  {
    id: "packageportal",
    symbol: "port",
    name: "PackagePortal",
  },
  {
    id: "packswap",
    symbol: "pact",
    name: "PactSwap",
  },
  {
    id: "pacoca",
    symbol: "pacoca",
    name: "Pacoca",
  },
  {
    id: "pagan-gods-fur-token",
    symbol: "fur",
    name: "Pagan Gods Fur",
  },
  {
    id: "page",
    symbol: "page",
    name: "Page",
  },
  {
    id: "paid-network",
    symbol: "paid",
    name: "PAID Network",
  },
  {
    id: "paint",
    symbol: "paint",
    name: "MurAll",
  },
  {
    id: "paint-swap",
    symbol: "brush",
    name: "Paint Swap",
  },
  {
    id: "pakcoin",
    symbol: "pak",
    name: "Pakcoin",
  },
  {
    id: "pala",
    symbol: "pala",
    name: "Pala",
  },
  {
    id: "palace",
    symbol: "paa",
    name: "Palace",
  },
  {
    id: "paladin",
    symbol: "pal",
    name: "Paladin",
  },
  {
    id: "paladin-dao",
    symbol: "pal",
    name: "Paladin DAO",
  },
  {
    id: "paladin-stkaave",
    symbol: "palstkaave",
    name: "Paladin stkAAVE",
  },
  {
    id: "palantir-tokenized-stock-defichain",
    symbol: "dpltr",
    name: "Palantir Tokenized Stock Defichain",
  },
  {
    id: "palette",
    symbol: "plt",
    name: "Palette",
  },
  {
    id: "palgold",
    symbol: "palg",
    name: "PalGold",
  },
  {
    id: "pallapay",
    symbol: "palla",
    name: "Pallapay",
  },
  {
    id: "pallas-finance",
    symbol: "pallas",
    name: "Pallas Finance",
  },
  {
    id: "palletone",
    symbol: "ptn",
    name: "PalletOne",
  },
  {
    id: "pamp-network",
    symbol: "pamp",
    name: "Pamp Network",
  },
  {
    id: "pampther",
    symbol: "pampther",
    name: "Pampther",
  },
  {
    id: "pancake-bunny",
    symbol: "bunny",
    name: "Pancake Bunny",
  },
  {
    id: "pancake-games",
    symbol: "gcake",
    name: "Pancake Games",
  },
  {
    id: "pancake-hunny",
    symbol: "hunny",
    name: "Hunny Finance",
  },
  {
    id: "pancakelock",
    symbol: "plock",
    name: "PancakeLock",
  },
  {
    id: "pancakepoll",
    symbol: "ppoll",
    name: "PancakePoll",
  },
  {
    id: "pancakeswap-token",
    symbol: "cake",
    name: "PancakeSwap",
  },
  {
    id: "pancakeswap-wormhole",
    symbol: "cake",
    name: "PancakeSwap (Wormhole)",
  },
  {
    id: "pancaketools",
    symbol: "tcake",
    name: "PancakeTools",
  },
  {
    id: "pandacoin",
    symbol: "pnd",
    name: "Pandacoin",
  },
  {
    id: "panda-coin",
    symbol: "panda",
    name: "Panda Coin",
  },
  {
    id: "pandadao",
    symbol: "panda",
    name: "PandaDAO",
  },
  {
    id: "panda-dao",
    symbol: "pdao",
    name: "Panda Dao",
  },
  {
    id: "panda-girl",
    symbol: "pgirl",
    name: "Panda Girl",
  },
  {
    id: "panda-multiverse",
    symbol: "pndmlv",
    name: "Panda Multiverse",
  },
  {
    id: "pandaswap-2",
    symbol: "panda",
    name: "PandaSwap",
  },
  {
    id: "pando",
    symbol: "pando",
    name: "Pando",
  },
  {
    id: "pandora-cash",
    symbol: "pcash",
    name: "Pandora Cash",
  },
  {
    id: "pandora-protocol",
    symbol: "pndr",
    name: "Pandora Protocol",
  },
  {
    id: "pandora-spirit",
    symbol: "psr",
    name: "Pandora Spirit",
  },
  {
    id: "pando-rings",
    symbol: "rmob",
    name: "Pando Rings",
  },
  {
    id: "pando-token",
    symbol: "ptx",
    name: "PandoProject",
  },
  {
    id: "pando-usd",
    symbol: "pusd",
    name: "Pando USD",
  },
  {
    id: "pangolin",
    symbol: "png",
    name: "Pangolin",
  },
  {
    id: "pangolinswap",
    symbol: "pangolin",
    name: "Pangolinswap",
  },
  {
    id: "panicswap",
    symbol: "panic",
    name: "PanicSwap",
  },
  {
    id: "pantheon-x",
    symbol: "xpn",
    name: "PANTHEON X",
  },
  {
    id: "panther",
    symbol: "zkp",
    name: "Panther Protocol",
  },
  {
    id: "pantherswap",
    symbol: "panther",
    name: "PantherSwap",
  },
  {
    id: "pantos",
    symbol: "pan",
    name: "Pantos",
  },
  {
    id: "panvala-pan",
    symbol: "pan",
    name: "Panvala Pan",
  },
  {
    id: "papa-doge",
    symbol: "papadoge",
    name: "Papa Doge",
  },
  {
    id: "paparazzi",
    symbol: "pazzi",
    name: "Paparazzi",
  },
  {
    id: "papel",
    symbol: "papel",
    name: "Papel",
  },
  {
    id: "paper-fantom",
    symbol: "paper",
    name: "Paper",
  },
  {
    id: "pappay",
    symbol: "pappay",
    name: "Pappay",
  },
  {
    id: "paprprintr-finance",
    symbol: "papr",
    name: "Paprprintr Finance",
  },
  {
    id: "parabolic-2",
    symbol: "para",
    name: "Parabolic",
  },
  {
    id: "parachute",
    symbol: "par",
    name: "Parachute",
  },
  {
    id: "paradisehotel-nft",
    symbol: "pht",
    name: "ParadiseHotel NFT",
  },
  {
    id: "paradox-nft",
    symbol: "pxbsc",
    name: "Paradox NFT",
  },
  {
    id: "paragen",
    symbol: "rgen",
    name: "Paragen",
  },
  {
    id: "paragon-capital",
    symbol: "paragon",
    name: "Paragon Capital",
  },
  {
    id: "paragonsdao",
    symbol: "pdt",
    name: "ParagonsDAO",
  },
  {
    id: "paralink-network",
    symbol: "para",
    name: "Paralink Network",
  },
  {
    id: "parallelchain",
    symbol: "xpll",
    name: "ParallelChain",
  },
  {
    id: "parallelcoin",
    symbol: "duo",
    name: "ParallelCoin",
  },
  {
    id: "paras",
    symbol: "paras",
    name: "Paras",
  },
  {
    id: "parasol-finance",
    symbol: "psol",
    name: "Parasol Finance",
  },
  {
    id: "parasset",
    symbol: "aset",
    name: "Parasset",
  },
  {
    id: "parastate",
    symbol: "state",
    name: "ParaState",
  },
  {
    id: "paraswap",
    symbol: "psp",
    name: "ParaSwap",
  },
  {
    id: "paratoken",
    symbol: "para",
    name: "ParaToken [OLD]",
  },
  {
    id: "paratoken-2",
    symbol: "para",
    name: "Para",
  },
  {
    id: "parex",
    symbol: "prx",
    name: "Parex",
  },
  {
    id: "paribu-net",
    symbol: "prb",
    name: "Paribu Net",
  },
  {
    id: "paribus",
    symbol: "pbx",
    name: "Paribus",
  },
  {
    id: "paris-saint-germain-fan-token",
    symbol: "psg",
    name: "Paris Saint-Germain Fan Token",
  },
  {
    id: "parkgene",
    symbol: "gene",
    name: "Parkgene",
  },
  {
    id: "parking-infinity-token",
    symbol: "park",
    name: "Parking Infinity",
  },
  {
    id: "parkingo",
    symbol: "got",
    name: "ParkinGo",
  },
  {
    id: "parma",
    symbol: "parma",
    name: "PARMA",
  },
  {
    id: "parrotdao",
    symbol: "parr",
    name: "ParrotDao",
  },
  {
    id: "parrot-egg",
    symbol: "ipegg",
    name: "Parrot Egg",
  },
  {
    id: "parrot-protocol",
    symbol: "prt",
    name: "Parrot Protocol",
  },
  {
    id: "parrot-usd",
    symbol: "pai",
    name: "Parrot USD",
  },
  {
    id: "parsiq",
    symbol: "prq",
    name: "PARSIQ",
  },
  {
    id: "parsiq-boost",
    symbol: "prqboost",
    name: "Parsiq Boost",
  },
  {
    id: "parsl",
    symbol: "seed",
    name: "Parsl",
  },
  {
    id: "par-stablecoin",
    symbol: "par",
    name: "Parallel",
  },
  {
    id: "partial",
    symbol: "partial",
    name: "Partial",
  },
  {
    id: "partial-share",
    symbol: "pshare",
    name: "Partial Share",
  },
  {
    id: "particl",
    symbol: "part",
    name: "Particl",
  },
  {
    id: "particle-2",
    symbol: "prtcle",
    name: "Particle",
  },
  {
    id: "particle-technology",
    symbol: "part",
    name: "Particle Technology",
  },
  {
    id: "partisia-blockchain",
    symbol: "mpc",
    name: "Partisia Blockchain",
  },
  {
    id: "partneroid",
    symbol: "ptr",
    name: "Partner Coin",
  },
  {
    id: "parts-of-four-coin",
    symbol: "p4c",
    name: "Parts of Four Coin",
  },
  {
    id: "partyboard",
    symbol: "pab",
    name: "PartyBoard",
  },
  {
    id: "party-dog",
    symbol: "pdog",
    name: "Party Dog",
  },
  {
    id: "pascalcoin",
    symbol: "pasc",
    name: "Pascal",
  },
  {
    id: "pasha",
    symbol: "pasha",
    name: "Pasha",
  },
  {
    id: "passive-income",
    symbol: "psi",
    name: "Passive Income",
  },
  {
    id: "passive-token",
    symbol: "passive",
    name: "Passive",
  },
  {
    id: "passport-finance",
    symbol: "pass",
    name: "Passport Finance",
  },
  {
    id: "pasta-finance",
    symbol: "pasta",
    name: "Pasta Finance",
  },
  {
    id: "pastel",
    symbol: "psl",
    name: "Pastel",
  },
  {
    id: "pastrypunks",
    symbol: "pastrypunks",
    name: "PastryPunks",
  },
  {
    id: "pasv",
    symbol: "pasv",
    name: "PASV",
  },
  {
    id: "pathdao",
    symbol: "path",
    name: "PathDAO",
  },
  {
    id: "pathfundv2",
    symbol: "path",
    name: "PathFundV2",
  },
  {
    id: "patientory",
    symbol: "ptoy",
    name: "Patientory",
  },
  {
    id: "patriot-exchange",
    symbol: "patx",
    name: "Patriot Exchange",
  },
  {
    id: "patron",
    symbol: "pat",
    name: "Patron",
  },
  {
    id: "pavecoin",
    symbol: "pvn",
    name: "Pavecoin",
  },
  {
    id: "pavia",
    symbol: "pavia",
    name: "Pavia",
  },
  {
    id: "paw",
    symbol: "paw",
    name: "Paw",
  },
  {
    id: "pawn",
    symbol: "pawn",
    name: "Pawn",
  },
  {
    id: "pawn-my-nft",
    symbol: "pnft",
    name: "Pawn My NFT",
  },
  {
    id: "paws-funds",
    symbol: "paws",
    name: "Paws Funds",
  },
  {
    id: "pawthereum",
    symbol: "pawth",
    name: "Pawthereum",
  },
  {
    id: "pawtocol",
    symbol: "upi",
    name: "Pawtocol",
  },
  {
    id: "paw-v2",
    symbol: "paw",
    name: "Paw V2",
  },
  {
    id: "pax-gold",
    symbol: "paxg",
    name: "PAX Gold",
  },
  {
    id: "paxos-gold-wormhole",
    symbol: "paxg",
    name: "Paxos Gold (Wormhole)",
  },
  {
    id: "paxos-standard",
    symbol: "usdp",
    name: "Pax Dollar",
  },
  {
    id: "payaccept",
    symbol: "payt",
    name: "PayAccept",
  },
  {
    id: "payb",
    symbol: "payb",
    name: "PayB",
  },
  {
    id: "paybandcoin",
    symbol: "pybc",
    name: "PaybandCoin",
  },
  {
    id: "paybolt",
    symbol: "pay",
    name: "PayBolt",
  },
  {
    id: "paybswap",
    symbol: "payb",
    name: "Paybswap",
  },
  {
    id: "paycent",
    symbol: "pyn",
    name: "Paycent",
  },
  {
    id: "paycer-protocol",
    symbol: "pcr",
    name: "Paycer Protocol",
  },
  {
    id: "paycheck-defi",
    symbol: "check",
    name: "Paycheck",
  },
  {
    id: "pay-coin",
    symbol: "pci",
    name: "Paycoin",
  },
  {
    id: "paycon-token",
    symbol: "con",
    name: "Paycon",
  },
  {
    id: "paygo",
    symbol: "paygo",
    name: "PayGo",
  },
  {
    id: "pay-it-now",
    symbol: "pin",
    name: "Pay It Now",
  },
  {
    id: "paymastercoin",
    symbol: "pmc",
    name: "PayMasterCoin",
  },
  {
    id: "payment-coin",
    symbol: "pod",
    name: "Payment Coin",
  },
  {
    id: "paynet-coin",
    symbol: "payn",
    name: "PayNet Coin",
  },
  {
    id: "paypal-tokenized-stock-zipmex",
    symbol: "pypl",
    name: "Paypal Tokenized Stock Zipmex",
  },
  {
    id: "paypie",
    symbol: "ppp",
    name: "PayPie",
  },
  {
    id: "paypolitan-token",
    symbol: "epan",
    name: "Paypolitan",
  },
  {
    id: "payrue",
    symbol: "propel",
    name: "Propel",
  },
  {
    id: "paytomat",
    symbol: "pti",
    name: "Paytomat",
  },
  {
    id: "payturn",
    symbol: "ptr",
    name: "Payturn",
  },
  {
    id: "payyoda",
    symbol: "yot",
    name: "PayYoda",
  },
  {
    id: "payz-payments",
    symbol: "payz",
    name: "Payz Payments",
  },
  {
    id: "pbtc35a",
    symbol: "pbtc35a",
    name: "pBTC35A",
  },
  {
    id: "pchain",
    symbol: "pi",
    name: "Plian",
  },
  {
    id: "pdbc-defichain",
    symbol: "dpdbc",
    name: "PDBC Defichain",
  },
  {
    id: "pddollar",
    symbol: "pdd",
    name: "PDDOLLAR",
  },
  {
    id: "pdollar",
    symbol: "pdo",
    name: "pDollar",
  },
  {
    id: "pdollar-share",
    symbol: "spdo",
    name: "pDollar Share",
  },
  {
    id: "pdshare",
    symbol: "pdshare",
    name: "PDSHARE",
  },
  {
    id: "pdx-coin",
    symbol: "pdx",
    name: "PDX Coin",
  },
  {
    id: "peace-dao",
    symbol: "peace",
    name: "Peace DAO",
  },
  {
    id: "peace-doge",
    symbol: "peacedoge",
    name: "Peace Doge",
  },
  {
    id: "peace-token",
    symbol: "pet",
    name: "Peace",
  },
  {
    id: "peach-finance",
    symbol: "peech",
    name: "Peach Finance",
  },
  {
    id: "peachfolio",
    symbol: "pchf",
    name: "Peachfolio",
  },
  {
    id: "peacockcoin",
    symbol: "pekc",
    name: "Peacockcoin",
  },
  {
    id: "peacockcoin-eth",
    symbol: "pekc",
    name: "Peacockcoin (ETH)",
  },
  {
    id: "pea-farm",
    symbol: "pea",
    name: "Pea Farm",
  },
  {
    id: "peak-avalanche",
    symbol: "peakavax",
    name: "Peak Avalanche",
  },
  {
    id: "peak-finance",
    symbol: "peak",
    name: "Peak Finance",
  },
  {
    id: "peakmines-peak",
    symbol: "peak",
    name: "Peakmines PEAK",
  },
  {
    id: "peanut",
    symbol: "nux",
    name: "Peanut",
  },
  {
    id: "pear",
    symbol: "pear",
    name: "Pear",
  },
  {
    id: "peardao",
    symbol: "pex",
    name: "PearDAO",
  },
  {
    id: "pearl-finance",
    symbol: "pearl",
    name: "Pearl Finance",
  },
  {
    id: "peaswap",
    symbol: "pea",
    name: "PeaSwap",
  },
  {
    id: "peculium-2",
    symbol: "pcl",
    name: "Peculium",
  },
  {
    id: "peecoin-charts",
    symbol: "peecoin",
    name: "PeeCoin Charts",
  },
  {
    id: "peepcoin",
    symbol: "pcn",
    name: "Peepcoin",
  },
  {
    id: "peercoin",
    symbol: "ppc",
    name: "Peercoin",
  },
  {
    id: "peerex-network",
    symbol: "perx",
    name: "PeerEx Network",
  },
  {
    id: "peerguess",
    symbol: "guess",
    name: "PeerGuess",
  },
  {
    id: "peet-defi",
    symbol: "pte",
    name: "Peet DeFi",
  },
  {
    id: "pegascoin",
    symbol: "pgc",
    name: "Pegascoin",
  },
  {
    id: "pegasusdao",
    symbol: "sus",
    name: "PegasusDAO",
  },
  {
    id: "pegasus-finance",
    symbol: "pega",
    name: "Pegasus Finance",
  },
  {
    id: "pegasys",
    symbol: "psys",
    name: "Pegasys",
  },
  {
    id: "pegaxy-stone",
    symbol: "pgx",
    name: "Pegaxy Stone",
  },
  {
    id: "pegazus-finance",
    symbol: "peg",
    name: "Pegazus Finance",
  },
  {
    id: "pegnet",
    symbol: "peg",
    name: "PegNet",
  },
  {
    id: "pele-network",
    symbol: "pele",
    name: "PELE Network",
  },
  {
    id: "pellet-food",
    symbol: "pellet",
    name: "Pellet Food",
  },
  {
    id: "pembrock",
    symbol: "pem",
    name: "Pembrock",
  },
  {
    id: "pencil-dao",
    symbol: "pencil",
    name: "Pencil DAO",
  },
  {
    id: "pendle",
    symbol: "pendle",
    name: "Pendle",
  },
  {
    id: "pengolincoin",
    symbol: "pgo",
    name: "PengolinCoin",
  },
  {
    id: "penguin-finance",
    symbol: "pefi",
    name: "Penguin Finance",
  },
  {
    id: "penguin-karts",
    symbol: "pgk",
    name: "Penguin Karts",
  },
  {
    id: "penguin-party-fish",
    symbol: "fish",
    name: "Penguin Party Fish",
  },
  {
    id: "penky",
    symbol: "penky",
    name: "Penky",
  },
  {
    id: "penny-for-bit",
    symbol: "pfb",
    name: "Penny For Bit",
  },
  {
    id: "pension-plan",
    symbol: "pp",
    name: "Pension Plan",
  },
  {
    id: "peony-coin",
    symbol: "pny",
    name: "Peony Coin",
  },
  {
    id: "peoples-punk",
    symbol: "dddd",
    name: "People's Punk",
  },
  {
    id: "peoplez",
    symbol: "lez",
    name: "Peoplez",
  },
  {
    id: "peos",
    symbol: "peos",
    name: "pEOS",
  },
  {
    id: "pepedex",
    symbol: "ppdex",
    name: "Pepedex",
  },
  {
    id: "pepegold",
    symbol: "peps",
    name: "PEPS Coin",
  },
  {
    id: "pepemoon",
    symbol: "pepe",
    name: "Pepemoon",
  },
  {
    id: "pepeverse",
    symbol: "pepevr",
    name: "PepeVerse",
  },
  {
    id: "pera-finance",
    symbol: "pera",
    name: "Pera Finance",
  },
  {
    id: "perfect-world",
    symbol: "pfw",
    name: "Perfect World",
  },
  {
    id: "peri-finance",
    symbol: "peri",
    name: "PERI Finance",
  },
  {
    id: "perion",
    symbol: "perc",
    name: "Perion",
  },
  {
    id: "perkle",
    symbol: "prkl",
    name: "Perkle",
  },
  {
    id: "perlin",
    symbol: "perl",
    name: "PERL.eco",
  },
  {
    id: "permission-coin",
    symbol: "ask",
    name: "Permission Coin",
  },
  {
    id: "perpetual-protocol",
    symbol: "perp",
    name: "Perpetual Protocol",
  },
  {
    id: "perpetual-wormhole",
    symbol: "perp",
    name: "Perpetual (Wormhole)",
  },
  {
    id: "perpetuum-coin",
    symbol: "prp",
    name: "Perpetuum Coin",
  },
  {
    id: "per-project",
    symbol: "per",
    name: "PER Project",
  },
  {
    id: "persia",
    symbol: "persia",
    name: "Persia",
  },
  {
    id: "persistence",
    symbol: "xprt",
    name: "Persistence",
  },
  {
    id: "persistence-staked-xprt",
    symbol: "stkxprt",
    name: "pSTAKE Staked XPRT",
  },
  {
    id: "perth-mint-gold-token",
    symbol: "pmgt",
    name: "Perth Mint Gold Token",
  },
  {
    id: "pesabase",
    symbol: "pesa",
    name: "Pesabase",
  },
  {
    id: "peseta-digital",
    symbol: "ptd",
    name: "Peseta Digital",
  },
  {
    id: "pet-alliance",
    symbol: "pal",
    name: "Pet Alliance",
  },
  {
    id: "pet-games",
    symbol: "petg",
    name: "Pet Games",
  },
  {
    id: "peth18c",
    symbol: "peth18c",
    name: "pETH18C",
  },
  {
    id: "petoverse",
    symbol: "peto",
    name: "Petoverse",
  },
  {
    id: "petrachor",
    symbol: "pta",
    name: "Petrachor",
  },
  {
    id: "petrodollar",
    symbol: "xpd",
    name: "PetroDollar",
  },
  {
    id: "petshelp",
    symbol: "peth",
    name: "PetsHelp",
  },
  {
    id: "petsneaker",
    symbol: "psc",
    name: "Petsneaker",
  },
  {
    id: "pexcoin",
    symbol: "pex",
    name: "Pexcoin",
  },
  {
    id: "pftm",
    symbol: "pftm",
    name: "pFTM",
  },
  {
    id: "pha",
    symbol: "pha",
    name: "Phala Network",
  },
  {
    id: "phaeton",
    symbol: "phae",
    name: "Phaeton",
  },
  {
    id: "phant",
    symbol: "pnt",
    name: "Phant",
  },
  {
    id: "phantamdao",
    symbol: "phm",
    name: "PhantomDAO",
  },
  {
    id: "phantasia",
    symbol: "fant",
    name: "Phantasia",
  },
  {
    id: "phantasma",
    symbol: "soul",
    name: "Phantasma",
  },
  {
    id: "phantasma-energy",
    symbol: "kcal",
    name: "Phantasma Energy",
  },
  {
    id: "phantasma-energy-old",
    symbol: "kcal",
    name: "Phantasma Energy [OLD]",
  },
  {
    id: "phantom-protocol",
    symbol: "phm",
    name: "Phantom Protocol",
  },
  {
    id: "phenix",
    symbol: "phenix",
    name: "Phenix",
  },
  {
    id: "phenix-finance",
    symbol: "phnx",
    name: "Phenix Finance",
  },
  {
    id: "phifi-finance",
    symbol: "phifiv2",
    name: "PhiFi Finance",
  },
  {
    id: "philcoin",
    symbol: "phl",
    name: "Philcoin",
  },
  {
    id: "philetairus-socius",
    symbol: "socius",
    name: "Philetairus Socius",
  },
  {
    id: "philips-pay-coin",
    symbol: "ppc",
    name: "PHILLIPS PAY COIN",
  },
  {
    id: "phillionex",
    symbol: "phn",
    name: "Phillionex",
  },
  {
    id: "philscurrency",
    symbol: "wage",
    name: "Digiwage",
  },
  {
    id: "phoenix",
    symbol: "phx",
    name: "Phoenix",
  },
  {
    id: "phoenixchain",
    symbol: "pcn",
    name: "PhoenixChain",
  },
  {
    id: "phoenixcoin",
    symbol: "pxc",
    name: "Phoenixcoin",
  },
  {
    id: "phoenixdao",
    symbol: "phnx",
    name: "PhoenixDAO",
  },
  {
    id: "phoenix-defi-finance",
    symbol: "pnixs",
    name: "Phoenix Defi Finance",
  },
  {
    id: "phoenixdefi-finance",
    symbol: "pnix",
    name: "PhoenixDefi.Finance",
  },
  {
    id: "phoenix-global",
    symbol: "phb",
    name: "Phoenix Global",
  },
  {
    id: "phoenix-token",
    symbol: "phx",
    name: "Phoenix Finance",
  },
  {
    id: "phoneum",
    symbol: "pht",
    name: "Phoneum",
  },
  {
    id: "phonon-dao",
    symbol: "phonon",
    name: "Phonon DAO",
  },
  {
    id: "phore",
    symbol: "phr",
    name: "Phore",
  },
  {
    id: "phoswap",
    symbol: "pho",
    name: "Phoswap",
  },
  {
    id: "photochromic",
    symbol: "phcr",
    name: "PhotoChromic",
  },
  {
    id: "photon",
    symbol: "pho",
    name: "Photon",
  },
  {
    id: "photonswap",
    symbol: "photon",
    name: "PhotonSwap",
  },
  {
    id: "phuket-holiday-coin",
    symbol: "phc",
    name: "Phuket Holiday Coin",
  },
  {
    id: "phunk-vault-nftx",
    symbol: "phunk",
    name: "PHUNK Vault (NFTX)",
  },
  {
    id: "phuntoken",
    symbol: "phtk",
    name: "Phun",
  },
  {
    id: "phu-quoc-dog",
    symbol: "pqd",
    name: "Phu Quoc Dog",
  },
  {
    id: "phuture",
    symbol: "phtr",
    name: "Phuture",
  },
  {
    id: "phuture-defi-index",
    symbol: "pdi",
    name: "Phuture DeFi Index",
  },
  {
    id: "physis",
    symbol: "phy",
    name: "Physis",
  },
  {
    id: "piasa",
    symbol: "piasa",
    name: "PIASA",
  },
  {
    id: "pibble",
    symbol: "pib",
    name: "Pibble",
  },
  {
    id: "picartnft",
    symbol: "panft",
    name: "PicArtNFT",
  },
  {
    id: "picasso-network",
    symbol: "pica",
    name: "Picasso Network",
  },
  {
    id: "piccolo-inu",
    symbol: "pinu",
    name: "Piccolo Inu",
  },
  {
    id: "picipo",
    symbol: "picipo",
    name: "Picipo",
  },
  {
    id: "pick",
    symbol: "pick",
    name: "PICK",
  },
  {
    id: "pickle-finance",
    symbol: "pickle",
    name: "Pickle Finance",
  },
  {
    id: "picogo",
    symbol: "pico",
    name: "PicoGo",
  },
  {
    id: "piction-network",
    symbol: "pxl",
    name: "Piction Network",
  },
  {
    id: "pidao",
    symbol: "pid",
    name: "PIDAO",
  },
  {
    id: "piedao-balanced-crypto-pie",
    symbol: "bcp",
    name: "PieDAO Balanced Crypto Pie",
  },
  {
    id: "piedao-btc",
    symbol: "btc++",
    name: "PieDAO BTC++",
  },
  {
    id: "piedao-defi",
    symbol: "defi++",
    name: "PieDAO DEFI++",
  },
  {
    id: "piedao-defi-large-cap",
    symbol: "defi+l",
    name: "PieDAO DEFI Large Cap",
  },
  {
    id: "piedao-defi-small-cap",
    symbol: "defi+s",
    name: "PieDAO DEFI Small Cap",
  },
  {
    id: "piedao-dough-v2",
    symbol: "dough",
    name: "PieDAO DOUGH v2",
  },
  {
    id: "piedao-yearn-ecosystem-pie",
    symbol: "ypie",
    name: "PieDAO Yearn Ecosystem Pie",
  },
  {
    id: "pieme",
    symbol: "pie",
    name: "Pieme",
  },
  {
    id: "pie-share",
    symbol: "pie",
    name: "Pie Share",
  },
  {
    id: "pige-inu",
    symbol: "pinu",
    name: "Pige Inu",
  },
  {
    id: "pigeoncoin",
    symbol: "pgn",
    name: "Pigeoncoin",
  },
  {
    id: "pigeon-sol",
    symbol: "pgnt",
    name: "Pigeon Sol",
  },
  {
    id: "pig-finance",
    symbol: "pig",
    name: "Pig Finance",
  },
  {
    id: "piggy",
    symbol: "piggy",
    name: "Piggy",
  },
  {
    id: "piggy-bank",
    symbol: "pb",
    name: "Piggy Bank",
  },
  {
    id: "piggy-bank-token",
    symbol: "piggy",
    name: "PiggyBank",
  },
  {
    id: "piggy-finance",
    symbol: "piggy",
    name: "Piggy Finance",
  },
  {
    id: "piggy-planet",
    symbol: "pigi",
    name: "Piggy Planet",
  },
  {
    id: "piggy-share",
    symbol: "pshare",
    name: "Piggy Share",
  },
  {
    id: "pigs",
    symbol: "pigs",
    name: "PIGS",
  },
  {
    id: "pikachu",
    symbol: "pika",
    name: "Pika",
  },
  {
    id: "pikachu-inu",
    symbol: "pikachu",
    name: "Pikachu Inu",
  },
  {
    id: "pikaster",
    symbol: "mls",
    name: "Pikaster",
  },
  {
    id: "pillar",
    symbol: "plr",
    name: "Pillar",
  },
  {
    id: "pilot",
    symbol: "ptd",
    name: "Pilot",
  },
  {
    id: "pine",
    symbol: "pine",
    name: "Pine",
  },
  {
    id: "pineapple-swap",
    symbol: "pns",
    name: "Pineapple swap",
  },
  {
    id: "pinecone-finance",
    symbol: "pct",
    name: "Pinecone Finance",
  },
  {
    id: "pi-network-defi",
    symbol: "pinetworkdefi",
    name: "Pi Network DeFi",
  },
  {
    id: "pinkcoin",
    symbol: "pink",
    name: "Pinkcoin",
  },
  {
    id: "pinkelon",
    symbol: "pinke",
    name: "PinkElon",
  },
  {
    id: "pinkmoon",
    symbol: "pinkm",
    name: "PinkMoon",
  },
  {
    id: "pinknode",
    symbol: "pnode",
    name: "Pinknode",
  },
  {
    id: "pink-panda",
    symbol: "pinkpanda",
    name: "Pink Panda",
  },
  {
    id: "pink-panther",
    symbol: "pink",
    name: "PINK PANTHER",
  },
  {
    id: "pinkpea-finance",
    symbol: "pea",
    name: "PinkPea.Finance",
  },
  {
    id: "pinksale",
    symbol: "pinksale",
    name: "PinkSale",
  },
  {
    id: "pinkslip-finance",
    symbol: "pslip",
    name: "Pinkslip Finance",
  },
  {
    id: "pinkswap-token",
    symbol: "pinks",
    name: "PinkSwap",
  },
  {
    id: "pintu-token",
    symbol: "ptu",
    name: "Pintu",
  },
  {
    id: "pip",
    symbol: "pip",
    name: "PIP",
  },
  {
    id: "piplcoin",
    symbol: "pipl",
    name: "PiplCoin",
  },
  {
    id: "pippi-finance",
    symbol: "pipi",
    name: "Pippi Finance",
  },
  {
    id: "pirate-boy",
    symbol: "pirateboy",
    name: "Pirate Boy",
  },
  {
    id: "piratecash",
    symbol: "pirate",
    name: "PirateCash",
  },
  {
    id: "pirate-chain",
    symbol: "arrr",
    name: "Pirate Chain",
  },
  {
    id: "piratecoin",
    symbol: "piratecoin☠",
    name: "PirateCoin",
  },
  {
    id: "piratedao",
    symbol: "jolly",
    name: "PirateDAO",
  },
  {
    id: "pirate-dice",
    symbol: "booty",
    name: "Pirate Dice",
  },
  {
    id: "pirate-inu",
    symbol: "pinu",
    name: "Pirate Inu",
  },
  {
    id: "piratera",
    symbol: "pira",
    name: "Piratera",
  },
  {
    id: "piratesking",
    symbol: "pkt",
    name: "PiratesKing",
  },
  {
    id: "pirate-x-pirate",
    symbol: "pxp",
    name: "Pirate x Pirate",
  },
  {
    id: "piston",
    symbol: "pstn",
    name: "Piston",
  },
  {
    id: "pist-trust",
    symbol: "pist",
    name: "Pist Trust",
  },
  {
    id: "pitbull",
    symbol: "pit",
    name: "Pitbull",
  },
  {
    id: "pitch",
    symbol: "pitch",
    name: "Pitch",
  },
  {
    id: "pitquidity-bsc",
    symbol: "pitqd",
    name: "Pitquidity-BSC",
  },
  {
    id: "pittys",
    symbol: "pittys",
    name: "Pittys",
  },
  {
    id: "pivot-token",
    symbol: "pvt",
    name: "Pivot",
  },
  {
    id: "pivx",
    symbol: "pivx",
    name: "PIVX",
  },
  {
    id: "pivx-lite",
    symbol: "pivxl",
    name: "Pivx Lite",
  },
  {
    id: "pixelgas",
    symbol: "pixelgas",
    name: "PixelGas",
  },
  {
    id: "pixelsquid",
    symbol: "pixelsquid",
    name: "PixelSQUID",
  },
  {
    id: "pixels-so",
    symbol: "pixl",
    name: "Pixels.so",
  },
  {
    id: "pixelverse",
    symbol: "pixel",
    name: "PixelVerse",
  },
  {
    id: "pixeos",
    symbol: "pixeos",
    name: "PixEOS",
  },
  {
    id: "pixiu-finance",
    symbol: "pixiu",
    name: "Pixiu Finance",
  },
  {
    id: "pixl-coin-2",
    symbol: "pxlc",
    name: "Pixl Coin",
  },
  {
    id: "pixls-vault-nftx",
    symbol: "pixls",
    name: "PIXLS Vault (NFTX)",
  },
  {
    id: "pizza-game",
    symbol: "pizza",
    name: "Pizza Game",
  },
  {
    id: "pizza-nft",
    symbol: "$pizza",
    name: "Pizza NFT",
  },
  {
    id: "pizza-pug-coin",
    symbol: "ppug",
    name: "Pizza Pug Coin",
  },
  {
    id: "pizzaswap",
    symbol: "pizza",
    name: "PizzaSwap",
  },
  {
    id: "pizza-usde",
    symbol: "pizza",
    name: "PIZZA",
  },
  {
    id: "pkg-token",
    symbol: "pkg",
    name: "PKG",
  },
  {
    id: "pkt",
    symbol: "pkt",
    name: "PKT",
  },
  {
    id: "placeh",
    symbol: "phl",
    name: "Placeholders",
  },
  {
    id: "place-war",
    symbol: "place",
    name: "PlaceWar Governance",
  },
  {
    id: "plair",
    symbol: "pla",
    name: "Plair",
  },
  {
    id: "planet",
    symbol: "pla",
    name: "PLANET",
  },
  {
    id: "planet-finance",
    symbol: "aqua",
    name: "Planet Finance",
  },
  {
    id: "planet-inu",
    symbol: "planetinu",
    name: "Planet Inu",
  },
  {
    id: "planet-sandbox",
    symbol: "psb",
    name: "Planet Sandbox",
  },
  {
    id: "planetwatch",
    symbol: "planets",
    name: "PlanetWatch",
  },
  {
    id: "plant2earn",
    symbol: "p2e",
    name: "Plant2Earn",
  },
  {
    id: "plant-exodus",
    symbol: "pexo",
    name: "Plant Exodus",
  },
  {
    id: "plant-vs-undead-token",
    symbol: "pvu",
    name: "Plant vs Undead",
  },
  {
    id: "plasma-finance",
    symbol: "ppay",
    name: "Plasma Finance",
  },
  {
    id: "plastiks",
    symbol: "plastik",
    name: "Plastiks",
  },
  {
    id: "plata-network",
    symbol: "plata",
    name: "Plata Network",
  },
  {
    id: "platform-for-underpaid-female-athletes",
    symbol: "pufa",
    name: "Platform for Underpaid Female Athletes",
  },
  {
    id: "platincoin",
    symbol: "plc",
    name: "PlatinCoin",
  },
  {
    id: "platinum-finance",
    symbol: "plat",
    name: "Platinum Finance",
  },
  {
    id: "platinx",
    symbol: "ptx",
    name: "PlatinX",
  },
  {
    id: "plato-farm",
    symbol: "mark",
    name: "Plato Farm",
  },
  {
    id: "plato-game",
    symbol: "plato",
    name: "Plato Game",
  },
  {
    id: "platoncoin",
    symbol: "pltc",
    name: "PlatonCoin",
  },
  {
    id: "platon-network",
    symbol: "lat",
    name: "PlatON Network",
  },
  {
    id: "platypus-finance",
    symbol: "ptp",
    name: "Platypus Finance",
  },
  {
    id: "play2live",
    symbol: "luc",
    name: "Level-Up Coin",
  },
  {
    id: "playa3ull-games",
    symbol: "3ull",
    name: "Playa3ull Games",
  },
  {
    id: "playandlike",
    symbol: "pal",
    name: "PlayAndLike",
  },
  {
    id: "playandlike-old",
    symbol: "pal",
    name: "PlayAndLike [OLD]",
  },
  {
    id: "playcent",
    symbol: "pcnt",
    name: "Playcent",
  },
  {
    id: "playchip",
    symbol: "pla",
    name: "PlayChip",
  },
  {
    id: "playcoin-qrc20",
    symbol: "ply",
    name: "PlayCoin (QRC-20)",
  },
  {
    id: "playdapp",
    symbol: "pla",
    name: "PlayDapp",
  },
  {
    id: "playermon",
    symbol: "pym",
    name: "Playermon",
  },
  {
    id: "playersonly",
    symbol: "po",
    name: "PlayersOnly",
  },
  {
    id: "playervsplayercoin",
    symbol: "pvp",
    name: "PlayerVsPlayerCoin",
  },
  {
    id: "playfuel",
    symbol: "plf",
    name: "PlayFuel",
  },
  {
    id: "playgame",
    symbol: "pxg",
    name: "PlayGame",
  },
  {
    id: "playground",
    symbol: "playa",
    name: "Playground",
  },
  {
    id: "playground-waves-floor-index",
    symbol: "waves",
    name: "Playground Waves Floor Index",
  },
  {
    id: "playgroundz",
    symbol: "iog",
    name: "Playgroundz",
  },
  {
    id: "play-it-forward-dao",
    symbol: "pif",
    name: "Play It Forward DAO",
  },
  {
    id: "playkey",
    symbol: "pkt",
    name: "PlayKey",
  },
  {
    id: "playmarket",
    symbol: "pmt",
    name: "DAO PlayMarket 2.0",
  },
  {
    id: "playnity",
    symbol: "ply",
    name: "PlayNity",
  },
  {
    id: "playpad",
    symbol: "ppad",
    name: "PlayPad",
  },
  {
    id: "playposeidon-nft",
    symbol: "ppp",
    name: "PlayPoseidon NFT",
  },
  {
    id: "play-to-maximize",
    symbol: "pmx",
    name: "Play To Maximize",
  },
  {
    id: "playtreks",
    symbol: "treks",
    name: "PlayTreks",
  },
  {
    id: "playzap",
    symbol: "playzap",
    name: "PlayZap",
  },
  {
    id: "plc-ultima",
    symbol: "plcu",
    name: "PLC Ultima",
  },
  {
    id: "plearn",
    symbol: "pln",
    name: "PLEARN",
  },
  {
    id: "pleasure-coin",
    symbol: "nsfw",
    name: "Pleasure Coin",
  },
  {
    id: "plebe-gaming",
    symbol: "pleb",
    name: "Plebe Gaming",
  },
  {
    id: "pledge",
    symbol: "plgr",
    name: "Pledge",
  },
  {
    id: "pledgecamp",
    symbol: "plg",
    name: "Pledgecamp",
  },
  {
    id: "pledge-finance",
    symbol: "mplgr",
    name: "Pledge Finance",
  },
  {
    id: "plena",
    symbol: "plena",
    name: "Plena",
  },
  {
    id: "plenty-dao",
    symbol: "plenty",
    name: "Plenty DeFi",
  },
  {
    id: "plethori",
    symbol: "ple",
    name: "Plethori",
  },
  {
    id: "plex",
    symbol: "plex",
    name: "PLEX",
  },
  {
    id: "plgnet",
    symbol: "plug",
    name: "PL^Gnet",
  },
  {
    id: "plotx",
    symbol: "plot",
    name: "PlotX",
  },
  {
    id: "plug",
    symbol: "plg",
    name: "Plug",
  },
  {
    id: "plug-chain",
    symbol: "plugcn",
    name: "Plug Chain",
  },
  {
    id: "plugin",
    symbol: "pli",
    name: "Plugin",
  },
  {
    id: "plumcake-finance",
    symbol: "plum",
    name: "PlumCake Finance",
  },
  {
    id: "plunge",
    symbol: "plg",
    name: "Plunge",
  },
  {
    id: "pluracoin",
    symbol: "plura",
    name: "PluraCoin",
  },
  {
    id: "plus-coin",
    symbol: "nplc",
    name: "Plus Coin",
  },
  {
    id: "plusonecoin",
    symbol: "plus1",
    name: "PlusOneCoin",
  },
  {
    id: "pluspad",
    symbol: "plus",
    name: "PlusPad",
  },
  {
    id: "pluton",
    symbol: "plu",
    name: "Pluton",
  },
  {
    id: "pluton-chain",
    symbol: "plc",
    name: "Pluton Chain",
  },
  {
    id: "pluto-network",
    symbol: "ptn",
    name: "Pluto Network",
  },
  {
    id: "plutonian-dao",
    symbol: "pld",
    name: "Plutonian DAO",
  },
  {
    id: "plutonium",
    symbol: "pln",
    name: "Plutonium",
  },
  {
    id: "plutopepe",
    symbol: "pluto",
    name: "PlutoPepe",
  },
  {
    id: "plutos-network",
    symbol: "plut",
    name: "Plutos Network",
  },
  {
    id: "plutusdao",
    symbol: "pls",
    name: "PlutusDAO",
  },
  {
    id: "pmail",
    symbol: "pml",
    name: "Pmail",
  },
  {
    id: "pnetwork",
    symbol: "pnt",
    name: "pNetwork",
  },
  {
    id: "pn-token",
    symbol: "pn",
    name: "PN",
  },
  {
    id: "poa-network",
    symbol: "poa",
    name: "POA Network",
  },
  {
    id: "poc-blockchain",
    symbol: "poc",
    name: "POC Blockchain",
  },
  {
    id: "poc-chain",
    symbol: "pocc",
    name: "POC Chain",
  },
  {
    id: "pochi-inu",
    symbol: "pochi",
    name: "Pochi Inu",
  },
  {
    id: "pocket-arena",
    symbol: "poc",
    name: "Pocket Arena",
  },
  {
    id: "pocketcoin",
    symbol: "pkoin",
    name: "Pocketcoin",
  },
  {
    id: "pocket-doge",
    symbol: "pckt",
    name: "Pocket",
  },
  {
    id: "pocket-network",
    symbol: "pokt",
    name: "Pocket Network",
  },
  {
    id: "pocket-node",
    symbol: "node",
    name: "Pocket Node",
  },
  {
    id: "pocmon-2",
    symbol: "mon",
    name: "PocMon",
  },
  {
    id: "pocoland",
    symbol: "poco",
    name: "Pocoland",
  },
  {
    id: "podo-point",
    symbol: "pod",
    name: "Podo Point",
  },
  {
    id: "poet",
    symbol: "poe",
    name: "Po.et",
  },
  {
    id: "pofi",
    symbol: "pofi",
    name: "PoFi",
  },
  {
    id: "pogcoin",
    symbol: "pog",
    name: "PogCoin",
  },
  {
    id: "pog-coin",
    symbol: "pog",
    name: "PolygonumOnline",
  },
  {
    id: "pointpay",
    symbol: "pxp",
    name: "PointPay",
  },
  {
    id: "pokedx",
    symbol: "pdx",
    name: "PokeDX",
  },
  {
    id: "pokelon",
    symbol: "pokelon",
    name: "POKELON",
  },
  {
    id: "poken",
    symbol: "pkn",
    name: "Poken",
  },
  {
    id: "pokerain",
    symbol: "mmda",
    name: "Pokerain",
  },
  {
    id: "pokerfi",
    symbol: "pokerfi",
    name: "PokerFi",
  },
  {
    id: "pokmonsters",
    symbol: "pok",
    name: "Pokmonsters",
  },
  {
    id: "polar",
    symbol: "polar",
    name: "POLAR",
  },
  {
    id: "polaris",
    symbol: "polar",
    name: "Polarisdefi",
  },
  {
    id: "polarisdao",
    symbol: "aris",
    name: "PolarisDAO",
  },
  {
    id: "polaris-share",
    symbol: "pola",
    name: "Polaris Share",
  },
  {
    id: "polaris-token",
    symbol: "plrs",
    name: "Polaris Token",
  },
  {
    id: "polars",
    symbol: "pol",
    name: "Polars",
  },
  {
    id: "polar-shares",
    symbol: "spolar",
    name: "Polar Shares",
  },
  {
    id: "polar-sync",
    symbol: "polar",
    name: "Polar Sync",
  },
  {
    id: "polar-token",
    symbol: "polar",
    name: "Polaris Finance Polar",
  },
  {
    id: "pole",
    symbol: "pole",
    name: "Pole (North Pole)",
  },
  {
    id: "police-and-thief-game",
    symbol: "loot",
    name: "Police and Thief Game",
  },
  {
    id: "policedoge",
    symbol: "policedoge",
    name: "PoliceDOGE",
  },
  {
    id: "polinate",
    symbol: "poli",
    name: "Polinate",
  },
  {
    id: "polis",
    symbol: "polis",
    name: "Polis",
  },
  {
    id: "polkabridge",
    symbol: "pbr",
    name: "PolkaBridge",
  },
  {
    id: "polkacipher",
    symbol: "cphr",
    name: "PolkaCipher",
  },
  {
    id: "polka-city",
    symbol: "polc",
    name: "Polkacity",
  },
  {
    id: "polka-classic",
    symbol: "dotc",
    name: "Polka Classic",
  },
  {
    id: "polkadex",
    symbol: "pdex",
    name: "Polkadex",
  },
  {
    id: "polkadog-v2-0",
    symbol: "einstein",
    name: "Polkadog V2.0",
  },
  {
    id: "polkadomain",
    symbol: "name",
    name: "PolkaDomain",
  },
  {
    id: "polkadot",
    symbol: "dot",
    name: "Polkadot",
  },
  {
    id: "polkaex",
    symbol: "pkex",
    name: "PolkaEx",
  },
  {
    id: "polkafantasy",
    symbol: "xp",
    name: "PolkaFantasy",
  },
  {
    id: "polkafoundry",
    symbol: "pkf",
    name: "PolkaFoundry",
  },
  {
    id: "polkago",
    symbol: "$plkg",
    name: "Polkago",
  },
  {
    id: "polkainsure-finance",
    symbol: "pis",
    name: "Polkainsure Finance",
  },
  {
    id: "polkally",
    symbol: "kally",
    name: "Kally",
  },
  {
    id: "polkamarkets",
    symbol: "polk",
    name: "Polkamarkets",
  },
  {
    id: "polkamonster",
    symbol: "pkmon",
    name: "PolkaMonster",
  },
  {
    id: "polkaparty",
    symbol: "polp",
    name: "PolkaParty",
  },
  {
    id: "polkapet-world",
    symbol: "pets",
    name: "PolkaPet World",
  },
  {
    id: "polkaplay",
    symbol: "polo",
    name: "NftyPlay",
  },
  {
    id: "polkarare",
    symbol: "prare",
    name: "Polkarare",
  },
  {
    id: "polkasocial-network",
    symbol: "psn",
    name: "Polkasocial Network",
  },
  {
    id: "polkastarter",
    symbol: "pols",
    name: "Polkastarter",
  },
  {
    id: "polkaswap",
    symbol: "pswap",
    name: "Polkaswap",
  },
  {
    id: "polkawar",
    symbol: "pwar",
    name: "PolkaWar",
  },
  {
    id: "polker",
    symbol: "pkr",
    name: "Polker",
  },
  {
    id: "pollchain",
    symbol: "poll",
    name: "Pollchain",
  },
  {
    id: "pollen",
    symbol: "pln",
    name: "Pollen",
  },
  {
    id: "pollen-coin",
    symbol: "pcn",
    name: "Pollen Coin",
  },
  {
    id: "pollux-coin",
    symbol: "pox",
    name: "Pollux Coin",
  },
  {
    id: "polly",
    symbol: "polly",
    name: "Polly Finance",
  },
  {
    id: "polly-defi-nest",
    symbol: "ndefi",
    name: "Polly DeFi Nest",
  },
  {
    id: "polyalpha-finance",
    symbol: "alpha",
    name: "PolyAlpha Finance",
  },
  {
    id: "polybius",
    symbol: "plbt",
    name: "Polybius",
  },
  {
    id: "polycat-finance",
    symbol: "fish",
    name: "Polycat Finance",
  },
  {
    id: "polychain-monsters",
    symbol: "pmon",
    name: "Polychain Monsters",
  },
  {
    id: "polychain-monsters-genesis",
    symbol: "pmlg",
    name: "Polychain Monsters Genesis",
  },
  {
    id: "polycub",
    symbol: "polycub",
    name: "PolyCub",
  },
  {
    id: "polydoge",
    symbol: "polydoge",
    name: "PolyDoge",
  },
  {
    id: "polyfarm-egg",
    symbol: "egg",
    name: "PolyFarm EGG",
  },
  {
    id: "polyfloki",
    symbol: "poki",
    name: "PolyFLOKI",
  },
  {
    id: "polygen",
    symbol: "pgen",
    name: "Polygen",
  },
  {
    id: "polygod",
    symbol: "gull",
    name: "PolyGod",
  },
  {
    id: "polygon-babydoge",
    symbol: "polybabydoge",
    name: "Polygon BabyDoge",
  },
  {
    id: "polygon-ecosystem-index",
    symbol: "peco",
    name: "Amun Polygon Ecosystem Index",
  },
  {
    id: "polygonfarm-finance",
    symbol: "spade",
    name: "PolygonFarm Finance",
  },
  {
    id: "polygon-hbd",
    symbol: "phbd",
    name: "Polygon HBD",
  },
  {
    id: "polygon-hive",
    symbol: "phive",
    name: "Polygon Hive",
  },
  {
    id: "polyient-games-governance-token",
    symbol: "pgt",
    name: "Polyient Games Governance",
  },
  {
    id: "polyient-games-unity",
    symbol: "pgu",
    name: "Polyient Games Unity",
  },
  {
    id: "polylastic",
    symbol: "polx",
    name: "Polylastic",
  },
  {
    id: "polylauncher",
    symbol: "angel",
    name: "Polylauncher",
  },
  {
    id: "polylion",
    symbol: "lion",
    name: "PolyLion",
  },
  {
    id: "polymath",
    symbol: "poly",
    name: "Polymath",
  },
  {
    id: "polymesh",
    symbol: "polyx",
    name: "Polymesh",
  },
  {
    id: "polymoon",
    symbol: "polymoon",
    name: "PolyMoon",
  },
  {
    id: "polypad",
    symbol: "polypad",
    name: "PolyPad",
  },
  {
    id: "poly-peg-mdex",
    symbol: "hmdx",
    name: "Poly-Peg Mdex",
  },
  {
    id: "polypug",
    symbol: "polypug",
    name: "PolyPug",
  },
  {
    id: "polypup",
    symbol: "pup",
    name: "PolyPup",
  },
  {
    id: "polypup-collar-token",
    symbol: "collar",
    name: "PolyPup Collar",
  },
  {
    id: "polyquity",
    symbol: "pyq",
    name: "PolyQuity",
  },
  {
    id: "polyquity-dollar",
    symbol: "pyd",
    name: "PolyQuity Dollar",
  },
  {
    id: "polyroll",
    symbol: "roll",
    name: "Polyroll",
  },
  {
    id: "polysafu",
    symbol: "safu",
    name: "polySAFU",
  },
  {
    id: "polyshark-finance",
    symbol: "shark",
    name: "PolyShark Finance",
  },
  {
    id: "polyshiba",
    symbol: "polyshiba",
    name: "PolyShiba",
  },
  {
    id: "polysports",
    symbol: "ps1",
    name: "POLYSPORTS",
  },
  {
    id: "polystar",
    symbol: "polystar",
    name: "PolyStar",
  },
  {
    id: "polyswarm",
    symbol: "nct",
    name: "PolySwarm",
  },
  {
    id: "polytrade",
    symbol: "trade",
    name: "Polytrade",
  },
  {
    id: "polyvertex",
    symbol: "vert",
    name: "PolyVertex",
  },
  {
    id: "polywave",
    symbol: "wave",
    name: "polyWAVE",
  },
  {
    id: "polywhale",
    symbol: "krill",
    name: "Polywhale",
  },
  {
    id: "polyx",
    symbol: "pxt",
    name: "POLYX",
  },
  {
    id: "polyyeld-token",
    symbol: "yeld",
    name: "PolyYeld",
  },
  {
    id: "polyyield-token",
    symbol: "yield",
    name: "PolyYield",
  },
  {
    id: "polyzap",
    symbol: "pzap",
    name: "PolyZap",
  },
  {
    id: "pomeranian",
    symbol: "pom",
    name: "Pomeranian",
  },
  {
    id: "pomerium",
    symbol: "pmr",
    name: "Pomerium",
  },
  {
    id: "pomerocket",
    symbol: "pome",
    name: "PomeRocket",
  },
  {
    id: "pomi",
    symbol: "pomi",
    name: "Pomi",
  },
  {
    id: "pomo",
    symbol: "pomo",
    name: "Pomo",
  },
  {
    id: "pompom",
    symbol: "pom",
    name: "PomPom",
  },
  {
    id: "pontoon",
    symbol: "toon",
    name: "Pontoon",
  },
  {
    id: "ponyo-inu",
    symbol: "ponyo",
    name: "Ponyo Impact",
  },
  {
    id: "ponzicoin",
    symbol: "ponzi",
    name: "PonziCoin",
  },
  {
    id: "pooch",
    symbol: "pooch",
    name: "Pooch",
  },
  {
    id: "poocoin",
    symbol: "poocoin",
    name: "PooCoin",
  },
  {
    id: "poodle",
    symbol: "poodl",
    name: "Poodl",
  },
  {
    id: "poofcash",
    symbol: "poof",
    name: "PoofCash",
  },
  {
    id: "poolcoin",
    symbol: "pool",
    name: "POOLCOIN",
  },
  {
    id: "poollotto-finance",
    symbol: "plt",
    name: "Poollotto.finance",
  },
  {
    id: "pool-party",
    symbol: "pp",
    name: "Pool Party",
  },
  {
    id: "pooltogether",
    symbol: "pool",
    name: "PoolTogether",
  },
  {
    id: "pool-token",
    symbol: "pool",
    name: "Pool",
  },
  {
    id: "poolz-finance",
    symbol: "poolz",
    name: "Poolz Finance",
  },
  {
    id: "poomoon",
    symbol: "poo",
    name: "POOMOON",
  },
  {
    id: "poopay",
    symbol: "poo",
    name: "PooPay",
  },
  {
    id: "poopsicle",
    symbol: "poop",
    name: "Poopsicle",
  },
  {
    id: "poordoge",
    symbol: "poordoge",
    name: "PoorDoge",
  },
  {
    id: "poor-quack",
    symbol: "poor",
    name: "Poor Quack",
  },
  {
    id: "pop",
    symbol: "pop!",
    name: "POP",
  },
  {
    id: "pop-chest-token",
    symbol: "pop",
    name: "POP Network",
  },
  {
    id: "popcorn",
    symbol: "pop",
    name: "Popcorn",
  },
  {
    id: "popkon",
    symbol: "popk",
    name: "POPKON",
  },
  {
    id: "popop-world",
    symbol: "pop",
    name: "Popop World",
  },
  {
    id: "populous",
    symbol: "ppt",
    name: "Populous",
  },
  {
    id: "populous-xbrl-token",
    symbol: "pxt",
    name: "Populous XBRL",
  },
  {
    id: "poriot",
    symbol: "zk",
    name: "Poriot",
  },
  {
    id: "poriverse",
    symbol: "riken",
    name: "Poriverse",
  },
  {
    id: "porkswap",
    symbol: "pswap",
    name: "PorkSwap",
  },
  {
    id: "pornrocket",
    symbol: "pornrocket",
    name: "PornRocket",
  },
  {
    id: "porta",
    symbol: "kian",
    name: "Porta",
  },
  {
    id: "portal",
    symbol: "portal",
    name: "Portal",
  },
  {
    id: "portals-ivory-index",
    symbol: "ivry",
    name: "Portals Ivory Index",
  },
  {
    id: "porte-token",
    symbol: "porte",
    name: "Porte",
  },
  {
    id: "port-finance",
    symbol: "port",
    name: "Port Finance",
  },
  {
    id: "portify",
    symbol: "pfy",
    name: "Portify",
  },
  {
    id: "portion",
    symbol: "prt",
    name: "Portion",
  },
  {
    id: "portugal-national-team-fan-token",
    symbol: "por",
    name: "Portugal National Team Fan Token",
  },
  {
    id: "portuma",
    symbol: "por",
    name: "Portuma",
  },
  {
    id: "pos-coin",
    symbol: "pos",
    name: "POS Coin",
  },
  {
    id: "poseidon-2",
    symbol: "psdn",
    name: "Poseidon",
  },
  {
    id: "poseidon-finance",
    symbol: "psdn",
    name: "Poseidon Finance",
  },
  {
    id: "poseidon-token",
    symbol: "pos",
    name: "Poseidon POS",
  },
  {
    id: "position-token",
    symbol: "posi",
    name: "Position",
  },
  {
    id: "positron-token",
    symbol: "pot",
    name: "Positron",
  },
  {
    id: "postcoin",
    symbol: "post",
    name: "PostCoin",
  },
  {
    id: "potato",
    symbol: "potato",
    name: "Potato",
  },
  {
    id: "potcoin",
    symbol: "pot",
    name: "Potcoin",
  },
  {
    id: "potent-coin",
    symbol: "ptt",
    name: "Potent Coin",
  },
  {
    id: "potentiam",
    symbol: "ptm",
    name: "Potentiam",
  },
  {
    id: "powerada",
    symbol: "pow",
    name: "PowerADA",
  },
  {
    id: "powerbalt",
    symbol: "pwrb",
    name: "PowerBalt",
  },
  {
    id: "power-cash",
    symbol: "prch",
    name: "Power Cash",
  },
  {
    id: "power-index-pool-token",
    symbol: "pipt",
    name: "Power Index Pool",
  },
  {
    id: "power-ledger",
    symbol: "powr",
    name: "Power Ledger",
  },
  {
    id: "power-nodes",
    symbol: "power",
    name: "Power Nodes",
  },
  {
    id: "powertrade-fuel",
    symbol: "ptf",
    name: "PowerTrade Fuel",
  },
  {
    id: "powerzilla",
    symbol: "powerzilla",
    name: "PowerZilla",
  },
  {
    id: "pqbert",
    symbol: "pqbert",
    name: "pQBERT",
  },
  {
    id: "pragma",
    symbol: "pragma",
    name: "Pragma",
  },
  {
    id: "prcy-coin",
    symbol: "prcy",
    name: "PRivaCY Coin",
  },
  {
    id: "precharge",
    symbol: "pcpi",
    name: "Precharge",
  },
  {
    id: "predictcoin",
    symbol: "pred",
    name: "Predictcoin",
  },
  {
    id: "prediqt",
    symbol: "pqt",
    name: "Prediqt",
  },
  {
    id: "predix-network",
    symbol: "prdx",
    name: "Predix Network",
  },
  {
    id: "prelax",
    symbol: "peax",
    name: "Prelax",
  },
  {
    id: "premia",
    symbol: "premia",
    name: "Premia",
  },
  {
    id: "premio",
    symbol: "premio",
    name: "Premio",
  },
  {
    id: "presaledao",
    symbol: "af-presaledao",
    name: "PresaleDAO",
  },
  {
    id: "presearch",
    symbol: "pre",
    name: "Presearch",
  },
  {
    id: "president-doge",
    symbol: "presidentdoge",
    name: "President Doge",
  },
  {
    id: "primal",
    symbol: "prm",
    name: "Primal",
  },
  {
    id: "primas",
    symbol: "pst",
    name: "Primas",
  },
  {
    id: "primate",
    symbol: "primate",
    name: "Primate",
  },
  {
    id: "prime",
    symbol: "d2d",
    name: "Prime",
  },
  {
    id: "primecoin",
    symbol: "xpm",
    name: "Primecoin",
  },
  {
    id: "prime-dai",
    symbol: "pdai",
    name: "Prime DAI",
  },
  {
    id: "prime-numbers",
    symbol: "prnt",
    name: "Prime Numbers",
  },
  {
    id: "prime-xi",
    symbol: "pxi",
    name: "Prime-XI",
  },
  {
    id: "primo-dao",
    symbol: "primo",
    name: "Primo DAO",
  },
  {
    id: "princess-striker-gem",
    symbol: "prsg",
    name: "Princess Striker Gem",
  },
  {
    id: "prism",
    symbol: "prism",
    name: "Prism",
  },
  {
    id: "prism-cluna",
    symbol: "cluna",
    name: "Prism cLUNA",
  },
  {
    id: "prism-governance-token",
    symbol: "xprism",
    name: "Prism Governance",
  },
  {
    id: "prism-network",
    symbol: "prism",
    name: "Prism Network",
  },
  {
    id: "prism-pluna",
    symbol: "pluna",
    name: "Prism pLUNA",
  },
  {
    id: "prism-protocol",
    symbol: "prism",
    name: "Prism Protocol",
  },
  {
    id: "prism-yluna",
    symbol: "yluna",
    name: "Prism yLUNA",
  },
  {
    id: "privacyswap",
    symbol: "prv",
    name: "PrivacySwap",
  },
  {
    id: "privapp-network",
    symbol: "bpriva",
    name: "Privapp Network",
  },
  {
    id: "privateum",
    symbol: "pvm",
    name: "Privateum",
  },
  {
    id: "privatix",
    symbol: "prix",
    name: "Privatix",
  },
  {
    id: "privcy",
    symbol: "priv",
    name: "PRiVCY",
  },
  {
    id: "privi-pix",
    symbol: "pix",
    name: "Privi Pix",
  },
  {
    id: "privi-trax",
    symbol: "trax",
    name: "Privi Trax",
  },
  {
    id: "prize-coin",
    symbol: "prz",
    name: "Prize Coin",
  },
  {
    id: "prizm",
    symbol: "pzm",
    name: "Prizm",
  },
  {
    id: "prntr",
    symbol: "prntr",
    name: "PRNTR",
  },
  {
    id: "probably-nothing",
    symbol: "prbly",
    name: "Probably Nothing",
  },
  {
    id: "probinex",
    symbol: "pbx",
    name: "Probinex",
  },
  {
    id: "probit-exchange",
    symbol: "prob",
    name: "Probit",
  },
  {
    id: "prodax",
    symbol: "dax",
    name: "Prodax",
  },
  {
    id: "professional-fighters-league-fan-token",
    symbol: "pfl",
    name: "Professional Fighters League Fan Token",
  },
  {
    id: "profit-bank",
    symbol: "pbk",
    name: "Profit Bank",
  },
  {
    id: "projectfeenixv2",
    symbol: "feenixv2",
    name: "ProjectFeenixv2",
  },
  {
    id: "project-galaxy",
    symbol: "gal",
    name: "Project Galaxy",
  },
  {
    id: "project-inverse",
    symbol: "xiv",
    name: "Planet Inverse",
  },
  {
    id: "projectmars",
    symbol: "mars",
    name: "ProjectMars",
  },
  {
    id: "project-oasis",
    symbol: "oasis",
    name: "ProjectOasis",
  },
  {
    id: "project-one-whale",
    symbol: "pow",
    name: "Project: One Whale",
  },
  {
    id: "project-pai",
    symbol: "pai",
    name: "Project Pai",
  },
  {
    id: "project-quantum",
    symbol: "qbit",
    name: "Project Quantum",
  },
  {
    id: "project-with",
    symbol: "wiken",
    name: "Project WITH",
  },
  {
    id: "projectx",
    symbol: "xil",
    name: "ProjectX",
  },
  {
    id: "project-x",
    symbol: "nanox",
    name: "Project-X",
  },
  {
    id: "project-x-nodes",
    symbol: "pxt",
    name: "Project X Finance",
  },
  {
    id: "projekt-gold",
    symbol: "gold",
    name: "Projekt Gold",
  },
  {
    id: "prometeus",
    symbol: "prom",
    name: "Prometeus",
  },
  {
    id: "prometheus",
    symbol: "phi",
    name: "Prometheus",
  },
  {
    id: "prometheus-token",
    symbol: "pro",
    name: "Peak Finance Prometheus",
  },
  {
    id: "promise-token",
    symbol: "promise",
    name: "Promise",
  },
  {
    id: "promodio",
    symbol: "pmd",
    name: "Promodio",
  },
  {
    id: "promo-swipe-coin",
    symbol: "psc",
    name: "Promo Swipe Coin",
  },
  {
    id: "promotionchain",
    symbol: "pc",
    name: "PromotionChain",
  },
  {
    id: "proof-of-liquidity",
    symbol: "pol",
    name: "Proof Of Liquidity",
  },
  {
    id: "propel-token",
    symbol: "pel",
    name: "Propel PEL",
  },
  {
    id: "propersix",
    symbol: "psix",
    name: "ProperSix",
  },
  {
    id: "property-blockchain-trade",
    symbol: "pbt",
    name: "PROPERTY BLOCKCHAIN TRADE",
  },
  {
    id: "props",
    symbol: "props",
    name: "Props",
  },
  {
    id: "propy",
    symbol: "pro",
    name: "Propy",
  },
  {
    id: "proshares-bitcoin-strategy-etf",
    symbol: "bito",
    name: "ProShares Bitcoin Strategy ETF",
  },
  {
    id: "prosper",
    symbol: "pros",
    name: "Prosper",
  },
  {
    id: "prostarter-token",
    symbol: "prot",
    name: "ProStarter",
  },
  {
    id: "proswap",
    symbol: "pros",
    name: "ProSwap",
  },
  {
    id: "protector-roge",
    symbol: "proge",
    name: "Protector Roge",
  },
  {
    id: "proteus-finance",
    symbol: "proteus",
    name: "Proteus Finance",
  },
  {
    id: "protocol-finance",
    symbol: "pfi",
    name: "Protocol Finance",
  },
  {
    id: "protocon",
    symbol: "pen",
    name: "Protocon",
  },
  {
    id: "protofi",
    symbol: "proto",
    name: "Protofi",
  },
  {
    id: "proton",
    symbol: "xpr",
    name: "Proton",
  },
  {
    id: "proton-coin",
    symbol: "pro",
    name: "Proton Coin",
  },
  {
    id: "proton-loan",
    symbol: "loan",
    name: "Proton Loan",
  },
  {
    id: "proton-token",
    symbol: "ptt",
    name: "Proton PTT",
  },
  {
    id: "protoreality-games",
    symbol: "prgc",
    name: "ProtoReality Games",
  },
  {
    id: "proud-money",
    symbol: "proud",
    name: "Proud Money",
  },
  {
    id: "provenance-blockchain",
    symbol: "hash",
    name: "Provenance Blockchain",
  },
  {
    id: "provoco",
    symbol: "voco",
    name: "Provoco",
  },
  {
    id: "proxeus",
    symbol: "xes",
    name: "Proxeus",
  },
  {
    id: "proximax",
    symbol: "xpx",
    name: "ProximaX",
  },
  {
    id: "proxy",
    symbol: "prxy",
    name: "Proxy",
  },
  {
    id: "proxynode",
    symbol: "prx",
    name: "ProxyNode",
  },
  {
    id: "pryz",
    symbol: "pryz",
    name: "Pryz",
  },
  {
    id: "pshare",
    symbol: "pshare",
    name: "pSHARE",
  },
  {
    id: "pspace",
    symbol: "pspace",
    name: "pSPACE",
  },
  {
    id: "pstake-finance",
    symbol: "pstake",
    name: "pSTAKE Finance",
  },
  {
    id: "pstake-staked-atom",
    symbol: "stkatom",
    name: "pSTAKE Staked ATOM",
  },
  {
    id: "pstake-staked-eth",
    symbol: "stketh",
    name: "pSTAKE Staked ETH",
  },
  {
    id: "psule",
    symbol: "sule",
    name: "Sule",
  },
  {
    id: "psyche",
    symbol: "usd1",
    name: "Psyche",
  },
  {
    id: "psycho-doge",
    symbol: "psychodoge",
    name: "Psycho Doge",
  },
  {
    id: "psy-coin",
    symbol: "psy",
    name: "PSY Coin",
  },
  {
    id: "psyoptions",
    symbol: "psy",
    name: "PsyOptions",
  },
  {
    id: "ptokens-btc",
    symbol: "pbtc",
    name: "pTokens BTC [OLD]",
  },
  {
    id: "ptokens-btc-2",
    symbol: "pbtc",
    name: "pTokens BTC",
  },
  {
    id: "ptokens-ore",
    symbol: "ore",
    name: "ORE Network",
  },
  {
    id: "pube-finance",
    symbol: "pube",
    name: "Pube Finance",
  },
  {
    id: "pub-finance",
    symbol: "pint",
    name: "Pub Finance",
  },
  {
    id: "public-index-network",
    symbol: "pin",
    name: "Public Index Network",
  },
  {
    id: "public-mint",
    symbol: "mint",
    name: "Public Mint",
  },
  {
    id: "publish",
    symbol: "news",
    name: "PUBLISH",
  },
  {
    id: "puddingswap",
    symbol: "pud",
    name: "PuddingSwap",
  },
  {
    id: "pudgy-pups-club",
    symbol: "pups",
    name: "Pudgy Pups Club",
  },
  {
    id: "pudgy-vault-nftx",
    symbol: "pudgy",
    name: "PUDGY Vault (NFTX)",
  },
  {
    id: "puff",
    symbol: "puff",
    name: "PUFF",
  },
  {
    id: "puff-santa",
    symbol: "puffsanta",
    name: "Puff Santa",
  },
  {
    id: "puglife",
    symbol: "pugl",
    name: "PugLife",
  },
  {
    id: "puli-inu",
    symbol: "puli",
    name: "Puli",
  },
  {
    id: "pulsechain",
    symbol: "pls",
    name: "Pulsechain",
  },
  {
    id: "pulsedoge",
    symbol: "pulsedoge",
    name: "PulseDoge",
  },
  {
    id: "pulsedogecoin",
    symbol: "plsd",
    name: "PulseDogecoin",
  },
  {
    id: "pulsemoon",
    symbol: "pulsemoon",
    name: "PulseMoon",
  },
  {
    id: "pulsepad",
    symbol: "plspad",
    name: "PulsePad",
  },
  {
    id: "pulse-token",
    symbol: "pulse",
    name: "PulseMarkets",
  },
  {
    id: "pumapay",
    symbol: "pma",
    name: "PumaPay",
  },
  {
    id: "puml-better-health",
    symbol: "puml",
    name: "PUML Better Health",
  },
  {
    id: "pump-coin",
    symbol: "pump",
    name: "Pump Coin",
  },
  {
    id: "pumpkin-inu",
    symbol: "pumpkin",
    name: "Pumpkin Inu",
  },
  {
    id: "pumpkin-punks",
    symbol: "ppunks",
    name: "Pumpkin Punks",
  },
  {
    id: "pumpshibax",
    symbol: "pshibax",
    name: "PumpShibaX",
  },
  {
    id: "pumptopia",
    symbol: "ptpa",
    name: "Pumptopia",
  },
  {
    id: "punch",
    symbol: "punch",
    name: "Punch",
  },
  {
    id: "pundi-x",
    symbol: "npxs",
    name: "Pundi X [OLD]",
  },
  {
    id: "pundi-x-2",
    symbol: "pundix",
    name: "Pundi X",
  },
  {
    id: "pundi-x-nem",
    symbol: "npxsxem",
    name: "Pundi X NEM",
  },
  {
    id: "pundi-x-purse",
    symbol: "purse",
    name: "Pundi X PURSE",
  },
  {
    id: "punk-network",
    symbol: "punk",
    name: "Punk.Network",
  },
  {
    id: "punks-comic",
    symbol: "punks",
    name: "PUNKS Comic",
  },
  {
    id: "punks-comic-pow",
    symbol: "pow",
    name: "Metahero Universe",
  },
  {
    id: "punk-shiba",
    symbol: "punks",
    name: "Punk Shiba",
  },
  {
    id: "punk-vault-nftx",
    symbol: "punk",
    name: "Punk Vault (NFTX)",
  },
  {
    id: "pup-doge",
    symbol: "pupdoge",
    name: "Pup Doge",
  },
  {
    id: "pupper",
    symbol: "pup",
    name: "Pupper",
  },
  {
    id: "puppets-arts",
    symbol: "puppets",
    name: "Puppets Arts",
  },
  {
    id: "puppy-doge",
    symbol: "puppy",
    name: "Puppy Doge",
  },
  {
    id: "puppy-token",
    symbol: "puppy",
    name: "Puppy",
  },
  {
    id: "pups-milk",
    symbol: "milk",
    name: "Pups Milk",
  },
  {
    id: "purefi",
    symbol: "ufi",
    name: "PureFi",
  },
  {
    id: "puregold-token",
    symbol: "pgpay",
    name: "PGPay",
  },
  {
    id: "purfect-network",
    symbol: "pur",
    name: "Purfect Network",
  },
  {
    id: "puriever",
    symbol: "pure",
    name: "Puriever",
  },
  {
    id: "purple-butterfly-trading",
    symbol: "pbtt",
    name: "Purple Butterfly Trading",
  },
  {
    id: "purple-floki-inu",
    symbol: "purplefloki",
    name: "Purple Floki Inu",
  },
  {
    id: "purpose",
    symbol: "prps",
    name: "Purpose",
  },
  {
    id: "purr-vault-nftx",
    symbol: "purr",
    name: "PURR Vault (NFTX)",
  },
  {
    id: "pusd",
    symbol: "pusd",
    name: "PUSD_Polyquity",
  },
  {
    id: "pusd-2",
    symbol: "pusd",
    name: "PUSd",
  },
  {
    id: "pussy-financial",
    symbol: "pussy",
    name: "Pussy Financial",
  },
  {
    id: "putincoin",
    symbol: "put",
    name: "PUTinCoin",
  },
  {
    id: "puzzle-and-dragons-x",
    symbol: "padx",
    name: "Puzzle And Dragons X",
  },
  {
    id: "pw-gold",
    symbol: "pwg",
    name: "PW-GOLD",
  },
  {
    id: "pwrd-stablecoin",
    symbol: "pwrd",
    name: "PWRD Stablecoin",
  },
  {
    id: "pye",
    symbol: "pye",
    name: "PYE",
  },
  {
    id: "pylon-eco-token",
    symbol: "petn",
    name: "Pylon Eco",
  },
  {
    id: "pylon-protocol",
    symbol: "mine",
    name: "Pylon Protocol",
  },
  {
    id: "pyram-token",
    symbol: "pyram",
    name: "Pyram",
  },
  {
    id: "pyrexcoin",
    symbol: "gpyx",
    name: "GoldenPyrex",
  },
  {
    id: "pyrk",
    symbol: "pyrk",
    name: "Pyrk",
  },
  {
    id: "pyromaniac",
    symbol: "pyro",
    name: "Pyroworld",
  },
  {
    id: "pyro-network",
    symbol: "pyro",
    name: "PYRO Network",
  },
  {
    id: "pyrrho-defi",
    symbol: "pyo",
    name: "Pyrrho",
  },
  {
    id: "q8e20-token",
    symbol: "q8e20",
    name: "Q8E20 Token",
  },
  {
    id: "qanplatform",
    symbol: "qanx",
    name: "QANplatform",
  },
  {
    id: "qash",
    symbol: "qash",
    name: "QASH",
  },
  {
    id: "qatar-2022",
    symbol: "fwc",
    name: "Qatar 2022",
  },
  {
    id: "qawalla",
    symbol: "qwla",
    name: "Qawalla",
  },
  {
    id: "qbao",
    symbol: "qbt",
    name: "Qbao",
  },
  {
    id: "qcash",
    symbol: "qc",
    name: "Qcash",
  },
  {
    id: "qchi",
    symbol: "qch",
    name: "QChi",
  },
  {
    id: "qchi-chain",
    symbol: "qhc",
    name: "QChi Chain",
  },
  {
    id: "q-dao-governance-token-v1-0",
    symbol: "qdao",
    name: "Q DAO Governance v1.0",
  },
  {
    id: "qfora",
    symbol: "quroz",
    name: "Qfora",
  },
  {
    id: "qian-second-generation-dollar",
    symbol: "qsd",
    name: "QIAN Second Generation Dollar",
  },
  {
    id: "qi-dao",
    symbol: "qi",
    name: "Qi Dao",
  },
  {
    id: "qiibee",
    symbol: "qbx",
    name: "qiibee",
  },
  {
    id: "qiswap",
    symbol: "qi",
    name: "QiSwap",
  },
  {
    id: "qitchain-network",
    symbol: "qtc",
    name: "Qitcoin",
  },
  {
    id: "qitmeer-network",
    symbol: "meer",
    name: "Qitmeer Network",
  },
  {
    id: "qlink",
    symbol: "qlc",
    name: "QLC Chain",
  },
  {
    id: "qmall",
    symbol: "qmall",
    name: "Qmall",
  },
  {
    id: "qmcoin",
    symbol: "qmc",
    name: "QMCoin",
  },
  {
    id: "qobit",
    symbol: "qob",
    name: "Qobit",
  },
  {
    id: "qoiniq",
    symbol: "qiq",
    name: "QoinIQ",
  },
  {
    id: "qowatt",
    symbol: "qwt",
    name: "QoWatt",
  },
  {
    id: "qqq-token",
    symbol: "qqq",
    name: "Poseidon Network",
  },
  {
    id: "qqq-tokenized-stock-defichain",
    symbol: "dqqq",
    name: "Invesco QQQ Trust Defichain",
  },
  {
    id: "qredit",
    symbol: "xqr",
    name: "Qredit",
  },
  {
    id: "qredo",
    symbol: "qrdo",
    name: "Qredo",
  },
  {
    id: "qrkita-token",
    symbol: "qrt",
    name: "Qrkita",
  },
  {
    id: "qshare",
    symbol: "qshare",
    name: "QShare",
  },
  {
    id: "qtum",
    symbol: "qtum",
    name: "Qtum",
  },
  {
    id: "quadency",
    symbol: "quad",
    name: "Quadency",
  },
  {
    id: "quadrant-protocol",
    symbol: "equad",
    name: "Quadrant Protocol",
  },
  {
    id: "quai-dao",
    symbol: "quai",
    name: "Quai Dao",
  },
  {
    id: "quam-network",
    symbol: "quam",
    name: "Quam Network",
  },
  {
    id: "quannabu",
    symbol: "qbu",
    name: "Quannabu",
  },
  {
    id: "quantfury",
    symbol: "qtf",
    name: "Quantfury",
  },
  {
    id: "quantic",
    symbol: "quantic",
    name: "Quantic",
  },
  {
    id: "quantis",
    symbol: "quan",
    name: "Quantis",
  },
  {
    id: "quantland",
    symbol: "qlt",
    name: "Quantland",
  },
  {
    id: "quant-network",
    symbol: "qnt",
    name: "Quant",
  },
  {
    id: "quantstamp",
    symbol: "qsp",
    name: "Quantstamp",
  },
  {
    id: "quantum-assets",
    symbol: "qa",
    name: "Quantum Assets",
  },
  {
    id: "quantum-resistant-ledger",
    symbol: "qrl",
    name: "Quantum Resistant Ledger",
  },
  {
    id: "quantum-tech",
    symbol: "qua",
    name: "Quantum Tech",
  },
  {
    id: "quarashi",
    symbol: "qua",
    name: "Quarashi",
  },
  {
    id: "quark",
    symbol: "qrk",
    name: "Quark",
  },
  {
    id: "quark-chain",
    symbol: "qkc",
    name: "QuarkChain",
  },
  {
    id: "quartz",
    symbol: "qtz",
    name: "Quartz",
  },
  {
    id: "quartz-defi",
    symbol: "quartz",
    name: "Quartz.defi",
  },
  {
    id: "quartz-defi-ashare",
    symbol: "ashare",
    name: "quartz.defi AShare",
  },
  {
    id: "quasacoin",
    symbol: "qua",
    name: "Quasacoin",
  },
  {
    id: "quasarcoin",
    symbol: "qac",
    name: "Quasarcoin",
  },
  {
    id: "qube-2",
    symbol: "qube",
    name: "Qube",
  },
  {
    id: "qubism",
    symbol: "qub",
    name: "Qubism",
  },
  {
    id: "qubit",
    symbol: "qbt",
    name: "Qubit",
  },
  {
    id: "quebecoin",
    symbol: "qbc",
    name: "Quebecoin",
  },
  {
    id: "queenbee",
    symbol: "qbz",
    name: "QUEENBEE",
  },
  {
    id: "quick",
    symbol: "quick",
    name: "Quickswap [OLD]",
  },
  {
    id: "quickchart",
    symbol: "quickchart",
    name: "QuickChart",
  },
  {
    id: "quick-mining",
    symbol: "qm",
    name: "Quick Mining",
  },
  {
    id: "quickswap",
    symbol: "quick",
    name: "Quickswap",
  },
  {
    id: "quickx-protocol",
    symbol: "qcx",
    name: "QuickX Protocol",
  },
  {
    id: "quidax",
    symbol: "qdx",
    name: "Quidax",
  },
  {
    id: "quidd",
    symbol: "quidd",
    name: "Quidd",
  },
  {
    id: "quid-ika",
    symbol: "quid",
    name: "Quid Ika",
  },
  {
    id: "quid-token",
    symbol: "quid",
    name: "Quid",
  },
  {
    id: "quik",
    symbol: "quik",
    name: "Quik",
  },
  {
    id: "quinads",
    symbol: "quin",
    name: "QUINADS",
  },
  {
    id: "quincoin",
    symbol: "qin",
    name: "QUINCOIN",
  },
  {
    id: "quint",
    symbol: "quint",
    name: "Quint",
  },
  {
    id: "quiverx",
    symbol: "qrx",
    name: "QuiverX",
  },
  {
    id: "quix-defi-index",
    symbol: "qdi",
    name: "Quix Defi Index",
  },
  {
    id: "quizdrop",
    symbol: "qdrop",
    name: "QuizDrop",
  },
  {
    id: "quiztok",
    symbol: "qtcon",
    name: "Quiztok",
  },
  {
    id: "quorum",
    symbol: "rum",
    name: "Quorum",
  },
  {
    id: "quota",
    symbol: "qta",
    name: "QUOTA",
  },
  {
    id: "quoth",
    symbol: "quoth",
    name: "Quoth",
  },
  {
    id: "quotient",
    symbol: "xqn",
    name: "Quotient",
  },
  {
    id: "quras-token",
    symbol: "xqc",
    name: "Quras",
  },
  {
    id: "qwertycoin",
    symbol: "qwc",
    name: "Qwertycoin",
  },
  {
    id: "r34p",
    symbol: "r34p",
    name: "R34P",
  },
  {
    id: "rabbit-finance",
    symbol: "rabbit",
    name: "Rabbit Finance",
  },
  {
    id: "rabet",
    symbol: "rbt",
    name: "Rabet",
  },
  {
    id: "rac",
    symbol: "rac",
    name: "RAC",
  },
  {
    id: "race",
    symbol: "race",
    name: "Race",
  },
  {
    id: "racefi",
    symbol: "racefi",
    name: "RaceFi",
  },
  {
    id: "racex",
    symbol: "racex",
    name: "RaceX",
  },
  {
    id: "racing-club-fan-token",
    symbol: "racing",
    name: "Racing Club Fan Token",
  },
  {
    id: "racoon",
    symbol: "rac",
    name: "Racøøn",
  },
  {
    id: "rad",
    symbol: "rad",
    name: "RAD",
  },
  {
    id: "radar",
    symbol: "radar",
    name: "Radar",
  },
  {
    id: "radi",
    symbol: "radi",
    name: "RADI",
  },
  {
    id: "radial-finance",
    symbol: "rdl",
    name: "Radial Finance",
  },
  {
    id: "radicle",
    symbol: "rad",
    name: "Radicle",
  },
  {
    id: "radio-caca",
    symbol: "raca",
    name: "Radio Caca",
  },
  {
    id: "radio-hero",
    symbol: "raho",
    name: "Radio Hero",
  },
  {
    id: "radioshack",
    symbol: "radio",
    name: "RadioShack",
  },
  {
    id: "radium",
    symbol: "val",
    name: "Validity",
  },
  {
    id: "radix",
    symbol: "xrd",
    name: "Radix",
  },
  {
    id: "radom",
    symbol: "dom",
    name: "Radom",
  },
  {
    id: "rae-token",
    symbol: "rae",
    name: "Receive Access Ecosystem",
  },
  {
    id: "rage-fan",
    symbol: "rage",
    name: "Rage.Fan",
  },
  {
    id: "ragnarokdao",
    symbol: "rgk",
    name: "RagnarokDAO",
  },
  {
    id: "rai",
    symbol: "rai",
    name: "Rai Reflex Index",
  },
  {
    id: "raicoin",
    symbol: "rai",
    name: "Raicoin",
  },
  {
    id: "raiden-network",
    symbol: "rdn",
    name: "Raiden Network",
  },
  {
    id: "raider-aurum",
    symbol: "aurum",
    name: "Raider Aurum",
  },
  {
    id: "raid-token",
    symbol: "raid",
    name: "Raid",
  },
  {
    id: "rai-finance",
    symbol: "sofi",
    name: "RAI Finance",
  },
  {
    id: "railgun",
    symbol: "rail",
    name: "Railgun",
  },
  {
    id: "railnode",
    symbol: "train",
    name: "RailNode",
  },
  {
    id: "rail-polygon",
    symbol: "railpoly",
    name: "Rail Polygon",
  },
  {
    id: "rainbowtoken",
    symbol: "rainbowtoken",
    name: "RainbowToken",
  },
  {
    id: "rainbow-token",
    symbol: "rnbw",
    name: "HaloDAO",
  },
  {
    id: "rainbow-token-2",
    symbol: "rbw",
    name: "Crypto Unicorns Rainbow",
  },
  {
    id: "rainicorn",
    symbol: "raini",
    name: "Rainicorn",
  },
  {
    id: "rainmaker-games",
    symbol: "rain",
    name: "Rainmaker Games",
  },
  {
    id: "rain-network",
    symbol: "rain",
    name: "RAIN Network",
  },
  {
    id: "raised-in-oblivion-x",
    symbol: "riox",
    name: "Raised in Oblivion X",
  },
  {
    id: "rai-token",
    symbol: "rai",
    name: "Rai",
  },
  {
    id: "rake-finance",
    symbol: "rak",
    name: "Rake Finance",
  },
  {
    id: "rakon",
    symbol: "rkn",
    name: "RAKON",
  },
  {
    id: "raku-coin",
    symbol: "rakuc",
    name: "Raku Coin",
  },
  {
    id: "rally-2",
    symbol: "rly",
    name: "Rally",
  },
  {
    id: "rally-solana",
    symbol: "srly",
    name: "Rally (Solana)",
  },
  {
    id: "ramenswap",
    symbol: "ramen",
    name: "RamenSwap",
  },
  {
    id: "ramifi",
    symbol: "ram",
    name: "Ramifi Protocol",
  },
  {
    id: "rammus",
    symbol: "rammus",
    name: "Rammus",
  },
  {
    id: "ramp",
    symbol: "ramp",
    name: "RAMP",
  },
  {
    id: "rams",
    symbol: "prams",
    name: "Rams - Super Bowl",
  },
  {
    id: "random",
    symbol: "rndm",
    name: "Random",
  },
  {
    id: "rangers-fan-token",
    symbol: "rft",
    name: "Rangers Fan Token",
  },
  {
    id: "rangers-protocol-gas",
    symbol: "rpg",
    name: "Rangers Protocol",
  },
  {
    id: "rango-exchange",
    symbol: "rango",
    name: "Rango Exchange",
  },
  {
    id: "rankerdao",
    symbol: "ranker",
    name: "RankerDao",
  },
  {
    id: "rank-token",
    symbol: "rank",
    name: "Rank Token",
  },
  {
    id: "ran-online-crypto-world",
    symbol: "rcw",
    name: "Ran Online Crypto World",
  },
  {
    id: "ran-x-crypto",
    symbol: "rxc",
    name: "Ran x Crypto",
  },
  {
    id: "rapids",
    symbol: "rpd",
    name: "Rapids",
  },
  {
    id: "rapidz",
    symbol: "rpzx",
    name: "Rapidz",
  },
  {
    id: "raptoreum",
    symbol: "rtm",
    name: "Raptoreum",
  },
  {
    id: "raptor-finance",
    symbol: "raptr",
    name: "Raptor Finance [OLD]",
  },
  {
    id: "raptor-finance-2",
    symbol: "rptr",
    name: "Raptor Finance",
  },
  {
    id: "rare",
    symbol: "rare",
    name: "Rare",
  },
  {
    id: "rare-ball-shares",
    symbol: "rbs",
    name: "Rare Ball Shares",
  },
  {
    id: "rarest",
    symbol: "rarest",
    name: "RAREST",
  },
  {
    id: "rarible",
    symbol: "rari",
    name: "Rarible",
  },
  {
    id: "rari-governance-token",
    symbol: "rgt",
    name: "Rari Governance",
  },
  {
    id: "rari-governance-token-wormhole",
    symbol: "rgt",
    name: "Rari Governance Token (Wormhole)",
  },
  {
    id: "rari-token",
    symbol: "rari",
    name: "Rari",
  },
  {
    id: "rasko",
    symbol: "rasko",
    name: "rASKO",
  },
  {
    id: "rasta-finance",
    symbol: "rasta",
    name: "Rasta Finance",
  },
  {
    id: "ratalert-fastfood",
    symbol: "ffood",
    name: "RatAlert FastFood",
  },
  {
    id: "rate3",
    symbol: "rte",
    name: "Rate3",
  },
  {
    id: "ratecoin",
    symbol: "xra",
    name: "Ratecoin",
  },
  {
    id: "ratio-finance",
    symbol: "ratio",
    name: "Ratio Protocol",
  },
  {
    id: "ratoken",
    symbol: "ratoken",
    name: "Ratoken",
  },
  {
    id: "ratrace",
    symbol: "ratrace",
    name: "RatRace",
  },
  {
    id: "ratscoin",
    symbol: "rats",
    name: "Ratscoin",
  },
  {
    id: "ravelin-finance",
    symbol: "rav",
    name: "Ravelin Finance",
  },
  {
    id: "ravencoin",
    symbol: "rvn",
    name: "Ravencoin",
  },
  {
    id: "ravencoin-classic",
    symbol: "rvc",
    name: "Ravencoin Classic",
  },
  {
    id: "raven-dark",
    symbol: "xrd",
    name: "Raven Dark",
  },
  {
    id: "ravendex",
    symbol: "rave",
    name: "Ravendex",
  },
  {
    id: "raven-protocol",
    symbol: "raven",
    name: "Raven Protocol",
  },
  {
    id: "raydium",
    symbol: "ray",
    name: "Raydium",
  },
  {
    id: "raydium-wormhole",
    symbol: "ray",
    name: "Raydium (Wormhole)",
  },
  {
    id: "raze-network",
    symbol: "raze",
    name: "Raze Network",
  },
  {
    id: "razor-network",
    symbol: "razor",
    name: "Razor Network",
  },
  {
    id: "rbch",
    symbol: "rbch",
    name: "rBCH",
  },
  {
    id: "rbxsamurai",
    symbol: "rbxs",
    name: "RBXSamurai",
  },
  {
    id: "rbx-token",
    symbol: "rbx",
    name: "RBX",
  },
  {
    id: "rccc",
    symbol: "rccc",
    name: "RCCC",
  },
  {
    id: "rchain",
    symbol: "rev",
    name: "RChain",
  },
  {
    id: "rdctoken",
    symbol: "rdct",
    name: "RDCT",
  },
  {
    id: "reactor-2",
    symbol: "rct",
    name: "Reactor",
  },
  {
    id: "realbox",
    symbol: "reb",
    name: "Realbox",
  },
  {
    id: "realfevr",
    symbol: "fevr",
    name: "RealFevr",
  },
  {
    id: "realfinance-network",
    symbol: "refi",
    name: "Realfinance Network",
  },
  {
    id: "realio-network",
    symbol: "rio",
    name: "Realio Network",
  },
  {
    id: "realital-metaverse",
    symbol: "reta",
    name: "Realital Metaverse",
  },
  {
    id: "reallink",
    symbol: "real",
    name: "RealLink",
  },
  {
    id: "realliq",
    symbol: "rlq",
    name: "Realliq",
  },
  {
    id: "realm",
    symbol: "realm",
    name: "Realm",
  },
  {
    id: "realms-of-ethernity",
    symbol: "reth",
    name: "Realms of Ethernity",
  },
  {
    id: "real-realm",
    symbol: "real",
    name: "Real Realm",
  },
  {
    id: "realtoken-s-13895-saratoga-st-detroit-mi",
    symbol: "realt-s-13895-saratoga-st-detroit-mi",
    name: "RealT - 13895 Saratoga St, Detroit, MI 48205",
  },
  {
    id: "realtract",
    symbol: "ret",
    name: "RealTract",
  },
  {
    id: "realy-metaverse",
    symbol: "real",
    name: "Realy Metaverse",
  },
  {
    id: "reapchain",
    symbol: "reap",
    name: "ReapChain",
  },
  {
    id: "reaper-token",
    symbol: "reaper",
    name: "Reaper",
  },
  {
    id: "rebase-aggregator-capital",
    symbol: "$react",
    name: "Rebase Aggregator Capital",
  },
  {
    id: "rebaseapy",
    symbol: "rebaseapy",
    name: "RebaseAPY",
  },
  {
    id: "rebasing-liquidity",
    symbol: "delta rlp",
    name: "Rebasing Liquidity",
  },
  {
    id: "rebel-bots",
    symbol: "rbls",
    name: "Rebel Bots",
  },
  {
    id: "rebellion-dao",
    symbol: "reb",
    name: "Rebellion DAO",
  },
  {
    id: "rebellion-protocol",
    symbol: "rebl",
    name: "Rebellion Protocol",
  },
  {
    id: "rebeltradertoken",
    symbol: "rtt",
    name: "RebelTrader",
  },
  {
    id: "rebit",
    symbol: "keyt",
    name: "Rebit",
  },
  {
    id: "recast1",
    symbol: "r1",
    name: "Recast1",
  },
  {
    id: "recharge",
    symbol: "rcg",
    name: "Recharge",
  },
  {
    id: "recharge-finance",
    symbol: "r3fi",
    name: "Recharge Finance",
  },
  {
    id: "recklessape",
    symbol: "reap",
    name: "RecklessApe",
  },
  {
    id: "recovery-right-token",
    symbol: "rrt",
    name: "Recovery Right",
  },
  {
    id: "rec-token",
    symbol: "rec",
    name: "Rec",
  },
  {
    id: "red",
    symbol: "red",
    name: "Red",
  },
  {
    id: "redbux",
    symbol: "redbux",
    name: "RedBUX",
  },
  {
    id: "redchillies",
    symbol: "redc",
    name: "RedChillies",
  },
  {
    id: "reddcoin",
    symbol: "rdd",
    name: "Reddcoin",
  },
  {
    id: "redfeg",
    symbol: "redfeg",
    name: "RedFeg",
  },
  {
    id: "redfireants",
    symbol: "rants",
    name: "redFireAnts",
  },
  {
    id: "red-floki",
    symbol: "redfloki",
    name: "Red Floki",
  },
  {
    id: "redfox-labs-2",
    symbol: "rfox",
    name: "RFOX",
  },
  {
    id: "redi",
    symbol: "redi",
    name: "REDi",
  },
  {
    id: "red-kishu",
    symbol: "redkishu",
    name: "Red Kishu",
  },
  {
    id: "redlight-node-district",
    symbol: "playmates",
    name: "Redlight Node District",
  },
  {
    id: "redmars",
    symbol: "rmars",
    name: "REDMARS",
  },
  {
    id: "redpanda-earth",
    symbol: "redpanda",
    name: "RedPanda Earth",
  },
  {
    id: "red-pill",
    symbol: "rpp",
    name: "Red Pill",
  },
  {
    id: "red-pulse",
    symbol: "phb",
    name: "Phoenix Global [OLD]",
  },
  {
    id: "red-shiba-token",
    symbol: "rst",
    name: "Red Shiba",
  },
  {
    id: "redzilla",
    symbol: "redzilla",
    name: "RedZilla",
  },
  {
    id: "reecoin",
    symbol: "ree",
    name: "ReeCoin",
  },
  {
    id: "reefer-token",
    symbol: "reefer",
    name: "Reefer",
  },
  {
    id: "reef-finance",
    symbol: "reef",
    name: "Reef Finance",
  },
  {
    id: "reesykle",
    symbol: "sycle",
    name: "Reesykle",
  },
  {
    id: "refereum",
    symbol: "rfr",
    name: "Refereum",
  },
  {
    id: "ref-finance",
    symbol: "ref",
    name: "Ref Finance",
  },
  {
    id: "refi",
    symbol: "refi",
    name: "Reimagined Finance",
  },
  {
    id: "refinable",
    symbol: "fine",
    name: "Refinable",
  },
  {
    id: "reflect-finance",
    symbol: "rfi",
    name: "reflect.finance",
  },
  {
    id: "reflecto",
    symbol: "reflecto",
    name: "Reflecto",
  },
  {
    id: "reflex",
    symbol: "rfx",
    name: "Reflex",
  },
  {
    id: "reflexer-ungovernance-token",
    symbol: "flx",
    name: "Reflexer Ungovernance",
  },
  {
    id: "reflex-finance-v2",
    symbol: "reflex",
    name: "Reflex Finance V2",
  },
  {
    id: "reforestation-mahogany",
    symbol: "rmog",
    name: "Reforestation Mahogany",
  },
  {
    id: "refork",
    symbol: "efk",
    name: "ReFork",
  },
  {
    id: "refugees-token",
    symbol: "$rfg",
    name: "Refugees",
  },
  {
    id: "regen",
    symbol: "regen",
    name: "Regen",
  },
  {
    id: "regiment-finance",
    symbol: "rtf",
    name: "Regiment Finance",
  },
  {
    id: "regularpresale",
    symbol: "regu",
    name: "RegularPresale",
  },
  {
    id: "rei-network",
    symbol: "rei",
    name: "REI Network",
  },
  {
    id: "relay-token",
    symbol: "relay",
    name: "Relay Chain",
  },
  {
    id: "relbit",
    symbol: "rlb",
    name: "Relbit",
  },
  {
    id: "release-ico-project",
    symbol: "rel",
    name: "RELEASE",
  },
  {
    id: "relevant",
    symbol: "rel",
    name: "Relevant",
  },
  {
    id: "relite-finance",
    symbol: "reli",
    name: "Relite Finance",
  },
  {
    id: "reltime",
    symbol: "rtc",
    name: "Reltime",
  },
  {
    id: "rematicegc",
    symbol: "rmtx",
    name: "RematicEGC",
  },
  {
    id: "remex",
    symbol: "rmx",
    name: "RemeX",
  },
  {
    id: "remita-coin",
    symbol: "remit",
    name: "Remita Coin",
  },
  {
    id: "remme",
    symbol: "rem",
    name: "Remme",
  },
  {
    id: "remnant-labs",
    symbol: "remn",
    name: "Remnant Labs",
  },
  {
    id: "rena-finance",
    symbol: "rena",
    name: "RENA Finance",
  },
  {
    id: "renbtc",
    symbol: "renbtc",
    name: "renBTC",
  },
  {
    id: "render-token",
    symbol: "rndr",
    name: "Render",
  },
  {
    id: "rendoge",
    symbol: "rendoge",
    name: "renDOGE",
  },
  {
    id: "renewableelectronicenergycoin",
    symbol: "reec",
    name: "Renewable Electronic Energy Coin",
  },
  {
    id: "renewable-energy",
    symbol: "ret",
    name: "Renewable Energy",
  },
  {
    id: "renfil",
    symbol: "renfil",
    name: "renFIL",
  },
  {
    id: "renrenbit",
    symbol: "rrb",
    name: "Renrenbit",
  },
  {
    id: "rens",
    symbol: "rens",
    name: "Rens",
  },
  {
    id: "rentberry",
    symbol: "berry",
    name: "Rentberry",
  },
  {
    id: "rentible",
    symbol: "rnb",
    name: "Rentible",
  },
  {
    id: "renzec",
    symbol: "renzec",
    name: "renZEC",
  },
  {
    id: "repo",
    symbol: "repo",
    name: "Repo Coin",
  },
  {
    id: "represent",
    symbol: "rpt",
    name: "Represent",
  },
  {
    id: "reptilian",
    symbol: "rptc",
    name: "Reptilian",
  },
  {
    id: "republic-credits",
    symbol: "rpc",
    name: "Republic Credits",
  },
  {
    id: "republic-of-dogs",
    symbol: "rod",
    name: "Republic of Dogs",
  },
  {
    id: "republic-protocol",
    symbol: "ren",
    name: "REN",
  },
  {
    id: "request-network",
    symbol: "req",
    name: "Request",
  },
  {
    id: "reserve",
    symbol: "rsv",
    name: "Reserve",
  },
  {
    id: "reserve-rights-token",
    symbol: "rsr",
    name: "Reserve Rights",
  },
  {
    id: "reserve-rights-wormhole",
    symbol: "rsr",
    name: "Reserve Rights (Wormhole)",
  },
  {
    id: "resfinex-token",
    symbol: "res",
    name: "Resfinex Token",
  },
  {
    id: "resource-protocol",
    symbol: "source",
    name: "ReSource Protocol",
  },
  {
    id: "restore-truth-token",
    symbol: "rtt",
    name: "Restore Truth",
  },
  {
    id: "reth",
    symbol: "reth",
    name: "rETH",
  },
  {
    id: "reth2",
    symbol: "reth2",
    name: "rETH2",
  },
  {
    id: "retire-token",
    symbol: "retire",
    name: "Retire",
  },
  {
    id: "retro-defi",
    symbol: "rcube",
    name: "Retro DEFI",
  },
  {
    id: "retromoon",
    symbol: "retro",
    name: "Retromoon",
  },
  {
    id: "reucoin",
    symbol: "reu",
    name: "REUCOIN [OLD]",
  },
  {
    id: "reucoin-2",
    symbol: "reu",
    name: "Reu",
  },
  {
    id: "revain",
    symbol: "rev",
    name: "Revain",
  },
  {
    id: "revault-network",
    symbol: "reva",
    name: "Revault Network",
  },
  {
    id: "revenue-coin",
    symbol: "rvc",
    name: "Revenue Coin",
  },
  {
    id: "reverse",
    symbol: "rvrs",
    name: "Reverse",
  },
  {
    id: "reverse-protocol",
    symbol: "rvrs",
    name: "Reverse Protocol",
  },
  {
    id: "revest-finance",
    symbol: "rvst",
    name: "Revest Finance",
  },
  {
    id: "review-capital",
    symbol: "recap",
    name: "Review Capital",
  },
  {
    id: "revival",
    symbol: "rvl",
    name: "REVIVAL",
  },
  {
    id: "revive",
    symbol: "rve",
    name: "Revive",
  },
  {
    id: "revoland",
    symbol: "revo",
    name: "Revoland",
  },
  {
    id: "revolotto",
    symbol: "rvl",
    name: "Revolotto",
  },
  {
    id: "revolt",
    symbol: "revt",
    name: "Revolt",
  },
  {
    id: "revolution",
    symbol: "rev",
    name: "Revolution",
  },
  {
    id: "revolutiongames",
    symbol: "rvlng",
    name: "RevolutionGames",
  },
  {
    id: "revolution-populi",
    symbol: "rvp",
    name: "Revolution Populi",
  },
  {
    id: "revoluzion",
    symbol: "rvz",
    name: "Revoluzion",
  },
  {
    id: "revolve-games",
    symbol: "rpg",
    name: "Revolve Games",
  },
  {
    id: "revomon",
    symbol: "revo",
    name: "Revomon",
  },
  {
    id: "revonetwork",
    symbol: "revo",
    name: "RevoNetwork",
  },
  {
    id: "revuto",
    symbol: "revu",
    name: "Revuto",
  },
  {
    id: "revv",
    symbol: "revv",
    name: "REVV",
  },
  {
    id: "reward-cycle",
    symbol: "rc",
    name: "Reward Cycle",
  },
  {
    id: "reward-cycle-2",
    symbol: "rc2",
    name: "Reward Cycle 2",
  },
  {
    id: "rewardeum",
    symbol: "reum",
    name: "Rewardeum",
  },
  {
    id: "reward-hunters-token",
    symbol: "rht",
    name: "Reward Hunters",
  },
  {
    id: "rewardiqa",
    symbol: "rew",
    name: "Rewardiqa",
  },
  {
    id: "rewards",
    symbol: "rwd",
    name: "Rewards",
  },
  {
    id: "rewards-bunny",
    symbol: "rbunny",
    name: "Rewards Bunny",
  },
  {
    id: "rewardscoin",
    symbol: "rwsc",
    name: "RewardsCoin",
  },
  {
    id: "rewards-token",
    symbol: "rewards",
    name: "Rewards Token",
  },
  {
    id: "rewardsx",
    symbol: "rex",
    name: "RewardsX",
  },
  {
    id: "rex",
    symbol: "rex",
    name: "Imbrex",
  },
  {
    id: "rfust",
    symbol: "rfust",
    name: "rfUST",
  },
  {
    id: "rhea-dao",
    symbol: "🏔",
    name: "Rhea DAO",
  },
  {
    id: "rhegic2",
    symbol: "rhegic2",
    name: "rHEGIC2",
  },
  {
    id: "rhinos-finance",
    symbol: "rho",
    name: "Rhinos Finance",
  },
  {
    id: "rhinos-game",
    symbol: "rhinos",
    name: "rhinos.game",
  },
  {
    id: "rhobusd",
    symbol: "rhobusd",
    name: "rhoBUSD [OLD]",
  },
  {
    id: "rhobusd-2",
    symbol: "rhobusd",
    name: "rhoBUSD",
  },
  {
    id: "rho-token",
    symbol: "rho",
    name: "Rho",
  },
  {
    id: "rhousdc",
    symbol: "rhousdc",
    name: "rhoUSDC",
  },
  {
    id: "rhousdt",
    symbol: "rhousdt",
    name: "rhoUSDT [OLD]",
  },
  {
    id: "rhousdt-2",
    symbol: "rhousdt",
    name: "rhoUSDT",
  },
  {
    id: "rhythm",
    symbol: "rhythm",
    name: "Rhythm",
  },
  {
    id: "ribbit",
    symbol: "ribt",
    name: "Ribbit",
  },
  {
    id: "ribbon-finance",
    symbol: "rbn",
    name: "Ribbon Finance",
  },
  {
    id: "rice",
    symbol: "rice",
    name: "Rice",
  },
  {
    id: "riceswap",
    symbol: "rice",
    name: "RiceSwap",
  },
  {
    id: "rice-wallet",
    symbol: "rice",
    name: "Rice Wallet",
  },
  {
    id: "rich",
    symbol: "rch",
    name: "Rich",
  },
  {
    id: "richcity",
    symbol: "rich",
    name: "RichCity",
  },
  {
    id: "richcity-cash",
    symbol: "cash",
    name: "Gangster Legends Cash",
  },
  {
    id: "rich-dao",
    symbol: "rich",
    name: "Rich DAO",
  },
  {
    id: "richie",
    symbol: "rich",
    name: "Richie 2.0",
  },
  {
    id: "richierich-coin",
    symbol: "rich",
    name: "RichieRich Coin",
  },
  {
    id: "rich-maker",
    symbol: "rich",
    name: "Rich Maker",
  },
  {
    id: "richochet",
    symbol: "ric",
    name: "Ricochet",
  },
  {
    id: "richquack",
    symbol: "quack",
    name: "Rich Quack",
  },
  {
    id: "richway-finance",
    symbol: "rich",
    name: "Richway.Finance",
  },
  {
    id: "rickmortydoxx",
    symbol: "rickmortydoxx",
    name: "RickMortyDoxx",
  },
  {
    id: "ricnatum",
    symbol: "rcnt",
    name: "Ricnatum",
  },
  {
    id: "ride_finance",
    symbol: "rides",
    name: "Rides Finance",
  },
  {
    id: "ride-my-car",
    symbol: "ride",
    name: "Ride My Car",
  },
  {
    id: "ride-to-earn",
    symbol: "rd2e",
    name: "Ride To Earn",
  },
  {
    id: "ridge",
    symbol: "ridge",
    name: "Ridge",
  },
  {
    id: "ridotto",
    symbol: "rdt",
    name: "Ridotto",
  },
  {
    id: "riecoin",
    symbol: "ric",
    name: "Riecoin",
  },
  {
    id: "rifi-united",
    symbol: "ru",
    name: "RIFI United",
  },
  {
    id: "rif-token",
    symbol: "rif",
    name: "RSK Infrastructure Framework",
  },
  {
    id: "rigel-finance",
    symbol: "rigel",
    name: "Rigel Finance",
  },
  {
    id: "rigel-protocol",
    symbol: "rgp",
    name: "Rigel Protocol",
  },
  {
    id: "rigoblock",
    symbol: "grg",
    name: "RigoBlock",
  },
  {
    id: "rijent-coin",
    symbol: "rtc",
    name: "Rijent Coin",
  },
  {
    id: "rikkei-finance",
    symbol: "rifi",
    name: "Rikkei Finance",
  },
  {
    id: "rilcoin",
    symbol: "ril",
    name: "Rilcoin",
  },
  {
    id: "rin-finance-coin",
    symbol: "rifico",
    name: "Rin Finance Coin",
  },
  {
    id: "ring",
    symbol: "ring",
    name: "Ring",
  },
  {
    id: "ring-financial",
    symbol: "ring",
    name: "RING Financial",
  },
  {
    id: "ring-x-platform",
    symbol: "ringx",
    name: "RING X PLATFORM",
  },
  {
    id: "rio-defi",
    symbol: "rfuel",
    name: "RioDeFi",
  },
  {
    id: "riot-racers",
    symbol: "riot",
    name: "Riot Racers",
  },
  {
    id: "ripae",
    symbol: "pae",
    name: "Ripae",
  },
  {
    id: "ripae-pbnb",
    symbol: "pbnb",
    name: "Ripae pBNB",
  },
  {
    id: "ripio-coin",
    symbol: "rpc",
    name: "Ripio Coin",
  },
  {
    id: "ripio-credit-network",
    symbol: "rcn",
    name: "Ripio Credit Network",
  },
  {
    id: "ripple",
    symbol: "xrp",
    name: "XRP",
  },
  {
    id: "ripple-alpha",
    symbol: "xla",
    name: "Ripple Alpha",
  },
  {
    id: "rise",
    symbol: "rise",
    name: "Rise",
  },
  {
    id: "rise2protocol",
    symbol: "ripr",
    name: "RISE2PROTOCOL",
  },
  {
    id: "risecity",
    symbol: "rsc",
    name: "RiseCity",
  },
  {
    id: "risehero",
    symbol: "rise",
    name: "RiseHero",
  },
  {
    id: "rise-of-defenders",
    symbol: "rdr",
    name: "Rise of Defenders",
  },
  {
    id: "rise-of-nebula",
    symbol: "ron",
    name: "Rise Of Nebula",
  },
  {
    id: "riseupv2",
    symbol: "riv2",
    name: "RiseUpV2",
  },
  {
    id: "risingsun",
    symbol: "rsun",
    name: "RisingSun",
  },
  {
    id: "riskmoon",
    symbol: "riskmoon",
    name: "Riskmoon",
  },
  {
    id: "ritestream",
    symbol: "rite",
    name: "ritestream",
  },
  {
    id: "rito",
    symbol: "rito",
    name: "Rito",
  },
  {
    id: "ri-token",
    symbol: "ri",
    name: "Xiotri RI",
  },
  {
    id: "riverboat",
    symbol: "rib",
    name: "RiverBoat",
  },
  {
    id: "rivetz",
    symbol: "rvt",
    name: "Rivetz",
  },
  {
    id: "rivex-erc20",
    symbol: "rvx",
    name: "Rivex",
  },
  {
    id: "rivrdoge",
    symbol: "rivrdoge",
    name: "RivrDoge",
  },
  {
    id: "rivrfloki",
    symbol: "rivrfloki",
    name: "RivrFloki",
  },
  {
    id: "rizen-coin",
    symbol: "rzn",
    name: "Rizen Coin (Old)",
  },
  {
    id: "rizen-coin-2",
    symbol: "rzn",
    name: "Rizen Coin",
  },
  {
    id: "rizespor-token",
    symbol: "rize",
    name: "Rizespor Token",
  },
  {
    id: "rizon",
    symbol: "atolo",
    name: "RIZON",
  },
  {
    id: "rloop",
    symbol: "rloop",
    name: "rLoop",
  },
  {
    id: "rmrk",
    symbol: "rmrk",
    name: "RMRK",
  },
  {
    id: "rna-cash",
    symbol: "rna",
    name: "RNA Cash",
  },
  {
    id: "rna-share",
    symbol: "rshare",
    name: "RNA Share",
  },
  {
    id: "road",
    symbol: "road",
    name: "ROAD",
  },
  {
    id: "roaring-twenties",
    symbol: "roar",
    name: "Roaring Twenties",
  },
  {
    id: "roar-token",
    symbol: "roar",
    name: "SOL Tigers Roar",
  },
  {
    id: "roarts",
    symbol: "roar",
    name: "RoArts",
  },
  {
    id: "robbocoach",
    symbol: "rbc",
    name: "RobboCoach",
  },
  {
    id: "robet-coin",
    symbol: "robet",
    name: "RoBet Coin",
  },
  {
    id: "robinhoodswap",
    symbol: "rbh",
    name: "RobinHoodSwap",
  },
  {
    id: "robiniaswap-token",
    symbol: "rbs",
    name: "RobiniaSwap",
  },
  {
    id: "robinos",
    symbol: "rbn",
    name: "Robinos",
  },
  {
    id: "robocalls",
    symbol: "rc20",
    name: "RoboCalls",
  },
  {
    id: "robodoge-coin",
    symbol: "robodoge",
    name: "RoboDoge Coin",
  },
  {
    id: "robofi-token",
    symbol: "vics",
    name: "RoboFi",
  },
  {
    id: "robohero",
    symbol: "robo",
    name: "RoboHero",
  },
  {
    id: "robo-inu-finance",
    symbol: "rbif",
    name: "Robo Inu Finance",
  },
  {
    id: "robonomics-network",
    symbol: "xrt",
    name: "Robonomics Network",
  },
  {
    id: "robonomics-web-services",
    symbol: "rws",
    name: "Robonomics Web Services",
  },
  {
    id: "roboots",
    symbol: "rbo",
    name: "Roboots",
  },
  {
    id: "roboshib",
    symbol: "roboshib",
    name: "RoboShib",
  },
  {
    id: "robo-step",
    symbol: "rost",
    name: "Robo Step",
  },
  {
    id: "robot",
    symbol: "robot",
    name: "Robot",
  },
  {
    id: "robotina",
    symbol: "rox",
    name: "Robotina",
  },
  {
    id: "robo-token",
    symbol: "robo",
    name: "Robo",
  },
  {
    id: "robot-shib",
    symbol: "rshib",
    name: "ROBOT SHIB",
  },
  {
    id: "robot-warriors",
    symbol: "metabot",
    name: "Robot Warriors",
  },
  {
    id: "robust-token",
    symbol: "rbt",
    name: "Robust",
  },
  {
    id: "rocket",
    symbol: "rokt",
    name: "Rocket",
  },
  {
    id: "rocket-bunny",
    symbol: "bunny",
    name: "Rocket Bunny",
  },
  {
    id: "rocketbusd",
    symbol: "rocketbusd",
    name: "RocketBUSD",
  },
  {
    id: "rocketcoin-2",
    symbol: "rocket",
    name: "RocketCoin",
  },
  {
    id: "rocketdoge",
    symbol: "rd",
    name: "RocketDoge",
  },
  {
    id: "rocket-finance",
    symbol: "rocket",
    name: "Rocket Finance",
  },
  {
    id: "rocket-fund",
    symbol: "rkt",
    name: "Rocket Fund",
  },
  {
    id: "rocket-global-coin",
    symbol: "rckc",
    name: "Rocket Global Coin",
  },
  {
    id: "rocket-pool",
    symbol: "rpl",
    name: "Rocket Pool",
  },
  {
    id: "rocket-pool-eth",
    symbol: "reth",
    name: "Rocket Pool ETH",
  },
  {
    id: "rocket-pool-wormhole",
    symbol: "rpl",
    name: "Rocket Pool (Wormhole)",
  },
  {
    id: "rocket-raccoon",
    symbol: "roc",
    name: "Rocket Raccoon",
  },
  {
    id: "rocket-share",
    symbol: "srocket",
    name: "Rocket Share",
  },
  {
    id: "rockettoken",
    symbol: "rktn",
    name: "RocketToken [OLD]",
  },
  {
    id: "rockettoken-2",
    symbol: "rktn",
    name: "RocketToken",
  },
  {
    id: "rocket-vault-rocketx",
    symbol: "rvf",
    name: "RocketX exchange",
  },
  {
    id: "rocket-zilla",
    symbol: "roz",
    name: "Rocket Zilla",
  },
  {
    id: "rocki",
    symbol: "rocki",
    name: "Rocki",
  },
  {
    id: "rock-n-rain-coin",
    symbol: "rnrc",
    name: "Rock N Rain Coin",
  },
  {
    id: "rocks-idle-game",
    symbol: "rocks",
    name: "Rocks Idle Game",
  },
  {
    id: "rockstar-doge",
    symbol: "rockstar",
    name: "Rockstar Doge",
  },
  {
    id: "rocky-inu",
    symbol: "rocky",
    name: "Rocky Inu",
  },
  {
    id: "roco-finance",
    symbol: "roco",
    name: "Roco Finance",
  },
  {
    id: "rogan",
    symbol: "rogan",
    name: "Rogan",
  },
  {
    id: "roge",
    symbol: "roge",
    name: "Rogue Doge",
  },
  {
    id: "rogue-coin",
    symbol: "rogue",
    name: "Rogue Coin",
  },
  {
    id: "roi",
    symbol: "roi",
    name: "5ROI",
  },
  {
    id: "roiyal-coin",
    symbol: "roco",
    name: "ROIyal Coin",
  },
  {
    id: "rokkit-fuel",
    symbol: "$rokk",
    name: "Rokkit Fuel",
  },
  {
    id: "rollbit-coin",
    symbol: "rlb",
    name: "Rollbit Coin",
  },
  {
    id: "rollium",
    symbol: "rlm",
    name: "MarbleVerse",
  },
  {
    id: "rome",
    symbol: "rome",
    name: "Rome",
  },
  {
    id: "romeo-doge",
    symbol: "romeodoge",
    name: "Romeo Doge",
  },
  {
    id: "ronin",
    symbol: "ron",
    name: "Ronin",
  },
  {
    id: "ronin-gamez",
    symbol: "roningmz",
    name: "Ronin Gamez",
  },
  {
    id: "ronpaulcoin",
    symbol: "rpc",
    name: "RonPaulCoin",
  },
  {
    id: "roobee",
    symbol: "roobee",
    name: "Roobee",
  },
  {
    id: "rook",
    symbol: "rook",
    name: "Rook",
  },
  {
    id: "rooster-battle",
    symbol: "rice",
    name: "Rooster Battle",
  },
  {
    id: "rootkit",
    symbol: "root",
    name: "Rootkit",
  },
  {
    id: "rootstock",
    symbol: "rbtc",
    name: "Rootstock RSK",
  },
  {
    id: "rope",
    symbol: "$rope",
    name: "Rope",
  },
  {
    id: "rope-token",
    symbol: "rope",
    name: "Rope Token",
  },
  {
    id: "ror-universe",
    symbol: "ror",
    name: "ROR Universe",
  },
  {
    id: "rose",
    symbol: "rose",
    name: "Rose",
  },
  {
    id: "roseon-finance",
    symbol: "rosn",
    name: "Roseon Finance",
  },
  {
    id: "rose-wormhole",
    symbol: "rose",
    name: "ROSE (Wormhole)",
  },
  {
    id: "ro-slayers",
    symbol: "slyr",
    name: "RO Slayers",
  },
  {
    id: "rotharium",
    symbol: "rth",
    name: "Rotharium",
  },
  {
    id: "rotten",
    symbol: "rot",
    name: "Rotten",
  },
  {
    id: "rottweiler-inu",
    symbol: "rottt",
    name: "Rottweiler Inu",
  },
  {
    id: "rougecoin",
    symbol: "xrge",
    name: "RougeCoin",
  },
  {
    id: "round-dollar",
    symbol: "rd",
    name: "Round Dollar",
  },
  {
    id: "roundrobin-protocol-token",
    symbol: "rrt",
    name: "RoundRobin Protocol",
  },
  {
    id: "roush-fenway-racing-fan-token",
    symbol: "roush",
    name: "Roush Fenway Racing Fan Token",
  },
  {
    id: "route",
    symbol: "route",
    name: "Router Protocol",
  },
  {
    id: "rover-inu",
    symbol: "rover",
    name: "Rover Inu",
  },
  {
    id: "rowan-coin",
    symbol: "rwn",
    name: "Rowan Coin",
  },
  {
    id: "roxe",
    symbol: "roc",
    name: "Roxe",
  },
  {
    id: "royalada",
    symbol: "royalada",
    name: "RoyalADA",
  },
  {
    id: "royal-bnb",
    symbol: "rb",
    name: "Royal BNB",
  },
  {
    id: "royal-doge",
    symbol: "rdoge",
    name: "Royal Doge",
  },
  {
    id: "royale",
    symbol: "roya",
    name: "Royale",
  },
  {
    id: "royal-gold",
    symbol: "rgold",
    name: "Royal Gold",
  },
  {
    id: "royal-protocol",
    symbol: "roy",
    name: "Royal Protocol",
  },
  {
    id: "rps-league",
    symbol: "rps",
    name: "Rps League",
  },
  {
    id: "rss3",
    symbol: "rss3",
    name: "RSS3",
  },
  {
    id: "rubic",
    symbol: "rbc",
    name: "Rubic",
  },
  {
    id: "rubix",
    symbol: "rbt",
    name: "Rubix",
  },
  {
    id: "ruby-currency",
    symbol: "rbc",
    name: "Ruby Currency",
  },
  {
    id: "ruby-play-network",
    symbol: "ruby",
    name: "Ruby Play Network",
  },
  {
    id: "ruff",
    symbol: "ruff",
    name: "Ruff",
  },
  {
    id: "rug-busters",
    symbol: "rugbust",
    name: "Rug Busters",
  },
  {
    id: "r-u-generous",
    symbol: "rug",
    name: "R U Generous",
  },
  {
    id: "rugpull-prevention",
    symbol: "rugpull",
    name: "Rugpull Prevention",
  },
  {
    id: "rugzombie",
    symbol: "zmbe",
    name: "RugZombie",
  },
  {
    id: "ruler-protocol",
    symbol: "ruler",
    name: "Ruler Protocol",
  },
  {
    id: "ruletka",
    symbol: "rtk",
    name: "Ruletka",
  },
  {
    id: "rumble-gaming",
    symbol: "rmbl",
    name: "Rumble Gaming",
  },
  {
    id: "rumito",
    symbol: "rutc",
    name: "Rumito",
  },
  {
    id: "run",
    symbol: "run",
    name: "Run",
  },
  {
    id: "rune",
    symbol: "rune",
    name: "Rune",
  },
  {
    id: "rune-shards",
    symbol: "rxs",
    name: "Rune Shards",
  },
  {
    id: "runner-land",
    symbol: "rlt",
    name: "Runner Land",
  },
  {
    id: "run-together",
    symbol: "run",
    name: "Run Together",
  },
  {
    id: "rupaya",
    symbol: "rupx",
    name: "Rupaya",
  },
  {
    id: "rupee",
    symbol: "rup",
    name: "Rupee",
  },
  {
    id: "rupiah-token",
    symbol: "idrt",
    name: "Rupiah",
  },
  {
    id: "rusd",
    symbol: "rusd",
    name: "rUSD",
  },
  {
    id: "rush",
    symbol: "ruc",
    name: "Rush",
  },
  {
    id: "rushcoin",
    symbol: "rush",
    name: "RushCoin",
  },
  {
    id: "rush-technology",
    symbol: "rush",
    name: "Rush Technology",
  },
  {
    id: "russell-coin",
    symbol: "rc",
    name: "RussellCoin",
  },
  {
    id: "rutheneum",
    symbol: "rth",
    name: "Rutheneum",
  },
  {
    id: "ruufcoin",
    symbol: "ruuf",
    name: "RuufCoin",
  },
  {
    id: "ruyi",
    symbol: "ruyi",
    name: "Ruyi",
  },
  {
    id: "rxcdnatoken",
    symbol: "dna",
    name: "RxcDna",
  },
  {
    id: "rxcgames",
    symbol: "rxcg",
    name: "RXCGames",
  },
  {
    id: "rxseed-coin",
    symbol: "wsow",
    name: "RxSeed Coin",
  },
  {
    id: "ryi-unity",
    symbol: "ryiu",
    name: "RYI Unity",
  },
  {
    id: "ryo",
    symbol: "ryo",
    name: "Ryo Currency",
  },
  {
    id: "ryoshis-vision",
    symbol: "ryoshi",
    name: "Ryoshis Vision",
  },
  {
    id: "ryoshi-token",
    symbol: "ryoshi",
    name: "Ryoshi",
  },
  {
    id: "s4fe",
    symbol: "s4f",
    name: "S4FE",
  },
  {
    id: "saave",
    symbol: "saave",
    name: "sAAVE",
  },
  {
    id: "sabac-warrior",
    symbol: "sw",
    name: "Sabac Warrior",
  },
  {
    id: "sabaka-inu",
    symbol: "sabaka inu",
    name: "Sabaka Inu",
  },
  {
    id: "saber",
    symbol: "sbr",
    name: "Saber",
  },
  {
    id: "saber-wormhole",
    symbol: "sbr",
    name: "Saber (Wormhole)",
  },
  {
    id: "saber-wrapped-usd-coin",
    symbol: "susdc-9",
    name: "Saber Wrapped USD Coin",
  },
  {
    id: "sacks",
    symbol: "sacks",
    name: "Sacks",
  },
  {
    id: "sacred-tails",
    symbol: "st",
    name: "Sacred Tails",
  },
  {
    id: "sada",
    symbol: "sada",
    name: "sADA",
  },
  {
    id: "sadbaby",
    symbol: "sdby",
    name: "Sadbaby [OLD]",
  },
  {
    id: "sadbaby-2",
    symbol: "sdby",
    name: "Sadbaby",
  },
  {
    id: "safcoin",
    symbol: "saf",
    name: "SafCoin",
  },
  {
    id: "safeaffinity",
    symbol: "affinity",
    name: "Affinity",
  },
  {
    id: "safeape",
    symbol: "usda",
    name: "SafeApe",
  },
  {
    id: "safe-baby-shiba",
    symbol: "sbsh",
    name: "Safe Baby Shiba",
  },
  {
    id: "safebank",
    symbol: "safebank",
    name: "SafeBank",
  },
  {
    id: "safebank-token",
    symbol: "sbank",
    name: "SafeBank BSC",
  },
  {
    id: "safebitcoin",
    symbol: "safebtc",
    name: "SafeBitcoin",
  },
  {
    id: "safeblast",
    symbol: "blast",
    name: "SafeBlast",
  },
  {
    id: "safebull",
    symbol: "safebull",
    name: "SafeBull",
  },
  {
    id: "safebuy",
    symbol: "sbf",
    name: "SAfebuy",
  },
  {
    id: "safecapital",
    symbol: "scap",
    name: "SafeCapital",
  },
  {
    id: "safecap-token",
    symbol: "sfc",
    name: "SafeCap",
  },
  {
    id: "safechaintoken",
    symbol: "sct",
    name: "Safechain",
  },
  {
    id: "safe-coin",
    symbol: "safe",
    name: "Safe",
  },
  {
    id: "safe-coin-2",
    symbol: "safe",
    name: "SafeCoin",
  },
  {
    id: "safecookie",
    symbol: "safecookie",
    name: "SafeCookie",
  },
  {
    id: "safecrypto",
    symbol: "sco",
    name: "SafeCrypto",
  },
  {
    id: "safe-deal",
    symbol: "sfd",
    name: "SafeDeal",
  },
  {
    id: "safedoge",
    symbol: "safedoge",
    name: "SafeDoge",
  },
  {
    id: "safedogecoin",
    symbol: "safedoge",
    name: "SafeDogecoin",
  },
  {
    id: "safedogecoin-v2",
    symbol: "safedoge",
    name: "SafeDogeCoin V2",
  },
  {
    id: "safedog-protocol",
    symbol: "safedog",
    name: "Safedog Protocol",
  },
  {
    id: "safedollar",
    symbol: "sdo",
    name: "SafeDollar",
  },
  {
    id: "safe-drive",
    symbol: "drive",
    name: "Safe Drive",
  },
  {
    id: "safe-earn",
    symbol: "safearn",
    name: "Safe Earn",
  },
  {
    id: "safeearth",
    symbol: "safeearth",
    name: "SafeEarth",
  },
  {
    id: "safe-energy",
    symbol: "energyx",
    name: "Safe Energy",
  },
  {
    id: "safegem",
    symbol: "gems",
    name: "SafeGem",
  },
  {
    id: "safehamsters",
    symbol: "safehamsters",
    name: "SafeHamsters",
  },
  {
    id: "safe-haven",
    symbol: "sha",
    name: "Safe Haven",
  },
  {
    id: "safehold",
    symbol: "safehold",
    name: "SafeHold",
  },
  {
    id: "safeinsure",
    symbol: "sins",
    name: "SafeInsure",
  },
  {
    id: "safelaunch",
    symbol: "sfex",
    name: "SafeLaunch",
  },
  {
    id: "safelcarus",
    symbol: "safeicarus",
    name: "SafeIcarus",
  },
  {
    id: "safelight",
    symbol: "safelight",
    name: "SafeLight",
  },
  {
    id: "safemars",
    symbol: "safemars",
    name: "Safemars",
  },
  {
    id: "safemars-protocol",
    symbol: "smars",
    name: "Safemars Protocol",
  },
  {
    id: "safememe",
    symbol: "sme",
    name: "SafeMeme",
  },
  {
    id: "safemoney",
    symbol: "safemoney",
    name: "SafeMoney",
  },
  {
    id: "safemoneybsc",
    symbol: "safemoney",
    name: "SafeMoneyBSC",
  },
  {
    id: "safemoon",
    symbol: "safemoon",
    name: "SafeMoon [OLD]",
  },
  {
    id: "safemoon-2",
    symbol: "sfm",
    name: "SafeMoon",
  },
  {
    id: "safemoonavax",
    symbol: "safemoona",
    name: "SafemoonAvax",
  },
  {
    id: "safemooncash",
    symbol: "safemooncash",
    name: "SafeMoonCash",
  },
  {
    id: "safemoon-inu",
    symbol: "smi",
    name: "SafeMoon Inu",
  },
  {
    id: "safemoon-swap",
    symbol: "sfms",
    name: "SafeMoon Swap",
  },
  {
    id: "safemoon-zilla",
    symbol: "sfz",
    name: "Safemoon Zilla",
  },
  {
    id: "safemusk",
    symbol: "safemusk",
    name: "SafeMusk",
  },
  {
    id: "safenami",
    symbol: "safenami",
    name: "SafeNami",
  },
  {
    id: "safe-nebula",
    symbol: "snb",
    name: "Safe Nebula",
  },
  {
    id: "safenotmoon",
    symbol: "$snm",
    name: "SafeNotMoon",
  },
  {
    id: "safepal",
    symbol: "sfp",
    name: "SafePal",
  },
  {
    id: "safepe",
    symbol: "loox",
    name: "SafePe",
  },
  {
    id: "safeplus",
    symbol: "$splusv2",
    name: "SafePlus V2",
  },
  {
    id: "safepluto",
    symbol: "safepluto",
    name: "SafePluto",
  },
  {
    id: "safermoon",
    symbol: "safermoon",
    name: "SAFERMOON",
  },
  {
    id: "safe-seafood-coin",
    symbol: "ssf",
    name: "Safe SeaFood Coin",
  },
  {
    id: "safeshiba",
    symbol: "safeshib",
    name: "SafeShiba [OLD]",
  },
  {
    id: "safeshiba-2",
    symbol: "safeshib",
    name: "SafeShiba",
  },
  {
    id: "safe-shield",
    symbol: "sfshld",
    name: "Safe Shield",
  },
  {
    id: "safespace",
    symbol: "safespace",
    name: "SafeSpace",
  },
  {
    id: "safestar",
    symbol: "safestar",
    name: "Safestar",
  },
  {
    id: "safesun",
    symbol: "safesun",
    name: "SafeSun",
  },
  {
    id: "safeswap-online",
    symbol: "swap",
    name: "SafeSwap Online",
  },
  {
    id: "safeswap-token",
    symbol: "ssgtx",
    name: "Safeswap SSGTX",
  },
  {
    id: "safetesla",
    symbol: "safetesla",
    name: "SafeTesla",
  },
  {
    id: "safe-token",
    symbol: "safe",
    name: "Safe Token",
  },
  {
    id: "safetrees",
    symbol: "trees",
    name: "Safetrees",
  },
  {
    id: "safe-trip-finance",
    symbol: "stf",
    name: "Safe Trip Finance",
  },
  {
    id: "safety",
    symbol: "sft",
    name: "Safety",
  },
  {
    id: "safewages",
    symbol: "safew",
    name: "SafeWages",
  },
  {
    id: "safewhale",
    symbol: "swhal",
    name: "SafeWhale",
  },
  {
    id: "safewolf",
    symbol: "sw",
    name: "SafeWolf",
  },
  {
    id: "safexi",
    symbol: "sxi",
    name: "SafeXI",
  },
  {
    id: "safezone",
    symbol: "safezone",
    name: "SafeZone",
  },
  {
    id: "saffron-finance",
    symbol: "sfi",
    name: "saffron.finance",
  },
  {
    id: "safle",
    symbol: "safle",
    name: "Safle",
  },
  {
    id: "safufide",
    symbol: "safest",
    name: "SafuFide",
  },
  {
    id: "safutitano",
    symbol: "safti",
    name: "SafuTitano",
  },
  {
    id: "safuu",
    symbol: "safuu",
    name: "SAFUU",
  },
  {
    id: "safuyield-protocol",
    symbol: "safuyield",
    name: "SafuYield Protocol",
  },
  {
    id: "saga-2",
    symbol: "saga",
    name: "Saga",
  },
  {
    id: "sagaworld",
    symbol: "sagaw",
    name: "SagaWorld",
  },
  {
    id: "sai",
    symbol: "sai",
    name: "Sai",
  },
  {
    id: "sail",
    symbol: "sail",
    name: "SAIL",
  },
  {
    id: "saint-inu",
    symbol: "saint",
    name: "Saint Inu",
  },
  {
    id: "saint-token",
    symbol: "saint",
    name: "Saint",
  },
  {
    id: "saitama-inu",
    symbol: "saitama",
    name: "Saitama Inu",
  },
  {
    id: "saitama-samurai",
    symbol: "saitamurai",
    name: "Saitama Samurai",
  },
  {
    id: "saitamax",
    symbol: "saitax",
    name: "SaitamaX",
  },
  {
    id: "saitanobi",
    symbol: "saitanobi",
    name: "Saitanobi",
  },
  {
    id: "saito",
    symbol: "saito",
    name: "Saito",
  },
  {
    id: "saitoki-inu",
    symbol: "saitoki",
    name: "Saitoki Inu",
  },
  {
    id: "saiyan-inu",
    symbol: "sayan",
    name: "Saiyan Inu",
  },
  {
    id: "saja",
    symbol: "sja",
    name: "Saja",
  },
  {
    id: "sak3",
    symbol: "sak3",
    name: "SAKE",
  },
  {
    id: "sakaryaspor",
    symbol: "skry",
    name: "Sakaryaspor",
  },
  {
    id: "sake-token",
    symbol: "sake",
    name: "SakeSwap",
  },
  {
    id: "sakhalin-husky",
    symbol: "sahu",
    name: "Sakhalin Husky",
  },
  {
    id: "sakura",
    symbol: "sku",
    name: "Sakura",
  },
  {
    id: "sakura-bloom",
    symbol: "skb",
    name: "Sakura Bloom",
  },
  {
    id: "sakura-inu",
    symbol: "sakura",
    name: "Sakura Inu",
  },
  {
    id: "sakura-neko",
    symbol: "neko",
    name: "Sakura Neko",
  },
  {
    id: "salary",
    symbol: "slr",
    name: "Salary",
  },
  {
    id: "salary-mining",
    symbol: "slrm",
    name: "Salary Mining",
  },
  {
    id: "salmon",
    symbol: "slm",
    name: "Salmon",
  },
  {
    id: "salmonation",
    symbol: "sui",
    name: "Salmonation",
  },
  {
    id: "salt",
    symbol: "salt",
    name: "SALT",
  },
  {
    id: "salus",
    symbol: "sls",
    name: "SaluS",
  },
  {
    id: "samecoin",
    symbol: "same",
    name: "Samecoin",
  },
  {
    id: "samo-inu",
    symbol: "sinu",
    name: "Samo INU",
  },
  {
    id: "samoyedcoin",
    symbol: "samo",
    name: "Samoyedcoin",
  },
  {
    id: "samsunspor-fan-token",
    symbol: "sam",
    name: "Samsunspor Fan Token",
  },
  {
    id: "samurai-legends",
    symbol: "smg",
    name: "Samurai Legends",
  },
  {
    id: "samusky-token",
    symbol: "samu",
    name: "Samusky",
  },
  {
    id: "sandclock",
    symbol: "quartz",
    name: "Sandclock",
  },
  {
    id: "sandego",
    symbol: "sdgo",
    name: "SanDeGo",
  },
  {
    id: "san-diego-coin",
    symbol: "sand",
    name: "San Diego Coin",
  },
  {
    id: "sandwich-network",
    symbol: "$sandwich",
    name: "Sandwich Network",
  },
  {
    id: "sangkara",
    symbol: "misa",
    name: "Sangkara",
  },
  {
    id: "sanin-inu",
    symbol: "sani",
    name: "Sanin Inu",
  },
  {
    id: "sanliurfaspor-token",
    symbol: "urfa",
    name: "Sanliurfaspor Token",
  },
  {
    id: "sanshu-inu",
    symbol: "sanshu",
    name: "Sanshu Inu",
  },
  {
    id: "sans-token",
    symbol: "sans",
    name: "Sans",
  },
  {
    id: "santaclaus",
    symbol: "santa",
    name: "Santaclaus",
  },
  {
    id: "santa-coin-2",
    symbol: "santa",
    name: "Santa Coin",
  },
  {
    id: "santa-dash",
    symbol: "santadash",
    name: "Santa Dash",
  },
  {
    id: "santadoge",
    symbol: "santa",
    name: "SantaDoge",
  },
  {
    id: "santa-floki-v2",
    symbol: "hohoho",
    name: "Santa Floki v2.0",
  },
  {
    id: "santa-inu",
    symbol: "saninu",
    name: "Santa Inu",
  },
  {
    id: "santas-war-nft-epic",
    symbol: "santawar",
    name: "Santas War NFT Epic",
  },
  {
    id: "santiment-network-token",
    symbol: "san",
    name: "Santiment Network",
  },
  {
    id: "santos-fc-fan-token",
    symbol: "santos",
    name: "Santos FC Fan Token",
  },
  {
    id: "santrast",
    symbol: "snrw",
    name: "Santrast",
  },
  {
    id: "sao-paulo-fc-fan-token",
    symbol: "spfc",
    name: "Sao Paulo FC Fan Token",
  },
  {
    id: "sapchain",
    symbol: "sap",
    name: "Sapchain",
  },
  {
    id: "sapien",
    symbol: "spn",
    name: "Sapien",
  },
  {
    id: "sappchat",
    symbol: "app",
    name: "SappChat",
  },
  {
    id: "sapphire",
    symbol: "sapp",
    name: "Sapphire",
  },
  {
    id: "sarcophagus",
    symbol: "sarco",
    name: "Sarcophagus",
  },
  {
    id: "sashimi",
    symbol: "sashimi",
    name: "Sashimi",
  },
  {
    id: "satcoin",
    symbol: "sat",
    name: "Satcoin",
  },
  {
    id: "satisfinance",
    symbol: "sat",
    name: "SatisFinance",
  },
  {
    id: "satoexchange-token",
    symbol: "satx",
    name: "SatoExchange",
  },
  {
    id: "satopay",
    symbol: "stop",
    name: "SatoPay",
  },
  {
    id: "satopay-yield-token",
    symbol: "spy",
    name: "Satopay Yield",
  },
  {
    id: "sator",
    symbol: "sao",
    name: "Sator",
  },
  {
    id: "satoshicity",
    symbol: "city",
    name: "SatoshiCity",
  },
  {
    id: "satoshi-monsters",
    symbol: "ssm",
    name: "Satoshi Monsters",
  },
  {
    id: "satoshistreetbets",
    symbol: "ssb",
    name: "SatoshiStreetBets",
  },
  {
    id: "satoshiswap",
    symbol: "swap",
    name: "SatoshiSwap",
  },
  {
    id: "satozhi",
    symbol: "satoz",
    name: "Satozhi",
  },
  {
    id: "satt",
    symbol: "satt",
    name: "SaTT",
  },
  {
    id: "saturna",
    symbol: "sat",
    name: "Saturna",
  },
  {
    id: "saud",
    symbol: "saud",
    name: "sAUD",
  },
  {
    id: "saunafinance-token",
    symbol: "sauna",
    name: "SaunaFinance",
  },
  {
    id: "sav3",
    symbol: "sav3",
    name: "SAV3",
  },
  {
    id: "savage",
    symbol: "savg",
    name: "SAVAGE",
  },
  {
    id: "savanna",
    symbol: "svn",
    name: "Savanna",
  },
  {
    id: "saveanimal",
    symbol: "saveanimal",
    name: "SaveAnimal",
  },
  {
    id: "save-baby-doge",
    symbol: "babydoge",
    name: "Save Baby Doge",
  },
  {
    id: "savebee-farm-honeycomb",
    symbol: "hc",
    name: "SAVEBEE FARM HONEYCOMB",
  },
  {
    id: "savebritney",
    symbol: "sbrt",
    name: "SaveBritney",
  },
  {
    id: "saveplanetearth",
    symbol: "spe",
    name: "SavePlanetEarth",
  },
  {
    id: "save-ralph",
    symbol: "ralph",
    name: "Save Ralph",
  },
  {
    id: "savetheworld",
    symbol: "save",
    name: "SaveTheWorld",
  },
  {
    id: "save-token-us",
    symbol: "save",
    name: "SaveToken",
  },
  {
    id: "savix",
    symbol: "svx",
    name: "Savix",
  },
  {
    id: "sax-token",
    symbol: "sax",
    name: "IdleStoneage SAX",
  },
  {
    id: "saylor-moon",
    symbol: "smoon",
    name: "SaylorMoon",
  },
  {
    id: "sbank",
    symbol: "sts",
    name: "SBank",
  },
  {
    id: "sbet",
    symbol: "sbet",
    name: "SBET",
  },
  {
    id: "sbf-coin",
    symbol: "sbfc",
    name: "SBF Coin",
  },
  {
    id: "sbland-vault-nftx",
    symbol: "sbland",
    name: "SBLAND Vault (NFTX)",
  },
  {
    id: "sbtc",
    symbol: "sbtc",
    name: "sBTC",
  },
  {
    id: "scalara-nft-index",
    symbol: "nfti",
    name: "Scalara NFT Index",
  },
  {
    id: "scaleswap-token",
    symbol: "sca",
    name: "Scaleswap",
  },
  {
    id: "scallop",
    symbol: "sclp",
    name: "Scallop",
  },
  {
    id: "scan-defi",
    symbol: "scan",
    name: "Scan DeFi",
  },
  {
    id: "scanetchain",
    symbol: "swc",
    name: "Scanetchain",
  },
  {
    id: "scar",
    symbol: "scar",
    name: "Scar",
  },
  {
    id: "scarab-finance",
    symbol: "scarab",
    name: "Scarab Finance",
  },
  {
    id: "scarcity",
    symbol: "scx",
    name: "Scarcity",
  },
  {
    id: "scardust",
    symbol: "scard",
    name: "SCARDust",
  },
  {
    id: "scarface-finance",
    symbol: "scar",
    name: "Scarface Finance",
  },
  {
    id: "scary-chain-capital",
    symbol: "scc",
    name: "Scary Chain Capital",
  },
  {
    id: "scary-games",
    symbol: "scy",
    name: "Scary Games",
  },
  {
    id: "scaryswap",
    symbol: "scary",
    name: "Scaryswap",
  },
  {
    id: "scash",
    symbol: "scash",
    name: "sCASH",
  },
  {
    id: "s-c-corinthians-fan-token",
    symbol: "sccp",
    name: "S.C. Corinthians Fan Token",
  },
  {
    id: "schain-wallet",
    symbol: "scha",
    name: "Schain Wallet",
  },
  {
    id: "schillingcoin",
    symbol: "sch",
    name: "Schilling-Coin",
  },
  {
    id: "schnoodle",
    symbol: "snood",
    name: "Schnoodle",
  },
  {
    id: "scholarship-coin",
    symbol: "scho",
    name: "Scholarship Coin",
  },
  {
    id: "schrodinger",
    symbol: "kitty dinger",
    name: "Schrodinger",
  },
  {
    id: "science_chain",
    symbol: "scc",
    name: "Science Chain",
  },
  {
    id: "scientia",
    symbol: "scie",
    name: "Scientia",
  },
  {
    id: "scientix",
    symbol: "scix",
    name: "Scientix",
  },
  {
    id: "scifi-index",
    symbol: "scifi",
    name: "SCIFI Index",
  },
  {
    id: "scolcoin",
    symbol: "scol",
    name: "Scolcoin",
  },
  {
    id: "sconex",
    symbol: "sconex",
    name: "SCOneX",
  },
  {
    id: "scoobi-doge",
    symbol: "scoobi",
    name: "Scoobi Doge",
  },
  {
    id: "scootercoin",
    symbol: "scoot",
    name: "ScooterCoin",
  },
  {
    id: "scope",
    symbol: "scp",
    name: "Scope",
  },
  {
    id: "scopecoin",
    symbol: "xscp",
    name: "ScopeCoin",
  },
  {
    id: "scopuly-token",
    symbol: "scop",
    name: "Scopuly",
  },
  {
    id: "scorefam",
    symbol: "sft",
    name: "Scorefam",
  },
  {
    id: "score-token",
    symbol: "sco",
    name: "Score",
  },
  {
    id: "scorpion-finance",
    symbol: "scorpfin",
    name: "Scorpion Finance",
  },
  {
    id: "scorum",
    symbol: "scr",
    name: "Scorum",
  },
  {
    id: "scotty-beam",
    symbol: "scotty",
    name: "Scotty Beam",
  },
  {
    id: "scrap",
    symbol: "scrap",
    name: "Scrap",
  },
  {
    id: "scream",
    symbol: "scream",
    name: "Scream",
  },
  {
    id: "scribe",
    symbol: "scribe",
    name: "Scribe",
  },
  {
    id: "scriv",
    symbol: "scriv",
    name: "SCRIV",
  },
  {
    id: "scroll-token",
    symbol: "xd",
    name: "Data Transaction XD",
  },
  {
    id: "scrooge",
    symbol: "scrooge",
    name: "Scrooge",
  },
  {
    id: "scry-info",
    symbol: "ddd",
    name: "Scry.info",
  },
  {
    id: "scrypta",
    symbol: "lyra",
    name: "Scrypta",
  },
  {
    id: "sdefi",
    symbol: "sdefi",
    name: "sDEFI",
  },
  {
    id: "sdot",
    symbol: "sdot",
    name: "sDOT",
  },
  {
    id: "sdraco",
    symbol: "sdraco",
    name: "SDRACO",
  },
  {
    id: "sea",
    symbol: "sea",
    name: "Sea",
  },
  {
    id: "seachain",
    symbol: "seachain",
    name: "SeaChain",
  },
  {
    id: "seadex",
    symbol: "sead",
    name: "SEADEX",
  },
  {
    id: "seadog-metaverse",
    symbol: "seadog",
    name: "Seadog Metaverse",
  },
  {
    id: "seamlessswap-token",
    symbol: "seamless",
    name: "SeamlessSwap",
  },
  {
    id: "seancecircle",
    symbol: "seance",
    name: "SeanceCircle",
  },
  {
    id: "sea-oceanus",
    symbol: "sea",
    name: "Sea Oceanus",
  },
  {
    id: "seba",
    symbol: "seba",
    name: "Seba",
  },
  {
    id: "sechain",
    symbol: "snn",
    name: "SeChain",
  },
  {
    id: "secret",
    symbol: "scrt",
    name: "Secret",
  },
  {
    id: "secret-erc20",
    symbol: "wscrt",
    name: "Secret (ERC20)",
  },
  {
    id: "secret-finance",
    symbol: "sefi",
    name: "Secret Finance",
  },
  {
    id: "secretsky-finance",
    symbol: "ssf",
    name: "SecretSky Finance",
  },
  {
    id: "secretum",
    symbol: "ser",
    name: "Secretum",
  },
  {
    id: "secretworld",
    symbol: "ssd",
    name: "SecretWorld",
  },
  {
    id: "securabyte-protocol",
    symbol: "sbyte",
    name: "Securabyte Protocol",
  },
  {
    id: "secure",
    symbol: "scr",
    name: "Secure",
  },
  {
    id: "secure-cash",
    symbol: "scsx",
    name: "Secure Cash",
  },
  {
    id: "secured-moonrat-token",
    symbol: "smrat",
    name: "Secured MoonRat",
  },
  {
    id: "secured-ship",
    symbol: "ship",
    name: "Secured Ship",
  },
  {
    id: "securus",
    symbol: "xscr",
    name: "Securus",
  },
  {
    id: "seda",
    symbol: "seda",
    name: "SEDA",
  },
  {
    id: "sedo-pow-token",
    symbol: "sedo",
    name: "SEDO POW",
  },
  {
    id: "seed2need",
    symbol: "silo",
    name: "Seed2Need",
  },
  {
    id: "seeded-network",
    symbol: "seeded",
    name: "Seeded Network",
  },
  {
    id: "seeder-finance",
    symbol: "leaf",
    name: "Seeder Finance",
  },
  {
    id: "seedify-fund",
    symbol: "sfund",
    name: "Seedify.fund",
  },
  {
    id: "seedling",
    symbol: "sdln",
    name: "Seedling",
  },
  {
    id: "seedon",
    symbol: "seon",
    name: "Seedon",
  },
  {
    id: "seeds",
    symbol: "seeds",
    name: "Seeds",
  },
  {
    id: "seedswap",
    symbol: "snft",
    name: "SeedSwap",
  },
  {
    id: "seed-token",
    symbol: "seed",
    name: "HamstersLeague Seed",
  },
  {
    id: "seed-venture",
    symbol: "seed",
    name: "Seed Venture",
  },
  {
    id: "seek-tiger",
    symbol: "sti",
    name: "Seek Tiger",
  },
  {
    id: "seele",
    symbol: "seele",
    name: "Seele",
  },
  {
    id: "seen",
    symbol: "seen",
    name: "SEEN",
  },
  {
    id: "seesaw",
    symbol: "ssw",
    name: "Seesaw",
  },
  {
    id: "seigniorage-shares",
    symbol: "share",
    name: "Seigniorage Shares",
  },
  {
    id: "seismic",
    symbol: "scb",
    name: "Seismic",
  },
  {
    id: "sekopay-2",
    symbol: "seko",
    name: "SekoPay",
  },
  {
    id: "sekuritance",
    symbol: "skrt",
    name: "Sekuritance",
  },
  {
    id: "sekuya",
    symbol: "skuy",
    name: "Sekuya",
  },
  {
    id: "selenium",
    symbol: "slc",
    name: "Selenium",
  },
  {
    id: "selfbar",
    symbol: "sbar",
    name: "Selfbar",
  },
  {
    id: "selfkey",
    symbol: "key",
    name: "SelfKey",
  },
  {
    id: "semitoken",
    symbol: "semi",
    name: "Semi",
  },
  {
    id: "semux",
    symbol: "sem",
    name: "Semux",
  },
  {
    id: "senate",
    symbol: "senate",
    name: "SENATE",
  },
  {
    id: "senator-karen",
    symbol: "karen",
    name: "Senator Karen",
  },
  {
    id: "sense",
    symbol: "sense",
    name: "Sense",
  },
  {
    id: "sensei",
    symbol: "sensei",
    name: "Sensei",
  },
  {
    id: "sensei-shib",
    symbol: "$sensei",
    name: "Sensei Shib",
  },
  {
    id: "sensi",
    symbol: "sensi",
    name: "Sensi",
  },
  {
    id: "sensible-finance",
    symbol: "sensi",
    name: "Sensible Finance [OLD]",
  },
  {
    id: "sensitrust",
    symbol: "sets",
    name: "Sensitrust",
  },
  {
    id: "senso",
    symbol: "senso",
    name: "SENSO",
  },
  {
    id: "senspark",
    symbol: "sen",
    name: "Senspark",
  },
  {
    id: "sentiment-token",
    symbol: "sent",
    name: "Sentiment",
  },
  {
    id: "sentinel",
    symbol: "dvpn",
    name: "Sentinel",
  },
  {
    id: "sentinel-chain",
    symbol: "senc",
    name: "Sentinel Chain",
  },
  {
    id: "sentinel-group",
    symbol: "dvpn",
    name: "Sentinel [OLD]",
  },
  {
    id: "sentinel-protocol",
    symbol: "upp",
    name: "Sentinel Protocol",
  },
  {
    id: "sentivate",
    symbol: "sntvt",
    name: "Sentivate",
  },
  {
    id: "sentre",
    symbol: "sntr",
    name: "Sentre",
  },
  {
    id: "seor-network",
    symbol: "seor",
    name: "SEOR Network",
  },
  {
    id: "sequence",
    symbol: "seq",
    name: "Sequence",
  },
  {
    id: "serenity",
    symbol: "seren",
    name: "Serenity",
  },
  {
    id: "serenity-financial",
    symbol: "srnt",
    name: "Serenity Financial",
  },
  {
    id: "serey-coin",
    symbol: "sry",
    name: "Serey Coin",
  },
  {
    id: "sergey-save-link",
    symbol: "ssl",
    name: "SERGS Governance",
  },
  {
    id: "sergs",
    symbol: "sergs",
    name: "SERGS",
  },
  {
    id: "serum",
    symbol: "srm",
    name: "Serum",
  },
  {
    id: "serum-ecosystem-token",
    symbol: "seco",
    name: "Serum Ecosystem",
  },
  {
    id: "serum-wormhole",
    symbol: "srmso",
    name: "Serum (Wormhole)",
  },
  {
    id: "serum-wormhole-from-ethereum",
    symbol: "srmet",
    name: "Serum (Wormhole from Ethereum)",
  },
  {
    id: "sescrt",
    symbol: "sescrt",
    name: "StakeEasy Secret Derivative Token",
  },
  {
    id: "sessia",
    symbol: "kicks",
    name: "SESSIA",
  },
  {
    id: "seth",
    symbol: "seth",
    name: "sETH",
  },
  {
    id: "seth2",
    symbol: "seth2",
    name: "sETH2",
  },
  {
    id: "sether",
    symbol: "seth",
    name: "Sether",
  },
  {
    id: "seur",
    symbol: "seur",
    name: "sEUR",
  },
  {
    id: "severe-rise-games",
    symbol: "srgt",
    name: "Severe Rise Games",
  },
  {
    id: "sewer-rat-social-club-chiz-token",
    symbol: "chiz",
    name: "Sewer Rat Social Club CHIZ Token",
  },
  {
    id: "sexcoin",
    symbol: "sxc",
    name: "Sexcoin",
  },
  {
    id: "sf-capital",
    symbol: "sfcp",
    name: "SF Capital",
  },
  {
    id: "s-finance",
    symbol: "sfg",
    name: "S.Finance",
  },
  {
    id: "sg20",
    symbol: "sg20",
    name: "SG20",
  },
  {
    id: "sgt-shib",
    symbol: "sgts",
    name: "Sgt.SHIB",
  },
  {
    id: "shabu-shabu",
    symbol: "kobe",
    name: "Shabu Shabu",
  },
  {
    id: "shack",
    symbol: "shack",
    name: "Shack",
  },
  {
    id: "shade-cash",
    symbol: "shade",
    name: "Shade Cash",
  },
  {
    id: "shade-protocol",
    symbol: "shd",
    name: "Shade Protocol",
  },
  {
    id: "shadows",
    symbol: "dows",
    name: "Shadows",
  },
  {
    id: "shadow-token",
    symbol: "shdw",
    name: "Shadow",
  },
  {
    id: "shakita-inu",
    symbol: "shak",
    name: "Shakita Inu",
  },
  {
    id: "shaman",
    symbol: "shaman",
    name: "Shaman",
  },
  {
    id: "shaman-king-inu",
    symbol: "shaman",
    name: "Shaman King Inu [OLD]",
  },
  {
    id: "shambala",
    symbol: "bala",
    name: "Shambala",
  },
  {
    id: "shapepay",
    symbol: "spp",
    name: "ShapePay",
  },
  {
    id: "shapeshift-fox-token",
    symbol: "fox",
    name: "ShapeShift FOX Token",
  },
  {
    id: "shard",
    symbol: "shard",
    name: "Shard Coin",
  },
  {
    id: "shard-2",
    symbol: "shard",
    name: "Shard",
  },
  {
    id: "sharder-protocol",
    symbol: "ss",
    name: "Sharder protocol",
  },
  {
    id: "shardingdao",
    symbol: "shd",
    name: "ShardingDAO",
  },
  {
    id: "shardus",
    symbol: "ult",
    name: "Shardus",
  },
  {
    id: "share-nft",
    symbol: "snt",
    name: "Share NFT",
  },
  {
    id: "sharering",
    symbol: "shr",
    name: "Share",
  },
  {
    id: "sharity",
    symbol: "$shari",
    name: "Sharity",
  },
  {
    id: "sharkcoin",
    symbol: "skn",
    name: "Sharkcoin",
  },
  {
    id: "sharkrace",
    symbol: "shrk",
    name: "SharkRace",
  },
  {
    id: "shar-pei",
    symbol: "sharpei",
    name: "Shar Pei",
  },
  {
    id: "shazu",
    symbol: "shazu",
    name: "Shazu",
  },
  {
    id: "shd-cash",
    symbol: "shdc",
    name: "SHD Cash",
  },
  {
    id: "shebolleth-commerce",
    symbol: "sbecom",
    name: "SheBollETH Commerce",
  },
  {
    id: "sheeba",
    symbol: "sheeba",
    name: "SHEEBA",
  },
  {
    id: "sheep-game",
    symbol: "awool",
    name: "Sheep Game",
  },
  {
    id: "sheeptoken",
    symbol: "sheep",
    name: "Sheep",
  },
  {
    id: "sheesh",
    symbol: "sheesh",
    name: "Sheesh",
  },
  {
    id: "sheesha-finance",
    symbol: "sheesha",
    name: "Sheesha Finance (BEP20)",
  },
  {
    id: "sheesha-finance-erc20",
    symbol: "sheesha",
    name: "Sheesha Finance (ERC20)",
  },
  {
    id: "sheesha-finance-polygon",
    symbol: "msheesha",
    name: "Sheesha Finance Polygon",
  },
  {
    id: "sheeshmoon",
    symbol: "smoo",
    name: "SheeshMoon",
  },
  {
    id: "sheikh-coin",
    symbol: "sheikh",
    name: "Sheikh Coin",
  },
  {
    id: "shelby-token",
    symbol: "sby",
    name: "Shelby",
  },
  {
    id: "shelling",
    symbol: "shl",
    name: "Shelling",
  },
  {
    id: "shell-token",
    symbol: "shell",
    name: "Shell",
  },
  {
    id: "sheng",
    symbol: "sheng",
    name: "SHENG",
  },
  {
    id: "shengweihu",
    symbol: "shengweihu",
    name: "Shengweihu",
  },
  {
    id: "shera",
    symbol: "shr",
    name: "shera [OLD]",
  },
  {
    id: "shera-2",
    symbol: "shr",
    name: "Shera",
  },
  {
    id: "sherlock365",
    symbol: "lock",
    name: "Sherlock365",
  },
  {
    id: "sherpa",
    symbol: "sherpa",
    name: "Sherpa",
  },
  {
    id: "shiba-bank",
    symbol: "shibabank",
    name: "Shiba Bank",
  },
  {
    id: "shibabnb-org",
    symbol: "shibabnb",
    name: "ShibaBNB.org",
  },
  {
    id: "shiba-bsc",
    symbol: "shibsc",
    name: "SHIBA BSC",
  },
  {
    id: "shibacash",
    symbol: "shibacash",
    name: "ShibaCash",
  },
  {
    id: "shibacock",
    symbol: "cock",
    name: "Shibacock",
  },
  {
    id: "shibacorgi",
    symbol: "shico",
    name: "ShibaCorgi",
  },
  {
    id: "shibadoge",
    symbol: "shibdoge",
    name: "ShibaDoge",
  },
  {
    id: "shiba-dollars",
    symbol: "shibadollars",
    name: "Shiba Dollars",
  },
  {
    id: "shiba-dragon",
    symbol: "shibad",
    name: "Shiba Dragon",
  },
  {
    id: "shiba-elon",
    symbol: "eshib",
    name: "Shiba Elon",
  },
  {
    id: "shibaelonverse",
    symbol: "shibev",
    name: "ShibaElonVerse",
  },
  {
    id: "shiba-fantom",
    symbol: "shiba",
    name: "Shiba Fantom",
  },
  {
    id: "shibafi",
    symbol: "shibafi",
    name: "Shiba Finance",
  },
  {
    id: "shiba-floki",
    symbol: "floki",
    name: "Shiba Floki Inu",
  },
  {
    id: "shibagalaxy",
    symbol: "shibgx",
    name: "ShibaGalaxy",
  },
  {
    id: "shiba-games",
    symbol: "shibagames",
    name: "Shiba Games",
  },
  {
    id: "shiba-hunter",
    symbol: "shunt",
    name: "Shiba Hunter",
  },
  {
    id: "shiba-inu",
    symbol: "shib",
    name: "Shiba Inu",
  },
  {
    id: "shiba-inu-billionaire",
    symbol: "shibib",
    name: "Shiba Inu Billionaire",
  },
  {
    id: "shiba-inu-classic",
    symbol: "shibic",
    name: "Shiba Inu Classic",
  },
  {
    id: "shiba-inu-empire",
    symbol: "shibemp",
    name: "Shiba Inu Empire",
  },
  {
    id: "shiba-inu-mother",
    symbol: "shibm",
    name: "Shiba Inu Mother",
  },
  {
    id: "shiba-inu-wormhole",
    symbol: "shib",
    name: "Shiba Inu (Wormhole)",
  },
  {
    id: "shibaken-finance",
    symbol: "shibaken",
    name: "Shibaken Finance",
  },
  {
    id: "shibalana",
    symbol: "shiba",
    name: "Shibalana",
  },
  {
    id: "shiba-light",
    symbol: "shibt",
    name: "Shiba Light",
  },
  {
    id: "shibalite",
    symbol: "shiblite",
    name: "ShibaLite",
  },
  {
    id: "shibametaverse",
    symbol: "shibameta",
    name: "ShibaMetaverse",
  },
  {
    id: "shiba-metaverse",
    symbol: "shibmeta",
    name: "Shiba Metaverse",
  },
  {
    id: "shibamon",
    symbol: "shibamon",
    name: "Shibamon",
  },
  {
    id: "shiba-mongoose",
    symbol: "shibmong",
    name: "Shiba Mongoose",
  },
  {
    id: "shiba-moon",
    symbol: "shibm",
    name: "Shiba Moon",
  },
  {
    id: "shibana",
    symbol: "bana",
    name: "Shibana",
  },
  {
    id: "shibanft",
    symbol: "shibanft",
    name: "ShibaNFT",
  },
  {
    id: "shibanova",
    symbol: "nova",
    name: "ShibaNova",
  },
  {
    id: "shibapad",
    symbol: "sbp",
    name: "ShibaPad",
  },
  {
    id: "shiba-predator",
    symbol: "qom",
    name: "Shiba Predator",
  },
  {
    id: "shibapup",
    symbol: "shibapup",
    name: "ShibaPup",
  },
  {
    id: "shiba-ramen",
    symbol: "shibaramen",
    name: "Shiba Ramen",
  },
  {
    id: "shib-army",
    symbol: "shibarmy",
    name: "Shib Army",
  },
  {
    id: "shibarocket",
    symbol: "shibarocket",
    name: "ShibaRocket",
  },
  {
    id: "shiba-shogun",
    symbol: "shibagun",
    name: "Shiba Shogun",
  },
  {
    id: "shiba-toby",
    symbol: "shbt",
    name: "Shiba Toby",
  },
  {
    id: "shiba-universe",
    symbol: "shibu",
    name: "Shiba Universe",
  },
  {
    id: "shibavax",
    symbol: "shibx",
    name: "Shibavax",
  },
  {
    id: "shibaverse",
    symbol: "verse",
    name: "Shibaverse",
  },
  {
    id: "shibaverse-token",
    symbol: "shiver",
    name: "Shibaverse SHIVER",
  },
  {
    id: "shiba-viking",
    symbol: "shibking",
    name: "Shiba Viking",
  },
  {
    id: "shiba-watch",
    symbol: "shibaw",
    name: "Shiba Watch",
  },
  {
    id: "shiba-x",
    symbol: "shibax",
    name: "Shiba X",
  },
  {
    id: "shibazilla",
    symbol: "shibazilla",
    name: "ShibaZilla",
  },
  {
    id: "shibboo-inu",
    symbol: "shibboo",
    name: "Shibboo Inu",
  },
  {
    id: "shib-cake",
    symbol: "shibcake",
    name: "SHIB CAKE",
  },
  {
    id: "shibelon",
    symbol: "shibelon",
    name: "ShibElon",
  },
  {
    id: "shibgeki",
    symbol: "shibgeki",
    name: "Shibgeki",
  },
  {
    id: "shib-generating",
    symbol: "shg",
    name: "Shib Generating",
  },
  {
    id: "shibgf",
    symbol: "shibgf",
    name: "SHIBGF",
  },
  {
    id: "shibgotchi",
    symbol: "shibgotchi",
    name: "SHiBGOTCHi",
  },
  {
    id: "shibkiller",
    symbol: "shibkiller",
    name: "ShibKiller",
  },
  {
    id: "shibmerican",
    symbol: "shibmerican",
    name: "Shibmerican",
  },
  {
    id: "shibmoon",
    symbol: "shibm",
    name: "ShibMoon",
  },
  {
    id: "shibnaki",
    symbol: "shaki",
    name: "SHIBNAKI",
  },
  {
    id: "shibnobi",
    symbol: "shinja",
    name: "Shibnobi",
  },
  {
    id: "shiboki-2",
    symbol: "shiboki",
    name: "Shiboki",
  },
  {
    id: "shibonk",
    symbol: "shibo",
    name: "Shibonk",
  },
  {
    id: "shibooster",
    symbol: "shiboost",
    name: "Shibooster",
  },
  {
    id: "shiborg-inu",
    symbol: "shiborg",
    name: "SHIBORG INU",
  },
  {
    id: "shibrobi",
    symbol: "shiborg",
    name: "ShibRobi",
  },
  {
    id: "shibrwd",
    symbol: "srwd",
    name: "ShibRWD",
  },
  {
    id: "shibtama",
    symbol: "shibtama",
    name: "Shibtama",
  },
  {
    id: "shibtaro",
    symbol: "shibtaro",
    name: "ShibTaro",
  },
  {
    id: "shibui-dao",
    symbol: "shibui",
    name: "Shibui DAO",
  },
  {
    id: "shibu-life",
    symbol: "shibu",
    name: "Shibu Life",
  },
  {
    id: "shibvinci",
    symbol: "shiv",
    name: "ShibVinci",
  },
  {
    id: "shiden",
    symbol: "sdn",
    name: "Shiden Network",
  },
  {
    id: "shield",
    symbol: "xsh",
    name: "SHIELD",
  },
  {
    id: "shield-dao",
    symbol: "sld",
    name: "ShieldEX",
  },
  {
    id: "shield-finance",
    symbol: "coli",
    name: "Coliquidity",
  },
  {
    id: "shield-network",
    symbol: "shieldnet",
    name: "Shield Network",
  },
  {
    id: "shield-protocol",
    symbol: "shield",
    name: "Shield Protocol [OLD]",
  },
  {
    id: "shield-protocol-2",
    symbol: "shield",
    name: "Shield Protocol",
  },
  {
    id: "shield-protocol-token",
    symbol: "shield",
    name: "Shield Protocol Token",
  },
  {
    id: "shiftal-coin",
    symbol: "sfl",
    name: "Shiftal Coin",
  },
  {
    id: "shih-tzu",
    symbol: "shih",
    name: "Shih Tzu",
  },
  {
    id: "shikage",
    symbol: "shkg",
    name: "Shikage",
  },
  {
    id: "shikoku-inu",
    symbol: "shiko",
    name: "Shikoku Inu",
  },
  {
    id: "shilling",
    symbol: "sh",
    name: "Shilling",
  },
  {
    id: "shillit-app",
    symbol: "shill",
    name: "Shillit App",
  },
  {
    id: "shill-token",
    symbol: "shill",
    name: "Project SEED SHILL",
  },
  {
    id: "shilly-bar",
    symbol: "shbar",
    name: "Shilly Bar",
  },
  {
    id: "shimmer-network",
    symbol: "smr",
    name: "Shimmer Network",
  },
  {
    id: "shina-inu",
    symbol: "shi",
    name: "Shina Inu",
  },
  {
    id: "shinchan-token",
    symbol: "shinnosuke",
    name: "ShinChan",
  },
  {
    id: "shinechain",
    symbol: "she",
    name: "ShineChain",
  },
  {
    id: "shinedao",
    symbol: "shn",
    name: "ShineDAO",
  },
  {
    id: "shinemine",
    symbol: "shine",
    name: "ShineMine",
  },
  {
    id: "shinfloki",
    symbol: "shinfloki",
    name: "ShinFloki",
  },
  {
    id: "shining-crystal-shard",
    symbol: "scs",
    name: "Shining Crystal Shard",
  },
  {
    id: "shinji-inu",
    symbol: "shinji",
    name: "Shinji Inu",
  },
  {
    id: "shinjirai",
    symbol: "$shinji",
    name: "ShinjiRai",
  },
  {
    id: "shinjiro",
    symbol: "shinjiro",
    name: "Shinjiro",
  },
  {
    id: "shinji-the-zombie-slayer",
    symbol: "shinjiz",
    name: "Shinji the Zombie Slayer",
  },
  {
    id: "shinjurai",
    symbol: "shinjurai",
    name: "Shinjurai",
  },
  {
    id: "shinjutsu",
    symbol: "shinjutsu",
    name: "Shinjutsu",
  },
  {
    id: "shinobi",
    symbol: "snb",
    name: "Shinobi",
  },
  {
    id: "shinobi-inu",
    symbol: "shin",
    name: "Shinobi Inu",
  },
  {
    id: "shintama",
    symbol: "shintama",
    name: "Shintama",
  },
  {
    id: "shiny",
    symbol: "shiny",
    name: "Shiny",
  },
  {
    id: "shipchain",
    symbol: "ship",
    name: "ShipChain",
  },
  {
    id: "shipitpro",
    symbol: "shpp",
    name: "ShipItPro",
  },
  {
    id: "shiplay",
    symbol: "sply",
    name: "ShiPlay",
  },
  {
    id: "shirainu",
    symbol: "shr",
    name: "ShiraINU",
  },
  {
    id: "shirtum",
    symbol: "shi",
    name: "Shirtum",
  },
  {
    id: "shiryo-inu",
    symbol: "shiryo-inu",
    name: "Shiryo",
  },
  {
    id: "shisha",
    symbol: "shish",
    name: "Shisha",
  },
  {
    id: "shitcoin",
    symbol: "shit",
    name: "ShitCoin",
  },
  {
    id: "shitzu",
    symbol: "shitzu",
    name: "Shitzu",
  },
  {
    id: "shiwbawitch-token",
    symbol: "shibawitch",
    name: "SHIWBAWITCH",
  },
  {
    id: "shkooby-inu",
    symbol: "shkooby",
    name: "SHKOOBY INU",
  },
  {
    id: "shoebill-coin",
    symbol: "shbl",
    name: "Shoebill Coin",
  },
  {
    id: "shoefy",
    symbol: "shoe",
    name: "ShoeFy",
  },
  {
    id: "shontoken",
    symbol: "shon",
    name: "Shon",
  },
  {
    id: "shoot",
    symbol: "shoo",
    name: "SHOOT",
  },
  {
    id: "shopnext",
    symbol: "next",
    name: "ShopNEXT",
  },
  {
    id: "shopperoo",
    symbol: "sro",
    name: "Shopperoo",
  },
  {
    id: "shoppi-coin",
    symbol: "shop",
    name: "Shoppi Coin",
  },
  {
    id: "shopping-io",
    symbol: "spi",
    name: "Shopping.io",
  },
  {
    id: "shorty",
    symbol: "shorty",
    name: "Shorty",
  },
  {
    id: "showcase-token",
    symbol: "sho",
    name: "Showcase",
  },
  {
    id: "showhand",
    symbol: "hand",
    name: "ShowHand",
  },
  {
    id: "shping",
    symbol: "shping",
    name: "Shping",
  },
  {
    id: "shroom-finance",
    symbol: "shroom",
    name: "Niftyx Protocol",
  },
  {
    id: "shrooms",
    symbol: "shrm",
    name: "Shrooms",
  },
  {
    id: "shuey-rhon-inu",
    symbol: "shuey",
    name: "Shuey Rhon Inu",
  },
  {
    id: "shumo",
    symbol: "shumo",
    name: "Shumo",
  },
  {
    id: "shuna-inuverse",
    symbol: "shunav2",
    name: "Shuna Inuverse",
  },
  {
    id: "shyft-network-2",
    symbol: "shft",
    name: "Shyft Network",
  },
  {
    id: "si14bet",
    symbol: "si14",
    name: "Si14Bet",
  },
  {
    id: "siacashcoin",
    symbol: "scc",
    name: "SiaCashCoin",
  },
  {
    id: "siaclassic",
    symbol: "scc",
    name: "SiaClassic",
  },
  {
    id: "siacoin",
    symbol: "sc",
    name: "Siacoin",
  },
  {
    id: "siambitcoin",
    symbol: "sbtc",
    name: "SiamBitcoin",
  },
  {
    id: "siaprime-coin",
    symbol: "scp",
    name: "ScPrime",
  },
  {
    id: "sibcoin",
    symbol: "sib",
    name: "SIBCoin",
  },
  {
    id: "siberian-husky",
    symbol: "shusky",
    name: "Siberian Husky",
  },
  {
    id: "sicash",
    symbol: "sic",
    name: "SICash",
  },
  {
    id: "siddcoin",
    symbol: "sidd",
    name: "Siddcoin",
  },
  {
    id: "sidekick-token",
    symbol: "sk",
    name: "SideKick",
  },
  {
    id: "sideshift-token",
    symbol: "xai",
    name: "SideShift",
  },
  {
    id: "sidus",
    symbol: "sidus",
    name: "Sidus",
  },
  {
    id: "sienna",
    symbol: "sienna",
    name: "Sienna",
  },
  {
    id: "sienna-erc20",
    symbol: "wsienna",
    name: "Sienna [ERC-20]",
  },
  {
    id: "sierra",
    symbol: "sra",
    name: "Sierra",
  },
  {
    id: "sif",
    symbol: "sif",
    name: "Sif",
  },
  {
    id: "sifchain",
    symbol: "erowan",
    name: "Sifchain",
  },
  {
    id: "sifu-vision",
    symbol: "sifu",
    name: "Sifu Vision",
  },
  {
    id: "signal",
    symbol: "sgnl",
    name: "Signal",
  },
  {
    id: "signal-token",
    symbol: "sig",
    name: "Signal SIG",
  },
  {
    id: "signata",
    symbol: "sata",
    name: "Signata",
  },
  {
    id: "signaturechain",
    symbol: "sign",
    name: "SignatureChain",
  },
  {
    id: "signed",
    symbol: "sign",
    name: "Signed",
  },
  {
    id: "signum",
    symbol: "signa",
    name: "Signum",
  },
  {
    id: "silent-notary",
    symbol: "ubsn",
    name: "Silent Notary",
  },
  {
    id: "sil-finance",
    symbol: "sil",
    name: "SIL Finance V2",
  },
  {
    id: "silkchain",
    symbol: "silk",
    name: "SilkChain",
  },
  {
    id: "silo-finance",
    symbol: "silo",
    name: "Silo Finance",
  },
  {
    id: "silva-token",
    symbol: "silva",
    name: "Silva",
  },
  {
    id: "silvercashs",
    symbol: "svc",
    name: "Silvercashs",
  },
  {
    id: "silvercoin",
    symbol: "sc",
    name: "SilverCoin",
  },
  {
    id: "silverstonks",
    symbol: "sstx",
    name: "Silver Stonks",
  },
  {
    id: "silvertoken",
    symbol: "slvt",
    name: "Silver SLVT",
  },
  {
    id: "silver-tokenized-stock-defichain",
    symbol: "dslv",
    name: "iShares Silver Trust Defichain",
  },
  {
    id: "silverway",
    symbol: "slv",
    name: "Silverway",
  },
  {
    id: "simba-empire",
    symbol: "sim",
    name: "Simba Empire",
  },
  {
    id: "simba-inu",
    symbol: "simbainu",
    name: "Simba Inu",
  },
  {
    id: "simba-storage-token",
    symbol: "sst",
    name: "SIMBA Storage",
  },
  {
    id: "simba-token",
    symbol: "simba",
    name: "Simba",
  },
  {
    id: "simbcoin-swap",
    symbol: "smbswap",
    name: "SimbCoin Swap",
  },
  {
    id: "simple-cool-automatic-money",
    symbol: "scam",
    name: "Simple Cool Automatic Money",
  },
  {
    id: "simple-masternode-coin",
    symbol: "smnc",
    name: "Simple Masternode Coin",
  },
  {
    id: "simple-token",
    symbol: "ost",
    name: "OST",
  },
  {
    id: "simplexchain",
    symbol: "sxc",
    name: "SimplexChain",
  },
  {
    id: "simplicity-coin",
    symbol: "spl",
    name: "Simplicity Coin",
  },
  {
    id: "simpli-finance",
    symbol: "simpli",
    name: "Simpli Finance",
  },
  {
    id: "simply",
    symbol: "simply",
    name: "Simply",
  },
  {
    id: "simp-token",
    symbol: "simp",
    name: "Simp",
  },
  {
    id: "simracer-coin",
    symbol: "src",
    name: "Simracer Coin",
  },
  {
    id: "sinan-energy",
    symbol: "set",
    name: "Sinan Energy",
  },
  {
    id: "sincere-cate",
    symbol: "$scate",
    name: "Sincere Cate",
  },
  {
    id: "sincere-doge",
    symbol: "sdoge",
    name: "Sincere Doge",
  },
  {
    id: "sin-city",
    symbol: "sin",
    name: "Sinverse",
  },
  {
    id: "sinerium",
    symbol: "xnr",
    name: "Sinerium",
  },
  {
    id: "singer-community-coin",
    symbol: "singer",
    name: "Singer Community Coin",
  },
  {
    id: "singh",
    symbol: "singh",
    name: "Singh",
  },
  {
    id: "single-finance",
    symbol: "single",
    name: "Single Finance",
  },
  {
    id: "sing-token",
    symbol: "sing",
    name: "Sing",
  },
  {
    id: "sing-token-avalanche",
    symbol: "sing",
    name: "Sing (Avalanche)",
  },
  {
    id: "sing-token-bsc",
    symbol: "sing",
    name: "Sing (BSC)",
  },
  {
    id: "singulardtv",
    symbol: "sngls",
    name: "SingularDTV",
  },
  {
    id: "singularity",
    symbol: "sgly",
    name: "Singularity",
  },
  {
    id: "singularitydao",
    symbol: "sdao",
    name: "SingularityDAO",
  },
  {
    id: "singularitynet",
    symbol: "agix",
    name: "SingularityNET",
  },
  {
    id: "sins-finance",
    symbol: "sin",
    name: "Sins Finance",
  },
  {
    id: "sint-truidense-voetbalvereniging-fan-token",
    symbol: "stv",
    name: "Sint-Truidense Voetbalvereniging Fan Token",
  },
  {
    id: "sipher",
    symbol: "sipher",
    name: "Sipher",
  },
  {
    id: "siren",
    symbol: "si",
    name: "Siren",
  },
  {
    id: "sirin-labs-token",
    symbol: "srn",
    name: "Sirin Labs",
  },
  {
    id: "sirio",
    symbol: "sir",
    name: "Sirio",
  },
  {
    id: "sirius-finance",
    symbol: "srs",
    name: "Sirius Finance",
  },
  {
    id: "sishi-finance",
    symbol: "sishi",
    name: "Sishi Finance",
  },
  {
    id: "sivasspor",
    symbol: "siv",
    name: "Sivasspor",
  },
  {
    id: "sixeleven",
    symbol: "611",
    name: "SixEleven",
  },
  {
    id: "six-network",
    symbol: "six",
    name: "SIX Network",
  },
  {
    id: "sjwcoin",
    symbol: "sjw",
    name: "SJWCoin",
  },
  {
    id: "skale",
    symbol: "skl",
    name: "SKALE",
  },
  {
    id: "skey-network",
    symbol: "skey",
    name: "Skey Network",
  },
  {
    id: "skillchain",
    symbol: "ski",
    name: "Skillchain",
  },
  {
    id: "skill-guilds",
    symbol: "sgk",
    name: "Skill Guilds",
  },
  {
    id: "skinchain",
    symbol: "skc",
    name: "SKINCHAIN",
  },
  {
    id: "skincoin",
    symbol: "skin",
    name: "SkinCoin",
  },
  {
    id: "sklay",
    symbol: "sklay",
    name: "sKLAY",
  },
  {
    id: "skraps",
    symbol: "skrp",
    name: "Skraps",
  },
  {
    id: "skrumble-network",
    symbol: "skm",
    name: "Skrumble Network",
  },
  {
    id: "skull",
    symbol: "skull",
    name: "Skull",
  },
  {
    id: "skybridger",
    symbol: "skbr",
    name: "SkyBridger",
  },
  {
    id: "skycoin",
    symbol: "sky",
    name: "Skycoin",
  },
  {
    id: "skydos",
    symbol: "sdc",
    name: "SkyDOS",
  },
  {
    id: "skylands",
    symbol: "skylands",
    name: "SkyLands",
  },
  {
    id: "skyrim-finance",
    symbol: "skyrim",
    name: "Skyrim Finance",
  },
  {
    id: "skyrocketing",
    symbol: "skyrocketing",
    name: "Skyrocketing",
  },
  {
    id: "sky-shiba",
    symbol: "sky",
    name: "Sky Shiba",
  },
  {
    id: "skyward-finance",
    symbol: "skyward",
    name: "Skyward Finance",
  },
  {
    id: "skyx-token",
    symbol: "skyx",
    name: "SkyX",
  },
  {
    id: "sl3-token",
    symbol: "sl3",
    name: "Mammoth",
  },
  {
    id: "slam-token",
    symbol: "slam",
    name: "Slam",
  },
  {
    id: "sleepearn-finance",
    symbol: "sen",
    name: "SleepEarn Finance",
  },
  {
    id: "sleepfuture",
    symbol: "sleepee",
    name: "SleepFuture",
  },
  {
    id: "sleepy-shib",
    symbol: "sleepy-shib",
    name: "Sleepy-Shib",
  },
  {
    id: "sleepy-sloth",
    symbol: "sleepy",
    name: "Sleepy Sloth Finance",
  },
  {
    id: "slimcoin",
    symbol: "slm",
    name: "Slimcoin",
  },
  {
    id: "slink",
    symbol: "slink",
    name: "sLINK",
  },
  {
    id: "slnv2",
    symbol: "slnv2",
    name: "SLNV2",
  },
  {
    id: "slothcoin",
    symbol: "sloth",
    name: "SlothCoin",
  },
  {
    id: "slt",
    symbol: "slt",
    name: "SLT",
  },
  {
    id: "small-doge",
    symbol: "sdog",
    name: "Small Doge",
  },
  {
    id: "small-fish-cookie",
    symbol: "sfc",
    name: "Small Fish Cookie",
  },
  {
    id: "smart-block-chain-city",
    symbol: "sbcc",
    name: "Smart Block Chain City",
  },
  {
    id: "smart-busd",
    symbol: "sbusd",
    name: "Smart BUSD",
  },
  {
    id: "smartcash",
    symbol: "smart",
    name: "SmartCash",
  },
  {
    id: "smartchem",
    symbol: "smac",
    name: "Smartchem",
  },
  {
    id: "smartcoin-2",
    symbol: "smrt",
    name: "SmartCoin",
  },
  {
    id: "smart-coin-smrtr",
    symbol: "smrtr",
    name: "SmarterCoin",
  },
  {
    id: "smartcredit-token",
    symbol: "smartcredit",
    name: "SmartCredit",
  },
  {
    id: "smart-donation-coin",
    symbol: "sdc",
    name: "Smart Donation Coin",
  },
  {
    id: "smart-electrum",
    symbol: "select",
    name: "Smart Electrum",
  },
  {
    id: "smartfi",
    symbol: "smtf",
    name: "SmartFi",
  },
  {
    id: "smartlands",
    symbol: "dnt",
    name: "Definder Network",
  },
  {
    id: "smartlox",
    symbol: "smartlox",
    name: "SmartLOX",
  },
  {
    id: "smart-marketing-token",
    symbol: "smt",
    name: "Smart Marketing",
  },
  {
    id: "smart-medical-coin",
    symbol: "smc",
    name: "Smart Medical Coin",
  },
  {
    id: "smartmesh",
    symbol: "smt",
    name: "SmartMesh",
  },
  {
    id: "smart-mfg",
    symbol: "mfg",
    name: "Smart MFG",
  },
  {
    id: "smartnft",
    symbol: "smartnft",
    name: "SmartNFT",
  },
  {
    id: "smartnodes-finance",
    symbol: "smrt",
    name: "Smart Finance",
  },
  {
    id: "smartofgiving",
    symbol: "aog",
    name: "smARTOFGIVING",
  },
  {
    id: "smartpad",
    symbol: "pad",
    name: "SmartPad [OLD]",
  },
  {
    id: "smartpad-2",
    symbol: "pad",
    name: "SmartPad",
  },
  {
    id: "smart-reward-token",
    symbol: "srt",
    name: "Smart Reward Token",
  },
  {
    id: "smartshare",
    symbol: "ssp",
    name: "Smartshare",
  },
  {
    id: "smart-shiba",
    symbol: "smartshib",
    name: "Smart Shiba",
  },
  {
    id: "smart-token",
    symbol: "smart",
    name: "Smart",
  },
  {
    id: "smart-valor",
    symbol: "valor",
    name: "Smart Valor",
  },
  {
    id: "smart-wallet-token",
    symbol: "swt",
    name: "Smart Wallet",
  },
  {
    id: "smartway-finance",
    symbol: "smart",
    name: "Smartway.Finance",
  },
  {
    id: "smartworth",
    symbol: "smartworth",
    name: "Smartworth",
  },
  {
    id: "smartx",
    symbol: "sat",
    name: "SmartX",
  },
  {
    id: "smarty-pay",
    symbol: "spy",
    name: "Smarty Pay",
  },
  {
    id: "smash-cash",
    symbol: "smash",
    name: "Smash Cash",
  },
  {
    id: "smash-token",
    symbol: "sas",
    name: "Smashchain",
  },
  {
    id: "smaugs-nft",
    symbol: "smg",
    name: "Smaugs NFT",
  },
  {
    id: "smd-coin",
    symbol: "smd",
    name: "SMD Coin",
  },
  {
    id: "smegmars",
    symbol: "smgm",
    name: "SMEGMARS",
  },
  {
    id: "smg",
    symbol: "smg",
    name: "SMG",
  },
  {
    id: "smilecoin",
    symbol: "sec",
    name: "Smilecoin",
  },
  {
    id: "smile-coin",
    symbol: "smile",
    name: "Smile Coin",
  },
  {
    id: "smile-token",
    symbol: "smile",
    name: "Smile",
  },
  {
    id: "smileycoin",
    symbol: "smly",
    name: "Smileycoin",
  },
  {
    id: "smoke",
    symbol: "smoke",
    name: "Smoke",
  },
  {
    id: "smoke-high",
    symbol: "smoke",
    name: "Smoke High",
  },
  {
    id: "smolting-inu",
    symbol: "smol",
    name: "Smolting Inu",
  },
  {
    id: "smooth-love-potion",
    symbol: "slp",
    name: "Smooth Love Potion",
  },
  {
    id: "smooth-love-potion-wormhole",
    symbol: "slp",
    name: "Smooth Love Potion (Wormhole)",
  },
  {
    id: "smoothy",
    symbol: "smty",
    name: "Smoothy",
  },
  {
    id: "smscodes",
    symbol: "smsct",
    name: "SMSCodes",
  },
  {
    id: "snail-trail",
    symbol: "slime",
    name: "Snail Trail",
  },
  {
    id: "snake",
    symbol: "gsk",
    name: "SNAKE",
  },
  {
    id: "snake-rinium",
    symbol: "rim",
    name: "Snake Rinium",
  },
  {
    id: "snake-token",
    symbol: "snk",
    name: "CryptoSnake",
  },
  {
    id: "snapex",
    symbol: "snap",
    name: "SnapEx",
  },
  {
    id: "snapparazzi",
    symbol: "rno",
    name: "Earneo",
  },
  {
    id: "snetwork",
    symbol: "snet",
    name: "Snetwork",
  },
  {
    id: "snglsdao-governance-token",
    symbol: "sgt",
    name: "snglsDAO Governance",
  },
  {
    id: "snook",
    symbol: "snk",
    name: "Snook",
  },
  {
    id: "snoopdao",
    symbol: "snoop",
    name: "SnoopDAO",
  },
  {
    id: "snoopflokidog",
    symbol: "sfd",
    name: "Snoop Floki Dog",
  },
  {
    id: "snoshares",
    symbol: "snoshare",
    name: "Snoshares",
  },
  {
    id: "snovio",
    symbol: "snov",
    name: "Snovian.Space",
  },
  {
    id: "snowballtoken",
    symbol: "snowball",
    name: "Snowball Token",
  },
  {
    id: "snowball-token",
    symbol: "snob",
    name: "Snowball",
  },
  {
    id: "snowbank",
    symbol: "sb",
    name: "Snowbank",
  },
  {
    id: "snowbear",
    symbol: "sbr",
    name: "Snowbear",
  },
  {
    id: "snowblossom",
    symbol: "snow",
    name: "SnowBlossom",
  },
  {
    id: "snow-burn",
    symbol: "burn",
    name: "Snow Burn",
  },
  {
    id: "snowcrash-token",
    symbol: "nora",
    name: "SnowCrash",
  },
  {
    id: "snowdog",
    symbol: "sdog",
    name: "Snowdog",
  },
  {
    id: "snowgem",
    symbol: "tent",
    name: "TENT",
  },
  {
    id: "snowswap",
    symbol: "snow",
    name: "Snowswap",
  },
  {
    id: "snowtomb",
    symbol: "stomb",
    name: "Snowtomb",
  },
  {
    id: "snowtomb-lot",
    symbol: "slot",
    name: "Snowtomb LOT",
  },
  {
    id: "snowy-owl",
    symbol: "sno",
    name: "Snowy Owl",
  },
  {
    id: "snx-debt-mirror",
    symbol: "dsnx",
    name: "SNX Debt Mirror",
  },
  {
    id: "soakmont",
    symbol: "skmt",
    name: "Soakmont",
  },
  {
    id: "soar-2",
    symbol: "soar",
    name: "Soar",
  },
  {
    id: "soba-token",
    symbol: "soba",
    name: "SOBA",
  },
  {
    id: "socaverse",
    symbol: "soca",
    name: "Socaverse",
  },
  {
    id: "soccerhub",
    symbol: "sch",
    name: "SoccerHub",
  },
  {
    id: "soccer-infinity",
    symbol: "socin",
    name: "Soccer Infinity",
  },
  {
    id: "socean-staked-sol",
    symbol: "scnsol",
    name: "Socean Staked Sol",
  },
  {
    id: "socialblox",
    symbol: "sblx",
    name: "SocialBlox",
  },
  {
    id: "social-good-project",
    symbol: "sg",
    name: "SocialGood",
  },
  {
    id: "sociall",
    symbol: "scl",
    name: "Sociall",
  },
  {
    id: "social-rocket",
    symbol: "rocks",
    name: "Social Rocket",
  },
  {
    id: "social-send",
    symbol: "send",
    name: "Social Send",
  },
  {
    id: "socialx-2",
    symbol: "sosx",
    name: "SocialX",
  },
  {
    id: "society-of-galactic-exploration",
    symbol: "sge",
    name: "Society of Galactic Exploration",
  },
  {
    id: "socilink",
    symbol: "soc",
    name: "SociLink",
  },
  {
    id: "soda-coin",
    symbol: "soc",
    name: "SODA Coin",
  },
  {
    id: "softchain",
    symbol: "scc",
    name: "SoftChain",
  },
  {
    id: "soga-project",
    symbol: "soga",
    name: "SOGA Project",
  },
  {
    id: "sokuswap",
    symbol: "soku",
    name: "SokuSwap",
  },
  {
    id: "sol-1x",
    symbol: "sol1x",
    name: "SOL 1x",
  },
  {
    id: "solabrador",
    symbol: "solab",
    name: "Solabrador",
  },
  {
    id: "solace",
    symbol: "solace",
    name: "SOLACE",
  },
  {
    id: "solace-coin",
    symbol: "solace",
    name: "Solace Coin",
  },
  {
    id: "solalambo",
    symbol: "sob",
    name: "SolaLambo",
  },
  {
    id: "solana",
    symbol: "sol",
    name: "Solana",
  },
  {
    id: "solana-ecosystem-index",
    symbol: "soli",
    name: "Solana Ecosystem Index",
  },
  {
    id: "solana-inu",
    symbol: "inu",
    name: "Solana Inu",
  },
  {
    id: "solana-nut",
    symbol: "solnut",
    name: "Solana Nut",
  },
  {
    id: "solana-paws",
    symbol: "paws",
    name: "Solana Paws",
  },
  {
    id: "solanasail-governance-token",
    symbol: "gsail",
    name: "SolanaSail Governance",
  },
  {
    id: "solanax",
    symbol: "sold",
    name: "Solanax",
  },
  {
    id: "sola-ninja",
    symbol: "snj",
    name: "Sola Ninja",
  },
  {
    id: "solanium",
    symbol: "slim",
    name: "Solanium",
  },
  {
    id: "solanyx",
    symbol: "syx",
    name: "Solanyx",
  },
  {
    id: "solape-token",
    symbol: "solape",
    name: "SOLAPE",
  },
  {
    id: "solapoly",
    symbol: "slpy",
    name: "Solapoly",
  },
  {
    id: "solar",
    symbol: "solar",
    name: "Solar",
  },
  {
    id: "solarbeam",
    symbol: "solar",
    name: "Solarbeam",
  },
  {
    id: "solar-bear",
    symbol: "solbear",
    name: "Solar Bear",
  },
  {
    id: "solar-energy",
    symbol: "seg",
    name: "Solar Energy",
  },
  {
    id: "solareum-wallet",
    symbol: "xsb",
    name: "Solareum Wallet",
  },
  {
    id: "solarfare",
    symbol: "slf",
    name: "Solarfare",
  },
  {
    id: "solarflare",
    symbol: "flare",
    name: "Solarflare",
  },
  {
    id: "solar-full-cycle",
    symbol: "sfc",
    name: "Solar Full Cycle",
  },
  {
    id: "solaris",
    symbol: "xlr",
    name: "Solaris",
  },
  {
    id: "solarminex",
    symbol: "smx",
    name: "SolarMineX",
  },
  {
    id: "solarmoon",
    symbol: "solar",
    name: "Solarmoon",
  },
  {
    id: "solarr",
    symbol: "slrr",
    name: "Solarr",
  },
  {
    id: "sola-token",
    symbol: "sola",
    name: "SOLA",
  },
  {
    id: "solaunch",
    symbol: "slh",
    name: "SoLaunch",
  },
  {
    id: "sol-baby-doge",
    symbol: "sbabydoge",
    name: "SOL Baby Doge",
  },
  {
    id: "solbank-token",
    symbol: "sbnk",
    name: "Solbank",
  },
  {
    id: "solberg",
    symbol: "slb",
    name: "Solberg",
  },
  {
    id: "solberry",
    symbol: "solberry",
    name: "SolBerry",
  },
  {
    id: "solbit",
    symbol: "sbt",
    name: "SOLBIT",
  },
  {
    id: "solcash",
    symbol: "solcash",
    name: "SOLCash",
  },
  {
    id: "solcats",
    symbol: "meow",
    name: "Solcats",
  },
  {
    id: "solchicks-shards",
    symbol: "shards",
    name: "SolChicks Shards",
  },
  {
    id: "solchicks-token",
    symbol: "chicks",
    name: "SolChicks",
  },
  {
    id: "solcial",
    symbol: "slcl",
    name: "Solcial",
  },
  {
    id: "solclout",
    symbol: "sct",
    name: "SolClout",
  },
  {
    id: "solcondoms",
    symbol: "condoms",
    name: "SolCondoms",
  },
  {
    id: "solcubator",
    symbol: "solc",
    name: "Solcubator",
  },
  {
    id: "soldait",
    symbol: "sit",
    name: "Soldait",
  },
  {
    id: "soldate-token",
    symbol: "date",
    name: "SolDate",
  },
  {
    id: "solderland",
    symbol: "sldr",
    name: "Solderland",
  },
  {
    id: "soldex",
    symbol: "solx",
    name: "Soldex",
  },
  {
    id: "soldiernodes",
    symbol: "sld",
    name: "SoldierNodes",
  },
  {
    id: "soldo",
    symbol: "sld",
    name: "Soldo",
  },
  {
    id: "soldoge",
    symbol: "sdoge",
    name: "SolDoge",
  },
  {
    id: "solend",
    symbol: "slnd",
    name: "Solend",
  },
  {
    id: "solex-finance",
    symbol: "slx",
    name: "Solex Finance",
  },
  {
    id: "solfarm",
    symbol: "tulip",
    name: "Tulip Protocol",
  },
  {
    id: "solfina",
    symbol: "solfi",
    name: "Solfina",
  },
  {
    id: "solfire-finance",
    symbol: "fire",
    name: "Solfire Finance",
  },
  {
    id: "sol-flowers",
    symbol: "flwr",
    name: "SOL Flowers",
  },
  {
    id: "sol-fox",
    symbol: "sfox",
    name: "Sol Fox",
  },
  {
    id: "solhero",
    symbol: "hero",
    name: "SolHero",
  },
  {
    id: "solice",
    symbol: "slc",
    name: "Solice",
  },
  {
    id: "solideth",
    symbol: "solideth",
    name: "SolidETH",
  },
  {
    id: "solidex",
    symbol: "sex",
    name: "Solidex",
  },
  {
    id: "soliditylabs",
    symbol: "soliditylabs",
    name: "SolidityLabs",
  },
  {
    id: "solidly",
    symbol: "solid",
    name: "Solidly",
  },
  {
    id: "solid-protocol",
    symbol: "solid",
    name: "Solid Protocol",
  },
  {
    id: "solidray-finance",
    symbol: "srt",
    name: "Solidray Finance",
  },
  {
    id: "solidsex-tokenized-vesolid",
    symbol: "solidsex",
    name: "SOLIDsex: Tokenized veSOLID",
  },
  {
    id: "solidus-aitech",
    symbol: "aitech",
    name: "Solidus Ai Tech",
  },
  {
    id: "solily-protocol",
    symbol: "lily",
    name: "Solily Protocol",
  },
  {
    id: "solit",
    symbol: "slt",
    name: "Solit",
  },
  {
    id: "solium-rise",
    symbol: "solar",
    name: "Solium Rise",
  },
  {
    id: "solminter",
    symbol: "smrt",
    name: "Solminter",
  },
  {
    id: "solmoon",
    symbol: "solmo",
    name: "SolMoon",
  },
  {
    id: "solo-coin",
    symbol: "solo",
    name: "Sologenic",
  },
  {
    id: "solomon-defi",
    symbol: "slm",
    name: "Solomon Defi",
  },
  {
    id: "solootbox-dao",
    symbol: "box",
    name: "Solootbox DAO",
  },
  {
    id: "solo-vault-nftx",
    symbol: "solo",
    name: "SOLO Vault (NFTX)",
  },
  {
    id: "soloxcoin",
    symbol: "sl",
    name: "SoloxCoin",
  },
  {
    id: "solpad-finance",
    symbol: "solpad",
    name: "Solpad Finance",
  },
  {
    id: "solpatrol-bail",
    symbol: "bail",
    name: "SolPatrol Bail",
  },
  {
    id: "solpay-finance",
    symbol: "solpay",
    name: "SolPay Finance",
  },
  {
    id: "solrazr",
    symbol: "solr",
    name: "SolRazr",
  },
  {
    id: "solrider",
    symbol: "srd",
    name: "SolRider",
  },
  {
    id: "solrise-finance",
    symbol: "slrs",
    name: "Solrise Finance",
  },
  {
    id: "solster",
    symbol: "str",
    name: "Solster",
  },
  {
    id: "soltato-fries",
    symbol: "fries",
    name: "Soltato FRIES",
  },
  {
    id: "solum",
    symbol: "solum",
    name: "Solum",
  },
  {
    id: "soluna",
    symbol: "slna",
    name: "Soluna",
  },
  {
    id: "solunavax-index",
    symbol: "solunavax",
    name: "SOLUNAVAX Index",
  },
  {
    id: "solust",
    symbol: "solust",
    name: "solUST",
  },
  {
    id: "solve-care",
    symbol: "solve",
    name: "SOLVE",
  },
  {
    id: "solvent",
    symbol: "svt",
    name: "Solvent",
  },
  {
    id: "solview",
    symbol: "solv",
    name: "Solview",
  },
  {
    id: "sol-wormhole",
    symbol: "sol",
    name: "SOL (Wormhole)",
  },
  {
    id: "solx-gaming-guild",
    symbol: "sgg",
    name: "SolX Gaming Guild",
  },
  {
    id: "solyard-finance",
    symbol: "yard",
    name: "Solyard Finance",
  },
  {
    id: "sombe",
    symbol: "sbe",
    name: "Sombe",
  },
  {
    id: "sombra-network",
    symbol: "smbr",
    name: "Sombra",
  },
  {
    id: "somdej",
    symbol: "sdc",
    name: "Somdej",
  },
  {
    id: "somee-advertising-token",
    symbol: "sat",
    name: "SoMee Advertising",
  },
  {
    id: "somee-social",
    symbol: "somee",
    name: "SoMee.Social",
  },
  {
    id: "somee-social-old",
    symbol: "ong",
    name: "SoMee.Social [OLD]",
  },
  {
    id: "somesing",
    symbol: "ssx",
    name: "SOMESING",
  },
  {
    id: "sommelier",
    symbol: "somm",
    name: "Sommelier",
  },
  {
    id: "somnium",
    symbol: "som",
    name: "Somnium",
  },
  {
    id: "somnium-space-cubes",
    symbol: "cube",
    name: "Somnium Space CUBEs",
  },
  {
    id: "sona-network",
    symbol: "sona",
    name: "Sona Network",
  },
  {
    id: "sonar",
    symbol: "ping",
    name: "Sonar",
  },
  {
    id: "sonarwatch",
    symbol: "sonar",
    name: "SonarWatch",
  },
  {
    id: "songbird",
    symbol: "sgb",
    name: "Songbird",
  },
  {
    id: "songcoin",
    symbol: "song",
    name: "SongCoin",
  },
  {
    id: "sonic-token",
    symbol: "sonic",
    name: "AVAXRush Sonic",
  },
  {
    id: "sonm",
    symbol: "snm",
    name: "SONM",
  },
  {
    id: "sono",
    symbol: "sono",
    name: "SONO",
  },
  {
    id: "sonocoin",
    symbol: "sono",
    name: "SonoCoin",
  },
  {
    id: "son-of-doge-v2",
    symbol: "sod",
    name: "Son of Doge",
  },
  {
    id: "son-of-elon",
    symbol: "soe",
    name: "Son of Elon",
  },
  {
    id: "sonofsaitama",
    symbol: "sos",
    name: "SonOfSaitama",
  },
  {
    id: "sonofshib",
    symbol: "son",
    name: "SONofSHIB",
  },
  {
    id: "sopay",
    symbol: "sop",
    name: "SoPay",
  },
  {
    id: "sophiatx",
    symbol: "sphtx",
    name: "SophiaTX",
  },
  {
    id: "sora",
    symbol: "xor",
    name: "Sora",
  },
  {
    id: "sorachancoin",
    symbol: "sora",
    name: "SorachanCoin",
  },
  {
    id: "sora-synthetic-usd",
    symbol: "xstusd",
    name: "SORA Synthetic USD",
  },
  {
    id: "sora-validator-token",
    symbol: "val",
    name: "Sora Validator",
  },
  {
    id: "sos-amazonia",
    symbol: "sosamz",
    name: "SOS AMAZÔNIA",
  },
  {
    id: "sos-foundation",
    symbol: "sos",
    name: "SOS Foundation",
  },
  {
    id: "sota-finance",
    symbol: "sota",
    name: "SOTA Finance",
  },
  {
    id: "soul-dog-city-bones",
    symbol: "bones",
    name: "Soul Dogs City Bones",
  },
  {
    id: "soulocoin",
    symbol: "soulo",
    name: "SouloCoin",
  },
  {
    id: "souls-of-meta",
    symbol: "som",
    name: "Souls of Meta",
  },
  {
    id: "soul-swap",
    symbol: "soul",
    name: "Soul Swap",
  },
  {
    id: "sound-coin",
    symbol: "sound",
    name: "Sound Coin",
  },
  {
    id: "souni-token",
    symbol: "son",
    name: "Souni",
  },
  {
    id: "south-african-tether",
    symbol: "xzar",
    name: "South African Tether",
  },
  {
    id: "southxchange-coin",
    symbol: "sxcc",
    name: "SouthXchange Coin",
  },
  {
    id: "sov",
    symbol: "sov",
    name: "SOV",
  },
  {
    id: "sovereign-coin",
    symbol: "sov",
    name: "Sovereign Coin",
  },
  {
    id: "sovi-token",
    symbol: "sovi",
    name: "Sovi",
  },
  {
    id: "sovranocoin",
    symbol: "svr",
    name: "SovranoCoin",
  },
  {
    id: "sovryn",
    symbol: "sov",
    name: "Sovryn",
  },
  {
    id: "soxycoin",
    symbol: "soxy",
    name: "SOXYCOIN",
  },
  {
    id: "soy-finance",
    symbol: "soy",
    name: "Soy Finance",
  },
  {
    id: "space",
    symbol: "space",
    name: "Space",
  },
  {
    id: "spacechain-erc-20",
    symbol: "spc",
    name: "SpaceChain (ERC-20)",
  },
  {
    id: "spacecoin",
    symbol: "space",
    name: "Spacecoin",
  },
  {
    id: "spacecorgi",
    symbol: "scorgi",
    name: "SpaceCorgi",
  },
  {
    id: "space-corsair-key",
    symbol: "sck",
    name: "Space Corsair Key",
  },
  {
    id: "spacecowboy",
    symbol: "scb",
    name: "SpaceCowBoy",
  },
  {
    id: "spacecrypto",
    symbol: "spg",
    name: "SpaceCrypto",
  },
  {
    id: "space-crypto",
    symbol: "spg",
    name: "Space Crypto",
  },
  {
    id: "spacedawgs",
    symbol: "dawgs",
    name: "SpaceDawgs",
  },
  {
    id: "space-dog",
    symbol: "space dog",
    name: "Space dog",
  },
  {
    id: "spacefalcon",
    symbol: "fcon",
    name: "SpaceFalcon",
  },
  {
    id: "spacefi",
    symbol: "star",
    name: "SpaceFi",
  },
  {
    id: "space-game-klaye",
    symbol: "$klaye",
    name: "Space Game KLAYE",
  },
  {
    id: "space-game-ores",
    symbol: "$ores",
    name: "Space Game ORES",
  },
  {
    id: "spacegoat-token",
    symbol: "sgt",
    name: "SpaceGoat",
  },
  {
    id: "spacegrime",
    symbol: "grimex",
    name: "SpaceGrime",
  },
  {
    id: "space-hamster",
    symbol: "hams",
    name: "Space Hamster",
  },
  {
    id: "space-iz",
    symbol: "spiz",
    name: "SPACE-iZ",
  },
  {
    id: "spacelens",
    symbol: "space",
    name: "Spacelens",
  },
  {
    id: "space-link",
    symbol: "splink",
    name: "Space Link",
  },
  {
    id: "spacemeta",
    symbol: "spmeta",
    name: "SpaceMeta",
  },
  {
    id: "spacemine",
    symbol: "mine",
    name: "SpaceMine",
  },
  {
    id: "space-misfits",
    symbol: "smcw",
    name: "Space Misfits",
  },
  {
    id: "space-monkey-token",
    symbol: "monke",
    name: "Space Monkey MONKE",
  },
  {
    id: "space-ore",
    symbol: "spo",
    name: "Space Ore",
  },
  {
    id: "spacepi",
    symbol: "spacepi",
    name: "SpacePi",
  },
  {
    id: "spaceport-universe",
    symbol: "spu",
    name: "SpacePort Universe",
  },
  {
    id: "spaceship-war",
    symbol: "spw",
    name: "Spaceship War",
  },
  {
    id: "space-sip",
    symbol: "sip",
    name: "Space SIP",
  },
  {
    id: "space-soldier",
    symbol: "soldier",
    name: "Space Soldier",
  },
  {
    id: "spaceswap-milk2",
    symbol: "milk2",
    name: "Spaceswap MILK2",
  },
  {
    id: "spaceswap-shake",
    symbol: "shake",
    name: "Spaceswap SHAKE",
  },
  {
    id: "spacetoast",
    symbol: "spacetoast",
    name: "SpaceToast",
  },
  {
    id: "space-token",
    symbol: "space",
    name: "ApeRocket Space",
  },
  {
    id: "space-token-bsc",
    symbol: "space",
    name: "Space Token BSC",
  },
  {
    id: "spacevikings",
    symbol: "svt",
    name: "SpaceVikings",
  },
  {
    id: "spacexlife",
    symbol: "safe",
    name: "SpaceXliFe",
  },
  {
    id: "spacey-2025",
    symbol: "spay",
    name: "SpaceY 2025",
  },
  {
    id: "spain-national-fan-token",
    symbol: "snft",
    name: "Spain National Fan Token",
  },
  {
    id: "spankchain",
    symbol: "spank",
    name: "SpankChain",
  },
  {
    id: "spantale",
    symbol: "ael",
    name: "Spantale",
  },
  {
    id: "spark-finance",
    symbol: "spark",
    name: "Spark Finance",
  },
  {
    id: "sparklab",
    symbol: "spark",
    name: "SparkLab",
  },
  {
    id: "sparkle",
    symbol: "sprkl",
    name: "Sparkle Loyalty",
  },
  {
    id: "sparkle-coin",
    symbol: "sctk",
    name: "Sparkle Coin",
  },
  {
    id: "sparkpoint",
    symbol: "srk",
    name: "SparkPoint",
  },
  {
    id: "sparkpoint-fuel",
    symbol: "sfuel",
    name: "SparkPoint Fuel",
  },
  {
    id: "sparks",
    symbol: "spk",
    name: "SparksPay",
  },
  {
    id: "sparta",
    symbol: "spar",
    name: "Sparta",
  },
  {
    id: "spartacus",
    symbol: "spa",
    name: "Spartacus",
  },
  {
    id: "spartan",
    symbol: "300",
    name: "Spartan",
  },
  {
    id: "spartancoin",
    symbol: "spn",
    name: "SpartanCoin",
  },
  {
    id: "spartan-index",
    symbol: "spi",
    name: "Spartan Index",
  },
  {
    id: "spartan-protocol-token",
    symbol: "sparta",
    name: "Spartan Protocol",
  },
  {
    id: "spartan-token",
    symbol: "spa",
    name: "Spartans",
  },
  {
    id: "spd-game",
    symbol: "spdc",
    name: "SPD Game",
  },
  {
    id: "spdr-s-p-500-etf-trust-defichain",
    symbol: "dspy",
    name: "SPDR S&P 500 ETF Trust Defichain",
  },
  {
    id: "spear-finance",
    symbol: "spear",
    name: "Spear Finance",
  },
  {
    id: "specter-finance",
    symbol: "specter",
    name: "Specter Finance",
  },
  {
    id: "specter-share",
    symbol: "sshare",
    name: "Specter Share",
  },
  {
    id: "spectra",
    symbol: "spc",
    name: "Spectra",
  },
  {
    id: "spectrecoin",
    symbol: "alias",
    name: "Alias",
  },
  {
    id: "spectre-dividend-token",
    symbol: "sxdt",
    name: "Spectre.ai Dividend",
  },
  {
    id: "spectresecuritycoin",
    symbol: "xspc",
    name: "SpectreSecurityCoin",
  },
  {
    id: "spectre-utility-token",
    symbol: "sxut",
    name: "Spectre.ai Utility",
  },
  {
    id: "spectrum",
    symbol: "spt",
    name: "SPECTRUM",
  },
  {
    id: "spectrum-token",
    symbol: "spec",
    name: "Spectrum Protocol",
  },
  {
    id: "speedcash",
    symbol: "scs",
    name: "Speedcash",
  },
  {
    id: "speed-coin",
    symbol: "speed",
    name: "Speed Coin",
  },
  {
    id: "speed-mining-service",
    symbol: "sms",
    name: "Speed Mining Service",
  },
  {
    id: "speed-star-joc",
    symbol: "joc",
    name: "Speed Star JOC",
  },
  {
    id: "speed-star-speed",
    symbol: "speed",
    name: "Speed Star SPEED",
  },
  {
    id: "speed-star-star",
    symbol: "star",
    name: "Speed Star STAR",
  },
  {
    id: "spellfire",
    symbol: "spellfire",
    name: "Spellfire",
  },
  {
    id: "spellprinter",
    symbol: "spellp",
    name: "SpellPrinter",
  },
  {
    id: "spell-token",
    symbol: "spell",
    name: "Spell",
  },
  {
    id: "spell-token-wormhole",
    symbol: "spell",
    name: "Spell Token (Wormhole)",
  },
  {
    id: "spendcoin",
    symbol: "spnd",
    name: "Spendcoin",
  },
  {
    id: "spender-x",
    symbol: "spdx",
    name: "SPENDER-X",
  },
  {
    id: "sperax",
    symbol: "spa",
    name: "Sperax",
  },
  {
    id: "sperax-usd",
    symbol: "usds",
    name: "Sperax USD",
  },
  {
    id: "sphere",
    symbol: "sphr",
    name: "Sphere",
  },
  {
    id: "sphere-finance",
    symbol: "sphere",
    name: "Sphere Finance",
  },
  {
    id: "sphere-social",
    symbol: "sat",
    name: "Social Activity",
  },
  {
    id: "spherium",
    symbol: "sphri",
    name: "Spherium",
  },
  {
    id: "spheroid-universe",
    symbol: "sph",
    name: "Spheroid Universe",
  },
  {
    id: "sphinxel",
    symbol: "spx",
    name: "Sphinxel",
  },
  {
    id: "sphynx",
    symbol: "sphynx",
    name: "Sphynx",
  },
  {
    id: "sphynx-eth",
    symbol: "sphynx",
    name: "Sphynx ETH",
  },
  {
    id: "sphynx-labs",
    symbol: "sphynx",
    name: "Sphynx Labs",
  },
  {
    id: "sphynx-network",
    symbol: "sph",
    name: "Sphynx Network",
  },
  {
    id: "spice",
    symbol: "spice",
    name: "Spice Token",
  },
  {
    id: "spice-dao",
    symbol: "spice",
    name: "Spice DAO",
  },
  {
    id: "spice-finance",
    symbol: "spice",
    name: "SPICE",
  },
  {
    id: "spice-trade",
    symbol: "spice",
    name: "Spice Trade",
  },
  {
    id: "spiceusd",
    symbol: "usds",
    name: "SpiceUSD",
  },
  {
    id: "spiderdao",
    symbol: "spdr",
    name: "SpiderDAO",
  },
  {
    id: "spideyfloki",
    symbol: "spideyxmas",
    name: "SpideyFloki",
  },
  {
    id: "spinada-cash",
    symbol: "spin",
    name: "Spinada Cash",
  },
  {
    id: "spindle",
    symbol: "spd",
    name: "SPINDLE",
  },
  {
    id: "spintop",
    symbol: "spin",
    name: "Spintop",
  },
  {
    id: "spiral",
    symbol: "spr",
    name: "Spiral",
  },
  {
    id: "spiritdao-ghost",
    symbol: "ghost",
    name: "SpiritDAO Ghost",
  },
  {
    id: "spiritswap",
    symbol: "spirit",
    name: "SpiritSwap",
  },
  {
    id: "splash",
    symbol: "spl",
    name: "Splash",
  },
  {
    id: "splat",
    symbol: "splat",
    name: "SPLAT",
  },
  {
    id: "splinterlands",
    symbol: "sps",
    name: "Splinterlands",
  },
  {
    id: "splyt",
    symbol: "shopx",
    name: "SHOPX",
  },
  {
    id: "spongebob-square",
    symbol: "spongs",
    name: "SpongeBob Square",
  },
  {
    id: "sponsee",
    symbol: "spon",
    name: "Sponsee",
  },
  {
    id: "spookeletons-token",
    symbol: "spkl",
    name: "Spookeletons",
  },
  {
    id: "spooky10000",
    symbol: "spk10k",
    name: "Spooky10000",
  },
  {
    id: "spookyshiba",
    symbol: "spookyshiba",
    name: "SpookyShiba",
  },
  {
    id: "spookyswap",
    symbol: "boo",
    name: "Spookyswap",
  },
  {
    id: "spool-dao-token",
    symbol: "spool",
    name: "Spool DAO",
  },
  {
    id: "spore",
    symbol: "spore",
    name: "Spore",
  },
  {
    id: "spores-network",
    symbol: "spo",
    name: "Spores Network",
  },
  {
    id: "sporkdao",
    symbol: "spork",
    name: "SporkDAO",
  },
  {
    id: "sport",
    symbol: "sport",
    name: "SPORT",
  },
  {
    id: "sport-and-leisure",
    symbol: "snl",
    name: "Sport and Leisure",
  },
  {
    id: "sportemon-go-x",
    symbol: "sgox",
    name: "Sportemon-Go X",
  },
  {
    id: "sport-investing",
    symbol: "sitx",
    name: "Sport Investing",
  },
  {
    id: "sportium",
    symbol: "sprt",
    name: "Sportium",
  },
  {
    id: "sportoken",
    symbol: "spt",
    name: "Sportoken",
  },
  {
    id: "sports-2k75",
    symbol: "s2k",
    name: "Sports 2K75",
  },
  {
    id: "sports-bet",
    symbol: "sbet",
    name: "Sports Bet",
  },
  {
    id: "sportsicon",
    symbol: "$icons",
    name: "SportsIcon",
  },
  {
    id: "sportzchain",
    symbol: "spn",
    name: "Sportzchain",
  },
  {
    id: "spots",
    symbol: "spt",
    name: "Spots",
  },
  {
    id: "spring",
    symbol: "spring",
    name: "Spring",
  },
  {
    id: "sprink",
    symbol: "sprink",
    name: "Sprink",
  },
  {
    id: "sprint-coin",
    symbol: "sprx",
    name: "Sprint Coin",
  },
  {
    id: "spritzmoon-crypto",
    symbol: "spritzmoon",
    name: "SpritzMoon Crypto",
  },
  {
    id: "sprouts",
    symbol: "sprts",
    name: "Sprouts",
  },
  {
    id: "sproutsextreme",
    symbol: "spex",
    name: "SproutsExtreme",
  },
  {
    id: "spunk-vault-nftx",
    symbol: "spunk",
    name: "SPUNK Vault (NFTX)",
  },
  {
    id: "spyritcoin",
    symbol: "spyrit",
    name: "SpyritCoin",
  },
  {
    id: "sqgl-vault-nftx",
    symbol: "sqgl",
    name: "SQGL Vault (NFTX)",
  },
  {
    id: "square-token",
    symbol: "squa",
    name: "Square",
  },
  {
    id: "squawk",
    symbol: "squawk",
    name: "Squawk [OLD]",
  },
  {
    id: "squawk-2",
    symbol: "squawk",
    name: "Squawk",
  },
  {
    id: "squeeze-token",
    symbol: "squeeze",
    name: "Squeeze",
  },
  {
    id: "squid",
    symbol: "squid",
    name: "SquidDao",
  },
  {
    id: "squid-2",
    symbol: "squid",
    name: "SQUID Finance",
  },
  {
    id: "squid-game",
    symbol: "squid",
    name: "Squid Game",
  },
  {
    id: "squid-inu",
    symbol: "squid",
    name: "Squid Inu",
  },
  {
    id: "squid-moon",
    symbol: "sqm",
    name: "Squid Moon",
  },
  {
    id: "squidverse3d",
    symbol: "svg",
    name: "SquidVerse3D",
  },
  {
    id: "squirrel-finance",
    symbol: "nuts",
    name: "Squirrel Finance",
  },
  {
    id: "squirt-game",
    symbol: "squirt",
    name: "Squirt Game",
  },
  {
    id: "squishiverse",
    symbol: "slime",
    name: "SquishiVerse",
  },
  {
    id: "squoge-coin",
    symbol: "sqc",
    name: "Squoge Coin",
  },
  {
    id: "srcoin",
    symbol: "srh",
    name: "SRH",
  },
  {
    id: "sriracha-inu",
    symbol: "sriracha",
    name: "Sriracha Inu",
  },
  {
    id: "srnartgallery",
    symbol: "sact",
    name: "srnArtGallery",
  },
  {
    id: "srnartgallery-tokenized-arts",
    symbol: "sista",
    name: "srnArtGallery Tokenized Arts",
  },
  {
    id: "srune",
    symbol: "srune",
    name: "sRUNE",
  },
  {
    id: "ssv-network",
    symbol: "ssv",
    name: "SSV Network",
  },
  {
    id: "stabilize",
    symbol: "stbz",
    name: "Stabilize",
  },
  {
    id: "stabilize-bsc",
    symbol: "stbb",
    name: "Stabilize BSC",
  },
  {
    id: "stabilize-token",
    symbol: "set",
    name: "Stabilize SET",
  },
  {
    id: "stabilize-usd",
    symbol: "susd",
    name: "Stabilize USD",
  },
  {
    id: "stable-asset",
    symbol: "sta",
    name: "STABLE ASSET",
  },
  {
    id: "stable-btc",
    symbol: "onebtc",
    name: "Stable BTC",
  },
  {
    id: "stabledoc-token",
    symbol: "sdt",
    name: "Stabledoc",
  },
  {
    id: "stable-fox",
    symbol: "onefox",
    name: "Stable FOX",
  },
  {
    id: "stable-uni",
    symbol: "oneuni",
    name: "Stable UNI",
  },
  {
    id: "stableusd",
    symbol: "usds",
    name: "Stably USD",
  },
  {
    id: "stacker-ventures",
    symbol: "stack",
    name: "Stacker Ventures",
  },
  {
    id: "stackos",
    symbol: "stack",
    name: "StackOS",
  },
  {
    id: "stacktical",
    symbol: "dsla",
    name: "DSLA Protocol",
  },
  {
    id: "stack-treasury",
    symbol: "stackt",
    name: "Stack Treasury",
  },
  {
    id: "stacy",
    symbol: "stacy",
    name: "Stacy",
  },
  {
    id: "stader",
    symbol: "sd",
    name: "Stader",
  },
  {
    id: "stader-lunax",
    symbol: "lunax",
    name: "Stader LunaX",
  },
  {
    id: "stader-maticx",
    symbol: "maticx",
    name: "Stader MaticX",
  },
  {
    id: "stadium",
    symbol: "std",
    name: "Stadium",
  },
  {
    id: "stadium-ape",
    symbol: "sape",
    name: "Stadium Ape",
  },
  {
    id: "stadium-pepe",
    symbol: "spep",
    name: "Stadium Pepe",
  },
  {
    id: "stafi",
    symbol: "fis",
    name: "Stafi",
  },
  {
    id: "stafi-ratom",
    symbol: "ratom",
    name: "StaFi rATOM",
  },
  {
    id: "stakd-token",
    symbol: "stkd",
    name: "Stakd",
  },
  {
    id: "stakeborg-dao",
    symbol: "standard",
    name: "Stakeborg DAO",
  },
  {
    id: "stakecube",
    symbol: "scc",
    name: "Stakecube",
  },
  {
    id: "staked-aave-balancer-pool-token",
    symbol: "stkabpt",
    name: "Staked Aave Balancer Pool Token",
  },
  {
    id: "stake-dao",
    symbol: "sdt",
    name: "Stake DAO",
  },
  {
    id: "staked-ether",
    symbol: "steth",
    name: "Lido Staked Ether",
  },
  {
    id: "staked-eth-harbour",
    symbol: "seth-h",
    name: "Staked ETH Harbour",
  },
  {
    id: "staked-exodia",
    symbol: "sexod",
    name: "Staked Exodia",
  },
  {
    id: "staked-icx",
    symbol: "sicx",
    name: "Staked ICX",
  },
  {
    id: "staked-klima",
    symbol: "sklima",
    name: "Staked Klima",
  },
  {
    id: "staked_kuji",
    symbol: "skuji",
    name: "Staked Kuji",
  },
  {
    id: "staked-luna",
    symbol: "stluna",
    name: "Staked Luna",
  },
  {
    id: "staked-near",
    symbol: "stnear",
    name: "Staked NEAR",
  },
  {
    id: "staked-note",
    symbol: "snote",
    name: "Staked Note",
  },
  {
    id: "staked-olympus-v1",
    symbol: "sohm",
    name: "Staked Olympus v1",
  },
  {
    id: "staked-tarot",
    symbol: "xtarot",
    name: "Staked TAROT",
  },
  {
    id: "stakedthorus",
    symbol: "stho",
    name: "StakedThorus",
  },
  {
    id: "staked-yeti",
    symbol: "syeti",
    name: "Staked YETI",
  },
  {
    id: "stakehound",
    symbol: "stfiro",
    name: "StakedFIRO",
  },
  {
    id: "stakehound-staked-ether",
    symbol: "steth",
    name: "StakeHound Staked Ether",
  },
  {
    id: "stakemoon",
    symbol: "smoon",
    name: "Stakemoon",
  },
  {
    id: "stakenet",
    symbol: "xsn",
    name: "Stakenet",
  },
  {
    id: "staker",
    symbol: "str",
    name: "Staker",
  },
  {
    id: "staker-dao",
    symbol: "stkr",
    name: "Staker DAO",
  },
  {
    id: "stakewise",
    symbol: "swise",
    name: "StakeWise",
  },
  {
    id: "stakewise-staked-gno",
    symbol: "sgno",
    name: "StakeWise Staked GNO",
  },
  {
    id: "stakholders",
    symbol: "sh",
    name: "StakHolders",
  },
  {
    id: "stamen-tellus-token",
    symbol: "stt",
    name: "Stamen Tellus",
  },
  {
    id: "standard-protocol",
    symbol: "stnd",
    name: "Standard Protocol",
  },
  {
    id: "stand-cash",
    symbol: "sac",
    name: "Stand Cash",
  },
  {
    id: "stand-share",
    symbol: "sas",
    name: "Stand Share",
  },
  {
    id: "star-atlas",
    symbol: "atlas",
    name: "Star Atlas",
  },
  {
    id: "star-atlas-dao",
    symbol: "polis",
    name: "Star Atlas DAO",
  },
  {
    id: "star-atlas-wormhole",
    symbol: "atlas",
    name: "Star Atlas (Wormhole)",
  },
  {
    id: "starbase",
    symbol: "star",
    name: "Starbase",
  },
  {
    id: "starbase-huobi",
    symbol: "se",
    name: "Starbase Huobi",
  },
  {
    id: "starbaseuniverse",
    symbol: "suni",
    name: "StarbaseUniverse",
  },
  {
    id: "starbots",
    symbol: "bot",
    name: "Starbots",
  },
  {
    id: "starchain",
    symbol: "stc",
    name: "StarChain",
  },
  {
    id: "star-chain",
    symbol: "star",
    name: "Star Chain",
  },
  {
    id: "starchaindoge",
    symbol: "starchaindoge",
    name: "StarChainDoge",
  },
  {
    id: "starchi",
    symbol: "elixir",
    name: "Starchi",
  },
  {
    id: "starcoin",
    symbol: "stc",
    name: "Starcoin",
  },
  {
    id: "stargate-finance",
    symbol: "stg",
    name: "Stargate Finance",
  },
  {
    id: "stargaze",
    symbol: "stars",
    name: "Stargaze",
  },
  {
    id: "stargazer-protocol",
    symbol: "stardust",
    name: "Stargazer Protocol",
  },
  {
    id: "starkmeta",
    symbol: "smeta",
    name: "StarkMeta",
  },
  {
    id: "starlaunch",
    symbol: "stars",
    name: "StarLaunch",
  },
  {
    id: "starlay-finance",
    symbol: "lay",
    name: "Starlay Finance",
  },
  {
    id: "starlink",
    symbol: "starl",
    name: "StarLink",
  },
  {
    id: "starly",
    symbol: "starly",
    name: "Starly",
  },
  {
    id: "starmon-token",
    symbol: "smon",
    name: "StarMon",
  },
  {
    id: "starname",
    symbol: "iov",
    name: "Starname",
  },
  {
    id: "starnodes",
    symbol: "strz",
    name: "Starnodes",
  },
  {
    id: "starpad",
    symbol: "srp",
    name: "Starpad",
  },
  {
    id: "starplay",
    symbol: "stpc",
    name: "StarPlay",
  },
  {
    id: "starsharks",
    symbol: "sss",
    name: "StarSharks",
  },
  {
    id: "starsharks-sea",
    symbol: "sea",
    name: "StarSharks SEA",
  },
  {
    id: "star-shib",
    symbol: "starsb",
    name: "Star Shib",
  },
  {
    id: "starship",
    symbol: "starship",
    name: "StarShip",
  },
  {
    id: "star-ship-royal",
    symbol: "ssr",
    name: "Star Ship Royal",
  },
  {
    id: "starship-token",
    symbol: "stars",
    name: "StarShip Stars",
  },
  {
    id: "starstream",
    symbol: "stars",
    name: "Starstream",
  },
  {
    id: "startfi",
    symbol: "stfi",
    name: "StartFi",
  },
  {
    id: "start-vesting",
    symbol: "vest",
    name: "START Vesting",
  },
  {
    id: "star-wars-cat",
    symbol: "swcat",
    name: "Star Wars Cat",
  },
  {
    id: "starwire",
    symbol: "str",
    name: "Starwire",
  },
  {
    id: "starworks-global-ecosystem",
    symbol: "starx",
    name: "STARX",
  },
  {
    id: "stasis-eurs",
    symbol: "eurs",
    name: "STASIS EURO",
  },
  {
    id: "stater",
    symbol: "str",
    name: "Stater",
  },
  {
    id: "statera",
    symbol: "sta",
    name: "Statera",
  },
  {
    id: "statik",
    symbol: "statik",
    name: "Statik",
  },
  {
    id: "status",
    symbol: "snt",
    name: "Status",
  },
  {
    id: "stax-protocol",
    symbol: "stax",
    name: "Stax Protocol",
  },
  {
    id: "stay",
    symbol: "stay",
    name: "STAY",
  },
  {
    id: "stay-in-destiny-world",
    symbol: "siw",
    name: "Stay In Destiny World",
  },
  {
    id: "staysafu",
    symbol: "safu",
    name: "StaySAFU",
  },
  {
    id: "steakbank-finance",
    symbol: "sbf",
    name: "SteakBank Finance",
  },
  {
    id: "steakhut-finance",
    symbol: "steak",
    name: "SteakHut Finance",
  },
  {
    id: "steaks-finance",
    symbol: "steak",
    name: "Steaks Finance",
  },
  {
    id: "steak-token",
    symbol: "steak",
    name: "Steak",
  },
  {
    id: "stealthcoin",
    symbol: "xst",
    name: "Stealth",
  },
  {
    id: "steam-exchange",
    symbol: "steamx",
    name: "Steam Exchange",
  },
  {
    id: "steel",
    symbol: "steel",
    name: "Steel",
  },
  {
    id: "steem",
    symbol: "steem",
    name: "Steem",
  },
  {
    id: "steem-dollars",
    symbol: "sbd",
    name: "Steem Dollars",
  },
  {
    id: "stellar",
    symbol: "xlm",
    name: "Stellar",
  },
  {
    id: "stellar-diamond",
    symbol: "xld",
    name: "Stellar Diamond",
  },
  {
    id: "stellarinu",
    symbol: "stellarinu",
    name: "StellarInu",
  },
  {
    id: "stellar-invictus",
    symbol: "tryon",
    name: "Stellar Invictus",
  },
  {
    id: "stellarpayglobal",
    symbol: "xlpg",
    name: "StellarPayGlobal",
  },
  {
    id: "stellaswap",
    symbol: "stella",
    name: "StellaSwap",
  },
  {
    id: "stellite",
    symbol: "xla",
    name: "Scala",
  },
  {
    id: "stemx",
    symbol: "stemx",
    name: "STEMX",
  },
  {
    id: "step",
    symbol: "step",
    name: "Step",
  },
  {
    id: "step-app-fitfi",
    symbol: "fitfi",
    name: "Step App",
  },
  {
    id: "step-c",
    symbol: "stc",
    name: "Step C",
  },
  {
    id: "step-finance",
    symbol: "step",
    name: "Step Finance",
  },
  {
    id: "stepg",
    symbol: "stepg",
    name: "STEPG",
  },
  {
    id: "step-hero",
    symbol: "hero",
    name: "Step Hero",
  },
  {
    id: "step-hero-soul",
    symbol: "step",
    name: "Step Hero Soul",
  },
  {
    id: "stepn",
    symbol: "gmt",
    name: "STEPN",
  },
  {
    id: "stib-token",
    symbol: "sti",
    name: "StiB",
  },
  {
    id: "stickman-battleground",
    symbol: "stman",
    name: "Stickman Battleground",
  },
  {
    id: "stilton-musk",
    symbol: "stilton",
    name: "Stilton Musk",
  },
  {
    id: "stimmy",
    symbol: "stimmy",
    name: "$STIMMY",
  },
  {
    id: "sting",
    symbol: "stn",
    name: "Sting",
  },
  {
    id: "stingdefi",
    symbol: "sdfi",
    name: "StingDefi",
  },
  {
    id: "stipend",
    symbol: "spd",
    name: "Stipend",
  },
  {
    id: "stkd-scrt",
    symbol: "stkd",
    name: "Stkd SCRT",
  },
  {
    id: "stobox-token",
    symbol: "stbu",
    name: "Stobox",
  },
  {
    id: "ston",
    symbol: "ston",
    name: "Ston",
  },
  {
    id: "stoneage-nft",
    symbol: "ges",
    name: "Stoneage NFT",
  },
  {
    id: "stoned-ape-crew-index",
    symbol: "sac",
    name: "Stoned Ape Crew Index",
  },
  {
    id: "stoned-shiba",
    symbol: "stoned",
    name: "Stoned Shiba",
  },
  {
    id: "stone-token",
    symbol: "stn",
    name: "Stone",
  },
  {
    id: "stonk",
    symbol: "stonk",
    name: "Stonk Swap",
  },
  {
    id: "stonk-2",
    symbol: "stonk",
    name: "Stonk",
  },
  {
    id: "stonk-league",
    symbol: "a",
    name: "Stonk League Aegis",
  },
  {
    id: "stopelon",
    symbol: "stopelon",
    name: "StopElon",
  },
  {
    id: "storage-area-network-anywhere",
    symbol: "sana",
    name: "Storage Area Network Anywhere",
  },
  {
    id: "storichain-token",
    symbol: "tori",
    name: "Storichain",
  },
  {
    id: "storiqa",
    symbol: "stq",
    name: "Storiqa",
  },
  {
    id: "storj",
    symbol: "storj",
    name: "Storj",
  },
  {
    id: "storks-token",
    symbol: "storks",
    name: "Storks",
  },
  {
    id: "storm",
    symbol: "stmx",
    name: "StormX",
  },
  {
    id: "storm-bringer-token",
    symbol: "stb",
    name: "Storm Bringer",
  },
  {
    id: "storm-token",
    symbol: "storm",
    name: "Storm",
  },
  {
    id: "storx",
    symbol: "srx",
    name: "StorX",
  },
  {
    id: "story",
    symbol: "story",
    name: "Story",
  },
  {
    id: "stox",
    symbol: "stx",
    name: "Stox",
  },
  {
    id: "stp-network",
    symbol: "stpt",
    name: "STP Network",
  },
  {
    id: "strains",
    symbol: "sfn",
    name: "Strains",
  },
  {
    id: "straitsx-indonesia-rupiah",
    symbol: "xidr",
    name: "XIDR",
  },
  {
    id: "stratis",
    symbol: "strax",
    name: "Stratis",
  },
  {
    id: "stratos",
    symbol: "stos",
    name: "Stratos",
  },
  {
    id: "strayacoin",
    symbol: "nah",
    name: "Strayacoin",
  },
  {
    id: "strayinu",
    symbol: "strayinu",
    name: "StrayInu",
  },
  {
    id: "streamcoin",
    symbol: "strm",
    name: "StreamCoin",
  },
  {
    id: "stream-protocol",
    symbol: "stpl",
    name: "Stream Protocol",
  },
  {
    id: "streamr",
    symbol: "data",
    name: "Streamr",
  },
  {
    id: "streamr-xdata",
    symbol: "xdata",
    name: "Streamr XDATA",
  },
  {
    id: "stream-smart-business",
    symbol: "$ssb",
    name: "Stream Smart Business",
  },
  {
    id: "streeth",
    symbol: "streeth",
    name: "STREETH",
  },
  {
    id: "street-runner",
    symbol: "srg",
    name: "Street Runner",
  },
  {
    id: "stretch-to-earn",
    symbol: "ste",
    name: "Stretch To Earn",
  },
  {
    id: "strike",
    symbol: "strk",
    name: "Strike",
  },
  {
    id: "strikecoin",
    symbol: "strx",
    name: "StrikeX",
  },
  {
    id: "stripcoin",
    symbol: "strip",
    name: "StripCoin",
  },
  {
    id: "strip-finance",
    symbol: "strip",
    name: "Strip Finance",
  },
  {
    id: "strips-finance",
    symbol: "strp",
    name: "Strips Finance",
  },
  {
    id: "stripto",
    symbol: "strip",
    name: "Stripto",
  },
  {
    id: "strite",
    symbol: "stri",
    name: "Strite",
  },
  {
    id: "strong",
    symbol: "strong",
    name: "Strong",
  },
  {
    id: "strong-bull",
    symbol: "bull",
    name: "Strong Bull",
  },
  {
    id: "stronger",
    symbol: "strngr",
    name: "Stronger",
  },
  {
    id: "stronghands",
    symbol: "shnd",
    name: "StrongHands",
  },
  {
    id: "stronghands-finance",
    symbol: "ishnd",
    name: "StrongHands Finance",
  },
  {
    id: "stronghands-masternode",
    symbol: "shmn",
    name: "StrongHands Masternode",
  },
  {
    id: "stronghold-token",
    symbol: "shx",
    name: "Stronghold",
  },
  {
    id: "strongnode",
    symbol: "sne",
    name: "StrongNode",
  },
  {
    id: "structure-finance",
    symbol: "stf",
    name: "Structure Finance",
  },
  {
    id: "strudel-finance",
    symbol: "trdl",
    name: "Strudel Finance",
  },
  {
    id: "student-coin",
    symbol: "stc",
    name: "Student Coin",
  },
  {
    id: "studyum",
    symbol: "stud",
    name: "Studyum",
  },
  {
    id: "subgame",
    symbol: "sgb",
    name: "SubGame",
  },
  {
    id: "subme",
    symbol: "sub",
    name: "Subme",
  },
  {
    id: "subquery-network",
    symbol: "sqt",
    name: "SubQuery Network",
  },
  {
    id: "substratum",
    symbol: "sub",
    name: "Substratum",
  },
  {
    id: "subx-finance",
    symbol: "sfx",
    name: "SUBX FINANCE LAB",
  },
  {
    id: "success-inu",
    symbol: "success",
    name: "SUCCESS INU",
  },
  {
    id: "succession",
    symbol: "sccn",
    name: "Succession",
  },
  {
    id: "such-shiba",
    symbol: "such",
    name: "Such Shiba",
  },
  {
    id: "sucrecoin",
    symbol: "xsr",
    name: "Sucrecoin",
  },
  {
    id: "sugarbounce",
    symbol: "tip",
    name: "SugarBounce",
  },
  {
    id: "sugarchain",
    symbol: "sugar",
    name: "Sugarchain",
  },
  {
    id: "sugar-kingdom",
    symbol: "candy",
    name: "Sugar Kingdom",
  },
  {
    id: "sukhavati-network",
    symbol: "skt",
    name: "Sukhavati Network",
  },
  {
    id: "suku",
    symbol: "suku",
    name: "SUKU",
  },
  {
    id: "sumcoin",
    symbol: "sum",
    name: "Sumcoin",
  },
  {
    id: "summer",
    symbol: "summer",
    name: "Summer",
  },
  {
    id: "summit-defi",
    symbol: "summit",
    name: "Summit DeFi [OLD]",
  },
  {
    id: "summit-defi-2",
    symbol: "summit",
    name: "Summit DeFi",
  },
  {
    id: "summoner",
    symbol: "sut",
    name: "Summoner",
  },
  {
    id: "sumokoin",
    symbol: "sumo",
    name: "Sumokoin",
  },
  {
    id: "sumswap",
    symbol: "sum",
    name: "SumSwap",
  },
  {
    id: "sun",
    symbol: "sun",
    name: "SUN",
  },
  {
    id: "suncontract",
    symbol: "snc",
    name: "SunContract",
  },
  {
    id: "sundaeswap",
    symbol: "sundae",
    name: "SundaeSwap",
  },
  {
    id: "sunder-goverance-token",
    symbol: "sunder",
    name: "Sunder Goverance",
  },
  {
    id: "sunflower-finance",
    symbol: "sfo",
    name: "Sunflower Finance",
  },
  {
    id: "sunflower-land",
    symbol: "sfl",
    name: "Sunflower Land",
  },
  {
    id: "sunny-aggregator",
    symbol: "sunny",
    name: "Sunny Aggregator",
  },
  {
    id: "sunnysideup",
    symbol: "ssu",
    name: "SunnySideUp",
  },
  {
    id: "sunrise",
    symbol: "sunc",
    name: "Sunrise",
  },
  {
    id: "sunshield",
    symbol: "sshld",
    name: "SunShield",
  },
  {
    id: "sun-token",
    symbol: "sun",
    name: "Sun Token",
  },
  {
    id: "supa-foundation",
    symbol: "supa",
    name: "SUPA Foundation",
  },
  {
    id: "supe-infinity",
    symbol: "supe",
    name: "Supe Infinity",
  },
  {
    id: "super8",
    symbol: "s8",
    name: "Super8",
  },
  {
    id: "superalgos",
    symbol: "sa",
    name: "Superalgos",
  },
  {
    id: "superbid",
    symbol: "superbid",
    name: "SuperBid",
  },
  {
    id: "superbnb-finance",
    symbol: "spb",
    name: "SuperBNB.Finance [OLD]",
  },
  {
    id: "superbonds",
    symbol: "sb",
    name: "SuperBonds",
  },
  {
    id: "superbrain-capital-dao",
    symbol: "$sbc",
    name: "SuperBrain Capital Dao",
  },
  {
    id: "supercars",
    symbol: "car",
    name: "Supercars",
  },
  {
    id: "superciety",
    symbol: "super",
    name: "Superciety",
  },
  {
    id: "supercoin",
    symbol: "super",
    name: "SuperCoin",
  },
  {
    id: "super-coinview-token",
    symbol: "scv",
    name: "Super CoinView",
  },
  {
    id: "superdoge",
    symbol: "supdog",
    name: "SuperDoge",
  },
  {
    id: "superfarm",
    symbol: "super",
    name: "SuperFarm",
  },
  {
    id: "super-floki",
    symbol: "sloki",
    name: "Super Floki",
  },
  {
    id: "superfuel",
    symbol: "sfuel",
    name: "SuperFuel",
  },
  {
    id: "super-hero",
    symbol: "sh",
    name: "Super Hero",
  },
  {
    id: "superinu",
    symbol: "sinu",
    name: "SuperInu",
  },
  {
    id: "superlauncher-dao",
    symbol: "launch",
    name: "SuperLauncher DAO",
  },
  {
    id: "supermegahyperdoge",
    symbol: "smhdoge",
    name: "SuperMegaHyperDoge",
  },
  {
    id: "superminesweeper",
    symbol: "sm",
    name: "SuperMinesweeper",
  },
  {
    id: "supernova",
    symbol: "snt",
    name: "Supernova",
  },
  {
    id: "superplayer-world",
    symbol: "honor",
    name: "SuperPlayer World",
  },
  {
    id: "superrare",
    symbol: "rare",
    name: "SuperRare",
  },
  {
    id: "super-rare-ball-shares",
    symbol: "srbs",
    name: "Super Rare Ball Shares",
  },
  {
    id: "super-shiba",
    symbol: "$sshiba",
    name: "Super Shiba",
  },
  {
    id: "superskynet",
    symbol: "ssn",
    name: "SuperSkyNet",
  },
  {
    id: "supersonic-finance",
    symbol: "ssn",
    name: "Supersonic Finance",
  },
  {
    id: "super-three-kingdoms",
    symbol: "stk",
    name: "Super Three Kingdoms",
  },
  {
    id: "supertron",
    symbol: "stro",
    name: "Supertron",
  },
  {
    id: "supertx-governance-token",
    symbol: "sup",
    name: "SuperTx Governance",
  },
  {
    id: "super-whale-dao",
    symbol: "swdao",
    name: "Super Whale DAO",
  },
  {
    id: "super-zero",
    symbol: "sero",
    name: "SERO",
  },
  {
    id: "support-doge",
    symbol: "supd",
    name: "Support Doge",
  },
  {
    id: "supra-token",
    symbol: "supra",
    name: "Supra",
  },
  {
    id: "supremacy",
    symbol: "sups",
    name: "Supremacy",
  },
  {
    id: "supreme-finance",
    symbol: "hype",
    name: "Supreme Finance",
  },
  {
    id: "suprenft",
    symbol: "snft",
    name: "SupreNFT",
  },
  {
    id: "suqa",
    symbol: "sin",
    name: "SINOVATE",
  },
  {
    id: "sureremit",
    symbol: "rmt",
    name: "SureRemit",
  },
  {
    id: "suretly",
    symbol: "sur",
    name: "Suretly",
  },
  {
    id: "surfexutilitytoken",
    symbol: "surf",
    name: "SurfExUtilityToken",
  },
  {
    id: "surf-finance",
    symbol: "surf",
    name: "Surf.Finance",
  },
  {
    id: "surfmoon",
    symbol: "surfmoon",
    name: "SurfMoon",
  },
  {
    id: "surge-inu",
    symbol: "surge",
    name: "Surge Inu",
  },
  {
    id: "survival-game-online",
    symbol: "surv",
    name: "Survival Game Online",
  },
  {
    id: "surviving-soldiers",
    symbol: "ssg",
    name: "Surviving Soldiers",
  },
  {
    id: "survivor-finance",
    symbol: "suv",
    name: "Survivor Finance",
  },
  {
    id: "sushi",
    symbol: "sushi",
    name: "Sushi",
  },
  {
    id: "sushiba",
    symbol: "sushiba",
    name: "Sushiba",
  },
  {
    id: "sushi-wormhole",
    symbol: "sushi",
    name: "Sushi (Wormhole)",
  },
  {
    id: "sustainable-energy-token",
    symbol: "set",
    name: "Sustainable Energy",
  },
  {
    id: "suteku",
    symbol: "suteku",
    name: "Suteku",
  },
  {
    id: "suterusu",
    symbol: "suter",
    name: "Suterusu",
  },
  {
    id: "suvereno",
    symbol: "suv",
    name: "Suvereno",
  },
  {
    id: "swace",
    symbol: "swace",
    name: "Swace",
  },
  {
    id: "swagbucks",
    symbol: "bucks",
    name: "SwagBucks",
  },
  {
    id: "swag-finance",
    symbol: "swag",
    name: "SWAG Finance",
  },
  {
    id: "swag-finance-wormhole",
    symbol: "swag",
    name: "SWAG Finance (Wormhole)",
  },
  {
    id: "swak",
    symbol: "swak",
    name: "SWAK",
  },
  {
    id: "s-wallet-protocol",
    symbol: "swp",
    name: "S-Wallet Protocol",
  },
  {
    id: "swamp-coin",
    symbol: "swamp",
    name: "Swamp Coin",
  },
  {
    id: "swampy",
    symbol: "swamp",
    name: "Swampy",
  },
  {
    id: "swanlana",
    symbol: "swan",
    name: "Swanlana",
  },
  {
    id: "swap",
    symbol: "xwp",
    name: "Swap",
  },
  {
    id: "swapall",
    symbol: "sap",
    name: "SwapAll",
  },
  {
    id: "swapdex",
    symbol: "sdx",
    name: "SwapDEX",
  },
  {
    id: "swaperry",
    symbol: "perry",
    name: "Swaperry",
  },
  {
    id: "swapfolio",
    symbol: "swfl",
    name: "Swapfolio",
  },
  {
    id: "swapmatic",
    symbol: "swam",
    name: "SwapMatic",
  },
  {
    id: "swapp",
    symbol: "swapp",
    name: "SWAPP Protocol",
  },
  {
    id: "swappery-token",
    symbol: "swpr",
    name: "The Swappery",
  },
  {
    id: "swappi",
    symbol: "ppi",
    name: "Swappi",
  },
  {
    id: "swapr",
    symbol: "swpr",
    name: "Swapr",
  },
  {
    id: "swapsicle-pops",
    symbol: "pops",
    name: "Swapsicle Pops",
  },
  {
    id: "swaptracker",
    symbol: "swpt",
    name: "SwapTracker",
  },
  {
    id: "swapx",
    symbol: "xwap",
    name: "SwapX",
  },
  {
    id: "swapxi-token",
    symbol: "swapxi",
    name: "SwapXI",
  },
  {
    id: "swapz-app",
    symbol: "swapz",
    name: "SWAPZ.app",
  },
  {
    id: "swarm",
    symbol: "swm",
    name: "Swarm Network",
  },
  {
    id: "swarm-bzz",
    symbol: "bzz",
    name: "Swarm",
  },
  {
    id: "swarm-city",
    symbol: "swt",
    name: "Swarm City",
  },
  {
    id: "swarm-markets",
    symbol: "smt",
    name: "Swarm Markets",
  },
  {
    id: "swash",
    symbol: "swash",
    name: "Swash",
  },
  {
    id: "sway-social",
    symbol: "sway",
    name: "Sway Social",
  },
  {
    id: "sw-dao",
    symbol: "swd",
    name: "SW DAO",
  },
  {
    id: "sweatcoin",
    symbol: "sweat",
    name: "SweatCoin",
  },
  {
    id: "sweep-capital",
    symbol: "sweep",
    name: "Sweep Capital",
  },
  {
    id: "sweet-btc",
    symbol: "sbtc",
    name: "Sweet BTC",
  },
  {
    id: "swerve-dao",
    symbol: "swrv",
    name: "Swerve",
  },
  {
    id: "swerve-protocol",
    symbol: "swerve",
    name: "SWERVE Protocol",
  },
  {
    id: "swftcoin",
    symbol: "swftc",
    name: "SWFTCOIN",
  },
  {
    id: "swgtoken",
    symbol: "swg",
    name: "SWG",
  },
  {
    id: "swiftcash",
    symbol: "swift",
    name: "SwiftCash",
  },
  {
    id: "swiftlance-token",
    symbol: "swl",
    name: "Swiftlance",
  },
  {
    id: "swinca-2",
    symbol: "swi",
    name: "Swinca",
  },
  {
    id: "swincoin",
    symbol: "swin",
    name: "SwinCoin",
  },
  {
    id: "swing",
    symbol: "swing",
    name: "Swing",
  },
  {
    id: "swingby",
    symbol: "swingby",
    name: "Swingby",
  },
  {
    id: "swipe",
    symbol: "sxp",
    name: "SXP",
  },
  {
    id: "swipe-network",
    symbol: "swipe",
    name: "SWIPE Network",
  },
  {
    id: "swipe-wormhole",
    symbol: "sxp",
    name: "Swipe (Wormhole)",
  },
  {
    id: "swipp",
    symbol: "swipp",
    name: "Swipp",
  },
  {
    id: "swirge",
    symbol: "swgb",
    name: "Swirge",
  },
  {
    id: "swirl-cash",
    symbol: "swirl",
    name: "Swirl Cash",
  },
  {
    id: "swirltoken",
    symbol: "swirl",
    name: "Swirl",
  },
  {
    id: "swissborg",
    symbol: "chsb",
    name: "SwissBorg",
  },
  {
    id: "switch",
    symbol: "esh",
    name: "Switch",
  },
  {
    id: "switcheo",
    symbol: "swth",
    name: "Carbon Protocol",
  },
  {
    id: "swivel-governance",
    symbol: "swiv",
    name: "Swivel Governance",
  },
  {
    id: "swole-doge",
    symbol: "swole",
    name: "Swole Doge",
  },
  {
    id: "swop",
    symbol: "swop",
    name: "Swop",
  },
  {
    id: "swtcoin",
    symbol: "swat",
    name: "SWTCoin",
  },
  {
    id: "swusd",
    symbol: "swusd",
    name: "Swerve.fi USD",
  },
  {
    id: "swyft",
    symbol: "swyftt",
    name: "SWYFT",
  },
  {
    id: "sx-network",
    symbol: "sx",
    name: "SX Network",
  },
  {
    id: "sya-x-flooz",
    symbol: "sya",
    name: "SYA x Flooz",
  },
  {
    id: "sybc-coin",
    symbol: "sybc",
    name: "SYBC Coin",
  },
  {
    id: "syfin",
    symbol: "syf",
    name: "Syfin",
  },
  {
    id: "sylo",
    symbol: "sylo",
    name: "Sylo",
  },
  {
    id: "symbiosis-finance",
    symbol: "sis",
    name: "Symbiosis Finance",
  },
  {
    id: "symbol",
    symbol: "xym",
    name: "Symbol",
  },
  {
    id: "symbull",
    symbol: "symbull",
    name: "SymBULL",
  },
  {
    id: "symmetric",
    symbol: "symm",
    name: "Symmetric",
  },
  {
    id: "symverse",
    symbol: "sym",
    name: "SymVerse",
  },
  {
    id: "synapse-2",
    symbol: "syn",
    name: "Synapse",
  },
  {
    id: "synapse-network",
    symbol: "snp",
    name: "Synapse Network",
  },
  {
    id: "syncdao-governance",
    symbol: "sdg",
    name: "SyncDAO Governance",
  },
  {
    id: "synchrobitcoin",
    symbol: "snb",
    name: "SynchroBitcoin",
  },
  {
    id: "synchrolife",
    symbol: "syc",
    name: "SynchroLife",
  },
  {
    id: "synchrony",
    symbol: "scy",
    name: "Synchrony",
  },
  {
    id: "sync-network",
    symbol: "sync",
    name: "Sync Network",
  },
  {
    id: "syndicate-2",
    symbol: "synr",
    name: "MOBLAND",
  },
  {
    id: "synesis-one",
    symbol: "sns",
    name: "Synesis One",
  },
  {
    id: "synex-coin",
    symbol: "minecraft",
    name: "Synex Coin",
  },
  {
    id: "synthetic-ftt",
    symbol: "xftt",
    name: "Synthetic FTT",
  },
  {
    id: "synthetic-sol",
    symbol: "xsol",
    name: "Synthetic SOL",
  },
  {
    id: "synthetic-usd",
    symbol: "xusd",
    name: "Synthetic USD",
  },
  {
    id: "synthetic-usd-fabric",
    symbol: "fusd",
    name: "Synthetic USD (Fabric)",
  },
  {
    id: "synthetify-token",
    symbol: "sny",
    name: "Synthetify",
  },
  {
    id: "synthetix-network-token-wormhole",
    symbol: "snx",
    name: "Synthetix Network Token (Wormhole)",
  },
  {
    id: "synth-ousd",
    symbol: "ousd",
    name: "Synth oUSD",
  },
  {
    id: "sypool",
    symbol: "syp",
    name: "Sypool",
  },
  {
    id: "syrex",
    symbol: "srx",
    name: "Syrex",
  },
  {
    id: "syscoin",
    symbol: "sys",
    name: "Syscoin",
  },
  {
    id: "t99",
    symbol: "t99",
    name: "T99",
  },
  {
    id: "tabank",
    symbol: "tab",
    name: "Tabank",
  },
  {
    id: "taboo-token",
    symbol: "taboo",
    name: "Taboo",
  },
  {
    id: "tabtrader",
    symbol: "ttt",
    name: "TabTrader",
  },
  {
    id: "tacoenergy",
    symbol: "tacoe",
    name: "TacoEnergy",
  },
  {
    id: "tacos",
    symbol: "taco",
    name: "Tacos",
  },
  {
    id: "tadpole-finance",
    symbol: "tad",
    name: "Tadpole",
  },
  {
    id: "tadpole-token",
    symbol: "tad",
    name: "Frog Tadpole",
  },
  {
    id: "taf-token",
    symbol: "taf",
    name: "TAF",
  },
  {
    id: "tagbond",
    symbol: "tag",
    name: "Tagbond",
  },
  {
    id: "tagcoin",
    symbol: "tag",
    name: "Tagcoin",
  },
  {
    id: "tag-protocol",
    symbol: "tag",
    name: "Tag Protocol",
  },
  {
    id: "tagrcoin",
    symbol: "tagr",
    name: "TAGRcoin",
  },
  {
    id: "tahu",
    symbol: "tahu",
    name: "TAHU",
  },
  {
    id: "tai",
    symbol: "tai",
    name: "tBridge",
  },
  {
    id: "taiga",
    symbol: "tai",
    name: "Taiga",
  },
  {
    id: "tails",
    symbol: "tails",
    name: "Tails",
  },
  {
    id: "tajcoin",
    symbol: "taj",
    name: "TajCoin",
  },
  {
    id: "takamaka-green-coin",
    symbol: "tkg",
    name: "Takamaka Green Coin",
  },
  {
    id: "takeda-shin",
    symbol: "takeda",
    name: "Takeda Shin",
  },
  {
    id: "taki",
    symbol: "taki",
    name: "Taki",
  },
  {
    id: "taklimakan-network",
    symbol: "tan",
    name: "Taklimakan Network",
  },
  {
    id: "tako-token",
    symbol: "tako",
    name: "Tako",
  },
  {
    id: "talan",
    symbol: "talan",
    name: "Talan",
  },
  {
    id: "talaria-inu",
    symbol: "tali",
    name: "Talaria Inu",
  },
  {
    id: "talecraft",
    symbol: "craft",
    name: "TaleCraft",
  },
  {
    id: "talent",
    symbol: "tnt",
    name: "Talent",
  },
  {
    id: "talentcoin",
    symbol: "tlnt",
    name: "TalentCoin",
  },
  {
    id: "talent-coin",
    symbol: "tlnt",
    name: "Talent Coin",
  },
  {
    id: "talent-token",
    symbol: "ttx",
    name: "Talent TTX",
  },
  {
    id: "tale-of-chain",
    symbol: "tale",
    name: "Tales Of Chain",
  },
  {
    id: "taler",
    symbol: "tlr",
    name: "Taler",
  },
  {
    id: "talkado",
    symbol: "talk",
    name: "Talkado",
  },
  {
    id: "talken",
    symbol: "talk",
    name: "Talken",
  },
  {
    id: "tama-finance",
    symbol: "tama",
    name: "Tama Finance",
  },
  {
    id: "tamago",
    symbol: "tama",
    name: "Tamago",
  },
  {
    id: "tangible",
    symbol: "tngbl",
    name: "Tangible",
  },
  {
    id: "tangle",
    symbol: "tngl",
    name: "Tangle",
  },
  {
    id: "tangoswap",
    symbol: "tango",
    name: "TangoSwap",
  },
  {
    id: "tank-battle",
    symbol: "tbl",
    name: "Tank Battle",
  },
  {
    id: "tank-gold",
    symbol: "tgold",
    name: "Tank Gold",
  },
  {
    id: "tank-metaverse",
    symbol: "tnk",
    name: "Tank Metaverse",
  },
  {
    id: "tanks",
    symbol: "tanks",
    name: "Tanks",
  },
  {
    id: "tanuki-token",
    symbol: "tanuki",
    name: "Tanuki",
  },
  {
    id: "tap",
    symbol: "xtp",
    name: "Tap",
  },
  {
    id: "tap-fantasy",
    symbol: "tap",
    name: "Tap Fantasy",
  },
  {
    id: "tapioca",
    symbol: "tap",
    name: "Tapioca DAO",
  },
  {
    id: "tapme-token",
    symbol: "tap",
    name: "TAPME",
  },
  {
    id: "tapmydata",
    symbol: "tap",
    name: "TapX",
  },
  {
    id: "tarality",
    symbol: "taral",
    name: "Tarality",
  },
  {
    id: "taraxa",
    symbol: "tara",
    name: "Taraxa",
  },
  {
    id: "tardigrades-finance",
    symbol: "trdg",
    name: "Tardigrades Finance",
  },
  {
    id: "tarot",
    symbol: "tarot",
    name: "Tarot",
  },
  {
    id: "taroverse",
    symbol: "taro",
    name: "Taroverse",
  },
  {
    id: "tart",
    symbol: "tart",
    name: "Tartarus Finance",
  },
  {
    id: "tartarus",
    symbol: "tar",
    name: "Tartarus",
  },
  {
    id: "tastenft",
    symbol: "taste",
    name: "TasteNFT",
  },
  {
    id: "tattoomoney",
    symbol: "tat2",
    name: "TattooMoney",
  },
  {
    id: "taunt-battleworld",
    symbol: "",
    name: "Taunt Battleworld",
  },
  {
    id: "tavittcoin",
    symbol: "tavitt",
    name: "Tavittcoin",
  },
  {
    id: "taxa-token",
    symbol: "txt",
    name: "Taxa Network",
  },
  {
    id: "tbcc",
    symbol: "tbcc",
    name: "TBCC",
  },
  {
    id: "t-bitcoin",
    symbol: "tbtc",
    name: "τBitcoin",
  },
  {
    id: "tbtc",
    symbol: "tbtc",
    name: "tBTC",
  },
  {
    id: "tcash",
    symbol: "tcash",
    name: "TCASH",
  },
  {
    id: "tcgcoin",
    symbol: "tcgcoin",
    name: "TCGCoin",
  },
  {
    id: "tcgcoin-2-0",
    symbol: "tcg2",
    name: "TCGCoin 2.0",
  },
  {
    id: "tchalla",
    symbol: "tcha",
    name: "TCHALLA",
  },
  {
    id: "tcoin-fun",
    symbol: "tco",
    name: "Tcoin.fun",
  },
  {
    id: "tcw-token",
    symbol: "tcw",
    name: "TCW",
  },
  {
    id: "tdoge",
    symbol: "tdoge",
    name: "τDoge",
  },
  {
    id: "teal",
    symbol: "teat",
    name: "TEAL",
  },
  {
    id: "team-heretics-fan-token",
    symbol: "th",
    name: "Team Heretics Fan Token",
  },
  {
    id: "team-vitality-fan-token",
    symbol: "vit",
    name: "Team Vitality Fan Token",
  },
  {
    id: "teaswap-art",
    symbol: "tsa",
    name: "Teaswap Art",
  },
  {
    id: "tea-token",
    symbol: "tea",
    name: "Tea",
  },
  {
    id: "techcoin",
    symbol: "tlc",
    name: "Techcoin",
  },
  {
    id: "techpay",
    symbol: "tpc",
    name: "Techpay",
  },
  {
    id: "techshare-token",
    symbol: "tcl",
    name: "Techshare",
  },
  {
    id: "tecracoin",
    symbol: "tcr",
    name: "TecraCoin ERC20",
  },
  {
    id: "tectonic",
    symbol: "tonic",
    name: "Tectonic",
  },
  {
    id: "teddy",
    symbol: "teddy",
    name: "Teddy",
  },
  {
    id: "teddy-dog",
    symbol: "tdg",
    name: "Teddy Dog",
  },
  {
    id: "teddy-doge",
    symbol: "teddy",
    name: "Teddy Doge",
  },
  {
    id: "teddy-dollar",
    symbol: "tsd",
    name: "Teddy Dollar",
  },
  {
    id: "te-food",
    symbol: "tone",
    name: "TE-FOOD",
  },
  {
    id: "tekcoin",
    symbol: "tek",
    name: "TEKcoin",
  },
  {
    id: "telcoin",
    symbol: "tel",
    name: "Telcoin",
  },
  {
    id: "tellor",
    symbol: "trb",
    name: "Tellor",
  },
  {
    id: "telos",
    symbol: "tlos",
    name: "Telos",
  },
  {
    id: "telos-coin",
    symbol: "telos",
    name: "Teloscoin",
  },
  {
    id: "temco",
    symbol: "temco",
    name: "TEMCO",
  },
  {
    id: "templardao",
    symbol: "tem",
    name: "Templar DAO",
  },
  {
    id: "temple",
    symbol: "temple",
    name: "TempleDAO",
  },
  {
    id: "tempo-dao",
    symbol: "tempo",
    name: "Tempo DAO",
  },
  {
    id: "tempus",
    symbol: "temp",
    name: "Tempus",
  },
  {
    id: "temtem",
    symbol: "tem",
    name: "Temtum",
  },
  {
    id: "ten",
    symbol: "tenfi",
    name: "TEN",
  },
  {
    id: "tena",
    symbol: "tena",
    name: "TENA",
  },
  {
    id: "tendies",
    symbol: "tend",
    name: "Tendies",
  },
  {
    id: "tendieswap",
    symbol: "tendie",
    name: "TendieSwap",
  },
  {
    id: "teneo",
    symbol: "ten",
    name: "Teneo",
  },
  {
    id: "tenet",
    symbol: "ten",
    name: "Tenet",
  },
  {
    id: "tengu",
    symbol: "tengu",
    name: "Tengu",
  },
  {
    id: "tenset",
    symbol: "10set",
    name: "Tenset",
  },
  {
    id: "tenshi",
    symbol: "tenshi",
    name: "Tenshi v2",
  },
  {
    id: "tenup",
    symbol: "tup",
    name: "Tenup",
  },
  {
    id: "ten-wallet",
    symbol: "tenw",
    name: "TEN Wallet",
  },
  {
    id: "tenx",
    symbol: "pay",
    name: "TenX",
  },
  {
    id: "tenxcoin",
    symbol: "txc",
    name: "TenXCoin",
  },
  {
    id: "tepleton",
    symbol: "tep",
    name: "Tepleton",
  },
  {
    id: "terablock",
    symbol: "tbc",
    name: "TeraBlock",
  },
  {
    id: "terareum",
    symbol: "tera",
    name: "Terareum",
  },
  {
    id: "tera-smart-money",
    symbol: "tera",
    name: "TERA",
  },
  {
    id: "ternio",
    symbol: "tern",
    name: "Ternio",
  },
  {
    id: "terra-aut",
    symbol: "aut",
    name: "Terra AUT",
  },
  {
    id: "terra-cat",
    symbol: "cat",
    name: "Terra CAT",
  },
  {
    id: "terra-cht",
    symbol: "cht",
    name: "Terra CHT",
  },
  {
    id: "terra-cnt",
    symbol: "cnt",
    name: "Terra CNT",
  },
  {
    id: "terracoin",
    symbol: "trc",
    name: "Terracoin",
  },
  {
    id: "terra-dkt",
    symbol: "dkt",
    name: "Terra DKT",
  },
  {
    id: "terra-eut",
    symbol: "eut",
    name: "Terra EUT",
  },
  {
    id: "terra-gbt",
    symbol: "gbt",
    name: "Terra GBT",
  },
  {
    id: "terra-hkt",
    symbol: "hkt",
    name: "Terra HKT",
  },
  {
    id: "terra-idt",
    symbol: "idt",
    name: "Terra IDT",
  },
  {
    id: "terra-int",
    symbol: "int",
    name: "Terra INT",
  },
  {
    id: "terra-jpt",
    symbol: "jpt",
    name: "Terra JPT",
  },
  {
    id: "terra-krw",
    symbol: "krtc",
    name: "TerraClassicKRW",
  },
  {
    id: "terra-luna",
    symbol: "lunc",
    name: "Terra Luna Classic",
  },
  {
    id: "terra-luna-2",
    symbol: "luna",
    name: "Terra",
  },
  {
    id: "terramnt",
    symbol: "mnt",
    name: "Terra MNT",
  },
  {
    id: "terra-name-service",
    symbol: "tns",
    name: "Terra Name Service",
  },
  {
    id: "terran-coin",
    symbol: "trr",
    name: "Terran Coin",
  },
  {
    id: "terra-pht",
    symbol: "pht",
    name: "Terra PHT",
  },
  {
    id: "terra-sdt",
    symbol: "sdt",
    name: "Terra SDT",
  },
  {
    id: "terra-set",
    symbol: "set",
    name: "Terra SET",
  },
  {
    id: "terra-sgt",
    symbol: "sgt",
    name: "Terra SGT",
  },
  {
    id: "terra-tht",
    symbol: "tht",
    name: "Terra THT",
  },
  {
    id: "terrausd",
    symbol: "ustc",
    name: "TerraClassicUSD",
  },
  {
    id: "terrausd-wormhole",
    symbol: "ust",
    name: "TerraUSD (Wormhole)",
  },
  {
    id: "terra-virtua-kolect",
    symbol: "tvk",
    name: "Terra Virtua Kolect",
  },
  {
    id: "terra-world-token",
    symbol: "twd",
    name: "Terra World",
  },
  {
    id: "teslafan",
    symbol: "teslf",
    name: "Teslafan",
  },
  {
    id: "teslafunds",
    symbol: "tsf",
    name: "Transaction Service Fee",
  },
  {
    id: "tesla-inu",
    symbol: "tesinu",
    name: "Tesla Inu",
  },
  {
    id: "tesra",
    symbol: "tsr",
    name: "Tesra",
  },
  {
    id: "tessla-coin",
    symbol: "tsla",
    name: "Tessla Coin",
  },
  {
    id: "tether",
    symbol: "usdt",
    name: "Tether",
  },
  {
    id: "tether-avalanche-bridged-usdt-e",
    symbol: "usdt",
    name: "Tether Avalanche Bridged (USDT.e)",
  },
  {
    id: "tether-eurt",
    symbol: "eurt",
    name: "Euro Tether",
  },
  {
    id: "tether-gold",
    symbol: "xaut",
    name: "Tether Gold",
  },
  {
    id: "tetherino",
    symbol: "ttr",
    name: "Tetherino",
  },
  {
    id: "tether-usd-celer",
    symbol: "ceusdt",
    name: "Tether USD - Celer",
  },
  {
    id: "tether-usd-pos-wormhole",
    symbol: "usdtpo",
    name: "Tether USD (PoS) (Wormhole)",
  },
  {
    id: "tether-usd-wormhole",
    symbol: "usdtso",
    name: "Tether USD (Wormhole)",
  },
  {
    id: "tether-usd-wormhole-from-bsc",
    symbol: "usdtbs",
    name: "Tether USD (Wormhole from BSC)",
  },
  {
    id: "tether-usd-wormhole-from-ethereum",
    symbol: "usdtet",
    name: "Tether USD (Wormhole from Ethereum)",
  },
  {
    id: "tethys-finance",
    symbol: "tethys",
    name: "Tethys Finance",
  },
  {
    id: "tetra-pay",
    symbol: "tpay",
    name: "Tetra Pay",
  },
  {
    id: "tetu",
    symbol: "tetu",
    name: "TETU",
  },
  {
    id: "tezilla",
    symbol: "tezilla",
    name: "Tezilla",
  },
  {
    id: "tezos",
    symbol: "xtz",
    name: "Tezos",
  },
  {
    id: "tfs-token",
    symbol: "tfs",
    name: "TFS",
  },
  {
    id: "tg-dao",
    symbol: "tgdao",
    name: "TG DAO",
  },
  {
    id: "thaicoin",
    symbol: "tac",
    name: "Thaicoin",
  },
  {
    id: "thales",
    symbol: "thales",
    name: "Thales",
  },
  {
    id: "the-4th-pillar",
    symbol: "four",
    name: "4thpillar technologies",
  },
  {
    id: "the-abyss",
    symbol: "abyss",
    name: "Abyss",
  },
  {
    id: "the-alliance-of-eragard",
    symbol: "era",
    name: "The Alliance of Eragard",
  },
  {
    id: "the-amaze-world",
    symbol: "amze",
    name: "The Amaze World",
  },
  {
    id: "the-apis",
    symbol: "api",
    name: "The APIS",
  },
  {
    id: "the-bend",
    symbol: "bend",
    name: "The Bend",
  },
  {
    id: "thebigcoin",
    symbol: "big",
    name: "TheBigCoin",
  },
  {
    id: "the-bitcoin-family",
    symbol: "family",
    name: "The Bitcoin Family",
  },
  {
    id: "theboringtoken",
    symbol: "tbt",
    name: "TheBoring",
  },
  {
    id: "theca",
    symbol: "theca",
    name: "Theca",
  },
  {
    id: "the-cancoin",
    symbol: "canna",
    name: "The CanCoin",
  },
  {
    id: "thecash",
    symbol: "tch",
    name: "THECASH",
  },
  {
    id: "the-cat-inu",
    symbol: "thecat",
    name: "The Cat Inu",
  },
  {
    id: "the-chad-token",
    symbol: "chad",
    name: "The Chad",
  },
  {
    id: "the-champcoin",
    symbol: "tcc",
    name: "The ChampCoin",
  },
  {
    id: "the-citadel",
    symbol: "thecitadel",
    name: "The Citadel",
  },
  {
    id: "the-collective-coin",
    symbol: "tcc",
    name: "The Collective Coin",
  },
  {
    id: "the-commission",
    symbol: "cmsn",
    name: "The Commission",
  },
  {
    id: "the-coop-network",
    symbol: "gmd",
    name: "The Coop Network",
  },
  {
    id: "the-corgi-of-polkabridge",
    symbol: "corgib",
    name: "The Corgi of PolkaBridge",
  },
  {
    id: "the-crypto-prophecies",
    symbol: "tcp",
    name: "The Crypto Prophecies",
  },
  {
    id: "the-crypto-you",
    symbol: "milk",
    name: "The Crypto You",
  },
  {
    id: "the-crypt-space",
    symbol: "crypt",
    name: "The Crypt Space",
  },
  {
    id: "the-daox-index",
    symbol: "daox",
    name: "The DAOX Index",
  },
  {
    id: "the-davis-legacy-coin",
    symbol: "tdlc",
    name: "The Davis Legacy Coin",
  },
  {
    id: "the-doge-nft",
    symbol: "dog",
    name: "The Doge NFT",
  },
  {
    id: "the-dynasty",
    symbol: "dyt",
    name: "The Dynasty",
  },
  {
    id: "the-employment-commons-work-token",
    symbol: "work",
    name: "The Employment Commons Work",
  },
  {
    id: "the-essential-coin",
    symbol: "esc",
    name: "The Essential Coin",
  },
  {
    id: "the-everlasting-parachain",
    symbol: "elp",
    name: "The Everlasting Parachain",
  },
  {
    id: "the-fire-token",
    symbol: "xfr",
    name: "The Fire",
  },
  {
    id: "theflashcurrency",
    symbol: "tfc",
    name: "TheFlashCurrency",
  },
  {
    id: "the-forbidden-forest",
    symbol: "forestplus",
    name: "The Forbidden Forest",
  },
  {
    id: "theforce-trade",
    symbol: "foc",
    name: "TheForce Trade",
  },
  {
    id: "thefutbolcoin",
    symbol: "tfc",
    name: "TheFutbolCoin",
  },
  {
    id: "the-garden",
    symbol: "tgc",
    name: "The Garden",
  },
  {
    id: "thegcccoin",
    symbol: "gcc",
    name: "Global Cryptocurrency",
  },
  {
    id: "thegems",
    symbol: "gems",
    name: "GEMS Esports 3.0 Platform",
  },
  {
    id: "the-grand-banks",
    symbol: "grand",
    name: "The Grand Banks",
  },
  {
    id: "the-graph",
    symbol: "grt",
    name: "The Graph",
  },
  {
    id: "the-graph-wormhole",
    symbol: "grt",
    name: "The Graph (Wormhole)",
  },
  {
    id: "the-hash-speed",
    symbol: "ths",
    name: "The Hash Speed",
  },
  {
    id: "theholyrogercoin",
    symbol: "roger",
    name: "TheHolyRogerCoin",
  },
  {
    id: "the-husl",
    symbol: "husl",
    name: "The HUSL",
  },
  {
    id: "the-idols-nft",
    symbol: "idol",
    name: "The Idols NFT",
  },
  {
    id: "thekey",
    symbol: "tky",
    name: "THEKEY",
  },
  {
    id: "the-killbox-game",
    symbol: "kbox",
    name: "The Killbox Game",
  },
  {
    id: "the-king",
    symbol: "theking",
    name: "The King",
  },
  {
    id: "the-lab-finance",
    symbol: "labo",
    name: "The Lab Finance",
  },
  {
    id: "the-laboratory",
    symbol: "$lab",
    name: "The Laboratory",
  },
  {
    id: "the-landlord",
    symbol: "lndlrd",
    name: "The Landlord",
  },
  {
    id: "the-last-war",
    symbol: "tlw",
    name: "The Last War",
  },
  {
    id: "the-legend-of-deification",
    symbol: "tlod",
    name: "The Legend of Deification",
  },
  {
    id: "the-mars-shiba",
    symbol: "marsshib",
    name: "The Mars Shiba",
  },
  {
    id: "the-mask",
    symbol: "dmask",
    name: "The Mask",
  },
  {
    id: "the-meebits",
    symbol: "nmeebits",
    name: "The Meebits",
  },
  {
    id: "the-midas-touch-gold",
    symbol: "tmtg",
    name: "The Midas Touch Gold",
  },
  {
    id: "themis",
    symbol: "get",
    name: "Themis Network",
  },
  {
    id: "themis-2",
    symbol: "mis",
    name: "Themis",
  },
  {
    id: "themis-protocol",
    symbol: "tms",
    name: "Themis Protocol",
  },
  {
    id: "the-monopolist",
    symbol: "mono",
    name: "The Monopolist",
  },
  {
    id: "the-moon-shiba",
    symbol: "moonshib",
    name: "The Moon Shiba",
  },
  {
    id: "the-nature-token",
    symbol: "nature",
    name: "The Nature",
  },
  {
    id: "the-neighbours",
    symbol: "neibr",
    name: "The Neighbours",
  },
  {
    id: "the-neko",
    symbol: "neko",
    name: "The Neko",
  },
  {
    id: "the-node",
    symbol: "the",
    name: "THENODE",
  },
  {
    id: "the-one-ring",
    symbol: "ring",
    name: "The One Ring",
  },
  {
    id: "the-open-network",
    symbol: "ton",
    name: "The Open Network",
  },
  {
    id: "theos",
    symbol: "theos",
    name: "Theos",
  },
  {
    id: "theoscoin",
    symbol: "ths",
    name: "Theoscoin",
  },
  {
    id: "the-pablo-token",
    symbol: "pablo",
    name: "The Pablo",
  },
  {
    id: "the-parallel",
    symbol: "prl",
    name: "The Parallel",
  },
  {
    id: "the-people-coin",
    symbol: "peeps",
    name: "The People’s Coin",
  },
  {
    id: "the-philosophers-stone",
    symbol: "tpos",
    name: "The Philosophers Stone",
  },
  {
    id: "the-phoenix",
    symbol: "fire",
    name: "The Phoenix",
  },
  {
    id: "thepiggygarden",
    symbol: "tpg",
    name: "ThePiggyGarden",
  },
  {
    id: "the-plant-dao",
    symbol: "sprout",
    name: "The Plant Dao",
  },
  {
    id: "the-randomdao",
    symbol: "rnd",
    name: "The RandomDAO",
  },
  {
    id: "the-rare-antiquities-token-2",
    symbol: "rat",
    name: "The Rare Antiquities",
  },
  {
    id: "the-real-golden-inu",
    symbol: "trgi",
    name: "The Real Golden Inu",
  },
  {
    id: "the-realm-defenders",
    symbol: "trd",
    name: "The Realm Defenders",
  },
  {
    id: "the-reaper",
    symbol: "rpr",
    name: "The Reaper",
  },
  {
    id: "the-red-order",
    symbol: "ordr",
    name: "The Red Order",
  },
  {
    id: "the-sandbox",
    symbol: "sand",
    name: "The Sandbox",
  },
  {
    id: "the-sandbox-wormhole",
    symbol: "sand",
    name: "The Sandbox (Wormhole)",
  },
  {
    id: "the-seed-farm",
    symbol: "seed",
    name: "The Seed Farm",
  },
  {
    id: "thesolandao",
    symbol: "sdo",
    name: "TheSolanDAO",
  },
  {
    id: "the-soldiers-gold",
    symbol: "tsg",
    name: "The Soldiers Gold",
  },
  {
    id: "the-spartans",
    symbol: "tsp",
    name: "The Spartans",
  },
  {
    id: "the-starship-finance",
    symbol: "bip",
    name: "The Starship Finance",
  },
  {
    id: "the-sun-rises",
    symbol: "sunrise",
    name: "The Sun Rises",
  },
  {
    id: "thetadrop",
    symbol: "tdrop",
    name: "ThetaDrop",
  },
  {
    id: "theta-fuel",
    symbol: "tfuel",
    name: "Theta Fuel",
  },
  {
    id: "thetan-arena",
    symbol: "thg",
    name: "Thetan Arena",
  },
  {
    id: "thetan-coin",
    symbol: "thc",
    name: "Thetan Coin",
  },
  {
    id: "theta-token",
    symbol: "theta",
    name: "Theta Network",
  },
  {
    id: "the-three-kingdoms",
    symbol: "ttk",
    name: "The Three Kingdoms",
  },
  {
    id: "the-tokenized-bitcoin",
    symbol: "imbtc",
    name: "The Tokenized Bitcoin",
  },
  {
    id: "the-transfer-token",
    symbol: "ttt",
    name: "The Transfer",
  },
  {
    id: "the-transplant-coin",
    symbol: "tpc",
    name: "The Transplant Coin",
  },
  {
    id: "the-troller-coin",
    symbol: "troller",
    name: "The Troller Coin",
  },
  {
    id: "the-wasted-lands",
    symbol: "wal",
    name: "The Wasted Lands",
  },
  {
    id: "the-web3-project",
    symbol: "web3",
    name: "The Web3 Project",
  },
  {
    id: "the-winkyverse",
    symbol: "wnk",
    name: "The Winkyverse",
  },
  {
    id: "the-wolf-pack",
    symbol: "pack",
    name: "The Wolf Pack",
  },
  {
    id: "the-xenobots-project",
    symbol: "xeno",
    name: "The Xenobots Project",
  },
  {
    id: "thingschain",
    symbol: "tic",
    name: "Thingschain",
  },
  {
    id: "thingsoperatingsystem",
    symbol: "tos",
    name: "ThingsOperatingSystem",
  },
  {
    id: "thinkium",
    symbol: "tkm",
    name: "Thinkium",
  },
  {
    id: "this",
    symbol: "this",
    name: "THIS",
  },
  {
    id: "thisoption",
    symbol: "tons",
    name: "Thisoption",
  },
  {
    id: "thol-token",
    symbol: "thol",
    name: "AngelBlock",
  },
  {
    id: "thor",
    symbol: "thor",
    name: "Thor",
  },
  {
    id: "thorchain",
    symbol: "rune",
    name: "THORChain",
  },
  {
    id: "thorchain-erc20",
    symbol: "rune",
    name: "THORChain (ERC20)",
  },
  {
    id: "thorecash",
    symbol: "tch",
    name: "Thorecash (ERC-20)",
  },
  {
    id: "thorecoin",
    symbol: "thr",
    name: "Thorecoin",
  },
  {
    id: "thorenext",
    symbol: "thx",
    name: "Thorenext",
  },
  {
    id: "thoreum-v2",
    symbol: "thoreum",
    name: "Thoreum V2",
  },
  {
    id: "thorncoin",
    symbol: "thrn",
    name: "Thorncoin",
  },
  {
    id: "thors-mead",
    symbol: "mead",
    name: "Thors Mead",
  },
  {
    id: "thorstarter",
    symbol: "xrune",
    name: "Thorstarter",
  },
  {
    id: "thorswap",
    symbol: "thor",
    name: "THORSwap",
  },
  {
    id: "thorus",
    symbol: "tho",
    name: "Thorus",
  },
  {
    id: "thorwallet",
    symbol: "tgt",
    name: "THORWallet DEX",
  },
  {
    id: "thought",
    symbol: "tht",
    name: "Thought",
  },
  {
    id: "threefold-token",
    symbol: "tft",
    name: "ThreeFold",
  },
  {
    id: "threshold-network-token",
    symbol: "t",
    name: "Threshold Network",
  },
  {
    id: "throne",
    symbol: "thn",
    name: "Throne",
  },
  {
    id: "thropic",
    symbol: "thropic",
    name: "Thropic (OLD)",
  },
  {
    id: "thropic-v2",
    symbol: "thropicv2",
    name: "Thropic",
  },
  {
    id: "thtf",
    symbol: "thtf",
    name: "THTF",
  },
  {
    id: "thunderada-app",
    symbol: "thunderada",
    name: "ThunderADA.app",
  },
  {
    id: "thunderbnb",
    symbol: "thunderbnb",
    name: "ThunderBNB",
  },
  {
    id: "thundereth",
    symbol: "thundereth",
    name: "ThunderETH",
  },
  {
    id: "thunder-token",
    symbol: "tt",
    name: "ThunderCore",
  },
  {
    id: "thunderverse",
    symbol: "thunder",
    name: "ThunderVerse",
  },
  {
    id: "thx",
    symbol: "thx",
    name: "Thx!",
  },
  {
    id: "thx-network",
    symbol: "thx",
    name: "THX Network",
  },
  {
    id: "tia",
    symbol: "tia",
    name: "TIA",
  },
  {
    id: "tianya-token",
    symbol: "tyt",
    name: "Tianya",
  },
  {
    id: "tianyu-finance",
    symbol: "tyc",
    name: "Tianyu Finance",
  },
  {
    id: "tiara",
    symbol: "tti",
    name: "Tiara",
  },
  {
    id: "ticket-finance",
    symbol: "ticket",
    name: "Ticket Finance",
  },
  {
    id: "ticoex-token",
    symbol: "tico",
    name: "TICOEX",
  },
  {
    id: "tictalk",
    symbol: "tic",
    name: "TicTalk",
  },
  {
    id: "tidal-finance",
    symbol: "tidal",
    name: "Tidal Finance",
  },
  {
    id: "tierion",
    symbol: "tnt",
    name: "Tierion",
  },
  {
    id: "tierra-meta",
    symbol: "trmt",
    name: "Tierra Meta",
  },
  {
    id: "ties-network",
    symbol: "tie",
    name: "Ties.DB",
  },
  {
    id: "tifi-token",
    symbol: "tifi",
    name: "TiFi",
  },
  {
    id: "tigercash",
    symbol: "tch",
    name: "TigerCash",
  },
  {
    id: "tiger-coin",
    symbol: "tiger",
    name: "Tiger Coin",
  },
  {
    id: "tigercoin-2",
    symbol: "tiger",
    name: "TigerCoin",
  },
  {
    id: "tiger-cub",
    symbol: "tcub",
    name: "Tiger Cub",
  },
  {
    id: "tigerinu2022",
    symbol: "tigerinu2022",
    name: "TigerInu2022",
  },
  {
    id: "tiger-king",
    symbol: "tking",
    name: "Tiger King Coin",
  },
  {
    id: "tigerqueen",
    symbol: "tqueen",
    name: "TigerQueen",
  },
  {
    id: "tiger-shares",
    symbol: "tiger",
    name: "Tiger Shares",
  },
  {
    id: "tiger-token",
    symbol: "tgnb",
    name: "Tiger",
  },
  {
    id: "tiki-token",
    symbol: "tiki",
    name: "Tiki",
  },
  {
    id: "tilwiki",
    symbol: "tlw",
    name: "TilWiki",
  },
  {
    id: "timechain-swap-token",
    symbol: "tcs",
    name: "Timechain Swap",
  },
  {
    id: "timecoin-protocol",
    symbol: "tmcn",
    name: "Timecoin Protocol",
  },
  {
    id: "timeleap-finance",
    symbol: "time",
    name: "Timeleap Finance",
  },
  {
    id: "timelockcoin",
    symbol: "tym",
    name: "TimeLockCoin",
  },
  {
    id: "time-new-bank",
    symbol: "tnb",
    name: "Time New Bank",
  },
  {
    id: "timerr",
    symbol: "timerr",
    name: "Timerr",
  },
  {
    id: "timers",
    symbol: "ipm",
    name: "Timers",
  },
  {
    id: "timeshuffle",
    symbol: "tims",
    name: "TimeShuffle",
  },
  {
    id: "timeshuffle-gold",
    symbol: "gold",
    name: "TimeShuffle GOLD",
  },
  {
    id: "tiny-bonez",
    symbol: "t1ny",
    name: "Tiny Bonez",
  },
  {
    id: "tiny-coin",
    symbol: "tinc",
    name: "Tiny Coin",
  },
  {
    id: "tiny-colony",
    symbol: "tiny",
    name: "Tiny Colony",
  },
  {
    id: "tip-blue",
    symbol: "blue",
    name: "Tip.Blue",
  },
  {
    id: "tipsy",
    symbol: "tipsy",
    name: "Tipsy",
  },
  {
    id: "tipsycoin",
    symbol: "$tipsy",
    name: "TipsyCoin",
  },
  {
    id: "tiraverse",
    symbol: "tvrs",
    name: "TiraVerse",
  },
  {
    id: "titan-coin",
    symbol: "ttn",
    name: "Titan Coin",
  },
  {
    id: "titan-hunters",
    symbol: "tita",
    name: "Titan Hunters",
  },
  {
    id: "titania-token",
    symbol: "titania",
    name: "Titania",
  },
  {
    id: "titano",
    symbol: "titano",
    name: "Titano",
  },
  {
    id: "titanswap",
    symbol: "titan",
    name: "TitanSwap",
  },
  {
    id: "titi-financial",
    symbol: "titi",
    name: "Titi Financial",
  },
  {
    id: "title-network",
    symbol: "tnet",
    name: "Bitcoin Clashic",
  },
  {
    id: "titsv2",
    symbol: "tits",
    name: "TitsV2",
  },
  {
    id: "ti-value",
    symbol: "tv",
    name: "Ti-Value",
  },
  {
    id: "tkn-token",
    symbol: "tknt",
    name: "TKN",
  },
  {
    id: "tmc",
    symbol: "tmc",
    name: "TMC",
  },
  {
    id: "tmeta",
    symbol: "tmt",
    name: "TMETA",
  },
  {
    id: "tnc-coin",
    symbol: "tnc",
    name: "TNC Coin",
  },
  {
    id: "tnns",
    symbol: "tnns",
    name: "TNNS",
  },
  {
    id: "tokamak-network",
    symbol: "ton",
    name: "Tokamak Network",
  },
  {
    id: "tokel",
    symbol: "tkl",
    name: "Tokel",
  },
  {
    id: "tokemak",
    symbol: "toke",
    name: "Tokemak",
  },
  {
    id: "tokemak-wormhole",
    symbol: "toke",
    name: "Tokemak (Wormhole)",
  },
  {
    id: "tokemon",
    symbol: "tkmn",
    name: "Tokemon",
  },
  {
    id: "toke-n",
    symbol: "toke.n",
    name: "TOKE.N",
  },
  {
    id: "tokenarium",
    symbol: "tknrm",
    name: "Tokenarium",
  },
  {
    id: "tokenasset",
    symbol: "ntb",
    name: "TokenAsset",
  },
  {
    id: "tokenbank",
    symbol: "tbank",
    name: "Tokenbank",
  },
  {
    id: "tokenbook",
    symbol: "tbk",
    name: "TokenBook",
  },
  {
    id: "tokenbox",
    symbol: "tbx",
    name: "Tokenbox",
  },
  {
    id: "tokencard",
    symbol: "tkn",
    name: "Monolith",
  },
  {
    id: "token-cashpay",
    symbol: "tcp",
    name: "Token CashPay",
  },
  {
    id: "token-cheetah",
    symbol: "chtt",
    name: "Cheetah",
  },
  {
    id: "tokenclub",
    symbol: "tct",
    name: "TokenClub",
  },
  {
    id: "tokendesk",
    symbol: "tds",
    name: "TokenDesk",
  },
  {
    id: "token-dforce-usd",
    symbol: "usx",
    name: "dForce USD",
  },
  {
    id: "token-engineering-commons",
    symbol: "tec",
    name: "Engineering Commons",
  },
  {
    id: "tokenfy",
    symbol: "tknfy",
    name: "Tokenfy",
  },
  {
    id: "tokengo",
    symbol: "gpt",
    name: "GoPower",
  },
  {
    id: "tokenize-xchange",
    symbol: "tkx",
    name: "Tokenize Xchange",
  },
  {
    id: "tokenjenny",
    symbol: "jenn",
    name: "TokenJenny",
  },
  {
    id: "token-kennel",
    symbol: "kennel",
    name: "Token Kennel",
  },
  {
    id: "tokenlon",
    symbol: "lon",
    name: "Tokenlon",
  },
  {
    id: "tokenoid",
    symbol: "noid",
    name: "Tokenoid",
  },
  {
    id: "tokenomy",
    symbol: "ten",
    name: "Tokenomy",
  },
  {
    id: "tokenpay",
    symbol: "tpay",
    name: "TPAY",
  },
  {
    id: "tokenplace",
    symbol: "tok",
    name: "Tokenplace",
  },
  {
    id: "tokenplay",
    symbol: "top",
    name: "Tokenplay",
  },
  {
    id: "token-play",
    symbol: "tp3",
    name: "Token Play",
  },
  {
    id: "token-pocket",
    symbol: "tpt",
    name: "Pocket TPT",
  },
  {
    id: "token-shelby",
    symbol: "tsy",
    name: "Token Shelby",
  },
  {
    id: "tokenstand-network",
    symbol: "stand",
    name: "TokenStand Network",
  },
  {
    id: "token-tkx",
    symbol: "tkx",
    name: "Xixo TKX",
  },
  {
    id: "tokentuber",
    symbol: "tuber",
    name: "TokenTuber",
  },
  {
    id: "tokes",
    symbol: "tks",
    name: "Tokes",
  },
  {
    id: "toko",
    symbol: "toko",
    name: "Tokoin",
  },
  {
    id: "tokocrypto",
    symbol: "tko",
    name: "Tokocrypto",
  },
  {
    id: "tokok",
    symbol: "tok",
    name: "Tokok",
  },
  {
    id: "tokonft",
    symbol: "tkn",
    name: "TokoNFT",
  },
  {
    id: "tokpie",
    symbol: "tkp",
    name: "TOKPIE",
  },
  {
    id: "tokyo",
    symbol: "tokc",
    name: "Tokyo Coin",
  },
  {
    id: "tokyo-au",
    symbol: "tokau",
    name: "Tokyo AU",
  },
  {
    id: "tokyo-inu",
    symbol: "toki",
    name: "Tokyo Inu",
  },
  {
    id: "tolar",
    symbol: "tol",
    name: "Tolar",
  },
  {
    id: "tomb",
    symbol: "tomb",
    name: "Tomb",
  },
  {
    id: "tombprinter",
    symbol: "tombp",
    name: "TombPrinter",
  },
  {
    id: "tomb-shares",
    symbol: "tshare",
    name: "Tomb Shares",
  },
  {
    id: "tom-coin",
    symbol: "tmc",
    name: "Tom Coin",
  },
  {
    id: "tom-finance",
    symbol: "tom",
    name: "TOM Finance",
  },
  {
    id: "tomochain",
    symbol: "tomo",
    name: "TomoChain",
  },
  {
    id: "tomoe",
    symbol: "tomoe",
    name: "TomoChain ERC-20",
  },
  {
    id: "tomtomcoin",
    symbol: "toms",
    name: "TomTomCoin",
  },
  {
    id: "tonestra",
    symbol: "tnr",
    name: "Tonestra",
  },
  {
    id: "tonic-dex",
    symbol: "tonic",
    name: "Tonic DEX",
  },
  {
    id: "tonstarter",
    symbol: "tos",
    name: "TONStarter",
  },
  {
    id: "tontoken",
    symbol: "ton",
    name: "TON",
  },
  {
    id: "toobcoin",
    symbol: "toob",
    name: "Toobcoin",
  },
  {
    id: "toolape",
    symbol: "tape",
    name: "ToolApe",
  },
  {
    id: "tools",
    symbol: "tools",
    name: "TOOLS",
  },
  {
    id: "toonft",
    symbol: "toon",
    name: "TooNFT",
  },
  {
    id: "too-token",
    symbol: "too",
    name: "TOO",
  },
  {
    id: "topbidder",
    symbol: "bid",
    name: "TopBidder",
  },
  {
    id: "topchain",
    symbol: "topc",
    name: "TopChain",
  },
  {
    id: "top-coin-token",
    symbol: "tct",
    name: "Top Coin",
  },
  {
    id: "topflower",
    symbol: "tpf",
    name: "TopFlower",
  },
  {
    id: "topmanager",
    symbol: "tmt",
    name: "TopManager",
  },
  {
    id: "top-network",
    symbol: "top",
    name: "TOP Network",
  },
  {
    id: "topshelf-finance",
    symbol: "liqr",
    name: "Topshelf Finance",
  },
  {
    id: "tor",
    symbol: "tor",
    name: "TOR",
  },
  {
    id: "torchain",
    symbol: "tor",
    name: "Torchain",
  },
  {
    id: "torekko",
    symbol: "trk",
    name: "Torekko",
  },
  {
    id: "torex",
    symbol: "tor",
    name: "Torex",
  },
  {
    id: "torg",
    symbol: "torg",
    name: "TORG",
  },
  {
    id: "torii-finance",
    symbol: "torii",
    name: "Torii Finance",
  },
  {
    id: "tornadao",
    symbol: "nado",
    name: "Tornadao",
  },
  {
    id: "tornado-cash",
    symbol: "torn",
    name: "Tornado Cash",
  },
  {
    id: "torocus-token",
    symbol: "torocus",
    name: "TOROCUS",
  },
  {
    id: "torpedo",
    symbol: "torpedo",
    name: "Torpedo",
  },
  {
    id: "torq-coin",
    symbol: "torq",
    name: "TORQ Coin",
  },
  {
    id: "torum",
    symbol: "xtm",
    name: "Torum",
  },
  {
    id: "t-os",
    symbol: "tosc",
    name: "T.OS",
  },
  {
    id: "tosdis",
    symbol: "dis",
    name: "TosDis",
  },
  {
    id: "toshinori-inu",
    symbol: "toshinori",
    name: "Toshinori Inu",
  },
  {
    id: "toshi-token",
    symbol: "toshi",
    name: "Toshimon",
  },
  {
    id: "total-crypto-market-cap-token",
    symbol: "tcap",
    name: "Total Crypto Market Cap",
  },
  {
    id: "totally-a-rug-pull",
    symbol: "tarp",
    name: "Totally A Rug Pull",
  },
  {
    id: "totem-earth-systems",
    symbol: "ctzn",
    name: "Totem",
  },
  {
    id: "totemfi",
    symbol: "totm",
    name: "TotemFi",
  },
  {
    id: "totem-finance",
    symbol: "totem",
    name: "Totem Finance",
  },
  {
    id: "to-the-moon-token",
    symbol: "ton",
    name: "To The Moon Token",
  },
  {
    id: "totoro-inu",
    symbol: "totoro",
    name: "Totoro Inu",
  },
  {
    id: "toucan-protocol-base-carbon-tonne",
    symbol: "bct",
    name: "Toucan Protocol: Base Carbon Tonne",
  },
  {
    id: "toucan-protocol-nature-carbon-tonne",
    symbol: "nct",
    name: "Toucan Protocol: Nature Carbon Tonne",
  },
  {
    id: "touchcon",
    symbol: "toc",
    name: "TouchCon",
  },
  {
    id: "touchfuture",
    symbol: "tf",
    name: "TouchFuture",
  },
  {
    id: "tourist-shiba-inu",
    symbol: "tourists",
    name: "Tourist Shiba Inu",
  },
  {
    id: "tourist-token",
    symbol: "toto",
    name: "Tourist",
  },
  {
    id: "touriva",
    symbol: "tour",
    name: "Touriva",
  },
  {
    id: "toursim-coin",
    symbol: "tic",
    name: "Toursim Coin",
  },
  {
    id: "tower",
    symbol: "tower",
    name: "Tower",
  },
  {
    id: "tower-defense-titans",
    symbol: "titans",
    name: "Tower Defense Titans",
  },
  {
    id: "tower-usd",
    symbol: "twr",
    name: "Tower USD",
  },
  {
    id: "town-star",
    symbol: "town",
    name: "Town Star",
  },
  {
    id: "toxicdeer-finance",
    symbol: "deer",
    name: "ToxicDeer Finance",
  },
  {
    id: "toxicgamenft",
    symbol: "txc",
    name: "ToxicGameNft",
  },
  {
    id: "toxic-game-nft",
    symbol: "ntxc",
    name: "Toxic Game NFT",
  },
  {
    id: "tozex",
    symbol: "toz",
    name: "Tozex",
  },
  {
    id: "tpiggy",
    symbol: "tpiggy",
    name: "Tpiggy",
  },
  {
    id: "tp-swap",
    symbol: "tp",
    name: "Token Swap",
  },
  {
    id: "tr3zor",
    symbol: "tr3",
    name: "Tr3zor",
  },
  {
    id: "trabzonspor-fan-token",
    symbol: "tra",
    name: "Trabzonspor Fan Token",
  },
  {
    id: "trace-network-labs",
    symbol: "trace",
    name: "Trace Network Labs",
  },
  {
    id: "tracer-dao",
    symbol: "tcr",
    name: "Tracer DAO",
  },
  {
    id: "tractor-joe",
    symbol: "tractor",
    name: "Tractor Joe",
  },
  {
    id: "tradao",
    symbol: "tod",
    name: "TraDAO",
  },
  {
    id: "tradcoin",
    symbol: "trad",
    name: "Tradcoin",
  },
  {
    id: "trade-fighter",
    symbol: "tdf",
    name: "Trade Fighter",
  },
  {
    id: "traders-coin",
    symbol: "trdc",
    name: "Traders Coin",
  },
  {
    id: "traders-global-business",
    symbol: "tgb",
    name: "Traders Global Business",
  },
  {
    id: "tradestars",
    symbol: "tsx",
    name: "TradeStars",
  },
  {
    id: "trade-win",
    symbol: "twi",
    name: "Trade.win",
  },
  {
    id: "tranche-finance",
    symbol: "slice",
    name: "Tranche Finance",
  },
  {
    id: "tranchess",
    symbol: "chess",
    name: "Tranchess",
  },
  {
    id: "tranquil-finance",
    symbol: "tranq",
    name: "Tranquil Finance",
  },
  {
    id: "tranquility-city",
    symbol: "lumen",
    name: "Tranquility City",
  },
  {
    id: "tranquil-staked-one",
    symbol: "stone",
    name: "Tranquil Staked ONE",
  },
  {
    id: "transcodium",
    symbol: "tns",
    name: "Transcodium",
  },
  {
    id: "transhuman-coin",
    symbol: "thc",
    name: "Transhuman Coin",
  },
  {
    id: "transient",
    symbol: "tsct",
    name: "Transient",
  },
  {
    id: "trapeza-protocol",
    symbol: "fidl",
    name: "Trapeza Protocol",
  },
  {
    id: "tratok",
    symbol: "trat",
    name: "Tratok",
  },
  {
    id: "trava-finance",
    symbol: "trava",
    name: "Trava Finance",
  },
  {
    id: "travel-care-2",
    symbol: "travel",
    name: "Travel Care",
  },
  {
    id: "travel-coin",
    symbol: "tcoin",
    name: "Travel Coin",
  },
  {
    id: "travelnote",
    symbol: "tvnt",
    name: "TravelNote",
  },
  {
    id: "traverse",
    symbol: "verse",
    name: "Traverse",
  },
  {
    id: "travgopv",
    symbol: "tpv",
    name: "TravGoPV",
  },
  {
    id: "traxia",
    symbol: "tmt",
    name: "Traxia",
  },
  {
    id: "traxx",
    symbol: "traxx",
    name: "Traxx",
  },
  {
    id: "trazable",
    symbol: "trz",
    name: "Trazable",
  },
  {
    id: "tre",
    symbol: "tre",
    name: "Green Land",
  },
  {
    id: "treasure",
    symbol: "treasure",
    name: "Treasure",
  },
  {
    id: "treasure-sl",
    symbol: "tsl",
    name: "Treasure SL",
  },
  {
    id: "treasure-token-finance",
    symbol: "treasure",
    name: "Treasure Finance",
  },
  {
    id: "treasure-under-sea",
    symbol: "tus",
    name: "Treasure Under Sea",
  },
  {
    id: "treasury-bond-eth-tokenized-stock-defichain",
    symbol: "dtlt",
    name: "iShares 20+ Year Treasury Bond ETF Defichain",
  },
  {
    id: "treatdao",
    symbol: "treat",
    name: "TreatDAO [OLD]",
  },
  {
    id: "treatdao-v2",
    symbol: "treat",
    name: "TreatDAO",
  },
  {
    id: "treeb",
    symbol: "treeb",
    name: "Retreeb",
  },
  {
    id: "treecle",
    symbol: "trcl",
    name: "Treecle",
  },
  {
    id: "treep-token",
    symbol: "treep",
    name: "Treep",
  },
  {
    id: "tremendous-coin",
    symbol: "tmds",
    name: "Tremendous Coin",
  },
  {
    id: "trendering",
    symbol: "trnd",
    name: "Trendering",
  },
  {
    id: "trendsy",
    symbol: "trndz",
    name: "Trendsy",
  },
  {
    id: "tresor-finance",
    symbol: "$tresor",
    name: "Tresor Finance",
  },
  {
    id: "trezarcoin",
    symbol: "tzc",
    name: "TrezarCoin",
  },
  {
    id: "triall",
    symbol: "trl",
    name: "Triall",
  },
  {
    id: "trias-token",
    symbol: "trias",
    name: "TriasLab",
  },
  {
    id: "tribal",
    symbol: "tribl",
    name: "Tribal",
  },
  {
    id: "tribalpunk-cryptoverse",
    symbol: "anta",
    name: "Tribalpunk Cryptoverse",
  },
  {
    id: "tribar",
    symbol: "xtri",
    name: "Tribar",
  },
  {
    id: "tribe-2",
    symbol: "tribe",
    name: "Tribe",
  },
  {
    id: "tribeland",
    symbol: "trbl",
    name: "Tribeland",
  },
  {
    id: "tribeone",
    symbol: "haka",
    name: "TribeOne",
  },
  {
    id: "tribe-token",
    symbol: "tribex",
    name: "Tribe Token",
  },
  {
    id: "tribe-wormhole",
    symbol: "tribe",
    name: "Tribe (Wormhole)",
  },
  {
    id: "trickle",
    symbol: "h2o",
    name: "Trickle",
  },
  {
    id: "triipmiles",
    symbol: "tiim",
    name: "TriipMiles",
  },
  {
    id: "trillion",
    symbol: "tt",
    name: "Trillion",
  },
  {
    id: "trillium",
    symbol: "tt",
    name: "Trillium",
  },
  {
    id: "trinity",
    symbol: "tty",
    name: "Trinity",
  },
  {
    id: "trinity-defi",
    symbol: "trin",
    name: "Trinity Defi",
  },
  {
    id: "trinity-network-credit",
    symbol: "tnc",
    name: "Trinity Network Credit",
  },
  {
    id: "tripcandy",
    symbol: "candy",
    name: "TripCandy",
  },
  {
    id: "tripedia",
    symbol: "trip",
    name: "Tripedia",
  },
  {
    id: "tripio",
    symbol: "trio",
    name: "Tripio",
  },
  {
    id: "trip-leverage-token",
    symbol: "tlt",
    name: "Trip Leverage",
  },
  {
    id: "tripolar",
    symbol: "tripolar",
    name: "Tripolar",
  },
  {
    id: "trips-community",
    symbol: "trips",
    name: "Trips Community",
  },
  {
    id: "trism",
    symbol: "trism",
    name: "Trism",
  },
  {
    id: "trisolaris",
    symbol: "tri",
    name: "Trisolaris",
  },
  {
    id: "triton",
    symbol: "xeq",
    name: "Equilibria",
  },
  {
    id: "trittium",
    symbol: "trtt",
    name: "Trittium",
  },
  {
    id: "triumphx",
    symbol: "trix",
    name: "TriumphX",
  },
  {
    id: "triveum",
    symbol: "trv",
    name: "Triveum",
  },
  {
    id: "trodl",
    symbol: "tro",
    name: "Trodl",
  },
  {
    id: "trolite",
    symbol: "trl",
    name: "Trolite",
  },
  {
    id: "trollbox",
    symbol: "tox",
    name: "trollbox",
  },
  {
    id: "trollcoin",
    symbol: "troll",
    name: "Trollcoin",
  },
  {
    id: "tron",
    symbol: "trx",
    name: "TRON",
  },
  {
    id: "tronbetdice",
    symbol: "dice",
    name: "TRONbetDice",
  },
  {
    id: "tronbetlive",
    symbol: "live",
    name: "TRONbetLive",
  },
  {
    id: "tron-bsc",
    symbol: "trx",
    name: "TRON (BSC)",
  },
  {
    id: "tronclassic",
    symbol: "trxc",
    name: "TronClassic",
  },
  {
    id: "tron-connect",
    symbol: "tcx",
    name: "Tron Connect",
  },
  {
    id: "troneuroperewardcoin",
    symbol: "terc",
    name: "TronEuropeRewardCoin",
  },
  {
    id: "tronipay",
    symbol: "trp",
    name: "Tronipay",
  },
  {
    id: "tronpad",
    symbol: "tronpad",
    name: "TRONPAD",
  },
  {
    id: "tropical-finance",
    symbol: "daiquiri",
    name: "Tropical Finance",
  },
  {
    id: "troy",
    symbol: "troy",
    name: "Troy",
  },
  {
    id: "trubadger",
    symbol: "trubgr",
    name: "TruBadger",
  },
  {
    id: "trueaud",
    symbol: "taud",
    name: "TrueAUD",
  },
  {
    id: "truebit-protocol",
    symbol: "tru",
    name: "Truebit Protocol",
  },
  {
    id: "trueburn",
    symbol: "true",
    name: "TrueBurn",
  },
  {
    id: "true-chain",
    symbol: "true",
    name: "TrueChain",
  },
  {
    id: "truedeck",
    symbol: "tdp",
    name: "TrueDeck",
  },
  {
    id: "truefeedbackchain",
    symbol: "tfbx",
    name: "Truefeedback",
  },
  {
    id: "truefi",
    symbol: "tru",
    name: "TrueFi",
  },
  {
    id: "trueflip",
    symbol: "tfl",
    name: "TrueFlip",
  },
  {
    id: "truegame",
    symbol: "tgame",
    name: "Truegame",
  },
  {
    id: "truehkd",
    symbol: "thkd",
    name: "TrueHKD",
  },
  {
    id: "true-pnl",
    symbol: "pnl",
    name: "True PNL",
  },
  {
    id: "true-usd",
    symbol: "tusd",
    name: "TrueUSD",
  },
  {
    id: "trustbase",
    symbol: "tbe",
    name: "TrustBase",
  },
  {
    id: "trusted-node",
    symbol: "tnode",
    name: "Trusted Node",
  },
  {
    id: "trustercoin",
    symbol: "tsc",
    name: "TrusterCoin",
  },
  {
    id: "trust-ether-reorigin",
    symbol: "teo",
    name: "Trust Ether ReOrigin",
  },
  {
    id: "trustfi-network-token",
    symbol: "tfi",
    name: "TrustFi Network",
  },
  {
    id: "trustkeys-network",
    symbol: "trustk",
    name: "TrustKeys Network",
  },
  {
    id: "trustnft",
    symbol: "trustnft",
    name: "TrustNFT",
  },
  {
    id: "trustpad",
    symbol: "tpad",
    name: "TrustPad",
  },
  {
    id: "trustpay",
    symbol: "tph",
    name: "Trustpay",
  },
  {
    id: "trust-recruit",
    symbol: "trt",
    name: "Trust Recruit",
  },
  {
    id: "trustrise",
    symbol: "trise",
    name: "TrustRise",
  },
  {
    id: "trustswap",
    symbol: "swap",
    name: "Trustswap",
  },
  {
    id: "trustusd",
    symbol: "trusd",
    name: "TrustUSD",
  },
  {
    id: "trustverse",
    symbol: "trv",
    name: "TrustVerse",
  },
  {
    id: "trust-wallet-token",
    symbol: "twt",
    name: "Trust Wallet",
  },
  {
    id: "trustworks",
    symbol: "trust",
    name: "Trustworks",
  },
  {
    id: "truth-technology",
    symbol: "truth",
    name: "Truth Technology",
  },
  {
    id: "trx3l",
    symbol: "trx3l",
    name: "TRX3L",
  },
  {
    id: "tryc",
    symbol: "tryc",
    name: "TRYC",
  },
  {
    id: "try-finance",
    symbol: "try",
    name: "Try.Finance",
  },
  {
    id: "tryhards",
    symbol: "try",
    name: "TryHards",
  },
  {
    id: "tryvium-2",
    symbol: "tryv",
    name: "Tryvium",
  },
  {
    id: "tsar-network",
    symbol: "tsar",
    name: "Tsar Network",
  },
  {
    id: "tsuki-inu",
    symbol: "tkinu",
    name: "Tsuki Inu",
  },
  {
    id: "tsukiverse-galactic-adventures",
    symbol: "tsuga",
    name: "Tsukiverse:Galactic Adventures",
  },
  {
    id: "tsuzuki-inu",
    symbol: "tzki",
    name: "Tsuzuki Inu",
  },
  {
    id: "ttanslateme-network-token",
    symbol: "tmn",
    name: "TranslateMe Network",
  },
  {
    id: "ttcoin",
    symbol: "tc",
    name: "TTcoin",
  },
  {
    id: "ttc-protocol",
    symbol: "maro",
    name: "Maro",
  },
  {
    id: "ttx-metaverse",
    symbol: "xmeta",
    name: "TTX Metaverse",
  },
  {
    id: "tube2",
    symbol: "tube2",
    name: "TUBE2",
  },
  {
    id: "tudabirds",
    symbol: "burd",
    name: "tudaBirds",
  },
  {
    id: "tulip",
    symbol: "tulip",
    name: "Tulip",
  },
  {
    id: "tundra-token",
    symbol: "tundra",
    name: "Tundra",
  },
  {
    id: "tune",
    symbol: "tun",
    name: "TUNE",
  },
  {
    id: "tune-fm",
    symbol: "jam",
    name: "Tune.Fm",
  },
  {
    id: "tune-token",
    symbol: "tune",
    name: "TUNE TOKEN",
  },
  {
    id: "turbo-wallet",
    symbol: "turbo",
    name: "Turbo Wallet",
  },
  {
    id: "turex",
    symbol: "tur",
    name: "Turex",
  },
  {
    id: "turkiye-basketbol-federasyonu-token",
    symbol: "tbft",
    name: "Turkiye Basketbol Federasyonu Token",
  },
  {
    id: "turnt-up-tikis",
    symbol: "tut",
    name: "Turnt Up Tikis",
  },
  {
    id: "turtlecoin",
    symbol: "trtl",
    name: "TurtleCoin",
  },
  {
    id: "turtle-racing",
    symbol: "turt",
    name: "Turtle Racing",
  },
  {
    id: "turtles-token",
    symbol: "trtls",
    name: "Turtles",
  },
  {
    id: "turu",
    symbol: "turu",
    name: "Turu",
  },
  {
    id: "tusk-token",
    symbol: "tusk",
    name: "Mammoth.Bet",
  },
  {
    id: "tutellus",
    symbol: "tut",
    name: "Tutellus",
  },
  {
    id: "tutors-diary",
    symbol: "tuda",
    name: "Tutor's Diary",
  },
  {
    id: "tutti-frutti-finance",
    symbol: "tff",
    name: "Tutti Frutti",
  },
  {
    id: "tuxcoin",
    symbol: "tux",
    name: "Tuxcoin",
  },
  {
    id: "tuzlaspor",
    symbol: "tuzla",
    name: "Tuzlaspor Token",
  },
  {
    id: "tvgcoin",
    symbol: "tvg",
    name: "TVGCOIN",
  },
  {
    id: "tvt",
    symbol: "tvt",
    name: "TVT",
  },
  {
    id: "twelve-legions",
    symbol: "ctl",
    name: "Twelve Legions",
  },
  {
    id: "twinci",
    symbol: "twin",
    name: "Twinci",
  },
  {
    id: "twin-finance",
    symbol: "twin",
    name: "Twin Finance",
  },
  {
    id: "twinu",
    symbol: "twinu",
    name: "TWINU",
  },
  {
    id: "twirl-governance-token",
    symbol: "tgt",
    name: "Twirl Governance",
  },
  {
    id: "twist",
    symbol: "twist",
    name: "TWIST",
  },
  {
    id: "twitter-tokenized-stock-zipmex",
    symbol: "twtr",
    name: "Twitter Tokenized Stock Zipmex",
  },
  {
    id: "two-monkey-juice-bar",
    symbol: "$tmon",
    name: "Two Monkey Juice Bar",
  },
  {
    id: "txa",
    symbol: "txa",
    name: "TXA",
  },
  {
    id: "txbit",
    symbol: "txbit",
    name: "Txbit",
  },
  {
    id: "tycheloto",
    symbol: "tyche",
    name: "TycheLoto",
  },
  {
    id: "tycoon",
    symbol: "tyc",
    name: "Tycoon",
  },
  {
    id: "tycoon-global",
    symbol: "tct",
    name: "Tycoon Global",
  },
  {
    id: "typerium",
    symbol: "type",
    name: "Typerium",
  },
  {
    id: "typhoon-cash",
    symbol: "phoon",
    name: "Typhoon Cash",
  },
  {
    id: "typhoon-network",
    symbol: "typh",
    name: "Typhoon Network",
  },
  {
    id: "tyv",
    symbol: "tyv",
    name: "TYV",
  },
  {
    id: "uangmarket",
    symbol: "uang",
    name: "UangMarket",
  },
  {
    id: "ubeswap",
    symbol: "ube",
    name: "Ubeswap",
  },
  {
    id: "ubex",
    symbol: "ubex",
    name: "Ubex",
  },
  {
    id: "ubg-token",
    symbol: "ubg",
    name: "UBG",
  },
  {
    id: "ubiner",
    symbol: "ubin",
    name: "Ubiner",
  },
  {
    id: "ubiq",
    symbol: "ubq",
    name: "Ubiq",
  },
  {
    id: "ubix-network",
    symbol: "ubx",
    name: "UBIX Network",
  },
  {
    id: "ubu",
    symbol: "ubu",
    name: "UBU",
  },
  {
    id: "ubu-finance",
    symbol: "ubu",
    name: "UBU Finance",
  },
  {
    id: "ubxs-token",
    symbol: "ubxs",
    name: "UBXS",
  },
  {
    id: "uca",
    symbol: "uca",
    name: "UCA Coin",
  },
  {
    id: "ucash",
    symbol: "ucash",
    name: "U.CASH",
  },
  {
    id: "uchain",
    symbol: "ucn",
    name: "UChain",
  },
  {
    id: "ucoin",
    symbol: "u",
    name: "Ucoin",
  },
  {
    id: "ucrowdme",
    symbol: "ucm",
    name: "UCROWDME",
  },
  {
    id: "ucx",
    symbol: "ucx",
    name: "UCX",
  },
  {
    id: "ufc-fan-token",
    symbol: "ufc",
    name: "UFC Fan Token",
  },
  {
    id: "ufo",
    symbol: "ufo",
    name: "UFO",
  },
  {
    id: "ufocoin",
    symbol: "ufo",
    name: "Uniform Fiscal Object",
  },
  {
    id: "ufo-gaming",
    symbol: "ufo",
    name: "UFO Gaming",
  },
  {
    id: "ufo-gaming-wormhole",
    symbol: "ufo",
    name: "UFO Gaming (Wormhole)",
  },
  {
    id: "uhive",
    symbol: "hve2",
    name: "Uhive",
  },
  {
    id: "uka-doge-coin",
    symbol: "udoge",
    name: "Uka Doge Coin",
  },
  {
    id: "ukiss",
    symbol: "kiss",
    name: "UKISS",
  },
  {
    id: "ukrainedao-flag-nft",
    symbol: "love",
    name: "UkraineDAO Flag NFT",
  },
  {
    id: "ulanco",
    symbol: "uac",
    name: "Ulanco",
  },
  {
    id: "uland",
    symbol: "uland",
    name: "ULAND",
  },
  {
    id: "ulgen-hash-power",
    symbol: "uhp",
    name: "Ulgen Hash Power",
  },
  {
    id: "ulord",
    symbol: "ut",
    name: "Ulord",
  },
  {
    id: "ulti-arena",
    symbol: "ulti",
    name: "Ulti Arena",
  },
  {
    id: "ultiledger",
    symbol: "ult",
    name: "Ultiledger",
  },
  {
    id: "ultimogg",
    symbol: "ultgg",
    name: "UltimoGG",
  },
  {
    id: "ultra",
    symbol: "uos",
    name: "Ultra",
  },
  {
    id: "ultrachad",
    symbol: "uchad",
    name: "UltraChad",
  },
  {
    id: "ultra-clear",
    symbol: "ucr",
    name: "Ultra Clear",
  },
  {
    id: "ultragate",
    symbol: "ulg",
    name: "Ultragate",
  },
  {
    id: "ultrain",
    symbol: "ugas",
    name: "Ultrain",
  },
  {
    id: "ultralpha",
    symbol: "uat",
    name: "UltrAlpha",
  },
  {
    id: "ultra-nft",
    symbol: "unft",
    name: "Ultra NFT",
  },
  {
    id: "ultrasafe",
    symbol: "ultra",
    name: "UltraSafe",
  },
  {
    id: "ultronglow",
    symbol: "utg",
    name: "UltronGlow",
  },
  {
    id: "uma",
    symbol: "uma",
    name: "UMA",
  },
  {
    id: "umami-finance",
    symbol: "umami",
    name: "Umami Finance",
  },
  {
    id: "umbra-network",
    symbol: "umbr",
    name: "Umbria Network",
  },
  {
    id: "umbrellacoin",
    symbol: "umc",
    name: "Umbrella Coin",
  },
  {
    id: "umbrella-network",
    symbol: "umb",
    name: "Umbrella Network",
  },
  {
    id: "umee",
    symbol: "umee",
    name: "Umee",
  },
  {
    id: "umetaworld",
    symbol: "umw",
    name: "UMetaWorld",
  },
  {
    id: "ume-token",
    symbol: "ume",
    name: "UME",
  },
  {
    id: "umi",
    symbol: "umi",
    name: "UMI",
  },
  {
    id: "umi-digital",
    symbol: "umi",
    name: "Umi Digital",
  },
  {
    id: "unagii-dai",
    symbol: "udai",
    name: "Unagii Dai",
  },
  {
    id: "unagii-eth",
    symbol: "ueth",
    name: "Unagii ETH",
  },
  {
    id: "unagii-tether-usd",
    symbol: "uusdt",
    name: "Unagii Tether USD",
  },
  {
    id: "unagii-usd-coin",
    symbol: "uusdc",
    name: "Unagii USD Coin",
  },
  {
    id: "unagii-wrapped-bitcoin",
    symbol: "uwbtc",
    name: "Unagii Wrapped Bitcoin",
  },
  {
    id: "unbanked",
    symbol: "unbnk",
    name: "Unbanked",
  },
  {
    id: "unbound-finance",
    symbol: "unb",
    name: "Unbound Finance",
  },
  {
    id: "uncl",
    symbol: "uncl",
    name: "UNCL",
  },
  {
    id: "uncle-doge",
    symbol: "udoge",
    name: "Uncle Doge",
  },
  {
    id: "unclemine",
    symbol: "um",
    name: "UncleMine",
  },
  {
    id: "uncle-scrooge-finance",
    symbol: "crooge",
    name: "Uncle Scrooge Finance",
  },
  {
    id: "undead-blocks",
    symbol: "undead",
    name: "Undead Blocks",
  },
  {
    id: "underground-warriors",
    symbol: "wp",
    name: "Underground Warriors",
  },
  {
    id: "underminegold",
    symbol: "umg",
    name: "UnderMineGold",
  },
  {
    id: "u-network",
    symbol: "uuu",
    name: "U Network",
  },
  {
    id: "unfederalreserve",
    symbol: "ersdl",
    name: "unFederalReserve",
  },
  {
    id: "uniarts",
    symbol: "uart",
    name: "UniArts",
  },
  {
    id: "unibright",
    symbol: "ubt",
    name: "Unibright",
  },
  {
    id: "unicake",
    symbol: "uct",
    name: "UniCAKE",
  },
  {
    id: "unicandy",
    symbol: "ucd",
    name: "UniCandy",
  },
  {
    id: "unicap-finance",
    symbol: "ucap",
    name: "Unicap.Finance",
  },
  {
    id: "unicly",
    symbol: "unic",
    name: "Unicly",
  },
  {
    id: "unicly-aavegotchi-astronauts-collection",
    symbol: "ugotchi",
    name: "Unicly Aavegotchi Astronauts Collection",
  },
  {
    id: "unicly-bored-ape-yacht-club-collection",
    symbol: "uape",
    name: "Unicly Bored Ape Yacht Club Collection",
  },
  {
    id: "unicly-chris-mccann-collection",
    symbol: "ucm",
    name: "Unicly Chris McCann Collection",
  },
  {
    id: "unicly-cryptopunks-collection",
    symbol: "upunk",
    name: "Unicly CryptoPunks Collection",
  },
  {
    id: "unicly-doki-doki-collection",
    symbol: "udoki",
    name: "Unicly Doki Doki Collection",
  },
  {
    id: "unicly-fewocious-collection",
    symbol: "ufewo",
    name: "Unicly Fewocious Collection",
  },
  {
    id: "unicly-genesis-collection",
    symbol: "uunicly",
    name: "Unicly Genesis Collection",
  },
  {
    id: "unicly-genesis-mooncats-collection",
    symbol: "ugmc",
    name: "Unicly Genesis MoonCats Collection",
  },
  {
    id: "unicly-mooncats-collection",
    symbol: "umoon",
    name: "Unicly MoonCats Collection",
  },
  {
    id: "unicly-mystic-axies-collection",
    symbol: "uaxie",
    name: "Unicly Mystic Axies Collection",
  },
  {
    id: "unicly-waifu-collection",
    symbol: "uwaifu",
    name: "Unicly Waifu Collection",
  },
  {
    id: "unicorn-cake",
    symbol: "unic",
    name: "Unicorn Cake",
  },
  {
    id: "unicorn-milk",
    symbol: "unim",
    name: "Unicorn Milk",
  },
  {
    id: "unicorn-token",
    symbol: "uni",
    name: "UNICORN",
  },
  {
    id: "unicrypt-2",
    symbol: "uncx",
    name: "UniCrypt",
  },
  {
    id: "unidex",
    symbol: "unidx",
    name: "UniDex",
  },
  {
    id: "unido-ep",
    symbol: "udo",
    name: "Unido",
  },
  {
    id: "unifarm",
    symbol: "ufarm",
    name: "UniFarm",
  },
  {
    id: "unifees",
    symbol: "fees",
    name: "Unifees",
  },
  {
    id: "unifi",
    symbol: "unifi",
    name: "Covenants",
  },
  {
    id: "unification",
    symbol: "fund",
    name: "Unification",
  },
  {
    id: "unifi-defi",
    symbol: "unifi",
    name: "UNIFI DeFi",
  },
  {
    id: "unifi-protocol",
    symbol: "up",
    name: "UniFi Protocol",
  },
  {
    id: "unifi-protocol-dao",
    symbol: "unfi",
    name: "Unifi Protocol DAO",
  },
  {
    id: "unifty",
    symbol: "nif",
    name: "Unifty",
  },
  {
    id: "unifund",
    symbol: "ifund",
    name: "Unifund",
  },
  {
    id: "unikoin-gold",
    symbol: "ukg",
    name: "Unikoin Gold",
  },
  {
    id: "unilab-network",
    symbol: "ulab",
    name: "Unilab",
  },
  {
    id: "unilayer",
    symbol: "layer",
    name: "UniLayer",
  },
  {
    id: "unilock-network-2",
    symbol: "unl",
    name: "Unilock.Network",
  },
  {
    id: "unimaxpad",
    symbol: "umax",
    name: "Unimaxpad",
  },
  {
    id: "unimex-network",
    symbol: "umx",
    name: "UniMex Network",
  },
  {
    id: "union-fair-coin",
    symbol: "ufc",
    name: "Union Fair Coin",
  },
  {
    id: "union-protocol-governance-token",
    symbol: "unn",
    name: "UNION Protocol Governance",
  },
  {
    id: "unipilot",
    symbol: "pilot",
    name: "Unipilot",
  },
  {
    id: "unipower",
    symbol: "power",
    name: "UniPower",
  },
  {
    id: "uniqly",
    symbol: "uniq",
    name: "Uniqly",
  },
  {
    id: "unique-fans",
    symbol: "fans",
    name: "Unique Fans",
  },
  {
    id: "uniquemeta",
    symbol: "unqm",
    name: "UniqueMeta",
  },
  {
    id: "unique-one",
    symbol: "rare",
    name: "Unique One",
  },
  {
    id: "uniqueone-photo",
    symbol: "foto",
    name: "UniqueOne Photo",
  },
  {
    id: "unique-utility-token",
    symbol: "unqt",
    name: "Unique Utility",
  },
  {
    id: "unirealchain",
    symbol: "unr",
    name: "Unirealchain",
  },
  {
    id: "unisocks",
    symbol: "socks",
    name: "Unisocks",
  },
  {
    id: "unistake",
    symbol: "unistake",
    name: "Unistake",
  },
  {
    id: "uniswap",
    symbol: "uni",
    name: "Uniswap",
  },
  {
    id: "uniswap-state-dollar",
    symbol: "usd",
    name: "unified Stable Dollar",
  },
  {
    id: "uniswap-wormhole",
    symbol: "uni",
    name: "Uniswap (Wormhole)",
  },
  {
    id: "unite",
    symbol: "unite",
    name: "Unite",
  },
  {
    id: "unitech",
    symbol: "utc",
    name: "Unitech",
  },
  {
    id: "united-bitcoin",
    symbol: "ubtc",
    name: "United Bitcoin",
  },
  {
    id: "unitedcoins",
    symbol: "units",
    name: "UnitedCoins",
  },
  {
    id: "unitedcrowd",
    symbol: "uct",
    name: "UnitedCrowd",
  },
  {
    id: "united-dao",
    symbol: "utd",
    name: "United DAO",
  },
  {
    id: "united-doge-finance",
    symbol: "udog",
    name: "United Doge Finance",
  },
  {
    id: "united-emirate",
    symbol: "uec",
    name: "United Emirate",
  },
  {
    id: "united-emirate-decentralized-coin",
    symbol: "uedc",
    name: "United Emirate Decentralized Coin",
  },
  {
    id: "united-token",
    symbol: "uted",
    name: "United",
  },
  {
    id: "united-traders-token",
    symbol: "utt",
    name: "United Traders",
  },
  {
    id: "unit-protocol",
    symbol: "col",
    name: "Unit Protocol",
  },
  {
    id: "unit-protocol-duck",
    symbol: "duck",
    name: "Unit Protocol New",
  },
  {
    id: "unitrade",
    symbol: "trade",
    name: "Unitrade",
  },
  {
    id: "unitus",
    symbol: "uis",
    name: "Unitus",
  },
  {
    id: "unitycom",
    symbol: "unitycom",
    name: "UnityCom",
  },
  {
    id: "unity-network",
    symbol: "unt",
    name: "Unity Network",
  },
  {
    id: "unity-protocol",
    symbol: "unity",
    name: "Unity Protocol",
  },
  {
    id: "unityventures",
    symbol: "uv",
    name: "UnityVentures",
  },
  {
    id: "unium",
    symbol: "unm",
    name: "UNIUM",
  },
  {
    id: "universal-basic-income",
    symbol: "ubi",
    name: "Universal Basic Income",
  },
  {
    id: "universal-coin",
    symbol: "ucoin",
    name: "Universal Coin",
  },
  {
    id: "universal-currency",
    symbol: "unit",
    name: "Universal Currency",
  },
  {
    id: "universal-floki-coin",
    symbol: "ufloki",
    name: "Universal Floki Coin",
  },
  {
    id: "universal-gold",
    symbol: "upxau",
    name: "Universal Gold",
  },
  {
    id: "universal-liquidity-union",
    symbol: "ulu",
    name: "Universal Liquidity Union",
  },
  {
    id: "universal-pickle",
    symbol: "$upl",
    name: "Universal Pickle",
  },
  {
    id: "universal-protocol-token",
    symbol: "upt",
    name: "Universal Protocol Token",
  },
  {
    id: "universe-2",
    symbol: "univ",
    name: "Universe",
  },
  {
    id: "universe-coin",
    symbol: "unis",
    name: "Universe Coin",
  },
  {
    id: "universe-crystal-gene",
    symbol: "ucg",
    name: "Universe Crystal Gene",
  },
  {
    id: "universe-finance-token",
    symbol: "unt",
    name: "Universe Finance",
  },
  {
    id: "universe-island",
    symbol: "uim",
    name: "Universe Island",
  },
  {
    id: "universe-token",
    symbol: "uni",
    name: "UNIVERSE Project",
  },
  {
    id: "universe-token-2",
    symbol: "universe",
    name: "Universe Token",
  },
  {
    id: "universe-xyz",
    symbol: "xyz",
    name: "Universe.XYZ",
  },
  {
    id: "universidad-de-chile-fan-token",
    symbol: "uch",
    name: "Universidad de Chile Fan Token",
  },
  {
    id: "unive-x",
    symbol: "unvx",
    name: "UNIVE X",
  },
  {
    id: "uniwhales",
    symbol: "uwl",
    name: "UniWhales",
  },
  {
    id: "uniworld",
    symbol: "unw",
    name: "UniWorld",
  },
  {
    id: "unix",
    symbol: "unix",
    name: "UniX",
  },
  {
    id: "unizen",
    symbol: "zcx",
    name: "Unizen",
  },
  {
    id: "unknown-fair-object",
    symbol: "ufo",
    name: "Unknown Fair Object",
  },
  {
    id: "unlend-finance",
    symbol: "uft",
    name: "UniLend Finance",
  },
  {
    id: "unlimitedip",
    symbol: "uip",
    name: "UnlimitedIP",
  },
  {
    id: "unlock",
    symbol: "unlock",
    name: "UNLOCK",
  },
  {
    id: "unlock-protocol",
    symbol: "udt",
    name: "Unlock Protocol",
  },
  {
    id: "unmarshal",
    symbol: "marsh",
    name: "Unmarshal",
  },
  {
    id: "unobtanium",
    symbol: "uno",
    name: "Unobtanium",
  },
  {
    id: "uno-re",
    symbol: "uno",
    name: "Uno Re",
  },
  {
    id: "unq",
    symbol: "unq",
    name: "Unique Venture clubs",
  },
  {
    id: "unreal-finance",
    symbol: "ugt",
    name: "Unreal Finance",
  },
  {
    id: "unslashed-finance",
    symbol: "usf",
    name: "Unslashed Finance",
  },
  {
    id: "unus-dao",
    symbol: "udo",
    name: "Unus Dao",
  },
  {
    id: "unvest",
    symbol: "unv",
    name: "Unvest",
  },
  {
    id: "upbnb",
    symbol: "upbnb",
    name: "upBNB",
  },
  {
    id: "upbots",
    symbol: "ubxt",
    name: "UpBots",
  },
  {
    id: "upbots-wormhole",
    symbol: "ubxt",
    name: "UpBots (Wormhole)",
  },
  {
    id: "upcoin",
    symbol: "upcoin",
    name: "Upcoin",
  },
  {
    id: "updefi",
    symbol: "up",
    name: "UpDeFi",
  },
  {
    id: "updog",
    symbol: "updog",
    name: "UpDog",
  },
  {
    id: "upfi-network",
    symbol: "ups",
    name: "UPFI Network",
  },
  {
    id: "upfinity",
    symbol: "upf",
    name: "UpFinity",
  },
  {
    id: "upfire",
    symbol: "upr",
    name: "Upfire",
  },
  {
    id: "upfiring",
    symbol: "ufr",
    name: "Upfiring",
  },
  {
    id: "upfund",
    symbol: "upt",
    name: "UPFUND",
  },
  {
    id: "uplexa",
    symbol: "upx",
    name: "uPlexa",
  },
  {
    id: "uplift",
    symbol: "lift",
    name: "Uplift",
  },
  {
    id: "uplink",
    symbol: "uplink",
    name: "UpLink",
  },
  {
    id: "uponly-token",
    symbol: "upo",
    name: "UpOnly",
  },
  {
    id: "upper-dollar",
    symbol: "usdu",
    name: "Upper Dollar",
  },
  {
    id: "upper-euro",
    symbol: "euru",
    name: "Upper Euro",
  },
  {
    id: "upper-pound",
    symbol: "gbpu",
    name: "Upper Pound",
  },
  {
    id: "upper-swiss-franc",
    symbol: "chfu",
    name: "Upper Swiss Franc",
  },
  {
    id: "uppsme",
    symbol: "upps",
    name: "UppsMe",
  },
  {
    id: "upshib",
    symbol: "upshib",
    name: "upShib",
  },
  {
    id: "uptoken",
    symbol: "up",
    name: "Up",
  },
  {
    id: "up-token",
    symbol: "up",
    name: "Tron Up",
  },
  {
    id: "uptrend",
    symbol: "trend",
    name: "UpTrend",
  },
  {
    id: "uquid-coin",
    symbol: "uqc",
    name: "Uquid Coin",
  },
  {
    id: "uraniumx",
    symbol: "urx",
    name: "UraniumX",
  },
  {
    id: "uranus",
    symbol: "urac",
    name: "Uranus",
  },
  {
    id: "ureeqa",
    symbol: "urqa",
    name: "UREEQA",
  },
  {
    id: "urgaming",
    symbol: "urg",
    name: "UrGaming",
  },
  {
    id: "urg-university",
    symbol: "urg-u",
    name: "URG University",
  },
  {
    id: "urubit",
    symbol: "urub",
    name: "Urubit",
  },
  {
    id: "urus-token",
    symbol: "urus",
    name: "Aurox",
  },
  {
    id: "usd",
    symbol: "usd+",
    name: "USD+",
  },
  {
    id: "usd-balance",
    symbol: "usdb",
    name: "USD Balance",
  },
  {
    id: "usd-coin",
    symbol: "usdc",
    name: "USD Coin",
  },
  {
    id: "usd-coin-avalanche-bridged-usdc-e",
    symbol: "usdc",
    name: "USD Coin Avalanche Bridged (USDC.e)",
  },
  {
    id: "usd-coin-celer",
    symbol: "ceusdc",
    name: "USD Coin - Celer",
  },
  {
    id: "usd-coin-nomad",
    symbol: "nomadusdc",
    name: "USD Coin - Nomad",
  },
  {
    id: "usd-coin-pos-wormhole",
    symbol: "usdcpo",
    name: "USD Coin (PoS) (Wormhole)",
  },
  {
    id: "usd-coin-wormhole",
    symbol: "usdcso",
    name: "USD Coin (Wormhole)",
  },
  {
    id: "usd-coin-wormhole-from-avalanche",
    symbol: "usdcav",
    name: "USD Coin (Wormhole from Avalanche)",
  },
  {
    id: "usd-coin-wormhole-from-bsc",
    symbol: "usdcbs",
    name: "USD Coin (Wormhole from BSC)",
  },
  {
    id: "usd-coin-wormhole-from-ethereum",
    symbol: "usdcet",
    name: "USD Coin (Wormhole from Ethereum)",
  },
  {
    id: "usdd",
    symbol: "usdd",
    name: "USDD",
  },
  {
    id: "usdex-stablecoin",
    symbol: "usdex",
    name: "USDEX",
  },
  {
    id: "usd-gambit",
    symbol: "usdg",
    name: "USD Gambit",
  },
  {
    id: "usdh",
    symbol: "usdh",
    name: "USDH",
  },
  {
    id: "usdk",
    symbol: "usdk",
    name: "USDK",
  },
  {
    id: "usdk-wormhole",
    symbol: "usdk",
    name: "USDK (Wormhole)",
  },
  {
    id: "usd-mars",
    symbol: "usdm",
    name: "USD Mars",
  },
  {
    id: "usd-open-dollar",
    symbol: "usdo",
    name: "USD Open Dollar",
  },
  {
    id: "usdp",
    symbol: "usdp",
    name: "USDP Stablecoin",
  },
  {
    id: "usdq",
    symbol: "usdq",
    name: "USDQ",
  },
  {
    id: "usd-reserve",
    symbol: "usdr",
    name: "USD Reserve",
  },
  {
    id: "usd-sports",
    symbol: "usdsp",
    name: "USD Sports",
  },
  {
    id: "usdv",
    symbol: "usdv",
    name: "USD Velero Stablecoin",
  },
  {
    id: "usdx",
    symbol: "usdx",
    name: "USDX",
  },
  {
    id: "usdx-stablecoin",
    symbol: "usdx",
    name: "USDx Stablecoin",
  },
  {
    id: "usd-zee",
    symbol: "usdz",
    name: "USD ZEE",
  },
  {
    id: "usechain",
    symbol: "use",
    name: "Usechain",
  },
  {
    id: "useless",
    symbol: "useless",
    name: "Useless [OLD]",
  },
  {
    id: "useless-2",
    symbol: "useless",
    name: "Useless",
  },
  {
    id: "usgold",
    symbol: "usg",
    name: "USGold",
  },
  {
    id: "ushare",
    symbol: "ushare",
    name: "USHARE",
  },
  {
    id: "usn",
    symbol: "usn",
    name: "USN",
  },
  {
    id: "utility-nft-coin",
    symbol: "unc",
    name: "Utility NFT Coin",
  },
  {
    id: "utip",
    symbol: "utip",
    name: "uTip",
  },
  {
    id: "utopia",
    symbol: "crp",
    name: "Crypton",
  },
  {
    id: "utopia-2",
    symbol: "topia",
    name: "Utopia",
  },
  {
    id: "utopia-genesis-foundation",
    symbol: "uop",
    name: "Utopia Genesis Foundation",
  },
  {
    id: "utopia-token",
    symbol: "uto",
    name: "Secret Skellies Society Utopia",
  },
  {
    id: "utrust",
    symbol: "utk",
    name: "Utrust",
  },
  {
    id: "utu-coin",
    symbol: "utu",
    name: "UTU Coin",
  },
  {
    id: "uwu-vault-nftx",
    symbol: "uwu",
    name: "UWU Vault (NFTX)",
  },
  {
    id: "uxd-protocol-token",
    symbol: "uxp",
    name: "UXD Protocol",
  },
  {
    id: "uxd-stablecoin",
    symbol: "uxd",
    name: "UXD Stablecoin",
  },
  {
    id: "uzumaki-inu",
    symbol: "uzumaki",
    name: "Uzumaki Inu",
  },
  {
    id: "uzyth",
    symbol: "zyth",
    name: "Uzyth",
  },
  {
    id: "v3s-share",
    symbol: "vshare",
    name: "V3S Share",
  },
  {
    id: "vabble",
    symbol: "vab",
    name: "Vabble",
  },
  {
    id: "vacay",
    symbol: "vacay",
    name: "Vacay",
  },
  {
    id: "vader-protocol",
    symbol: "vader",
    name: "Vader Protocol",
  },
  {
    id: "vagabond",
    symbol: "vgo",
    name: "Vagabond",
  },
  {
    id: "vai",
    symbol: "vai",
    name: "Vai",
  },
  {
    id: "vaiot",
    symbol: "vai",
    name: "Vaiot",
  },
  {
    id: "valas-finance",
    symbol: "valas",
    name: "Valas Finance",
  },
  {
    id: "valencia-cf-fan-token",
    symbol: "vcf",
    name: "Valencia CF Fan Token",
  },
  {
    id: "valentine-floki",
    symbol: "flov",
    name: "Valentine Floki",
  },
  {
    id: "valid",
    symbol: "vld",
    name: "Vetri",
  },
  {
    id: "valkyrie-protocol",
    symbol: "vkr",
    name: "Valkyrie Protocol",
  },
  {
    id: "valkyrio-token",
    symbol: "valk",
    name: "Valkyrio",
  },
  {
    id: "valleyswap",
    symbol: "vs",
    name: "ValleySwap",
  },
  {
    id: "valobit",
    symbol: "vbit",
    name: "VALOBIT",
  },
  {
    id: "valor",
    symbol: "v$",
    name: "Valor",
  },
  {
    id: "valorfoundation",
    symbol: "valor",
    name: "ValorFoundation",
  },
  {
    id: "valuablecoins",
    symbol: "vc",
    name: "ValuableCoins",
  },
  {
    id: "value-finance",
    symbol: "vft",
    name: "Value Finance",
  },
  {
    id: "value-liquidity",
    symbol: "value",
    name: "Value DeFi",
  },
  {
    id: "valuto",
    symbol: "vlu",
    name: "Valuto",
  },
  {
    id: "vancat",
    symbol: "vancat",
    name: "Vancat [OLD]",
  },
  {
    id: "vancat-2",
    symbol: "vancat",
    name: "Vancat",
  },
  {
    id: "vanci-finance",
    symbol: "vancii",
    name: "Vanci Finance",
  },
  {
    id: "vanguard-real-estate-tokenized-stock-defichain",
    symbol: "dvnq",
    name: "Vanguard Real Estate Tokenized Stock Defichain",
  },
  {
    id: "vanguard-sp-500-etf-tokenized-stock-defichain",
    symbol: "dvoo",
    name: "Vanguard S&P 500 ETF Tokenized Stock Defichain",
  },
  {
    id: "vanilla",
    symbol: "vnl",
    name: "Vanilla",
  },
  {
    id: "vanilla-network",
    symbol: "vnla",
    name: "Vanilla Network",
  },
  {
    id: "vanity",
    symbol: "vny",
    name: "Vanity",
  },
  {
    id: "vankia-chain",
    symbol: "vkt",
    name: "Vankia Chain",
  },
  {
    id: "vanspor-token",
    symbol: "van",
    name: "Vanspor Token",
  },
  {
    id: "vantaur",
    symbol: "vtar",
    name: "Vantaur",
  },
  {
    id: "vanywhere",
    symbol: "vany",
    name: "Vanywhere",
  },
  {
    id: "vaperscoin",
    symbol: "vprc",
    name: "VapersCoin",
  },
  {
    id: "vapornodes",
    symbol: "vpnd",
    name: "VaporNodes",
  },
  {
    id: "varen",
    symbol: "vrn",
    name: "Varen",
  },
  {
    id: "vault",
    symbol: "vault",
    name: "VAULT",
  },
  {
    id: "vaultdefi",
    symbol: "vault",
    name: "Vault-X",
  },
  {
    id: "vault-hill-city",
    symbol: "vhc",
    name: "Vault Hill City",
  },
  {
    id: "vault-s",
    symbol: "vault-s",
    name: "Vault-S",
  },
  {
    id: "vaulty-token",
    symbol: "vlty",
    name: "Vaulty",
  },
  {
    id: "vbswap",
    symbol: "vbswap",
    name: "vBSWAP",
  },
  {
    id: "vcash",
    symbol: "xvc",
    name: "Vcash",
  },
  {
    id: "vcgamers",
    symbol: "vcg",
    name: "VCGamers",
  },
  {
    id: "vechain",
    symbol: "vet",
    name: "VeChain",
  },
  {
    id: "veco",
    symbol: "veco",
    name: "Veco",
  },
  {
    id: "vecrv-dao-yvault",
    symbol: "yve-crvdao",
    name: "veCRV-DAO yVault",
  },
  {
    id: "vector-finance",
    symbol: "vtx",
    name: "Vector Finance",
  },
  {
    id: "vectorium",
    symbol: "vect",
    name: "Vectorium",
  },
  {
    id: "vectorspace",
    symbol: "vxv",
    name: "Vectorspace AI",
  },
  {
    id: "vedao",
    symbol: "weve",
    name: "veDAO",
  },
  {
    id: "veed",
    symbol: "veed",
    name: "VEED",
  },
  {
    id: "vee-finance",
    symbol: "vee",
    name: "Vee Finance",
  },
  {
    id: "veelancing",
    symbol: "slbz",
    name: "Veelancing",
  },
  {
    id: "vefi",
    symbol: "vef",
    name: "Vefi",
  },
  {
    id: "vega-coin",
    symbol: "vega",
    name: "Vega Coin",
  },
  {
    id: "vegannation-greencoin",
    symbol: "grnc",
    name: "VeganNation GreenCoin",
  },
  {
    id: "vega-protocol",
    symbol: "vega",
    name: "Vega Protocol",
  },
  {
    id: "vegawallet-token",
    symbol: "vgw",
    name: "VegaWallet",
  },
  {
    id: "veggiecoin",
    symbol: "vegi",
    name: "VeggieCoin",
  },
  {
    id: "veil",
    symbol: "veil",
    name: "VEIL",
  },
  {
    id: "vektor",
    symbol: "vektor",
    name: "VEKTOR",
  },
  {
    id: "velas",
    symbol: "vlx",
    name: "Velas",
  },
  {
    id: "velaspad",
    symbol: "vlxpad",
    name: "VelasPad",
  },
  {
    id: "veldorabsc",
    symbol: "vdora",
    name: "VeldoraBSC",
  },
  {
    id: "velerodao",
    symbol: "vdgt",
    name: "VeleroDAO",
  },
  {
    id: "veles",
    symbol: "vls",
    name: "Veles",
  },
  {
    id: "velhalla",
    symbol: "scar",
    name: "Velhalla",
  },
  {
    id: "velo",
    symbol: "velo",
    name: "Velo",
  },
  {
    id: "velodrome-finance",
    symbol: "velo",
    name: "Velodrome Finance",
  },
  {
    id: "velorex",
    symbol: "vex",
    name: "Velorex",
  },
  {
    id: "vempire-ddao",
    symbol: "vemp",
    name: "vEmpire DDAO",
  },
  {
    id: "vendit",
    symbol: "vndt",
    name: "Vendit",
  },
  {
    id: "venice",
    symbol: "veni",
    name: "Venice",
  },
  {
    id: "venjocoin",
    symbol: "vjc",
    name: "VENJOCOIN",
  },
  {
    id: "venox",
    symbol: "vnx",
    name: "Venox",
  },
  {
    id: "vent-finance",
    symbol: "vent",
    name: "Vent Finance",
  },
  {
    id: "vention",
    symbol: "vention",
    name: "Vention",
  },
  {
    id: "ventiswap",
    symbol: "vst",
    name: "VentiSwap",
  },
  {
    id: "venus",
    symbol: "xvs",
    name: "Venus",
  },
  {
    id: "venus-bch",
    symbol: "vbch",
    name: "Venus BCH",
  },
  {
    id: "venus-beth",
    symbol: "vbeth",
    name: "Venus BETH",
  },
  {
    id: "venus-btc",
    symbol: "vbtc",
    name: "Venus BTC",
  },
  {
    id: "venus-busd",
    symbol: "vbusd",
    name: "Venus BUSD",
  },
  {
    id: "venus-dai",
    symbol: "vdai",
    name: "Venus DAI",
  },
  {
    id: "venus-doge",
    symbol: "vdoge",
    name: "Venus DOGE",
  },
  {
    id: "venus-dot",
    symbol: "vdot",
    name: "Venus DOT",
  },
  {
    id: "venus-eth",
    symbol: "veth",
    name: "Venus ETH",
  },
  {
    id: "venus-fil",
    symbol: "vfil",
    name: "Venus FIL",
  },
  {
    id: "venus-link",
    symbol: "vlink",
    name: "Venus LINK",
  },
  {
    id: "venus-ltc",
    symbol: "vltc",
    name: "Venus LTC",
  },
  {
    id: "venus-reward-token",
    symbol: "vrt",
    name: "Venus Reward",
  },
  {
    id: "venus-sxp",
    symbol: "vsxp",
    name: "Venus SXP",
  },
  {
    id: "venus-usdc",
    symbol: "vusdc",
    name: "Venus USDC",
  },
  {
    id: "venus-usdt",
    symbol: "vusdt",
    name: "Venus USDT",
  },
  {
    id: "venus-xrp",
    symbol: "vxrp",
    name: "Venus XRP",
  },
  {
    id: "venus-xvs",
    symbol: "vxvs",
    name: "Venus XVS",
  },
  {
    id: "vera",
    symbol: "vera",
    name: "Vera",
  },
  {
    id: "vera-cruz-coin",
    symbol: "vcco",
    name: "Vera Cruz Coin",
  },
  {
    id: "vera-exchange",
    symbol: "vera",
    name: "VERA Exchange",
  },
  {
    id: "veraone",
    symbol: "vro",
    name: "VeraOne",
  },
  {
    id: "verasity",
    symbol: "vra",
    name: "Verasity",
  },
  {
    id: "veraswap",
    symbol: "vrap",
    name: "VeraSwap",
  },
  {
    id: "verge",
    symbol: "xvg",
    name: "Verge",
  },
  {
    id: "veriblock",
    symbol: "vbk",
    name: "VeriBlock",
  },
  {
    id: "vericoin",
    symbol: "vrc",
    name: "VeriCoin",
  },
  {
    id: "veridocglobal",
    symbol: "vdg",
    name: "VeriDocGlobal",
  },
  {
    id: "verify",
    symbol: "cred",
    name: "Verify",
  },
  {
    id: "verify-token",
    symbol: "vrfy",
    name: "Verify VRFY",
  },
  {
    id: "verisafe",
    symbol: "vsf",
    name: "VeriSafe",
  },
  {
    id: "veritaseum",
    symbol: "veri",
    name: "Veritaseum",
  },
  {
    id: "verlux",
    symbol: "vlx",
    name: "Verlux",
  },
  {
    id: "vero-farm",
    symbol: "vero",
    name: "Vero Farm",
  },
  {
    id: "verox",
    symbol: "vrx",
    name: "Verox",
  },
  {
    id: "versa",
    symbol: "versa",
    name: "Versa",
  },
  {
    id: "versagames",
    symbol: "versa",
    name: "VersaGames",
  },
  {
    id: "versal-token",
    symbol: "ver",
    name: "VersalNFT",
  },
  {
    id: "verse",
    symbol: "verse",
    name: "Verse",
  },
  {
    id: "version",
    symbol: "v",
    name: "Version",
  },
  {
    id: "verso",
    symbol: "vso",
    name: "Verso",
  },
  {
    id: "versoview",
    symbol: "vvt",
    name: "VersoView",
  },
  {
    id: "versus-farm",
    symbol: "versus",
    name: "Versus Farm",
  },
  {
    id: "vertcoin",
    symbol: "vtc",
    name: "Vertcoin",
  },
  {
    id: "verus-coin",
    symbol: "vrsc",
    name: "Verus Coin",
  },
  {
    id: "verve",
    symbol: "verve",
    name: "Verve",
  },
  {
    id: "vesper-finance",
    symbol: "vsp",
    name: "Vesper Finance",
  },
  {
    id: "vesper-vdollar",
    symbol: "vusd",
    name: "Vesper V-Dollar",
  },
  {
    id: "vesq",
    symbol: "vsq",
    name: "VESQ",
  },
  {
    id: "vesta-finance",
    symbol: "vsta",
    name: "Vesta Finance",
  },
  {
    id: "vestallytoken",
    symbol: "vtt",
    name: "VesTally",
  },
  {
    id: "vesta-stable",
    symbol: "vst",
    name: "Vesta Stable",
  },
  {
    id: "vestchain",
    symbol: "vest",
    name: "VestChain",
  },
  {
    id: "vested-solarbeam",
    symbol: "vesolar",
    name: "Vested SolarBeam",
  },
  {
    id: "vether",
    symbol: "veth",
    name: "Vether",
  },
  {
    id: "vethor-token",
    symbol: "vtho",
    name: "VeThor",
  },
  {
    id: "vetter-token",
    symbol: "vetter",
    name: "Vetter",
  },
  {
    id: "veusd",
    symbol: "veusd",
    name: "VeUSD",
  },
  {
    id: "vexanium",
    symbol: "vex",
    name: "Vexanium",
  },
  {
    id: "vexchange",
    symbol: "vex",
    name: "Vexchange",
  },
  {
    id: "vfox",
    symbol: "vfox",
    name: "VFOX",
  },
  {
    id: "viacoin",
    symbol: "via",
    name: "Viacoin",
  },
  {
    id: "viagra-token",
    symbol: "viagra",
    name: "Viagra",
  },
  {
    id: "vibe",
    symbol: "vibe",
    name: "VIBE",
  },
  {
    id: "viberate",
    symbol: "vib",
    name: "Viberate",
  },
  {
    id: "viblo",
    symbol: "viblo",
    name: "VIBLO",
  },
  {
    id: "vibranium",
    symbol: "vbn",
    name: "Vibranium",
  },
  {
    id: "vica-token",
    symbol: "vica",
    name: "ViCA",
  },
  {
    id: "vicewrld",
    symbol: "vice",
    name: "Vicewrld",
  },
  {
    id: "vicmove",
    symbol: "vim",
    name: "VicMove",
  },
  {
    id: "victoria-vr",
    symbol: "vr",
    name: "Victoria VR",
  },
  {
    id: "victorum",
    symbol: "vcc",
    name: "Victorum",
  },
  {
    id: "victory-gem",
    symbol: "vtg",
    name: "Victory Gem",
  },
  {
    id: "v-id-blockchain",
    symbol: "vidt",
    name: "VIDT Datalink",
  },
  {
    id: "videocoin",
    symbol: "vid",
    name: "Vivid Labs",
  },
  {
    id: "vidiachange",
    symbol: "vida",
    name: "Vidiachange",
  },
  {
    id: "vidulum",
    symbol: "vdl",
    name: "Vidulum",
  },
  {
    id: "vidy",
    symbol: "vidy",
    name: "VIDY",
  },
  {
    id: "vidya",
    symbol: "vidya",
    name: "Vidya",
  },
  {
    id: "vidyx",
    symbol: "vidyx",
    name: "VidyX",
  },
  {
    id: "vig",
    symbol: "vig",
    name: "VIG",
  },
  {
    id: "vigorus",
    symbol: "vis",
    name: "Vigorus",
  },
  {
    id: "viiida-gold",
    symbol: "auv",
    name: "VIIIDA Gold",
  },
  {
    id: "viking-elon",
    symbol: "velon",
    name: "Viking Elon",
  },
  {
    id: "vikings-finance",
    symbol: "val",
    name: "Vikings Finance",
  },
  {
    id: "vikings-valhalla",
    symbol: "vv",
    name: "Vikings Valhalla",
  },
  {
    id: "viking-swap",
    symbol: "viking",
    name: "Viking Swap",
  },
  {
    id: "vikkytoken",
    symbol: "vikky",
    name: "Vikky",
  },
  {
    id: "vince-chain",
    symbol: "vce",
    name: "Vince Chain",
  },
  {
    id: "vincenzo-network",
    symbol: "vzn",
    name: "Vincenzo Network",
  },
  {
    id: "vinchain",
    symbol: "vin",
    name: "VINchain",
  },
  {
    id: "vinci",
    symbol: "vinci",
    name: "Vinci",
  },
  {
    id: "vindax-coin",
    symbol: "vd",
    name: "VinDax Coin",
  },
  {
    id: "vip-coin",
    symbol: "vip",
    name: "Vip Coin",
  },
  {
    id: "vipcoin-gold",
    symbol: "vcg",
    name: "VipCoin.Gold",
  },
  {
    id: "viper",
    symbol: "viper",
    name: "Viper",
  },
  {
    id: "viplus",
    symbol: "vpl",
    name: "Viplus",
  },
  {
    id: "vipstarcoin",
    symbol: "vips",
    name: "VIPSTARCOIN",
  },
  {
    id: "vip-token",
    symbol: "vip",
    name: "VIP",
  },
  {
    id: "viral",
    symbol: "viral",
    name: "Viral",
  },
  {
    id: "vira-lata-finance",
    symbol: "reau",
    name: "Vira-Lata Finance",
  },
  {
    id: "viral-ethereum",
    symbol: "eviral",
    name: "Viral Ethereum",
  },
  {
    id: "viral-inu",
    symbol: "vinu",
    name: "Viral Inu",
  },
  {
    id: "vires-finance",
    symbol: "vires",
    name: "Vires Finance",
  },
  {
    id: "virgo",
    symbol: "vgo",
    name: "Virgo",
  },
  {
    id: "virtual-gamer",
    symbol: "vgm",
    name: "Virtual Gamer",
  },
  {
    id: "virtual-goods-token",
    symbol: "vgo",
    name: "Virtual Goods",
  },
  {
    id: "virtual-tourist",
    symbol: "vt",
    name: "Virtual Tourist",
  },
  {
    id: "virtue",
    symbol: "virtue",
    name: "Virtue",
  },
  {
    id: "virtue-poker",
    symbol: "vpp",
    name: "Virtue Poker Points",
  },
  {
    id: "virtus-finance",
    symbol: "vap",
    name: "Virtus Finance",
  },
  {
    id: "viserion-finance",
    symbol: "vefi",
    name: "Viserion Finance",
  },
  {
    id: "visio",
    symbol: "visio",
    name: "Visio",
  },
  {
    id: "vision",
    symbol: "vsn",
    name: "Vision",
  },
  {
    id: "vision-fi",
    symbol: "vsn",
    name: "Vision Fi",
  },
  {
    id: "visiongame",
    symbol: "vision",
    name: "VisionGame",
  },
  {
    id: "vision-metaverse",
    symbol: "vs",
    name: "Vision Metaverse",
  },
  {
    id: "vision-network",
    symbol: "vsn",
    name: "Vision Network",
  },
  {
    id: "visor",
    symbol: "visr",
    name: "Visor",
  },
  {
    id: "vitadao",
    symbol: "vita",
    name: "VitaDAO",
  },
  {
    id: "vita-inu",
    symbol: "vinu",
    name: "Vita Inu",
  },
  {
    id: "vitality",
    symbol: "vita",
    name: "Vitality",
  },
  {
    id: "vitall-markets",
    symbol: "vital",
    name: "Vitall Markets",
  },
  {
    id: "vitamin-coin",
    symbol: "vitc",
    name: "Vitamin Coin",
  },
  {
    id: "vite",
    symbol: "vite",
    name: "Vite",
  },
  {
    id: "vitex",
    symbol: "vx",
    name: "ViteX Coin",
  },
  {
    id: "vitoge",
    symbol: "vitoge",
    name: "Vitoge",
  },
  {
    id: "vitteey",
    symbol: "vity",
    name: "Vitteey",
  },
  {
    id: "viva",
    symbol: "viva",
    name: "Viva",
  },
  {
    id: "viva-classic",
    symbol: "viva",
    name: "Viva Classic [OLD]",
  },
  {
    id: "viva-classic-2",
    symbol: "viva",
    name: "Viva Classic",
  },
  {
    id: "vivaion",
    symbol: "vivaion",
    name: "Vivaion",
  },
  {
    id: "vival",
    symbol: "viv",
    name: "Vival",
  },
  {
    id: "vive-la-bouje",
    symbol: "vive",
    name: "Vive La Bouje",
  },
  {
    id: "vixco",
    symbol: "vix",
    name: "Vixco",
  },
  {
    id: "vizslaswap",
    symbol: "vizslaswap",
    name: "VizslaSwap",
  },
  {
    id: "vlaunch",
    symbol: "vpad",
    name: "VLaunch",
  },
  {
    id: "vmates",
    symbol: "mate",
    name: "Vmates",
  },
  {
    id: "vm-tycoons-businesses",
    symbol: "businesses",
    name: "VM Tycoons Businesses",
  },
  {
    id: "vndc",
    symbol: "vndc",
    name: "VNDC",
  },
  {
    id: "vntchain",
    symbol: "vnt",
    name: "VNT Chain",
  },
  {
    id: "vn-token",
    symbol: "vn",
    name: "VN",
  },
  {
    id: "vnx-exchange",
    symbol: "vnxlu",
    name: "VNX Exchange",
  },
  {
    id: "vodi-x",
    symbol: "vdx",
    name: "Vodi X",
  },
  {
    id: "vodka-token",
    symbol: "vodka",
    name: "Vodka",
  },
  {
    id: "vodra",
    symbol: "vdr",
    name: "Vodra",
  },
  {
    id: "voice-street",
    symbol: "vst",
    name: "Voice Street",
  },
  {
    id: "void-games",
    symbol: "void",
    name: "Void Games",
  },
  {
    id: "volatility-protocol-token",
    symbol: "vol",
    name: "Volatility Protocol",
  },
  {
    id: "volentix-vtx",
    symbol: "vtx",
    name: "Volentix",
  },
  {
    id: "vollar",
    symbol: "vollar",
    name: "V-Dimension",
  },
  {
    id: "volt",
    symbol: "acdc",
    name: "Volt",
  },
  {
    id: "voltage",
    symbol: "volt",
    name: "Voltage",
  },
  {
    id: "volt-inu",
    symbol: "volt",
    name: "Volt Inu [OLD]",
  },
  {
    id: "volt-inu-2",
    symbol: "volt",
    name: "Volt Inu",
  },
  {
    id: "volt-protocol",
    symbol: "volt",
    name: "Volt Protocol",
  },
  {
    id: "volts-finance",
    symbol: "volts",
    name: "Volts.Finance",
  },
  {
    id: "voltswap",
    symbol: "volt",
    name: "VoltSwap",
  },
  {
    id: "voovoo",
    symbol: "voo",
    name: "VooVoo",
  },
  {
    id: "vortex-dao",
    symbol: "space",
    name: "Vortex DAO",
  },
  {
    id: "vortex-defi",
    symbol: "vtx",
    name: "Vortex DeFi",
  },
  {
    id: "vortex-network",
    symbol: "vtx",
    name: "VorteX Network",
  },
  {
    id: "votechain",
    symbol: "vbsc",
    name: "Votechain",
  },
  {
    id: "voucher-eth",
    symbol: "veth",
    name: "Voucher ETH",
  },
  {
    id: "vow",
    symbol: "vow",
    name: "Vow",
  },
  {
    id: "voxel-x-network",
    symbol: "vxl",
    name: "Voxel X Network",
  },
  {
    id: "vox-finance",
    symbol: "vox",
    name: "Vox.Finance",
  },
  {
    id: "voxies",
    symbol: "voxel",
    name: "Voxies",
  },
  {
    id: "voyager",
    symbol: "vgr",
    name: "Voyager",
  },
  {
    id: "voyce",
    symbol: "voyce",
    name: "Voyce",
  },
  {
    id: "voyr",
    symbol: "voyrme",
    name: "VOYR",
  },
  {
    id: "voytek-bear-coin",
    symbol: "bear",
    name: "BEAR Coin",
  },
  {
    id: "vpex-exchange",
    symbol: "vpx",
    name: "VPEX Exchange",
  },
  {
    id: "vpncoin",
    symbol: "vash",
    name: "VPNCoin",
  },
  {
    id: "vr-blocks",
    symbol: "vrblocks",
    name: "VR Blocks",
  },
  {
    id: "vrynt",
    symbol: "vrynt",
    name: "VRYNT",
  },
  {
    id: "vsolidus",
    symbol: "vsol",
    name: "VSolidus",
  },
  {
    id: "vsync",
    symbol: "vsx",
    name: "Vsync",
  },
  {
    id: "v-systems",
    symbol: "vsys",
    name: "V.SYSTEMS",
  },
  {
    id: "vulcan-forged",
    symbol: "pyr",
    name: "Vulcan Forged",
  },
  {
    id: "vulcano-2",
    symbol: "vulc",
    name: "Vulcano",
  },
  {
    id: "vulkania",
    symbol: "vlk",
    name: "Vulkania [OLD]",
  },
  {
    id: "vulkania-2",
    symbol: "vlk",
    name: "Vulkania",
  },
  {
    id: "vulture-peak",
    symbol: "vpk",
    name: "Vulture Peak",
  },
  {
    id: "vvs-finance",
    symbol: "vvs",
    name: "VVS Finance",
  },
  {
    id: "vvsp",
    symbol: "vvsp",
    name: "vVSP",
  },
  {
    id: "vybit",
    symbol: "vi",
    name: "Vybit",
  },
  {
    id: "vyfinance",
    symbol: "vyfi",
    name: "VyFinance",
  },
  {
    id: "vyndao",
    symbol: "vyn",
    name: "Vyndao",
  },
  {
    id: "vynk-chain",
    symbol: "vync",
    name: "VYNK Chain",
  },
  {
    id: "wabi",
    symbol: "wabi",
    name: "Wabi",
  },
  {
    id: "wab-network",
    symbol: "baw",
    name: "BAW Network",
  },
  {
    id: "wadzpay-token",
    symbol: "wtk",
    name: "WadzPay",
  },
  {
    id: "wagerr",
    symbol: "wgr",
    name: "Wagerr",
  },
  {
    id: "waggle-network",
    symbol: "wag",
    name: "Waggle Network",
  },
  {
    id: "wagmi",
    symbol: "wagmi",
    name: "WAGMI",
  },
  {
    id: "wagmi-game",
    symbol: "wagmi",
    name: "WAGMI Game",
  },
  {
    id: "wagmi-on-solana",
    symbol: "wagmi",
    name: "WAGMI On Solana",
  },
  {
    id: "wagyuswap",
    symbol: "wag",
    name: "WagyuSwap",
  },
  {
    id: "waifer",
    symbol: "waif",
    name: "Waifer",
  },
  {
    id: "waifu-token",
    symbol: "waif",
    name: "Waifu",
  },
  {
    id: "waifu-vault-nftx",
    symbol: "waifu",
    name: "WAIFU Vault (NFTX)",
  },
  {
    id: "wakanda-inu",
    symbol: "wkd",
    name: "Wakanda Inu",
  },
  {
    id: "waletoken",
    symbol: "wtn",
    name: "Wale",
  },
  {
    id: "walken",
    symbol: "wlkn",
    name: "Walken",
  },
  {
    id: "walletnow",
    symbol: "wnow",
    name: "WalletNow",
  },
  {
    id: "wallet-pay",
    symbol: "xpay",
    name: "Wallet Pay",
  },
  {
    id: "wallet-plus-x",
    symbol: "wpx",
    name: "Wallet Plus X",
  },
  {
    id: "wallet-swap",
    symbol: "wswap",
    name: "Wallet Swap",
  },
  {
    id: "wallfair",
    symbol: "wfair",
    name: "Wallfair",
  },
  {
    id: "wallstreetbets-com",
    symbol: "wsb",
    name: "Wallstreetbets.com",
  },
  {
    id: "wall-street-bets-dapp",
    symbol: "wsb",
    name: "WallStreetBets DApp",
  },
  {
    id: "wall-street-capital",
    symbol: "wsc",
    name: "Wall Street Capital",
  },
  {
    id: "wall-street-games",
    symbol: "wsg",
    name: "Wall Street Games",
  },
  {
    id: "wall-street-inu",
    symbol: "wallstreetinu",
    name: "Wall Street Inu",
  },
  {
    id: "wallstreetninja",
    symbol: "wsn",
    name: "WallStreetNinja",
  },
  {
    id: "walrus",
    symbol: "wlrs",
    name: "Walrus",
  },
  {
    id: "walter-inu",
    symbol: "$winu",
    name: "Walter Inu",
  },
  {
    id: "waltonchain",
    symbol: "wtc",
    name: "Waltonchain",
  },
  {
    id: "wam",
    symbol: "wam",
    name: "Wam",
  },
  {
    id: "wamo",
    symbol: "wamo",
    name: "WAMO",
  },
  {
    id: "wanaka-farm",
    symbol: "wana",
    name: "Wanaka Farm",
  },
  {
    id: "wanaka-farm-wairere-token",
    symbol: "wai",
    name: "Wanaka Farm WAIRERE",
  },
  {
    id: "wanavax",
    symbol: "wanavax",
    name: "wanAVAX",
  },
  {
    id: "wanbtc",
    symbol: "wanbtc",
    name: "wanBTC",
  },
  {
    id: "wanchain",
    symbol: "wan",
    name: "Wanchain",
  },
  {
    id: "wanda-exchange",
    symbol: "we",
    name: "Wanda Exchange",
  },
  {
    id: "waneth",
    symbol: "waneth",
    name: "wanETH",
  },
  {
    id: "wannaswap",
    symbol: "wanna",
    name: "WannaSwap",
  },
  {
    id: "wanswap",
    symbol: "wasp",
    name: "WanSwap",
  },
  {
    id: "wanusdc",
    symbol: "wanusdc",
    name: "wanUSDC",
  },
  {
    id: "wanusdt",
    symbol: "wanusdt",
    name: "wanUSDT",
  },
  {
    id: "wanxrp",
    symbol: "wanxrp",
    name: "wanXRP",
  },
  {
    id: "wapswap-finance",
    symbol: "wap",
    name: "WapSwap Finance",
  },
  {
    id: "war-bond",
    symbol: "wbond",
    name: "War Bond",
  },
  {
    id: "warden",
    symbol: "wad",
    name: "Warden",
  },
  {
    id: "warena",
    symbol: "rena",
    name: "Warena",
  },
  {
    id: "war-of-tribes",
    symbol: "wotg",
    name: "War of Tribes",
  },
  {
    id: "warp-bond",
    symbol: "warp",
    name: "Warp Bond",
  },
  {
    id: "warp-finance",
    symbol: "warp",
    name: "Warp Finance",
  },
  {
    id: "warrior-rare-essentials",
    symbol: "ware",
    name: "Warrior Rare Essentials",
  },
  {
    id: "warriors-land-fuel",
    symbol: "wlf",
    name: "Warriors Land Fuel",
  },
  {
    id: "warrior-token",
    symbol: "war",
    name: "Warrior",
  },
  {
    id: "warship-battles",
    symbol: "$oil",
    name: "Warship Battles",
  },
  {
    id: "wasabix",
    symbol: "wasabi",
    name: "WasabiX",
  },
  {
    id: "wasdaq-finance",
    symbol: "wsdq",
    name: "Wasdaq Finance",
  },
  {
    id: "wasder",
    symbol: "was",
    name: "Wasder",
  },
  {
    id: "waste-coin",
    symbol: "waco",
    name: "Waste Digital Coin",
  },
  {
    id: "watchdo",
    symbol: "wdo",
    name: "WatchDO",
  },
  {
    id: "watchmen",
    symbol: "wtm",
    name: "WATCHMEN",
  },
  {
    id: "watchtower-2",
    symbol: "wtw",
    name: "Watchtower",
  },
  {
    id: "waterfall-finance",
    symbol: "waterfall",
    name: "Waterfall Finance",
  },
  {
    id: "waterfall-governance-token",
    symbol: "wtf",
    name: "Waterfall Governance",
  },
  {
    id: "wault",
    symbol: "waultx",
    name: "Wault",
  },
  {
    id: "waultswap",
    symbol: "wex",
    name: "WaultSwap",
  },
  {
    id: "waultswap-polygon",
    symbol: "wexpoly",
    name: "WaultSwap Polygon",
  },
  {
    id: "wault-usd",
    symbol: "wusd",
    name: "Wault USD",
  },
  {
    id: "wave-pay-coin",
    symbol: "wpc",
    name: "Wave Pay Coin",
  },
  {
    id: "waves",
    symbol: "waves",
    name: "Waves",
  },
  {
    id: "waves-community-token",
    symbol: "wct",
    name: "Waves Community",
  },
  {
    id: "waves-ducks",
    symbol: "egg",
    name: "Waves Ducks",
  },
  {
    id: "waves-enterprise",
    symbol: "west",
    name: "Waves Enterprise",
  },
  {
    id: "waves-exchange",
    symbol: "wx",
    name: "Waves Exchange",
  },
  {
    id: "wavesgo",
    symbol: "wgo",
    name: "WavesGo",
  },
  {
    id: "wax",
    symbol: "waxp",
    name: "WAX",
  },
  {
    id: "waxe",
    symbol: "waxe",
    name: "WAXE",
  },
  {
    id: "wayawolfcoin",
    symbol: "ww",
    name: "WayaWolfCoin",
  },
  {
    id: "waykichain",
    symbol: "wicc",
    name: "WaykiChain",
  },
  {
    id: "waykichain-governance-coin",
    symbol: "wgrt",
    name: "WaykiChain Governance Coin",
  },
  {
    id: "wazirx",
    symbol: "wrx",
    name: "WazirX",
  },
  {
    id: "wbnb",
    symbol: "wbnb",
    name: "Wrapped BNB",
  },
  {
    id: "wealthsecrets",
    symbol: "wsc",
    name: "WealthSecrets",
  },
  {
    id: "wealthy-habits",
    symbol: "whb",
    name: "Wealthy Habits",
  },
  {
    id: "wearesatoshi",
    symbol: "n8v",
    name: "NativeCoin",
  },
  {
    id: "weave",
    symbol: "weave",
    name: "Weave",
  },
  {
    id: "web3-all-best-ico",
    symbol: "web3allbi",
    name: "Web3 ALL BEST ICO",
  },
  {
    id: "web3-dev",
    symbol: "web3",
    name: "Web3 Dev",
  },
  {
    id: "web-3-development",
    symbol: "3web",
    name: "Web 3 Development",
  },
  {
    id: "web3-doge",
    symbol: "web3",
    name: "Web3 Doge",
  },
  {
    id: "web3games",
    symbol: "w3g",
    name: "Web3Games",
  },
  {
    id: "web3-inu",
    symbol: "web3",
    name: "WEB3 Inu",
  },
  {
    id: "web3land",
    symbol: "web3",
    name: "WEB3Land",
  },
  {
    id: "webchain",
    symbol: "mintme",
    name: "MintMe.com Coin",
  },
  {
    id: "webcoin",
    symbol: "web",
    name: "Webcoin",
  },
  {
    id: "web-coin-pay",
    symbol: "wec",
    name: "Web Coin Pay",
  },
  {
    id: "webdollar",
    symbol: "webd",
    name: "webdollar",
  },
  {
    id: "webflix",
    symbol: "wfx",
    name: "WebFlix",
  },
  {
    id: "web-four",
    symbol: "webfour",
    name: "WEBFOUR",
  },
  {
    id: "web-innovation-ph",
    symbol: "webn",
    name: "WEBN",
  },
  {
    id: "weble-ecosystem-token",
    symbol: "wet",
    name: "Weble Ecosystem",
  },
  {
    id: "webooswap",
    symbol: "weboo",
    name: "WebooSwap",
  },
  {
    id: "webuy",
    symbol: "we",
    name: "WeBuy",
  },
  {
    id: "wechain-coin",
    symbol: "wxtc",
    name: "WeChain Coin",
  },
  {
    id: "wecoown",
    symbol: "wcx",
    name: "WeCoOwn",
  },
  {
    id: "weentar",
    symbol: "wntr",
    name: "Weentar",
  },
  {
    id: "ween-token",
    symbol: "weens",
    name: "Ween",
  },
  {
    id: "wegro",
    symbol: "wegro",
    name: "WeGro",
  },
  {
    id: "weird-dao",
    symbol: "weird",
    name: "Weird Dao",
  },
  {
    id: "weiup",
    symbol: "weiup",
    name: "WeiUp",
  },
  {
    id: "weld",
    symbol: "weld",
    name: "Weld",
  },
  {
    id: "wellness-convertible",
    symbol: "wcv",
    name: "Wellness Convertible",
  },
  {
    id: "welltrado",
    symbol: "wtl",
    name: "Welltrado",
  },
  {
    id: "welnance-finance",
    symbol: "wel",
    name: "Welnance Finance",
  },
  {
    id: "we-love-gm",
    symbol: "gm",
    name: "we love gm",
  },
  {
    id: "welups-blockchain",
    symbol: "welups",
    name: "Welups Blockchain",
  },
  {
    id: "wemix-token",
    symbol: "wemix",
    name: "WEMIX",
  },
  {
    id: "wenlambo",
    symbol: "wenlambo",
    name: "Wenlambo",
  },
  {
    id: "wen-lambo",
    symbol: "lambo",
    name: "Wen Lambo",
  },
  {
    id: "wenmoon",
    symbol: "wm",
    name: "WenMoon",
  },
  {
    id: "wepiggy-coin",
    symbol: "wpc",
    name: "WePiggy Coin",
  },
  {
    id: "wepower",
    symbol: "wpr",
    name: "WePower",
  },
  {
    id: "werenode",
    symbol: "wrc",
    name: "Werenode",
  },
  {
    id: "werewolf-coin",
    symbol: "wwc",
    name: "Werewolf Coin",
  },
  {
    id: "werewolves-game",
    symbol: "wolf",
    name: "Werewolves Game",
  },
  {
    id: "westarter",
    symbol: "war",
    name: "WeStarter",
  },
  {
    id: "weta-vr",
    symbol: "weta",
    name: "WETA VR",
  },
  {
    id: "weth",
    symbol: "weth",
    name: "WETH",
  },
  {
    id: "wetrust",
    symbol: "trst",
    name: "WeTrust",
  },
  {
    id: "weway",
    symbol: "wwy",
    name: "WeWay",
  },
  {
    id: "weyu",
    symbol: "weyu",
    name: "WEYU",
  },
  {
    id: "wfdp",
    symbol: "wfdp",
    name: "WFDP",
  },
  {
    id: "wgmi",
    symbol: "wgmi",
    name: "WGMI",
  },
  {
    id: "whale",
    symbol: "whale",
    name: "WHALE",
  },
  {
    id: "whale-coin",
    symbol: "whale",
    name: "Whale Coin",
  },
  {
    id: "whale-fall",
    symbol: "whale",
    name: "Whale Fall",
  },
  {
    id: "whalegirl",
    symbol: "wgirl",
    name: "WhaleGirl",
  },
  {
    id: "whalemap",
    symbol: "wmp",
    name: "Whalemap",
  },
  {
    id: "whaler",
    symbol: "wha",
    name: "Whaler",
  },
  {
    id: "whaleroom",
    symbol: "whl",
    name: "WhaleRoom",
  },
  {
    id: "whalestreet-shrimp-token",
    symbol: "$hrimp",
    name: "WhaleStreet $hrimp",
  },
  {
    id: "whale-vault-nftx",
    symbol: "whale",
    name: "WHALE Vault (NFTX)",
  },
  {
    id: "wheat-token",
    symbol: "wheat",
    name: "Wheat (BSC)",
  },
  {
    id: "wheelers",
    symbol: "wheel",
    name: "Wheelers",
  },
  {
    id: "when-lambo",
    symbol: "lmbo",
    name: "When Lambo",
  },
  {
    id: "when-token",
    symbol: "when",
    name: "WhenHub",
  },
  {
    id: "whey",
    symbol: "whey",
    name: "WHEY",
  },
  {
    id: "whey-token",
    symbol: "whey",
    name: "Shredded Apes Whey",
  },
  {
    id: "whirl-finance",
    symbol: "whirl",
    name: "Whirl Finance",
  },
  {
    id: "whitecoin",
    symbol: "xwc",
    name: "Whitecoin",
  },
  {
    id: "whiteheart",
    symbol: "white",
    name: "Whiteheart",
  },
  {
    id: "whiterockcasino",
    symbol: "wrc",
    name: "WhiteRockCasino",
  },
  {
    id: "white-whale",
    symbol: "whale",
    name: "White Whale",
  },
  {
    id: "whitex",
    symbol: "whx",
    name: "WhiteX",
  },
  {
    id: "whitex-community",
    symbol: "whxc",
    name: "WhiteX Community",
  },
  {
    id: "whive",
    symbol: "whive",
    name: "Whive",
  },
  {
    id: "whole-earth-coin",
    symbol: "wec",
    name: "Whole Earth Coin",
  },
  {
    id: "whole-network",
    symbol: "node",
    name: "Whole Network",
  },
  {
    id: "wibx",
    symbol: "wbx",
    name: "WiBX",
  },
  {
    id: "wicrypt",
    symbol: "wnt",
    name: "Wicrypt",
  },
  {
    id: "wider-coin",
    symbol: "wdr",
    name: "Wider Coin",
  },
  {
    id: "widiland",
    symbol: "widi",
    name: "WidiLand",
  },
  {
    id: "widi-soul",
    symbol: "wso",
    name: "Widi Soul",
  },
  {
    id: "wifedoge",
    symbol: "wifedoge",
    name: "Wifedoge",
  },
  {
    id: "wifi-coin",
    symbol: "wifi",
    name: "Wifi Coin",
  },
  {
    id: "wiggly-finance",
    symbol: "wgl",
    name: "Wiggly Finance",
  },
  {
    id: "wigoswap",
    symbol: "wigo",
    name: "WigoSwap",
  },
  {
    id: "wiix-coin",
    symbol: "wxc",
    name: "WIIX Coin",
  },
  {
    id: "wiki-token",
    symbol: "wiki",
    name: "Wiki",
  },
  {
    id: "wild-beast-block",
    symbol: "wbb",
    name: "Wild Beast Block",
  },
  {
    id: "wild-credit",
    symbol: "wild",
    name: "Wild Credit",
  },
  {
    id: "wilder-world",
    symbol: "wild",
    name: "Wilder World",
  },
  {
    id: "wild-island-game",
    symbol: "wild",
    name: "Wild Island Game",
  },
  {
    id: "wild-ride",
    symbol: "wild",
    name: "Wild Ride",
  },
  {
    id: "winco",
    symbol: "wco",
    name: "Winco",
  },
  {
    id: "windfall-token",
    symbol: "wft",
    name: "Windfall",
  },
  {
    id: "winding-tree",
    symbol: "lif",
    name: "Lif",
  },
  {
    id: "windoge95",
    symbol: "wndg95",
    name: "Windoge95",
  },
  {
    id: "winerz",
    symbol: "$wnz",
    name: "Winerz",
  },
  {
    id: "wine-shares",
    symbol: "wine",
    name: "Wine Shares",
  },
  {
    id: "wing-finance",
    symbol: "wing",
    name: "Wing Finance",
  },
  {
    id: "wings",
    symbol: "wings",
    name: "Wings",
  },
  {
    id: "wings-protocol",
    symbol: "xwip",
    name: "Wings Protocol",
  },
  {
    id: "wingswap",
    symbol: "wis",
    name: "WingSwap",
  },
  {
    id: "wink",
    symbol: "win",
    name: "WINkLink",
  },
  {
    id: "winklink-bsc",
    symbol: "win",
    name: "WINkLink BSC",
  },
  {
    id: "winnow",
    symbol: "wnnw",
    name: "WinNow",
  },
  {
    id: "winry-inu",
    symbol: "winry",
    name: "Winry Inu",
  },
  {
    id: "winstars",
    symbol: "wnl",
    name: "WinStars Live",
  },
  {
    id: "winter",
    symbol: "winter",
    name: "Winter",
  },
  {
    id: "wipemyass",
    symbol: "wipe",
    name: "WipeMyAss",
  },
  {
    id: "wirex",
    symbol: "wxt",
    name: "Wirex",
  },
  {
    id: "wirtual",
    symbol: "wirtual",
    name: "Wirtual",
  },
  {
    id: "wiseavax",
    symbol: "wiseavax",
    name: "WiseAvax",
  },
  {
    id: "wise-token11",
    symbol: "wise",
    name: "Wise",
  },
  {
    id: "wish-finance-2",
    symbol: "wish",
    name: "Wish Finance",
  },
  {
    id: "wisteria-swap",
    symbol: "wst",
    name: "Wisteria Swap",
  },
  {
    id: "witchain",
    symbol: "wit",
    name: "WITChain",
  },
  {
    id: "witcher-inu",
    symbol: "winu",
    name: "Witcher Inu",
  },
  {
    id: "witcherverse",
    symbol: "wch",
    name: "WitcherVerse",
  },
  {
    id: "witch-token",
    symbol: "witch",
    name: "Witch",
  },
  {
    id: "witnet",
    symbol: "wit",
    name: "Witnet",
  },
  {
    id: "wiva",
    symbol: "wiva",
    name: "WIVA",
  },
  {
    id: "wixlar",
    symbol: "wix",
    name: "Wixlar",
  },
  {
    id: "wizardia",
    symbol: "wzrd",
    name: "Wizardia",
  },
  {
    id: "wizardium",
    symbol: "wizzy",
    name: "Wizardium",
  },
  {
    id: "wizards-and-dragons",
    symbol: "gp",
    name: "Wizards And Dragons",
  },
  {
    id: "wizard-token",
    symbol: "wizard",
    name: "Wizard BSC",
  },
  {
    id: "wizard-vault-nftx",
    symbol: "wizard",
    name: "WIZARD Vault (NFTX)",
  },
  {
    id: "wizarre-scroll",
    symbol: "scrl",
    name: "Wizarre Scroll",
  },
  {
    id: "wjewel",
    symbol: "wjewel",
    name: "WJEWEL",
  },
  {
    id: "wliti",
    symbol: "wliti",
    name: "wLITI",
  },
  {
    id: "wlitidao",
    symbol: "wld",
    name: "wLitiDAO",
  },
  {
    id: "wmatic",
    symbol: "wmatic",
    name: "Wrapped Matic",
  },
  {
    id: "wodex",
    symbol: "wmt",
    name: "Wodex",
  },
  {
    id: "wohlstand-token",
    symbol: "wt",
    name: "Wohlstand",
  },
  {
    id: "wohpedao",
    symbol: "peace",
    name: "WohpeDao",
  },
  {
    id: "wojak-finance",
    symbol: "woj",
    name: "Wojak Finance",
  },
  {
    id: "wolfcoin",
    symbol: "wolf",
    name: "WOLFCOIN",
  },
  {
    id: "wolfecoin",
    symbol: "wolfe",
    name: "Wolfecoin",
  },
  {
    id: "wolf-game-wool",
    symbol: "wool",
    name: "Wolf Game Wool",
  },
  {
    id: "wolfgirl",
    symbol: "wlfgrl",
    name: "Wolfgirl",
  },
  {
    id: "wolf-girl",
    symbol: "wolfgirl",
    name: "Wolf Girl",
  },
  {
    id: "wolfi",
    symbol: "wolfi",
    name: "WOLFI",
  },
  {
    id: "wolf_king",
    symbol: "wolf",
    name: "Wolf King",
  },
  {
    id: "wolf-pups",
    symbol: "wolfies",
    name: "WOLF PUPS [OLD]",
  },
  {
    id: "wolf-pups-2",
    symbol: "wolfies",
    name: "WOLF PUPS",
  },
  {
    id: "wolfsafepoorpeople",
    symbol: "wspp",
    name: "WolfSafePoorPeople",
  },
  {
    id: "wolfsafepoorpeople-polygon",
    symbol: "wspp",
    name: "WolfSafePoorPeople Polygon",
  },
  {
    id: "wolf-town-wool",
    symbol: "wtwool",
    name: "Wolf Town Wool",
  },
  {
    id: "wolfy",
    symbol: "wolfy",
    name: "WOLFY",
  },
  {
    id: "wolverinu",
    symbol: "wolverinu",
    name: "WOLVERINU",
  },
  {
    id: "wolves-of-wall-street",
    symbol: "wows",
    name: "Wolves of Wall Street",
  },
  {
    id: "women-empowerment-token",
    symbol: "wemp",
    name: "Women Empowerment",
  },
  {
    id: "wom-token",
    symbol: "wom",
    name: "WOM Protocol",
  },
  {
    id: "wonderfi-tokenized-stock",
    symbol: "wndr",
    name: "WonderFi Tokenized Stock",
  },
  {
    id: "wonderhero",
    symbol: "wnd",
    name: "WonderHero [OLD]",
  },
  {
    id: "wonderhero-2",
    symbol: "wnd",
    name: "WonderHero",
  },
  {
    id: "wonderhero-hon",
    symbol: "hon",
    name: "WonderHero HON",
  },
  {
    id: "wonderland",
    symbol: "time",
    name: "Wonderland",
  },
  {
    id: "wonderman-nation",
    symbol: "wndr",
    name: "Wonderman Nation",
  },
  {
    id: "woodcoin",
    symbol: "log",
    name: "Woodcoin",
  },
  {
    id: "woof-token",
    symbol: "woof",
    name: "WOOF",
  },
  {
    id: "woof-token-2",
    symbol: "woof",
    name: "Woof Token",
  },
  {
    id: "woofy",
    symbol: "woofy",
    name: "Woofy",
  },
  {
    id: "wool-token",
    symbol: "wool",
    name: "Wool",
  },
  {
    id: "woo-network",
    symbol: "woo",
    name: "WOO Network",
  },
  {
    id: "woonkly-power",
    symbol: "woop",
    name: "Woonkly Power",
  },
  {
    id: "woop",
    symbol: "woop",
    name: "WOOP",
  },
  {
    id: "woozoo-music",
    symbol: "wzm",
    name: "Woozoo Music",
  },
  {
    id: "wordl-defi",
    symbol: "wordl",
    name: "Wordl DeFi",
  },
  {
    id: "wordlex",
    symbol: "wdx",
    name: "Wordlex",
  },
  {
    id: "workertown",
    symbol: "wtn",
    name: "WorkerTown",
  },
  {
    id: "work-quest",
    symbol: "wqt",
    name: "Work Quest",
  },
  {
    id: "worktips",
    symbol: "wtip",
    name: "Worktips",
  },
  {
    id: "worldcoin",
    symbol: "wdc",
    name: "WorldCoin",
  },
  {
    id: "worldcore",
    symbol: "wrc",
    name: "Worldcore",
  },
  {
    id: "world-mobile-token",
    symbol: "wmt",
    name: "World Mobile Token",
  },
  {
    id: "world-of-defish",
    symbol: "wod",
    name: "World of Defish",
  },
  {
    id: "world-of-v",
    symbol: "wov",
    name: "World of V",
  },
  {
    id: "world-of-waves",
    symbol: "wow",
    name: "World of Waves",
  },
  {
    id: "worldpet",
    symbol: "wpt",
    name: "WORLDPET",
  },
  {
    id: "worldplus",
    symbol: "wpl",
    name: "WorldPlus",
  },
  {
    id: "world-stream-finance",
    symbol: "$tream",
    name: "World Stream Finance",
  },
  {
    id: "world-token",
    symbol: "world",
    name: "World",
  },
  {
    id: "wormfi",
    symbol: "worm",
    name: "WormFi",
  },
  {
    id: "worthpad",
    symbol: "worth",
    name: "Worthpad",
  },
  {
    id: "worthwhile",
    symbol: "whe",
    name: "Worthwhile",
  },
  {
    id: "wownero",
    symbol: "wow",
    name: "Wownero",
  },
  {
    id: "wowperson",
    symbol: "wowp",
    name: "WowPerson",
  },
  {
    id: "wowswap",
    symbol: "wow",
    name: "WOWswap",
  },
  {
    id: "wow-token",
    symbol: "wow",
    name: "WOWNFT",
  },
  {
    id: "wozx",
    symbol: "wozx",
    name: "Efforce",
  },
  {
    id: "wpp-token",
    symbol: "wpp",
    name: "WPP",
  },
  {
    id: "wraith",
    symbol: "wraith",
    name: "Wraith",
  },
  {
    id: "wrapped-0xethereum-token",
    symbol: "w0xeth",
    name: "Wrapped 0xEthereum Token",
  },
  {
    id: "wrapped-ada",
    symbol: "wada",
    name: "Wrapped ADA",
  },
  {
    id: "wrapped-ampleforth",
    symbol: "wampl",
    name: "Wrapped Ampleforth",
  },
  {
    id: "wrapped-anatha",
    symbol: "wanatha",
    name: "Wrapped ANATHA",
  },
  {
    id: "wrapped-atromg8",
    symbol: "wag8",
    name: "Wrapped ATROMG8",
  },
  {
    id: "wrapped-avax",
    symbol: "wavax",
    name: "Wrapped AVAX",
  },
  {
    id: "wrapped-bch",
    symbol: "wbch",
    name: "Wrapped BCH",
  },
  {
    id: "wrapped-bind",
    symbol: "wbind",
    name: "Wrapped BIND",
  },
  {
    id: "wrapped-bitcoin",
    symbol: "wbtc",
    name: "Wrapped Bitcoin",
  },
  {
    id: "wrapped-bitcoin-celer",
    symbol: "cewbtc",
    name: "Wrapped Bitcoin - Celer",
  },
  {
    id: "wrapped-bitcoin-sollet",
    symbol: "sobtc",
    name: "Wrapped Bitcoin (Sollet)",
  },
  {
    id: "wrapped-bitcoin-stacks",
    symbol: "xbtc",
    name: "Wrapped Bitcoin-Stacks",
  },
  {
    id: "wrapped-bnb-celer",
    symbol: "cewbnb",
    name: "Wrapped BNB - Celer",
  },
  {
    id: "wrapped-btc-wormhole",
    symbol: "wbtc",
    name: "Wrapped BTC (Wormhole)",
  },
  {
    id: "wrapped-btt",
    symbol: "wbtt",
    name: "Wrapped BTT",
  },
  {
    id: "wrapped-busd",
    symbol: "wbusd",
    name: "Wrapped BUSD",
  },
  {
    id: "wrapped-busd-allbridge-from-bsc",
    symbol: "abbusd",
    name: "Wrapped BUSD (Allbridge from BSC)",
  },
  {
    id: "wrapped-cennz",
    symbol: "wcennz",
    name: "Wrapped CENNZ",
  },
  {
    id: "wrapped-centrifuge",
    symbol: "wcfg",
    name: "Wrapped Centrifuge",
  },
  {
    id: "wrapped-chainlink-sollet",
    symbol: "solink",
    name: "Wrapped Chainlink (Sollet)",
  },
  {
    id: "wrapped-conceal",
    symbol: "wccx",
    name: "Wrapped Conceal",
  },
  {
    id: "wrapped-conflux",
    symbol: "wcfx",
    name: "Wrapped Conflux",
  },
  {
    id: "wrapped-cro",
    symbol: "wcro",
    name: "Wrapped CRO",
  },
  {
    id: "wrapped-cryptokitties",
    symbol: "wck",
    name: "Wrapped CryptoKitties",
  },
  {
    id: "wrapped-cusd-allbridge-from-celo",
    symbol: "acusd",
    name: "Wrapped CUSD (Allbridge from Celo)",
  },
  {
    id: "wrapped-dgld",
    symbol: "wdgld",
    name: "Wrapped-DGLD",
  },
  {
    id: "wrapped-ducatusx",
    symbol: "wducx",
    name: "Wrapped DucatusX",
  },
  {
    id: "wrapped-ecomi",
    symbol: "womi",
    name: "Wrapped ECOMI",
  },
  {
    id: "wrapped-elastos",
    symbol: "wela",
    name: "Wrapped Elastos",
  },
  {
    id: "wrapped-elrond",
    symbol: "wegld",
    name: "Wrapped Elrond",
  },
  {
    id: "wrapped-energi",
    symbol: "wnrg",
    name: "Wrapped Energi",
  },
  {
    id: "wrapped-ether-celer",
    symbol: "ceweth",
    name: "Wrapped Ether - Celer",
  },
  {
    id: "wrapped-ethereum-sollet",
    symbol: "soeth",
    name: "Wrapped Ethereum (Sollet)",
  },
  {
    id: "wrapped-ever",
    symbol: "wever",
    name: "Wrapped Ever",
  },
  {
    id: "wrapped-fantom",
    symbol: "wftm",
    name: "Wrapped Fantom",
  },
  {
    id: "wrapped-fantom-celer",
    symbol: "cewftm",
    name: "Wrapped Fantom - Celer",
  },
  {
    id: "wrapped-filecoin",
    symbol: "wfil",
    name: "Wrapped Filecoin",
  },
  {
    id: "wrapped-fireants",
    symbol: "wants",
    name: "Wrapped FireAnts",
  },
  {
    id: "wrapped-flow",
    symbol: "wflow",
    name: "Wrapped Flow",
  },
  {
    id: "wrapped-gen-0-cryptokitties",
    symbol: "wg0",
    name: "Wrapped Gen-0 CryptoKitties",
  },
  {
    id: "wrapped-hec",
    symbol: "wshec",
    name: "Wrapped HEC",
  },
  {
    id: "wrapped-hoo",
    symbol: "whoo",
    name: "Wrapped HOO",
  },
  {
    id: "wrapped-huobi-token",
    symbol: "wht",
    name: "Wrapped Huobi",
  },
  {
    id: "wrapped-iotex",
    symbol: "wiotx",
    name: "Wrapped IoTex",
  },
  {
    id: "wrapped-kadena",
    symbol: "wkda",
    name: "Wrapped Kadena",
  },
  {
    id: "wrapped-kcs",
    symbol: "wkcs",
    name: "Wrapped KCS",
  },
  {
    id: "wrapped-leo",
    symbol: "wleo",
    name: "Wrapped LEO",
  },
  {
    id: "wrapped-marblecards",
    symbol: "wmc",
    name: "Wrapped MarbleCards",
  },
  {
    id: "wrapped-memory",
    symbol: "wmemo",
    name: "Wonderful Memories",
  },
  {
    id: "wrapped-metrix",
    symbol: "mrxb",
    name: "Wrapped Metrix",
  },
  {
    id: "wrapped-moonbeam",
    symbol: "wglmr",
    name: "Wrapped Moonbeam",
  },
  {
    id: "wrapped-moon-cats",
    symbol: "mcat20",
    name: "Wrapped Moon Cats",
  },
  {
    id: "wrapped-nce",
    symbol: "wnce",
    name: "Wrapped NCE",
  },
  {
    id: "wrapped-ncg",
    symbol: "wncg",
    name: "Wrapped NCG",
  },
  {
    id: "wrapped-near",
    symbol: "wnear",
    name: "Wrapped Near",
  },
  {
    id: "wrapped-newyorkcoin",
    symbol: "wnyc",
    name: "Wrapped NewYorkCoin",
  },
  {
    id: "wrapped-nxm",
    symbol: "wnxm",
    name: "Wrapped NXM",
  },
  {
    id: "wrapped-okt",
    symbol: "wokt",
    name: "Wrapped OKT",
  },
  {
    id: "wrapped-one",
    symbol: "wone",
    name: "Wrapped One",
  },
  {
    id: "wrapped-paycoin",
    symbol: "wpci",
    name: "Wrapped Paycoin",
  },
  {
    id: "wrapped-pkt",
    symbol: "wpkt",
    name: "Wrapped PKT",
  },
  {
    id: "wrapped-police",
    symbol: "polis",
    name: "Wrapped Police",
  },
  {
    id: "wrapped-rose",
    symbol: "wrose",
    name: "Wrapped Rose",
  },
  {
    id: "wrapped-sexod",
    symbol: "wsexod",
    name: "Wrapped sEXOD",
  },
  {
    id: "wrapped-shiden-network",
    symbol: "sdn",
    name: "Wrapped Shiden Network",
  },
  {
    id: "wrapped-solana",
    symbol: "sol",
    name: "Wrapped Solana",
  },
  {
    id: "wrapped-staked-metaversepro",
    symbol: "wsmeta",
    name: "Wrapped Staked MetaversePro",
  },
  {
    id: "wrapped-staked-necc",
    symbol: "nnecc",
    name: "Wrapped Staked Necc",
  },
  {
    id: "wrapped-staked-olympus",
    symbol: "wsohm",
    name: "Wrapped Staked Olympus",
  },
  {
    id: "wrapped-staked-scr",
    symbol: "wsscr",
    name: "Wrapped Staked SCR",
  },
  {
    id: "wrapped-star",
    symbol: "wstr",
    name: "Wrapped Star",
  },
  {
    id: "wrapped-statera",
    symbol: "wsta",
    name: "Wrapped Statera",
  },
  {
    id: "wrapped-steth",
    symbol: "wsteth",
    name: "Wrapped stETH",
  },
  {
    id: "wrapped-syscoin",
    symbol: "wsys",
    name: "Wrapped Syscoin",
  },
  {
    id: "wrapped-telos",
    symbol: "wtlos",
    name: "Wrapped Telos",
  },
  {
    id: "wrapped-terra",
    symbol: "lunc",
    name: "Wrapped Terra Classic",
  },
  {
    id: "wrapped-tfuel",
    symbol: "tfuel",
    name: "Wrapped Theta Fuel",
  },
  {
    id: "wrapped-thunderpokt",
    symbol: "wtpokt",
    name: "Wrapped ThunderPOKT",
  },
  {
    id: "wrapped-ton-crystal",
    symbol: "wton",
    name: "Wrapped TON Crystal",
  },
  {
    id: "wrapped-tron",
    symbol: "wtrx",
    name: "Wrapped Tron",
  },
  {
    id: "wrapped-turtlecoin",
    symbol: "wtrtl",
    name: "Wrapped TurtleCoin",
  },
  {
    id: "wrapped-usdc",
    symbol: "wusdc",
    name: "Wrapped USDC",
  },
  {
    id: "wrapped-usdt-allbridge-from-polygon",
    symbol: "apusdt",
    name: "Wrapped USDT (Allbridge from Polygon)",
  },
  {
    id: "wrapped-ust",
    symbol: "ustc",
    name: "Wrapped USTC",
  },
  {
    id: "wrapped-vechain",
    symbol: "wvet",
    name: "Wrapped VeChain",
  },
  {
    id: "wrapped-velas",
    symbol: "wvlx",
    name: "Wrapped Velas",
  },
  {
    id: "wrapped-virgin-gen-0-cryptokitties",
    symbol: "wvg0",
    name: "Wrapped Virgin Gen-0 CryptoKittties",
  },
  {
    id: "wrapped-vsolidus",
    symbol: "wvsol",
    name: "Wrapped VSolidus",
  },
  {
    id: "wrapped-wan",
    symbol: "wwan",
    name: "Wrapped Wan",
  },
  {
    id: "wrapped-widecoin",
    symbol: "wwcn",
    name: "Wrapped Widecoin",
  },
  {
    id: "wrapped-wit",
    symbol: "ewit",
    name: "Wrapped Wit",
  },
  {
    id: "wrapped-wrx",
    symbol: "bwrx",
    name: "Wrapped WRX",
  },
  {
    id: "wrapped-xbtc",
    symbol: "wxbtc",
    name: "Wrapped xBTC",
  },
  {
    id: "wrapped-xdai",
    symbol: "wxdai",
    name: "Wrapped XDAI",
  },
  {
    id: "wrapped-xmr-btse",
    symbol: "wxmr",
    name: "Wrapped XMR by BTSE",
  },
  {
    id: "wrapped-xrp",
    symbol: "wxrp",
    name: "Wrapped XRP",
  },
  {
    id: "wrapped-yfi-sollet",
    symbol: "soyfi",
    name: "Wrapped YFI (Sollet)",
  },
  {
    id: "wrapped-zcash",
    symbol: "wzec",
    name: "Wrapped Zcash",
  },
  {
    id: "wsb-sh",
    symbol: "wsbt",
    name: "WSB.sh",
  },
  {
    id: "wtf-token",
    symbol: "wtf",
    name: "Fees.wtf",
  },
  {
    id: "wxcoin",
    symbol: "wxc",
    name: "WXCOINS",
  },
  {
    id: "x",
    symbol: "x",
    name: "SpaceGrime X",
  },
  {
    id: "x2",
    symbol: "x2",
    name: "X2",
  },
  {
    id: "x-2",
    symbol: "x",
    name: "X",
  },
  {
    id: "x22",
    symbol: "x22",
    name: "X22",
  },
  {
    id: "x2y2",
    symbol: "x2y2",
    name: "X2Y2",
  },
  {
    id: "x42-protocol",
    symbol: "x42",
    name: "X42 Protocol",
  },
  {
    id: "x8-project",
    symbol: "x8x",
    name: "X8X",
  },
  {
    id: "x99token",
    symbol: "x99",
    name: "x99",
  },
  {
    id: "xaea-xii-token",
    symbol: "xaea-xii",
    name: "XAEA-Xii",
  },
  {
    id: "xana",
    symbol: "xeta",
    name: "Xana",
  },
  {
    id: "xape",
    symbol: "xp",
    name: "xApe",
  },
  {
    id: "xaurum",
    symbol: "xaur",
    name: "Xaurum",
  },
  {
    id: "xave-coin",
    symbol: "xvc",
    name: "Xave Coin",
  },
  {
    id: "xaviera-techno-solutions",
    symbol: "xts",
    name: "Xaviera Techno Solutions",
  },
  {
    id: "xbe-token",
    symbol: "xbe",
    name: "XBE",
  },
  {
    id: "xbit",
    symbol: "xbt",
    name: "Xbit",
  },
  {
    id: "x-block",
    symbol: "ix",
    name: "X-Block",
  },
  {
    id: "xbn",
    symbol: "xbn",
    name: "Elastic BNB",
  },
  {
    id: "xbn-community-token",
    symbol: "xbc",
    name: "XBN Community",
  },
  {
    id: "xbullion",
    symbol: "gold",
    name: "XBullion",
  },
  {
    id: "xbullion_silver",
    symbol: "silv",
    name: "XBullion Silver",
  },
  {
    id: "xbx",
    symbol: "xbx",
    name: "XBX",
  },
  {
    id: "xcad-network",
    symbol: "xcad",
    name: "XCAD Network",
  },
  {
    id: "xcarnival",
    symbol: "xcv",
    name: "XCarnival",
  },
  {
    id: "x-cash",
    symbol: "xcash",
    name: "X-CASH",
  },
  {
    id: "xcel-swap",
    symbol: "xld",
    name: "Xcel Defi",
  },
  {
    id: "xceltoken-plus",
    symbol: "xlab",
    name: "XCELTOKEN PLUS",
  },
  {
    id: "xcf-token",
    symbol: "xcf",
    name: "XCF Token",
  },
  {
    id: "xchainz",
    symbol: "xcz",
    name: "XChainZ",
  },
  {
    id: "xcom",
    symbol: "xc",
    name: "XCOM",
  },
  {
    id: "x-consoles",
    symbol: "game",
    name: "X-Consoles",
  },
  {
    id: "xdai",
    symbol: "xdai",
    name: "XDAI",
  },
  {
    id: "xdai-native-comb",
    symbol: "xcomb",
    name: "xDai Native Comb",
  },
  {
    id: "xdai-stake",
    symbol: "stake",
    name: "STAKE",
  },
  {
    id: "xdce-crowd-sale",
    symbol: "xdc",
    name: "XDC Network",
  },
  {
    id: "xdefi",
    symbol: "xdefi",
    name: "XDEFI",
  },
  {
    id: "xdefi-governance-token",
    symbol: "xdex",
    name: "XDEFI Governance",
  },
  {
    id: "xdoge",
    symbol: "xdoge",
    name: "Xdoge",
  },
  {
    id: "xdollar",
    symbol: "xdo",
    name: "xDollar",
  },
  {
    id: "xdollar-interverse-money",
    symbol: "xim",
    name: "xDollar Interverse Money",
  },
  {
    id: "xdollar-stablecoin",
    symbol: "xusd",
    name: "xDollar Stablecoin",
  },
  {
    id: "xdrake",
    symbol: "xdr",
    name: "XDrake",
  },
  {
    id: "xeebster",
    symbol: "xeeb",
    name: "Xeebster",
  },
  {
    id: "xels",
    symbol: "xels",
    name: "XELS",
  },
  {
    id: "xend-finance",
    symbol: "xend",
    name: "Xend Finance",
  },
  {
    id: "xenios",
    symbol: "xnc",
    name: "Xenios",
  },
  {
    id: "xeniumx",
    symbol: "xemx",
    name: "Xeniumx",
  },
  {
    id: "xenon-pay",
    symbol: "x2p",
    name: "Xenon Pay",
  },
  {
    id: "xenon-pay-old",
    symbol: "x2p",
    name: "Xenon Pay [Old]",
  },
  {
    id: "xenon-play",
    symbol: "xplay",
    name: "Xenon Play",
  },
  {
    id: "xenophondao",
    symbol: "xph",
    name: "XenophonDAO",
  },
  {
    id: "xeno-token",
    symbol: "xno",
    name: "Xeno",
  },
  {
    id: "xenoverse-crypto",
    symbol: "xenox",
    name: "Xenoverse Crypto",
  },
  {
    id: "xensor",
    symbol: "xsr",
    name: "Xensor",
  },
  {
    id: "xeonbit",
    symbol: "xnb",
    name: "Xeonbit",
  },
  {
    id: "xeonbit-token",
    symbol: "xns",
    name: "Xeonbit XNS",
  },
  {
    id: "xeta-reality",
    symbol: "xeta",
    name: "Xeta Reality",
  },
  {
    id: "xeus",
    symbol: "xeus",
    name: "XEUS",
  },
  {
    id: "xfarmer",
    symbol: "xf",
    name: "xFarmer",
  },
  {
    id: "xfinance",
    symbol: "xfi",
    name: "Xfinance",
  },
  {
    id: "xfinite-entertainment-token",
    symbol: "xet",
    name: "Xfinite Entertainment",
  },
  {
    id: "xfit",
    symbol: "xfit",
    name: "Xfit",
  },
  {
    id: "xfund",
    symbol: "xfund",
    name: "xFund",
  },
  {
    id: "xgold-coin",
    symbol: "xgold",
    name: "Xgold Coin",
  },
  {
    id: "x-hash",
    symbol: "xsh",
    name: "X-HASH",
  },
  {
    id: "xhashtag",
    symbol: "xtag",
    name: "xHashtag",
  },
  {
    id: "xiamipool",
    symbol: "xmpt",
    name: "XiamiPool",
  },
  {
    id: "xiasi-inu",
    symbol: "xiasi",
    name: "Xiasi Inu",
  },
  {
    id: "xiden",
    symbol: "xden",
    name: "Xiden",
  },
  {
    id: "xid-network",
    symbol: "xid",
    name: "Xid Network",
  },
  {
    id: "xido-finance",
    symbol: "xido",
    name: "Xido Finance",
  },
  {
    id: "xiglute-coin",
    symbol: "xgc",
    name: "Xiglute Coin",
  },
  {
    id: "xigua-finance",
    symbol: "xplus",
    name: "Xigua Finance",
  },
  {
    id: "xio",
    symbol: "xio",
    name: "Blockzero Labs",
  },
  {
    id: "xion-finance",
    symbol: "xgt",
    name: "Xion Finance",
  },
  {
    id: "xiotri",
    symbol: "xiot",
    name: "Xiotri",
  },
  {
    id: "xircus",
    symbol: "xircus",
    name: "Xircus",
  },
  {
    id: "xi-token",
    symbol: "xi",
    name: "Xi",
  },
  {
    id: "xjewel",
    symbol: "xjewel",
    name: "xJEWEL",
  },
  {
    id: "xl-moon",
    symbol: "xlmn",
    name: "XL-Moon",
  },
  {
    id: "xmark",
    symbol: "xmark",
    name: "xMARK",
  },
  {
    id: "xmax",
    symbol: "xmx",
    name: "XMax",
  },
  {
    id: "xmetaversal",
    symbol: "xmeta",
    name: "XMetaversal",
  },
  {
    id: "x-metaverse",
    symbol: "xmeta",
    name: "X-Metaverse",
  },
  {
    id: "xmine",
    symbol: "xmn",
    name: "Xmine",
  },
  {
    id: "xmon",
    symbol: "xmon",
    name: "XMON",
  },
  {
    id: "xmooney",
    symbol: "xm",
    name: "xMooney",
  },
  {
    id: "xnft",
    symbol: "xnft",
    name: "xNFT Protocol",
  },
  {
    id: "xodex",
    symbol: "xodex",
    name: "Xodex",
  },
  {
    id: "xolo-inu",
    symbol: "xl",
    name: "Xolo Inu",
  },
  {
    id: "xov",
    symbol: "xov",
    name: "XOVBank",
  },
  {
    id: "xp",
    symbol: "xp",
    name: "XP",
  },
  {
    id: "xpad",
    symbol: "xpad",
    name: "xPAD",
  },
  {
    id: "xpansion-game",
    symbol: "xps",
    name: "Xpansion Game",
  },
  {
    id: "xpendium",
    symbol: "xpnd",
    name: "Xpendium",
  },
  {
    id: "xp-network",
    symbol: "xpnet",
    name: "XP Network",
  },
  {
    id: "xpool",
    symbol: "xpo",
    name: "Xpool",
  },
  {
    id: "xpose-protocol",
    symbol: "xp",
    name: "Xpose Protocol",
  },
  {
    id: "x-power-chain",
    symbol: "xpo",
    name: "X-power Chain",
  },
  {
    id: "x-protocol",
    symbol: "pot",
    name: "X Protocol",
  },
  {
    id: "xptp",
    symbol: "xptp",
    name: "xPTP",
  },
  {
    id: "xquake",
    symbol: "xqk",
    name: "XQuake",
  },
  {
    id: "xrdoge",
    symbol: "xrdoge",
    name: "XRdoge",
  },
  {
    id: "xreators",
    symbol: "ort",
    name: "XREATORS",
  },
  {
    id: "xre-global",
    symbol: "xre",
    name: "XRE Global",
  },
  {
    id: "xriba",
    symbol: "xra",
    name: "Xriba",
  },
  {
    id: "xrpalike-gene",
    symbol: "xag",
    name: "Xrpalike Gene",
  },
  {
    id: "xrpaynet",
    symbol: "xrpaynet",
    name: "XRPayNet",
  },
  {
    id: "xrp-bep2",
    symbol: "xrp-bf2",
    name: "XRP BEP2",
  },
  {
    id: "xrp-classic",
    symbol: "xrpc",
    name: "XRP Classic",
  },
  {
    id: "xr-shiba-inu",
    symbol: "xrshib",
    name: "XR Shiba Inu",
  },
  {
    id: "xrun",
    symbol: "xrun",
    name: "XRun",
  },
  {
    id: "xsgd",
    symbol: "xsgd",
    name: "XSGD",
  },
  {
    id: "xsigma",
    symbol: "sig",
    name: "xSigma",
  },
  {
    id: "xsl-labs",
    symbol: "syl",
    name: "XSL Labs",
  },
  {
    id: "xstorage",
    symbol: "xstx",
    name: "XStorage",
  },
  {
    id: "xsushi",
    symbol: "xsushi",
    name: "xSUSHI",
  },
  {
    id: "xswap",
    symbol: "xsp",
    name: "XSwap",
  },
  {
    id: "xswap-protocol",
    symbol: "xsp",
    name: "XSwap Protocol",
  },
  {
    id: "xtblock-token",
    symbol: "xtt-b20",
    name: "XTblock",
  },
  {
    id: "xtcom-token",
    symbol: "xt",
    name: "XT.com",
  },
  {
    id: "xtendcash",
    symbol: "xtnc",
    name: "XtendCash",
  },
  {
    id: "xtime",
    symbol: "xtm",
    name: "XTime",
  },
  {
    id: "xtoken",
    symbol: "xtk",
    name: "xToken",
  },
  {
    id: "xtrabytes",
    symbol: "xby",
    name: "XTRABYTES",
  },
  {
    id: "xtra-fund",
    symbol: "xtra",
    name: "Xtra Fund",
  },
  {
    id: "xtra-token",
    symbol: "xtra",
    name: "XTRA",
  },
  {
    id: "xtremcoin",
    symbol: "xtr",
    name: "Xtremcoin",
  },
  {
    id: "xtrm",
    symbol: "xtrm",
    name: "XTRM",
  },
  {
    id: "xuez",
    symbol: "xuez",
    name: "Xuez Coin",
  },
  {
    id: "xungible",
    symbol: "xgbl",
    name: "Xungible",
  },
  {
    id: "xusd",
    symbol: "xusd",
    name: "xUSD",
  },
  {
    id: "xusd-token",
    symbol: "xusd",
    name: "xUSD Token",
  },
  {
    id: "xverse",
    symbol: "xvc",
    name: "Xverse",
  },
  {
    id: "xwin-finance",
    symbol: "xwin",
    name: "xWIN Finance",
  },
  {
    id: "x-world-games",
    symbol: "xwg",
    name: "X World Games",
  },
  {
    id: "xx-platform",
    symbol: "xxp",
    name: "XX Platform",
  },
  {
    id: "xy-finance",
    symbol: "xy",
    name: "XY Finance",
  },
  {
    id: "xyo-network",
    symbol: "xyo",
    name: "XYO Network",
  },
  {
    id: "xysl",
    symbol: "xysl",
    name: "xYSL",
  },
  {
    id: "y-5-finance",
    symbol: "y-5",
    name: "Y-5 FINANCE",
  },
  {
    id: "yaapoo",
    symbol: "yap",
    name: "Yaapoo",
  },
  {
    id: "yachtx",
    symbol: "yachtx",
    name: "YachtX",
  },
  {
    id: "yacoin",
    symbol: "yac",
    name: "YACoin",
  },
  {
    id: "yadacoin",
    symbol: "yda",
    name: "YadaCoin",
  },
  {
    id: "yaki-gold",
    symbol: "yag",
    name: "Yaki Gold",
  },
  {
    id: "yam-2",
    symbol: "yam",
    name: "YAM",
  },
  {
    id: "yamp-finance",
    symbol: "yamp",
    name: "Yamp Finance",
  },
  {
    id: "yam-v2",
    symbol: "yamv2",
    name: "YAM v2",
  },
  {
    id: "yap-stone",
    symbol: "yap",
    name: "Yap Stone",
  },
  {
    id: "yarloo",
    symbol: "yarl",
    name: "Yarloo",
  },
  {
    id: "yas",
    symbol: "yas",
    name: "YAS",
  },
  {
    id: "yasha-dao",
    symbol: "yasha",
    name: "Yasha Dao",
  },
  {
    id: "yawww",
    symbol: "yaw",
    name: "Yawww",
  },
  {
    id: "yaxis",
    symbol: "yaxis",
    name: "yAxis",
  },
  {
    id: "yay-games",
    symbol: "yay",
    name: "YAY Games",
  },
  {
    id: "yayo-coin",
    symbol: "yayo",
    name: "Yayo Coin",
  },
  {
    id: "yayswap",
    symbol: "yay",
    name: "YaySwap",
  },
  {
    id: "ycash",
    symbol: "yec",
    name: "Ycash",
  },
  {
    id: "y-coin",
    symbol: "yco",
    name: "Y Coin",
  },
  {
    id: "ydragon",
    symbol: "ydr",
    name: "YDragon",
  },
  {
    id: "yeabrswap",
    symbol: "sbear",
    name: "yBEARSwap",
  },
  {
    id: "yeafinance",
    symbol: "yea",
    name: "YeaFinance",
  },
  {
    id: "yeager-inu",
    symbol: "yeager",
    name: "Yeager Inu",
  },
  {
    id: "yearn-cash",
    symbol: "yfic",
    name: "Yearn Cash",
  },
  {
    id: "yearn-classic-finance",
    symbol: "earn",
    name: "Yearn Classic Finance",
  },
  {
    id: "yearn-ecosystem-token-index",
    symbol: "yeti",
    name: "Yearn Ecosystem Index",
  },
  {
    id: "yearn-ethereum-finance",
    symbol: "yefi",
    name: "Yearn Ethereum Finance",
  },
  {
    id: "yearn-finance",
    symbol: "yfi",
    name: "yearn.finance",
  },
  {
    id: "yearn-finance-bit",
    symbol: "yfbt",
    name: "Yearn Finance Bit",
  },
  {
    id: "yearn-finance-bit2",
    symbol: "yfb2",
    name: "Yearn Finance Bit2",
  },
  {
    id: "yearn-finance-diamond-token",
    symbol: "yfdt",
    name: "Yearn Finance Diamond",
  },
  {
    id: "yearn-finance-dot",
    symbol: "yfdot",
    name: "Yearn Finance DOT",
  },
  {
    id: "yearn-finance-infrastructure-labs",
    symbol: "ylab",
    name: "Yearn-finance Infrastructure Labs",
  },
  {
    id: "yearn-finance-management",
    symbol: "yefim",
    name: "Yearn Finance Management",
  },
  {
    id: "yearn-finance-network",
    symbol: "yfn",
    name: "Yearn Finance Network",
  },
  {
    id: "yearn-finance-passive-income",
    symbol: "yfpi",
    name: "Yearn Finance Passive Income",
  },
  {
    id: "yearn-finance-red-moon",
    symbol: "yfrm",
    name: "Yearn Finance Red Moon",
  },
  {
    id: "yearn-finance-value",
    symbol: "yfiv",
    name: "Yearn Finance Value",
  },
  {
    id: "yearn-finance-wormhole",
    symbol: "yfi",
    name: "yearn.finance (Wormhole)",
  },
  {
    id: "yearnlab",
    symbol: "ylb",
    name: "Yearnlab",
  },
  {
    id: "yearn-lazy-ape",
    symbol: "yla",
    name: "Yearn Lazy Ape",
  },
  {
    id: "yearn-secure",
    symbol: "ysec",
    name: "Yearn Secure",
  },
  {
    id: "yee",
    symbol: "yee",
    name: "Yee",
  },
  {
    id: "yefi",
    symbol: "yefi",
    name: "YeFi",
  },
  {
    id: "yeld-finance",
    symbol: "yeld",
    name: "Yeld Finance",
  },
  {
    id: "yel-finance",
    symbol: "yel",
    name: "Yel.Finance",
  },
  {
    id: "yellowheart-protocol",
    symbol: "hrts",
    name: "YellowHeart Protocol",
  },
  {
    id: "yellow-road",
    symbol: "road",
    name: "Yellow Road",
  },
  {
    id: "yeni-malatyaspor-token",
    symbol: "yms",
    name: "Yeni Malatyaspor Token",
  },
  {
    id: "yenten",
    symbol: "ytn",
    name: "YENTEN",
  },
  {
    id: "yesorno",
    symbol: "yon",
    name: "YESorNO",
  },
  {
    id: "yeticoin",
    symbol: "yetic",
    name: "YetiCoin",
  },
  {
    id: "yeti-finance",
    symbol: "yeti",
    name: "Yeti Finance",
  },
  {
    id: "yetiswap",
    symbol: "yts",
    name: "YetiSwap",
  },
  {
    id: "yfbeta",
    symbol: "yfbeta",
    name: "yfBeta",
  },
  {
    id: "yfdai-finance",
    symbol: "yf-dai",
    name: "YfDAI.finance",
  },
  {
    id: "yfdfi-finance",
    symbol: "yfd",
    name: "Your Finance Decentralized",
  },
  {
    id: "yfe-money",
    symbol: "yfe",
    name: "YFE Money",
  },
  {
    id: "yff-finance",
    symbol: "yff",
    name: "YFF.Finance",
  },
  {
    id: "yffi-finance",
    symbol: "yffi",
    name: "yffi finance",
  },
  {
    id: "yffii-finance",
    symbol: "yffii",
    name: "YFFII Finance",
  },
  {
    id: "yffs",
    symbol: "yffs",
    name: "YFFS Finance",
  },
  {
    id: "yfii-finance",
    symbol: "yfii",
    name: "DFI.money",
  },
  {
    id: "yfii-gold",
    symbol: "yfiig",
    name: "YFII Gold",
  },
  {
    id: "yfilend-finance",
    symbol: "yfild",
    name: "YFILEND.FINANCE",
  },
  {
    id: "yfione",
    symbol: "yfo",
    name: "YFIONE",
  },
  {
    id: "yfix-finance",
    symbol: "yfix",
    name: "YFIX.finance",
  },
  {
    id: "yflink",
    symbol: "yfl",
    name: "YF Link",
  },
  {
    id: "yfos-finance",
    symbol: "yfos",
    name: "YFOS.finance",
  },
  {
    id: "yfox-finance",
    symbol: "yfox",
    name: "YFOX Finance",
  },
  {
    id: "yfpro-finance",
    symbol: "yfpro",
    name: "YFPRO Finance",
  },
  {
    id: "yfscience",
    symbol: "yfsi",
    name: "Yfscience",
  },
  {
    id: "yftether",
    symbol: "yfte",
    name: "YFTether",
  },
  {
    id: "yfu-finance",
    symbol: "yfu",
    name: "yfu.finance",
  },
  {
    id: "yfx",
    symbol: "yfx",
    name: "Your Futures Exchange",
  },
  {
    id: "yi12-stfinance",
    symbol: "yi12",
    name: "Yield Stake Finance",
  },
  {
    id: "yield-app",
    symbol: "yld",
    name: "YIELD App",
  },
  {
    id: "yieldblox",
    symbol: "ybx",
    name: "YieldBlox",
  },
  {
    id: "yield-guild-games",
    symbol: "ygg",
    name: "Yield Guild Games",
  },
  {
    id: "yield-guild-games-south-east-asia",
    symbol: "sea",
    name: "Yield Guild Games South East Asia",
  },
  {
    id: "yield-guild-games-wormhole",
    symbol: "ygg",
    name: "Yield Guild Games (Wormhole)",
  },
  {
    id: "yield-hunt",
    symbol: "gem",
    name: "Yield Hunt",
  },
  {
    id: "yieldly",
    symbol: "yldy",
    name: "Yieldly",
  },
  {
    id: "yield-optimization-platform",
    symbol: "yop",
    name: "Yield Optimization Platform & Protocol",
  },
  {
    id: "yield-parrot",
    symbol: "lory",
    name: "Yield Parrot",
  },
  {
    id: "yield-protocol",
    symbol: "yield",
    name: "Yield Protocol",
  },
  {
    id: "yieldwars-com",
    symbol: "war",
    name: "YieldWars",
  },
  {
    id: "yieldwatch",
    symbol: "watch",
    name: "Yieldwatch",
  },
  {
    id: "yield-yak",
    symbol: "yak",
    name: "Yield Yak",
  },
  {
    id: "yinbi",
    symbol: "yinbi",
    name: "Yinbi",
  },
  {
    id: "yin-finance",
    symbol: "yin",
    name: "YIN Finance",
  },
  {
    id: "ymplepay",
    symbol: "ympa",
    name: "YmplePay",
  },
  {
    id: "yobit-token",
    symbol: "yo",
    name: "Yobit",
  },
  {
    id: "yocoin",
    symbol: "yoc",
    name: "Yocoin",
  },
  {
    id: "yocoinyoco",
    symbol: "yoco",
    name: "YocoinYOCO",
  },
  {
    id: "yogo",
    symbol: "yogo",
    name: "Yogo",
  },
  {
    id: "yohero",
    symbol: "yo",
    name: "YoHero",
  },
  {
    id: "yohero-yhc",
    symbol: "yhc",
    name: "YoHero (YHC)",
  },
  {
    id: "yoi-shiba-inu",
    symbol: "yosi",
    name: "Yoi Shiba Inu",
  },
  {
    id: "yokcoin",
    symbol: "yok",
    name: "YOKcoin",
  },
  {
    id: "yolo-cash",
    symbol: "ylc",
    name: "YOLOCash",
  },
  {
    id: "yooshi",
    symbol: "yooshi",
    name: "YooShi",
  },
  {
    id: "yooshiba-inu",
    symbol: "yshibainu",
    name: "Yooshiba Inu",
  },
  {
    id: "yoplex",
    symbol: "yplx",
    name: "Yoplex",
  },
  {
    id: "yoshi-exchange",
    symbol: "yoshi",
    name: "Yoshi.exchange",
  },
  {
    id: "youcash",
    symbol: "youc",
    name: "YOUcash",
  },
  {
    id: "you-chain",
    symbol: "you",
    name: "YOU Chain",
  },
  {
    id: "youclout",
    symbol: "yct",
    name: "Youclout",
  },
  {
    id: "youlive-coin",
    symbol: "uc",
    name: "YouLive Coin",
  },
  {
    id: "youminter",
    symbol: "umint",
    name: "YouMinter",
  },
  {
    id: "young-boys-fan-token",
    symbol: "ybo",
    name: "Young Boys Fan Token",
  },
  {
    id: "youngparrot",
    symbol: "ypc",
    name: "YoungParrot",
  },
  {
    id: "your",
    symbol: "your",
    name: "Your",
  },
  {
    id: "yourkiss",
    symbol: "yks",
    name: "YourKiss",
  },
  {
    id: "your-open-metaverse",
    symbol: "yom",
    name: "Your Open Metaverse",
  },
  {
    id: "youswap",
    symbol: "you",
    name: "YouSwap",
  },
  {
    id: "youves-uusd",
    symbol: "uusd",
    name: "Youves uUSD",
  },
  {
    id: "youves-you-governance",
    symbol: "you",
    name: "Youves YOU Governance",
  },
  {
    id: "youwho",
    symbol: "you",
    name: "Youwho",
  },
  {
    id: "yoyow",
    symbol: "yoyow",
    name: "YOYOW",
  },
  {
    id: "yrise-finance",
    symbol: "yrise",
    name: "yRise Finance",
  },
  {
    id: "ysl",
    symbol: "ysl",
    name: "YSL",
  },
  {
    id: "ysoy-chain",
    symbol: "ysoy",
    name: "YSOY Chain",
  },
  {
    id: "ystar",
    symbol: "ysr",
    name: "Ystar",
  },
  {
    id: "ytofu",
    symbol: "ytofu",
    name: "yTOFU",
  },
  {
    id: "ytv-coin",
    symbol: "ytv",
    name: "YTV Coin",
  },
  {
    id: "yuan-chain-coin",
    symbol: "ycc",
    name: "Yuan Chain Coin",
  },
  {
    id: "yucreat",
    symbol: "yuct",
    name: "Yucreat",
  },
  {
    id: "yugi",
    symbol: "yugi",
    name: "Yugi",
  },
  {
    id: "yummy",
    symbol: "yummy",
    name: "Yummy",
  },
  {
    id: "yunex",
    symbol: "yun",
    name: "YunEx Yun",
  },
  {
    id: "yup",
    symbol: "yup",
    name: "Yup",
  },
  {
    id: "yusd-stablecoin",
    symbol: "yusd",
    name: "YUSD Stablecoin",
  },
  {
    id: "yuse",
    symbol: "yuse",
    name: "Yuse",
  },
  {
    id: "yusra",
    symbol: "yusra",
    name: "YUSRA",
  },
  {
    id: "yuzuswap",
    symbol: "yuzu",
    name: "YuzuSwap",
  },
  {
    id: "yvault-lp-ycurve",
    symbol: "yvault-lp-ycurve",
    name: "yUSD",
  },
  {
    id: "yvboost",
    symbol: "yvboost",
    name: "Yearn Compounding veCRV yVault",
  },
  {
    id: "yvs-finance",
    symbol: "yvs",
    name: "YVS Finance",
  },
  {
    id: "yye-energy",
    symbol: "yye",
    name: "YYE Energy",
  },
  {
    id: "zabaku-inu",
    symbol: "zabaku",
    name: "Zabaku Inu",
  },
  {
    id: "zabu-token",
    symbol: "zabu",
    name: "Zabu",
  },
  {
    id: "zac",
    symbol: "zac",
    name: "ZAC",
  },
  {
    id: "zada",
    symbol: "zada",
    name: "Zada",
  },
  {
    id: "zafira",
    symbol: "zfai",
    name: "Zafira",
  },
  {
    id: "zagent-gem",
    symbol: "zeg",
    name: "Zagent Gem",
  },
  {
    id: "zaif-token",
    symbol: "zaif",
    name: "Zaif",
  },
  {
    id: "zaigar-finance",
    symbol: "zaif",
    name: "Zaigar Finance",
  },
  {
    id: "zambesigold",
    symbol: "zgd",
    name: "ZambesiGold",
  },
  {
    id: "zam-io",
    symbol: "zam",
    name: "Zam.io",
  },
  {
    id: "zamzam",
    symbol: "zamzam",
    name: "ZAMZAM",
  },
  {
    id: "zano",
    symbol: "zano",
    name: "Zano",
  },
  {
    id: "zantepay",
    symbol: "zantepay",
    name: "Zantepay",
  },
  {
    id: "zap",
    symbol: "zap",
    name: "Zap",
  },
  {
    id: "zappy",
    symbol: "zap",
    name: "Zappy",
  },
  {
    id: "zarcash",
    symbol: "zarh",
    name: "Zarhexcash",
  },
  {
    id: "zasset-zusd",
    symbol: "zusd",
    name: "Zasset zUSD",
  },
  {
    id: "zatcoin",
    symbol: "zatcoin",
    name: "ZatCoin [OLD]",
  },
  {
    id: "zatcoin-2",
    symbol: "zpro",
    name: "ZatCoin",
  },
  {
    id: "zb-token",
    symbol: "zb",
    name: "ZB",
  },
  {
    id: "zcash",
    symbol: "zec",
    name: "Zcash",
  },
  {
    id: "zccoin",
    symbol: "zcc",
    name: "ZcCoin",
  },
  {
    id: "zclassic",
    symbol: "zcl",
    name: "Zclassic",
  },
  {
    id: "zcoin",
    symbol: "firo",
    name: "Firo",
  },
  {
    id: "zcon-protocol",
    symbol: "zcon",
    name: "Zcon Protocol",
  },
  {
    id: "zcore",
    symbol: "zcr",
    name: "ZCore",
  },
  {
    id: "zcore-finance",
    symbol: "zefi",
    name: "ZCore Finance",
  },
  {
    id: "zealium",
    symbol: "nzl",
    name: "Zealium",
  },
  {
    id: "zebec-protocol",
    symbol: "zbc",
    name: "Zebec Protocol",
  },
  {
    id: "zebi",
    symbol: "zco",
    name: "Zebi",
  },
  {
    id: "zedxion",
    symbol: "zedxion",
    name: "Zedxion",
  },
  {
    id: "zeedex",
    symbol: "zdex",
    name: "Zeedex",
  },
  {
    id: "zeepin",
    symbol: "zpt",
    name: "Zeepin",
  },
  {
    id: "zeitcoin",
    symbol: "zeit",
    name: "Zeitcoin",
  },
  {
    id: "zelaapayae",
    symbol: "zpae",
    name: "ZelaaPayAE",
  },
  {
    id: "zelcash",
    symbol: "flux",
    name: "Flux",
  },
  {
    id: "zelda-inu",
    symbol: "zlda",
    name: "Zelda Inu",
  },
  {
    id: "zeloop-eco-reward",
    symbol: "erw",
    name: "ZeLoop Eco Reward",
  },
  {
    id: "zelwin",
    symbol: "zlw",
    name: "Zelwin",
  },
  {
    id: "zenad",
    symbol: "znd",
    name: "Zenad",
  },
  {
    id: "zencash",
    symbol: "zen",
    name: "Horizen",
  },
  {
    id: "zenc-coin",
    symbol: "zenc",
    name: "Zenc Coin",
  },
  {
    id: "zenfi-ai",
    symbol: "zenfi",
    name: "ZenFi AI",
  },
  {
    id: "zenfuse",
    symbol: "zefu",
    name: "Zenfuse",
  },
  {
    id: "zenith-chain",
    symbol: "zenith",
    name: "Zenith Chain",
  },
  {
    id: "zenith-token",
    symbol: "zenx",
    name: "ZenithX",
  },
  {
    id: "zenlink-network-token",
    symbol: "zlk",
    name: "Zenlink Network",
  },
  {
    id: "zennies",
    symbol: "zeni",
    name: "Zennies",
  },
  {
    id: "zeno-inu",
    symbol: "zeno",
    name: "Zeno Inu",
  },
  {
    id: "zenon",
    symbol: "znn",
    name: "Zenon",
  },
  {
    id: "zensports",
    symbol: "sports",
    name: "ZenSports",
  },
  {
    id: "zenswap-network-token",
    symbol: "znt",
    name: "Zenswap Network ZNT",
  },
  {
    id: "zent-cash",
    symbol: "ztc",
    name: "Zent Cash",
  },
  {
    id: "zenzo",
    symbol: "znz",
    name: "ZENZO",
  },
  {
    id: "zeon",
    symbol: "zeon",
    name: "ZEON Network",
  },
  {
    id: "zeos",
    symbol: "zeos",
    name: "ZEOS",
  },
  {
    id: "zeptagram",
    symbol: "zptc",
    name: "Zeptacoin",
  },
  {
    id: "zer-dex",
    symbol: "zdx",
    name: "Zer-Dex",
  },
  {
    id: "zero",
    symbol: "zer",
    name: "Zero",
  },
  {
    id: "zero-exchange",
    symbol: "zero",
    name: "0.exchange",
  },
  {
    id: "zerogoki",
    symbol: "rei",
    name: "Zerogoki",
  },
  {
    id: "zerohybrid",
    symbol: "zht",
    name: "ZeroHybrid Network",
  },
  {
    id: "zeronauts",
    symbol: "zns",
    name: "Zeronauts",
  },
  {
    id: "zeroswap",
    symbol: "zee",
    name: "ZeroSwap",
  },
  {
    id: "zero-tech",
    symbol: "zero",
    name: "Zero Tech",
  },
  {
    id: "zerotwohm",
    symbol: "z2o",
    name: "ZeroTwOhm",
  },
  {
    id: "zerozed",
    symbol: "x0z",
    name: "Zerozed",
  },
  {
    id: "zetacoin",
    symbol: "zet",
    name: "Zetacoin",
  },
  {
    id: "zeto",
    symbol: "ztc",
    name: "ZeTo",
  },
  {
    id: "zetta-bitcoin-hashrate-token",
    symbol: "zbtc",
    name: "Zetta Bitcoin Hashrate",
  },
  {
    id: "zeus10000",
    symbol: "zeus10000",
    name: "ZEUS10000",
  },
  {
    id: "zeus-node-finance",
    symbol: "zeus",
    name: "Zeus Node Finance",
  },
  {
    id: "zeusshield",
    symbol: "zsc",
    name: "Zeusshield",
  },
  {
    id: "zeuxcoin",
    symbol: "zuc",
    name: "ZeuxCoin",
  },
  {
    id: "zfarm",
    symbol: "zfarm",
    name: "ZFarm",
  },
  {
    id: "zignaly",
    symbol: "zig",
    name: "Zignaly",
  },
  {
    id: "zik-token",
    symbol: "zik",
    name: "Ziktalk",
  },
  {
    id: "zilchess",
    symbol: "zch",
    name: "ZilChess",
  },
  {
    id: "zilla",
    symbol: "zla",
    name: "Zilla",
  },
  {
    id: "zilla-dao",
    symbol: "zd",
    name: "Zilla DAO",
  },
  {
    id: "zilla-finance-2-0",
    symbol: "zilla",
    name: "Zilla Finance 2.0",
  },
  {
    id: "zilla-shares",
    symbol: "zshare",
    name: "Zilla Shares",
  },
  {
    id: "zilla-shares-2-0",
    symbol: "zshare",
    name: "Zilla Shares 2.0",
  },
  {
    id: "zillioncoin",
    symbol: "zln",
    name: "ZillionCoin",
  },
  {
    id: "zilliqa",
    symbol: "zil",
    name: "Zilliqa",
  },
  {
    id: "zilpay-wallet",
    symbol: "zlp",
    name: "ZilPay Wallet",
  },
  {
    id: "zilstream",
    symbol: "stream",
    name: "ZilStream",
  },
  {
    id: "zilsurvey",
    symbol: "srv",
    name: "zilSurvey",
  },
  {
    id: "zilswap",
    symbol: "zwap",
    name: "ZilSwap",
  },
  {
    id: "zilwall",
    symbol: "zwall",
    name: "ZilWall",
  },
  {
    id: "zilwall-paint",
    symbol: "zpaint",
    name: "ZilWall Paint",
  },
  {
    id: "zimbocash",
    symbol: "zash",
    name: "ZIMBOCASH",
  },
  {
    id: "zin",
    symbol: "zin",
    name: "Zin",
  },
  {
    id: "zinari",
    symbol: "zina",
    name: "ZINARI",
  },
  {
    id: "zinja",
    symbol: "z",
    name: "Zinja",
  },
  {
    id: "zion",
    symbol: "zion",
    name: "Zion",
  },
  {
    id: "zioncoin",
    symbol: "znc",
    name: "ZionCoin",
  },
  {
    id: "zionomics",
    symbol: "ziox",
    name: "Zionomics",
  },
  {
    id: "ziot",
    symbol: "ziot",
    name: "Ziot",
  },
  {
    id: "zip",
    symbol: "zip",
    name: "Zipper Network",
  },
  {
    id: "zipmex-token",
    symbol: "zmt",
    name: "Zipmex",
  },
  {
    id: "zippie",
    symbol: "zipt",
    name: "Zippie",
  },
  {
    id: "zipswap",
    symbol: "zip",
    name: "ZipSwap",
  },
  {
    id: "zirve-coin",
    symbol: "zirve",
    name: "Zirve Coin",
  },
  {
    id: "ziticoin",
    symbol: "ziti",
    name: "Ziticoin",
  },
  {
    id: "zjlt-distributed-factoring-network",
    symbol: "zjlt",
    name: "ZJLT Distributed Factoring Network",
  },
  {
    id: "zjoe",
    symbol: "zjoe",
    name: "zJOE",
  },
  {
    id: "zkspace",
    symbol: "zks",
    name: "ZKSpace",
  },
  {
    id: "zktube",
    symbol: "zkt",
    name: "zkTube",
  },
  {
    id: "zlot",
    symbol: "zlot",
    name: "zLOT",
  },
  {
    id: "zmine",
    symbol: "zmn",
    name: "ZMINE",
  },
  {
    id: "zodiac",
    symbol: "zdc",
    name: "Zodiac",
  },
  {
    id: "zodiacdao",
    symbol: "zd",
    name: "ZodiacDAO",
  },
  {
    id: "zodiacs",
    symbol: "zdc",
    name: "Zodiacs",
  },
  {
    id: "zodiacsv2",
    symbol: "zdcv2",
    name: "ZodiacsV2",
  },
  {
    id: "zodium",
    symbol: "zodi",
    name: "Zodium",
  },
  {
    id: "zoe-cash",
    symbol: "zoe",
    name: "Zoe Cash",
  },
  {
    id: "zoid-pay",
    symbol: "zpay",
    name: "ZoidPay",
  },
  {
    id: "zoints",
    symbol: "zee",
    name: "Zoints",
  },
  {
    id: "zombiecake",
    symbol: "zc",
    name: "ZombieCake",
  },
  {
    id: "zombie-inu",
    symbol: "zinu",
    name: "Zombie Inu",
  },
  {
    id: "zombie-network-blood",
    symbol: "blood",
    name: "Zombie Network Blood",
  },
  {
    id: "zombie-world-z",
    symbol: "zwz",
    name: "Zombie World Z",
  },
  {
    id: "zomfi",
    symbol: "zomfi",
    name: "Zomfi",
  },
  {
    id: "zomi",
    symbol: "zomi",
    name: "ZOMI",
  },
  {
    id: "zone",
    symbol: "zone",
    name: "Zone",
  },
  {
    id: "zonecoin",
    symbol: "zne",
    name: "Zonecoin",
  },
  {
    id: "zone-of-avoidance",
    symbol: "zoa",
    name: "Zone of Avoidance",
  },
  {
    id: "zonoswap",
    symbol: "zono",
    name: "Zonoswap",
  },
  {
    id: "zoobit",
    symbol: "zbt",
    name: "Zoobit",
  },
  {
    id: "zoo-coin",
    symbol: "zoo",
    name: "ZooCoin",
  },
  {
    id: "zoo-crypto-world",
    symbol: "zoo",
    name: "ZOO Crypto World",
  },
  {
    id: "zoodao",
    symbol: "zoo",
    name: "ZooDAO",
  },
  {
    id: "zookeeper",
    symbol: "zoo",
    name: "ZooKeeper",
  },
  {
    id: "zoo-labs",
    symbol: "zoo",
    name: "Zoo Labs",
  },
  {
    id: "zoomswap",
    symbol: "zm",
    name: "ZoomSwap",
  },
  {
    id: "zooshi",
    symbol: "zooshi",
    name: "Zooshi",
  },
  {
    id: "zoo-token",
    symbol: "zoot",
    name: "Zoo",
  },
  {
    id: "zoracles",
    symbol: "zora",
    name: "Zoracles",
  },
  {
    id: "zoro-inu",
    symbol: "zoro",
    name: "Zoro Inu",
  },
  {
    id: "zper",
    symbol: "zpr",
    name: "ZPER",
  },
  {
    id: "zrcoin",
    symbol: "zrc",
    name: "ZrCoin",
  },
  {
    id: "zro",
    symbol: "zro",
    name: "Carb0n.fi",
  },
  {
    id: "zrocor",
    symbol: "zcor",
    name: "Zrocor",
  },
  {
    id: "ztcoin",
    symbol: "zt",
    name: "ZBG",
  },
  {
    id: "zuescrowdfunding",
    symbol: "zeus",
    name: "ZeusNetwork",
  },
  {
    id: "zufinance",
    symbol: "zuf",
    name: "ZuFinance",
  },
  {
    id: "zug",
    symbol: "zug",
    name: "EtherOrcs",
  },
  {
    id: "zuki-moba",
    symbol: "zuki",
    name: "Zuki Moba",
  },
  {
    id: "zumcoin",
    symbol: "zum",
    name: "ZumCoin",
  },
  {
    id: "zum-token",
    symbol: "zum",
    name: "ZUM",
  },
  {
    id: "zuna",
    symbol: "zuna",
    name: "Zuna",
  },
  {
    id: "zupi-coin",
    symbol: "zupi",
    name: "Zupi Coin",
  },
  {
    id: "zuplo",
    symbol: "zlp",
    name: "Zuplo",
  },
  {
    id: "zurrency",
    symbol: "zurr",
    name: "ZURRENCY",
  },
  {
    id: "zusd",
    symbol: "zusd",
    name: "ZUSD",
  },
  {
    id: "zuz-protocol",
    symbol: "zuz",
    name: "ZUZ Protocol",
  },
  {
    id: "zynecoin",
    symbol: "zyn",
    name: "Zynecoin",
  },
  {
    id: "zyro",
    symbol: "zyro",
    name: "Zyro",
  },
  {
    id: "zyrri",
    symbol: "zyr",
    name: "Zyrri",
  },
  {
    id: "zytara-dollar",
    symbol: "zusd",
    name: "Zytara Dollar",
  },
  {
    id: "zyx",
    symbol: "zyx",
    name: "ZYX",
  },
];
